import * as y from "react";
import Y, { createContext as on, useMemo as zt, createElement as ge, useContext as Et, useCallback as ft, forwardRef as K, Children as an, isValidElement as nr, cloneElement as Te, Fragment as Z1, useRef as pe, useEffect as ve, useState as ne, useLayoutEffect as io, useReducer as Vd, useId as Hd } from "react";
import * as Dn from "react-dom";
import C2, { flushSync as S2 } from "react-dom";
var qd = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function L2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Q1 = { exports: {} }, ta = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mc;
function Wd() {
  if (Mc)
    return ta;
  Mc = 1;
  var e = Y, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(o, c, d) {
    var u, f = {}, p = null, h = null;
    d !== void 0 && (p = "" + d), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (u in c)
      r.call(c, u) && !i.hasOwnProperty(u) && (f[u] = c[u]);
    if (o && o.defaultProps)
      for (u in c = o.defaultProps, c)
        f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: t, type: o, key: p, ref: h, props: f, _owner: a.current };
  }
  return ta.Fragment = n, ta.jsx = s, ta.jsxs = s, ta;
}
var na = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nc;
function Ud() {
  return Nc || (Nc = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Y, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), o = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g = Symbol.iterator, v = "@@iterator";
    function x(E) {
      if (E === null || typeof E != "object")
        return null;
      var q = g && E[g] || E[v];
      return typeof q == "function" ? q : null;
    }
    var m = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(E) {
      {
        for (var q = arguments.length, Q = new Array(q > 1 ? q - 1 : 0), ye = 1; ye < q; ye++)
          Q[ye - 1] = arguments[ye];
        _("error", E, Q);
      }
    }
    function _(E, q, Q) {
      {
        var ye = m.ReactDebugCurrentFrame, Ee = ye.getStackAddendum();
        Ee !== "" && (q += "%s", Q = Q.concat([Ee]));
        var Ae = Q.map(function(Me) {
          return String(Me);
        });
        Ae.unshift("Warning: " + q), Function.prototype.apply.call(console[E], console, Ae);
      }
    }
    var C = !1, w = !1, N = !1, M = !1, S = !1, T;
    T = Symbol.for("react.module.reference");
    function j(E) {
      return !!(typeof E == "string" || typeof E == "function" || E === r || E === i || S || E === a || E === d || E === u || M || E === h || C || w || N || typeof E == "object" && E !== null && (E.$$typeof === p || E.$$typeof === f || E.$$typeof === s || E.$$typeof === o || E.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      E.$$typeof === T || E.getModuleId !== void 0));
    }
    function D(E, q, Q) {
      var ye = E.displayName;
      if (ye)
        return ye;
      var Ee = q.displayName || q.name || "";
      return Ee !== "" ? Q + "(" + Ee + ")" : Q;
    }
    function A(E) {
      return E.displayName || "Context";
    }
    function k(E) {
      if (E == null)
        return null;
      if (typeof E.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof E == "function")
        return E.displayName || E.name || null;
      if (typeof E == "string")
        return E;
      switch (E) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof E == "object")
        switch (E.$$typeof) {
          case o:
            var q = E;
            return A(q) + ".Consumer";
          case s:
            var Q = E;
            return A(Q._context) + ".Provider";
          case c:
            return D(E, E.render, "ForwardRef");
          case f:
            var ye = E.displayName || null;
            return ye !== null ? ye : k(E.type) || "Memo";
          case p: {
            var Ee = E, Ae = Ee._payload, Me = Ee._init;
            try {
              return k(Me(Ae));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, R = 0, F, P, I, H, O, W, se;
    function ue() {
    }
    ue.__reactDisabledLog = !0;
    function ee() {
      {
        if (R === 0) {
          F = console.log, P = console.info, I = console.warn, H = console.error, O = console.group, W = console.groupCollapsed, se = console.groupEnd;
          var E = {
            configurable: !0,
            enumerable: !0,
            value: ue,
            writable: !0
          };
          Object.defineProperties(console, {
            info: E,
            log: E,
            warn: E,
            error: E,
            group: E,
            groupCollapsed: E,
            groupEnd: E
          });
        }
        R++;
      }
    }
    function ae() {
      {
        if (R--, R === 0) {
          var E = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, E, {
              value: F
            }),
            info: $({}, E, {
              value: P
            }),
            warn: $({}, E, {
              value: I
            }),
            error: $({}, E, {
              value: H
            }),
            group: $({}, E, {
              value: O
            }),
            groupCollapsed: $({}, E, {
              value: W
            }),
            groupEnd: $({}, E, {
              value: se
            })
          });
        }
        R < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ie = m.ReactCurrentDispatcher, U;
    function J(E, q, Q) {
      {
        if (U === void 0)
          try {
            throw Error();
          } catch (Ee) {
            var ye = Ee.stack.trim().match(/\n( *(at )?)/);
            U = ye && ye[1] || "";
          }
        return `
` + U + E;
      }
    }
    var fe = !1, Z;
    {
      var be = typeof WeakMap == "function" ? WeakMap : Map;
      Z = new be();
    }
    function L(E, q) {
      if (!E || fe)
        return "";
      {
        var Q = Z.get(E);
        if (Q !== void 0)
          return Q;
      }
      var ye;
      fe = !0;
      var Ee = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ae;
      Ae = ie.current, ie.current = null, ee();
      try {
        if (q) {
          var Me = function() {
            throw Error();
          };
          if (Object.defineProperty(Me.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Me, []);
            } catch (Gt) {
              ye = Gt;
            }
            Reflect.construct(E, [], Me);
          } else {
            try {
              Me.call();
            } catch (Gt) {
              ye = Gt;
            }
            E.call(Me.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Gt) {
            ye = Gt;
          }
          E();
        }
      } catch (Gt) {
        if (Gt && ye && typeof Gt.stack == "string") {
          for (var Le = Gt.stack.split(`
`), ct = ye.stack.split(`
`), qe = Le.length - 1, We = ct.length - 1; qe >= 1 && We >= 0 && Le[qe] !== ct[We]; )
            We--;
          for (; qe >= 1 && We >= 0; qe--, We--)
            if (Le[qe] !== ct[We]) {
              if (qe !== 1 || We !== 1)
                do
                  if (qe--, We--, We < 0 || Le[qe] !== ct[We]) {
                    var xt = `
` + Le[qe].replace(" at new ", " at ");
                    return E.displayName && xt.includes("<anonymous>") && (xt = xt.replace("<anonymous>", E.displayName)), typeof E == "function" && Z.set(E, xt), xt;
                  }
                while (qe >= 1 && We >= 0);
              break;
            }
        }
      } finally {
        fe = !1, ie.current = Ae, ae(), Error.prepareStackTrace = Ee;
      }
      var vr = E ? E.displayName || E.name : "", Lc = vr ? J(vr) : "";
      return typeof E == "function" && Z.set(E, Lc), Lc;
    }
    function B(E, q, Q) {
      return L(E, !1);
    }
    function ce(E) {
      var q = E.prototype;
      return !!(q && q.isReactComponent);
    }
    function _e(E, q, Q) {
      if (E == null)
        return "";
      if (typeof E == "function")
        return L(E, ce(E));
      if (typeof E == "string")
        return J(E);
      switch (E) {
        case d:
          return J("Suspense");
        case u:
          return J("SuspenseList");
      }
      if (typeof E == "object")
        switch (E.$$typeof) {
          case c:
            return B(E.render);
          case f:
            return _e(E.type, q, Q);
          case p: {
            var ye = E, Ee = ye._payload, Ae = ye._init;
            try {
              return _e(Ae(Ee), q, Q);
            } catch {
            }
          }
        }
      return "";
    }
    var we = Object.prototype.hasOwnProperty, ze = {}, Ge = m.ReactDebugCurrentFrame;
    function Pe(E) {
      if (E) {
        var q = E._owner, Q = _e(E.type, E._source, q ? q.type : null);
        Ge.setExtraStackFrame(Q);
      } else
        Ge.setExtraStackFrame(null);
    }
    function at(E, q, Q, ye, Ee) {
      {
        var Ae = Function.call.bind(we);
        for (var Me in E)
          if (Ae(E, Me)) {
            var Le = void 0;
            try {
              if (typeof E[Me] != "function") {
                var ct = Error((ye || "React class") + ": " + Q + " type `" + Me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof E[Me] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ct.name = "Invariant Violation", ct;
              }
              Le = E[Me](q, Me, ye, Q, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (qe) {
              Le = qe;
            }
            Le && !(Le instanceof Error) && (Pe(Ee), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ye || "React class", Q, Me, typeof Le), Pe(null)), Le instanceof Error && !(Le.message in ze) && (ze[Le.message] = !0, Pe(Ee), b("Failed %s type: %s", Q, Le.message), Pe(null));
          }
      }
    }
    var jt = Array.isArray;
    function l1(E) {
      return jt(E);
    }
    function Sd(E) {
      {
        var q = typeof Symbol == "function" && Symbol.toStringTag, Q = q && E[Symbol.toStringTag] || E.constructor.name || "Object";
        return Q;
      }
    }
    function Ld(E) {
      try {
        return hc(E), !1;
      } catch {
        return !0;
      }
    }
    function hc(E) {
      return "" + E;
    }
    function gc(E) {
      if (Ld(E))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Sd(E)), hc(E);
    }
    var ea = m.ReactCurrentOwner, Md = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, vc, bc, d1;
    d1 = {};
    function Nd(E) {
      if (we.call(E, "ref")) {
        var q = Object.getOwnPropertyDescriptor(E, "ref").get;
        if (q && q.isReactWarning)
          return !1;
      }
      return E.ref !== void 0;
    }
    function zd(E) {
      if (we.call(E, "key")) {
        var q = Object.getOwnPropertyDescriptor(E, "key").get;
        if (q && q.isReactWarning)
          return !1;
      }
      return E.key !== void 0;
    }
    function Ed(E, q) {
      if (typeof E.ref == "string" && ea.current && q && ea.current.stateNode !== q) {
        var Q = k(ea.current.type);
        d1[Q] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', k(ea.current.type), E.ref), d1[Q] = !0);
      }
    }
    function Td(E, q) {
      {
        var Q = function() {
          vc || (vc = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", q));
        };
        Q.isReactWarning = !0, Object.defineProperty(E, "key", {
          get: Q,
          configurable: !0
        });
      }
    }
    function kd(E, q) {
      {
        var Q = function() {
          bc || (bc = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", q));
        };
        Q.isReactWarning = !0, Object.defineProperty(E, "ref", {
          get: Q,
          configurable: !0
        });
      }
    }
    var jd = function(E, q, Q, ye, Ee, Ae, Me) {
      var Le = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: E,
        key: q,
        ref: Q,
        props: Me,
        // Record the component responsible for creating this element.
        _owner: Ae
      };
      return Le._store = {}, Object.defineProperty(Le._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Le, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ye
      }), Object.defineProperty(Le, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ee
      }), Object.freeze && (Object.freeze(Le.props), Object.freeze(Le)), Le;
    };
    function Pd(E, q, Q, ye, Ee) {
      {
        var Ae, Me = {}, Le = null, ct = null;
        Q !== void 0 && (gc(Q), Le = "" + Q), zd(q) && (gc(q.key), Le = "" + q.key), Nd(q) && (ct = q.ref, Ed(q, Ee));
        for (Ae in q)
          we.call(q, Ae) && !Md.hasOwnProperty(Ae) && (Me[Ae] = q[Ae]);
        if (E && E.defaultProps) {
          var qe = E.defaultProps;
          for (Ae in qe)
            Me[Ae] === void 0 && (Me[Ae] = qe[Ae]);
        }
        if (Le || ct) {
          var We = typeof E == "function" ? E.displayName || E.name || "Unknown" : E;
          Le && Td(Me, We), ct && kd(Me, We);
        }
        return jd(E, Le, ct, Ee, ye, ea.current, Me);
      }
    }
    var u1 = m.ReactCurrentOwner, yc = m.ReactDebugCurrentFrame;
    function gr(E) {
      if (E) {
        var q = E._owner, Q = _e(E.type, E._source, q ? q.type : null);
        yc.setExtraStackFrame(Q);
      } else
        yc.setExtraStackFrame(null);
    }
    var f1;
    f1 = !1;
    function p1(E) {
      return typeof E == "object" && E !== null && E.$$typeof === t;
    }
    function xc() {
      {
        if (u1.current) {
          var E = k(u1.current.type);
          if (E)
            return `

Check the render method of \`` + E + "`.";
        }
        return "";
      }
    }
    function Ad(E) {
      {
        if (E !== void 0) {
          var q = E.fileName.replace(/^.*[\\\/]/, ""), Q = E.lineNumber;
          return `

Check your code at ` + q + ":" + Q + ".";
        }
        return "";
      }
    }
    var _c = {};
    function $d(E) {
      {
        var q = xc();
        if (!q) {
          var Q = typeof E == "string" ? E : E.displayName || E.name;
          Q && (q = `

Check the top-level render call using <` + Q + ">.");
        }
        return q;
      }
    }
    function wc(E, q) {
      {
        if (!E._store || E._store.validated || E.key != null)
          return;
        E._store.validated = !0;
        var Q = $d(q);
        if (_c[Q])
          return;
        _c[Q] = !0;
        var ye = "";
        E && E._owner && E._owner !== u1.current && (ye = " It was passed a child from " + k(E._owner.type) + "."), gr(E), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Q, ye), gr(null);
      }
    }
    function Cc(E, q) {
      {
        if (typeof E != "object")
          return;
        if (l1(E))
          for (var Q = 0; Q < E.length; Q++) {
            var ye = E[Q];
            p1(ye) && wc(ye, q);
          }
        else if (p1(E))
          E._store && (E._store.validated = !0);
        else if (E) {
          var Ee = x(E);
          if (typeof Ee == "function" && Ee !== E.entries)
            for (var Ae = Ee.call(E), Me; !(Me = Ae.next()).done; )
              p1(Me.value) && wc(Me.value, q);
        }
      }
    }
    function Id(E) {
      {
        var q = E.type;
        if (q == null || typeof q == "string")
          return;
        var Q;
        if (typeof q == "function")
          Q = q.propTypes;
        else if (typeof q == "object" && (q.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        q.$$typeof === f))
          Q = q.propTypes;
        else
          return;
        if (Q) {
          var ye = k(q);
          at(Q, E.props, "prop", ye, E);
        } else if (q.PropTypes !== void 0 && !f1) {
          f1 = !0;
          var Ee = k(q);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ee || "Unknown");
        }
        typeof q.getDefaultProps == "function" && !q.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Od(E) {
      {
        for (var q = Object.keys(E.props), Q = 0; Q < q.length; Q++) {
          var ye = q[Q];
          if (ye !== "children" && ye !== "key") {
            gr(E), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ye), gr(null);
            break;
          }
        }
        E.ref !== null && (gr(E), b("Invalid attribute `ref` supplied to `React.Fragment`."), gr(null));
      }
    }
    function Sc(E, q, Q, ye, Ee, Ae) {
      {
        var Me = j(E);
        if (!Me) {
          var Le = "";
          (E === void 0 || typeof E == "object" && E !== null && Object.keys(E).length === 0) && (Le += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ct = Ad(Ee);
          ct ? Le += ct : Le += xc();
          var qe;
          E === null ? qe = "null" : l1(E) ? qe = "array" : E !== void 0 && E.$$typeof === t ? (qe = "<" + (k(E.type) || "Unknown") + " />", Le = " Did you accidentally export a JSX literal instead of a component?") : qe = typeof E, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", qe, Le);
        }
        var We = Pd(E, q, Q, Ee, Ae);
        if (We == null)
          return We;
        if (Me) {
          var xt = q.children;
          if (xt !== void 0)
            if (ye)
              if (l1(xt)) {
                for (var vr = 0; vr < xt.length; vr++)
                  Cc(xt[vr], E);
                Object.freeze && Object.freeze(xt);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cc(xt, E);
        }
        return E === r ? Od(We) : Id(We), We;
      }
    }
    function Rd(E, q, Q) {
      return Sc(E, q, Q, !0);
    }
    function Dd(E, q, Q) {
      return Sc(E, q, Q, !1);
    }
    var Fd = Dd, Bd = Rd;
    na.Fragment = r, na.jsx = Fd, na.jsxs = Bd;
  }()), na;
}
process.env.NODE_ENV === "production" ? Q1.exports = Wd() : Q1.exports = Ud();
var l = Q1.exports;
function M2(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = M2(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Gd() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = M2(e)) && (r && (r += " "), r += t);
  return r;
}
const zc = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, z = Gd, De = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return z(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: a, defaultVariants: i } = t, s = Object.keys(a).map((d) => {
    const u = n == null ? void 0 : n[d], f = i == null ? void 0 : i[d];
    if (u === null)
      return null;
    const p = zc(u) || zc(f);
    return a[d][p];
  }), o = n && Object.entries(n).reduce((d, u) => {
    let [f, p] = u;
    return p === void 0 || (d[f] = p), d;
  }, {}), c = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((d, u) => {
    let { class: f, className: p, ...h } = u;
    return Object.entries(h).every((g) => {
      let [v, x] = g;
      return Array.isArray(x) ? x.includes({
        ...i,
        ...o
      }[v]) : {
        ...i,
        ...o
      }[v] === x;
    }) ? [
      ...d,
      f,
      p
    ] : d;
  }, []);
  return z(e, s, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function Ne() {
  return Ne = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ne.apply(this, arguments);
}
function Di(e, t = []) {
  let n = [];
  function r(i, s) {
    const o = /* @__PURE__ */ on(s), c = n.length;
    n = [
      ...n,
      s
    ];
    function d(f) {
      const { scope: p, children: h, ...g } = f, v = (p == null ? void 0 : p[e][c]) || o, x = zt(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ ge(v.Provider, {
        value: x
      }, h);
    }
    function u(f, p) {
      const h = (p == null ? void 0 : p[e][c]) || o, g = Et(h);
      if (g)
        return g;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [
      d,
      u
    ];
  }
  const a = () => {
    const i = n.map((s) => /* @__PURE__ */ on(s));
    return function(o) {
      const c = (o == null ? void 0 : o[e]) || i;
      return zt(
        () => ({
          [`__scope${e}`]: {
            ...o,
            [e]: c
          }
        }),
        [
          o,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    r,
    Yd(a, ...t)
  ];
}
function Yd(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const s = r.reduce((o, { useScope: c, scopeName: d }) => {
        const f = c(i)[`__scope${d}`];
        return {
          ...o,
          ...f
        };
      }, {});
      return zt(
        () => ({
          [`__scope${t.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Kd(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function so(...e) {
  return (t) => e.forEach(
    (n) => Kd(n, t)
  );
}
function Rt(...e) {
  return ft(so(...e), e);
}
const lt = /* @__PURE__ */ K((e, t) => {
  const { children: n, ...r } = e, a = an.toArray(n), i = a.find(Zd);
  if (i) {
    const s = i.props.children, o = a.map((c) => c === i ? an.count(s) > 1 ? an.only(null) : /* @__PURE__ */ nr(s) ? s.props.children : null : c);
    return /* @__PURE__ */ ge(J1, Ne({}, r, {
      ref: t
    }), /* @__PURE__ */ nr(s) ? /* @__PURE__ */ Te(s, void 0, o) : null);
  }
  return /* @__PURE__ */ ge(J1, Ne({}, r, {
    ref: t
  }), n);
});
lt.displayName = "Slot";
const J1 = /* @__PURE__ */ K((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ nr(n) ? /* @__PURE__ */ Te(n, {
    ...Qd(r, n.props),
    ref: t ? so(t, n.ref) : n.ref
  }) : an.count(n) > 1 ? an.only(null) : null;
});
J1.displayName = "SlotClone";
const Xd = ({ children: e }) => /* @__PURE__ */ ge(Z1, null, e);
function Zd(e) {
  return /* @__PURE__ */ nr(e) && e.type === Xd;
}
function Qd(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...o) => {
      i(...o), a(...o);
    } : a && (n[r] = a) : r === "style" ? n[r] = {
      ...a,
      ...i
    } : r === "className" && (n[r] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function oo(e) {
  const t = e + "CollectionProvider", [n, r] = Di(t), [a, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), s = (h) => {
    const { scope: g, children: v } = h, x = Y.useRef(null), m = Y.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ Y.createElement(a, {
      scope: g,
      itemMap: m,
      collectionRef: x
    }, v);
  }, o = e + "CollectionSlot", c = /* @__PURE__ */ Y.forwardRef((h, g) => {
    const { scope: v, children: x } = h, m = i(o, v), b = Rt(g, m.collectionRef);
    return /* @__PURE__ */ Y.createElement(lt, {
      ref: b
    }, x);
  }), d = e + "CollectionItemSlot", u = "data-radix-collection-item", f = /* @__PURE__ */ Y.forwardRef((h, g) => {
    const { scope: v, children: x, ...m } = h, b = Y.useRef(null), _ = Rt(g, b), C = i(d, v);
    return Y.useEffect(() => (C.itemMap.set(b, {
      ref: b,
      ...m
    }), () => void C.itemMap.delete(b))), /* @__PURE__ */ Y.createElement(lt, {
      [u]: "",
      ref: _
    }, x);
  });
  function p(h) {
    const g = i(e + "CollectionConsumer", h);
    return Y.useCallback(() => {
      const x = g.collectionRef.current;
      if (!x)
        return [];
      const m = Array.from(x.querySelectorAll(`[${u}]`));
      return Array.from(g.itemMap.values()).sort(
        (C, w) => m.indexOf(C.ref.current) - m.indexOf(w.ref.current)
      );
    }, [
      g.collectionRef,
      g.itemMap
    ]);
  }
  return [
    {
      Provider: s,
      Slot: c,
      ItemSlot: f
    },
    p,
    r
  ];
}
function Ke(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function Lt(e) {
  const t = pe(e);
  return ve(() => {
    t.current = e;
  }), zt(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function Fi({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, a] = Jd({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, o = Lt(n), c = ft((d) => {
    if (i) {
      const f = typeof d == "function" ? d(e) : d;
      f !== e && o(f);
    } else
      a(d);
  }, [
    i,
    e,
    a,
    o
  ]);
  return [
    s,
    c
  ];
}
function Jd({ defaultProp: e, onChange: t }) {
  const n = ne(e), [r] = n, a = pe(r), i = Lt(t);
  return ve(() => {
    a.current !== r && (i(r), a.current = r);
  }, [
    r,
    a,
    i
  ]), n;
}
const e8 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ot = e8.reduce((e, t) => {
  const n = /* @__PURE__ */ K((r, a) => {
    const { asChild: i, ...s } = r, o = i ? lt : t;
    return ve(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ ge(o, Ne({}, s, {
      ref: a
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function t8(e, t) {
  e && S2(
    () => e.dispatchEvent(t)
  );
}
const rr = globalThis != null && globalThis.document ? io : () => {
};
function n8(e, t) {
  return Vd((n, r) => {
    const a = t[n][r];
    return a ?? n;
  }, e);
}
const Wr = (e) => {
  const { present: t, children: n } = e, r = r8(t), a = typeof n == "function" ? n({
    present: r.isPresent
  }) : an.only(n), i = Rt(r.ref, a.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Te(a, {
    ref: i
  }) : null;
};
Wr.displayName = "Presence";
function r8(e) {
  const [t, n] = ne(), r = pe({}), a = pe(e), i = pe("none"), s = e ? "mounted" : "unmounted", [o, c] = n8(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ve(() => {
    const d = Oa(r.current);
    i.current = o === "mounted" ? d : "none";
  }, [
    o
  ]), rr(() => {
    const d = r.current, u = a.current;
    if (u !== e) {
      const p = i.current, h = Oa(d);
      e ? c("MOUNT") : h === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(u && p !== h ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), rr(() => {
    if (t) {
      const d = (f) => {
        const h = Oa(r.current).includes(f.animationName);
        f.target === t && h && S2(
          () => c("ANIMATION_END")
        );
      }, u = (f) => {
        f.target === t && (i.current = Oa(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(o),
    ref: ft((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function Oa(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const a8 = y.useId || (() => {
});
let i8 = 0;
function Bi(e) {
  const [t, n] = y.useState(a8());
  return rr(() => {
    e || n(
      (r) => r ?? String(i8++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const N2 = "Collapsible", [s8, z2] = Di(N2), [o8, co] = s8(N2), c8 = /* @__PURE__ */ K((e, t) => {
  const { __scopeCollapsible: n, open: r, defaultOpen: a, disabled: i, onOpenChange: s, ...o } = e, [c = !1, d] = Fi({
    prop: r,
    defaultProp: a,
    onChange: s
  });
  return /* @__PURE__ */ ge(o8, {
    scope: n,
    disabled: i,
    contentId: Bi(),
    open: c,
    onOpenToggle: ft(
      () => d(
        (u) => !u
      ),
      [
        d
      ]
    )
  }, /* @__PURE__ */ ge(ot.div, Ne({
    "data-state": lo(c),
    "data-disabled": i ? "" : void 0
  }, o, {
    ref: t
  })));
}), l8 = "CollapsibleTrigger", d8 = /* @__PURE__ */ K((e, t) => {
  const { __scopeCollapsible: n, ...r } = e, a = co(l8, n);
  return /* @__PURE__ */ ge(ot.button, Ne({
    type: "button",
    "aria-controls": a.contentId,
    "aria-expanded": a.open || !1,
    "data-state": lo(a.open),
    "data-disabled": a.disabled ? "" : void 0,
    disabled: a.disabled
  }, r, {
    ref: t,
    onClick: Ke(e.onClick, a.onOpenToggle)
  }));
}), E2 = "CollapsibleContent", u8 = /* @__PURE__ */ K((e, t) => {
  const { forceMount: n, ...r } = e, a = co(E2, e.__scopeCollapsible);
  return /* @__PURE__ */ ge(
    Wr,
    {
      present: n || a.open
    },
    ({ present: i }) => /* @__PURE__ */ ge(f8, Ne({}, r, {
      ref: t,
      present: i
    }))
  );
}), f8 = /* @__PURE__ */ K((e, t) => {
  const { __scopeCollapsible: n, present: r, children: a, ...i } = e, s = co(E2, n), [o, c] = ne(r), d = pe(null), u = Rt(t, d), f = pe(0), p = f.current, h = pe(0), g = h.current, v = s.open || o, x = pe(v), m = pe();
  return ve(() => {
    const b = requestAnimationFrame(
      () => x.current = !1
    );
    return () => cancelAnimationFrame(b);
  }, []), rr(() => {
    const b = d.current;
    if (b) {
      m.current = m.current || {
        transitionDuration: b.style.transitionDuration,
        animationName: b.style.animationName
      }, b.style.transitionDuration = "0s", b.style.animationName = "none";
      const _ = b.getBoundingClientRect();
      f.current = _.height, h.current = _.width, x.current || (b.style.transitionDuration = m.current.transitionDuration, b.style.animationName = m.current.animationName), c(r);
    }
  }, [
    s.open,
    r
  ]), /* @__PURE__ */ ge(ot.div, Ne({
    "data-state": lo(s.open),
    "data-disabled": s.disabled ? "" : void 0,
    id: s.contentId,
    hidden: !v
  }, i, {
    ref: u,
    style: {
      "--radix-collapsible-content-height": p ? `${p}px` : void 0,
      "--radix-collapsible-content-width": g ? `${g}px` : void 0,
      ...e.style
    }
  }), v && a);
});
function lo(e) {
  return e ? "open" : "closed";
}
const T2 = c8, k2 = d8, j2 = u8, p8 = /* @__PURE__ */ on(void 0);
function P2(e) {
  const t = Et(p8);
  return e || t || "ltr";
}
const Fn = "Accordion", m8 = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [uo, h8, g8] = oo(Fn), [Vi, PE] = Di(Fn, [
  g8,
  z2
]), fo = z2(), A2 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { type: n, ...r } = e, a = r, i = r;
  return /* @__PURE__ */ Y.createElement(uo.Provider, {
    scope: e.__scopeAccordion
  }, n === "multiple" ? /* @__PURE__ */ Y.createElement(x8, Ne({}, i, {
    ref: t
  })) : /* @__PURE__ */ Y.createElement(y8, Ne({}, a, {
    ref: t
  })));
});
A2.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [$2, v8] = Vi(Fn), [I2, b8] = Vi(Fn, {
  collapsible: !1
}), y8 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: a = () => {
  }, collapsible: i = !1, ...s } = e, [o, c] = Fi({
    prop: n,
    defaultProp: r,
    onChange: a
  });
  return /* @__PURE__ */ Y.createElement($2, {
    scope: e.__scopeAccordion,
    value: o ? [
      o
    ] : [],
    onItemOpen: c,
    onItemClose: Y.useCallback(
      () => i && c(""),
      [
        i,
        c
      ]
    )
  }, /* @__PURE__ */ Y.createElement(I2, {
    scope: e.__scopeAccordion,
    collapsible: i
  }, /* @__PURE__ */ Y.createElement(O2, Ne({}, s, {
    ref: t
  }))));
}), x8 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: a = () => {
  }, ...i } = e, [s = [], o] = Fi({
    prop: n,
    defaultProp: r,
    onChange: a
  }), c = Y.useCallback(
    (u) => o(
      (f = []) => [
        ...f,
        u
      ]
    ),
    [
      o
    ]
  ), d = Y.useCallback(
    (u) => o(
      (f = []) => f.filter(
        (p) => p !== u
      )
    ),
    [
      o
    ]
  );
  return /* @__PURE__ */ Y.createElement($2, {
    scope: e.__scopeAccordion,
    value: s,
    onItemOpen: c,
    onItemClose: d
  }, /* @__PURE__ */ Y.createElement(I2, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ Y.createElement(O2, Ne({}, i, {
    ref: t
  }))));
}), [_8, Hi] = Vi(Fn), O2 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { __scopeAccordion: n, disabled: r, dir: a, orientation: i = "vertical", ...s } = e, o = Y.useRef(null), c = Rt(o, t), d = h8(n), f = P2(a) === "ltr", p = Ke(e.onKeyDown, (h) => {
    var g;
    if (!m8.includes(h.key))
      return;
    const v = h.target, x = d().filter((T) => {
      var j;
      return !((j = T.ref.current) !== null && j !== void 0 && j.disabled);
    }), m = x.findIndex(
      (T) => T.ref.current === v
    ), b = x.length;
    if (m === -1)
      return;
    h.preventDefault();
    let _ = m;
    const C = 0, w = b - 1, N = () => {
      _ = m + 1, _ > w && (_ = C);
    }, M = () => {
      _ = m - 1, _ < C && (_ = w);
    };
    switch (h.key) {
      case "Home":
        _ = C;
        break;
      case "End":
        _ = w;
        break;
      case "ArrowRight":
        i === "horizontal" && (f ? N() : M());
        break;
      case "ArrowDown":
        i === "vertical" && N();
        break;
      case "ArrowLeft":
        i === "horizontal" && (f ? M() : N());
        break;
      case "ArrowUp":
        i === "vertical" && M();
        break;
    }
    const S = _ % b;
    (g = x[S].ref.current) === null || g === void 0 || g.focus();
  });
  return /* @__PURE__ */ Y.createElement(_8, {
    scope: n,
    disabled: r,
    direction: a,
    orientation: i
  }, /* @__PURE__ */ Y.createElement(uo.Slot, {
    scope: n
  }, /* @__PURE__ */ Y.createElement(ot.div, Ne({}, s, {
    "data-orientation": i,
    ref: c,
    onKeyDown: r ? void 0 : p
  }))));
}), es = "AccordionItem", [w8, po] = Vi(es), C8 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { __scopeAccordion: n, value: r, ...a } = e, i = Hi(es, n), s = v8(es, n), o = fo(n), c = Bi(), d = r && s.value.includes(r) || !1, u = i.disabled || e.disabled;
  return /* @__PURE__ */ Y.createElement(w8, {
    scope: n,
    open: d,
    disabled: u,
    triggerId: c
  }, /* @__PURE__ */ Y.createElement(T2, Ne({
    "data-orientation": i.orientation,
    "data-state": R2(d)
  }, o, a, {
    ref: t,
    disabled: u,
    open: d,
    onOpenChange: (f) => {
      f ? s.onItemOpen(r) : s.onItemClose(r);
    }
  })));
}), S8 = "AccordionHeader", L8 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, a = Hi(Fn, n), i = po(S8, n);
  return /* @__PURE__ */ Y.createElement(ot.h3, Ne({
    "data-orientation": a.orientation,
    "data-state": R2(i.open),
    "data-disabled": i.disabled ? "" : void 0
  }, r, {
    ref: t
  }));
}), Ec = "AccordionTrigger", M8 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, a = Hi(Fn, n), i = po(Ec, n), s = b8(Ec, n), o = fo(n);
  return /* @__PURE__ */ Y.createElement(uo.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ Y.createElement(k2, Ne({
    "aria-disabled": i.open && !s.collapsible || void 0,
    "data-orientation": a.orientation,
    id: i.triggerId
  }, o, r, {
    ref: t
  })));
}), N8 = "AccordionContent", z8 = /* @__PURE__ */ Y.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, a = Hi(Fn, n), i = po(N8, n), s = fo(n);
  return /* @__PURE__ */ Y.createElement(j2, Ne({
    role: "region",
    "aria-labelledby": i.triggerId,
    "data-orientation": a.orientation
  }, s, r, {
    ref: t,
    style: {
      "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
      "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function R2(e) {
  return e ? "open" : "closed";
}
const Fr = A2, mo = C8, E8 = L8, fr = M8, Ur = z8, T8 = "_container_1shj5_209", k8 = "_trigger_1shj5_266", Yt = {
  container: T8,
  "utility-navigation-base": "_utility-navigation-base_1shj5_221",
  "nav-item": "_nav-item_1shj5_225",
  trigger: k8,
  "content-border": "_content-border_1shj5_266",
  "cta-button": "_cta-button_1shj5_273"
}, j8 = (e) => {
  const {
    className: t,
    navigationItems: n,
    ctaButtons: r,
    ariaLabel: a = "Utility Navigation"
  } = e, i = pe(null);
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      customRef: i,
      className: z(Yt.container, {
        [Yt.up]: !0
      }),
      children: /* @__PURE__ */ l.jsx(
        Oi,
        {
          className: z(Yt["utility-navigation-base"], t),
          "aria-label": a,
          "data-testid": "utility-navigation",
          children: /* @__PURE__ */ l.jsxs(a1, { children: [
            n == null ? void 0 : n.map((s, o) => {
              if ("title" in s) {
                const { title: c, links: d } = s;
                return /* @__PURE__ */ l.jsxs(
                  qt,
                  {
                    className: Yt["nav-item"],
                    value: o.toString(),
                    children: [
                      /* @__PURE__ */ l.jsxs(
                        lc,
                        {
                          className: z(Yt.trigger),
                          children: [
                            c,
                            /* @__PURE__ */ l.jsx(
                              "div",
                              {
                                role: "presentation",
                                className: Yt["content-border"]
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ l.jsx(dc, { children: d.map((u, f) => /* @__PURE__ */ l.jsx(
                        tr,
                        {
                          className: z(
                            Yt["menu-link"]
                          ),
                          underline: "none",
                          asInherited: !0,
                          children: u.link
                        },
                        f
                      )) })
                    ]
                  },
                  o
                );
              }
              return /* @__PURE__ */ l.jsx(
                qt,
                {
                  className: Yt["nav-item"],
                  children: /* @__PURE__ */ l.jsx(
                    tr,
                    {
                      asInherited: !0,
                      underline: "none",
                      children: s.link
                    }
                  )
                },
                o
              );
            }),
            r && /* @__PURE__ */ l.jsx(l.Fragment, { children: r.map((s, o) => /* @__PURE__ */ l.jsx(qt, { children: /* @__PURE__ */ l.jsx(
              tr,
              {
                "data-testid": "cta-button",
                variant: s.color,
                className: Yt["cta-button"],
                children: s.link
              }
            ) }, o)) })
          ] })
        }
      )
    }
  );
}, P8 = "_dropdownmenu_dn2sr_1", A8 = "_animateUp_dn2sr_1", m1 = {
  "utility-navigation-mobile-base": "_utility-navigation-mobile-base_dn2sr_209",
  "utility-navigation-mobile-list": "_utility-navigation-mobile-list_dn2sr_214",
  dropdownmenu: P8,
  animateUp: A8
}, $8 = (e) => {
  const { className: t, navigationItems: n, ctaButtons: r } = e;
  return /* @__PURE__ */ l.jsxs("div", { className: m1["utility-navigation-mobile-base"], children: [
    /* @__PURE__ */ l.jsx(
      "ul",
      {
        className: z(
          m1["utility-navigation-mobile-list"],
          t
        ),
        children: n == null ? void 0 : n.map((a, i) => {
          if ("title" in a) {
            const { title: s, links: o } = a;
            return /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsxs("details", { children: [
              /* @__PURE__ */ l.jsx("summary", { children: s }),
              /* @__PURE__ */ l.jsx("ul", { children: o.map((c, d) => /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx(
                X,
                {
                  underline: "none",
                  asInherited: !0,
                  children: c.mobileLink ?? c.link
                }
              ) }, d)) })
            ] }) }, i);
          } else
            return /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx(
              X,
              {
                underline: "none",
                asInherited: !0,
                children: a.mobileLink ?? a.link
              }
            ) }, i);
        })
      }
    ),
    r == null ? void 0 : r.map((a, i) => {
      const { color: s, link: o } = a;
      return /* @__PURE__ */ l.jsx(
        X,
        {
          className: m1["cta-button"],
          variant: s,
          size: "large",
          children: o
        },
        i
      );
    })
  ] });
}, I8 = ["top", "right", "bottom", "left"], jn = Math.min, vt = Math.max, gi = Math.round, Ra = Math.floor, Pn = (e) => ({
  x: e,
  y: e
}), O8 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, R8 = {
  start: "end",
  end: "start"
};
function ts(e, t, n) {
  return vt(e, jn(t, n));
}
function cn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ln(e) {
  return e.split("-")[0];
}
function Gr(e) {
  return e.split("-")[1];
}
function ho(e) {
  return e === "x" ? "y" : "x";
}
function go(e) {
  return e === "y" ? "height" : "width";
}
function Yr(e) {
  return ["top", "bottom"].includes(ln(e)) ? "y" : "x";
}
function vo(e) {
  return ho(Yr(e));
}
function D8(e, t, n) {
  n === void 0 && (n = !1);
  const r = Gr(e), a = vo(e), i = go(a);
  let s = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = vi(s)), [s, vi(s)];
}
function F8(e) {
  const t = vi(e);
  return [ns(e), t, ns(t)];
}
function ns(e) {
  return e.replace(/start|end/g, (t) => R8[t]);
}
function B8(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function V8(e, t, n, r) {
  const a = Gr(e);
  let i = B8(ln(e), n === "start", r);
  return a && (i = i.map((s) => s + "-" + a), t && (i = i.concat(i.map(ns)))), i;
}
function vi(e) {
  return e.replace(/left|right|bottom|top/g, (t) => O8[t]);
}
function H8(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function D2(e) {
  return typeof e != "number" ? H8(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function bi(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Tc(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = Yr(t), s = vo(t), o = go(s), c = ln(t), d = i === "y", u = r.x + r.width / 2 - a.width / 2, f = r.y + r.height / 2 - a.height / 2, p = r[o] / 2 - a[o] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: u,
        y: r.y - a.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: r.x - a.width,
        y: f
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Gr(t)) {
    case "start":
      h[s] -= p * (n && d ? -1 : 1);
      break;
    case "end":
      h[s] += p * (n && d ? -1 : 1);
      break;
  }
  return h;
}
const q8 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: s
  } = n, o = i.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let d = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: u,
    y: f
  } = Tc(d, r, c), p = r, h = {}, g = 0;
  for (let v = 0; v < o.length; v++) {
    const {
      name: x,
      fn: m
    } = o[v], {
      x: b,
      y: _,
      data: C,
      reset: w
    } = await m({
      x: u,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: a,
      middlewareData: h,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = b ?? u, f = _ ?? f, h = {
      ...h,
      [x]: {
        ...h[x],
        ...C
      }
    }, w && g <= 50 && (g++, typeof w == "object" && (w.placement && (p = w.placement), w.rects && (d = w.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : w.rects), {
      x: u,
      y: f
    } = Tc(d, p, c)), v = -1);
  }
  return {
    x: u,
    y: f,
    placement: p,
    strategy: a,
    middlewareData: h
  };
};
async function ha(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: s,
    elements: o,
    strategy: c
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = cn(t, e), g = D2(h), x = o[p ? f === "floating" ? "reference" : "floating" : f], m = bi(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(x))) == null || n ? x : x.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
    boundary: d,
    rootBoundary: u,
    strategy: c
  })), b = f === "floating" ? {
    ...s.floating,
    x: r,
    y: a
  } : s.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), C = await (i.isElement == null ? void 0 : i.isElement(_)) ? await (i.getScale == null ? void 0 : i.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = bi(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: b,
    offsetParent: _,
    strategy: c
  }) : b);
  return {
    top: (m.top - w.top + g.top) / C.y,
    bottom: (w.bottom - m.bottom + g.bottom) / C.y,
    left: (m.left - w.left + g.left) / C.x,
    right: (w.right - m.right + g.right) / C.x
  };
}
const W8 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: i,
      platform: s,
      elements: o,
      middlewareData: c
    } = t, {
      element: d,
      padding: u = 0
    } = cn(e, t) || {};
    if (d == null)
      return {};
    const f = D2(u), p = {
      x: n,
      y: r
    }, h = vo(a), g = go(h), v = await s.getDimensions(d), x = h === "y", m = x ? "top" : "left", b = x ? "bottom" : "right", _ = x ? "clientHeight" : "clientWidth", C = i.reference[g] + i.reference[h] - p[h] - i.floating[g], w = p[h] - i.reference[h], N = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(d));
    let M = N ? N[_] : 0;
    (!M || !await (s.isElement == null ? void 0 : s.isElement(N))) && (M = o.floating[_] || i.floating[g]);
    const S = C / 2 - w / 2, T = M / 2 - v[g] / 2 - 1, j = jn(f[m], T), D = jn(f[b], T), A = j, k = M - v[g] - D, $ = M / 2 - v[g] / 2 + S, R = ts(A, $, k), F = !c.arrow && Gr(a) != null && $ !== R && i.reference[g] / 2 - ($ < A ? j : D) - v[g] / 2 < 0, P = F ? $ < A ? $ - A : $ - k : 0;
    return {
      [h]: p[h] + P,
      data: {
        [h]: R,
        centerOffset: $ - R - P,
        ...F && {
          alignmentOffset: P
        }
      },
      reset: F
    };
  }
}), U8 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: i,
        rects: s,
        initialPlacement: o,
        platform: c,
        elements: d
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...x
      } = cn(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const m = ln(a), b = ln(o) === o, _ = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), C = p || (b || !v ? [vi(o)] : F8(o));
      !p && g !== "none" && C.push(...V8(o, v, g, _));
      const w = [o, ...C], N = await ha(t, x), M = [];
      let S = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && M.push(N[m]), f) {
        const A = D8(a, s, _);
        M.push(N[A[0]], N[A[1]]);
      }
      if (S = [...S, {
        placement: a,
        overflows: M
      }], !M.every((A) => A <= 0)) {
        var T, j;
        const A = (((T = i.flip) == null ? void 0 : T.index) || 0) + 1, k = w[A];
        if (k)
          return {
            data: {
              index: A,
              overflows: S
            },
            reset: {
              placement: k
            }
          };
        let $ = (j = S.filter((R) => R.overflows[0] <= 0).sort((R, F) => R.overflows[1] - F.overflows[1])[0]) == null ? void 0 : j.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var D;
              const R = (D = S.map((F) => [F.placement, F.overflows.filter((P) => P > 0).reduce((P, I) => P + I, 0)]).sort((F, P) => F[1] - P[1])[0]) == null ? void 0 : D[0];
              R && ($ = R);
              break;
            }
            case "initialPlacement":
              $ = o;
              break;
          }
        if (a !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function kc(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function jc(e) {
  return I8.some((t) => e[t] >= 0);
}
const G8 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = cn(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await ha(t, {
            ...a,
            elementContext: "reference"
          }), s = kc(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: jc(s)
            }
          };
        }
        case "escaped": {
          const i = await ha(t, {
            ...a,
            altBoundary: !0
          }), s = kc(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: jc(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Y8(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), s = ln(n), o = Gr(n), c = Yr(n) === "y", d = ["left", "top"].includes(s) ? -1 : 1, u = i && c ? -1 : 1, f = cn(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return o && typeof g == "number" && (h = o === "end" ? g * -1 : g), c ? {
    x: h * u,
    y: p * d
  } : {
    x: p * d,
    y: h * u
  };
}
const K8 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: i,
        placement: s,
        middlewareData: o
      } = t, c = await Y8(t, e);
      return s === ((n = o.offset) == null ? void 0 : n.placement) && (r = o.arrow) != null && r.alignmentOffset ? {} : {
        x: a + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, X8 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: o = {
          fn: (x) => {
            let {
              x: m,
              y: b
            } = x;
            return {
              x: m,
              y: b
            };
          }
        },
        ...c
      } = cn(e, t), d = {
        x: n,
        y: r
      }, u = await ha(t, c), f = Yr(ln(a)), p = ho(f);
      let h = d[p], g = d[f];
      if (i) {
        const x = p === "y" ? "top" : "left", m = p === "y" ? "bottom" : "right", b = h + u[x], _ = h - u[m];
        h = ts(b, h, _);
      }
      if (s) {
        const x = f === "y" ? "top" : "left", m = f === "y" ? "bottom" : "right", b = g + u[x], _ = g - u[m];
        g = ts(b, g, _);
      }
      const v = o.fn({
        ...t,
        [p]: h,
        [f]: g
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r
        }
      };
    }
  };
}, Z8 = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: a,
        rects: i,
        middlewareData: s
      } = t, {
        offset: o = 0,
        mainAxis: c = !0,
        crossAxis: d = !0
      } = cn(e, t), u = {
        x: n,
        y: r
      }, f = Yr(a), p = ho(f);
      let h = u[p], g = u[f];
      const v = cn(o, t), x = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (c) {
        const _ = p === "y" ? "height" : "width", C = i.reference[p] - i.floating[_] + x.mainAxis, w = i.reference[p] + i.reference[_] - x.mainAxis;
        h < C ? h = C : h > w && (h = w);
      }
      if (d) {
        var m, b;
        const _ = p === "y" ? "width" : "height", C = ["top", "left"].includes(ln(a)), w = i.reference[f] - i.floating[_] + (C && ((m = s.offset) == null ? void 0 : m[f]) || 0) + (C ? 0 : x.crossAxis), N = i.reference[f] + i.reference[_] + (C ? 0 : ((b = s.offset) == null ? void 0 : b[f]) || 0) - (C ? x.crossAxis : 0);
        g < w ? g = w : g > N && (g = N);
      }
      return {
        [p]: h,
        [f]: g
      };
    }
  };
}, Q8 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: a,
        elements: i
      } = t, {
        apply: s = () => {
        },
        ...o
      } = cn(e, t), c = await ha(t, o), d = ln(n), u = Gr(n), f = Yr(n) === "y", {
        width: p,
        height: h
      } = r.floating;
      let g, v;
      d === "top" || d === "bottom" ? (g = d, v = u === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (v = d, g = u === "end" ? "top" : "bottom");
      const x = h - c[g], m = p - c[v], b = !t.middlewareData.shift;
      let _ = x, C = m;
      if (f) {
        const N = p - c.left - c.right;
        C = u || b ? jn(m, N) : N;
      } else {
        const N = h - c.top - c.bottom;
        _ = u || b ? jn(x, N) : N;
      }
      if (b && !u) {
        const N = vt(c.left, 0), M = vt(c.right, 0), S = vt(c.top, 0), T = vt(c.bottom, 0);
        f ? C = p - 2 * (N !== 0 || M !== 0 ? N + M : vt(c.left, c.right)) : _ = h - 2 * (S !== 0 || T !== 0 ? S + T : vt(c.top, c.bottom));
      }
      await s({
        ...t,
        availableWidth: C,
        availableHeight: _
      });
      const w = await a.getDimensions(i.floating);
      return p !== w.width || h !== w.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function An(e) {
  return F2(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function bt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function gn(e) {
  var t;
  return (t = (F2(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function F2(e) {
  return e instanceof Node || e instanceof bt(e).Node;
}
function dn(e) {
  return e instanceof Element || e instanceof bt(e).Element;
}
function Wt(e) {
  return e instanceof HTMLElement || e instanceof bt(e).HTMLElement;
}
function Pc(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof bt(e).ShadowRoot;
}
function Na(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = Tt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function J8(e) {
  return ["table", "td", "th"].includes(An(e));
}
function bo(e) {
  const t = yo(), n = Tt(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function eu(e) {
  let t = Br(e);
  for (; Wt(t) && !qi(t); ) {
    if (bo(t))
      return t;
    t = Br(t);
  }
  return null;
}
function yo() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function qi(e) {
  return ["html", "body", "#document"].includes(An(e));
}
function Tt(e) {
  return bt(e).getComputedStyle(e);
}
function Wi(e) {
  return dn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Br(e) {
  if (An(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Pc(e) && e.host || // Fallback.
    gn(e)
  );
  return Pc(t) ? t.host : t;
}
function B2(e) {
  const t = Br(e);
  return qi(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Wt(t) && Na(t) ? t : B2(t);
}
function ga(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = B2(e), i = a === ((r = e.ownerDocument) == null ? void 0 : r.body), s = bt(a);
  return i ? t.concat(s, s.visualViewport || [], Na(a) ? a : [], s.frameElement && n ? ga(s.frameElement) : []) : t.concat(a, ga(a, [], n));
}
function V2(e) {
  const t = Tt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = Wt(e), i = a ? e.offsetWidth : n, s = a ? e.offsetHeight : r, o = gi(n) !== i || gi(r) !== s;
  return o && (n = i, r = s), {
    width: n,
    height: r,
    $: o
  };
}
function xo(e) {
  return dn(e) ? e : e.contextElement;
}
function Ir(e) {
  const t = xo(e);
  if (!Wt(t))
    return Pn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = V2(t);
  let s = (i ? gi(n.width) : n.width) / r, o = (i ? gi(n.height) : n.height) / a;
  return (!s || !Number.isFinite(s)) && (s = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: s,
    y: o
  };
}
const tu = /* @__PURE__ */ Pn(0);
function H2(e) {
  const t = bt(e);
  return !yo() || !t.visualViewport ? tu : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function nu(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== bt(e) ? !1 : t;
}
function ar(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = xo(e);
  let s = Pn(1);
  t && (r ? dn(r) && (s = Ir(r)) : s = Ir(e));
  const o = nu(i, n, r) ? H2(i) : Pn(0);
  let c = (a.left + o.x) / s.x, d = (a.top + o.y) / s.y, u = a.width / s.x, f = a.height / s.y;
  if (i) {
    const p = bt(i), h = r && dn(r) ? bt(r) : r;
    let g = p, v = g.frameElement;
    for (; v && r && h !== g; ) {
      const x = Ir(v), m = v.getBoundingClientRect(), b = Tt(v), _ = m.left + (v.clientLeft + parseFloat(b.paddingLeft)) * x.x, C = m.top + (v.clientTop + parseFloat(b.paddingTop)) * x.y;
      c *= x.x, d *= x.y, u *= x.x, f *= x.y, c += _, d += C, g = bt(v), v = g.frameElement;
    }
  }
  return bi({
    width: u,
    height: f,
    x: c,
    y: d
  });
}
const ru = [":popover-open", ":modal"];
function q2(e) {
  return ru.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function au(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const i = a === "fixed", s = gn(r), o = t ? q2(t.floating) : !1;
  if (r === s || o && i)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Pn(1);
  const u = Pn(0), f = Wt(r);
  if ((f || !f && !i) && ((An(r) !== "body" || Na(s)) && (c = Wi(r)), Wt(r))) {
    const p = ar(r);
    d = Ir(r), u.x = p.x + r.clientLeft, u.y = p.y + r.clientTop;
  }
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - c.scrollLeft * d.x + u.x,
    y: n.y * d.y - c.scrollTop * d.y + u.y
  };
}
function iu(e) {
  return Array.from(e.getClientRects());
}
function W2(e) {
  return ar(gn(e)).left + Wi(e).scrollLeft;
}
function su(e) {
  const t = gn(e), n = Wi(e), r = e.ownerDocument.body, a = vt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = vt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + W2(e);
  const o = -n.scrollTop;
  return Tt(r).direction === "rtl" && (s += vt(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: s,
    y: o
  };
}
function ou(e, t) {
  const n = bt(e), r = gn(e), a = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, o = 0, c = 0;
  if (a) {
    i = a.width, s = a.height;
    const d = yo();
    (!d || d && t === "fixed") && (o = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: o,
    y: c
  };
}
function cu(e, t) {
  const n = ar(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = Wt(e) ? Ir(e) : Pn(1), s = e.clientWidth * i.x, o = e.clientHeight * i.y, c = a * i.x, d = r * i.y;
  return {
    width: s,
    height: o,
    x: c,
    y: d
  };
}
function Ac(e, t, n) {
  let r;
  if (t === "viewport")
    r = ou(e, n);
  else if (t === "document")
    r = su(gn(e));
  else if (dn(t))
    r = cu(t, n);
  else {
    const a = H2(e);
    r = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return bi(r);
}
function U2(e, t) {
  const n = Br(e);
  return n === t || !dn(n) || qi(n) ? !1 : Tt(n).position === "fixed" || U2(n, t);
}
function lu(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ga(e, [], !1).filter((o) => dn(o) && An(o) !== "body"), a = null;
  const i = Tt(e).position === "fixed";
  let s = i ? Br(e) : e;
  for (; dn(s) && !qi(s); ) {
    const o = Tt(s), c = bo(s);
    !c && o.position === "fixed" && (a = null), (i ? !c && !a : !c && o.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || Na(s) && !c && U2(e, s)) ? r = r.filter((u) => u !== s) : a = o, s = Br(s);
  }
  return t.set(e, r), r;
}
function du(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const s = [...n === "clippingAncestors" ? lu(t, this._c) : [].concat(n), r], o = s[0], c = s.reduce((d, u) => {
    const f = Ac(t, u, a);
    return d.top = vt(f.top, d.top), d.right = jn(f.right, d.right), d.bottom = jn(f.bottom, d.bottom), d.left = vt(f.left, d.left), d;
  }, Ac(t, o, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function uu(e) {
  const {
    width: t,
    height: n
  } = V2(e);
  return {
    width: t,
    height: n
  };
}
function fu(e, t, n) {
  const r = Wt(t), a = gn(t), i = n === "fixed", s = ar(e, !0, i, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Pn(0);
  if (r || !r && !i)
    if ((An(t) !== "body" || Na(a)) && (o = Wi(t)), r) {
      const f = ar(t, !0, i, t);
      c.x = f.x + t.clientLeft, c.y = f.y + t.clientTop;
    } else
      a && (c.x = W2(a));
  const d = s.left + o.scrollLeft - c.x, u = s.top + o.scrollTop - c.y;
  return {
    x: d,
    y: u,
    width: s.width,
    height: s.height
  };
}
function $c(e, t) {
  return !Wt(e) || Tt(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function G2(e, t) {
  const n = bt(e);
  if (!Wt(e) || q2(e))
    return n;
  let r = $c(e, t);
  for (; r && J8(r) && Tt(r).position === "static"; )
    r = $c(r, t);
  return r && (An(r) === "html" || An(r) === "body" && Tt(r).position === "static" && !bo(r)) ? n : r || eu(e) || n;
}
const pu = async function(e) {
  const t = this.getOffsetParent || G2, n = this.getDimensions;
  return {
    reference: fu(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await n(e.floating)
    }
  };
};
function mu(e) {
  return Tt(e).direction === "rtl";
}
const hu = {
  convertOffsetParentRelativeRectToViewportRelativeRect: au,
  getDocumentElement: gn,
  getClippingRect: du,
  getOffsetParent: G2,
  getElementRects: pu,
  getClientRects: iu,
  getDimensions: uu,
  getScale: Ir,
  isElement: dn,
  isRTL: mu
};
function gu(e, t) {
  let n = null, r;
  const a = gn(e);
  function i() {
    var o;
    clearTimeout(r), (o = n) == null || o.disconnect(), n = null;
  }
  function s(o, c) {
    o === void 0 && (o = !1), c === void 0 && (c = 1), i();
    const {
      left: d,
      top: u,
      width: f,
      height: p
    } = e.getBoundingClientRect();
    if (o || t(), !f || !p)
      return;
    const h = Ra(u), g = Ra(a.clientWidth - (d + f)), v = Ra(a.clientHeight - (u + p)), x = Ra(d), b = {
      rootMargin: -h + "px " + -g + "px " + -v + "px " + -x + "px",
      threshold: vt(0, jn(1, c)) || 1
    };
    let _ = !0;
    function C(w) {
      const N = w[0].intersectionRatio;
      if (N !== c) {
        if (!_)
          return s();
        N ? s(!1, N) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      _ = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...b,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, b);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function vu(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, d = xo(e), u = a || i ? [...d ? ga(d) : [], ...ga(t)] : [];
  u.forEach((m) => {
    a && m.addEventListener("scroll", n, {
      passive: !0
    }), i && m.addEventListener("resize", n);
  });
  const f = d && o ? gu(d, n) : null;
  let p = -1, h = null;
  s && (h = new ResizeObserver((m) => {
    let [b] = m;
    b && b.target === d && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var _;
      (_ = h) == null || _.observe(t);
    })), n();
  }), d && !c && h.observe(d), h.observe(t));
  let g, v = c ? ar(e) : null;
  c && x();
  function x() {
    const m = ar(e);
    v && (m.x !== v.x || m.y !== v.y || m.width !== v.width || m.height !== v.height) && n(), v = m, g = requestAnimationFrame(x);
  }
  return n(), () => {
    var m;
    u.forEach((b) => {
      a && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), f == null || f(), (m = h) == null || m.disconnect(), h = null, c && cancelAnimationFrame(g);
  };
}
const bu = X8, yu = U8, xu = Q8, _u = G8, Ic = W8, wu = Z8, Cu = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: hu,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return q8(e, t, {
    ...a,
    platform: i
  });
}, Su = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: a
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Ic({
        element: r.current,
        padding: a
      }).fn(n) : {} : r ? Ic({
        element: r,
        padding: a
      }).fn(n) : {};
    }
  };
};
var fi = typeof document < "u" ? io : ve;
function yi(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!yi(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = a[r];
      if (!(i === "_owner" && e.$$typeof) && !yi(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Y2(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Oc(e, t) {
  const n = Y2(e);
  return Math.round(t * n) / n;
}
function Rc(e) {
  const t = y.useRef(e);
  return fi(() => {
    t.current = e;
  }), t;
}
function Lu(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: o = !0,
    whileElementsMounted: c,
    open: d
  } = e, [u, f] = y.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, h] = y.useState(r);
  yi(p, r) || h(r);
  const [g, v] = y.useState(null), [x, m] = y.useState(null), b = y.useCallback((P) => {
    P !== N.current && (N.current = P, v(P));
  }, []), _ = y.useCallback((P) => {
    P !== M.current && (M.current = P, m(P));
  }, []), C = i || g, w = s || x, N = y.useRef(null), M = y.useRef(null), S = y.useRef(u), T = c != null, j = Rc(c), D = Rc(a), A = y.useCallback(() => {
    if (!N.current || !M.current)
      return;
    const P = {
      placement: t,
      strategy: n,
      middleware: p
    };
    D.current && (P.platform = D.current), Cu(N.current, M.current, P).then((I) => {
      const H = {
        ...I,
        isPositioned: !0
      };
      k.current && !yi(S.current, H) && (S.current = H, Dn.flushSync(() => {
        f(H);
      }));
    });
  }, [p, t, n, D]);
  fi(() => {
    d === !1 && S.current.isPositioned && (S.current.isPositioned = !1, f((P) => ({
      ...P,
      isPositioned: !1
    })));
  }, [d]);
  const k = y.useRef(!1);
  fi(() => (k.current = !0, () => {
    k.current = !1;
  }), []), fi(() => {
    if (C && (N.current = C), w && (M.current = w), C && w) {
      if (j.current)
        return j.current(C, w, A);
      A();
    }
  }, [C, w, A, j, T]);
  const $ = y.useMemo(() => ({
    reference: N,
    floating: M,
    setReference: b,
    setFloating: _
  }), [b, _]), R = y.useMemo(() => ({
    reference: C,
    floating: w
  }), [C, w]), F = y.useMemo(() => {
    const P = {
      position: n,
      left: 0,
      top: 0
    };
    if (!R.floating)
      return P;
    const I = Oc(R.floating, u.x), H = Oc(R.floating, u.y);
    return o ? {
      ...P,
      transform: "translate(" + I + "px, " + H + "px)",
      ...Y2(R.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: I,
      top: H
    };
  }, [n, o, R.floating, u.x, u.y]);
  return y.useMemo(() => ({
    ...u,
    update: A,
    refs: $,
    elements: R,
    floatingStyles: F
  }), [u, A, $, R, F]);
}
function Mu(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function K2(...e) {
  return (t) => e.forEach((n) => Mu(n, t));
}
function X2(...e) {
  return y.useCallback(K2(...e), e);
}
var Z2 = y.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = y.Children.toArray(n), i = a.find(zu);
  if (i) {
    const s = i.props.children, o = a.map((c) => c === i ? y.Children.count(s) > 1 ? y.Children.only(null) : y.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ l.jsx(rs, { ...r, ref: t, children: y.isValidElement(s) ? y.cloneElement(s, void 0, o) : null });
  }
  return /* @__PURE__ */ l.jsx(rs, { ...r, ref: t, children: n });
});
Z2.displayName = "Slot";
var rs = y.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (y.isValidElement(n)) {
    const a = Tu(n);
    return y.cloneElement(n, {
      ...Eu(r, n.props),
      // @ts-ignore
      ref: t ? K2(t, a) : a
    });
  }
  return y.Children.count(n) > 1 ? y.Children.only(null) : null;
});
rs.displayName = "SlotClone";
var Nu = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
function zu(e) {
  return y.isValidElement(e) && e.type === Nu;
}
function Eu(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...o) => {
      i(...o), a(...o);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Tu(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ku = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], _o = ku.reduce((e, t) => {
  const n = y.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, o = i ? Z2 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(o, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), ju = "Arrow", Q2 = y.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: a = 5, ...i } = e;
  return /* @__PURE__ */ l.jsx(
    _o.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ l.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Q2.displayName = ju;
var Pu = Q2;
function Au(e, t = []) {
  let n = [];
  function r(i, s) {
    const o = y.createContext(s), c = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: p, children: h, ...g } = f, v = (p == null ? void 0 : p[e][c]) || o, x = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ l.jsx(v.Provider, { value: x, children: h });
    }
    function u(f, p) {
      const h = (p == null ? void 0 : p[e][c]) || o, g = y.useContext(h);
      if (g)
        return g;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, u];
  }
  const a = () => {
    const i = n.map((s) => y.createContext(s));
    return function(o) {
      const c = (o == null ? void 0 : o[e]) || i;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: c } }),
        [o, c]
      );
    };
  };
  return a.scopeName = e, [r, $u(a, ...t)];
}
function $u(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const s = r.reduce((o, { useScope: c, scopeName: d }) => {
        const f = c(i)[`__scope${d}`];
        return { ...o, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Iu(e) {
  const t = y.useRef(e);
  return y.useEffect(() => {
    t.current = e;
  }), y.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var as = globalThis != null && globalThis.document ? y.useLayoutEffect : () => {
};
function Ou(e) {
  const [t, n] = y.useState(void 0);
  return as(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const i = a[0];
        let s, o;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          s = d.inlineSize, o = d.blockSize;
        } else
          s = e.offsetWidth, o = e.offsetHeight;
        n({ width: s, height: o });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var wo = "Popper", [J2, e0] = Au(wo), [Ru, t0] = J2(wo), n0 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = y.useState(null);
  return /* @__PURE__ */ l.jsx(Ru, { scope: t, anchor: r, onAnchorChange: a, children: n });
};
n0.displayName = wo;
var r0 = "PopperAnchor", a0 = y.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...a } = e, i = t0(r0, n), s = y.useRef(null), o = X2(t, s);
    return y.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ l.jsx(_o.div, { ...a, ref: o });
  }
);
a0.displayName = r0;
var Co = "PopperContent", [Du, Fu] = J2(Co), i0 = y.forwardRef(
  (e, t) => {
    var U, J, fe, Z, be, L;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: a = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: o = 0,
      avoidCollisions: c = !0,
      collisionBoundary: d = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: g,
      ...v
    } = e, x = t0(Co, n), [m, b] = y.useState(null), _ = X2(t, (B) => b(B)), [C, w] = y.useState(null), N = Ou(C), M = (N == null ? void 0 : N.width) ?? 0, S = (N == null ? void 0 : N.height) ?? 0, T = r + (i !== "center" ? "-" + i : ""), j = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, D = Array.isArray(d) ? d : [d], A = D.length > 0, k = {
      padding: j,
      boundary: D.filter(Vu),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: A
    }, { refs: $, floatingStyles: R, placement: F, isPositioned: P, middlewareData: I } = Lu({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: T,
      whileElementsMounted: (...B) => vu(...B, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: x.anchor
      },
      middleware: [
        K8({ mainAxis: a + S, alignmentAxis: s }),
        c && bu({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? wu() : void 0,
          ...k
        }),
        c && yu({ ...k }),
        xu({
          ...k,
          apply: ({ elements: B, rects: ce, availableWidth: _e, availableHeight: we }) => {
            const { width: ze, height: Ge } = ce.reference, Pe = B.floating.style;
            Pe.setProperty("--radix-popper-available-width", `${_e}px`), Pe.setProperty("--radix-popper-available-height", `${we}px`), Pe.setProperty("--radix-popper-anchor-width", `${ze}px`), Pe.setProperty("--radix-popper-anchor-height", `${Ge}px`);
          }
        }),
        C && Su({ element: C, padding: o }),
        Hu({ arrowWidth: M, arrowHeight: S }),
        p && _u({ strategy: "referenceHidden", ...k })
      ]
    }), [H, O] = c0(F), W = Iu(g);
    as(() => {
      P && (W == null || W());
    }, [P, W]);
    const se = (U = I.arrow) == null ? void 0 : U.x, ue = (J = I.arrow) == null ? void 0 : J.y, ee = ((fe = I.arrow) == null ? void 0 : fe.centerOffset) !== 0, [ae, ie] = y.useState();
    return as(() => {
      m && ie(window.getComputedStyle(m).zIndex);
    }, [m]), /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: $.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...R,
          transform: P ? R.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ae,
          "--radix-popper-transform-origin": [
            (Z = I.transformOrigin) == null ? void 0 : Z.x,
            (be = I.transformOrigin) == null ? void 0 : be.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((L = I.hide) == null ? void 0 : L.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ l.jsx(
          Du,
          {
            scope: n,
            placedSide: H,
            onArrowChange: w,
            arrowX: se,
            arrowY: ue,
            shouldHideArrow: ee,
            children: /* @__PURE__ */ l.jsx(
              _o.div,
              {
                "data-side": H,
                "data-align": O,
                ...v,
                ref: _,
                style: {
                  ...v.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: P ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
i0.displayName = Co;
var s0 = "PopperArrow", Bu = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, o0 = y.forwardRef(function(t, n) {
  const { __scopePopper: r, ...a } = t, i = Fu(s0, r), s = Bu[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l.jsx(
          Pu,
          {
            ...a,
            ref: n,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
o0.displayName = s0;
function Vu(e) {
  return e !== null;
}
var Hu = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var x, m, b;
    const { placement: n, rects: r, middlewareData: a } = t, s = ((x = a.arrow) == null ? void 0 : x.centerOffset) !== 0, o = s ? 0 : e.arrowWidth, c = s ? 0 : e.arrowHeight, [d, u] = c0(n), f = { start: "0%", center: "50%", end: "100%" }[u], p = (((m = a.arrow) == null ? void 0 : m.x) ?? 0) + o / 2, h = (((b = a.arrow) == null ? void 0 : b.y) ?? 0) + c / 2;
    let g = "", v = "";
    return d === "bottom" ? (g = s ? f : `${p}px`, v = `${-c}px`) : d === "top" ? (g = s ? f : `${p}px`, v = `${r.floating.height + c}px`) : d === "right" ? (g = `${-c}px`, v = s ? f : `${h}px`) : d === "left" && (g = `${r.floating.width + c}px`, v = s ? f : `${h}px`), { data: { x: g, y: v } };
  }
});
function c0(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var qu = n0, Wu = a0, Uu = i0, Gu = o0;
function Yu(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ku(...e) {
  return (t) => e.forEach((n) => Yu(n, t));
}
var l0 = y.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = y.Children.toArray(n), i = a.find(Zu);
  if (i) {
    const s = i.props.children, o = a.map((c) => c === i ? y.Children.count(s) > 1 ? y.Children.only(null) : y.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ l.jsx(is, { ...r, ref: t, children: y.isValidElement(s) ? y.cloneElement(s, void 0, o) : null });
  }
  return /* @__PURE__ */ l.jsx(is, { ...r, ref: t, children: n });
});
l0.displayName = "Slot";
var is = y.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (y.isValidElement(n)) {
    const a = Ju(n);
    return y.cloneElement(n, {
      ...Qu(r, n.props),
      // @ts-ignore
      ref: t ? Ku(t, a) : a
    });
  }
  return y.Children.count(n) > 1 ? y.Children.only(null) : null;
});
is.displayName = "SlotClone";
var Xu = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
function Zu(e) {
  return y.isValidElement(e) && e.type === Xu;
}
function Qu(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...o) => {
      i(...o), a(...o);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Ju(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ef = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], tf = ef.reduce((e, t) => {
  const n = y.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, o = i ? l0 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(o, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), nf = globalThis != null && globalThis.document ? y.useLayoutEffect : () => {
}, rf = "Portal", So = y.forwardRef((e, t) => {
  var o;
  const { container: n, ...r } = e, [a, i] = y.useState(!1);
  nf(() => i(!0), []);
  const s = n || a && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return s ? C2.createPortal(/* @__PURE__ */ l.jsx(tf.div, { ...r, ref: t }), s) : null;
});
So.displayName = rf;
function af(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function sf(...e) {
  return (t) => e.forEach((n) => af(n, t));
}
var d0 = y.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = y.Children.toArray(n), i = a.find(cf);
  if (i) {
    const s = i.props.children, o = a.map((c) => c === i ? y.Children.count(s) > 1 ? y.Children.only(null) : y.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ l.jsx(ss, { ...r, ref: t, children: y.isValidElement(s) ? y.cloneElement(s, void 0, o) : null });
  }
  return /* @__PURE__ */ l.jsx(ss, { ...r, ref: t, children: n });
});
d0.displayName = "Slot";
var ss = y.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (y.isValidElement(n)) {
    const a = df(n);
    return y.cloneElement(n, {
      ...lf(r, n.props),
      // @ts-ignore
      ref: t ? sf(t, a) : a
    });
  }
  return y.Children.count(n) > 1 ? y.Children.only(null) : null;
});
ss.displayName = "SlotClone";
var of = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
function cf(e) {
  return y.isValidElement(e) && e.type === of;
}
function lf(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...o) => {
      i(...o), a(...o);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function df(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var uf = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ff = uf.reduce((e, t) => {
  const n = y.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, o = i ? d0 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(o, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), pf = "AspectRatio", u0 = y.forwardRef(
  (e, t) => {
    const { ratio: n = 1 / 1, style: r, ...a } = e;
    return /* @__PURE__ */ l.jsx(
      "div",
      {
        style: {
          // ensures inner element is contained
          position: "relative",
          // ensures padding bottom trick maths works
          width: "100%",
          paddingBottom: `${100 / n}%`
        },
        "data-radix-aspect-ratio-wrapper": "",
        children: /* @__PURE__ */ l.jsx(
          ff.div,
          {
            ...a,
            ref: t,
            style: {
              ...r,
              // ensures children expand in ratio
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }
          }
        )
      }
    );
  }
);
u0.displayName = pf;
var mf = u0;
function hf(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function f0(...e) {
  return (t) => e.forEach((n) => hf(n, t));
}
function p0(...e) {
  return y.useCallback(f0(...e), e);
}
function gf(e, t = []) {
  let n = [];
  function r(i, s) {
    const o = y.createContext(s), c = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: p, children: h, ...g } = f, v = (p == null ? void 0 : p[e][c]) || o, x = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ l.jsx(v.Provider, { value: x, children: h });
    }
    function u(f, p) {
      const h = (p == null ? void 0 : p[e][c]) || o, g = y.useContext(h);
      if (g)
        return g;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, u];
  }
  const a = () => {
    const i = n.map((s) => y.createContext(s));
    return function(o) {
      const c = (o == null ? void 0 : o[e]) || i;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: c } }),
        [o, c]
      );
    };
  };
  return a.scopeName = e, [r, vf(a, ...t)];
}
function vf(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const s = r.reduce((o, { useScope: c, scopeName: d }) => {
        const f = c(i)[`__scope${d}`];
        return { ...o, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Dc(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function m0(e) {
  const t = y.useRef(e);
  return y.useEffect(() => {
    t.current = e;
  }), y.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function bf({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = yf({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, o = m0(n), c = y.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && o(f);
      } else
        a(d);
    },
    [i, e, a, o]
  );
  return [s, c];
}
function yf({
  defaultProp: e,
  onChange: t
}) {
  const n = y.useState(e), [r] = n, a = y.useRef(r), i = m0(t);
  return y.useEffect(() => {
    a.current !== r && (i(r), a.current = r);
  }, [r, a, i]), n;
}
function xf(e) {
  const t = y.useRef({ value: e, previous: e });
  return y.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var os = globalThis != null && globalThis.document ? y.useLayoutEffect : () => {
};
function _f(e) {
  const [t, n] = y.useState(void 0);
  return os(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const i = a[0];
        let s, o;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          s = d.inlineSize, o = d.blockSize;
        } else
          s = e.offsetWidth, o = e.offsetHeight;
        n({ width: s, height: o });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function wf(e, t) {
  return y.useReducer((n, r) => t[n][r] ?? n, e);
}
var h0 = (e) => {
  const { present: t, children: n } = e, r = Cf(t), a = typeof n == "function" ? n({ present: r.isPresent }) : y.Children.only(n), i = p0(r.ref, Sf(a));
  return typeof n == "function" || r.isPresent ? y.cloneElement(a, { ref: i }) : null;
};
h0.displayName = "Presence";
function Cf(e) {
  const [t, n] = y.useState(), r = y.useRef({}), a = y.useRef(e), i = y.useRef("none"), s = e ? "mounted" : "unmounted", [o, c] = wf(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return y.useEffect(() => {
    const d = Da(r.current);
    i.current = o === "mounted" ? d : "none";
  }, [o]), os(() => {
    const d = r.current, u = a.current;
    if (u !== e) {
      const p = i.current, h = Da(d);
      e ? c("MOUNT") : h === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(u && p !== h ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, c]), os(() => {
    if (t) {
      const d = (f) => {
        const h = Da(r.current).includes(f.animationName);
        f.target === t && h && Dn.flushSync(() => c("ANIMATION_END"));
      }, u = (f) => {
        f.target === t && (i.current = Da(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: y.useCallback((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function Da(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Sf(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var g0 = y.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = y.Children.toArray(n), i = a.find(Mf);
  if (i) {
    const s = i.props.children, o = a.map((c) => c === i ? y.Children.count(s) > 1 ? y.Children.only(null) : y.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ l.jsx(cs, { ...r, ref: t, children: y.isValidElement(s) ? y.cloneElement(s, void 0, o) : null });
  }
  return /* @__PURE__ */ l.jsx(cs, { ...r, ref: t, children: n });
});
g0.displayName = "Slot";
var cs = y.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (y.isValidElement(n)) {
    const a = zf(n);
    return y.cloneElement(n, {
      ...Nf(r, n.props),
      // @ts-ignore
      ref: t ? f0(t, a) : a
    });
  }
  return y.Children.count(n) > 1 ? y.Children.only(null) : null;
});
cs.displayName = "SlotClone";
var Lf = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
function Mf(e) {
  return y.isValidElement(e) && e.type === Lf;
}
function Nf(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...o) => {
      i(...o), a(...o);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function zf(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ef = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], v0 = Ef.reduce((e, t) => {
  const n = y.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, o = i ? g0 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(o, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Lo = "Checkbox", [Tf, AE] = gf(Lo), [kf, jf] = Tf(Lo), b0 = y.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: a,
      defaultChecked: i,
      required: s,
      disabled: o,
      value: c = "on",
      onCheckedChange: d,
      ...u
    } = e, [f, p] = y.useState(null), h = p0(t, (_) => p(_)), g = y.useRef(!1), v = f ? !!f.closest("form") : !0, [x = !1, m] = bf({
      prop: a,
      defaultProp: i,
      onChange: d
    }), b = y.useRef(x);
    return y.useEffect(() => {
      const _ = f == null ? void 0 : f.form;
      if (_) {
        const C = () => m(b.current);
        return _.addEventListener("reset", C), () => _.removeEventListener("reset", C);
      }
    }, [f, m]), /* @__PURE__ */ l.jsxs(kf, { scope: n, state: x, disabled: o, children: [
      /* @__PURE__ */ l.jsx(
        v0.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": er(x) ? "mixed" : x,
          "aria-required": s,
          "data-state": _0(x),
          "data-disabled": o ? "" : void 0,
          disabled: o,
          value: c,
          ...u,
          ref: h,
          onKeyDown: Dc(e.onKeyDown, (_) => {
            _.key === "Enter" && _.preventDefault();
          }),
          onClick: Dc(e.onClick, (_) => {
            m((C) => er(C) ? !0 : !C), v && (g.current = _.isPropagationStopped(), g.current || _.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ l.jsx(
        Pf,
        {
          control: f,
          bubbles: !g.current,
          name: r,
          value: c,
          checked: x,
          required: s,
          disabled: o,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
b0.displayName = Lo;
var y0 = "CheckboxIndicator", x0 = y.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...a } = e, i = jf(y0, n);
    return /* @__PURE__ */ l.jsx(h0, { present: r || er(i.state) || i.state === !0, children: /* @__PURE__ */ l.jsx(
      v0.span,
      {
        "data-state": _0(i.state),
        "data-disabled": i.disabled ? "" : void 0,
        ...a,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
x0.displayName = y0;
var Pf = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...a } = e, i = y.useRef(null), s = xf(n), o = _f(t);
  return y.useEffect(() => {
    const c = i.current, d = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== n && f) {
      const p = new Event("click", { bubbles: r });
      c.indeterminate = er(n), f.call(c, er(n) ? !1 : n), c.dispatchEvent(p);
    }
  }, [s, n, r]), /* @__PURE__ */ l.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: er(n) ? !1 : n,
      ...a,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...o,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function er(e) {
  return e === "indeterminate";
}
function _0(e) {
  return er(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var w0 = b0, Af = x0;
function Fc(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Je(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function C0(e, t = []) {
  let n = [];
  function r(i, s) {
    const o = y.createContext(s), c = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: p, children: h, ...g } = f, v = (p == null ? void 0 : p[e][c]) || o, x = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ l.jsx(v.Provider, { value: x, children: h });
    }
    function u(f, p) {
      const h = (p == null ? void 0 : p[e][c]) || o, g = y.useContext(h);
      if (g)
        return g;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, u];
  }
  const a = () => {
    const i = n.map((s) => y.createContext(s));
    return function(o) {
      const c = (o == null ? void 0 : o[e]) || i;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: c } }),
        [o, c]
      );
    };
  };
  return a.scopeName = e, [r, $f(a, ...t)];
}
function $f(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const s = r.reduce((o, { useScope: c, scopeName: d }) => {
        const f = c(i)[`__scope${d}`];
        return { ...o, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function If(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function S0(...e) {
  return (t) => e.forEach((n) => If(n, t));
}
function mt(...e) {
  return y.useCallback(S0(...e), e);
}
var va = y.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = y.Children.toArray(n), i = a.find(Rf);
  if (i) {
    const s = i.props.children, o = a.map((c) => c === i ? y.Children.count(s) > 1 ? y.Children.only(null) : y.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ l.jsx(ls, { ...r, ref: t, children: y.isValidElement(s) ? y.cloneElement(s, void 0, o) : null });
  }
  return /* @__PURE__ */ l.jsx(ls, { ...r, ref: t, children: n });
});
va.displayName = "Slot";
var ls = y.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (y.isValidElement(n)) {
    const a = Ff(n);
    return y.cloneElement(n, {
      ...Df(r, n.props),
      // @ts-ignore
      ref: t ? S0(t, a) : a
    });
  }
  return y.Children.count(n) > 1 ? y.Children.only(null) : null;
});
ls.displayName = "SlotClone";
var Of = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
function Rf(e) {
  return y.isValidElement(e) && e.type === Of;
}
function Df(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...o) => {
      i(...o), a(...o);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Ff(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Bf(e) {
  const t = e + "CollectionProvider", [n, r] = C0(t), [a, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: g, children: v } = h, x = Y.useRef(null), m = Y.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l.jsx(a, { scope: g, itemMap: m, collectionRef: x, children: v });
  };
  s.displayName = t;
  const o = e + "CollectionSlot", c = Y.forwardRef(
    (h, g) => {
      const { scope: v, children: x } = h, m = i(o, v), b = mt(g, m.collectionRef);
      return /* @__PURE__ */ l.jsx(va, { ref: b, children: x });
    }
  );
  c.displayName = o;
  const d = e + "CollectionItemSlot", u = "data-radix-collection-item", f = Y.forwardRef(
    (h, g) => {
      const { scope: v, children: x, ...m } = h, b = Y.useRef(null), _ = mt(g, b), C = i(d, v);
      return Y.useEffect(() => (C.itemMap.set(b, { ref: b, ...m }), () => void C.itemMap.delete(b))), /* @__PURE__ */ l.jsx(va, { [u]: "", ref: _, children: x });
    }
  );
  f.displayName = d;
  function p(h) {
    const g = i(e + "CollectionConsumer", h);
    return Y.useCallback(() => {
      const x = g.collectionRef.current;
      if (!x)
        return [];
      const m = Array.from(x.querySelectorAll(`[${u}]`));
      return Array.from(g.itemMap.values()).sort(
        (C, w) => m.indexOf(C.ref.current) - m.indexOf(w.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: f },
    p,
    r
  ];
}
var Vf = y.createContext(void 0);
function Hf(e) {
  const t = y.useContext(Vf);
  return e || t || "ltr";
}
var qf = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], dt = qf.reduce((e, t) => {
  const n = y.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, o = i ? va : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(o, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Wf(e, t) {
  e && Dn.flushSync(() => e.dispatchEvent(t));
}
function Kr(e) {
  const t = y.useRef(e);
  return y.useEffect(() => {
    t.current = e;
  }), y.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Uf(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(e);
  y.useEffect(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Gf = "DismissableLayer", ds = "dismissableLayer.update", Yf = "dismissableLayer.pointerDownOutside", Kf = "dismissableLayer.focusOutside", Bc, L0 = y.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), M0 = y.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: o,
      ...c
    } = e, d = y.useContext(L0), [u, f] = y.useState(null), p = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = y.useState({}), g = mt(t, (M) => f(M)), v = Array.from(d.layers), [x] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), m = v.indexOf(x), b = u ? v.indexOf(u) : -1, _ = d.layersWithOutsidePointerEventsDisabled.size > 0, C = b >= m, w = Qf((M) => {
      const S = M.target, T = [...d.branches].some((j) => j.contains(S));
      !C || T || (a == null || a(M), s == null || s(M), M.defaultPrevented || o == null || o());
    }, p), N = Jf((M) => {
      const S = M.target;
      [...d.branches].some((j) => j.contains(S)) || (i == null || i(M), s == null || s(M), M.defaultPrevented || o == null || o());
    }, p);
    return Uf((M) => {
      b === d.layers.size - 1 && (r == null || r(M), !M.defaultPrevented && o && (M.preventDefault(), o()));
    }, p), y.useEffect(() => {
      if (u)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Bc = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), Vc(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = Bc);
        };
    }, [u, p, n, d]), y.useEffect(() => () => {
      u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), Vc());
    }, [u, d]), y.useEffect(() => {
      const M = () => h({});
      return document.addEventListener(ds, M), () => document.removeEventListener(ds, M);
    }, []), /* @__PURE__ */ l.jsx(
      dt.div,
      {
        ...c,
        ref: g,
        style: {
          pointerEvents: _ ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Je(e.onFocusCapture, N.onFocusCapture),
        onBlurCapture: Je(e.onBlurCapture, N.onBlurCapture),
        onPointerDownCapture: Je(
          e.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
M0.displayName = Gf;
var Xf = "DismissableLayerBranch", Zf = y.forwardRef((e, t) => {
  const n = y.useContext(L0), r = y.useRef(null), a = mt(t, r);
  return y.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ l.jsx(dt.div, { ...e, ref: a });
});
Zf.displayName = Xf;
function Qf(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(e), r = y.useRef(!1), a = y.useRef(() => {
  });
  return y.useEffect(() => {
    const i = (o) => {
      if (o.target && !r.current) {
        let c = function() {
          N0(
            Yf,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: o };
        o.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = c, t.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Jf(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(e), r = y.useRef(!1);
  return y.useEffect(() => {
    const a = (i) => {
      i.target && !r.current && N0(Kf, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Vc() {
  const e = new CustomEvent(ds);
  document.dispatchEvent(e);
}
function N0(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), r ? Wf(a, i) : a.dispatchEvent(i);
}
var h1 = 0;
function e5() {
  y.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Hc()), document.body.insertAdjacentElement("beforeend", e[1] ?? Hc()), h1++, () => {
      h1 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), h1--;
    };
  }, []);
}
function Hc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
function t5(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function z0(...e) {
  return (t) => e.forEach((n) => t5(n, t));
}
function n5(...e) {
  return y.useCallback(z0(...e), e);
}
var E0 = y.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = y.Children.toArray(n), i = a.find(a5);
  if (i) {
    const s = i.props.children, o = a.map((c) => c === i ? y.Children.count(s) > 1 ? y.Children.only(null) : y.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ l.jsx(us, { ...r, ref: t, children: y.isValidElement(s) ? y.cloneElement(s, void 0, o) : null });
  }
  return /* @__PURE__ */ l.jsx(us, { ...r, ref: t, children: n });
});
E0.displayName = "Slot";
var us = y.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (y.isValidElement(n)) {
    const a = s5(n);
    return y.cloneElement(n, {
      ...i5(r, n.props),
      // @ts-ignore
      ref: t ? z0(t, a) : a
    });
  }
  return y.Children.count(n) > 1 ? y.Children.only(null) : null;
});
us.displayName = "SlotClone";
var r5 = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
function a5(e) {
  return y.isValidElement(e) && e.type === r5;
}
function i5(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...o) => {
      i(...o), a(...o);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function s5(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var o5 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], c5 = o5.reduce((e, t) => {
  const n = y.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, o = i ? E0 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(o, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function qc(e) {
  const t = y.useRef(e);
  return y.useEffect(() => {
    t.current = e;
  }), y.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var g1 = "focusScope.autoFocusOnMount", v1 = "focusScope.autoFocusOnUnmount", Wc = { bubbles: !1, cancelable: !0 }, l5 = "FocusScope", Mo = y.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i,
    ...s
  } = e, [o, c] = y.useState(null), d = qc(a), u = qc(i), f = y.useRef(null), p = n5(t, (v) => c(v)), h = y.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  y.useEffect(() => {
    if (r) {
      let v = function(_) {
        if (h.paused || !o)
          return;
        const C = _.target;
        o.contains(C) ? f.current = C : Ln(f.current, { select: !0 });
      }, x = function(_) {
        if (h.paused || !o)
          return;
        const C = _.relatedTarget;
        C !== null && (o.contains(C) || Ln(f.current, { select: !0 }));
      }, m = function(_) {
        if (document.activeElement === document.body)
          for (const w of _)
            w.removedNodes.length > 0 && Ln(o);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", x);
      const b = new MutationObserver(m);
      return o && b.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", x), b.disconnect();
      };
    }
  }, [r, o, h.paused]), y.useEffect(() => {
    if (o) {
      Gc.add(h);
      const v = document.activeElement;
      if (!o.contains(v)) {
        const m = new CustomEvent(g1, Wc);
        o.addEventListener(g1, d), o.dispatchEvent(m), m.defaultPrevented || (d5(h5(T0(o)), { select: !0 }), document.activeElement === v && Ln(o));
      }
      return () => {
        o.removeEventListener(g1, d), setTimeout(() => {
          const m = new CustomEvent(v1, Wc);
          o.addEventListener(v1, u), o.dispatchEvent(m), m.defaultPrevented || Ln(v ?? document.body, { select: !0 }), o.removeEventListener(v1, u), Gc.remove(h);
        }, 0);
      };
    }
  }, [o, d, u, h]);
  const g = y.useCallback(
    (v) => {
      if (!n && !r || h.paused)
        return;
      const x = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, m = document.activeElement;
      if (x && m) {
        const b = v.currentTarget, [_, C] = u5(b);
        _ && C ? !v.shiftKey && m === C ? (v.preventDefault(), n && Ln(_, { select: !0 })) : v.shiftKey && m === _ && (v.preventDefault(), n && Ln(C, { select: !0 })) : m === b && v.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ l.jsx(c5.div, { tabIndex: -1, ...s, ref: p, onKeyDown: g });
});
Mo.displayName = l5;
function d5(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ln(r, { select: t }), document.activeElement !== n)
      return;
}
function u5(e) {
  const t = T0(e), n = Uc(t, e), r = Uc(t.reverse(), e);
  return [n, r];
}
function T0(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Uc(e, t) {
  for (const n of e)
    if (!f5(n, { upTo: t }))
      return n;
}
function f5(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function p5(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ln(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && p5(e) && t && e.select();
  }
}
var Gc = m5();
function m5() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Yc(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Yc(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Yc(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function h5(e) {
  return e.filter((t) => t.tagName !== "A");
}
var un = globalThis != null && globalThis.document ? y.useLayoutEffect : () => {
}, g5 = y.useId || (() => {
}), v5 = 0;
function No(e) {
  const [t, n] = y.useState(g5());
  return un(() => {
    e || n((r) => r ?? String(v5++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function Kc({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = b5({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, o = Kr(n), c = y.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && o(f);
      } else
        a(d);
    },
    [i, e, a, o]
  );
  return [s, c];
}
function b5({
  defaultProp: e,
  onChange: t
}) {
  const n = y.useState(e), [r] = n, a = y.useRef(r), i = Kr(t);
  return y.useEffect(() => {
    a.current !== r && (i(r), a.current = r);
  }, [r, a, i]), n;
}
function y5(e) {
  const t = y.useRef({ value: e, previous: e });
  return y.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var x5 = "VisuallyHidden", k0 = y.forwardRef(
  (e, t) => /* @__PURE__ */ l.jsx(
    dt.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
k0.displayName = x5;
var _5 = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, br = /* @__PURE__ */ new WeakMap(), Fa = /* @__PURE__ */ new WeakMap(), Ba = {}, b1 = 0, j0 = function(e) {
  return e && (e.host || j0(e.parentNode));
}, w5 = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = j0(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, C5 = function(e, t, n, r) {
  var a = w5(t, Array.isArray(e) ? e : [e]);
  Ba[n] || (Ba[n] = /* @__PURE__ */ new WeakMap());
  var i = Ba[n], s = [], o = /* @__PURE__ */ new Set(), c = new Set(a), d = function(f) {
    !f || o.has(f) || (o.add(f), d(f.parentNode));
  };
  a.forEach(d);
  var u = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(p) {
      if (o.has(p))
        u(p);
      else
        try {
          var h = p.getAttribute(r), g = h !== null && h !== "false", v = (br.get(p) || 0) + 1, x = (i.get(p) || 0) + 1;
          br.set(p, v), i.set(p, x), s.push(p), v === 1 && g && Fa.set(p, !0), x === 1 && p.setAttribute(n, "true"), g || p.setAttribute(r, "true");
        } catch (m) {
          console.error("aria-hidden: cannot operate on ", p, m);
        }
    });
  };
  return u(t), o.clear(), b1++, function() {
    s.forEach(function(f) {
      var p = br.get(f) - 1, h = i.get(f) - 1;
      br.set(f, p), i.set(f, h), p || (Fa.has(f) || f.removeAttribute(r), Fa.delete(f)), h || f.removeAttribute(n);
    }), b1--, b1 || (br = /* @__PURE__ */ new WeakMap(), br = /* @__PURE__ */ new WeakMap(), Fa = /* @__PURE__ */ new WeakMap(), Ba = {});
  };
}, P0 = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), a = t || _5(e);
  return a ? (r.push.apply(r, Array.from(a.querySelectorAll("[aria-live]"))), C5(r, a, n, "aria-hidden")) : function() {
    return null;
  };
}, st = function() {
  return st = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, st.apply(this, arguments);
};
function zo(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function A0(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, a = t.length, i; r < a; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var da = "right-scroll-bar-position", ua = "width-before-scroll-bar", S5 = "with-scroll-bars-hidden", L5 = "--removed-body-scroll-bar-size";
function y1(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function M5(e, t) {
  var n = ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var N5 = typeof window < "u" ? y.useLayoutEffect : y.useEffect, Xc = /* @__PURE__ */ new WeakMap();
function $0(e, t) {
  var n = M5(t || null, function(r) {
    return e.forEach(function(a) {
      return y1(a, r);
    });
  });
  return N5(function() {
    var r = Xc.get(n);
    if (r) {
      var a = new Set(r), i = new Set(e), s = n.current;
      a.forEach(function(o) {
        i.has(o) || y1(o, null);
      }), i.forEach(function(o) {
        a.has(o) || y1(o, s);
      });
    }
    Xc.set(n, e);
  }, [e]), n;
}
function z5(e) {
  return e;
}
function E5(e, t) {
  t === void 0 && (t = z5);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(o) {
          return o !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(o) {
          return i(o);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var o = n;
        n = [], o.forEach(i), s = n;
      }
      var c = function() {
        var u = s;
        s = [], u.forEach(i);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), n = {
        push: function(u) {
          s.push(u), d();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return a;
}
function I0(e) {
  e === void 0 && (e = {});
  var t = E5(null);
  return t.options = st({ async: !0, ssr: !1 }, e), t;
}
var O0 = function(e) {
  var t = e.sideCar, n = zo(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return y.createElement(r, st({}, n));
};
O0.isSideCarExport = !0;
function R0(e, t) {
  return e.useMedium(t), O0;
}
var D0 = I0(), x1 = function() {
}, Ui = y.forwardRef(function(e, t) {
  var n = y.useRef(null), r = y.useState({
    onScrollCapture: x1,
    onWheelCapture: x1,
    onTouchMoveCapture: x1
  }), a = r[0], i = r[1], s = e.forwardProps, o = e.children, c = e.className, d = e.removeScrollBar, u = e.enabled, f = e.shards, p = e.sideCar, h = e.noIsolation, g = e.inert, v = e.allowPinchZoom, x = e.as, m = x === void 0 ? "div" : x, b = e.gapMode, _ = zo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = p, w = $0([n, t]), N = st(st({}, _), a);
  return y.createElement(
    y.Fragment,
    null,
    u && y.createElement(C, { sideCar: D0, removeScrollBar: d, shards: f, noIsolation: h, inert: g, setCallbacks: i, allowPinchZoom: !!v, lockRef: n, gapMode: b }),
    s ? y.cloneElement(y.Children.only(o), st(st({}, N), { ref: w })) : y.createElement(m, st({}, N, { className: c, ref: w }), o)
  );
});
Ui.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ui.classNames = {
  fullWidth: ua,
  zeroRight: da
};
var T5 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function k5() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = T5();
  return t && e.setAttribute("nonce", t), e;
}
function j5(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function P5(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var A5 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = k5()) && (j5(t, n), P5(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, $5 = function() {
  var e = A5();
  return function(t, n) {
    y.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Eo = function() {
  var e = $5(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, I5 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _1 = function(e) {
  return parseInt(e || "", 10) || 0;
}, O5 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_1(n), _1(r), _1(a)];
}, R5 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return I5;
  var t = O5(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, D5 = Eo(), Or = "data-scroll-locked", F5 = function(e, t, n, r) {
  var a = e.left, i = e.top, s = e.right, o = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(S5, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(o, "px ").concat(r, `;
  }
  body[`).concat(Or, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(o, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(da, ` {
    right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(ua, ` {
    margin-right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(da, " .").concat(da, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(ua, " .").concat(ua, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Or, `] {
    `).concat(L5, ": ").concat(o, `px;
  }
`);
}, Zc = function() {
  var e = parseInt(document.body.getAttribute(Or) || "0", 10);
  return isFinite(e) ? e : 0;
}, B5 = function() {
  y.useEffect(function() {
    return document.body.setAttribute(Or, (Zc() + 1).toString()), function() {
      var e = Zc() - 1;
      e <= 0 ? document.body.removeAttribute(Or) : document.body.setAttribute(Or, e.toString());
    };
  }, []);
}, F0 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r;
  B5();
  var i = y.useMemo(function() {
    return R5(a);
  }, [a]);
  return y.createElement(D5, { styles: F5(i, !t, a, n ? "" : "!important") });
}, fs = !1;
if (typeof window < "u")
  try {
    var Va = Object.defineProperty({}, "passive", {
      get: function() {
        return fs = !0, !0;
      }
    });
    window.addEventListener("test", Va, Va), window.removeEventListener("test", Va, Va);
  } catch {
    fs = !1;
  }
var yr = fs ? { passive: !1 } : !1, V5 = function(e) {
  return e.tagName === "TEXTAREA";
}, B0 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !V5(e) && n[t] === "visible")
  );
}, H5 = function(e) {
  return B0(e, "overflowY");
}, q5 = function(e) {
  return B0(e, "overflowX");
}, Qc = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = V0(e, r);
    if (a) {
      var i = H0(e, r), s = i[1], o = i[2];
      if (s > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, W5 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, U5 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, V0 = function(e, t) {
  return e === "v" ? H5(t) : q5(t);
}, H0 = function(e, t) {
  return e === "v" ? W5(t) : U5(t);
}, G5 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Y5 = function(e, t, n, r, a) {
  var i = G5(e, window.getComputedStyle(t).direction), s = i * r, o = n.target, c = t.contains(o), d = !1, u = s > 0, f = 0, p = 0;
  do {
    var h = H0(e, o), g = h[0], v = h[1], x = h[2], m = v - x - i * g;
    (g || m) && V0(e, o) && (f += m, p += g), o instanceof ShadowRoot ? o = o.host : o = o.parentNode;
  } while (
    // portaled content
    !c && o !== document.body || // self content
    c && (t.contains(o) || t === o)
  );
  return (u && (a && Math.abs(f) < 1 || !a && s > f) || !u && (a && Math.abs(p) < 1 || !a && -s > p)) && (d = !0), d;
}, Ha = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Jc = function(e) {
  return [e.deltaX, e.deltaY];
}, el = function(e) {
  return e && "current" in e ? e.current : e;
}, K5 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, X5 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Z5 = 0, xr = [];
function Q5(e) {
  var t = y.useRef([]), n = y.useRef([0, 0]), r = y.useRef(), a = y.useState(Z5++)[0], i = y.useState(Eo)[0], s = y.useRef(e);
  y.useEffect(function() {
    s.current = e;
  }, [e]), y.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var v = A0([e.lockRef.current], (e.shards || []).map(el), !0).filter(Boolean);
      return v.forEach(function(x) {
        return x.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), v.forEach(function(x) {
          return x.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = y.useCallback(function(v, x) {
    if ("touches" in v && v.touches.length === 2)
      return !s.current.allowPinchZoom;
    var m = Ha(v), b = n.current, _ = "deltaX" in v ? v.deltaX : b[0] - m[0], C = "deltaY" in v ? v.deltaY : b[1] - m[1], w, N = v.target, M = Math.abs(_) > Math.abs(C) ? "h" : "v";
    if ("touches" in v && M === "h" && N.type === "range")
      return !1;
    var S = Qc(M, N);
    if (!S)
      return !0;
    if (S ? w = M : (w = M === "v" ? "h" : "v", S = Qc(M, N)), !S)
      return !1;
    if (!r.current && "changedTouches" in v && (_ || C) && (r.current = w), !w)
      return !0;
    var T = r.current || w;
    return Y5(T, x, v, T === "h" ? _ : C, !0);
  }, []), c = y.useCallback(function(v) {
    var x = v;
    if (!(!xr.length || xr[xr.length - 1] !== i)) {
      var m = "deltaY" in x ? Jc(x) : Ha(x), b = t.current.filter(function(w) {
        return w.name === x.type && (w.target === x.target || x.target === w.shadowParent) && K5(w.delta, m);
      })[0];
      if (b && b.should) {
        x.cancelable && x.preventDefault();
        return;
      }
      if (!b) {
        var _ = (s.current.shards || []).map(el).filter(Boolean).filter(function(w) {
          return w.contains(x.target);
        }), C = _.length > 0 ? o(x, _[0]) : !s.current.noIsolation;
        C && x.cancelable && x.preventDefault();
      }
    }
  }, []), d = y.useCallback(function(v, x, m, b) {
    var _ = { name: v, delta: x, target: m, should: b, shadowParent: J5(m) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== _;
      });
    }, 1);
  }, []), u = y.useCallback(function(v) {
    n.current = Ha(v), r.current = void 0;
  }, []), f = y.useCallback(function(v) {
    d(v.type, Jc(v), v.target, o(v, e.lockRef.current));
  }, []), p = y.useCallback(function(v) {
    d(v.type, Ha(v), v.target, o(v, e.lockRef.current));
  }, []);
  y.useEffect(function() {
    return xr.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", c, yr), document.addEventListener("touchmove", c, yr), document.addEventListener("touchstart", u, yr), function() {
      xr = xr.filter(function(v) {
        return v !== i;
      }), document.removeEventListener("wheel", c, yr), document.removeEventListener("touchmove", c, yr), document.removeEventListener("touchstart", u, yr);
    };
  }, []);
  var h = e.removeScrollBar, g = e.inert;
  return y.createElement(
    y.Fragment,
    null,
    g ? y.createElement(i, { styles: X5(a) }) : null,
    h ? y.createElement(F0, { gapMode: e.gapMode }) : null
  );
}
function J5(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const e7 = R0(D0, Q5);
var q0 = y.forwardRef(function(e, t) {
  return y.createElement(Ui, st({}, e, { ref: t, sideCar: e7 }));
});
q0.classNames = Ui.classNames;
const t7 = q0;
var n7 = [" ", "Enter", "ArrowUp", "ArrowDown"], r7 = [" ", "Enter"], za = "Select", [Gi, Yi, a7] = Bf(za), [Xr, $E] = C0(za, [
  a7,
  e0
]), Ki = e0(), [i7, Bn] = Xr(za), [s7, o7] = Xr(za), W0 = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    value: s,
    defaultValue: o,
    onValueChange: c,
    dir: d,
    name: u,
    autoComplete: f,
    disabled: p,
    required: h
  } = e, g = Ki(t), [v, x] = y.useState(null), [m, b] = y.useState(null), [_, C] = y.useState(!1), w = Hf(d), [N = !1, M] = Kc({
    prop: r,
    defaultProp: a,
    onChange: i
  }), [S, T] = Kc({
    prop: s,
    defaultProp: o,
    onChange: c
  }), j = y.useRef(null), D = v ? !!v.closest("form") : !0, [A, k] = y.useState(/* @__PURE__ */ new Set()), $ = Array.from(A).map((R) => R.props.value).join(";");
  return /* @__PURE__ */ l.jsx(qu, { ...g, children: /* @__PURE__ */ l.jsxs(
    i7,
    {
      required: h,
      scope: t,
      trigger: v,
      onTriggerChange: x,
      valueNode: m,
      onValueNodeChange: b,
      valueNodeHasChildren: _,
      onValueNodeHasChildrenChange: C,
      contentId: No(),
      value: S,
      onValueChange: T,
      open: N,
      onOpenChange: M,
      dir: w,
      triggerPointerDownPosRef: j,
      disabled: p,
      children: [
        /* @__PURE__ */ l.jsx(Gi.Provider, { scope: t, children: /* @__PURE__ */ l.jsx(
          s7,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: y.useCallback((R) => {
              k((F) => new Set(F).add(R));
            }, []),
            onNativeOptionRemove: y.useCallback((R) => {
              k((F) => {
                const P = new Set(F);
                return P.delete(R), P;
              });
            }, []),
            children: n
          }
        ) }),
        D ? /* @__PURE__ */ l.jsxs(
          v4,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: u,
            autoComplete: f,
            value: S,
            onChange: (R) => T(R.target.value),
            disabled: p,
            children: [
              S === void 0 ? /* @__PURE__ */ l.jsx("option", { value: "" }) : null,
              Array.from(A)
            ]
          },
          $
        ) : null
      ]
    }
  ) });
};
W0.displayName = za;
var U0 = "SelectTrigger", G0 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...a } = e, i = Ki(n), s = Bn(U0, n), o = s.disabled || r, c = mt(t, s.onTriggerChange), d = Yi(n), [u, f, p] = b4((g) => {
      const v = d().filter((b) => !b.disabled), x = v.find((b) => b.value === s.value), m = y4(v, g, x);
      m !== void 0 && s.onValueChange(m.value);
    }), h = () => {
      o || (s.onOpenChange(!0), p());
    };
    return /* @__PURE__ */ l.jsx(Wu, { asChild: !0, ...i, children: /* @__PURE__ */ l.jsx(
      dt.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-placeholder": g4(s.value) ? "" : void 0,
        ...a,
        ref: c,
        onClick: Je(a.onClick, (g) => {
          g.currentTarget.focus();
        }),
        onPointerDown: Je(a.onPointerDown, (g) => {
          const v = g.target;
          v.hasPointerCapture(g.pointerId) && v.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && (h(), s.triggerPointerDownPosRef.current = {
            x: Math.round(g.pageX),
            y: Math.round(g.pageY)
          }, g.preventDefault());
        }),
        onKeyDown: Je(a.onKeyDown, (g) => {
          const v = u.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && f(g.key), !(v && g.key === " ") && n7.includes(g.key) && (h(), g.preventDefault());
        })
      }
    ) });
  }
);
G0.displayName = U0;
var Y0 = "SelectValue", K0 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: a, children: i, placeholder: s = "", ...o } = e, c = Bn(Y0, n), { onValueNodeHasChildrenChange: d } = c, u = i !== void 0, f = mt(t, c.onValueNodeChange);
    return un(() => {
      d(u);
    }, [d, u]), /* @__PURE__ */ l.jsx(
      dt.span,
      {
        ...o,
        ref: f,
        style: { pointerEvents: "none" },
        children: g4(c.value) ? /* @__PURE__ */ l.jsx(l.Fragment, { children: s }) : i
      }
    );
  }
);
K0.displayName = Y0;
var c7 = "SelectIcon", X0 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...a } = e;
    return /* @__PURE__ */ l.jsx(dt.span, { "aria-hidden": !0, ...a, ref: t, children: r || "▼" });
  }
);
X0.displayName = c7;
var l7 = "SelectPortal", Z0 = (e) => /* @__PURE__ */ l.jsx(So, { asChild: !0, ...e });
Z0.displayName = l7;
var ir = "SelectContent", Q0 = y.forwardRef(
  (e, t) => {
    const n = Bn(ir, e.__scopeSelect), [r, a] = y.useState();
    if (un(() => {
      a(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? Dn.createPortal(
        /* @__PURE__ */ l.jsx(J0, { scope: e.__scopeSelect, children: /* @__PURE__ */ l.jsx(Gi.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ l.jsx("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ l.jsx(e4, { ...e, ref: t });
  }
);
Q0.displayName = ir;
var nn = 10, [J0, Vn] = Xr(ir), d7 = "SelectContentImpl", e4 = y.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: a,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: o,
      sideOffset: c,
      align: d,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: x,
      //
      ...m
    } = e, b = Bn(ir, n), [_, C] = y.useState(null), [w, N] = y.useState(null), M = mt(t, (U) => C(U)), [S, T] = y.useState(null), [j, D] = y.useState(
      null
    ), A = Yi(n), [k, $] = y.useState(!1), R = y.useRef(!1);
    y.useEffect(() => {
      if (_)
        return P0(_);
    }, [_]), e5();
    const F = y.useCallback(
      (U) => {
        const [J, ...fe] = A().map((L) => L.ref.current), [Z] = fe.slice(-1), be = document.activeElement;
        for (const L of U)
          if (L === be || (L == null || L.scrollIntoView({ block: "nearest" }), L === J && w && (w.scrollTop = 0), L === Z && w && (w.scrollTop = w.scrollHeight), L == null || L.focus(), document.activeElement !== be))
            return;
      },
      [A, w]
    ), P = y.useCallback(
      () => F([S, _]),
      [F, S, _]
    );
    y.useEffect(() => {
      k && P();
    }, [k, P]);
    const { onOpenChange: I, triggerPointerDownPosRef: H } = b;
    y.useEffect(() => {
      if (_) {
        let U = { x: 0, y: 0 };
        const J = (Z) => {
          var be, L;
          U = {
            x: Math.abs(Math.round(Z.pageX) - (((be = H.current) == null ? void 0 : be.x) ?? 0)),
            y: Math.abs(Math.round(Z.pageY) - (((L = H.current) == null ? void 0 : L.y) ?? 0))
          };
        }, fe = (Z) => {
          U.x <= 10 && U.y <= 10 ? Z.preventDefault() : _.contains(Z.target) || I(!1), document.removeEventListener("pointermove", J), H.current = null;
        };
        return H.current !== null && (document.addEventListener("pointermove", J), document.addEventListener("pointerup", fe, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", J), document.removeEventListener("pointerup", fe, { capture: !0 });
        };
      }
    }, [_, I, H]), y.useEffect(() => {
      const U = () => I(!1);
      return window.addEventListener("blur", U), window.addEventListener("resize", U), () => {
        window.removeEventListener("blur", U), window.removeEventListener("resize", U);
      };
    }, [I]);
    const [O, W] = b4((U) => {
      const J = A().filter((be) => !be.disabled), fe = J.find((be) => be.ref.current === document.activeElement), Z = y4(J, U, fe);
      Z && setTimeout(() => Z.ref.current.focus());
    }), se = y.useCallback(
      (U, J, fe) => {
        const Z = !R.current && !fe;
        (b.value !== void 0 && b.value === J || Z) && (T(U), Z && (R.current = !0));
      },
      [b.value]
    ), ue = y.useCallback(() => _ == null ? void 0 : _.focus(), [_]), ee = y.useCallback(
      (U, J, fe) => {
        const Z = !R.current && !fe;
        (b.value !== void 0 && b.value === J || Z) && D(U);
      },
      [b.value]
    ), ae = r === "popper" ? ps : t4, ie = ae === ps ? {
      side: o,
      sideOffset: c,
      align: d,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: x
    } : {};
    return /* @__PURE__ */ l.jsx(
      J0,
      {
        scope: n,
        content: _,
        viewport: w,
        onViewportChange: N,
        itemRefCallback: se,
        selectedItem: S,
        onItemLeave: ue,
        itemTextRefCallback: ee,
        focusSelectedItem: P,
        selectedItemText: j,
        position: r,
        isPositioned: k,
        searchRef: O,
        children: /* @__PURE__ */ l.jsx(t7, { as: va, allowPinchZoom: !0, children: /* @__PURE__ */ l.jsx(
          Mo,
          {
            asChild: !0,
            trapped: b.open,
            onMountAutoFocus: (U) => {
              U.preventDefault();
            },
            onUnmountAutoFocus: Je(a, (U) => {
              var J;
              (J = b.trigger) == null || J.focus({ preventScroll: !0 }), U.preventDefault();
            }),
            children: /* @__PURE__ */ l.jsx(
              M0,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: s,
                onFocusOutside: (U) => U.preventDefault(),
                onDismiss: () => b.onOpenChange(!1),
                children: /* @__PURE__ */ l.jsx(
                  ae,
                  {
                    role: "listbox",
                    id: b.contentId,
                    "data-state": b.open ? "open" : "closed",
                    dir: b.dir,
                    onContextMenu: (U) => U.preventDefault(),
                    ...m,
                    ...ie,
                    onPlaced: () => $(!0),
                    ref: M,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...m.style
                    },
                    onKeyDown: Je(m.onKeyDown, (U) => {
                      const J = U.ctrlKey || U.altKey || U.metaKey;
                      if (U.key === "Tab" && U.preventDefault(), !J && U.key.length === 1 && W(U.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(U.key)) {
                        let Z = A().filter((be) => !be.disabled).map((be) => be.ref.current);
                        if (["ArrowUp", "End"].includes(U.key) && (Z = Z.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(U.key)) {
                          const be = U.target, L = Z.indexOf(be);
                          Z = Z.slice(L + 1);
                        }
                        setTimeout(() => F(Z)), U.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
e4.displayName = d7;
var u7 = "SelectItemAlignedPosition", t4 = y.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...a } = e, i = Bn(ir, n), s = Vn(ir, n), [o, c] = y.useState(null), [d, u] = y.useState(null), f = mt(t, (M) => u(M)), p = Yi(n), h = y.useRef(!1), g = y.useRef(!0), { viewport: v, selectedItem: x, selectedItemText: m, focusSelectedItem: b } = s, _ = y.useCallback(() => {
    if (i.trigger && i.valueNode && o && d && v && x && m) {
      const M = i.trigger.getBoundingClientRect(), S = d.getBoundingClientRect(), T = i.valueNode.getBoundingClientRect(), j = m.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const be = j.left - S.left, L = T.left - be, B = M.left - L, ce = M.width + B, _e = Math.max(ce, S.width), we = window.innerWidth - nn, ze = Fc(L, [nn, we - _e]);
        o.style.minWidth = ce + "px", o.style.left = ze + "px";
      } else {
        const be = S.right - j.right, L = window.innerWidth - T.right - be, B = window.innerWidth - M.right - L, ce = M.width + B, _e = Math.max(ce, S.width), we = window.innerWidth - nn, ze = Fc(L, [nn, we - _e]);
        o.style.minWidth = ce + "px", o.style.right = ze + "px";
      }
      const D = p(), A = window.innerHeight - nn * 2, k = v.scrollHeight, $ = window.getComputedStyle(d), R = parseInt($.borderTopWidth, 10), F = parseInt($.paddingTop, 10), P = parseInt($.borderBottomWidth, 10), I = parseInt($.paddingBottom, 10), H = R + F + k + I + P, O = Math.min(x.offsetHeight * 5, H), W = window.getComputedStyle(v), se = parseInt(W.paddingTop, 10), ue = parseInt(W.paddingBottom, 10), ee = M.top + M.height / 2 - nn, ae = A - ee, ie = x.offsetHeight / 2, U = x.offsetTop + ie, J = R + F + U, fe = H - J;
      if (J <= ee) {
        const be = x === D[D.length - 1].ref.current;
        o.style.bottom = "0px";
        const L = d.clientHeight - v.offsetTop - v.offsetHeight, B = Math.max(
          ae,
          ie + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (be ? ue : 0) + L + P
        ), ce = J + B;
        o.style.height = ce + "px";
      } else {
        const be = x === D[0].ref.current;
        o.style.top = "0px";
        const B = Math.max(
          ee,
          R + v.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (be ? se : 0) + ie
        ) + fe;
        o.style.height = B + "px", v.scrollTop = J - ee + v.offsetTop;
      }
      o.style.margin = `${nn}px 0`, o.style.minHeight = O + "px", o.style.maxHeight = A + "px", r == null || r(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    p,
    i.trigger,
    i.valueNode,
    o,
    d,
    v,
    x,
    m,
    i.dir,
    r
  ]);
  un(() => _(), [_]);
  const [C, w] = y.useState();
  un(() => {
    d && w(window.getComputedStyle(d).zIndex);
  }, [d]);
  const N = y.useCallback(
    (M) => {
      M && g.current === !0 && (_(), b == null || b(), g.current = !1);
    },
    [_, b]
  );
  return /* @__PURE__ */ l.jsx(
    p7,
    {
      scope: n,
      contentWrapper: o,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: N,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ l.jsx(
            dt.div,
            {
              ...a,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...a.style
              }
            }
          )
        }
      )
    }
  );
});
t4.displayName = u7;
var f7 = "SelectPopperPosition", ps = y.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: a = nn,
    ...i
  } = e, s = Ki(n);
  return /* @__PURE__ */ l.jsx(
    Uu,
    {
      ...s,
      ...i,
      ref: t,
      align: r,
      collisionPadding: a,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
ps.displayName = f7;
var [p7, To] = Xr(ir, {}), ms = "SelectViewport", n4 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...a } = e, i = Vn(ms, n), s = To(ms, n), o = mt(t, i.onViewportChange), c = y.useRef(0);
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ l.jsx(Gi.Slot, { scope: n, children: /* @__PURE__ */ l.jsx(
        dt.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...a,
          ref: o,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...a.style
          },
          onScroll: Je(a.onScroll, (d) => {
            const u = d.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: p } = s;
            if (p != null && p.current && f) {
              const h = Math.abs(c.current - u.scrollTop);
              if (h > 0) {
                const g = window.innerHeight - nn * 2, v = parseFloat(f.style.minHeight), x = parseFloat(f.style.height), m = Math.max(v, x);
                if (m < g) {
                  const b = m + h, _ = Math.min(g, b), C = b - _;
                  f.style.height = _ + "px", f.style.bottom === "0px" && (u.scrollTop = C > 0 ? C : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
n4.displayName = ms;
var r4 = "SelectGroup", [m7, h7] = Xr(r4), a4 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, a = No();
    return /* @__PURE__ */ l.jsx(m7, { scope: n, id: a, children: /* @__PURE__ */ l.jsx(dt.div, { role: "group", "aria-labelledby": a, ...r, ref: t }) });
  }
);
a4.displayName = r4;
var i4 = "SelectLabel", s4 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, a = h7(i4, n);
    return /* @__PURE__ */ l.jsx(dt.div, { id: a.id, ...r, ref: t });
  }
);
s4.displayName = i4;
var xi = "SelectItem", [g7, o4] = Xr(xi), c4 = y.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: a = !1,
      textValue: i,
      ...s
    } = e, o = Bn(xi, n), c = Vn(xi, n), d = o.value === r, [u, f] = y.useState(i ?? ""), [p, h] = y.useState(!1), g = mt(
      t,
      (m) => {
        var b;
        return (b = c.itemRefCallback) == null ? void 0 : b.call(c, m, r, a);
      }
    ), v = No(), x = () => {
      a || (o.onValueChange(r), o.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ l.jsx(
      g7,
      {
        scope: n,
        value: r,
        disabled: a,
        textId: v,
        isSelected: d,
        onItemTextChange: y.useCallback((m) => {
          f((b) => b || ((m == null ? void 0 : m.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ l.jsx(
          Gi.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: a,
            textValue: u,
            children: /* @__PURE__ */ l.jsx(
              dt.div,
              {
                role: "option",
                "aria-labelledby": v,
                "data-highlighted": p ? "" : void 0,
                "aria-selected": d && p,
                "data-state": d ? "checked" : "unchecked",
                "aria-disabled": a || void 0,
                "data-disabled": a ? "" : void 0,
                tabIndex: a ? void 0 : -1,
                ...s,
                ref: g,
                onFocus: Je(s.onFocus, () => h(!0)),
                onBlur: Je(s.onBlur, () => h(!1)),
                onPointerUp: Je(s.onPointerUp, x),
                onPointerMove: Je(s.onPointerMove, (m) => {
                  var b;
                  a ? (b = c.onItemLeave) == null || b.call(c) : m.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Je(s.onPointerLeave, (m) => {
                  var b;
                  m.currentTarget === document.activeElement && ((b = c.onItemLeave) == null || b.call(c));
                }),
                onKeyDown: Je(s.onKeyDown, (m) => {
                  var _;
                  ((_ = c.searchRef) == null ? void 0 : _.current) !== "" && m.key === " " || (r7.includes(m.key) && x(), m.key === " " && m.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
c4.displayName = xi;
var oa = "SelectItemText", l4 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: a, ...i } = e, s = Bn(oa, n), o = Vn(oa, n), c = o4(oa, n), d = o7(oa, n), [u, f] = y.useState(null), p = mt(
      t,
      (m) => f(m),
      c.onItemTextChange,
      (m) => {
        var b;
        return (b = o.itemTextRefCallback) == null ? void 0 : b.call(o, m, c.value, c.disabled);
      }
    ), h = u == null ? void 0 : u.textContent, g = y.useMemo(
      () => /* @__PURE__ */ l.jsx("option", { value: c.value, disabled: c.disabled, children: h }, c.value),
      [c.disabled, c.value, h]
    ), { onNativeOptionAdd: v, onNativeOptionRemove: x } = d;
    return un(() => (v(g), () => x(g)), [v, x, g]), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(dt.span, { id: c.textId, ...i, ref: p }),
      c.isSelected && s.valueNode && !s.valueNodeHasChildren ? Dn.createPortal(i.children, s.valueNode) : null
    ] });
  }
);
l4.displayName = oa;
var d4 = "SelectItemIndicator", u4 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return o4(d4, n).isSelected ? /* @__PURE__ */ l.jsx(dt.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
u4.displayName = d4;
var hs = "SelectScrollUpButton", f4 = y.forwardRef((e, t) => {
  const n = Vn(hs, e.__scopeSelect), r = To(hs, e.__scopeSelect), [a, i] = y.useState(!1), s = mt(t, r.onScrollButtonChange);
  return un(() => {
    if (n.viewport && n.isPositioned) {
      let o = function() {
        const d = c.scrollTop > 0;
        i(d);
      };
      const c = n.viewport;
      return o(), c.addEventListener("scroll", o), () => c.removeEventListener("scroll", o);
    }
  }, [n.viewport, n.isPositioned]), a ? /* @__PURE__ */ l.jsx(
    m4,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: c } = n;
        o && c && (o.scrollTop = o.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
f4.displayName = hs;
var gs = "SelectScrollDownButton", p4 = y.forwardRef((e, t) => {
  const n = Vn(gs, e.__scopeSelect), r = To(gs, e.__scopeSelect), [a, i] = y.useState(!1), s = mt(t, r.onScrollButtonChange);
  return un(() => {
    if (n.viewport && n.isPositioned) {
      let o = function() {
        const d = c.scrollHeight - c.clientHeight, u = Math.ceil(c.scrollTop) < d;
        i(u);
      };
      const c = n.viewport;
      return o(), c.addEventListener("scroll", o), () => c.removeEventListener("scroll", o);
    }
  }, [n.viewport, n.isPositioned]), a ? /* @__PURE__ */ l.jsx(
    m4,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: c } = n;
        o && c && (o.scrollTop = o.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
p4.displayName = gs;
var m4 = y.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...a } = e, i = Vn("SelectScrollButton", n), s = y.useRef(null), o = Yi(n), c = y.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return y.useEffect(() => () => c(), [c]), un(() => {
    var u;
    const d = o().find((f) => f.ref.current === document.activeElement);
    (u = d == null ? void 0 : d.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [o]), /* @__PURE__ */ l.jsx(
    dt.div,
    {
      "aria-hidden": !0,
      ...a,
      ref: t,
      style: { flexShrink: 0, ...a.style },
      onPointerDown: Je(a.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerMove: Je(a.onPointerMove, () => {
        var d;
        (d = i.onItemLeave) == null || d.call(i), s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerLeave: Je(a.onPointerLeave, () => {
        c();
      })
    }
  );
}), v7 = "SelectSeparator", h4 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ l.jsx(dt.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
h4.displayName = v7;
var vs = "SelectArrow", b7 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, a = Ki(n), i = Bn(vs, n), s = Vn(vs, n);
    return i.open && s.position === "popper" ? /* @__PURE__ */ l.jsx(Gu, { ...a, ...r, ref: t }) : null;
  }
);
b7.displayName = vs;
function g4(e) {
  return e === "" || e === void 0;
}
var v4 = y.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, a = y.useRef(null), i = mt(t, a), s = y5(n);
    return y.useEffect(() => {
      const o = a.current, c = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (s !== n && u) {
        const f = new Event("change", { bubbles: !0 });
        u.call(o, n), o.dispatchEvent(f);
      }
    }, [s, n]), /* @__PURE__ */ l.jsx(k0, { asChild: !0, children: /* @__PURE__ */ l.jsx("select", { ...r, ref: i, defaultValue: n }) });
  }
);
v4.displayName = "BubbleSelect";
function b4(e) {
  const t = Kr(e), n = y.useRef(""), r = y.useRef(0), a = y.useCallback(
    (s) => {
      const o = n.current + s;
      t(o), function c(d) {
        n.current = d, window.clearTimeout(r.current), d !== "" && (r.current = window.setTimeout(() => c(""), 1e3));
      }(o);
    },
    [t]
  ), i = y.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return y.useEffect(() => () => window.clearTimeout(r.current), []), [n, a, i];
}
function y4(e, t, n) {
  const a = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = y7(e, Math.max(i, 0));
  a.length === 1 && (s = s.filter((d) => d !== n));
  const c = s.find(
    (d) => d.textValue.toLowerCase().startsWith(a.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function y7(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var x7 = W0, x4 = G0, _7 = K0, w7 = X0, C7 = Z0, _4 = Q0, S7 = n4, L7 = a4, w4 = s4, C4 = c4, M7 = l4, N7 = u4, S4 = f4, L4 = p4, M4 = h4;
function Tn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function z7(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function N4(...e) {
  return (t) => e.forEach((n) => z7(n, t));
}
function Zr(...e) {
  return y.useCallback(N4(...e), e);
}
function E7(e, t) {
  const n = y.createContext(t);
  function r(i) {
    const { children: s, ...o } = i, c = y.useMemo(() => o, Object.values(o));
    return /* @__PURE__ */ l.jsx(n.Provider, { value: c, children: s });
  }
  function a(i) {
    const s = y.useContext(n);
    if (s)
      return s;
    if (t !== void 0)
      return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [r, a];
}
function T7(e, t = []) {
  let n = [];
  function r(i, s) {
    const o = y.createContext(s), c = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: p, children: h, ...g } = f, v = (p == null ? void 0 : p[e][c]) || o, x = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ l.jsx(v.Provider, { value: x, children: h });
    }
    function u(f, p) {
      const h = (p == null ? void 0 : p[e][c]) || o, g = y.useContext(h);
      if (g)
        return g;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, u];
  }
  const a = () => {
    const i = n.map((s) => y.createContext(s));
    return function(o) {
      const c = (o == null ? void 0 : o[e]) || i;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: c } }),
        [o, c]
      );
    };
  };
  return a.scopeName = e, [r, k7(a, ...t)];
}
function k7(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const s = r.reduce((o, { useScope: c, scopeName: d }) => {
        const f = c(i)[`__scope${d}`];
        return { ...o, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var bs = globalThis != null && globalThis.document ? y.useLayoutEffect : () => {
}, j7 = y.useId || (() => {
}), P7 = 0;
function w1(e) {
  const [t, n] = y.useState(j7());
  return bs(() => {
    e || n((r) => r ?? String(P7++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function Ea(e) {
  const t = y.useRef(e);
  return y.useEffect(() => {
    t.current = e;
  }), y.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function A7({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = $7({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, o = Ea(n), c = y.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && o(f);
      } else
        a(d);
    },
    [i, e, a, o]
  );
  return [s, c];
}
function $7({
  defaultProp: e,
  onChange: t
}) {
  const n = y.useState(e), [r] = n, a = y.useRef(r), i = Ea(t);
  return y.useEffect(() => {
    a.current !== r && (i(r), a.current = r);
  }, [r, a, i]), n;
}
var ko = y.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = y.Children.toArray(n), i = a.find(O7);
  if (i) {
    const s = i.props.children, o = a.map((c) => c === i ? y.Children.count(s) > 1 ? y.Children.only(null) : y.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ l.jsx(ys, { ...r, ref: t, children: y.isValidElement(s) ? y.cloneElement(s, void 0, o) : null });
  }
  return /* @__PURE__ */ l.jsx(ys, { ...r, ref: t, children: n });
});
ko.displayName = "Slot";
var ys = y.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (y.isValidElement(n)) {
    const a = D7(n);
    return y.cloneElement(n, {
      ...R7(r, n.props),
      // @ts-ignore
      ref: t ? N4(t, a) : a
    });
  }
  return y.Children.count(n) > 1 ? y.Children.only(null) : null;
});
ys.displayName = "SlotClone";
var I7 = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
function O7(e) {
  return y.isValidElement(e) && e.type === I7;
}
function R7(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...o) => {
      i(...o), a(...o);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function D7(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var F7 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], pr = F7.reduce((e, t) => {
  const n = y.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, o = i ? ko : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(o, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function B7(e, t) {
  e && Dn.flushSync(() => e.dispatchEvent(t));
}
function V7(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ea(e);
  y.useEffect(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var H7 = "DismissableLayer", xs = "dismissableLayer.update", q7 = "dismissableLayer.pointerDownOutside", W7 = "dismissableLayer.focusOutside", tl, z4 = y.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), E4 = y.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: o,
      ...c
    } = e, d = y.useContext(z4), [u, f] = y.useState(null), p = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = y.useState({}), g = Zr(t, (M) => f(M)), v = Array.from(d.layers), [x] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), m = v.indexOf(x), b = u ? v.indexOf(u) : -1, _ = d.layersWithOutsidePointerEventsDisabled.size > 0, C = b >= m, w = Y7((M) => {
      const S = M.target, T = [...d.branches].some((j) => j.contains(S));
      !C || T || (a == null || a(M), s == null || s(M), M.defaultPrevented || o == null || o());
    }, p), N = K7((M) => {
      const S = M.target;
      [...d.branches].some((j) => j.contains(S)) || (i == null || i(M), s == null || s(M), M.defaultPrevented || o == null || o());
    }, p);
    return V7((M) => {
      b === d.layers.size - 1 && (r == null || r(M), !M.defaultPrevented && o && (M.preventDefault(), o()));
    }, p), y.useEffect(() => {
      if (u)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (tl = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), nl(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = tl);
        };
    }, [u, p, n, d]), y.useEffect(() => () => {
      u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), nl());
    }, [u, d]), y.useEffect(() => {
      const M = () => h({});
      return document.addEventListener(xs, M), () => document.removeEventListener(xs, M);
    }, []), /* @__PURE__ */ l.jsx(
      pr.div,
      {
        ...c,
        ref: g,
        style: {
          pointerEvents: _ ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Tn(e.onFocusCapture, N.onFocusCapture),
        onBlurCapture: Tn(e.onBlurCapture, N.onBlurCapture),
        onPointerDownCapture: Tn(
          e.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
E4.displayName = H7;
var U7 = "DismissableLayerBranch", G7 = y.forwardRef((e, t) => {
  const n = y.useContext(z4), r = y.useRef(null), a = Zr(t, r);
  return y.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ l.jsx(pr.div, { ...e, ref: a });
});
G7.displayName = U7;
function Y7(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ea(e), r = y.useRef(!1), a = y.useRef(() => {
  });
  return y.useEffect(() => {
    const i = (o) => {
      if (o.target && !r.current) {
        let c = function() {
          T4(
            q7,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: o };
        o.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = c, t.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function K7(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ea(e), r = y.useRef(!1);
  return y.useEffect(() => {
    const a = (i) => {
      i.target && !r.current && T4(W7, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function nl() {
  const e = new CustomEvent(xs);
  document.dispatchEvent(e);
}
function T4(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), r ? B7(a, i) : a.dispatchEvent(i);
}
function X7(e, t) {
  return y.useReducer((n, r) => t[n][r] ?? n, e);
}
var Xi = (e) => {
  const { present: t, children: n } = e, r = Z7(t), a = typeof n == "function" ? n({ present: r.isPresent }) : y.Children.only(n), i = Zr(r.ref, Q7(a));
  return typeof n == "function" || r.isPresent ? y.cloneElement(a, { ref: i }) : null;
};
Xi.displayName = "Presence";
function Z7(e) {
  const [t, n] = y.useState(), r = y.useRef({}), a = y.useRef(e), i = y.useRef("none"), s = e ? "mounted" : "unmounted", [o, c] = X7(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return y.useEffect(() => {
    const d = qa(r.current);
    i.current = o === "mounted" ? d : "none";
  }, [o]), bs(() => {
    const d = r.current, u = a.current;
    if (u !== e) {
      const p = i.current, h = qa(d);
      e ? c("MOUNT") : h === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(u && p !== h ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, c]), bs(() => {
    if (t) {
      const d = (f) => {
        const h = qa(r.current).includes(f.animationName);
        f.target === t && h && Dn.flushSync(() => c("ANIMATION_END"));
      }, u = (f) => {
        f.target === t && (i.current = qa(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: y.useCallback((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function qa(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Q7(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var C1 = 0;
function J7() {
  y.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? rl()), document.body.insertAdjacentElement("beforeend", e[1] ?? rl()), C1++, () => {
      C1 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), C1--;
    };
  }, []);
}
function rl() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var k4 = I0(), S1 = function() {
}, Zi = y.forwardRef(function(e, t) {
  var n = y.useRef(null), r = y.useState({
    onScrollCapture: S1,
    onWheelCapture: S1,
    onTouchMoveCapture: S1
  }), a = r[0], i = r[1], s = e.forwardProps, o = e.children, c = e.className, d = e.removeScrollBar, u = e.enabled, f = e.shards, p = e.sideCar, h = e.noIsolation, g = e.inert, v = e.allowPinchZoom, x = e.as, m = x === void 0 ? "div" : x, b = e.gapMode, _ = zo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = p, w = $0([n, t]), N = st(st({}, _), a);
  return y.createElement(
    y.Fragment,
    null,
    u && y.createElement(C, { sideCar: k4, removeScrollBar: d, shards: f, noIsolation: h, inert: g, setCallbacks: i, allowPinchZoom: !!v, lockRef: n, gapMode: b }),
    s ? y.cloneElement(y.Children.only(o), st(st({}, N), { ref: w })) : y.createElement(m, st({}, N, { className: c, ref: w }), o)
  );
});
Zi.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Zi.classNames = {
  fullWidth: ua,
  zeroRight: da
};
var _s = !1;
if (typeof window < "u")
  try {
    var Wa = Object.defineProperty({}, "passive", {
      get: function() {
        return _s = !0, !0;
      }
    });
    window.addEventListener("test", Wa, Wa), window.removeEventListener("test", Wa, Wa);
  } catch {
    _s = !1;
  }
var _r = _s ? { passive: !1 } : !1, ep = function(e) {
  return e.tagName === "TEXTAREA";
}, j4 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !ep(e) && n[t] === "visible")
  );
}, tp = function(e) {
  return j4(e, "overflowY");
}, np = function(e) {
  return j4(e, "overflowX");
}, al = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = P4(e, r);
    if (a) {
      var i = A4(e, r), s = i[1], o = i[2];
      if (s > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, rp = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, ap = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, P4 = function(e, t) {
  return e === "v" ? tp(t) : np(t);
}, A4 = function(e, t) {
  return e === "v" ? rp(t) : ap(t);
}, ip = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, sp = function(e, t, n, r, a) {
  var i = ip(e, window.getComputedStyle(t).direction), s = i * r, o = n.target, c = t.contains(o), d = !1, u = s > 0, f = 0, p = 0;
  do {
    var h = A4(e, o), g = h[0], v = h[1], x = h[2], m = v - x - i * g;
    (g || m) && P4(e, o) && (f += m, p += g), o instanceof ShadowRoot ? o = o.host : o = o.parentNode;
  } while (
    // portaled content
    !c && o !== document.body || // self content
    c && (t.contains(o) || t === o)
  );
  return (u && (a && Math.abs(f) < 1 || !a && s > f) || !u && (a && Math.abs(p) < 1 || !a && -s > p)) && (d = !0), d;
}, Ua = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, il = function(e) {
  return [e.deltaX, e.deltaY];
}, sl = function(e) {
  return e && "current" in e ? e.current : e;
}, op = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, cp = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, lp = 0, wr = [];
function dp(e) {
  var t = y.useRef([]), n = y.useRef([0, 0]), r = y.useRef(), a = y.useState(lp++)[0], i = y.useState(Eo)[0], s = y.useRef(e);
  y.useEffect(function() {
    s.current = e;
  }, [e]), y.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var v = A0([e.lockRef.current], (e.shards || []).map(sl), !0).filter(Boolean);
      return v.forEach(function(x) {
        return x.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), v.forEach(function(x) {
          return x.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = y.useCallback(function(v, x) {
    if ("touches" in v && v.touches.length === 2)
      return !s.current.allowPinchZoom;
    var m = Ua(v), b = n.current, _ = "deltaX" in v ? v.deltaX : b[0] - m[0], C = "deltaY" in v ? v.deltaY : b[1] - m[1], w, N = v.target, M = Math.abs(_) > Math.abs(C) ? "h" : "v";
    if ("touches" in v && M === "h" && N.type === "range")
      return !1;
    var S = al(M, N);
    if (!S)
      return !0;
    if (S ? w = M : (w = M === "v" ? "h" : "v", S = al(M, N)), !S)
      return !1;
    if (!r.current && "changedTouches" in v && (_ || C) && (r.current = w), !w)
      return !0;
    var T = r.current || w;
    return sp(T, x, v, T === "h" ? _ : C, !0);
  }, []), c = y.useCallback(function(v) {
    var x = v;
    if (!(!wr.length || wr[wr.length - 1] !== i)) {
      var m = "deltaY" in x ? il(x) : Ua(x), b = t.current.filter(function(w) {
        return w.name === x.type && (w.target === x.target || x.target === w.shadowParent) && op(w.delta, m);
      })[0];
      if (b && b.should) {
        x.cancelable && x.preventDefault();
        return;
      }
      if (!b) {
        var _ = (s.current.shards || []).map(sl).filter(Boolean).filter(function(w) {
          return w.contains(x.target);
        }), C = _.length > 0 ? o(x, _[0]) : !s.current.noIsolation;
        C && x.cancelable && x.preventDefault();
      }
    }
  }, []), d = y.useCallback(function(v, x, m, b) {
    var _ = { name: v, delta: x, target: m, should: b, shadowParent: up(m) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== _;
      });
    }, 1);
  }, []), u = y.useCallback(function(v) {
    n.current = Ua(v), r.current = void 0;
  }, []), f = y.useCallback(function(v) {
    d(v.type, il(v), v.target, o(v, e.lockRef.current));
  }, []), p = y.useCallback(function(v) {
    d(v.type, Ua(v), v.target, o(v, e.lockRef.current));
  }, []);
  y.useEffect(function() {
    return wr.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", c, _r), document.addEventListener("touchmove", c, _r), document.addEventListener("touchstart", u, _r), function() {
      wr = wr.filter(function(v) {
        return v !== i;
      }), document.removeEventListener("wheel", c, _r), document.removeEventListener("touchmove", c, _r), document.removeEventListener("touchstart", u, _r);
    };
  }, []);
  var h = e.removeScrollBar, g = e.inert;
  return y.createElement(
    y.Fragment,
    null,
    g ? y.createElement(i, { styles: cp(a) }) : null,
    h ? y.createElement(F0, { gapMode: e.gapMode }) : null
  );
}
function up(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const fp = R0(k4, dp);
var $4 = y.forwardRef(function(e, t) {
  return y.createElement(Zi, st({}, e, { ref: t, sideCar: fp }));
});
$4.classNames = Zi.classNames;
const pp = $4;
var jo = "Dialog", [I4, IE] = T7(jo), [mp, Dt] = I4(jo), O4 = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    modal: s = !0
  } = e, o = y.useRef(null), c = y.useRef(null), [d = !1, u] = A7({
    prop: r,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ l.jsx(
    mp,
    {
      scope: t,
      triggerRef: o,
      contentRef: c,
      contentId: w1(),
      titleId: w1(),
      descriptionId: w1(),
      open: d,
      onOpenChange: u,
      onOpenToggle: y.useCallback(() => u((f) => !f), [u]),
      modal: s,
      children: n
    }
  );
};
O4.displayName = jo;
var R4 = "DialogTrigger", D4 = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Dt(R4, n), i = Zr(t, a.triggerRef);
    return /* @__PURE__ */ l.jsx(
      pr.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": $o(a.open),
        ...r,
        ref: i,
        onClick: Tn(e.onClick, a.onOpenToggle)
      }
    );
  }
);
D4.displayName = R4;
var Po = "DialogPortal", [hp, F4] = I4(Po, {
  forceMount: void 0
}), B4 = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: a } = e, i = Dt(Po, t);
  return /* @__PURE__ */ l.jsx(hp, { scope: t, forceMount: n, children: y.Children.map(r, (s) => /* @__PURE__ */ l.jsx(Xi, { present: n || i.open, children: /* @__PURE__ */ l.jsx(So, { asChild: !0, container: a, children: s }) })) });
};
B4.displayName = Po;
var _i = "DialogOverlay", V4 = y.forwardRef(
  (e, t) => {
    const n = F4(_i, e.__scopeDialog), { forceMount: r = n.forceMount, ...a } = e, i = Dt(_i, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ l.jsx(Xi, { present: r || i.open, children: /* @__PURE__ */ l.jsx(gp, { ...a, ref: t }) }) : null;
  }
);
V4.displayName = _i;
var gp = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Dt(_i, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ l.jsx(pp, { as: ko, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ l.jsx(
        pr.div,
        {
          "data-state": $o(a.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), sr = "DialogContent", H4 = y.forwardRef(
  (e, t) => {
    const n = F4(sr, e.__scopeDialog), { forceMount: r = n.forceMount, ...a } = e, i = Dt(sr, e.__scopeDialog);
    return /* @__PURE__ */ l.jsx(Xi, { present: r || i.open, children: i.modal ? /* @__PURE__ */ l.jsx(vp, { ...a, ref: t }) : /* @__PURE__ */ l.jsx(bp, { ...a, ref: t }) });
  }
);
H4.displayName = sr;
var vp = y.forwardRef(
  (e, t) => {
    const n = Dt(sr, e.__scopeDialog), r = y.useRef(null), a = Zr(t, n.contentRef, r);
    return y.useEffect(() => {
      const i = r.current;
      if (i)
        return P0(i);
    }, []), /* @__PURE__ */ l.jsx(
      q4,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Tn(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: Tn(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, o = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || o) && i.preventDefault();
        }),
        onFocusOutside: Tn(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), bp = y.forwardRef(
  (e, t) => {
    const n = Dt(sr, e.__scopeDialog), r = y.useRef(!1), a = y.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      q4,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, o;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (o = n.triggerRef.current) == null || o.focus(), i.preventDefault()), r.current = !1, a.current = !1;
        },
        onInteractOutside: (i) => {
          var c, d;
          (c = e.onInteractOutside) == null || c.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const s = i.target;
          ((d = n.triggerRef.current) == null ? void 0 : d.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
        }
      }
    );
  }
), q4 = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: i, ...s } = e, o = Dt(sr, n), c = y.useRef(null), d = Zr(t, c);
    return J7(), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        Mo,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: a,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ l.jsx(
            E4,
            {
              role: "dialog",
              id: o.contentId,
              "aria-describedby": o.descriptionId,
              "aria-labelledby": o.titleId,
              "data-state": $o(o.open),
              ...s,
              ref: d,
              onDismiss: () => o.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        /* @__PURE__ */ l.jsx(yp, { titleId: o.titleId }),
        /* @__PURE__ */ l.jsx(_p, { contentRef: c, descriptionId: o.descriptionId })
      ] })
    ] });
  }
), Ao = "DialogTitle", W4 = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Dt(Ao, n);
    return /* @__PURE__ */ l.jsx(pr.h2, { id: a.titleId, ...r, ref: t });
  }
);
W4.displayName = Ao;
var U4 = "DialogDescription", G4 = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Dt(U4, n);
    return /* @__PURE__ */ l.jsx(pr.p, { id: a.descriptionId, ...r, ref: t });
  }
);
G4.displayName = U4;
var Y4 = "DialogClose", K4 = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Dt(Y4, n);
    return /* @__PURE__ */ l.jsx(
      pr.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Tn(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
K4.displayName = Y4;
function $o(e) {
  return e ? "open" : "closed";
}
var X4 = "DialogTitleWarning", [OE, Z4] = E7(X4, {
  contentName: sr,
  titleName: Ao,
  docsSlug: "dialog"
}), yp = ({ titleId: e }) => {
  const t = Z4(X4), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return y.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, xp = "DialogDescriptionWarning", _p = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Z4(xp).contentName}}.`;
  return y.useEffect(() => {
    var i;
    const a = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && a && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, wp = O4, Cp = D4, Sp = B4, Q4 = V4, J4 = H4, e3 = W4, t3 = G4, Lp = K4;
function sn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function Io(e, t = []) {
  let n = [];
  function r(i, s) {
    const o = y.createContext(s), c = n.length;
    n = [...n, s];
    function d(f) {
      const { scope: p, children: h, ...g } = f, v = (p == null ? void 0 : p[e][c]) || o, x = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ l.jsx(v.Provider, { value: x, children: h });
    }
    function u(f, p) {
      const h = (p == null ? void 0 : p[e][c]) || o, g = y.useContext(h);
      if (g)
        return g;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, u];
  }
  const a = () => {
    const i = n.map((s) => y.createContext(s));
    return function(o) {
      const c = (o == null ? void 0 : o[e]) || i;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: c } }),
        [o, c]
      );
    };
  };
  return a.scopeName = e, [r, Mp(a, ...t)];
}
function Mp(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const s = r.reduce((o, { useScope: c, scopeName: d }) => {
        const f = c(i)[`__scope${d}`];
        return { ...o, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Np(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function n3(...e) {
  return (t) => e.forEach((n) => Np(n, t));
}
function wi(...e) {
  return y.useCallback(n3(...e), e);
}
var Ci = y.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = y.Children.toArray(n), i = a.find(Ep);
  if (i) {
    const s = i.props.children, o = a.map((c) => c === i ? y.Children.count(s) > 1 ? y.Children.only(null) : y.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ l.jsx(ws, { ...r, ref: t, children: y.isValidElement(s) ? y.cloneElement(s, void 0, o) : null });
  }
  return /* @__PURE__ */ l.jsx(ws, { ...r, ref: t, children: n });
});
Ci.displayName = "Slot";
var ws = y.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (y.isValidElement(n)) {
    const a = kp(n);
    return y.cloneElement(n, {
      ...Tp(r, n.props),
      // @ts-ignore
      ref: t ? n3(t, a) : a
    });
  }
  return y.Children.count(n) > 1 ? y.Children.only(null) : null;
});
ws.displayName = "SlotClone";
var zp = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
function Ep(e) {
  return y.isValidElement(e) && e.type === zp;
}
function Tp(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...o) => {
      i(...o), a(...o);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function kp(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function jp(e) {
  const t = e + "CollectionProvider", [n, r] = Io(t), [a, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: g, children: v } = h, x = Y.useRef(null), m = Y.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l.jsx(a, { scope: g, itemMap: m, collectionRef: x, children: v });
  };
  s.displayName = t;
  const o = e + "CollectionSlot", c = Y.forwardRef(
    (h, g) => {
      const { scope: v, children: x } = h, m = i(o, v), b = wi(g, m.collectionRef);
      return /* @__PURE__ */ l.jsx(Ci, { ref: b, children: x });
    }
  );
  c.displayName = o;
  const d = e + "CollectionItemSlot", u = "data-radix-collection-item", f = Y.forwardRef(
    (h, g) => {
      const { scope: v, children: x, ...m } = h, b = Y.useRef(null), _ = wi(g, b), C = i(d, v);
      return Y.useEffect(() => (C.itemMap.set(b, { ref: b, ...m }), () => void C.itemMap.delete(b))), /* @__PURE__ */ l.jsx(Ci, { [u]: "", ref: _, children: x });
    }
  );
  f.displayName = d;
  function p(h) {
    const g = i(e + "CollectionConsumer", h);
    return Y.useCallback(() => {
      const x = g.collectionRef.current;
      if (!x)
        return [];
      const m = Array.from(x.querySelectorAll(`[${u}]`));
      return Array.from(g.itemMap.values()).sort(
        (C, w) => m.indexOf(C.ref.current) - m.indexOf(w.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: f },
    p,
    r
  ];
}
var Cs = globalThis != null && globalThis.document ? y.useLayoutEffect : () => {
}, Pp = y.useId || (() => {
}), Ap = 0;
function r3(e) {
  const [t, n] = y.useState(Pp());
  return Cs(() => {
    e || n((r) => r ?? String(Ap++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var $p = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Qr = $p.reduce((e, t) => {
  const n = y.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, o = i ? Ci : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(o, { ...s, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Oo(e) {
  const t = y.useRef(e);
  return y.useEffect(() => {
    t.current = e;
  }), y.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function a3({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = Ip({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, o = Oo(n), c = y.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && o(f);
      } else
        a(d);
    },
    [i, e, a, o]
  );
  return [s, c];
}
function Ip({
  defaultProp: e,
  onChange: t
}) {
  const n = y.useState(e), [r] = n, a = y.useRef(r), i = Oo(t);
  return y.useEffect(() => {
    a.current !== r && (i(r), a.current = r);
  }, [r, a, i]), n;
}
var Op = y.createContext(void 0);
function i3(e) {
  const t = y.useContext(Op);
  return e || t || "ltr";
}
var L1 = "rovingFocusGroup.onEntryFocus", Rp = { bubbles: !1, cancelable: !0 }, Qi = "RovingFocusGroup", [Ss, s3, Dp] = jp(Qi), [Fp, o3] = Io(
  Qi,
  [Dp]
), [Bp, Vp] = Fp(Qi), c3 = y.forwardRef(
  (e, t) => /* @__PURE__ */ l.jsx(Ss.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(Ss.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(Hp, { ...e, ref: t }) }) })
);
c3.displayName = Qi;
var Hp = y.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: a = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: o,
    onCurrentTabStopIdChange: c,
    onEntryFocus: d,
    preventScrollOnEntryFocus: u = !1,
    ...f
  } = e, p = y.useRef(null), h = wi(t, p), g = i3(i), [v = null, x] = a3({
    prop: s,
    defaultProp: o,
    onChange: c
  }), [m, b] = y.useState(!1), _ = Oo(d), C = s3(n), w = y.useRef(!1), [N, M] = y.useState(0);
  return y.useEffect(() => {
    const S = p.current;
    if (S)
      return S.addEventListener(L1, _), () => S.removeEventListener(L1, _);
  }, [_]), /* @__PURE__ */ l.jsx(
    Bp,
    {
      scope: n,
      orientation: r,
      dir: g,
      loop: a,
      currentTabStopId: v,
      onItemFocus: y.useCallback(
        (S) => x(S),
        [x]
      ),
      onItemShiftTab: y.useCallback(() => b(!0), []),
      onFocusableItemAdd: y.useCallback(
        () => M((S) => S + 1),
        []
      ),
      onFocusableItemRemove: y.useCallback(
        () => M((S) => S - 1),
        []
      ),
      children: /* @__PURE__ */ l.jsx(
        Qr.div,
        {
          tabIndex: m || N === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: sn(e.onMouseDown, () => {
            w.current = !0;
          }),
          onFocus: sn(e.onFocus, (S) => {
            const T = !w.current;
            if (S.target === S.currentTarget && T && !m) {
              const j = new CustomEvent(L1, Rp);
              if (S.currentTarget.dispatchEvent(j), !j.defaultPrevented) {
                const D = C().filter((F) => F.focusable), A = D.find((F) => F.active), k = D.find((F) => F.id === v), R = [A, k, ...D].filter(
                  Boolean
                ).map((F) => F.ref.current);
                u3(R, u);
              }
            }
            w.current = !1;
          }),
          onBlur: sn(e.onBlur, () => b(!1))
        }
      )
    }
  );
}), l3 = "RovingFocusGroupItem", d3 = y.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: a = !1,
      tabStopId: i,
      ...s
    } = e, o = r3(), c = i || o, d = Vp(l3, n), u = d.currentTabStopId === c, f = s3(n), { onFocusableItemAdd: p, onFocusableItemRemove: h } = d;
    return y.useEffect(() => {
      if (r)
        return p(), () => h();
    }, [r, p, h]), /* @__PURE__ */ l.jsx(
      Ss.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: a,
        children: /* @__PURE__ */ l.jsx(
          Qr.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": d.orientation,
            ...s,
            ref: t,
            onMouseDown: sn(e.onMouseDown, (g) => {
              r ? d.onItemFocus(c) : g.preventDefault();
            }),
            onFocus: sn(e.onFocus, () => d.onItemFocus(c)),
            onKeyDown: sn(e.onKeyDown, (g) => {
              if (g.key === "Tab" && g.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (g.target !== g.currentTarget)
                return;
              const v = Up(g, d.orientation, d.dir);
              if (v !== void 0) {
                if (g.metaKey || g.ctrlKey || g.altKey || g.shiftKey)
                  return;
                g.preventDefault();
                let m = f().filter((b) => b.focusable).map((b) => b.ref.current);
                if (v === "last")
                  m.reverse();
                else if (v === "prev" || v === "next") {
                  v === "prev" && m.reverse();
                  const b = m.indexOf(g.currentTarget);
                  m = d.loop ? Gp(m, b + 1) : m.slice(b + 1);
                }
                setTimeout(() => u3(m));
              }
            })
          }
        )
      }
    );
  }
);
d3.displayName = l3;
var qp = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Wp(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Up(e, t, n) {
  const r = Wp(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return qp[r];
}
function u3(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function Gp(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Yp = c3, Kp = d3;
function Xp(e, t) {
  return y.useReducer((n, r) => t[n][r] ?? n, e);
}
var f3 = (e) => {
  const { present: t, children: n } = e, r = Zp(t), a = typeof n == "function" ? n({ present: r.isPresent }) : y.Children.only(n), i = wi(r.ref, Qp(a));
  return typeof n == "function" || r.isPresent ? y.cloneElement(a, { ref: i }) : null;
};
f3.displayName = "Presence";
function Zp(e) {
  const [t, n] = y.useState(), r = y.useRef({}), a = y.useRef(e), i = y.useRef("none"), s = e ? "mounted" : "unmounted", [o, c] = Xp(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return y.useEffect(() => {
    const d = Ga(r.current);
    i.current = o === "mounted" ? d : "none";
  }, [o]), Cs(() => {
    const d = r.current, u = a.current;
    if (u !== e) {
      const p = i.current, h = Ga(d);
      e ? c("MOUNT") : h === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(u && p !== h ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, c]), Cs(() => {
    if (t) {
      const d = (f) => {
        const h = Ga(r.current).includes(f.animationName);
        f.target === t && h && Dn.flushSync(() => c("ANIMATION_END"));
      }, u = (f) => {
        f.target === t && (i.current = Ga(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: y.useCallback((d) => {
      d && (r.current = getComputedStyle(d)), n(d);
    }, [])
  };
}
function Ga(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Qp(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ro = "Tabs", [Jp, RE] = Io(Ro, [
  o3
]), p3 = o3(), [em, Do] = Jp(Ro), m3 = y.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: a,
      defaultValue: i,
      orientation: s = "horizontal",
      dir: o,
      activationMode: c = "automatic",
      ...d
    } = e, u = i3(o), [f, p] = a3({
      prop: r,
      onChange: a,
      defaultProp: i
    });
    return /* @__PURE__ */ l.jsx(
      em,
      {
        scope: n,
        baseId: r3(),
        value: f,
        onValueChange: p,
        orientation: s,
        dir: u,
        activationMode: c,
        children: /* @__PURE__ */ l.jsx(
          Qr.div,
          {
            dir: u,
            "data-orientation": s,
            ...d,
            ref: t
          }
        )
      }
    );
  }
);
m3.displayName = Ro;
var h3 = "TabsList", g3 = y.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...a } = e, i = Do(h3, n), s = p3(n);
    return /* @__PURE__ */ l.jsx(
      Yp,
      {
        asChild: !0,
        ...s,
        orientation: i.orientation,
        dir: i.dir,
        loop: r,
        children: /* @__PURE__ */ l.jsx(
          Qr.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...a,
            ref: t
          }
        )
      }
    );
  }
);
g3.displayName = h3;
var v3 = "TabsTrigger", b3 = y.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: a = !1, ...i } = e, s = Do(v3, n), o = p3(n), c = _3(s.baseId, r), d = w3(s.baseId, r), u = r === s.value;
    return /* @__PURE__ */ l.jsx(
      Kp,
      {
        asChild: !0,
        ...o,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ l.jsx(
          Qr.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": d,
            "data-state": u ? "active" : "inactive",
            "data-disabled": a ? "" : void 0,
            disabled: a,
            id: c,
            ...i,
            ref: t,
            onMouseDown: sn(e.onMouseDown, (f) => {
              !a && f.button === 0 && f.ctrlKey === !1 ? s.onValueChange(r) : f.preventDefault();
            }),
            onKeyDown: sn(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && s.onValueChange(r);
            }),
            onFocus: sn(e.onFocus, () => {
              const f = s.activationMode !== "manual";
              !u && !a && f && s.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
b3.displayName = v3;
var y3 = "TabsContent", x3 = y.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: a, children: i, ...s } = e, o = Do(y3, n), c = _3(o.baseId, r), d = w3(o.baseId, r), u = r === o.value, f = y.useRef(u);
    return y.useEffect(() => {
      const p = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(p);
    }, []), /* @__PURE__ */ l.jsx(f3, { present: a || u, children: ({ present: p }) => /* @__PURE__ */ l.jsx(
      Qr.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": o.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !p,
        id: d,
        tabIndex: 0,
        ...s,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: p && i
      }
    ) });
  }
);
x3.displayName = y3;
function _3(e, t) {
  return `${e}-trigger-${t}`;
}
function w3(e, t) {
  return `${e}-content-${t}`;
}
var tm = m3, nm = g3, rm = b3, C3 = x3;
const Ls = /* @__PURE__ */ K((e, t) => /* @__PURE__ */ ge(ot.span, Ne({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), am = Ls, mr = (e, t) => t && nr(e) ? Te(e, {
  loading: t ? "lazy" : void 0
}) : e, im = (e) => {
  const { addressLine1: t, addressLine2: n, city: r, state: a, zip: i } = e;
  return `${t}, ${n ?? ""}, ${r}, ${a} ${i}`;
}, me = (e) => e, hr = (e) => {
  switch (e) {
    case "white":
    case "whiteSmoke":
    case "achOrange":
    case "utilityInfo":
    case "utilityWarning":
    case "utilityNegative":
    case "utilityPositive":
    case "utilityUtility":
      return !1;
    default:
      return !0;
  }
}, S3 = (e) => {
  const { backgroundColor: t, buttonStyle: n, theme: r, order: a = "first" } = e;
  if (!(n === void 0 || n === "link"))
    switch (r) {
      case "Corporate":
        switch (t) {
          case "white":
          case "whiteSmoke":
            return "solid1";
          case "denimBlue":
            return "light1";
          default:
            return "solid-1-inverse";
        }
      case "SoutheastConsumer":
        switch (t) {
          case "achOrange":
            switch (n) {
              case "outlined":
                return "outlined-alt";
              default:
              case "solid":
                return "light1";
            }
          case "blue":
          case "burntOrange":
          case "cchaPurple":
          case "denimBlue":
          case "teal":
          case "wellnessBlue":
            switch (n) {
              case "outlined":
                return "outlined-inverse";
              default:
              case "solid":
                return "light1";
            }
          case "darkTeal":
            switch (n) {
              case "outlined":
                return "outlined-inverse";
              default:
              case "solid":
                switch (a) {
                  case "first":
                    return "light-inverse";
                  default:
                  case "second":
                    return "solid-1-inverse";
                }
            }
          case "utilityInfo":
            switch (n) {
              case "outlined":
                return "outlined";
              default:
              case "solid":
                switch (a) {
                  case "first":
                    return "solid1";
                  default:
                  case "second":
                    return "solid2";
                }
            }
          case "utilityNegative":
          case "utilityPositive":
          case "utilityUtility":
          case "utilityWarning":
            switch (n) {
              case "outlined":
                return "outlined-alt";
              default:
              case "solid":
                switch (a) {
                  case "first":
                    return "solid1";
                  default:
                  case "second":
                    return "solid2";
                }
            }
          case "transparent":
          case "white":
          case "whiteSmoke":
            switch (n) {
              case "outlined":
                return "outlined";
              default:
              case "solid":
                switch (a) {
                  case "first":
                    return "solid1";
                  default:
                  case "second":
                    return "solid2";
                }
            }
          default:
            switch (n) {
              case "outlined":
                return "outlined-inverse";
              default:
              case "solid":
                return "solid-1-inverse";
            }
        }
      default:
      case "Consumer":
        switch (t) {
          case "white":
          case "whiteSmoke":
            switch (n) {
              case "outlined":
                return "outlined";
              default:
              case "solid":
                switch (a) {
                  case "first":
                    return "solid1";
                  default:
                  case "second":
                    return "solid2";
                }
            }
          case "wellnessBlue":
            switch (n) {
              case "outlined":
                return "outlined-inverse";
              default:
              case "solid":
                return "light-inverse";
            }
          case "denimBlue":
            switch (n) {
              case "outlined":
                return "outlined-inverse";
              default:
              case "solid":
                return "light1";
            }
          case "achOrange":
            switch (n) {
              case "outlined":
                return "outlined-alt";
              default:
              case "solid":
                return "solid-1-inverse";
            }
          case "utilityInfo":
            switch (n) {
              case "outlined":
                return "outlined-alt";
              default:
              case "solid":
                switch (a) {
                  case "first":
                    return "solid1";
                  default:
                  case "second":
                    return "solid2";
                }
            }
          case "utilityNegative":
          case "utilityPositive":
          case "utilityUtility":
          case "utilityWarning":
            switch (n) {
              case "outlined":
                return "outlined-alt";
              default:
              case "solid":
                switch (a) {
                  case "first":
                    return "solid1";
                  default:
                  case "second":
                    return "solid2";
                }
            }
          default:
            switch (n) {
              case "outlined":
                return "outlined-inverse";
              default:
              case "solid":
                return "solid-1-inverse";
            }
        }
    }
}, L3 = (e) => {
  const { backgroundColor: t, theme: n } = e;
  switch (t) {
    case "burntOrange":
    case "blue":
    case "cchaPurple":
    case "darkTeal":
    case "denimBlue":
    case "teal":
    case "wellnessBlue":
      return "inverse";
    case "achOrange":
      switch (n) {
        case "SoutheastConsumer":
          return "default";
        default:
          return "alt";
      }
    case "utilityInfo":
    case "utilityNegative":
    case "utilityPositive":
    case "utilityUtility":
    case "utilityWarning":
      return "alt";
    default:
    case "white":
    case "whiteSmoke":
      return "default";
  }
}, M3 = (e) => {
  const { addressLine1: t, addressLine2: n, city: r, state: a, zip: i } = e;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${t}, ${n ?? ""}, ${r}, ${a} ${i}`
  )}`;
}, sm = /^[A-Za-z0-9\-',.!@#$%\\/:;"<>?&*()_+‘’“”  ]+$/, Ms = (e) => new RegExp(sm).test(e);
function om() {
  return new Promise((e, t) => {
    if (!navigator.geolocation) {
      t("Geolocation is not supported.");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (n) => {
        e(n);
      },
      () => {
        t("Unable to retrieve location.");
      }
    );
  });
}
function cm(e) {
  return new Promise((t, n) => {
    if (!e) {
      n("Invalid Google Maps API key.");
      return;
    }
    if (typeof window.google == "object" && typeof window.google.maps == "object") {
      t();
      return;
    }
    const r = document.createElement("script");
    r.src = `https://maps.googleapis.com/maps/api/js?key=${e}&libraries=places`, r.async = !0, r.defer = !0, r.onload = () => t(), r.onerror = () => {
      console.log("An error occurred loading the Google Maps script."), n("An error occurred loading the Google Maps script.");
    }, document.head.appendChild(r);
  });
}
function lm(e) {
  const { latitude: t, longitude: n } = e;
  return new Promise((r, a) => {
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
      a("Google Maps API not loaded.");
      return;
    }
    const i = new window.google.maps.Geocoder(), s = new window.google.maps.LatLng(t, n);
    i.geocode({ location: s }, (o, c) => {
      if (c === "OK" && o.length > 0) {
        const u = o[0].address_components.find(
          (p) => p.types.includes("postal_code")
        ), f = u ? u.long_name : "";
        r({ zipCode: f });
      } else
        a("An error occurred fetching the zip code.");
    });
  });
}
function dm(e, t) {
  let n;
  return function(...r) {
    n && clearTimeout(n), n = setTimeout(() => {
      e(...r);
    }, t);
  };
}
const um = async () => {
  if (!navigator.permissions)
    return console.error("Permissions API is not supported in this browser."), !1;
  try {
    return (await navigator.permissions.query({
      name: "geolocation"
    })).state === "denied";
  } catch (e) {
    return console.error("Error checking geolocation permission:", e), !1;
  }
}, fm = (e) => typeof e == "object" && e !== null && "code" in e && "message" in e, pm = (e) => {
  typeof window < "u" && window.scrollTo({
    top: e,
    behavior: "smooth"
    // for smoothly scrolling
  });
}, mm = () => pm(0), hm = (e) => {
  if (!(e != null && e.startsWith("#")))
    return;
  const t = document.querySelector(e);
  t == null || t.scrollIntoView({ behavior: "smooth" });
}, gm = me({
  solid1: "r-btn-solid1",
  solid2: "r-btn-solid2",
  light1: "r-btn-light1",
  light2: "r-btn-light2",
  outlined: "r-btn-outlined",
  "outlined-alt": "r-btn-outlined-alt",
  "solid-1-inverse": "r-btn-solid-1-inverse",
  "outlined-inverse": "r-btn-outlined-inverse",
  "light-inverse": "r-btn-light-inverse"
}), vm = me({
  medium: "r-btn-medium",
  large: "r-btn-large",
  responsive: "r-btn-responsive"
}), Fo = De("r-btn", {
  variants: {
    variant: gm,
    size: vm
  }
}), bm = "_container_9xxyc_210", ym = "_logo_9xxyc_223", xm = "_invisible_9xxyc_505", _m = "_stuck_9xxyc_519", wm = "_color_9xxyc_560", Cm = "_orange_9xxyc_608", Sm = "_yellow_9xxyc_611", Lm = "_purple_9xxyc_614", Mm = "_blue_9xxyc_617", Nm = "_green_9xxyc_620", zm = "_slideDown_9xxyc_1", Em = "_slideUp_9xxyc_1", he = {
  container: bm,
  "bg-transparent": "_bg-transparent_9xxyc_223",
  "logo-inverse": "_logo-inverse_9xxyc_223",
  "logo-default": "_logo-default_9xxyc_226",
  "nav-menu": "_nav-menu_9xxyc_229",
  "nav-list-desktop": "_nav-list-desktop_9xxyc_239",
  "nav-list-mobile": "_nav-list-mobile_9xxyc_243",
  logo: ym,
  "nav-list": "_nav-list_9xxyc_239",
  "nav-item-link": "_nav-item-link_9xxyc_266",
  "featured-cta": "_featured-cta_9xxyc_294",
  "sheet-content": "_sheet-content_9xxyc_297",
  "sheet-overlay": "_sheet-overlay_9xxyc_298",
  "sheet-header": "_sheet-header_9xxyc_311",
  "mobile-menu": "_mobile-menu_9xxyc_341",
  "mobile-search-form": "_mobile-search-form_9xxyc_347",
  "mobile-nav-items": "_mobile-nav-items_9xxyc_377",
  "mobile-link": "_mobile-link_9xxyc_386",
  "mobile-accordion": "_mobile-accordion_9xxyc_393",
  "mobile-accordion-item": "_mobile-accordion-item_9xxyc_396",
  "mobile-accordion-trigger": "_mobile-accordion-trigger_9xxyc_400",
  "mobile-accordion-content": "_mobile-accordion-content_9xxyc_404",
  invisible: xm,
  "desktop-search": "_desktop-search_9xxyc_509",
  stuck: _m,
  color: wm,
  orange: Cm,
  yellow: Sm,
  purple: Lm,
  blue: Mm,
  green: Nm,
  "nav-item-menu": "_nav-item-menu_9xxyc_623",
  "nav-item-menu-link": "_nav-item-menu-link_9xxyc_631",
  slideDown: zm,
  "desktop-search-form": "_desktop-search-form_9xxyc_668",
  slideUp: Em,
  "nav-item-link-text": "_nav-item-link-text_9xxyc_714"
}, DE = [
  "orange",
  "yellow",
  "purple",
  "blue",
  "green"
], FE = ["white", "transparent"], Tm = 251, km = (e) => {
  const [t, n] = ne(!1), r = pe(null), a = pe(null), [i, s] = ne(!1), {
    className: o,
    isStuck: c,
    isSearchBarOpen: d,
    setIsSearchBarOpen: u,
    logoUrl: f,
    logoTitle: p,
    logoImage: h,
    logoImageInverse: g,
    ariaLabel: v = "Main Navigation",
    navigationItems: x,
    mobileMenuTriggerOpenLabel: m,
    mobileMenuTriggerCloseLabel: b,
    searchLabel: _,
    searchPlaceholder: C,
    searchUrl: w,
    searchColor: N,
    mobileCallLink: M,
    utilityNavigation: S,
    featuredCtaButton: T,
    backgroundColor: j
  } = e;
  return ve(() => {
    d && a.current && a.current.focus();
  }, [d, a.current]), ve(() => {
    document.body && setTimeout(() => {
      t ? document.body.style.pointerEvents = "initial" : document.body.style.pointerEvents = "";
    }, Tm);
  }, [t]), ve(() => {
    t || s(!1);
  }, [t]), /* @__PURE__ */ l.jsxs(
    Oz,
    {
      open: t,
      onOpenChange: n,
      children: [
        /* @__PURE__ */ l.jsx(
          T2,
          {
            asChild: !0,
            open: d,
            onOpenChange: u,
            children: /* @__PURE__ */ l.jsxs(
              xe,
              {
                customRef: r,
                className: z(he.container, {
                  [he.stuck]: c,
                  [he["bg-transparent"]]: j === "transparent"
                }),
                children: [
                  /* @__PURE__ */ l.jsxs(
                    Oi,
                    {
                      "data-testid": "global-navigation",
                      "aria-label": v,
                      className: z(
                        he["nav-menu"],
                        c && he.stuck,
                        o
                      ),
                      children: [
                        g && j === "transparent" && /* @__PURE__ */ l.jsx(
                          "a",
                          {
                            href: f,
                            title: p,
                            className: z(
                              he.logo,
                              he["logo-inverse"]
                            ),
                            children: g
                          }
                        ),
                        /* @__PURE__ */ l.jsx(
                          "a",
                          {
                            href: f,
                            title: p,
                            className: z(
                              he.logo,
                              he["logo-default"]
                            ),
                            children: h
                          }
                        ),
                        x && x.length > 0 && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                          /* @__PURE__ */ l.jsx(
                            jm,
                            {
                              navigationItems: x,
                              searchLabel: _,
                              searchUrl: w,
                              searchColor: N
                            }
                          ),
                          /* @__PURE__ */ l.jsx(
                            ol,
                            {
                              isMobileSheetOpen: t,
                              mobileMenuTriggerOpenLabel: m,
                              mobileMenuTriggerCloseLabel: b,
                              searchLabel: _,
                              mobileCallLink: M,
                              searchUrl: w,
                              featuredCtaButton: T,
                              setIsMobileSearchClicked: s
                            }
                          )
                        ] })
                      ]
                    }
                  ),
                  w && /* @__PURE__ */ l.jsx(
                    j2,
                    {
                      "data-testid": "desktop-search",
                      className: he["desktop-search"],
                      children: /* @__PURE__ */ l.jsxs(
                        "form",
                        {
                          action: w,
                          className: he["desktop-search-form"],
                          children: [
                            /* @__PURE__ */ l.jsx(
                              "input",
                              {
                                ref: a,
                                name: "q",
                                type: "search",
                                placeholder: C
                              }
                            ),
                            /* @__PURE__ */ l.jsx(
                              "button",
                              {
                                type: "submit",
                                "aria-label": _,
                                children: /* @__PURE__ */ l.jsx(re, { icon: "magnifyingGlass" })
                              }
                            )
                          ]
                        }
                      )
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ l.jsxs(Dz, { children: [
          /* @__PURE__ */ l.jsx(Ls, { children: /* @__PURE__ */ l.jsx(ld, { children: v }) }),
          /* @__PURE__ */ l.jsxs(
            od,
            {
              "data-mobile-menu": !0,
              direction: "top",
              className: he["sheet-content"],
              children: [
                /* @__PURE__ */ l.jsx(Ls, { children: /* @__PURE__ */ l.jsx(dd, { children: v }) }),
                /* @__PURE__ */ l.jsx(cd, { className: he["sheet-header"], children: /* @__PURE__ */ l.jsx(xe, { children: /* @__PURE__ */ l.jsxs(
                  Oi,
                  {
                    "data-testid": "global-navigation-mobile",
                    "aria-label": v,
                    className: z(
                      he["nav-menu"],
                      c && he.stuck,
                      o
                    ),
                    children: [
                      g && j === "transparent" && /* @__PURE__ */ l.jsx(
                        "a",
                        {
                          href: f,
                          title: p,
                          className: z(
                            he.logo,
                            he["logo-inverse"]
                          ),
                          children: g
                        }
                      ),
                      /* @__PURE__ */ l.jsx(
                        "a",
                        {
                          href: f,
                          title: p,
                          className: z(
                            he.logo,
                            he["logo-default"]
                          ),
                          children: h
                        }
                      ),
                      /* @__PURE__ */ l.jsx(
                        ol,
                        {
                          isMobileSheetOpen: t,
                          mobileMenuTriggerOpenLabel: m,
                          mobileMenuTriggerCloseLabel: b,
                          searchLabel: _,
                          mobileCallLink: M,
                          searchUrl: w,
                          featuredCtaButton: T,
                          setIsMobileSearchClicked: s
                        }
                      )
                    ]
                  }
                ) }) }),
                /* @__PURE__ */ l.jsx(
                  Pm,
                  {
                    navigationItems: x,
                    searchPlaceholder: C,
                    searchUrl: w,
                    searchLabel: _,
                    utilityNavigation: S,
                    isMobileSearchClicked: i,
                    setIsMobileSheetOpen: n
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ l.jsx(sd, { className: he["sheet-overlay"] })
        ] })
      ]
    }
  );
}, jm = (e) => {
  const { navigationItems: t, searchUrl: n, searchLabel: r, searchColor: a } = e;
  return /* @__PURE__ */ l.jsxs(
    a1,
    {
      className: z(he["nav-list"], he["nav-list-desktop"]),
      children: [
        t == null ? void 0 : t.map((i, s) => {
          const { color: o } = i;
          if (i.type === "dropdown") {
            const { title: c, links: d } = i;
            return /* @__PURE__ */ l.jsxs(
              qt,
              {
                value: `nav-item-${s}`,
                children: [
                  /* @__PURE__ */ l.jsx(
                    lc,
                    {
                      className: z(
                        he["nav-item-link"],
                        o ? he.color : "",
                        o ? he[o] : ""
                      ),
                      children: /* @__PURE__ */ l.jsx("span", { "data-text": c, children: c })
                    }
                  ),
                  /* @__PURE__ */ l.jsx(
                    dc,
                    {
                      className: he["nav-item-menu"],
                      children: d.map((u, f) => /* @__PURE__ */ l.jsx(
                        tr,
                        {
                          className: z(
                            he["nav-item-menu-link"]
                          ),
                          underline: "none",
                          asInherited: !0,
                          children: u.link
                        },
                        f
                      ))
                    }
                  )
                ]
              },
              `nav-item-${s}`
            );
          }
          return /* @__PURE__ */ l.jsx(qt, { children: /* @__PURE__ */ l.jsx(
            tr,
            {
              asInherited: !0,
              underline: "none",
              className: z(
                he["nav-item-link"],
                o ? he.color : "",
                o ? he[o] : ""
              ),
              children: i.link
            }
          ) }, s);
        }),
        n && /* @__PURE__ */ l.jsx(qt, { value: "nav-item-search", children: /* @__PURE__ */ l.jsxs(
          k2,
          {
            className: z(
              he["nav-item-link"],
              a ? he.color : "",
              a ? he[a] : ""
            ),
            children: [
              /* @__PURE__ */ l.jsx("span", { children: r }),
              /* @__PURE__ */ l.jsx(re, { icon: "magnifyingGlass" })
            ]
          }
        ) })
      ]
    }
  );
}, ol = (e) => {
  const {
    isMobileSheetOpen: t,
    searchUrl: n,
    searchLabel: r,
    mobileCallLink: a,
    mobileMenuTriggerOpenLabel: i,
    mobileMenuTriggerCloseLabel: s,
    featuredCtaButton: o,
    setIsMobileSearchClicked: c
  } = e;
  return /* @__PURE__ */ l.jsxs(
    a1,
    {
      className: z(he["nav-list"], he["nav-list-mobile"]),
      children: [
        o ? /* @__PURE__ */ l.jsx(qt, { children: /* @__PURE__ */ l.jsx(
          tr,
          {
            className: z(
              he["featured-cta"],
              Fo({
                variant: o.color
              })
            ),
            children: o.link
          }
        ) }) : a ? /* @__PURE__ */ l.jsx(qt, { children: /* @__PURE__ */ l.jsx(
          tr,
          {
            className: he["nav-item-link"],
            asInherited: !0,
            underline: "none",
            children: Te(a, {
              children: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                /* @__PURE__ */ l.jsx(
                  "span",
                  {
                    className: he["nav-item-link-text"],
                    children: a.props.children
                  }
                ),
                /* @__PURE__ */ l.jsx(
                  re,
                  {
                    icon: "phone",
                    flip: "horizontal"
                  }
                )
              ] })
            })
          }
        ) }) : n && /* @__PURE__ */ l.jsx(
          qt,
          {
            className: z(t && he.invisible),
            "aria-hidden": t ? "true" : "false",
            children: /* @__PURE__ */ l.jsxs(
              x2,
              {
                className: z(he["nav-item-link"]),
                onClick: () => c(!0),
                "aria-label": r,
                children: [
                  /* @__PURE__ */ l.jsx("span", { className: z(he["nav-item-link-text"]), children: r == null ? void 0 : r.toUpperCase() }),
                  /* @__PURE__ */ l.jsx(re, { icon: "magnifyingGlass" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ l.jsx(qt, { children: t ? /* @__PURE__ */ l.jsxs(
          Rz,
          {
            className: he["nav-item-link"],
            "aria-label": s,
            children: [
              /* @__PURE__ */ l.jsx(
                "span",
                {
                  className: z(he["nav-item-link-text"]),
                  "data-text": s,
                  children: s
                }
              ),
              /* @__PURE__ */ l.jsx(re, { icon: "xmark" })
            ]
          }
        ) : /* @__PURE__ */ l.jsxs(
          x2,
          {
            className: he["nav-item-link"],
            "aria-label": i,
            children: [
              /* @__PURE__ */ l.jsx(
                "span",
                {
                  className: z(he["nav-item-link-text"]),
                  "data-text": s,
                  children: i
                }
              ),
              /* @__PURE__ */ l.jsx(re, { icon: "bars" })
            ]
          }
        ) })
      ]
    }
  );
}, Pm = (e) => {
  const {
    navigationItems: t,
    searchPlaceholder: n,
    searchUrl: r,
    searchLabel: a,
    utilityNavigation: i,
    isMobileSearchClicked: s,
    setIsMobileSheetOpen: o
  } = e;
  return /* @__PURE__ */ l.jsxs("div", { className: he["mobile-menu"], children: [
    r && /* @__PURE__ */ l.jsx(xe, { backgroundColor: "whiteSmoke", children: /* @__PURE__ */ l.jsxs(
      "form",
      {
        action: r,
        className: he["mobile-search-form"],
        children: [
          /* @__PURE__ */ l.jsx(
            "input",
            {
              name: "q",
              type: "search",
              placeholder: n,
              autoFocus: s
            }
          ),
          /* @__PURE__ */ l.jsx(
            "button",
            {
              type: "submit",
              "aria-label": a,
              children: /* @__PURE__ */ l.jsx(re, { icon: "magnifyingGlass" })
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ l.jsx("div", { className: he["mobile-nav-items"], children: t == null ? void 0 : t.map((c, d) => {
      if (c.type === "dropdown")
        return /* @__PURE__ */ l.jsx(
          Ps,
          {
            type: "single",
            collapsible: !0,
            className: he["mobile-accordion"],
            children: /* @__PURE__ */ l.jsxs(
              i6,
              {
                value: c.title,
                className: he["mobile-accordion-item"],
                children: [
                  /* @__PURE__ */ l.jsx(
                    s6,
                    {
                      className: he["mobile-accordion-trigger"],
                      children: c.title
                    }
                  ),
                  /* @__PURE__ */ l.jsx(
                    Dv,
                    {
                      className: he["mobile-accordion-content"],
                      children: c.links.map((u, f) => /* @__PURE__ */ l.jsx(
                        X,
                        {
                          asInherited: !0,
                          className: he["mobile-link"],
                          onClick: () => {
                            o(!1);
                          },
                          children: u.mobileLink ?? u.link
                        },
                        f
                      ))
                    }
                  )
                ]
              }
            )
          },
          d
        );
      if (c.type === "link")
        return /* @__PURE__ */ l.jsx(
          X,
          {
            asInherited: !0,
            className: he["mobile-link"],
            onClick: () => {
              o(!1);
            },
            children: c.mobileLink ?? c.link
          },
          d
        );
    }) }),
    i && /* @__PURE__ */ l.jsx(xe, { backgroundColor: "whiteSmoke", children: /* @__PURE__ */ l.jsx(
      $8,
      {
        className: he["mobile-menu-utility"],
        ...i
      }
    ) })
  ] });
}, Ya = {
  "content-feed-for-health-news-card": "_content-feed-for-health-news-card_ohx1b_209",
  "hide-card-img": "_hide-card-img_ohx1b_221",
  "card-title-link": "_card-title-link_ohx1b_224",
  "card-excerpt": "_card-excerpt_ohx1b_230"
}, Am = (e) => {
  const {
    className: t,
    excerpt: n,
    headline: r,
    shouldHideImagesOnMobile: a,
    shouldHideSupportCopyOnCards: i,
    imageSrc: s,
    url: o,
    shouldLazyLoad: c = !1,
    ...d
  } = e;
  return /* @__PURE__ */ l.jsx(ur, { backgroundColor: "transparent", children: /* @__PURE__ */ l.jsxs(
    Bt,
    {
      elevation: "none",
      className: z(
        Ya["content-feed-for-health-news-card"],
        t
      ),
      "data-testid": "content-feed-for-health-news-card",
      ...d,
      children: [
        /* @__PURE__ */ l.jsx(
          "img",
          {
            className: z({
              [Ya["hide-card-img"]]: a
            }),
            "data-testid": "content-feed-for-health-news-card-image",
            src: s,
            alt: r,
            loading: c ? "lazy" : void 0
          }
        ),
        /* @__PURE__ */ l.jsx(
          X,
          {
            className: Ya["card-title-link"],
            "data-testid": "content-feed-for-health-news-card-link",
            fontStyle: "smLink",
            href: o,
            target: "_blank",
            children: r
          }
        ),
        !i && n && /* @__PURE__ */ l.jsx(
          le,
          {
            className: Ya["card-excerpt"],
            "data-testid": "content-feed-for-health-news-card-excerpt",
            children: /* @__PURE__ */ l.jsx(
              "p",
              {
                dangerouslySetInnerHTML: {
                  __html: n
                }
              }
            )
          }
        )
      ]
    }
  ) });
}, $m = "_headline_thazs_218", Im = "_image_thazs_238", Qe = {
  "with-shadow": "_with-shadow_thazs_209",
  "bottom-section": "_bottom-section_thazs_212",
  "copy-section": "_copy-section_thazs_215",
  headline: $m,
  "cta-content-card": "_cta-content-card_thazs_223",
  "bg-white": "_bg-white_thazs_229",
  "bg-transparent": "_bg-transparent_thazs_232",
  "image-container": "_image-container_thazs_238",
  image: Im,
  "cta-section": "_cta-section_thazs_259",
  "cta-section-center": "_cta-section-center_thazs_264",
  "cta-link": "_cta-link_thazs_264",
  "cta-section-left": "_cta-section-left_thazs_268",
  "cta-link-top": "_cta-link-top_thazs_272",
  "cta-link-bottom": "_cta-link-bottom_thazs_273",
  "cta-button": "_cta-button_thazs_279",
  "top-cta": "_top-cta_thazs_291"
}, Om = De("", {
  variants: {
    hasDropShadow: me({
      true: Qe["with-shadow"],
      false: ""
    }),
    ctaAlignment: me({
      center: Qe["cta-section-center"],
      left: Qe["cta-section-left"]
    })
  }
}), BE = (e) => {
  const {
    backgroundColor: t = "white",
    bodyCopy: n,
    className: r,
    ctaAlignment: a = "center",
    firstCta: i,
    firstCtaStyle: s = "button",
    headlineTag: o = "p",
    headline: c,
    image: d,
    secondCta: u,
    secondCtaStyle: f = "button",
    thirdCta: p,
    shouldLazyLoad: h = !1,
    ...g
  } = e;
  return /* @__PURE__ */ l.jsxs(
    Bt,
    {
      elevation: "none",
      "data-testid": "cta-content-card",
      className: z(
        Qe["cta-content-card"],
        {
          [Qe["bg-white"]]: t === "white",
          [Qe["bg-transparent"]]: t === "transparent"
        },
        r
      ),
      ...g,
      children: [
        d && /* @__PURE__ */ l.jsx("div", { className: Qe["image-container"], children: /* @__PURE__ */ l.jsx(
          yn,
          {
            ratio: "16:9",
            className: Qe.image,
            "data-testid": "cta-card-image",
            shouldLazyLoad: h,
            children: d
          }
        ) }),
        /* @__PURE__ */ l.jsxs("div", { className: Qe["bottom-section"], children: [
          /* @__PURE__ */ l.jsxs("div", { className: Qe["copy-section"], children: [
            c && /* @__PURE__ */ l.jsx(
              G,
              {
                tag: o,
                "data-testid": "cta-card-headline",
                className: Qe.headline,
                children: c
              }
            ),
            n && /* @__PURE__ */ l.jsx(le, { "data-testid": "cta-card-body-copy", children: n })
          ] }),
          /* @__PURE__ */ l.jsxs(
            "div",
            {
              className: z(
                Om({ ctaAlignment: a }),
                Qe["cta-section"]
              ),
              children: [
                i && (s === "button" ? /* @__PURE__ */ l.jsx(
                  X,
                  {
                    "data-testid": "content-card-first-cta",
                    size: "responsive",
                    variant: "solid1",
                    className: Qe["cta-button"],
                    children: i
                  }
                ) : /* @__PURE__ */ l.jsx(
                  X,
                  {
                    "data-testid": "content-card-first-cta",
                    className: Qe["cta-link-top"],
                    children: i
                  }
                )),
                u && (f === "button" ? /* @__PURE__ */ l.jsx(
                  X,
                  {
                    "data-testid": "content-card-second-cta",
                    size: "responsive",
                    variant: "solid1",
                    className: Qe["cta-button"],
                    children: u
                  }
                ) : /* @__PURE__ */ l.jsx(
                  X,
                  {
                    "data-testid": "content-card-second-cta",
                    className: Qe["cta-link-bottom"],
                    children: u
                  }
                )),
                p && /* @__PURE__ */ l.jsx(
                  X,
                  {
                    "data-testid": "content-card-third-cta",
                    className: Qe["cta-link"],
                    children: p
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}, Rm = "_headline_k8jge_229", ra = {
  "bordered-card": "_bordered-card_k8jge_209",
  "text-content": "_text-content_k8jge_221",
  headline: Rm,
  "cta-wrapper": "_cta-wrapper_k8jge_232"
}, Dm = (e) => {
  const {
    className: t,
    firstCTA: n,
    firstCTAStyle: r = "button",
    headline: a,
    icon: i,
    secondCTA: s,
    secondCTAStyle: o = "button",
    supportCopy: c,
    headlineTag: d = "h3",
    topColorBar: u = "none",
    reputationScheduleForm: f,
    ...p
  } = e;
  return /* @__PURE__ */ l.jsxs(
    Bt,
    {
      elevation: "elevation1",
      topColorBar: u,
      className: z(ra["bordered-card"], t),
      "data-testid": "icon-cta-bordered-card",
      ...p,
      children: [
        i && /* @__PURE__ */ l.jsx(re, { icon: i }),
        (a || c) && /* @__PURE__ */ l.jsxs("div", { className: ra["text-content"], children: [
          a && /* @__PURE__ */ l.jsx(
            G,
            {
              "data-testid": "icon-cta-bordered-card-headline",
              tag: d,
              className: ra.headline,
              children: a
            }
          ),
          c && /* @__PURE__ */ l.jsx(
            le,
            {
              "data-testid": "icon-cta-bordered-card-support-copy",
              className: ra["support-copy"],
              children: c
            }
          )
        ] }),
        f,
        (n || s) && /* @__PURE__ */ l.jsxs("div", { className: ra["cta-wrapper"], children: [
          n && /* @__PURE__ */ l.jsx(
            X,
            {
              "data-testid": "icon-cta-bordered-card-first-cta",
              variant: r === "button" ? "solid1" : void 0,
              size: "responsive",
              children: n
            }
          ),
          s && /* @__PURE__ */ l.jsx(
            X,
            {
              "data-testid": "icon-cta-bordered-card-second-cta",
              variant: o === "button" ? "solid1" : void 0,
              size: "responsive",
              children: s
            }
          )
        ] })
      ]
    }
  );
}, aa = {
  "icon-cta-simplified-card": "_icon-cta-simplified-card_117rt_209",
  "icon-cta-simplified-card-icon": "_icon-cta-simplified-card-icon_117rt_212",
  "icon-cta-simplified-card-headline": "_icon-cta-simplified-card-headline_117rt_220",
  "icon-cta-simplified-card-support-copy": "_icon-cta-simplified-card-support-copy_117rt_226",
  "icon-cta-simplified-card-anchor-wrapper": "_icon-cta-simplified-card-anchor-wrapper_117rt_229"
}, VE = (e) => {
  const {
    className: t,
    icon: n,
    supportCopy: r,
    cta: a,
    headline: i,
    headlineTag: s,
    ctaStyle: o = "button",
    ...c
  } = e;
  return /* @__PURE__ */ l.jsxs(
    Bt,
    {
      className: z(aa["icon-cta-simplified-card"], t),
      "data-testid": "icon-cta-simplified-card",
      elevation: "none",
      ...c,
      children: [
        n && /* @__PURE__ */ l.jsx("div", { className: aa["icon-cta-simplified-card-icon"], children: /* @__PURE__ */ l.jsx(
          re,
          {
            icon: n,
            "data-testid": "icon-cta-simplified-card-icon"
          }
        ) }),
        i && /* @__PURE__ */ l.jsx(
          G,
          {
            "data-testid": "icon-cta-simplified-card-headline",
            tag: s,
            className: aa["icon-cta-simplified-card-headline"],
            children: i
          }
        ),
        r && /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "icon-cta-simplified-card-support-copy",
            className: aa["icon-cta-simplified-card-support-copy"],
            children: r
          }
        ),
        a && /* @__PURE__ */ l.jsx(
          "div",
          {
            className: aa["icon-cta-simplified-card-anchor-wrapper"],
            children: /* @__PURE__ */ l.jsx(
              X,
              {
                size: "responsive",
                variant: o === "button" ? "solid1" : void 0,
                "data-testid": "icon-cta-simplified-card-link",
                children: a
              }
            )
          }
        )
      ]
    }
  );
}, cl = {
  "location-input": "_location-input_ei7df_2",
  "get-location-trigger": "_get-location-trigger_ei7df_5"
}, N3 = (e) => {
  const {
    getLocationTriggerTitle: t,
    googleMapsApiKey: n,
    isLoading: r,
    onSetIsLoading: a,
    onSetValue: i,
    onGetLocationError: s,
    onChange: o,
    ...c
  } = e, [d, u] = ne(!1);
  ve(() => {
    n && (async () => {
      a(!0), await cm(n), a(!1);
    })();
  }, [n, a]), ve(() => {
    (async () => {
      const h = await um();
      u(!h);
    })();
  }, []), ve(() => {
    (async () => {
      const h = await navigator.permissions.query({
        name: "geolocation"
      });
      h.onchange = () => {
        u(
          h.state !== "denied"
        );
      };
    })();
  }, []);
  const f = ft(async () => {
    try {
      a(!0);
      const { coords: p } = await om(), { zipCode: h } = await lm(p);
      i(h);
    } catch (p) {
      fm(p) ? p.code !== p.PERMISSION_DENIED && s() : console.error("Unexpected error:", p);
    } finally {
      a(!1);
    }
  }, [a, i, s]);
  return /* @__PURE__ */ l.jsx(
    En,
    {
      disabled: r,
      onChange: (p) => {
        i(p.target.value), o == null || o(p);
      },
      className: cl["location-input"],
      inlineButton: d && n && /* @__PURE__ */ l.jsx(
        "button",
        {
          title: t,
          type: "button",
          className: cl["get-location-trigger"],
          "data-testid": "get-precise-location-trigger",
          onClick: f,
          children: /* @__PURE__ */ l.jsx(re, { icon: "locationCrosshairs" })
        }
      ),
      ...c
    }
  );
}, Fm = "_headline_vaw7s_218", Ka = {
  "left-aligned-card": "_left-aligned-card_vaw7s_209",
  headline: Fm,
  "card-cta": "_card-cta_vaw7s_221"
}, HE = (e) => {
  const {
    cardCTA: t,
    className: n,
    headline: r,
    icon: a,
    supportCopy: i,
    headlineTag: s = "p",
    ...o
  } = e;
  return /* @__PURE__ */ l.jsxs(
    Bt,
    {
      elevation: "none",
      className: z(Ka["left-aligned-card"], n),
      "data-testid": "icon-cta-left-aligned-card",
      ...o,
      children: [
        a && /* @__PURE__ */ l.jsx(re, { icon: a }),
        r && /* @__PURE__ */ l.jsx(
          G,
          {
            "data-testid": "icon-cta-left-aligned-card-headline",
            tag: s,
            className: Ka.headline,
            children: r
          }
        ),
        i && /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "icon-cta-left-aligned-card-support-copy",
            className: Ka["support-copy"],
            children: i
          }
        ),
        t && /* @__PURE__ */ l.jsx(
          X,
          {
            "data-testid": "icon-cta-left-aligned-card-card-cta",
            className: Ka["card-cta"],
            size: "responsive",
            children: t
          }
        )
      ]
    }
  );
}, Bm = "_headline_l2rjo_218", Vm = "_icon_l2rjo_209", Cr = {
  "icon-cta": "_icon-cta_l2rjo_209",
  headline: Bm,
  icon: Vm,
  "content-container": "_content-container_l2rjo_229",
  "icon-anchor": "_icon-anchor_l2rjo_234",
  "support-copy": "_support-copy_l2rjo_244"
}, qE = (e) => {
  const {
    icon: t,
    headline: n,
    headlineTag: r = "p",
    supportCopy: a,
    cardCTA: i,
    className: s,
    ...o
  } = e, c = /* @__PURE__ */ l.jsxs(
    Bt,
    {
      elevation: "none",
      className: z(Cr["icon-cta"], s),
      "data-testid": "icon-cta-card",
      ...o,
      children: [
        t && /* @__PURE__ */ l.jsx(
          re,
          {
            className: Cr.icon,
            icon: t,
            "data-testid": "icon-cta-icon"
          }
        ),
        /* @__PURE__ */ l.jsxs("div", { className: Cr["content-container"], children: [
          n && /* @__PURE__ */ l.jsx(
            G,
            {
              tag: r,
              className: Cr.headline,
              "data-testid": "icon-cta-headline",
              children: n
            }
          ),
          a && /* @__PURE__ */ l.jsx(
            le,
            {
              className: Cr["support-copy"],
              "data-testid": "icon-cta-support-copy",
              children: a
            }
          )
        ] })
      ]
    }
  );
  return i ? /* @__PURE__ */ l.jsx(X, { className: Cr["icon-anchor"], children: Te(i, {
    children: c,
    "data-testid": "icon-cta-anchor"
  }) }) : c;
}, Hm = "_heading_ozpme_212", qm = "_button_ozpme_251", et = {
  "reverse-row-base": "_reverse-row-base_ozpme_209",
  heading: Hm,
  "copy-column": "_copy-column_ozpme_218",
  "content-center-align": "_content-center-align_ozpme_224",
  "content-top-align": "_content-top-align_ozpme_227",
  "anchor-links": "_anchor-links_ozpme_230",
  "supporting-copy": "_supporting-copy_ozpme_234",
  "reverse-row-card": "_reverse-row-card_ozpme_237",
  "call-to-action-container": "_call-to-action-container_ozpme_240",
  "call-to-action-div": "_call-to-action-div_ozpme_243",
  button: qm,
  "media-side-padding": "_media-side-padding_ozpme_256",
  "media-container-right": "_media-container-right_ozpme_256",
  "media-container-left": "_media-container-left_ozpme_262",
  "copy-column-reverse": "_copy-column-reverse_ozpme_268"
}, Wm = De(et["reverse-row-base"], {
  variants: {
    contentAlignment: me({
      center: et["content-center-align"],
      top: et["content-top-align"]
    })
  }
}), WE = (e) => {
  const {
    className: t,
    contentAlignment: n = "top",
    ctaStyle: r,
    firstCta: a,
    headline: i,
    headlineTag: s = "h2",
    image: o,
    mediaSide: c = "left",
    secondCta: d,
    supportingCopy: u,
    videoId: f,
    shouldLazyLoad: p = !1,
    ...h
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      "data-testid": "reverse-row-base",
      className: z(et["reverse-row-base"], t),
      ...h,
      children: /* @__PURE__ */ l.jsxs(
        rt,
        {
          className: et["reverse-row-card"],
          reverse: c === "left" ? "tablet" : void 0,
          children: [
            /* @__PURE__ */ l.jsxs(
              Rn,
              {
                span: "4",
                spanTabletLg: "6",
                className: z(
                  et["copy-column"],
                  c === "right" && et["copy-column-reverse"],
                  Wm({ contentAlignment: n })
                ),
                children: [
                  /* @__PURE__ */ l.jsxs("div", { className: et["copy-container"], children: [
                    /* @__PURE__ */ l.jsx(
                      G,
                      {
                        tag: s,
                        "data-testid": "reverse-row-heading",
                        className: et.heading,
                        children: i
                      }
                    ),
                    u && /* @__PURE__ */ l.jsx(
                      le,
                      {
                        "data-testid": "reverse-row-supporting-copy",
                        className: et["supporting-copy"],
                        children: u
                      }
                    )
                  ] }),
                  r === "button" ? /* @__PURE__ */ l.jsxs("div", { className: et["call-to-action-div"], children: [
                    a && /* @__PURE__ */ l.jsx(
                      X,
                      {
                        "data-testid": "reverse-row-first-cta",
                        size: "responsive",
                        variant: "solid1",
                        className: et.button,
                        children: a
                      }
                    ),
                    d && /* @__PURE__ */ l.jsx(
                      X,
                      {
                        "data-testid": "reverse-row-second-cta",
                        size: "responsive",
                        variant: "solid1",
                        className: et.button,
                        children: d
                      }
                    )
                  ] }) : /* @__PURE__ */ l.jsxs("div", { className: et["anchor-links"], children: [
                    a && /* @__PURE__ */ l.jsx(X, { "data-testid": "reverse-row-first-cta", children: a }),
                    d && /* @__PURE__ */ l.jsx(X, { "data-testid": "reverse-row-second-cta", children: d })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ l.jsxs(
              Rn,
              {
                span: "4",
                spanTabletLg: "6",
                className: c === "left" ? et["media-container-left"] : et["media-container-right"],
                children: [
                  o && !f && /* @__PURE__ */ l.jsx(
                    yn,
                    {
                      ratio: "8:5",
                      "data-testid": "reverse-row-image",
                      shouldLazyLoad: p,
                      children: o
                    }
                  ),
                  f && /* @__PURE__ */ l.jsx(
                    o1,
                    {
                      "data-testid": "reverse-row-youtube-embed",
                      videoId: f
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}, Um = "_prefix_1m94r_214", Gm = "_statistic_1m94r_213", Ym = "_suffix_1m94r_216", qn = {
  "list-item": "_list-item_1m94r_209",
  "statistics-block": "_statistics-block_1m94r_213",
  prefix: Um,
  statistic: Gm,
  suffix: Ym,
  "support-copy": "_support-copy_1m94r_222",
  "list-item-color-default": "_list-item-color-default_1m94r_243"
}, UE = (e) => {
  const { className: t, statistic: n, prefix: r, suffix: a, supportCopy: i, ...s } = e, o = Et(Hn), c = hr(o);
  return /* @__PURE__ */ l.jsxs(
    "li",
    {
      "data-testid": "side-statistics-item",
      className: z(
        qn["list-item"],
        { [qn["list-item-color-default"]]: !c },
        t
      ),
      ...s,
      children: [
        /* @__PURE__ */ l.jsxs("div", { className: qn["statistics-block"], children: [
          r && /* @__PURE__ */ l.jsx(
            G,
            {
              "data-testid": "side-statistics-item-prefix",
              tag: "span",
              className: qn.prefix,
              children: r
            }
          ),
          /* @__PURE__ */ l.jsx(
            G,
            {
              "data-testid": "side-statistics-item-statistic",
              tag: "span",
              className: qn.statistic,
              children: n
            }
          ),
          a && /* @__PURE__ */ l.jsx(
            G,
            {
              "data-testid": "side-statistics-item-suffix",
              tag: "span",
              className: qn.suffix,
              children: a
            }
          )
        ] }),
        /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "side-statistics-item-support-copy",
            className: qn["support-copy"],
            children: i
          }
        )
      ]
    }
  );
}, Km = "_item_1ww7g_209", Xm = "_prefix_1ww7g_230", Zm = "_statistic_1ww7g_219", Qm = "_suffix_1ww7g_232", Pt = {
  item: Km,
  "top-text": "_top-text_1ww7g_216",
  "statistic-span": "_statistic-span_1ww7g_219",
  "bottom-text": "_bottom-text_1ww7g_224",
  prefix: Xm,
  statistic: Zm,
  suffix: Qm,
  "superscript-suffix": "_superscript-suffix_1ww7g_236",
  "item-stacked-mobile": "_item-stacked-mobile_1ww7g_242",
  "item-color-default": "_item-color-default_1ww7g_252",
  "item-stacked-desktop": "_item-stacked-desktop_1ww7g_284"
}, ll = " ", GE = (e) => {
  const {
    className: t,
    topText: n,
    prefix: r,
    statisticsNumber: a,
    suffix: i,
    superscriptSuffix: s,
    bottomText: o,
    ...c
  } = e, d = Et(Hn), u = hr(d), { isStackedMobile: f, isStackedDesktop: p } = Et(
    G3
  );
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: z(
        Pt.item,
        {
          [Pt["item-color-default"]]: !u,
          [Pt["item-stacked-mobile"]]: f,
          [Pt["item-stacked-desktop"]]: p
        },
        t
      ),
      "data-testid": "hero-statistics-item",
      ...c,
      children: [
        /* @__PURE__ */ l.jsx(
          G,
          {
            "data-testid": "hero-statistics-item-top-text",
            tag: "span",
            className: Pt["top-text"],
            children: n ?? ll
          }
        ),
        /* @__PURE__ */ l.jsxs("span", { className: Pt["statistic-span"], children: [
          r && /* @__PURE__ */ l.jsx(
            G,
            {
              "data-testid": "hero-statistics-item-prefix",
              tag: "span",
              className: Pt.prefix,
              children: r
            }
          ),
          /* @__PURE__ */ l.jsxs(
            G,
            {
              "data-testid": "hero-statistics-item-statistics-number",
              tag: "span",
              className: Pt.statistic,
              children: [
                a,
                s && /* @__PURE__ */ l.jsx(
                  G,
                  {
                    "data-testid": "hero-statistics-item-superscript-suffix",
                    tag: "sup",
                    className: Pt["superscript-suffix"],
                    children: s
                  }
                )
              ]
            }
          ),
          i && /* @__PURE__ */ l.jsx(
            G,
            {
              "data-testid": "hero-statistics-item-suffix",
              tag: "span",
              className: Pt.suffix,
              children: i
            }
          )
        ] }),
        /* @__PURE__ */ l.jsx(
          G,
          {
            "data-testid": "hero-statistics-item-bottom-text",
            tag: "span",
            className: Pt["bottom-text"],
            children: o ?? ll
          }
        )
      ]
    }
  );
}, Kt = {
  "media-with-caption-base": "_media-with-caption-base_piafy_209",
  "image-border": "_image-border_piafy_217",
  "image-link": "_image-link_piafy_220",
  "media-left": "_media-left_piafy_241",
  "media-right": "_media-right_piafy_245",
  "media-size-20": "_media-size-20_piafy_249",
  "media-size-30": "_media-size-30_piafy_252",
  "media-size-40": "_media-size-40_piafy_255",
  "media-size-50": "_media-size-50_piafy_258"
}, z3 = (e) => {
  const {
    className: t,
    image: n,
    imageCaption: r,
    imageContainerSize: a,
    imageCtaLink: i,
    imageSide: s,
    isActive: o,
    isImageBorderOn: c = !1,
    onReady: d,
    videoId: u,
    shouldLazyLoad: f = !1,
    ...p
  } = e, h = mr(n, f);
  return /* @__PURE__ */ l.jsxs(
    "figure",
    {
      "data-testid": "media-with-caption",
      className: z(
        Kt["media-with-caption-base"],
        {
          [Kt["media-left"]]: s === "left",
          [Kt["media-right"]]: s === "right",
          [Kt["image-border"]]: c,
          [Kt["media-size-20"]]: a === "twenty",
          [Kt["media-size-30"]]: a === "thirty",
          [Kt["media-size-40"]]: a === "forty",
          [Kt["media-size-50"]]: a === "fifty"
        },
        t
      ),
      ...p,
      children: [
        h ? i ? /* @__PURE__ */ l.jsx(
          X,
          {
            className: Kt["image-link"],
            "data-testid": "media-with-caption-image-link",
            children: Te(i, {
              children: h
            })
          }
        ) : h : u && /* @__PURE__ */ l.jsx(
          o1,
          {
            "data-testid": "media-with-caption-video",
            videoId: u,
            onReady: d,
            isActive: o
          }
        ),
        r && /* @__PURE__ */ l.jsx(
          le,
          {
            as: "figcaption",
            "data-testid": "media-with-caption-caption",
            children: r
          }
        )
      ]
    }
  );
}, Jm = "_alert_6wxb9_209", _t = {
  alert: Jm,
  "alert-icon": "_alert-icon_6wxb9_215",
  "alert-primary-text": "_alert-primary-text_6wxb9_221",
  "alert-mobile-text": "_alert-mobile-text_6wxb9_222",
  "alert-trigger": "_alert-trigger_6wxb9_228",
  "trigger-icon": "_trigger-icon_6wxb9_237",
  "trigger-open": "_trigger-open_6wxb9_241",
  "trigger-close": "_trigger-close_6wxb9_242",
  "trigger-text": "_trigger-text_6wxb9_252",
  "alert-expanded-text": "_alert-expanded-text_6wxb9_255"
}, e9 = (e) => {
  const {
    className: t,
    primaryAlertText: n,
    expandedAlertText: r,
    mobileAlertText: a,
    alertType: i = "info",
    shouldHideIcon: s = !1,
    showMoreLabel: o = "Show More",
    showLessLabel: c = "Show Less",
    ...d
  } = e;
  return /* @__PURE__ */ l.jsx(
    Fr,
    {
      type: "single",
      collapsible: !0,
      children: /* @__PURE__ */ l.jsx(
        xe,
        {
          backgroundColor: Y3[i],
          ...d,
          children: /* @__PURE__ */ l.jsxs(
            mo,
            {
              value: "alert",
              "data-testid": "alert-expandable",
              className: z(_t.alert, t),
              ...d,
              children: [
                !s && /* @__PURE__ */ l.jsx(
                  re,
                  {
                    "data-testid": "alert-icon",
                    className: _t["alert-icon"],
                    icon: K3[i]
                  }
                ),
                a && /* @__PURE__ */ l.jsx(
                  le,
                  {
                    "data-testid": "alert-mobile-text",
                    className: _t["alert-mobile-text"],
                    children: a
                  }
                ),
                /* @__PURE__ */ l.jsx(
                  le,
                  {
                    "data-testid": "alert-primary-text",
                    className: _t["alert-primary-text"],
                    children: n
                  }
                ),
                /* @__PURE__ */ l.jsxs(
                  fr,
                  {
                    "data-testid": "alert-trigger",
                    className: _t["alert-trigger"],
                    children: [
                      /* @__PURE__ */ l.jsxs(
                        "span",
                        {
                          "data-testid": "trigger-open",
                          className: _t["trigger-open"],
                          children: [
                            /* @__PURE__ */ l.jsx("span", { className: _t["trigger-text"], children: o }),
                            /* @__PURE__ */ l.jsx(
                              re,
                              {
                                className: _t["trigger-icon"],
                                icon: "plus"
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ l.jsxs(
                        "span",
                        {
                          "data-testid": "trigger-close",
                          className: _t["trigger-close"],
                          children: [
                            /* @__PURE__ */ l.jsx("span", { className: _t["trigger-text"], children: c }),
                            /* @__PURE__ */ l.jsx(
                              re,
                              {
                                className: _t["trigger-icon"],
                                icon: "minus"
                              }
                            )
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ l.jsx(
                  Ur,
                  {
                    "data-testid": "alert-expanded-text",
                    className: _t["alert-expanded-text"],
                    children: /* @__PURE__ */ l.jsx(le, { children: r })
                  }
                )
              ]
            }
          )
        }
      )
    }
  );
}, t9 = "_alert_eqa42_209", Sr = {
  alert: t9,
  "alert-dismiss-button": "_alert-dismiss-button_eqa42_215",
  "alert-icon": "_alert-icon_eqa42_226",
  "alert-primary-text": "_alert-primary-text_eqa42_232",
  "alert-mobile-text": "_alert-mobile-text_eqa42_233"
}, n9 = (e) => {
  const {
    className: t,
    primaryAlertText: n,
    mobileAlertText: r,
    alertType: a = "info",
    isDismissible: i = !0,
    shouldHideIcon: s = !1,
    isDismissed: o,
    dismissButtonTitle: c = "Dismiss",
    onDismiss: d,
    ...u
  } = e, [f, p] = ne(
    o ?? !1
  ), h = () => {
    p(!0), d == null || d();
  };
  return f ? null : /* @__PURE__ */ l.jsx(
    xe,
    {
      className: z(Sr.container, t),
      "data-testid": "alert-dismissible",
      backgroundColor: Y3[a],
      ...u,
      children: /* @__PURE__ */ l.jsxs("div", { className: Sr.alert, children: [
        i && /* @__PURE__ */ l.jsx(
          "button",
          {
            type: "button",
            title: c,
            "data-testid": "alert-dismiss-button",
            className: Sr["alert-dismiss-button"],
            onClick: h,
            children: /* @__PURE__ */ l.jsx(re, { icon: "xmark" })
          }
        ),
        !s && /* @__PURE__ */ l.jsx(
          re,
          {
            "data-testid": "alert-icon",
            className: Sr["alert-icon"],
            icon: K3[a]
          }
        ),
        r && /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "alert-mobile-text",
            className: Sr["alert-mobile-text"],
            children: r
          }
        ),
        /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "alert-primary-text",
            className: Sr["alert-primary-text"],
            children: n
          }
        )
      ] })
    }
  );
}, Fe = {
  "location-card-container": "_location-card-container_vld8e_209",
  "location-card": "_location-card_vld8e_209",
  "location-image": "_location-image_vld8e_217",
  "location-emergency-phone": "_location-emergency-phone_vld8e_221",
  "location-phone-link": "_location-phone-link_vld8e_226",
  "location-card-email": "_location-card-email_vld8e_229",
  "location-card-content": "_location-card-content_vld8e_232",
  "location-card-icon": "_location-card-icon_vld8e_238",
  "location-card-cta": "_location-card-cta_vld8e_243",
  "cta-button": "_cta-button_vld8e_249",
  "location-name": "_location-name_vld8e_254",
  "location-card-image-wrapper": "_location-card-image-wrapper_vld8e_263",
  "overlay-container": "_overlay-container_vld8e_266",
  "location-card-address-info": "_location-card-address-info_vld8e_286",
  "children-image": "_children-image_vld8e_291"
}, YE = (e) => {
  const {
    location: t,
    firstCta: n,
    secondCta: r,
    shouldDisplayImageOverlay: a,
    animalIcon: i,
    firstCtaStyle: s = "solid",
    secondCtaStyle: o = "link",
    threeSixtyImage: c,
    emergencyPhoneLabel: d,
    className: u,
    shouldLazyLoad: f = !1,
    ...p
  } = e, h = M3(t), g = ({ children: x }) => t.locationTour ? /* @__PURE__ */ l.jsx(
    X,
    {
      className: Fe["image-link"],
      "data-testid": "location-card-image-link",
      children: Te(t.locationTour, {
        children: x
      })
    }
  ) : x, v = mr(
    t.image,
    f
  );
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      "data-testid": "location-card-container",
      className: z(Fe["location-card-container"], u),
      children: [
        i && /* @__PURE__ */ l.jsx(
          "div",
          {
            "data-testid": "location-card-children-image",
            className: Fe["children-image"],
            children: i
          }
        ),
        /* @__PURE__ */ l.jsx(ur, { backgroundColor: "white", children: /* @__PURE__ */ l.jsxs(
          Bt,
          {
            elevation: "elevation1",
            className: Fe["location-card"],
            "data-testid": "location-card-card",
            ...p,
            children: [
              v && /* @__PURE__ */ l.jsx(g, { children: /* @__PURE__ */ l.jsxs(
                "div",
                {
                  "data-testid": "location-card-image-wrapper",
                  className: Fe["location-card-image-wrapper"],
                  children: [
                    /* @__PURE__ */ l.jsx(lt, { className: Fe["location-image"], children: v }),
                    a && (t == null ? void 0 : t.locationTour) && /* @__PURE__ */ l.jsx(
                      "div",
                      {
                        "data-testid": "location-card-overlay-container",
                        className: Fe["overlay-container"],
                        children: c
                      }
                    )
                  ]
                }
              ) }),
              /* @__PURE__ */ l.jsxs("div", { className: Fe["location-card-content"], children: [
                /* @__PURE__ */ l.jsx(
                  G,
                  {
                    "data-testid": "location-card-name",
                    className: Fe["location-name"],
                    children: t.locationName
                  }
                ),
                /* @__PURE__ */ l.jsxs("div", { className: Fe["location-card-address-info"], children: [
                  /* @__PURE__ */ l.jsx(
                    re,
                    {
                      className: Fe["location-card-icon"],
                      icon: "locationDot"
                    }
                  ),
                  /* @__PURE__ */ l.jsx(
                    wd,
                    {
                      href: h,
                      target: "_blank",
                      "data-testid": "location-card-address-link",
                      location: t
                    }
                  )
                ] }),
                (t.defaultPhone || t.emergencyPhone) && /* @__PURE__ */ l.jsxs(
                  "div",
                  {
                    "data-testid": "location-card-phone-links",
                    className: Fe["location-card-address-info"],
                    children: [
                      /* @__PURE__ */ l.jsx(
                        re,
                        {
                          className: Fe["location-card-icon"],
                          icon: "phone"
                        }
                      ),
                      /* @__PURE__ */ l.jsxs("div", { children: [
                        t.defaultPhone && /* @__PURE__ */ l.jsx(
                          X,
                          {
                            "data-testid": "location-card-default-phone",
                            href: `tel:${t.defaultPhone}`,
                            className: Fe["location-phone-link"],
                            children: t.defaultPhone
                          }
                        ),
                        t.emergencyPhone && /* @__PURE__ */ l.jsxs(
                          "div",
                          {
                            "data-testid": "location-card-emergency-phone",
                            className: Fe["location-emergency-phone"],
                            children: [
                              /* @__PURE__ */ l.jsx(
                                X,
                                {
                                  href: `tel:${t.emergencyPhone}`,
                                  className: Fe["location-phone-link"],
                                  children: t.emergencyPhone
                                }
                              ),
                              d && /* @__PURE__ */ l.jsx(
                                G,
                                {
                                  className: Fe["emergency-phone-label"],
                                  children: d
                                }
                              )
                            ]
                          }
                        )
                      ] })
                    ]
                  }
                ),
                t.email && /* @__PURE__ */ l.jsxs(
                  "div",
                  {
                    "data-testid": "location-card-email",
                    className: Fe["location-card-address-info"],
                    children: [
                      /* @__PURE__ */ l.jsx(
                        re,
                        {
                          className: Fe["location-card-icon"],
                          icon: "envelope"
                        }
                      ),
                      /* @__PURE__ */ l.jsx(
                        X,
                        {
                          className: Fe["location-card-email"],
                          href: `mailto:${t.email}`,
                          children: t.email
                        }
                      )
                    ]
                  }
                ),
                (n || r) && /* @__PURE__ */ l.jsxs(
                  "div",
                  {
                    "data-testid": "location-card-ctas",
                    className: Fe["location-card-cta"],
                    children: [
                      n && /* @__PURE__ */ l.jsx(
                        X,
                        {
                          "data-testid": "location-card-first-cta",
                          className: Fe["cta-button"],
                          size: "responsive",
                          buttonStyle: s,
                          children: n
                        }
                      ),
                      r && /* @__PURE__ */ l.jsx(
                        X,
                        {
                          "data-testid": "location-card-second-cta",
                          className: Fe["cta-button"],
                          size: "responsive",
                          buttonStyle: o,
                          children: r
                        }
                      )
                    ]
                  }
                )
              ] })
            ]
          }
        ) })
      ]
    }
  );
}, M1 = {
  "reputation-schedule-cta-search-form": "_reputation-schedule-cta-search-form_mnt2d_209"
}, KE = (e) => {
  const {
    buttonText: t = "Schedule online",
    errorMessage: n = "Enter city, state and/or ZIP is required",
    filterType: r = "specialties",
    filterText: a,
    headline: i,
    headlineTag: s = "p",
    icon: o,
    placeholderText: c,
    searchLabel: d,
    searchType: u = "Doctor",
    searchUrl: f,
    supportCopy: p,
    topColorBar: h,
    ...g
  } = e;
  return /* @__PURE__ */ l.jsx(
    Dm,
    {
      headline: i,
      headlineTag: s,
      icon: o,
      supportCopy: p,
      topColorBar: h,
      reputationScheduleForm: /* @__PURE__ */ l.jsx(
        r9,
        {
          buttonText: t,
          errorMessage: n,
          filterType: r,
          filterText: a,
          placeholderText: c,
          searchLabel: d,
          searchType: u,
          searchUrl: f
        }
      ),
      ...g
    }
  );
}, r9 = (e) => {
  const {
    buttonText: t,
    errorMessage: n,
    filterType: r,
    filterText: a,
    placeholderText: i,
    searchLabel: s,
    searchType: o,
    searchUrl: c
  } = e, d = pe(null), [u, f] = ne(!1), p = (h) => {
    var m, b;
    h.preventDefault();
    const g = (b = (m = d.current) == null ? void 0 : m.value) == null ? void 0 : b.trim();
    if (!g) {
      f(!0);
      return;
    }
    f(!1);
    const v = new URLSearchParams();
    v.append("s-autosearch", "true"), v.append("s-address", g), v.append("s-filter", `${r}:${a}`), o === "Doctor" && v.append("s-defaultsearchtype", "address");
    const x = v.toString().replaceAll("+", "%20").replaceAll("%3A", ":");
    window.location.href = `${c}?${x}`;
  };
  return /* @__PURE__ */ l.jsxs(
    "form",
    {
      "data-testid": "reputation-schedule-cta-search-form",
      className: M1["reputation-schedule-cta-search-form"],
      onSubmit: p,
      children: [
        /* @__PURE__ */ l.jsx(
          En,
          {
            ariaRequired: "true",
            "data-testid": "reputation-schedule-cta-search-input",
            className: M1["reputation-schedule-cta-search-input"],
            ref: d,
            type: "text",
            placeholder: i,
            errorMessage: n,
            errorMessageId: "reputation-schedule-cta-error-message",
            label: s,
            inputId: "reputation-schedule-cta-search-input",
            name: "reputation-schedule-cta-search-input",
            hasError: u,
            setHasError: f
          }
        ),
        /* @__PURE__ */ l.jsx(
          vn,
          {
            variant: "solid1",
            size: "responsive",
            type: "submit",
            "data-testid": "reputation-schedule-cta-search-button",
            className: M1["reputation-schedule-cta-search-button"],
            children: t
          }
        )
      ]
    }
  );
}, a9 = {
  "find-a-doctor-base": "_find-a-doctor-base_19d3u_209"
}, XE = (e) => {
  const {
    className: t,
    doctorNameInvalidErrorMessage: n,
    doctorNameRequiredErrorMessage: r,
    doctorsNameInputPlaceholder: a,
    filterType: i,
    getPreciseLocationTriggerTitle: s,
    googleMapsAPIKey: o = "",
    legendLabel: c,
    locationInputPlaceholder: d,
    locationInvalidErrorMessage: u,
    locationRequiredErrorMessage: f,
    searchAPIErrorMessage: p,
    searchUrl: h,
    specialtyItems: g,
    specialtySelectLabel: v,
    submitButtonTitle: x,
    ...m
  } = e, [b, _] = ne(!1), [C, w] = ne(""), [N, M] = ne(""), [S, T] = ne(null), [j, D] = ne(""), [A, k] = ne(null), $ = !!S || !!A, R = !!C && !!N, F = !!j, P = !!N, I = !C && !N && !j, O = I || b || !(!$ && (R || F || P)), W = (ee) => {
    ee.preventDefault(), _(() => !0), k(() => null), T(() => null);
    let ae = !0;
    if (I && (T(() => f), k(() => r), ae = !1), j && !Ms(j) && (k(() => n), ae = !1), N && !Ms(N) && (T(() => u), ae = !1), C && !N && (T(() => f), ae = !1), !ae) {
      _(() => !1);
      return;
    }
    const ie = new URLSearchParams();
    ie.append("s-autosearch", "true"), ie.append("s-address", N.trim()), ie.append("s-filter", `${i}:${C.trim()}`), ie.append(
      "s-defaultsearchtype",
      j ? "name" : "address"
    ), ie.append("s-name", j.trim());
    const U = ie.toString().replaceAll("+", "%20").replaceAll("%3A", ":");
    window.location.href = `${h}?${U}`, _(() => !1);
  }, se = zt(() => {
    const ee = [];
    return ee.push(
      /* @__PURE__ */ l.jsx(w2, { children: /* @__PURE__ */ l.jsx(Ma, { value: "select-a-specialty", children: v }) }, "select-a-specialty")
    ), Object.entries(g).forEach(([ae, ie]) => {
      const U = ie.map((J) => {
        const fe = `${ae}_${J}`;
        return /* @__PURE__ */ l.jsx(
          Ma,
          {
            value: fe,
            children: J
          },
          fe
        );
      });
      ee.push(
        /* @__PURE__ */ l.jsxs(w2, { children: [
          /* @__PURE__ */ l.jsx(xd, { children: ae }),
          U
        ] }, ae)
      );
    }), ee;
  }, [g, v]), ue = (ee) => {
    if (ee === "select-a-specialty") {
      w("");
      return;
    }
    const ae = ee.split("_");
    w(ae[1]);
  };
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: z(a9["find-a-doctor-base"], t),
      "data-testid": "find-a-doctor",
      onSubmit: W,
      tag: "form",
      ...m,
      children: /* @__PURE__ */ l.jsxs("fieldset", { disabled: b, children: [
        /* @__PURE__ */ l.jsx("legend", { children: c }),
        /* @__PURE__ */ l.jsx(
          _d,
          {
            ariaLabel: v,
            ariaRequired: "false",
            children: se,
            inputId: `${v}-input-id`,
            onValueChange: ue,
            placeholder: v
          }
        ),
        /* @__PURE__ */ l.jsx(
          N3,
          {
            ariaRequired: C ? "true" : "false",
            errorMessage: S,
            errorMessageId: "find-a-doctor-location-error",
            getLocationTriggerTitle: s,
            googleMapsApiKey: o,
            hasError: !!S,
            inputId: "find-a-doctor-location",
            isLoading: b,
            onChange: () => {
              S && T(null);
            },
            onFocus: () => T(null),
            onGetLocationError: () => {
              T(p);
            },
            onSetIsLoading: _,
            onSetValue: M,
            placeholder: d,
            value: N
          }
        ),
        /* @__PURE__ */ l.jsx(
          En,
          {
            ariaRequired: "true",
            errorMessage: A,
            errorMessageId: `${a}-error`,
            hasError: A !== null,
            inputId: `${a}-input-id`,
            onChange: (ee) => {
              D(ee.target.value), A && k(null);
            },
            placeholder: a,
            onFocus: () => {
              k(null);
            },
            value: j
          }
        ),
        /* @__PURE__ */ l.jsxs(
          vn,
          {
            disabled: O,
            size: "responsive",
            title: x,
            type: "submit",
            variant: "solid1",
            children: [
              /* @__PURE__ */ l.jsx(re, { icon: "magnifyingGlass" }),
              /* @__PURE__ */ l.jsx("span", { children: x })
            ]
          }
        )
      ] })
    }
  );
}, i9 = {
  "find-a-location-base": "_find-a-location-base_1i2lm_209"
}, ZE = (e) => {
  const {
    className: t,
    filterType: n,
    getPreciseLocationTriggerTitle: r,
    googleMapsAPIKey: a = "",
    legendLabel: i,
    locationInputPlaceholder: s,
    locationInvalidErrorMessage: o,
    locationRequiredErrorMessage: c,
    locationTypeItems: d,
    locationTypeLabel: u,
    searchAPIErrorMessage: f,
    searchUrl: p,
    submitButtonTitle: h,
    ...g
  } = e, [v, x] = ne(!1), [m, b] = ne(""), [_, C] = ne(""), [w, N] = ne(null), A = !m && !_ || v || !(!!!w && (!!m && !!_ || !!_)), k = (R) => {
    R.preventDefault(), x(() => !0), N(() => null);
    let F = !0;
    if (_ || (N(() => c), F = !1), _ && !Ms(_) && (N(() => o), F = !1), !F) {
      x(() => !1);
      return;
    }
    const P = new URLSearchParams();
    P.append("s-autosearch", "true"), P.append("s-filter", `${n}:${m.trim()}`), P.append("s-address", _.trim());
    const I = P.toString().replaceAll("+", "%20").replaceAll("%3A", ":");
    window.location.href = `${p}?${I}`, x(() => !1);
  }, $ = zt(() => {
    const R = [
      /* @__PURE__ */ l.jsx(
        Ma,
        {
          value: "select-a-location-type",
          children: u
        },
        "select-a-location-type"
      )
    ], F = d.map((P) => /* @__PURE__ */ l.jsx(
      Ma,
      {
        value: P,
        children: P
      },
      P
    ));
    return R.concat(F);
  }, [d, u]);
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: z(i9["find-a-location-base"], t),
      "data-testid": "find-a-location",
      onSubmit: k,
      tag: "form",
      ...g,
      children: /* @__PURE__ */ l.jsxs("fieldset", { disabled: v, children: [
        /* @__PURE__ */ l.jsx("legend", { children: i }),
        /* @__PURE__ */ l.jsx(
          _d,
          {
            ariaLabel: u,
            ariaRequired: "false",
            children: $,
            inputId: `${u}-input-id`,
            onValueChange: (R) => {
              b(R === "select-a-location-type" ? "" : R);
            },
            placeholder: u
          }
        ),
        /* @__PURE__ */ l.jsx(
          N3,
          {
            ariaRequired: "true",
            errorMessage: w,
            errorMessageId: "find-a-location-location-error",
            getLocationTriggerTitle: r,
            googleMapsApiKey: a,
            hasError: !!w,
            inputId: "find-a-location-location",
            isLoading: v,
            onFocus: () => N(null),
            onChange: () => {
              w && N(null);
            },
            onGetLocationError: () => N(f),
            onSetIsLoading: x,
            onSetValue: C,
            placeholder: s,
            value: _
          }
        ),
        /* @__PURE__ */ l.jsxs(
          vn,
          {
            disabled: A,
            size: "responsive",
            title: h,
            type: "submit",
            variant: "solid1",
            children: [
              /* @__PURE__ */ l.jsx(re, { icon: "magnifyingGlass" }),
              /* @__PURE__ */ l.jsx("span", { children: h })
            ]
          }
        )
      ] })
    }
  );
}, s9 = "_statistic_1tq60_209", Xa = {
  "statistics-item": "_statistics-item_1tq60_209",
  statistic: s9,
  "statistics-item-color-default": "_statistics-item-color-default_1tq60_219",
  "support-copy": "_support-copy_1tq60_220"
}, QE = (e) => {
  const { className: t, topStatistic: n, supportCopy: r, ...a } = e, i = Et(Hn), s = hr(i);
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      "data-testid": "top-statistics-item",
      className: z(
        Xa["statistics-item"],
        {
          [Xa["statistics-item-color-default"]]: !s
        },
        t
      ),
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          G,
          {
            "data-testid": "top-statistics-item-statistic",
            tag: "span",
            fontStyle: "lgHeading",
            fontStyleCorp: "smHeading",
            className: Xa.statistic,
            children: n
          }
        ),
        /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "top-statistics-item-support-copy",
            className: Xa["support-copy"],
            children: r
          }
        )
      ]
    }
  );
}, Wn = {
  "testimonial-card": "_testimonial-card_k12rq_209",
  "quote-circle": "_quote-circle_k12rq_216",
  "testimonial-card-content": "_testimonial-card-content_k12rq_233",
  "about-testimonial-author": "_about-testimonial-author_k12rq_242",
  "testimonial-author-title": "_testimonial-author-title_k12rq_245",
  "testimonial-text": "_testimonial-text_k12rq_248",
  "testimonial-author": "_testimonial-author_k12rq_245"
}, o9 = (e) => {
  const {
    className: t,
    testimonialText: n,
    testimonialAuthor: r,
    testimonialAuthorTitle: a,
    ...i
  } = e;
  return /* @__PURE__ */ l.jsx(ur, { children: /* @__PURE__ */ l.jsxs(
    Bt,
    {
      elevation: "elevation1",
      className: z(Wn["testimonial-card"], t),
      "data-testid": "testimonial-card",
      ...i,
      children: [
        /* @__PURE__ */ l.jsx(ur, { backgroundColor: "wellnessBlue", children: /* @__PURE__ */ l.jsx(
          "div",
          {
            "data-testid": "testimonial-quote-circle",
            className: Wn["quote-circle"],
            children: /* @__PURE__ */ l.jsx(
              G,
              {
                tag: "span",
                children: "“"
              }
            )
          }
        ) }),
        /* @__PURE__ */ l.jsxs(
          "figure",
          {
            "data-testid": "testimonial-card-content",
            className: Wn["testimonial-card-content"],
            children: [
              /* @__PURE__ */ l.jsx(
                le,
                {
                  as: "blockquote",
                  "data-testid": "testimonial-text",
                  className: Wn["testimonial-text"],
                  children: n
                }
              ),
              /* @__PURE__ */ l.jsxs(
                "figcaption",
                {
                  "data-testid": "about-testimonial-author",
                  className: Wn["about-testimonial-author"],
                  children: [
                    /* @__PURE__ */ l.jsx(
                      G,
                      {
                        "data-testid": "testimonial-author",
                        className: Wn["testimonial-author"],
                        tag: "p",
                        children: r
                      }
                    ),
                    a && /* @__PURE__ */ l.jsx(
                      G,
                      {
                        "data-testid": "testimonial-author-title",
                        className: Wn["testimonial-author-title"],
                        tag: "p",
                        children: a
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  ) });
};
function dl(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function Bo(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {}), Object.keys(t).forEach((n) => {
    typeof e[n] > "u" ? e[n] = t[n] : dl(t[n]) && dl(e[n]) && Object.keys(t[n]).length > 0 && Bo(e[n], t[n]);
  });
}
const E3 = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function pt() {
  const e = typeof document < "u" ? document : {};
  return Bo(e, E3), e;
}
const c9 = {
  document: E3,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function ht() {
  const e = typeof window < "u" ? window : {};
  return Bo(e, c9), e;
}
function Mn(e) {
  return e === void 0 && (e = ""), e.trim().split(" ").filter((t) => !!t.trim());
}
function l9(e) {
  const t = e;
  Object.keys(t).forEach((n) => {
    try {
      t[n] = null;
    } catch {
    }
    try {
      delete t[n];
    } catch {
    }
  });
}
function Si(e, t) {
  return t === void 0 && (t = 0), setTimeout(e, t);
}
function Li() {
  return Date.now();
}
function d9(e) {
  const t = ht();
  let n;
  return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n;
}
function u9(e, t) {
  t === void 0 && (t = "x");
  const n = ht();
  let r, a, i;
  const s = d9(e);
  return n.WebKitCSSMatrix ? (a = s.transform || s.webkitTransform, a.split(",").length > 6 && (a = a.split(", ").map((o) => o.replace(",", ".")).join(", ")), i = new n.WebKitCSSMatrix(a === "none" ? "" : a)) : (i = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = i.toString().split(",")), t === "x" && (n.WebKitCSSMatrix ? a = i.m41 : r.length === 16 ? a = parseFloat(r[12]) : a = parseFloat(r[4])), t === "y" && (n.WebKitCSSMatrix ? a = i.m42 : r.length === 16 ? a = parseFloat(r[13]) : a = parseFloat(r[5])), a || 0;
}
function ca(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function f9(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function gt() {
  const e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < arguments.length; n += 1) {
    const r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (r != null && !f9(r)) {
      const a = Object.keys(Object(r)).filter((i) => t.indexOf(i) < 0);
      for (let i = 0, s = a.length; i < s; i += 1) {
        const o = a[i], c = Object.getOwnPropertyDescriptor(r, o);
        c !== void 0 && c.enumerable && (ca(e[o]) && ca(r[o]) ? r[o].__swiper__ ? e[o] = r[o] : gt(e[o], r[o]) : !ca(e[o]) && ca(r[o]) ? (e[o] = {}, r[o].__swiper__ ? e[o] = r[o] : gt(e[o], r[o])) : e[o] = r[o]);
      }
    }
  }
  return e;
}
function Za(e, t, n) {
  e.style.setProperty(t, n);
}
function T3(e) {
  let {
    swiper: t,
    targetPosition: n,
    side: r
  } = e;
  const a = ht(), i = -t.translate;
  let s = null, o;
  const c = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", a.cancelAnimationFrame(t.cssModeFrameID);
  const d = n > i ? "next" : "prev", u = (p, h) => d === "next" && p >= h || d === "prev" && p <= h, f = () => {
    o = (/* @__PURE__ */ new Date()).getTime(), s === null && (s = o);
    const p = Math.max(Math.min((o - s) / c, 1), 0), h = 0.5 - Math.cos(p * Math.PI) / 2;
    let g = i + h * (n - i);
    if (u(g, n) && (g = n), t.wrapperEl.scrollTo({
      [r]: g
    }), u(g, n)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [r]: g
        });
      }), a.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = a.requestAnimationFrame(f);
  };
  f();
}
function k3(e) {
  return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
}
function $t(e, t) {
  return t === void 0 && (t = ""), [...e.children].filter((n) => n.matches(t));
}
function Mi(e) {
  try {
    console.warn(e);
    return;
  } catch {
  }
}
function Vr(e, t) {
  t === void 0 && (t = []);
  const n = document.createElement(e);
  return n.classList.add(...Array.isArray(t) ? t : Mn(t)), n;
}
function p9(e) {
  const t = ht(), n = pt(), r = e.getBoundingClientRect(), a = n.body, i = e.clientTop || a.clientTop || 0, s = e.clientLeft || a.clientLeft || 0, o = e === t ? t.scrollY : e.scrollTop, c = e === t ? t.scrollX : e.scrollLeft;
  return {
    top: r.top + o - i,
    left: r.left + c - s
  };
}
function m9(e, t) {
  const n = [];
  for (; e.previousElementSibling; ) {
    const r = e.previousElementSibling;
    t ? r.matches(t) && n.push(r) : n.push(r), e = r;
  }
  return n;
}
function h9(e, t) {
  const n = [];
  for (; e.nextElementSibling; ) {
    const r = e.nextElementSibling;
    t ? r.matches(t) && n.push(r) : n.push(r), e = r;
  }
  return n;
}
function Nn(e, t) {
  return ht().getComputedStyle(e, null).getPropertyValue(t);
}
function ba(e) {
  let t = e, n;
  if (t) {
    for (n = 0; (t = t.previousSibling) !== null; )
      t.nodeType === 1 && (n += 1);
    return n;
  }
}
function j3(e, t) {
  const n = [];
  let r = e.parentElement;
  for (; r; )
    t ? r.matches(t) && n.push(r) : n.push(r), r = r.parentElement;
  return n;
}
function g9(e, t) {
  function n(r) {
    r.target === e && (t.call(e, r), e.removeEventListener("transitionend", n));
  }
  t && e.addEventListener("transitionend", n);
}
function Ns(e, t, n) {
  const r = ht();
  return n ? e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(r.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(r.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom")) : e.offsetWidth;
}
function Se(e) {
  return (Array.isArray(e) ? e : [e]).filter((t) => !!t);
}
let N1;
function v9() {
  const e = ht(), t = pt();
  return {
    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
  };
}
function P3() {
  return N1 || (N1 = v9()), N1;
}
let z1;
function b9(e) {
  let {
    userAgent: t
  } = e === void 0 ? {} : e;
  const n = P3(), r = ht(), a = r.navigator.platform, i = t || r.navigator.userAgent, s = {
    ios: !1,
    android: !1
  }, o = r.screen.width, c = r.screen.height, d = i.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = i.match(/(iPad).*OS\s([\d_]+)/);
  const f = i.match(/(iPod)(.*OS\s([\d_]+))?/), p = !u && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/), h = a === "Win32";
  let g = a === "MacIntel";
  const v = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && g && n.touch && v.indexOf(`${o}x${c}`) >= 0 && (u = i.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), g = !1), d && !h && (s.os = "android", s.android = !0), (u || p || f) && (s.os = "ios", s.ios = !0), s;
}
function A3(e) {
  return e === void 0 && (e = {}), z1 || (z1 = b9(e)), z1;
}
let E1;
function y9() {
  const e = ht(), t = A3();
  let n = !1;
  function r() {
    const o = e.navigator.userAgent.toLowerCase();
    return o.indexOf("safari") >= 0 && o.indexOf("chrome") < 0 && o.indexOf("android") < 0;
  }
  if (r()) {
    const o = String(e.navigator.userAgent);
    if (o.includes("Version/")) {
      const [c, d] = o.split("Version/")[1].split(" ")[0].split(".").map((u) => Number(u));
      n = c < 16 || c === 16 && d < 2;
    }
  }
  const a = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), i = r(), s = i || a && t.ios;
  return {
    isSafari: n || i,
    needPerspectiveFix: n,
    need3dFix: s,
    isWebView: a
  };
}
function x9() {
  return E1 || (E1 = y9()), E1;
}
function _9(e) {
  let {
    swiper: t,
    on: n,
    emit: r
  } = e;
  const a = ht();
  let i = null, s = null;
  const o = () => {
    !t || t.destroyed || !t.initialized || (r("beforeResize"), r("resize"));
  }, c = () => {
    !t || t.destroyed || !t.initialized || (i = new ResizeObserver((f) => {
      s = a.requestAnimationFrame(() => {
        const {
          width: p,
          height: h
        } = t;
        let g = p, v = h;
        f.forEach((x) => {
          let {
            contentBoxSize: m,
            contentRect: b,
            target: _
          } = x;
          _ && _ !== t.el || (g = b ? b.width : (m[0] || m).inlineSize, v = b ? b.height : (m[0] || m).blockSize);
        }), (g !== p || v !== h) && o();
      });
    }), i.observe(t.el));
  }, d = () => {
    s && a.cancelAnimationFrame(s), i && i.unobserve && t.el && (i.unobserve(t.el), i = null);
  }, u = () => {
    !t || t.destroyed || !t.initialized || r("orientationchange");
  };
  n("init", () => {
    if (t.params.resizeObserver && typeof a.ResizeObserver < "u") {
      c();
      return;
    }
    a.addEventListener("resize", o), a.addEventListener("orientationchange", u);
  }), n("destroy", () => {
    d(), a.removeEventListener("resize", o), a.removeEventListener("orientationchange", u);
  });
}
function w9(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: a
  } = e;
  const i = [], s = ht(), o = function(u, f) {
    f === void 0 && (f = {});
    const p = s.MutationObserver || s.WebkitMutationObserver, h = new p((g) => {
      if (t.__preventObserver__)
        return;
      if (g.length === 1) {
        a("observerUpdate", g[0]);
        return;
      }
      const v = function() {
        a("observerUpdate", g[0]);
      };
      s.requestAnimationFrame ? s.requestAnimationFrame(v) : s.setTimeout(v, 0);
    });
    h.observe(u, {
      attributes: typeof f.attributes > "u" ? !0 : f.attributes,
      childList: typeof f.childList > "u" ? !0 : f.childList,
      characterData: typeof f.characterData > "u" ? !0 : f.characterData
    }), i.push(h);
  }, c = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const u = j3(t.hostEl);
        for (let f = 0; f < u.length; f += 1)
          o(u[f]);
      }
      o(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), o(t.wrapperEl, {
        attributes: !1
      });
    }
  }, d = () => {
    i.forEach((u) => {
      u.disconnect();
    }), i.splice(0, i.length);
  };
  n({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), r("init", c), r("destroy", d);
}
var C9 = {
  on(e, t, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function")
      return r;
    const a = n ? "unshift" : "push";
    return e.split(" ").forEach((i) => {
      r.eventsListeners[i] || (r.eventsListeners[i] = []), r.eventsListeners[i][a](t);
    }), r;
  },
  once(e, t, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function")
      return r;
    function a() {
      r.off(e, a), a.__emitterProxy && delete a.__emitterProxy;
      for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++)
        s[o] = arguments[o];
      t.apply(r, s);
    }
    return a.__emitterProxy = t, r.on(e, a, n);
  },
  onAny(e, t) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function")
      return n;
    const r = t ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners)
      return t;
    const n = t.eventsAnyListeners.indexOf(e);
    return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
  },
  off(e, t) {
    const n = this;
    return !n.eventsListeners || n.destroyed || !n.eventsListeners || e.split(" ").forEach((r) => {
      typeof t > "u" ? n.eventsListeners[r] = [] : n.eventsListeners[r] && n.eventsListeners[r].forEach((a, i) => {
        (a === t || a.__emitterProxy && a.__emitterProxy === t) && n.eventsListeners[r].splice(i, 1);
      });
    }), n;
  },
  emit() {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners)
      return e;
    let t, n, r;
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return typeof i[0] == "string" || Array.isArray(i[0]) ? (t = i[0], n = i.slice(1, i.length), r = e) : (t = i[0].events, n = i[0].data, r = i[0].context || e), n.unshift(r), (Array.isArray(t) ? t : t.split(" ")).forEach((c) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((d) => {
        d.apply(r, [c, ...n]);
      }), e.eventsListeners && e.eventsListeners[c] && e.eventsListeners[c].forEach((d) => {
        d.apply(r, n);
      });
    }), e;
  }
};
function S9() {
  const e = this;
  let t, n;
  const r = e.el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = r.clientWidth, typeof e.params.height < "u" && e.params.height !== null ? n = e.params.height : n = r.clientHeight, !(t === 0 && e.isHorizontal() || n === 0 && e.isVertical()) && (t = t - parseInt(Nn(r, "padding-left") || 0, 10) - parseInt(Nn(r, "padding-right") || 0, 10), n = n - parseInt(Nn(r, "padding-top") || 0, 10) - parseInt(Nn(r, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
    width: t,
    height: n,
    size: e.isHorizontal() ? t : n
  }));
}
function L9() {
  const e = this;
  function t(j, D) {
    return parseFloat(j.getPropertyValue(e.getDirectionLabel(D)) || 0);
  }
  const n = e.params, {
    wrapperEl: r,
    slidesEl: a,
    size: i,
    rtlTranslate: s,
    wrongRTL: o
  } = e, c = e.virtual && n.virtual.enabled, d = c ? e.virtual.slides.length : e.slides.length, u = $t(a, `.${e.params.slideClass}, swiper-slide`), f = c ? e.virtual.slides.length : u.length;
  let p = [];
  const h = [], g = [];
  let v = n.slidesOffsetBefore;
  typeof v == "function" && (v = n.slidesOffsetBefore.call(e));
  let x = n.slidesOffsetAfter;
  typeof x == "function" && (x = n.slidesOffsetAfter.call(e));
  const m = e.snapGrid.length, b = e.slidesGrid.length;
  let _ = n.spaceBetween, C = -v, w = 0, N = 0;
  if (typeof i > "u")
    return;
  typeof _ == "string" && _.indexOf("%") >= 0 ? _ = parseFloat(_.replace("%", "")) / 100 * i : typeof _ == "string" && (_ = parseFloat(_)), e.virtualSize = -_, u.forEach((j) => {
    s ? j.style.marginLeft = "" : j.style.marginRight = "", j.style.marginBottom = "", j.style.marginTop = "";
  }), n.centeredSlides && n.cssMode && (Za(r, "--swiper-centered-offset-before", ""), Za(r, "--swiper-centered-offset-after", ""));
  const M = n.grid && n.grid.rows > 1 && e.grid;
  M ? e.grid.initSlides(u) : e.grid && e.grid.unsetSlides();
  let S;
  const T = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((j) => typeof n.breakpoints[j].slidesPerView < "u").length > 0;
  for (let j = 0; j < f; j += 1) {
    S = 0;
    let D;
    if (u[j] && (D = u[j]), M && e.grid.updateSlide(j, D, u), !(u[j] && Nn(D, "display") === "none")) {
      if (n.slidesPerView === "auto") {
        T && (u[j].style[e.getDirectionLabel("width")] = "");
        const A = getComputedStyle(D), k = D.style.transform, $ = D.style.webkitTransform;
        if (k && (D.style.transform = "none"), $ && (D.style.webkitTransform = "none"), n.roundLengths)
          S = e.isHorizontal() ? Ns(D, "width", !0) : Ns(D, "height", !0);
        else {
          const R = t(A, "width"), F = t(A, "padding-left"), P = t(A, "padding-right"), I = t(A, "margin-left"), H = t(A, "margin-right"), O = A.getPropertyValue("box-sizing");
          if (O && O === "border-box")
            S = R + I + H;
          else {
            const {
              clientWidth: W,
              offsetWidth: se
            } = D;
            S = R + F + P + I + H + (se - W);
          }
        }
        k && (D.style.transform = k), $ && (D.style.webkitTransform = $), n.roundLengths && (S = Math.floor(S));
      } else
        S = (i - (n.slidesPerView - 1) * _) / n.slidesPerView, n.roundLengths && (S = Math.floor(S)), u[j] && (u[j].style[e.getDirectionLabel("width")] = `${S}px`);
      u[j] && (u[j].swiperSlideSize = S), g.push(S), n.centeredSlides ? (C = C + S / 2 + w / 2 + _, w === 0 && j !== 0 && (C = C - i / 2 - _), j === 0 && (C = C - i / 2 - _), Math.abs(C) < 1 / 1e3 && (C = 0), n.roundLengths && (C = Math.floor(C)), N % n.slidesPerGroup === 0 && p.push(C), h.push(C)) : (n.roundLengths && (C = Math.floor(C)), (N - Math.min(e.params.slidesPerGroupSkip, N)) % e.params.slidesPerGroup === 0 && p.push(C), h.push(C), C = C + S + _), e.virtualSize += S + _, w = S, N += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, i) + x, s && o && (n.effect === "slide" || n.effect === "coverflow") && (r.style.width = `${e.virtualSize + _}px`), n.setWrapperSize && (r.style[e.getDirectionLabel("width")] = `${e.virtualSize + _}px`), M && e.grid.updateWrapperSize(S, p), !n.centeredSlides) {
    const j = [];
    for (let D = 0; D < p.length; D += 1) {
      let A = p[D];
      n.roundLengths && (A = Math.floor(A)), p[D] <= e.virtualSize - i && j.push(A);
    }
    p = j, Math.floor(e.virtualSize - i) - Math.floor(p[p.length - 1]) > 1 && p.push(e.virtualSize - i);
  }
  if (c && n.loop) {
    const j = g[0] + _;
    if (n.slidesPerGroup > 1) {
      const D = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / n.slidesPerGroup), A = j * n.slidesPerGroup;
      for (let k = 0; k < D; k += 1)
        p.push(p[p.length - 1] + A);
    }
    for (let D = 0; D < e.virtual.slidesBefore + e.virtual.slidesAfter; D += 1)
      n.slidesPerGroup === 1 && p.push(p[p.length - 1] + j), h.push(h[h.length - 1] + j), e.virtualSize += j;
  }
  if (p.length === 0 && (p = [0]), _ !== 0) {
    const j = e.isHorizontal() && s ? "marginLeft" : e.getDirectionLabel("marginRight");
    u.filter((D, A) => !n.cssMode || n.loop ? !0 : A !== u.length - 1).forEach((D) => {
      D.style[j] = `${_}px`;
    });
  }
  if (n.centeredSlides && n.centeredSlidesBounds) {
    let j = 0;
    g.forEach((A) => {
      j += A + (_ || 0);
    }), j -= _;
    const D = j - i;
    p = p.map((A) => A <= 0 ? -v : A > D ? D + x : A);
  }
  if (n.centerInsufficientSlides) {
    let j = 0;
    if (g.forEach((D) => {
      j += D + (_ || 0);
    }), j -= _, j < i) {
      const D = (i - j) / 2;
      p.forEach((A, k) => {
        p[k] = A - D;
      }), h.forEach((A, k) => {
        h[k] = A + D;
      });
    }
  }
  if (Object.assign(e, {
    slides: u,
    snapGrid: p,
    slidesGrid: h,
    slidesSizesGrid: g
  }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
    Za(r, "--swiper-centered-offset-before", `${-p[0]}px`), Za(r, "--swiper-centered-offset-after", `${e.size / 2 - g[g.length - 1] / 2}px`);
    const j = -e.snapGrid[0], D = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((A) => A + j), e.slidesGrid = e.slidesGrid.map((A) => A + D);
  }
  if (f !== d && e.emit("slidesLengthChange"), p.length !== m && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== b && e.emit("slidesGridLengthChange"), n.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !c && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
    const j = `${n.containerModifierClass}backface-hidden`, D = e.el.classList.contains(j);
    f <= n.maxBackfaceHiddenSlides ? D || e.el.classList.add(j) : D && e.el.classList.remove(j);
  }
}
function M9(e) {
  const t = this, n = [], r = t.virtual && t.params.virtual.enabled;
  let a = 0, i;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const s = (o) => r ? t.slides[t.getSlideIndexByData(o)] : t.slides[o];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || []).forEach((o) => {
        n.push(o);
      });
    else
      for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
        const o = t.activeIndex + i;
        if (o > t.slides.length && !r)
          break;
        n.push(s(o));
      }
  else
    n.push(s(t.activeIndex));
  for (i = 0; i < n.length; i += 1)
    if (typeof n[i] < "u") {
      const o = n[i].offsetHeight;
      a = o > a ? o : a;
    }
  (a || a === 0) && (t.wrapperEl.style.height = `${a}px`);
}
function N9() {
  const e = this, t = e.slides, n = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
  for (let r = 0; r < t.length; r += 1)
    t[r].swiperSlideOffset = (e.isHorizontal() ? t[r].offsetLeft : t[r].offsetTop) - n - e.cssOverflowAdjustment();
}
function z9(e) {
  e === void 0 && (e = this && this.translate || 0);
  const t = this, n = t.params, {
    slides: r,
    rtlTranslate: a,
    snapGrid: i
  } = t;
  if (r.length === 0)
    return;
  typeof r[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let s = -e;
  a && (s = e), r.forEach((c) => {
    c.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass);
  }), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  let o = n.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : typeof o == "string" && (o = parseFloat(o));
  for (let c = 0; c < r.length; c += 1) {
    const d = r[c];
    let u = d.swiperSlideOffset;
    n.cssMode && n.centeredSlides && (u -= r[0].swiperSlideOffset);
    const f = (s + (n.centeredSlides ? t.minTranslate() : 0) - u) / (d.swiperSlideSize + o), p = (s - i[0] + (n.centeredSlides ? t.minTranslate() : 0) - u) / (d.swiperSlideSize + o), h = -(s - u), g = h + t.slidesSizesGrid[c], v = h >= 0 && h <= t.size - t.slidesSizesGrid[c];
    (h >= 0 && h < t.size - 1 || g > 1 && g <= t.size || h <= 0 && g >= t.size) && (t.visibleSlides.push(d), t.visibleSlidesIndexes.push(c), r[c].classList.add(n.slideVisibleClass)), v && r[c].classList.add(n.slideFullyVisibleClass), d.progress = a ? -f : f, d.originalProgress = a ? -p : p;
  }
}
function E9(e) {
  const t = this;
  if (typeof e > "u") {
    const u = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * u || 0;
  }
  const n = t.params, r = t.maxTranslate() - t.minTranslate();
  let {
    progress: a,
    isBeginning: i,
    isEnd: s,
    progressLoop: o
  } = t;
  const c = i, d = s;
  if (r === 0)
    a = 0, i = !0, s = !0;
  else {
    a = (e - t.minTranslate()) / r;
    const u = Math.abs(e - t.minTranslate()) < 1, f = Math.abs(e - t.maxTranslate()) < 1;
    i = u || a <= 0, s = f || a >= 1, u && (a = 0), f && (a = 1);
  }
  if (n.loop) {
    const u = t.getSlideIndexByData(0), f = t.getSlideIndexByData(t.slides.length - 1), p = t.slidesGrid[u], h = t.slidesGrid[f], g = t.slidesGrid[t.slidesGrid.length - 1], v = Math.abs(e);
    v >= p ? o = (v - p) / g : o = (v + g - h) / g, o > 1 && (o -= 1);
  }
  Object.assign(t, {
    progress: a,
    progressLoop: o,
    isBeginning: i,
    isEnd: s
  }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), i && !c && t.emit("reachBeginning toEdge"), s && !d && t.emit("reachEnd toEdge"), (c && !i || d && !s) && t.emit("fromEdge"), t.emit("progress", a);
}
const T1 = (e, t, n) => {
  t && !e.classList.contains(n) ? e.classList.add(n) : !t && e.classList.contains(n) && e.classList.remove(n);
};
function T9() {
  const e = this, {
    slides: t,
    params: n,
    slidesEl: r,
    activeIndex: a
  } = e, i = e.virtual && n.virtual.enabled, s = e.grid && n.grid && n.grid.rows > 1, o = (f) => $t(r, `.${n.slideClass}${f}, swiper-slide${f}`)[0];
  let c, d, u;
  if (i)
    if (n.loop) {
      let f = a - e.virtual.slidesBefore;
      f < 0 && (f = e.virtual.slides.length + f), f >= e.virtual.slides.length && (f -= e.virtual.slides.length), c = o(`[data-swiper-slide-index="${f}"]`);
    } else
      c = o(`[data-swiper-slide-index="${a}"]`);
  else
    s ? (c = t.filter((f) => f.column === a)[0], u = t.filter((f) => f.column === a + 1)[0], d = t.filter((f) => f.column === a - 1)[0]) : c = t[a];
  c && (s || (u = h9(c, `.${n.slideClass}, swiper-slide`)[0], n.loop && !u && (u = t[0]), d = m9(c, `.${n.slideClass}, swiper-slide`)[0], n.loop && !d === 0 && (d = t[t.length - 1]))), t.forEach((f) => {
    T1(f, f === c, n.slideActiveClass), T1(f, f === u, n.slideNextClass), T1(f, f === d, n.slidePrevClass);
  }), e.emitSlidesClasses();
}
const pi = (e, t) => {
  if (!e || e.destroyed || !e.params)
    return;
  const n = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, r = t.closest(n());
  if (r) {
    let a = r.querySelector(`.${e.params.lazyPreloaderClass}`);
    !a && e.isElement && (r.shadowRoot ? a = r.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      r.shadowRoot && (a = r.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), a && a.remove());
    })), a && a.remove();
  }
}, k1 = (e, t) => {
  if (!e.slides[t])
    return;
  const n = e.slides[t].querySelector('[loading="lazy"]');
  n && n.removeAttribute("loading");
}, zs = (e) => {
  if (!e || e.destroyed || !e.params)
    return;
  let t = e.params.lazyPreloadPrevNext;
  const n = e.slides.length;
  if (!n || !t || t < 0)
    return;
  t = Math.min(t, n);
  const r = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), a = e.activeIndex;
  if (e.params.grid && e.params.grid.rows > 1) {
    const s = a, o = [s - t];
    o.push(...Array.from({
      length: t
    }).map((c, d) => s + r + d)), e.slides.forEach((c, d) => {
      o.includes(c.column) && k1(e, d);
    });
    return;
  }
  const i = a + r - 1;
  if (e.params.rewind || e.params.loop)
    for (let s = a - t; s <= i + t; s += 1) {
      const o = (s % n + n) % n;
      (o < a || o > i) && k1(e, o);
    }
  else
    for (let s = Math.max(a - t, 0); s <= Math.min(i + t, n - 1); s += 1)
      s !== a && (s > i || s < a) && k1(e, s);
};
function k9(e) {
  const {
    slidesGrid: t,
    params: n
  } = e, r = e.rtlTranslate ? e.translate : -e.translate;
  let a;
  for (let i = 0; i < t.length; i += 1)
    typeof t[i + 1] < "u" ? r >= t[i] && r < t[i + 1] - (t[i + 1] - t[i]) / 2 ? a = i : r >= t[i] && r < t[i + 1] && (a = i + 1) : r >= t[i] && (a = i);
  return n.normalizeSlideIndex && (a < 0 || typeof a > "u") && (a = 0), a;
}
function j9(e) {
  const t = this, n = t.rtlTranslate ? t.translate : -t.translate, {
    snapGrid: r,
    params: a,
    activeIndex: i,
    realIndex: s,
    snapIndex: o
  } = t;
  let c = e, d;
  const u = (h) => {
    let g = h - t.virtual.slidesBefore;
    return g < 0 && (g = t.virtual.slides.length + g), g >= t.virtual.slides.length && (g -= t.virtual.slides.length), g;
  };
  if (typeof c > "u" && (c = k9(t)), r.indexOf(n) >= 0)
    d = r.indexOf(n);
  else {
    const h = Math.min(a.slidesPerGroupSkip, c);
    d = h + Math.floor((c - h) / a.slidesPerGroup);
  }
  if (d >= r.length && (d = r.length - 1), c === i && !t.params.loop) {
    d !== o && (t.snapIndex = d, t.emit("snapIndexChange"));
    return;
  }
  if (c === i && t.params.loop && t.virtual && t.params.virtual.enabled) {
    t.realIndex = u(c);
    return;
  }
  const f = t.grid && a.grid && a.grid.rows > 1;
  let p;
  if (t.virtual && a.virtual.enabled && a.loop)
    p = u(c);
  else if (f) {
    const h = t.slides.filter((v) => v.column === c)[0];
    let g = parseInt(h.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(g) && (g = Math.max(t.slides.indexOf(h), 0)), p = Math.floor(g / a.grid.rows);
  } else if (t.slides[c]) {
    const h = t.slides[c].getAttribute("data-swiper-slide-index");
    h ? p = parseInt(h, 10) : p = c;
  } else
    p = c;
  Object.assign(t, {
    previousSnapIndex: o,
    snapIndex: d,
    previousRealIndex: s,
    realIndex: p,
    previousIndex: i,
    activeIndex: c
  }), t.initialized && zs(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (s !== p && t.emit("realIndexChange"), t.emit("slideChange"));
}
function P9(e, t) {
  const n = this, r = n.params;
  let a = e.closest(`.${r.slideClass}, swiper-slide`);
  !a && n.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((o) => {
    !a && o.matches && o.matches(`.${r.slideClass}, swiper-slide`) && (a = o);
  });
  let i = !1, s;
  if (a) {
    for (let o = 0; o < n.slides.length; o += 1)
      if (n.slides[o] === a) {
        i = !0, s = o;
        break;
      }
  }
  if (a && i)
    n.clickedSlide = a, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(a.getAttribute("data-swiper-slide-index"), 10) : n.clickedIndex = s;
  else {
    n.clickedSlide = void 0, n.clickedIndex = void 0;
    return;
  }
  r.slideToClickedSlide && n.clickedIndex !== void 0 && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
}
var A9 = {
  updateSize: S9,
  updateSlides: L9,
  updateAutoHeight: M9,
  updateSlidesOffset: N9,
  updateSlidesProgress: z9,
  updateProgress: E9,
  updateSlidesClasses: T9,
  updateActiveIndex: j9,
  updateClickedSlide: P9
};
function $9(e) {
  e === void 0 && (e = this.isHorizontal() ? "x" : "y");
  const t = this, {
    params: n,
    rtlTranslate: r,
    translate: a,
    wrapperEl: i
  } = t;
  if (n.virtualTranslate)
    return r ? -a : a;
  if (n.cssMode)
    return a;
  let s = u9(i, e);
  return s += t.cssOverflowAdjustment(), r && (s = -s), s || 0;
}
function I9(e, t) {
  const n = this, {
    rtlTranslate: r,
    params: a,
    wrapperEl: i,
    progress: s
  } = n;
  let o = 0, c = 0;
  const d = 0;
  n.isHorizontal() ? o = r ? -e : e : c = e, a.roundLengths && (o = Math.floor(o), c = Math.floor(c)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? o : c, a.cssMode ? i[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -o : -c : a.virtualTranslate || (n.isHorizontal() ? o -= n.cssOverflowAdjustment() : c -= n.cssOverflowAdjustment(), i.style.transform = `translate3d(${o}px, ${c}px, ${d}px)`);
  let u;
  const f = n.maxTranslate() - n.minTranslate();
  f === 0 ? u = 0 : u = (e - n.minTranslate()) / f, u !== s && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
}
function O9() {
  return -this.snapGrid[0];
}
function R9() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function D9(e, t, n, r, a) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), r === void 0 && (r = !0);
  const i = this, {
    params: s,
    wrapperEl: o
  } = i;
  if (i.animating && s.preventInteractionOnTransition)
    return !1;
  const c = i.minTranslate(), d = i.maxTranslate();
  let u;
  if (r && e > c ? u = c : r && e < d ? u = d : u = e, i.updateProgress(u), s.cssMode) {
    const f = i.isHorizontal();
    if (t === 0)
      o[f ? "scrollLeft" : "scrollTop"] = -u;
    else {
      if (!i.support.smoothScroll)
        return T3({
          swiper: i,
          targetPosition: -u,
          side: f ? "left" : "top"
        }), !0;
      o.scrollTo({
        [f ? "left" : "top"]: -u,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (i.setTransition(0), i.setTranslate(u), n && (i.emit("beforeTransitionStart", t, a), i.emit("transitionEnd"))) : (i.setTransition(t), i.setTranslate(u), n && (i.emit("beforeTransitionStart", t, a), i.emit("transitionStart")), i.animating || (i.animating = !0, i.onTranslateToWrapperTransitionEnd || (i.onTranslateToWrapperTransitionEnd = function(p) {
    !i || i.destroyed || p.target === this && (i.wrapperEl.removeEventListener("transitionend", i.onTranslateToWrapperTransitionEnd), i.onTranslateToWrapperTransitionEnd = null, delete i.onTranslateToWrapperTransitionEnd, i.animating = !1, n && i.emit("transitionEnd"));
  }), i.wrapperEl.addEventListener("transitionend", i.onTranslateToWrapperTransitionEnd))), !0;
}
var F9 = {
  getTranslate: $9,
  setTranslate: I9,
  minTranslate: O9,
  maxTranslate: R9,
  translateTo: D9
};
function B9(e, t) {
  const n = this;
  n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${e}ms`, n.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), n.emit("setTransition", e, t);
}
function $3(e) {
  let {
    swiper: t,
    runCallbacks: n,
    direction: r,
    step: a
  } = e;
  const {
    activeIndex: i,
    previousIndex: s
  } = t;
  let o = r;
  if (o || (i > s ? o = "next" : i < s ? o = "prev" : o = "reset"), t.emit(`transition${a}`), n && i !== s) {
    if (o === "reset") {
      t.emit(`slideResetTransition${a}`);
      return;
    }
    t.emit(`slideChangeTransition${a}`), o === "next" ? t.emit(`slideNextTransition${a}`) : t.emit(`slidePrevTransition${a}`);
  }
}
function V9(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: r
  } = n;
  r.cssMode || (r.autoHeight && n.updateAutoHeight(), $3({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function H9(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: r
  } = n;
  n.animating = !1, !r.cssMode && (n.setTransition(0), $3({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
var q9 = {
  setTransition: B9,
  transitionStart: V9,
  transitionEnd: H9
};
function W9(e, t, n, r, a) {
  e === void 0 && (e = 0), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
  const i = this;
  let s = e;
  s < 0 && (s = 0);
  const {
    params: o,
    snapGrid: c,
    slidesGrid: d,
    previousIndex: u,
    activeIndex: f,
    rtlTranslate: p,
    wrapperEl: h,
    enabled: g
  } = i;
  if (!g && !r && !a || i.destroyed || i.animating && o.preventInteractionOnTransition)
    return !1;
  typeof t > "u" && (t = i.params.speed);
  const v = Math.min(i.params.slidesPerGroupSkip, s);
  let x = v + Math.floor((s - v) / i.params.slidesPerGroup);
  x >= c.length && (x = c.length - 1);
  const m = -c[x];
  if (o.normalizeSlideIndex)
    for (let _ = 0; _ < d.length; _ += 1) {
      const C = -Math.floor(m * 100), w = Math.floor(d[_] * 100), N = Math.floor(d[_ + 1] * 100);
      typeof d[_ + 1] < "u" ? C >= w && C < N - (N - w) / 2 ? s = _ : C >= w && C < N && (s = _ + 1) : C >= w && (s = _);
    }
  if (i.initialized && s !== f && (!i.allowSlideNext && (p ? m > i.translate && m > i.minTranslate() : m < i.translate && m < i.minTranslate()) || !i.allowSlidePrev && m > i.translate && m > i.maxTranslate() && (f || 0) !== s))
    return !1;
  s !== (u || 0) && n && i.emit("beforeSlideChangeStart"), i.updateProgress(m);
  let b;
  if (s > f ? b = "next" : s < f ? b = "prev" : b = "reset", p && -m === i.translate || !p && m === i.translate)
    return i.updateActiveIndex(s), o.autoHeight && i.updateAutoHeight(), i.updateSlidesClasses(), o.effect !== "slide" && i.setTranslate(m), b !== "reset" && (i.transitionStart(n, b), i.transitionEnd(n, b)), !1;
  if (o.cssMode) {
    const _ = i.isHorizontal(), C = p ? m : -m;
    if (t === 0) {
      const w = i.virtual && i.params.virtual.enabled;
      w && (i.wrapperEl.style.scrollSnapType = "none", i._immediateVirtual = !0), w && !i._cssModeVirtualInitialSet && i.params.initialSlide > 0 ? (i._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        h[_ ? "scrollLeft" : "scrollTop"] = C;
      })) : h[_ ? "scrollLeft" : "scrollTop"] = C, w && requestAnimationFrame(() => {
        i.wrapperEl.style.scrollSnapType = "", i._immediateVirtual = !1;
      });
    } else {
      if (!i.support.smoothScroll)
        return T3({
          swiper: i,
          targetPosition: C,
          side: _ ? "left" : "top"
        }), !0;
      h.scrollTo({
        [_ ? "left" : "top"]: C,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return i.setTransition(t), i.setTranslate(m), i.updateActiveIndex(s), i.updateSlidesClasses(), i.emit("beforeTransitionStart", t, r), i.transitionStart(n, b), t === 0 ? i.transitionEnd(n, b) : i.animating || (i.animating = !0, i.onSlideToWrapperTransitionEnd || (i.onSlideToWrapperTransitionEnd = function(C) {
    !i || i.destroyed || C.target === this && (i.wrapperEl.removeEventListener("transitionend", i.onSlideToWrapperTransitionEnd), i.onSlideToWrapperTransitionEnd = null, delete i.onSlideToWrapperTransitionEnd, i.transitionEnd(n, b));
  }), i.wrapperEl.addEventListener("transitionend", i.onSlideToWrapperTransitionEnd)), !0;
}
function U9(e, t, n, r) {
  e === void 0 && (e = 0), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
  const a = this;
  if (a.destroyed)
    return;
  typeof t > "u" && (t = a.params.speed);
  const i = a.grid && a.params.grid && a.params.grid.rows > 1;
  let s = e;
  if (a.params.loop)
    if (a.virtual && a.params.virtual.enabled)
      s = s + a.virtual.slidesBefore;
    else {
      let o;
      if (i) {
        const p = s * a.params.grid.rows;
        o = a.slides.filter((h) => h.getAttribute("data-swiper-slide-index") * 1 === p)[0].column;
      } else
        o = a.getSlideIndexByData(s);
      const c = i ? Math.ceil(a.slides.length / a.params.grid.rows) : a.slides.length, {
        centeredSlides: d
      } = a.params;
      let u = a.params.slidesPerView;
      u === "auto" ? u = a.slidesPerViewDynamic() : (u = Math.ceil(parseFloat(a.params.slidesPerView, 10)), d && u % 2 === 0 && (u = u + 1));
      let f = c - o < u;
      if (d && (f = f || o < Math.ceil(u / 2)), r && d && a.params.slidesPerView !== "auto" && !i && (f = !1), f) {
        const p = d ? o < a.activeIndex ? "prev" : "next" : o - a.activeIndex - 1 < a.params.slidesPerView ? "next" : "prev";
        a.loopFix({
          direction: p,
          slideTo: !0,
          activeSlideIndex: p === "next" ? o + 1 : o - c + 1,
          slideRealIndex: p === "next" ? a.realIndex : void 0
        });
      }
      if (i) {
        const p = s * a.params.grid.rows;
        s = a.slides.filter((h) => h.getAttribute("data-swiper-slide-index") * 1 === p)[0].column;
      } else
        s = a.getSlideIndexByData(s);
    }
  return requestAnimationFrame(() => {
    a.slideTo(s, t, n, r);
  }), a;
}
function G9(e, t, n) {
  t === void 0 && (t = !0);
  const r = this, {
    enabled: a,
    params: i,
    animating: s
  } = r;
  if (!a || r.destroyed)
    return r;
  typeof e > "u" && (e = r.params.speed);
  let o = i.slidesPerGroup;
  i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (o = Math.max(r.slidesPerViewDynamic("current", !0), 1));
  const c = r.activeIndex < i.slidesPerGroupSkip ? 1 : o, d = r.virtual && i.virtual.enabled;
  if (i.loop) {
    if (s && !d && i.loopPreventsSliding)
      return !1;
    if (r.loopFix({
      direction: "next"
    }), r._clientLeft = r.wrapperEl.clientLeft, r.activeIndex === r.slides.length - 1 && i.cssMode)
      return requestAnimationFrame(() => {
        r.slideTo(r.activeIndex + c, e, t, n);
      }), !0;
  }
  return i.rewind && r.isEnd ? r.slideTo(0, e, t, n) : r.slideTo(r.activeIndex + c, e, t, n);
}
function Y9(e, t, n) {
  t === void 0 && (t = !0);
  const r = this, {
    params: a,
    snapGrid: i,
    slidesGrid: s,
    rtlTranslate: o,
    enabled: c,
    animating: d
  } = r;
  if (!c || r.destroyed)
    return r;
  typeof e > "u" && (e = r.params.speed);
  const u = r.virtual && a.virtual.enabled;
  if (a.loop) {
    if (d && !u && a.loopPreventsSliding)
      return !1;
    r.loopFix({
      direction: "prev"
    }), r._clientLeft = r.wrapperEl.clientLeft;
  }
  const f = o ? r.translate : -r.translate;
  function p(m) {
    return m < 0 ? -Math.floor(Math.abs(m)) : Math.floor(m);
  }
  const h = p(f), g = i.map((m) => p(m));
  let v = i[g.indexOf(h) - 1];
  if (typeof v > "u" && a.cssMode) {
    let m;
    i.forEach((b, _) => {
      h >= b && (m = _);
    }), typeof m < "u" && (v = i[m > 0 ? m - 1 : m]);
  }
  let x = 0;
  if (typeof v < "u" && (x = s.indexOf(v), x < 0 && (x = r.activeIndex - 1), a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (x = x - r.slidesPerViewDynamic("previous", !0) + 1, x = Math.max(x, 0))), a.rewind && r.isBeginning) {
    const m = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
    return r.slideTo(m, e, t, n);
  } else if (a.loop && r.activeIndex === 0 && a.cssMode)
    return requestAnimationFrame(() => {
      r.slideTo(x, e, t, n);
    }), !0;
  return r.slideTo(x, e, t, n);
}
function K9(e, t, n) {
  t === void 0 && (t = !0);
  const r = this;
  if (!r.destroyed)
    return typeof e > "u" && (e = r.params.speed), r.slideTo(r.activeIndex, e, t, n);
}
function X9(e, t, n, r) {
  t === void 0 && (t = !0), r === void 0 && (r = 0.5);
  const a = this;
  if (a.destroyed)
    return;
  typeof e > "u" && (e = a.params.speed);
  let i = a.activeIndex;
  const s = Math.min(a.params.slidesPerGroupSkip, i), o = s + Math.floor((i - s) / a.params.slidesPerGroup), c = a.rtlTranslate ? a.translate : -a.translate;
  if (c >= a.snapGrid[o]) {
    const d = a.snapGrid[o], u = a.snapGrid[o + 1];
    c - d > (u - d) * r && (i += a.params.slidesPerGroup);
  } else {
    const d = a.snapGrid[o - 1], u = a.snapGrid[o];
    c - d <= (u - d) * r && (i -= a.params.slidesPerGroup);
  }
  return i = Math.max(i, 0), i = Math.min(i, a.slidesGrid.length - 1), a.slideTo(i, e, t, n);
}
function Z9() {
  const e = this;
  if (e.destroyed)
    return;
  const {
    params: t,
    slidesEl: n
  } = e, r = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let a = e.clickedIndex, i;
  const s = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
  if (t.loop) {
    if (e.animating)
      return;
    i = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? a < e.loopedSlides - r / 2 || a > e.slides.length - e.loopedSlides + r / 2 ? (e.loopFix(), a = e.getSlideIndex($t(n, `${s}[data-swiper-slide-index="${i}"]`)[0]), Si(() => {
      e.slideTo(a);
    })) : e.slideTo(a) : a > e.slides.length - r ? (e.loopFix(), a = e.getSlideIndex($t(n, `${s}[data-swiper-slide-index="${i}"]`)[0]), Si(() => {
      e.slideTo(a);
    })) : e.slideTo(a);
  } else
    e.slideTo(a);
}
var Q9 = {
  slideTo: W9,
  slideToLoop: U9,
  slideNext: G9,
  slidePrev: Y9,
  slideReset: K9,
  slideToClosest: X9,
  slideToClickedSlide: Z9
};
function J9(e) {
  const t = this, {
    params: n,
    slidesEl: r
  } = t;
  if (!n.loop || t.virtual && t.params.virtual.enabled)
    return;
  const a = () => {
    $t(r, `.${n.slideClass}, swiper-slide`).forEach((f, p) => {
      f.setAttribute("data-swiper-slide-index", p);
    });
  }, i = t.grid && n.grid && n.grid.rows > 1, s = n.slidesPerGroup * (i ? n.grid.rows : 1), o = t.slides.length % s !== 0, c = i && t.slides.length % n.grid.rows !== 0, d = (u) => {
    for (let f = 0; f < u; f += 1) {
      const p = t.isElement ? Vr("swiper-slide", [n.slideBlankClass]) : Vr("div", [n.slideClass, n.slideBlankClass]);
      t.slidesEl.append(p);
    }
  };
  if (o) {
    if (n.loopAddBlankSlides) {
      const u = s - t.slides.length % s;
      d(u), t.recalcSlides(), t.updateSlides();
    } else
      Mi("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    a();
  } else if (c) {
    if (n.loopAddBlankSlides) {
      const u = n.grid.rows - t.slides.length % n.grid.rows;
      d(u), t.recalcSlides(), t.updateSlides();
    } else
      Mi("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    a();
  } else
    a();
  t.loopFix({
    slideRealIndex: e,
    direction: n.centeredSlides ? void 0 : "next"
  });
}
function eh(e) {
  let {
    slideRealIndex: t,
    slideTo: n = !0,
    direction: r,
    setTranslate: a,
    activeSlideIndex: i,
    byController: s,
    byMousewheel: o
  } = e === void 0 ? {} : e;
  const c = this;
  if (!c.params.loop)
    return;
  c.emit("beforeLoopFix");
  const {
    slides: d,
    allowSlidePrev: u,
    allowSlideNext: f,
    slidesEl: p,
    params: h
  } = c, {
    centeredSlides: g
  } = h;
  if (c.allowSlidePrev = !0, c.allowSlideNext = !0, c.virtual && h.virtual.enabled) {
    n && (!h.centeredSlides && c.snapIndex === 0 ? c.slideTo(c.virtual.slides.length, 0, !1, !0) : h.centeredSlides && c.snapIndex < h.slidesPerView ? c.slideTo(c.virtual.slides.length + c.snapIndex, 0, !1, !0) : c.snapIndex === c.snapGrid.length - 1 && c.slideTo(c.virtual.slidesBefore, 0, !1, !0)), c.allowSlidePrev = u, c.allowSlideNext = f, c.emit("loopFix");
    return;
  }
  let v = h.slidesPerView;
  v === "auto" ? v = c.slidesPerViewDynamic() : (v = Math.ceil(parseFloat(h.slidesPerView, 10)), g && v % 2 === 0 && (v = v + 1));
  const x = h.slidesPerGroupAuto ? v : h.slidesPerGroup;
  let m = x;
  m % x !== 0 && (m += x - m % x), m += h.loopAdditionalSlides, c.loopedSlides = m;
  const b = c.grid && h.grid && h.grid.rows > 1;
  d.length < v + m ? Mi("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : b && h.grid.fill === "row" && Mi("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const _ = [], C = [];
  let w = c.activeIndex;
  typeof i > "u" ? i = c.getSlideIndex(d.filter((k) => k.classList.contains(h.slideActiveClass))[0]) : w = i;
  const N = r === "next" || !r, M = r === "prev" || !r;
  let S = 0, T = 0;
  const j = b ? Math.ceil(d.length / h.grid.rows) : d.length, A = (b ? d[i].column : i) + (g && typeof a > "u" ? -v / 2 + 0.5 : 0);
  if (A < m) {
    S = Math.max(m - A, x);
    for (let k = 0; k < m - A; k += 1) {
      const $ = k - Math.floor(k / j) * j;
      if (b) {
        const R = j - $ - 1;
        for (let F = d.length - 1; F >= 0; F -= 1)
          d[F].column === R && _.push(F);
      } else
        _.push(j - $ - 1);
    }
  } else if (A + v > j - m) {
    T = Math.max(A - (j - m * 2), x);
    for (let k = 0; k < T; k += 1) {
      const $ = k - Math.floor(k / j) * j;
      b ? d.forEach((R, F) => {
        R.column === $ && C.push(F);
      }) : C.push($);
    }
  }
  if (c.__preventObserver__ = !0, requestAnimationFrame(() => {
    c.__preventObserver__ = !1;
  }), M && _.forEach((k) => {
    d[k].swiperLoopMoveDOM = !0, p.prepend(d[k]), d[k].swiperLoopMoveDOM = !1;
  }), N && C.forEach((k) => {
    d[k].swiperLoopMoveDOM = !0, p.append(d[k]), d[k].swiperLoopMoveDOM = !1;
  }), c.recalcSlides(), h.slidesPerView === "auto" ? c.updateSlides() : b && (_.length > 0 && M || C.length > 0 && N) && c.slides.forEach((k, $) => {
    c.grid.updateSlide($, k, c.slides);
  }), h.watchSlidesProgress && c.updateSlidesOffset(), n) {
    if (_.length > 0 && M) {
      if (typeof t > "u") {
        const k = c.slidesGrid[w], R = c.slidesGrid[w + S] - k;
        o ? c.setTranslate(c.translate - R) : (c.slideTo(w + Math.ceil(S), 0, !1, !0), a && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - R, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - R));
      } else if (a) {
        const k = b ? _.length / h.grid.rows : _.length;
        c.slideTo(c.activeIndex + k, 0, !1, !0), c.touchEventsData.currentTranslate = c.translate;
      }
    } else if (C.length > 0 && N)
      if (typeof t > "u") {
        const k = c.slidesGrid[w], R = c.slidesGrid[w - T] - k;
        o ? c.setTranslate(c.translate - R) : (c.slideTo(w - T, 0, !1, !0), a && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - R, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - R));
      } else {
        const k = b ? C.length / h.grid.rows : C.length;
        c.slideTo(c.activeIndex - k, 0, !1, !0);
      }
  }
  if (c.allowSlidePrev = u, c.allowSlideNext = f, c.controller && c.controller.control && !s) {
    const k = {
      slideRealIndex: t,
      direction: r,
      setTranslate: a,
      activeSlideIndex: i,
      byController: !0
    };
    Array.isArray(c.controller.control) ? c.controller.control.forEach(($) => {
      !$.destroyed && $.params.loop && $.loopFix({
        ...k,
        slideTo: $.params.slidesPerView === h.slidesPerView ? n : !1
      });
    }) : c.controller.control instanceof c.constructor && c.controller.control.params.loop && c.controller.control.loopFix({
      ...k,
      slideTo: c.controller.control.params.slidesPerView === h.slidesPerView ? n : !1
    });
  }
  c.emit("loopFix");
}
function th() {
  const e = this, {
    params: t,
    slidesEl: n
  } = e;
  if (!t.loop || e.virtual && e.params.virtual.enabled)
    return;
  e.recalcSlides();
  const r = [];
  e.slides.forEach((a) => {
    const i = typeof a.swiperSlideIndex > "u" ? a.getAttribute("data-swiper-slide-index") * 1 : a.swiperSlideIndex;
    r[i] = a;
  }), e.slides.forEach((a) => {
    a.removeAttribute("data-swiper-slide-index");
  }), r.forEach((a) => {
    n.append(a);
  }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
var nh = {
  loopCreate: J9,
  loopFix: eh,
  loopDestroy: th
};
function rh(e) {
  const t = this;
  if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)
    return;
  const n = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  t.isElement && (t.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  });
}
function ah() {
  const e = this;
  e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  }));
}
var ih = {
  setGrabCursor: rh,
  unsetGrabCursor: ah
};
function sh(e, t) {
  t === void 0 && (t = this);
  function n(r) {
    if (!r || r === pt() || r === ht())
      return null;
    r.assignedSlot && (r = r.assignedSlot);
    const a = r.closest(e);
    return !a && !r.getRootNode ? null : a || n(r.getRootNode().host);
  }
  return n(t);
}
function ul(e, t, n) {
  const r = ht(), {
    params: a
  } = e, i = a.edgeSwipeDetection, s = a.edgeSwipeThreshold;
  return i && (n <= s || n >= r.innerWidth - s) ? i === "prevent" ? (t.preventDefault(), !0) : !1 : !0;
}
function oh(e) {
  const t = this, n = pt();
  let r = e;
  r.originalEvent && (r = r.originalEvent);
  const a = t.touchEventsData;
  if (r.type === "pointerdown") {
    if (a.pointerId !== null && a.pointerId !== r.pointerId)
      return;
    a.pointerId = r.pointerId;
  } else
    r.type === "touchstart" && r.targetTouches.length === 1 && (a.touchId = r.targetTouches[0].identifier);
  if (r.type === "touchstart") {
    ul(t, r, r.targetTouches[0].pageX);
    return;
  }
  const {
    params: i,
    touches: s,
    enabled: o
  } = t;
  if (!o || !i.simulateTouch && r.pointerType === "mouse" || t.animating && i.preventInteractionOnTransition)
    return;
  !t.animating && i.cssMode && i.loop && t.loopFix();
  let c = r.target;
  if (i.touchEventsTarget === "wrapper" && !t.wrapperEl.contains(c) || "which" in r && r.which === 3 || "button" in r && r.button > 0 || a.isTouched && a.isMoved)
    return;
  const d = !!i.noSwipingClass && i.noSwipingClass !== "", u = r.composedPath ? r.composedPath() : r.path;
  d && r.target && r.target.shadowRoot && u && (c = u[0]);
  const f = i.noSwipingSelector ? i.noSwipingSelector : `.${i.noSwipingClass}`, p = !!(r.target && r.target.shadowRoot);
  if (i.noSwiping && (p ? sh(f, c) : c.closest(f))) {
    t.allowClick = !0;
    return;
  }
  if (i.swipeHandler && !c.closest(i.swipeHandler))
    return;
  s.currentX = r.pageX, s.currentY = r.pageY;
  const h = s.currentX, g = s.currentY;
  if (!ul(t, r, h))
    return;
  Object.assign(a, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), s.startX = h, s.startY = g, a.touchStartTime = Li(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, i.threshold > 0 && (a.allowThresholdMove = !1);
  let v = !0;
  c.matches(a.focusableElements) && (v = !1, c.nodeName === "SELECT" && (a.isTouched = !1)), n.activeElement && n.activeElement.matches(a.focusableElements) && n.activeElement !== c && n.activeElement.blur();
  const x = v && t.allowTouchMove && i.touchStartPreventDefault;
  (i.touchStartForcePreventDefault || x) && !c.isContentEditable && r.preventDefault(), i.freeMode && i.freeMode.enabled && t.freeMode && t.animating && !i.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", r);
}
function ch(e) {
  const t = pt(), n = this, r = n.touchEventsData, {
    params: a,
    touches: i,
    rtlTranslate: s,
    enabled: o
  } = n;
  if (!o || !a.simulateTouch && e.pointerType === "mouse")
    return;
  let c = e;
  if (c.originalEvent && (c = c.originalEvent), c.type === "pointermove" && (r.touchId !== null || c.pointerId !== r.pointerId))
    return;
  let d;
  if (c.type === "touchmove") {
    if (d = [...c.changedTouches].filter((N) => N.identifier === r.touchId)[0], !d || d.identifier !== r.touchId)
      return;
  } else
    d = c;
  if (!r.isTouched) {
    r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", c);
    return;
  }
  const u = d.pageX, f = d.pageY;
  if (c.preventedByNestedSwiper) {
    i.startX = u, i.startY = f;
    return;
  }
  if (!n.allowTouchMove) {
    c.target.matches(r.focusableElements) || (n.allowClick = !1), r.isTouched && (Object.assign(i, {
      startX: u,
      startY: f,
      currentX: u,
      currentY: f
    }), r.touchStartTime = Li());
    return;
  }
  if (a.touchReleaseOnEdges && !a.loop) {
    if (n.isVertical()) {
      if (f < i.startY && n.translate <= n.maxTranslate() || f > i.startY && n.translate >= n.minTranslate()) {
        r.isTouched = !1, r.isMoved = !1;
        return;
      }
    } else if (u < i.startX && n.translate <= n.maxTranslate() || u > i.startX && n.translate >= n.minTranslate())
      return;
  }
  if (t.activeElement && c.target === t.activeElement && c.target.matches(r.focusableElements)) {
    r.isMoved = !0, n.allowClick = !1;
    return;
  }
  r.allowTouchCallbacks && n.emit("touchMove", c), i.previousX = i.currentX, i.previousY = i.currentY, i.currentX = u, i.currentY = f;
  const p = i.currentX - i.startX, h = i.currentY - i.startY;
  if (n.params.threshold && Math.sqrt(p ** 2 + h ** 2) < n.params.threshold)
    return;
  if (typeof r.isScrolling > "u") {
    let N;
    n.isHorizontal() && i.currentY === i.startY || n.isVertical() && i.currentX === i.startX ? r.isScrolling = !1 : p * p + h * h >= 25 && (N = Math.atan2(Math.abs(h), Math.abs(p)) * 180 / Math.PI, r.isScrolling = n.isHorizontal() ? N > a.touchAngle : 90 - N > a.touchAngle);
  }
  if (r.isScrolling && n.emit("touchMoveOpposite", c), typeof r.startMoving > "u" && (i.currentX !== i.startX || i.currentY !== i.startY) && (r.startMoving = !0), r.isScrolling || c.type === "touchmove" && r.preventTouchMoveFromPointerMove) {
    r.isTouched = !1;
    return;
  }
  if (!r.startMoving)
    return;
  n.allowClick = !1, !a.cssMode && c.cancelable && c.preventDefault(), a.touchMoveStopPropagation && !a.nested && c.stopPropagation();
  let g = n.isHorizontal() ? p : h, v = n.isHorizontal() ? i.currentX - i.previousX : i.currentY - i.previousY;
  a.oneWayMovement && (g = Math.abs(g) * (s ? 1 : -1), v = Math.abs(v) * (s ? 1 : -1)), i.diff = g, g *= a.touchRatio, s && (g = -g, v = -v);
  const x = n.touchesDirection;
  n.swipeDirection = g > 0 ? "prev" : "next", n.touchesDirection = v > 0 ? "prev" : "next";
  const m = n.params.loop && !a.cssMode, b = n.touchesDirection === "next" && n.allowSlideNext || n.touchesDirection === "prev" && n.allowSlidePrev;
  if (!r.isMoved) {
    if (m && b && n.loopFix({
      direction: n.swipeDirection
    }), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
      const N = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0
      });
      n.wrapperEl.dispatchEvent(N);
    }
    r.allowMomentumBounce = !1, a.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", c);
  }
  let _;
  if ((/* @__PURE__ */ new Date()).getTime(), r.isMoved && r.allowThresholdMove && x !== n.touchesDirection && m && b && Math.abs(g) >= 1) {
    Object.assign(i, {
      startX: u,
      startY: f,
      currentX: u,
      currentY: f,
      startTranslate: r.currentTranslate
    }), r.loopSwapReset = !0, r.startTranslate = r.currentTranslate;
    return;
  }
  n.emit("sliderMove", c), r.isMoved = !0, r.currentTranslate = g + r.startTranslate;
  let C = !0, w = a.resistanceRatio;
  if (a.touchReleaseOnEdges && (w = 0), g > 0 ? (m && b && !_ && r.allowThresholdMove && r.currentTranslate > (a.centeredSlides ? n.minTranslate() - n.slidesSizesGrid[n.activeIndex + 1] : n.minTranslate()) && n.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), r.currentTranslate > n.minTranslate() && (C = !1, a.resistance && (r.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + r.startTranslate + g) ** w))) : g < 0 && (m && b && !_ && r.allowThresholdMove && r.currentTranslate < (a.centeredSlides ? n.maxTranslate() + n.slidesSizesGrid[n.slidesSizesGrid.length - 1] : n.maxTranslate()) && n.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: n.slides.length - (a.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(a.slidesPerView, 10)))
  }), r.currentTranslate < n.maxTranslate() && (C = !1, a.resistance && (r.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - r.startTranslate - g) ** w))), C && (c.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (r.currentTranslate = r.startTranslate), a.threshold > 0)
    if (Math.abs(g) > a.threshold || r.allowThresholdMove) {
      if (!r.allowThresholdMove) {
        r.allowThresholdMove = !0, i.startX = i.currentX, i.startY = i.currentY, r.currentTranslate = r.startTranslate, i.diff = n.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY;
        return;
      }
    } else {
      r.currentTranslate = r.startTranslate;
      return;
    }
  !a.followFinger || a.cssMode || ((a.freeMode && a.freeMode.enabled && n.freeMode || a.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), a.freeMode && a.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate));
}
function lh(e) {
  const t = this, n = t.touchEventsData;
  let r = e;
  r.originalEvent && (r = r.originalEvent);
  let a;
  if (r.type === "touchend" || r.type === "touchcancel") {
    if (a = [...r.changedTouches].filter((w) => w.identifier === n.touchId)[0], !a || a.identifier !== n.touchId)
      return;
  } else {
    if (n.touchId !== null || r.pointerId !== n.pointerId)
      return;
    a = r;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(r.type) && !(["pointercancel", "contextmenu"].includes(r.type) && (t.browser.isSafari || t.browser.isWebView)))
    return;
  n.pointerId = null, n.touchId = null;
  const {
    params: s,
    touches: o,
    rtlTranslate: c,
    slidesGrid: d,
    enabled: u
  } = t;
  if (!u || !s.simulateTouch && r.pointerType === "mouse")
    return;
  if (n.allowTouchCallbacks && t.emit("touchEnd", r), n.allowTouchCallbacks = !1, !n.isTouched) {
    n.isMoved && s.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
    return;
  }
  s.grabCursor && n.isMoved && n.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const f = Li(), p = f - n.touchStartTime;
  if (t.allowClick) {
    const w = r.path || r.composedPath && r.composedPath();
    t.updateClickedSlide(w && w[0] || r.target, w), t.emit("tap click", r), p < 300 && f - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", r);
  }
  if (n.lastClickTime = Li(), Si(() => {
    t.destroyed || (t.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !t.swipeDirection || o.diff === 0 && !n.loopSwapReset || n.currentTranslate === n.startTranslate && !n.loopSwapReset) {
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    return;
  }
  n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
  let h;
  if (s.followFinger ? h = c ? t.translate : -t.translate : h = -n.currentTranslate, s.cssMode)
    return;
  if (s.freeMode && s.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: h
    });
    return;
  }
  const g = h >= -t.maxTranslate() && !t.params.loop;
  let v = 0, x = t.slidesSizesGrid[0];
  for (let w = 0; w < d.length; w += w < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
    const N = w < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
    typeof d[w + N] < "u" ? (g || h >= d[w] && h < d[w + N]) && (v = w, x = d[w + N] - d[w]) : (g || h >= d[w]) && (v = w, x = d[d.length - 1] - d[d.length - 2]);
  }
  let m = null, b = null;
  s.rewind && (t.isBeginning ? b = s.virtual && s.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (m = 0));
  const _ = (h - d[v]) / x, C = v < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
  if (p > s.longSwipesMs) {
    if (!s.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (_ >= s.longSwipesRatio ? t.slideTo(s.rewind && t.isEnd ? m : v + C) : t.slideTo(v)), t.swipeDirection === "prev" && (_ > 1 - s.longSwipesRatio ? t.slideTo(v + C) : b !== null && _ < 0 && Math.abs(_) > s.longSwipesRatio ? t.slideTo(b) : t.slideTo(v));
  } else {
    if (!s.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (r.target === t.navigation.nextEl || r.target === t.navigation.prevEl) ? r.target === t.navigation.nextEl ? t.slideTo(v + C) : t.slideTo(v) : (t.swipeDirection === "next" && t.slideTo(m !== null ? m : v + C), t.swipeDirection === "prev" && t.slideTo(b !== null ? b : v));
  }
}
function fl() {
  const e = this, {
    params: t,
    el: n
  } = e;
  if (n && n.offsetWidth === 0)
    return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: r,
    allowSlidePrev: a,
    snapGrid: i
  } = e, s = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const o = s && t.loop;
  (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !o ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !s ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = a, e.allowSlideNext = r, e.params.watchOverflow && i !== e.snapGrid && e.checkOverflow();
}
function dh(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function uh() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: n,
    enabled: r
  } = e;
  if (!r)
    return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let a;
  const i = e.maxTranslate() - e.minTranslate();
  i === 0 ? a = 0 : a = (e.translate - e.minTranslate()) / i, a !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function fh(e) {
  const t = this;
  pi(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
function ph() {
  const e = this;
  e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
const I3 = (e, t) => {
  const n = pt(), {
    params: r,
    el: a,
    wrapperEl: i,
    device: s
  } = e, o = !!r.nested, c = t === "on" ? "addEventListener" : "removeEventListener", d = t;
  n[c]("touchstart", e.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), a[c]("touchstart", e.onTouchStart, {
    passive: !1
  }), a[c]("pointerdown", e.onTouchStart, {
    passive: !1
  }), n[c]("touchmove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), n[c]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), n[c]("touchend", e.onTouchEnd, {
    passive: !0
  }), n[c]("pointerup", e.onTouchEnd, {
    passive: !0
  }), n[c]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), n[c]("touchcancel", e.onTouchEnd, {
    passive: !0
  }), n[c]("pointerout", e.onTouchEnd, {
    passive: !0
  }), n[c]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), n[c]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (r.preventClicks || r.preventClicksPropagation) && a[c]("click", e.onClick, !0), r.cssMode && i[c]("scroll", e.onScroll), r.updateOnWindowResize ? e[d](s.ios || s.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", fl, !0) : e[d]("observerUpdate", fl, !0), a[c]("load", e.onLoad, {
    capture: !0
  });
};
function mh() {
  const e = this, {
    params: t
  } = e;
  e.onTouchStart = oh.bind(e), e.onTouchMove = ch.bind(e), e.onTouchEnd = lh.bind(e), e.onDocumentTouchStart = ph.bind(e), t.cssMode && (e.onScroll = uh.bind(e)), e.onClick = dh.bind(e), e.onLoad = fh.bind(e), I3(e, "on");
}
function hh() {
  I3(this, "off");
}
var gh = {
  attachEvents: mh,
  detachEvents: hh
};
const pl = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function vh() {
  const e = this, {
    realIndex: t,
    initialized: n,
    params: r,
    el: a
  } = e, i = r.breakpoints;
  if (!i || i && Object.keys(i).length === 0)
    return;
  const s = e.getBreakpoint(i, e.params.breakpointsBase, e.el);
  if (!s || e.currentBreakpoint === s)
    return;
  const c = (s in i ? i[s] : void 0) || e.originalParams, d = pl(e, r), u = pl(e, c), f = e.params.grabCursor, p = c.grabCursor, h = r.enabled;
  d && !u ? (a.classList.remove(`${r.containerModifierClass}grid`, `${r.containerModifierClass}grid-column`), e.emitContainerClasses()) : !d && u && (a.classList.add(`${r.containerModifierClass}grid`), (c.grid.fill && c.grid.fill === "column" || !c.grid.fill && r.grid.fill === "column") && a.classList.add(`${r.containerModifierClass}grid-column`), e.emitContainerClasses()), f && !p ? e.unsetGrabCursor() : !f && p && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((_) => {
    if (typeof c[_] > "u")
      return;
    const C = r[_] && r[_].enabled, w = c[_] && c[_].enabled;
    C && !w && e[_].disable(), !C && w && e[_].enable();
  });
  const g = c.direction && c.direction !== r.direction, v = r.loop && (c.slidesPerView !== r.slidesPerView || g), x = r.loop;
  g && n && e.changeDirection(), gt(e.params, c);
  const m = e.params.enabled, b = e.params.loop;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), h && !m ? e.disable() : !h && m && e.enable(), e.currentBreakpoint = s, e.emit("_beforeBreakpoint", c), n && (v ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !x && b ? (e.loopCreate(t), e.updateSlides()) : x && !b && e.loopDestroy()), e.emit("breakpoint", c);
}
function bh(e, t, n) {
  if (t === void 0 && (t = "window"), !e || t === "container" && !n)
    return;
  let r = !1;
  const a = ht(), i = t === "window" ? a.innerHeight : n.clientHeight, s = Object.keys(e).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const c = parseFloat(o.substr(1));
      return {
        value: i * c,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  s.sort((o, c) => parseInt(o.value, 10) - parseInt(c.value, 10));
  for (let o = 0; o < s.length; o += 1) {
    const {
      point: c,
      value: d
    } = s[o];
    t === "window" ? a.matchMedia(`(min-width: ${d}px)`).matches && (r = c) : d <= n.clientWidth && (r = c);
  }
  return r || "max";
}
var yh = {
  setBreakpoint: vh,
  getBreakpoint: bh
};
function xh(e, t) {
  const n = [];
  return e.forEach((r) => {
    typeof r == "object" ? Object.keys(r).forEach((a) => {
      r[a] && n.push(t + a);
    }) : typeof r == "string" && n.push(t + r);
  }), n;
}
function _h() {
  const e = this, {
    classNames: t,
    params: n,
    rtl: r,
    el: a,
    device: i
  } = e, s = xh(["initialized", n.direction, {
    "free-mode": e.params.freeMode && n.freeMode.enabled
  }, {
    autoheight: n.autoHeight
  }, {
    rtl: r
  }, {
    grid: n.grid && n.grid.rows > 1
  }, {
    "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
  }, {
    android: i.android
  }, {
    ios: i.ios
  }, {
    "css-mode": n.cssMode
  }, {
    centered: n.cssMode && n.centeredSlides
  }, {
    "watch-progress": n.watchSlidesProgress
  }], n.containerModifierClass);
  t.push(...s), a.classList.add(...t), e.emitContainerClasses();
}
function wh() {
  const e = this, {
    el: t,
    classNames: n
  } = e;
  t.classList.remove(...n), e.emitContainerClasses();
}
var Ch = {
  addClasses: _h,
  removeClasses: wh
};
function Sh() {
  const e = this, {
    isLocked: t,
    params: n
  } = e, {
    slidesOffsetBefore: r
  } = n;
  if (r) {
    const a = e.slides.length - 1, i = e.slidesGrid[a] + e.slidesSizesGrid[a] + r * 2;
    e.isLocked = e.size > i;
  } else
    e.isLocked = e.snapGrid.length === 1;
  n.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), n.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
var Lh = {
  checkOverflow: Sh
}, Es = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function Mh(e, t) {
  return function(r) {
    r === void 0 && (r = {});
    const a = Object.keys(r)[0], i = r[a];
    if (typeof i != "object" || i === null) {
      gt(t, r);
      return;
    }
    if (e[a] === !0 && (e[a] = {
      enabled: !0
    }), a === "navigation" && e[a] && e[a].enabled && !e[a].prevEl && !e[a].nextEl && (e[a].auto = !0), ["pagination", "scrollbar"].indexOf(a) >= 0 && e[a] && e[a].enabled && !e[a].el && (e[a].auto = !0), !(a in e && "enabled" in i)) {
      gt(t, r);
      return;
    }
    typeof e[a] == "object" && !("enabled" in e[a]) && (e[a].enabled = !0), e[a] || (e[a] = {
      enabled: !1
    }), gt(t, r);
  };
}
const j1 = {
  eventsEmitter: C9,
  update: A9,
  translate: F9,
  transition: q9,
  slide: Q9,
  loop: nh,
  grabCursor: ih,
  events: gh,
  breakpoints: yh,
  checkOverflow: Lh,
  classes: Ch
}, P1 = {};
let Ji = class en {
  constructor() {
    let t, n;
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    a.length === 1 && a[0].constructor && Object.prototype.toString.call(a[0]).slice(8, -1) === "Object" ? n = a[0] : [t, n] = a, n || (n = {}), n = gt({}, n), t && !n.el && (n.el = t);
    const s = pt();
    if (n.el && typeof n.el == "string" && s.querySelectorAll(n.el).length > 1) {
      const u = [];
      return s.querySelectorAll(n.el).forEach((f) => {
        const p = gt({}, n, {
          el: f
        });
        u.push(new en(p));
      }), u;
    }
    const o = this;
    o.__swiper__ = !0, o.support = P3(), o.device = A3({
      userAgent: n.userAgent
    }), o.browser = x9(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], n.modules && Array.isArray(n.modules) && o.modules.push(...n.modules);
    const c = {};
    o.modules.forEach((u) => {
      u({
        params: n,
        swiper: o,
        extendParams: Mh(n, c),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    const d = gt({}, Es, c);
    return o.params = gt({}, d, P1, n), o.originalParams = gt({}, o.params), o.passedParams = gt({}, n), o.params && o.params.on && Object.keys(o.params.on).forEach((u) => {
      o.on(u, o.params.on[u]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
      enabled: o.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return o.params.direction === "horizontal";
      },
      isVertical() {
        return o.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: o.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  getDirectionLabel(t) {
    return this.isHorizontal() ? t : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[t];
  }
  getSlideIndex(t) {
    const {
      slidesEl: n,
      params: r
    } = this, a = $t(n, `.${r.slideClass}, swiper-slide`), i = ba(a[0]);
    return ba(t) - i;
  }
  getSlideIndexByData(t) {
    return this.getSlideIndex(this.slides.filter((n) => n.getAttribute("data-swiper-slide-index") * 1 === t)[0]);
  }
  recalcSlides() {
    const t = this, {
      slidesEl: n,
      params: r
    } = t;
    t.slides = $t(n, `.${r.slideClass}, swiper-slide`);
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, n) {
    const r = this;
    t = Math.min(Math.max(t, 0), 1);
    const a = r.minTranslate(), s = (r.maxTranslate() - a) * t + a;
    r.translateTo(s, typeof n > "u" ? 0 : n), r.updateActiveIndex(), r.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el)
      return;
    const n = t.el.className.split(" ").filter((r) => r.indexOf("swiper") === 0 || r.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", n.join(" "));
  }
  getSlideClasses(t) {
    const n = this;
    return n.destroyed ? "" : t.className.split(" ").filter((r) => r.indexOf("swiper-slide") === 0 || r.indexOf(n.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el)
      return;
    const n = [];
    t.slides.forEach((r) => {
      const a = t.getSlideClasses(r);
      n.push({
        slideEl: r,
        classNames: a
      }), t.emit("_slideClass", r, a);
    }), t.emit("_slideClasses", n);
  }
  slidesPerViewDynamic(t, n) {
    t === void 0 && (t = "current"), n === void 0 && (n = !1);
    const r = this, {
      params: a,
      slides: i,
      slidesGrid: s,
      slidesSizesGrid: o,
      size: c,
      activeIndex: d
    } = r;
    let u = 1;
    if (typeof a.slidesPerView == "number")
      return a.slidesPerView;
    if (a.centeredSlides) {
      let f = i[d] ? Math.ceil(i[d].swiperSlideSize) : 0, p;
      for (let h = d + 1; h < i.length; h += 1)
        i[h] && !p && (f += Math.ceil(i[h].swiperSlideSize), u += 1, f > c && (p = !0));
      for (let h = d - 1; h >= 0; h -= 1)
        i[h] && !p && (f += i[h].swiperSlideSize, u += 1, f > c && (p = !0));
    } else if (t === "current")
      for (let f = d + 1; f < i.length; f += 1)
        (n ? s[f] + o[f] - s[d] < c : s[f] - s[d] < c) && (u += 1);
    else
      for (let f = d - 1; f >= 0; f -= 1)
        s[d] - s[f] < c && (u += 1);
    return u;
  }
  update() {
    const t = this;
    if (!t || t.destroyed)
      return;
    const {
      snapGrid: n,
      params: r
    } = t;
    r.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((s) => {
      s.complete && pi(t, s);
    }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function a() {
      const s = t.rtlTranslate ? t.translate * -1 : t.translate, o = Math.min(Math.max(s, t.maxTranslate()), t.minTranslate());
      t.setTranslate(o), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let i;
    if (r.freeMode && r.freeMode.enabled && !r.cssMode)
      a(), r.autoHeight && t.updateAutoHeight();
    else {
      if ((r.slidesPerView === "auto" || r.slidesPerView > 1) && t.isEnd && !r.centeredSlides) {
        const s = t.virtual && r.virtual.enabled ? t.virtual.slides : t.slides;
        i = t.slideTo(s.length - 1, 0, !1, !0);
      } else
        i = t.slideTo(t.activeIndex, 0, !1, !0);
      i || a();
    }
    r.watchOverflow && n !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, n) {
    n === void 0 && (n = !0);
    const r = this, a = r.params.direction;
    return t || (t = a === "horizontal" ? "vertical" : "horizontal"), t === a || t !== "horizontal" && t !== "vertical" || (r.el.classList.remove(`${r.params.containerModifierClass}${a}`), r.el.classList.add(`${r.params.containerModifierClass}${t}`), r.emitContainerClasses(), r.params.direction = t, r.slides.forEach((i) => {
      t === "vertical" ? i.style.width = "" : i.style.height = "";
    }), r.emit("changeDirection"), n && r.update()), r;
  }
  changeLanguageDirection(t) {
    const n = this;
    n.rtl && t === "rtl" || !n.rtl && t === "ltr" || (n.rtl = t === "rtl", n.rtlTranslate = n.params.direction === "horizontal" && n.rtl, n.rtl ? (n.el.classList.add(`${n.params.containerModifierClass}rtl`), n.el.dir = "rtl") : (n.el.classList.remove(`${n.params.containerModifierClass}rtl`), n.el.dir = "ltr"), n.update());
  }
  mount(t) {
    const n = this;
    if (n.mounted)
      return !0;
    let r = t || n.params.el;
    if (typeof r == "string" && (r = document.querySelector(r)), !r)
      return !1;
    r.swiper = n, r.parentNode && r.parentNode.host && r.parentNode.host.nodeName === n.params.swiperElementNodeName.toUpperCase() && (n.isElement = !0);
    const a = () => `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let s = r && r.shadowRoot && r.shadowRoot.querySelector ? r.shadowRoot.querySelector(a()) : $t(r, a())[0];
    return !s && n.params.createElements && (s = Vr("div", n.params.wrapperClass), r.append(s), $t(r, `.${n.params.slideClass}`).forEach((o) => {
      s.append(o);
    })), Object.assign(n, {
      el: r,
      wrapperEl: s,
      slidesEl: n.isElement && !r.parentNode.host.slideSlots ? r.parentNode.host : s,
      hostEl: n.isElement ? r.parentNode.host : r,
      mounted: !0,
      // RTL
      rtl: r.dir.toLowerCase() === "rtl" || Nn(r, "direction") === "rtl",
      rtlTranslate: n.params.direction === "horizontal" && (r.dir.toLowerCase() === "rtl" || Nn(r, "direction") === "rtl"),
      wrongRTL: Nn(s, "display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const n = this;
    if (n.initialized || n.mount(t) === !1)
      return n;
    n.emit("beforeInit"), n.params.breakpoints && n.setBreakpoint(), n.addClasses(), n.updateSize(), n.updateSlides(), n.params.watchOverflow && n.checkOverflow(), n.params.grabCursor && n.enabled && n.setGrabCursor(), n.params.loop && n.virtual && n.params.virtual.enabled ? n.slideTo(n.params.initialSlide + n.virtual.slidesBefore, 0, n.params.runCallbacksOnInit, !1, !0) : n.slideTo(n.params.initialSlide, 0, n.params.runCallbacksOnInit, !1, !0), n.params.loop && n.loopCreate(), n.attachEvents();
    const a = [...n.el.querySelectorAll('[loading="lazy"]')];
    return n.isElement && a.push(...n.hostEl.querySelectorAll('[loading="lazy"]')), a.forEach((i) => {
      i.complete ? pi(n, i) : i.addEventListener("load", (s) => {
        pi(n, s.target);
      });
    }), zs(n), n.initialized = !0, zs(n), n.emit("init"), n.emit("afterInit"), n;
  }
  destroy(t, n) {
    t === void 0 && (t = !0), n === void 0 && (n = !0);
    const r = this, {
      params: a,
      el: i,
      wrapperEl: s,
      slides: o
    } = r;
    return typeof r.params > "u" || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), a.loop && r.loopDestroy(), n && (r.removeClasses(), i.removeAttribute("style"), s.removeAttribute("style"), o && o.length && o.forEach((c) => {
      c.classList.remove(a.slideVisibleClass, a.slideFullyVisibleClass, a.slideActiveClass, a.slideNextClass, a.slidePrevClass), c.removeAttribute("style"), c.removeAttribute("data-swiper-slide-index");
    })), r.emit("destroy"), Object.keys(r.eventsListeners).forEach((c) => {
      r.off(c);
    }), t !== !1 && (r.el.swiper = null, l9(r)), r.destroyed = !0), null;
  }
  static extendDefaults(t) {
    gt(P1, t);
  }
  static get extendedDefaults() {
    return P1;
  }
  static get defaults() {
    return Es;
  }
  static installModule(t) {
    en.prototype.__modules__ || (en.prototype.__modules__ = []);
    const n = en.prototype.__modules__;
    typeof t == "function" && n.indexOf(t) < 0 && n.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((n) => en.installModule(n)), en) : (en.installModule(t), en);
  }
};
Object.keys(j1).forEach((e) => {
  Object.keys(j1[e]).forEach((t) => {
    Ji.prototype[t] = j1[e][t];
  });
});
Ji.use([_9, w9]);
function Vo(e, t, n, r) {
  return e.params.createElements && Object.keys(r).forEach((a) => {
    if (!n[a] && n.auto === !0) {
      let i = $t(e.el, `.${r[a]}`)[0];
      i || (i = Vr("div", r[a]), i.className = r[a], e.el.append(i)), n[a] = i, t[a] = i;
    }
  }), n;
}
function Nh(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: a
  } = e;
  n({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), t.navigation = {
    nextEl: null,
    prevEl: null
  };
  function i(g) {
    let v;
    return g && typeof g == "string" && t.isElement && (v = t.el.querySelector(g), v) ? v : (g && (typeof g == "string" && (v = [...document.querySelectorAll(g)]), t.params.uniqueNavElements && typeof g == "string" && v && v.length > 1 && t.el.querySelectorAll(g).length === 1 ? v = t.el.querySelector(g) : v && v.length === 1 && (v = v[0])), g && !v ? g : v);
  }
  function s(g, v) {
    const x = t.params.navigation;
    g = Se(g), g.forEach((m) => {
      m && (m.classList[v ? "add" : "remove"](...x.disabledClass.split(" ")), m.tagName === "BUTTON" && (m.disabled = v), t.params.watchOverflow && t.enabled && m.classList[t.isLocked ? "add" : "remove"](x.lockClass));
    });
  }
  function o() {
    const {
      nextEl: g,
      prevEl: v
    } = t.navigation;
    if (t.params.loop) {
      s(v, !1), s(g, !1);
      return;
    }
    s(v, t.isBeginning && !t.params.rewind), s(g, t.isEnd && !t.params.rewind);
  }
  function c(g) {
    g.preventDefault(), !(t.isBeginning && !t.params.loop && !t.params.rewind) && (t.slidePrev(), a("navigationPrev"));
  }
  function d(g) {
    g.preventDefault(), !(t.isEnd && !t.params.loop && !t.params.rewind) && (t.slideNext(), a("navigationNext"));
  }
  function u() {
    const g = t.params.navigation;
    if (t.params.navigation = Vo(t, t.originalParams.navigation, t.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(g.nextEl || g.prevEl))
      return;
    let v = i(g.nextEl), x = i(g.prevEl);
    Object.assign(t.navigation, {
      nextEl: v,
      prevEl: x
    }), v = Se(v), x = Se(x);
    const m = (b, _) => {
      b && b.addEventListener("click", _ === "next" ? d : c), !t.enabled && b && b.classList.add(...g.lockClass.split(" "));
    };
    v.forEach((b) => m(b, "next")), x.forEach((b) => m(b, "prev"));
  }
  function f() {
    let {
      nextEl: g,
      prevEl: v
    } = t.navigation;
    g = Se(g), v = Se(v);
    const x = (m, b) => {
      m.removeEventListener("click", b === "next" ? d : c), m.classList.remove(...t.params.navigation.disabledClass.split(" "));
    };
    g.forEach((m) => x(m, "next")), v.forEach((m) => x(m, "prev"));
  }
  r("init", () => {
    t.params.navigation.enabled === !1 ? h() : (u(), o());
  }), r("toEdge fromEdge lock unlock", () => {
    o();
  }), r("destroy", () => {
    f();
  }), r("enable disable", () => {
    let {
      nextEl: g,
      prevEl: v
    } = t.navigation;
    if (g = Se(g), v = Se(v), t.enabled) {
      o();
      return;
    }
    [...g, ...v].filter((x) => !!x).forEach((x) => x.classList.add(t.params.navigation.lockClass));
  }), r("click", (g, v) => {
    let {
      nextEl: x,
      prevEl: m
    } = t.navigation;
    x = Se(x), m = Se(m);
    const b = v.target;
    if (t.params.navigation.hideOnClick && !m.includes(b) && !x.includes(b)) {
      if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === b || t.pagination.el.contains(b)))
        return;
      let _;
      x.length ? _ = x[0].classList.contains(t.params.navigation.hiddenClass) : m.length && (_ = m[0].classList.contains(t.params.navigation.hiddenClass)), a(_ === !0 ? "navigationShow" : "navigationHide"), [...x, ...m].filter((C) => !!C).forEach((C) => C.classList.toggle(t.params.navigation.hiddenClass));
    }
  });
  const p = () => {
    t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")), u(), o();
  }, h = () => {
    t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")), f();
  };
  Object.assign(t.navigation, {
    enable: p,
    disable: h,
    update: o,
    init: u,
    destroy: f
  });
}
function rn(e) {
  return e === void 0 && (e = ""), `.${e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function zh(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: a
  } = e;
  const i = "swiper-pagination";
  n({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (m) => m,
      formatFractionTotal: (m) => m,
      bulletClass: `${i}-bullet`,
      bulletActiveClass: `${i}-bullet-active`,
      modifierClass: `${i}-`,
      currentClass: `${i}-current`,
      totalClass: `${i}-total`,
      hiddenClass: `${i}-hidden`,
      progressbarFillClass: `${i}-progressbar-fill`,
      progressbarOppositeClass: `${i}-progressbar-opposite`,
      clickableClass: `${i}-clickable`,
      lockClass: `${i}-lock`,
      horizontalClass: `${i}-horizontal`,
      verticalClass: `${i}-vertical`,
      paginationDisabledClass: `${i}-disabled`
    }
  }), t.pagination = {
    el: null,
    bullets: []
  };
  let s, o = 0;
  function c() {
    return !t.params.pagination.el || !t.pagination.el || Array.isArray(t.pagination.el) && t.pagination.el.length === 0;
  }
  function d(m, b) {
    const {
      bulletActiveClass: _
    } = t.params.pagination;
    m && (m = m[`${b === "prev" ? "previous" : "next"}ElementSibling`], m && (m.classList.add(`${_}-${b}`), m = m[`${b === "prev" ? "previous" : "next"}ElementSibling`], m && m.classList.add(`${_}-${b}-${b}`)));
  }
  function u(m) {
    const b = m.target.closest(rn(t.params.pagination.bulletClass));
    if (!b)
      return;
    m.preventDefault();
    const _ = ba(b) * t.params.slidesPerGroup;
    if (t.params.loop) {
      if (t.realIndex === _)
        return;
      t.slideToLoop(_);
    } else
      t.slideTo(_);
  }
  function f() {
    const m = t.rtl, b = t.params.pagination;
    if (c())
      return;
    let _ = t.pagination.el;
    _ = Se(_);
    let C, w;
    const N = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length, M = t.params.loop ? Math.ceil(N / t.params.slidesPerGroup) : t.snapGrid.length;
    if (t.params.loop ? (w = t.previousRealIndex || 0, C = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex) : typeof t.snapIndex < "u" ? (C = t.snapIndex, w = t.previousSnapIndex) : (w = t.previousIndex || 0, C = t.activeIndex || 0), b.type === "bullets" && t.pagination.bullets && t.pagination.bullets.length > 0) {
      const S = t.pagination.bullets;
      let T, j, D;
      if (b.dynamicBullets && (s = Ns(S[0], t.isHorizontal() ? "width" : "height", !0), _.forEach((A) => {
        A.style[t.isHorizontal() ? "width" : "height"] = `${s * (b.dynamicMainBullets + 4)}px`;
      }), b.dynamicMainBullets > 1 && w !== void 0 && (o += C - (w || 0), o > b.dynamicMainBullets - 1 ? o = b.dynamicMainBullets - 1 : o < 0 && (o = 0)), T = Math.max(C - o, 0), j = T + (Math.min(S.length, b.dynamicMainBullets) - 1), D = (j + T) / 2), S.forEach((A) => {
        const k = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(($) => `${b.bulletActiveClass}${$}`)].map(($) => typeof $ == "string" && $.includes(" ") ? $.split(" ") : $).flat();
        A.classList.remove(...k);
      }), _.length > 1)
        S.forEach((A) => {
          const k = ba(A);
          k === C ? A.classList.add(...b.bulletActiveClass.split(" ")) : t.isElement && A.setAttribute("part", "bullet"), b.dynamicBullets && (k >= T && k <= j && A.classList.add(...`${b.bulletActiveClass}-main`.split(" ")), k === T && d(A, "prev"), k === j && d(A, "next"));
        });
      else {
        const A = S[C];
        if (A && A.classList.add(...b.bulletActiveClass.split(" ")), t.isElement && S.forEach((k, $) => {
          k.setAttribute("part", $ === C ? "bullet-active" : "bullet");
        }), b.dynamicBullets) {
          const k = S[T], $ = S[j];
          for (let R = T; R <= j; R += 1)
            S[R] && S[R].classList.add(...`${b.bulletActiveClass}-main`.split(" "));
          d(k, "prev"), d($, "next");
        }
      }
      if (b.dynamicBullets) {
        const A = Math.min(S.length, b.dynamicMainBullets + 4), k = (s * A - s) / 2 - D * s, $ = m ? "right" : "left";
        S.forEach((R) => {
          R.style[t.isHorizontal() ? $ : "top"] = `${k}px`;
        });
      }
    }
    _.forEach((S, T) => {
      if (b.type === "fraction" && (S.querySelectorAll(rn(b.currentClass)).forEach((j) => {
        j.textContent = b.formatFractionCurrent(C + 1);
      }), S.querySelectorAll(rn(b.totalClass)).forEach((j) => {
        j.textContent = b.formatFractionTotal(M);
      })), b.type === "progressbar") {
        let j;
        b.progressbarOpposite ? j = t.isHorizontal() ? "vertical" : "horizontal" : j = t.isHorizontal() ? "horizontal" : "vertical";
        const D = (C + 1) / M;
        let A = 1, k = 1;
        j === "horizontal" ? A = D : k = D, S.querySelectorAll(rn(b.progressbarFillClass)).forEach(($) => {
          $.style.transform = `translate3d(0,0,0) scaleX(${A}) scaleY(${k})`, $.style.transitionDuration = `${t.params.speed}ms`;
        });
      }
      b.type === "custom" && b.renderCustom ? (S.innerHTML = b.renderCustom(t, C + 1, M), T === 0 && a("paginationRender", S)) : (T === 0 && a("paginationRender", S), a("paginationUpdate", S)), t.params.watchOverflow && t.enabled && S.classList[t.isLocked ? "add" : "remove"](b.lockClass);
    });
  }
  function p() {
    const m = t.params.pagination;
    if (c())
      return;
    const b = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.grid && t.params.grid.rows > 1 ? t.slides.length / Math.ceil(t.params.grid.rows) : t.slides.length;
    let _ = t.pagination.el;
    _ = Se(_);
    let C = "";
    if (m.type === "bullets") {
      let w = t.params.loop ? Math.ceil(b / t.params.slidesPerGroup) : t.snapGrid.length;
      t.params.freeMode && t.params.freeMode.enabled && w > b && (w = b);
      for (let N = 0; N < w; N += 1)
        m.renderBullet ? C += m.renderBullet.call(t, N, m.bulletClass) : C += `<${m.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${m.bulletClass}"></${m.bulletElement}>`;
    }
    m.type === "fraction" && (m.renderFraction ? C = m.renderFraction.call(t, m.currentClass, m.totalClass) : C = `<span class="${m.currentClass}"></span> / <span class="${m.totalClass}"></span>`), m.type === "progressbar" && (m.renderProgressbar ? C = m.renderProgressbar.call(t, m.progressbarFillClass) : C = `<span class="${m.progressbarFillClass}"></span>`), t.pagination.bullets = [], _.forEach((w) => {
      m.type !== "custom" && (w.innerHTML = C || ""), m.type === "bullets" && t.pagination.bullets.push(...w.querySelectorAll(rn(m.bulletClass)));
    }), m.type !== "custom" && a("paginationRender", _[0]);
  }
  function h() {
    t.params.pagination = Vo(t, t.originalParams.pagination, t.params.pagination, {
      el: "swiper-pagination"
    });
    const m = t.params.pagination;
    if (!m.el)
      return;
    let b;
    typeof m.el == "string" && t.isElement && (b = t.el.querySelector(m.el)), !b && typeof m.el == "string" && (b = [...document.querySelectorAll(m.el)]), b || (b = m.el), !(!b || b.length === 0) && (t.params.uniqueNavElements && typeof m.el == "string" && Array.isArray(b) && b.length > 1 && (b = [...t.el.querySelectorAll(m.el)], b.length > 1 && (b = b.filter((_) => j3(_, ".swiper")[0] === t.el)[0])), Array.isArray(b) && b.length === 1 && (b = b[0]), Object.assign(t.pagination, {
      el: b
    }), b = Se(b), b.forEach((_) => {
      m.type === "bullets" && m.clickable && _.classList.add(...(m.clickableClass || "").split(" ")), _.classList.add(m.modifierClass + m.type), _.classList.add(t.isHorizontal() ? m.horizontalClass : m.verticalClass), m.type === "bullets" && m.dynamicBullets && (_.classList.add(`${m.modifierClass}${m.type}-dynamic`), o = 0, m.dynamicMainBullets < 1 && (m.dynamicMainBullets = 1)), m.type === "progressbar" && m.progressbarOpposite && _.classList.add(m.progressbarOppositeClass), m.clickable && _.addEventListener("click", u), t.enabled || _.classList.add(m.lockClass);
    }));
  }
  function g() {
    const m = t.params.pagination;
    if (c())
      return;
    let b = t.pagination.el;
    b && (b = Se(b), b.forEach((_) => {
      _.classList.remove(m.hiddenClass), _.classList.remove(m.modifierClass + m.type), _.classList.remove(t.isHorizontal() ? m.horizontalClass : m.verticalClass), m.clickable && (_.classList.remove(...(m.clickableClass || "").split(" ")), _.removeEventListener("click", u));
    })), t.pagination.bullets && t.pagination.bullets.forEach((_) => _.classList.remove(...m.bulletActiveClass.split(" ")));
  }
  r("changeDirection", () => {
    if (!t.pagination || !t.pagination.el)
      return;
    const m = t.params.pagination;
    let {
      el: b
    } = t.pagination;
    b = Se(b), b.forEach((_) => {
      _.classList.remove(m.horizontalClass, m.verticalClass), _.classList.add(t.isHorizontal() ? m.horizontalClass : m.verticalClass);
    });
  }), r("init", () => {
    t.params.pagination.enabled === !1 ? x() : (h(), p(), f());
  }), r("activeIndexChange", () => {
    typeof t.snapIndex > "u" && f();
  }), r("snapIndexChange", () => {
    f();
  }), r("snapGridLengthChange", () => {
    p(), f();
  }), r("destroy", () => {
    g();
  }), r("enable disable", () => {
    let {
      el: m
    } = t.pagination;
    m && (m = Se(m), m.forEach((b) => b.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)));
  }), r("lock unlock", () => {
    f();
  }), r("click", (m, b) => {
    const _ = b.target, C = Se(t.pagination.el);
    if (t.params.pagination.el && t.params.pagination.hideOnClick && C && C.length > 0 && !_.classList.contains(t.params.pagination.bulletClass)) {
      if (t.navigation && (t.navigation.nextEl && _ === t.navigation.nextEl || t.navigation.prevEl && _ === t.navigation.prevEl))
        return;
      const w = C[0].classList.contains(t.params.pagination.hiddenClass);
      a(w === !0 ? "paginationShow" : "paginationHide"), C.forEach((N) => N.classList.toggle(t.params.pagination.hiddenClass));
    }
  });
  const v = () => {
    t.el.classList.remove(t.params.pagination.paginationDisabledClass);
    let {
      el: m
    } = t.pagination;
    m && (m = Se(m), m.forEach((b) => b.classList.remove(t.params.pagination.paginationDisabledClass))), h(), p(), f();
  }, x = () => {
    t.el.classList.add(t.params.pagination.paginationDisabledClass);
    let {
      el: m
    } = t.pagination;
    m && (m = Se(m), m.forEach((b) => b.classList.add(t.params.pagination.paginationDisabledClass))), g();
  };
  Object.assign(t.pagination, {
    enable: v,
    disable: x,
    render: p,
    update: f,
    init: h,
    destroy: g
  });
}
function Eh(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: a
  } = e;
  const i = pt();
  let s = !1, o = null, c = null, d, u, f, p;
  n({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), t.scrollbar = {
    el: null,
    dragEl: null
  };
  function h() {
    if (!t.params.scrollbar.el || !t.scrollbar.el)
      return;
    const {
      scrollbar: A,
      rtlTranslate: k
    } = t, {
      dragEl: $,
      el: R
    } = A, F = t.params.scrollbar, P = t.params.loop ? t.progressLoop : t.progress;
    let I = u, H = (f - u) * P;
    k ? (H = -H, H > 0 ? (I = u - H, H = 0) : -H + u > f && (I = f + H)) : H < 0 ? (I = u + H, H = 0) : H + u > f && (I = f - H), t.isHorizontal() ? ($.style.transform = `translate3d(${H}px, 0, 0)`, $.style.width = `${I}px`) : ($.style.transform = `translate3d(0px, ${H}px, 0)`, $.style.height = `${I}px`), F.hide && (clearTimeout(o), R.style.opacity = 1, o = setTimeout(() => {
      R.style.opacity = 0, R.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function g(A) {
    !t.params.scrollbar.el || !t.scrollbar.el || (t.scrollbar.dragEl.style.transitionDuration = `${A}ms`);
  }
  function v() {
    if (!t.params.scrollbar.el || !t.scrollbar.el)
      return;
    const {
      scrollbar: A
    } = t, {
      dragEl: k,
      el: $
    } = A;
    k.style.width = "", k.style.height = "", f = t.isHorizontal() ? $.offsetWidth : $.offsetHeight, p = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0)), t.params.scrollbar.dragSize === "auto" ? u = f * p : u = parseInt(t.params.scrollbar.dragSize, 10), t.isHorizontal() ? k.style.width = `${u}px` : k.style.height = `${u}px`, p >= 1 ? $.style.display = "none" : $.style.display = "", t.params.scrollbar.hide && ($.style.opacity = 0), t.params.watchOverflow && t.enabled && A.el.classList[t.isLocked ? "add" : "remove"](t.params.scrollbar.lockClass);
  }
  function x(A) {
    return t.isHorizontal() ? A.clientX : A.clientY;
  }
  function m(A) {
    const {
      scrollbar: k,
      rtlTranslate: $
    } = t, {
      el: R
    } = k;
    let F;
    F = (x(A) - p9(R)[t.isHorizontal() ? "left" : "top"] - (d !== null ? d : u / 2)) / (f - u), F = Math.max(Math.min(F, 1), 0), $ && (F = 1 - F);
    const P = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * F;
    t.updateProgress(P), t.setTranslate(P), t.updateActiveIndex(), t.updateSlidesClasses();
  }
  function b(A) {
    const k = t.params.scrollbar, {
      scrollbar: $,
      wrapperEl: R
    } = t, {
      el: F,
      dragEl: P
    } = $;
    s = !0, d = A.target === P ? x(A) - A.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null, A.preventDefault(), A.stopPropagation(), R.style.transitionDuration = "100ms", P.style.transitionDuration = "100ms", m(A), clearTimeout(c), F.style.transitionDuration = "0ms", k.hide && (F.style.opacity = 1), t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"), a("scrollbarDragStart", A);
  }
  function _(A) {
    const {
      scrollbar: k,
      wrapperEl: $
    } = t, {
      el: R,
      dragEl: F
    } = k;
    s && (A.preventDefault && A.cancelable ? A.preventDefault() : A.returnValue = !1, m(A), $.style.transitionDuration = "0ms", R.style.transitionDuration = "0ms", F.style.transitionDuration = "0ms", a("scrollbarDragMove", A));
  }
  function C(A) {
    const k = t.params.scrollbar, {
      scrollbar: $,
      wrapperEl: R
    } = t, {
      el: F
    } = $;
    s && (s = !1, t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "", R.style.transitionDuration = ""), k.hide && (clearTimeout(c), c = Si(() => {
      F.style.opacity = 0, F.style.transitionDuration = "400ms";
    }, 1e3)), a("scrollbarDragEnd", A), k.snapOnRelease && t.slideToClosest());
  }
  function w(A) {
    const {
      scrollbar: k,
      params: $
    } = t, R = k.el;
    if (!R)
      return;
    const F = R, P = $.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, I = $.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!F)
      return;
    const H = A === "on" ? "addEventListener" : "removeEventListener";
    F[H]("pointerdown", b, P), i[H]("pointermove", _, P), i[H]("pointerup", C, I);
  }
  function N() {
    !t.params.scrollbar.el || !t.scrollbar.el || w("on");
  }
  function M() {
    !t.params.scrollbar.el || !t.scrollbar.el || w("off");
  }
  function S() {
    const {
      scrollbar: A,
      el: k
    } = t;
    t.params.scrollbar = Vo(t, t.originalParams.scrollbar, t.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const $ = t.params.scrollbar;
    if (!$.el)
      return;
    let R;
    if (typeof $.el == "string" && t.isElement && (R = t.el.querySelector($.el)), !R && typeof $.el == "string") {
      if (R = i.querySelectorAll($.el), !R.length)
        return;
    } else
      R || (R = $.el);
    t.params.uniqueNavElements && typeof $.el == "string" && R.length > 1 && k.querySelectorAll($.el).length === 1 && (R = k.querySelector($.el)), R.length > 0 && (R = R[0]), R.classList.add(t.isHorizontal() ? $.horizontalClass : $.verticalClass);
    let F;
    R && (F = R.querySelector(rn(t.params.scrollbar.dragClass)), F || (F = Vr("div", t.params.scrollbar.dragClass), R.append(F))), Object.assign(A, {
      el: R,
      dragEl: F
    }), $.draggable && N(), R && R.classList[t.enabled ? "remove" : "add"](...Mn(t.params.scrollbar.lockClass));
  }
  function T() {
    const A = t.params.scrollbar, k = t.scrollbar.el;
    k && k.classList.remove(...Mn(t.isHorizontal() ? A.horizontalClass : A.verticalClass)), M();
  }
  r("changeDirection", () => {
    if (!t.scrollbar || !t.scrollbar.el)
      return;
    const A = t.params.scrollbar;
    let {
      el: k
    } = t.scrollbar;
    k = Se(k), k.forEach(($) => {
      $.classList.remove(A.horizontalClass, A.verticalClass), $.classList.add(t.isHorizontal() ? A.horizontalClass : A.verticalClass);
    });
  }), r("init", () => {
    t.params.scrollbar.enabled === !1 ? D() : (S(), v(), h());
  }), r("update resize observerUpdate lock unlock changeDirection", () => {
    v();
  }), r("setTranslate", () => {
    h();
  }), r("setTransition", (A, k) => {
    g(k);
  }), r("enable disable", () => {
    const {
      el: A
    } = t.scrollbar;
    A && A.classList[t.enabled ? "remove" : "add"](...Mn(t.params.scrollbar.lockClass));
  }), r("destroy", () => {
    T();
  });
  const j = () => {
    t.el.classList.remove(...Mn(t.params.scrollbar.scrollbarDisabledClass)), t.scrollbar.el && t.scrollbar.el.classList.remove(...Mn(t.params.scrollbar.scrollbarDisabledClass)), S(), v(), h();
  }, D = () => {
    t.el.classList.add(...Mn(t.params.scrollbar.scrollbarDisabledClass)), t.scrollbar.el && t.scrollbar.el.classList.add(...Mn(t.params.scrollbar.scrollbarDisabledClass)), T();
  };
  Object.assign(t.scrollbar, {
    enable: j,
    disable: D,
    updateSize: v,
    setTranslate: h,
    init: S,
    destroy: T
  });
}
function Ts(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r
  } = e;
  n({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null
    }
  }), t.a11y = {
    clicked: !1
  };
  let a = null, i, s, o = (/* @__PURE__ */ new Date()).getTime();
  function c(P) {
    const I = a;
    I.length !== 0 && (I.innerHTML = "", I.innerHTML = P);
  }
  function d(P) {
    P === void 0 && (P = 16);
    const I = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(P).replace(/x/g, I);
  }
  function u(P) {
    P = Se(P), P.forEach((I) => {
      I.setAttribute("tabIndex", "0");
    });
  }
  function f(P) {
    P = Se(P), P.forEach((I) => {
      I.setAttribute("tabIndex", "-1");
    });
  }
  function p(P, I) {
    P = Se(P), P.forEach((H) => {
      H.setAttribute("role", I);
    });
  }
  function h(P, I) {
    P = Se(P), P.forEach((H) => {
      H.setAttribute("aria-roledescription", I);
    });
  }
  function g(P, I) {
    P = Se(P), P.forEach((H) => {
      H.setAttribute("aria-controls", I);
    });
  }
  function v(P, I) {
    P = Se(P), P.forEach((H) => {
      H.setAttribute("aria-label", I);
    });
  }
  function x(P, I) {
    P = Se(P), P.forEach((H) => {
      H.setAttribute("id", I);
    });
  }
  function m(P, I) {
    P = Se(P), P.forEach((H) => {
      H.setAttribute("aria-live", I);
    });
  }
  function b(P) {
    P = Se(P), P.forEach((I) => {
      I.setAttribute("aria-disabled", !0);
    });
  }
  function _(P) {
    P = Se(P), P.forEach((I) => {
      I.setAttribute("aria-disabled", !1);
    });
  }
  function C(P) {
    if (P.keyCode !== 13 && P.keyCode !== 32)
      return;
    const I = t.params.a11y, H = P.target;
    if (!(t.pagination && t.pagination.el && (H === t.pagination.el || t.pagination.el.contains(P.target)) && !P.target.matches(rn(t.params.pagination.bulletClass)))) {
      if (t.navigation && t.navigation.prevEl && t.navigation.nextEl) {
        const O = Se(t.navigation.prevEl);
        Se(t.navigation.nextEl).includes(H) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? c(I.lastSlideMessage) : c(I.nextSlideMessage)), O.includes(H) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? c(I.firstSlideMessage) : c(I.prevSlideMessage));
      }
      t.pagination && H.matches(rn(t.params.pagination.bulletClass)) && H.click();
    }
  }
  function w() {
    if (t.params.loop || t.params.rewind || !t.navigation)
      return;
    const {
      nextEl: P,
      prevEl: I
    } = t.navigation;
    I && (t.isBeginning ? (b(I), f(I)) : (_(I), u(I))), P && (t.isEnd ? (b(P), f(P)) : (_(P), u(P)));
  }
  function N() {
    return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
  }
  function M() {
    return N() && t.params.pagination.clickable;
  }
  function S() {
    const P = t.params.a11y;
    N() && t.pagination.bullets.forEach((I) => {
      t.params.pagination.clickable && (u(I), t.params.pagination.renderBullet || (p(I, "button"), v(I, P.paginationBulletMessage.replace(/\{\{index\}\}/, ba(I) + 1)))), I.matches(rn(t.params.pagination.bulletActiveClass)) ? I.setAttribute("aria-current", "true") : I.removeAttribute("aria-current");
    });
  }
  const T = (P, I, H) => {
    u(P), P.tagName !== "BUTTON" && (p(P, "button"), P.addEventListener("keydown", C)), v(P, H), g(P, I);
  }, j = (P) => {
    s && s !== P.target && !s.contains(P.target) && (i = !0), t.a11y.clicked = !0;
  }, D = () => {
    i = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        t.destroyed || (t.a11y.clicked = !1);
      });
    });
  }, A = (P) => {
    o = (/* @__PURE__ */ new Date()).getTime();
  }, k = (P) => {
    if (t.a11y.clicked || (/* @__PURE__ */ new Date()).getTime() - o < 100)
      return;
    const I = P.target.closest(`.${t.params.slideClass}, swiper-slide`);
    if (!I || !t.slides.includes(I))
      return;
    s = I;
    const H = t.slides.indexOf(I) === t.activeIndex, O = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(I);
    H || O || P.sourceCapabilities && P.sourceCapabilities.firesTouchEvents || (t.isHorizontal() ? t.el.scrollLeft = 0 : t.el.scrollTop = 0, requestAnimationFrame(() => {
      i || (t.slideTo(t.slides.indexOf(I), 0), i = !1);
    }));
  }, $ = () => {
    const P = t.params.a11y;
    P.itemRoleDescriptionMessage && h(t.slides, P.itemRoleDescriptionMessage), P.slideRole && p(t.slides, P.slideRole);
    const I = t.slides.length;
    P.slideLabelMessage && t.slides.forEach((H, O) => {
      const W = t.params.loop ? parseInt(H.getAttribute("data-swiper-slide-index"), 10) : O, se = P.slideLabelMessage.replace(/\{\{index\}\}/, W + 1).replace(/\{\{slidesLength\}\}/, I);
      v(H, se);
    });
  }, R = () => {
    const P = t.params.a11y;
    t.el.append(a);
    const I = t.el;
    P.containerRoleDescriptionMessage && h(I, P.containerRoleDescriptionMessage), P.containerMessage && v(I, P.containerMessage);
    const H = t.wrapperEl, O = P.id || H.getAttribute("id") || `swiper-wrapper-${d(16)}`, W = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
    x(H, O), m(H, W), $();
    let {
      nextEl: se,
      prevEl: ue
    } = t.navigation ? t.navigation : {};
    se = Se(se), ue = Se(ue), se && se.forEach((ae) => T(ae, O, P.nextSlideMessage)), ue && ue.forEach((ae) => T(ae, O, P.prevSlideMessage)), M() && Se(t.pagination.el).forEach((ie) => {
      ie.addEventListener("keydown", C);
    }), pt().addEventListener("visibilitychange", A), t.el.addEventListener("focus", k, !0), t.el.addEventListener("focus", k, !0), t.el.addEventListener("pointerdown", j, !0), t.el.addEventListener("pointerup", D, !0);
  };
  function F() {
    a && a.remove();
    let {
      nextEl: P,
      prevEl: I
    } = t.navigation ? t.navigation : {};
    P = Se(P), I = Se(I), P && P.forEach((O) => O.removeEventListener("keydown", C)), I && I.forEach((O) => O.removeEventListener("keydown", C)), M() && Se(t.pagination.el).forEach((W) => {
      W.removeEventListener("keydown", C);
    }), pt().removeEventListener("visibilitychange", A), t.el.removeEventListener("focus", k, !0), t.el.removeEventListener("pointerdown", j, !0), t.el.removeEventListener("pointerup", D, !0);
  }
  r("beforeInit", () => {
    a = Vr("span", t.params.a11y.notificationClass), a.setAttribute("aria-live", "assertive"), a.setAttribute("aria-atomic", "true");
  }), r("afterInit", () => {
    t.params.a11y.enabled && R();
  }), r("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    t.params.a11y.enabled && $();
  }), r("fromEdge toEdge afterInit lock unlock", () => {
    t.params.a11y.enabled && w();
  }), r("paginationUpdate", () => {
    t.params.a11y.enabled && S();
  }), r("destroy", () => {
    t.params.a11y.enabled && F();
  });
}
function Th(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: a,
    params: i
  } = e;
  t.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, n({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let s, o, c = i && i.autoplay ? i.autoplay.delay : 3e3, d = i && i.autoplay ? i.autoplay.delay : 3e3, u, f = (/* @__PURE__ */ new Date()).getTime(), p, h, g, v, x, m, b;
  function _(I) {
    !t || t.destroyed || !t.wrapperEl || I.target === t.wrapperEl && (t.wrapperEl.removeEventListener("transitionend", _), !b && j());
  }
  const C = () => {
    if (t.destroyed || !t.autoplay.running)
      return;
    t.autoplay.paused ? p = !0 : p && (d = u, p = !1);
    const I = t.autoplay.paused ? u : f + d - (/* @__PURE__ */ new Date()).getTime();
    t.autoplay.timeLeft = I, a("autoplayTimeLeft", I, I / c), o = requestAnimationFrame(() => {
      C();
    });
  }, w = () => {
    let I;
    return t.virtual && t.params.virtual.enabled ? I = t.slides.filter((O) => O.classList.contains("swiper-slide-active"))[0] : I = t.slides[t.activeIndex], I ? parseInt(I.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, N = (I) => {
    if (t.destroyed || !t.autoplay.running)
      return;
    cancelAnimationFrame(o), C();
    let H = typeof I > "u" ? t.params.autoplay.delay : I;
    c = t.params.autoplay.delay, d = t.params.autoplay.delay;
    const O = w();
    !Number.isNaN(O) && O > 0 && typeof I > "u" && (H = O, c = O, d = O), u = H;
    const W = t.params.speed, se = () => {
      !t || t.destroyed || (t.params.autoplay.reverseDirection ? !t.isBeginning || t.params.loop || t.params.rewind ? (t.slidePrev(W, !0, !0), a("autoplay")) : t.params.autoplay.stopOnLastSlide || (t.slideTo(t.slides.length - 1, W, !0, !0), a("autoplay")) : !t.isEnd || t.params.loop || t.params.rewind ? (t.slideNext(W, !0, !0), a("autoplay")) : t.params.autoplay.stopOnLastSlide || (t.slideTo(0, W, !0, !0), a("autoplay")), t.params.cssMode && (f = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        N();
      })));
    };
    return H > 0 ? (clearTimeout(s), s = setTimeout(() => {
      se();
    }, H)) : requestAnimationFrame(() => {
      se();
    }), H;
  }, M = () => {
    f = (/* @__PURE__ */ new Date()).getTime(), t.autoplay.running = !0, N(), a("autoplayStart");
  }, S = () => {
    t.autoplay.running = !1, clearTimeout(s), cancelAnimationFrame(o), a("autoplayStop");
  }, T = (I, H) => {
    if (t.destroyed || !t.autoplay.running)
      return;
    clearTimeout(s), I || (m = !0);
    const O = () => {
      a("autoplayPause"), t.params.autoplay.waitForTransition ? t.wrapperEl.addEventListener("transitionend", _) : j();
    };
    if (t.autoplay.paused = !0, H) {
      x && (u = t.params.autoplay.delay), x = !1, O();
      return;
    }
    u = (u || t.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - f), !(t.isEnd && u < 0 && !t.params.loop) && (u < 0 && (u = 0), O());
  }, j = () => {
    t.isEnd && u < 0 && !t.params.loop || t.destroyed || !t.autoplay.running || (f = (/* @__PURE__ */ new Date()).getTime(), m ? (m = !1, N(u)) : N(), t.autoplay.paused = !1, a("autoplayResume"));
  }, D = () => {
    if (t.destroyed || !t.autoplay.running)
      return;
    const I = pt();
    I.visibilityState === "hidden" && (m = !0, T(!0)), I.visibilityState === "visible" && j();
  }, A = (I) => {
    I.pointerType === "mouse" && (m = !0, b = !0, !(t.animating || t.autoplay.paused) && T(!0));
  }, k = (I) => {
    I.pointerType === "mouse" && (b = !1, t.autoplay.paused && j());
  }, $ = () => {
    t.params.autoplay.pauseOnMouseEnter && (t.el.addEventListener("pointerenter", A), t.el.addEventListener("pointerleave", k));
  }, R = () => {
    t.el.removeEventListener("pointerenter", A), t.el.removeEventListener("pointerleave", k);
  }, F = () => {
    pt().addEventListener("visibilitychange", D);
  }, P = () => {
    pt().removeEventListener("visibilitychange", D);
  };
  r("init", () => {
    t.params.autoplay.enabled && ($(), F(), M());
  }), r("destroy", () => {
    R(), P(), t.autoplay.running && S();
  }), r("_freeModeStaticRelease", () => {
    (g || m) && j();
  }), r("_freeModeNoMomentumRelease", () => {
    t.params.autoplay.disableOnInteraction ? S() : T(!0, !0);
  }), r("beforeTransitionStart", (I, H, O) => {
    t.destroyed || !t.autoplay.running || (O || !t.params.autoplay.disableOnInteraction ? T(!0, !0) : S());
  }), r("sliderFirstMove", () => {
    if (!(t.destroyed || !t.autoplay.running)) {
      if (t.params.autoplay.disableOnInteraction) {
        S();
        return;
      }
      h = !0, g = !1, m = !1, v = setTimeout(() => {
        m = !0, g = !0, T(!0);
      }, 200);
    }
  }), r("touchEnd", () => {
    if (!(t.destroyed || !t.autoplay.running || !h)) {
      if (clearTimeout(v), clearTimeout(s), t.params.autoplay.disableOnInteraction) {
        g = !1, h = !1;
        return;
      }
      g && t.params.cssMode && j(), g = !1, h = !1;
    }
  }), r("slideChange", () => {
    t.destroyed || !t.autoplay.running || (x = !0);
  }), Object.assign(t.autoplay, {
    start: M,
    stop: S,
    pause: T,
    resume: j
  });
}
function ks(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r
  } = e;
  n({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let a = !1, i = !1;
  t.thumbs = {
    swiper: null
  };
  function s() {
    const d = t.thumbs.swiper;
    if (!d || d.destroyed)
      return;
    const u = d.clickedIndex, f = d.clickedSlide;
    if (f && f.classList.contains(t.params.thumbs.slideThumbActiveClass) || typeof u > "u" || u === null)
      return;
    let p;
    d.params.loop ? p = parseInt(d.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : p = u, t.params.loop ? t.slideToLoop(p) : t.slideTo(p);
  }
  function o() {
    const {
      thumbs: d
    } = t.params;
    if (a)
      return !1;
    a = !0;
    const u = t.constructor;
    if (d.swiper instanceof u)
      t.thumbs.swiper = d.swiper, Object.assign(t.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(t.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), t.thumbs.swiper.update();
    else if (ca(d.swiper)) {
      const f = Object.assign({}, d.swiper);
      Object.assign(f, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), t.thumbs.swiper = new u(f), i = !0;
    }
    return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", s), !0;
  }
  function c(d) {
    const u = t.thumbs.swiper;
    if (!u || u.destroyed)
      return;
    const f = u.params.slidesPerView === "auto" ? u.slidesPerViewDynamic() : u.params.slidesPerView;
    let p = 1;
    const h = t.params.thumbs.slideThumbActiveClass;
    if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (p = t.params.slidesPerView), t.params.thumbs.multipleActiveThumbs || (p = 1), p = Math.floor(p), u.slides.forEach((x) => x.classList.remove(h)), u.params.loop || u.params.virtual && u.params.virtual.enabled)
      for (let x = 0; x < p; x += 1)
        $t(u.slidesEl, `[data-swiper-slide-index="${t.realIndex + x}"]`).forEach((m) => {
          m.classList.add(h);
        });
    else
      for (let x = 0; x < p; x += 1)
        u.slides[t.realIndex + x] && u.slides[t.realIndex + x].classList.add(h);
    const g = t.params.thumbs.autoScrollOffset, v = g && !u.params.loop;
    if (t.realIndex !== u.realIndex || v) {
      const x = u.activeIndex;
      let m, b;
      if (u.params.loop) {
        const _ = u.slides.filter((C) => C.getAttribute("data-swiper-slide-index") === `${t.realIndex}`)[0];
        m = u.slides.indexOf(_), b = t.activeIndex > t.previousIndex ? "next" : "prev";
      } else
        m = t.realIndex, b = m > t.previousIndex ? "next" : "prev";
      v && (m += b === "next" ? g : -1 * g), u.visibleSlidesIndexes && u.visibleSlidesIndexes.indexOf(m) < 0 && (u.params.centeredSlides ? m > x ? m = m - Math.floor(f / 2) + 1 : m = m + Math.floor(f / 2) - 1 : m > x && u.params.slidesPerGroup, u.slideTo(m, d ? 0 : void 0));
    }
  }
  r("beforeInit", () => {
    const {
      thumbs: d
    } = t.params;
    if (!(!d || !d.swiper))
      if (typeof d.swiper == "string" || d.swiper instanceof HTMLElement) {
        const u = pt(), f = () => {
          const h = typeof d.swiper == "string" ? u.querySelector(d.swiper) : d.swiper;
          if (h && h.swiper)
            d.swiper = h.swiper, o(), c(!0);
          else if (h) {
            const g = (v) => {
              d.swiper = v.detail[0], h.removeEventListener("init", g), o(), c(!0), d.swiper.update(), t.update();
            };
            h.addEventListener("init", g);
          }
          return h;
        }, p = () => {
          if (t.destroyed)
            return;
          f() || requestAnimationFrame(p);
        };
        requestAnimationFrame(p);
      } else
        o(), c(!0);
  }), r("slideChange update resize observerUpdate", () => {
    c();
  }), r("setTransition", (d, u) => {
    const f = t.thumbs.swiper;
    !f || f.destroyed || f.setTransition(u);
  }), r("beforeDestroy", () => {
    const d = t.thumbs.swiper;
    !d || d.destroyed || i && d.destroy();
  }), Object.assign(t.thumbs, {
    init: o,
    update: c
  });
}
function kh(e) {
  const {
    effect: t,
    swiper: n,
    on: r,
    setTranslate: a,
    setTransition: i,
    overwriteParams: s,
    perspective: o,
    recreateShadows: c,
    getEffectParams: d
  } = e;
  r("beforeInit", () => {
    if (n.params.effect !== t)
      return;
    n.classNames.push(`${n.params.containerModifierClass}${t}`), o && o() && n.classNames.push(`${n.params.containerModifierClass}3d`);
    const f = s ? s() : {};
    Object.assign(n.params, f), Object.assign(n.originalParams, f);
  }), r("setTranslate", () => {
    n.params.effect === t && a();
  }), r("setTransition", (f, p) => {
    n.params.effect === t && i(p);
  }), r("transitionEnd", () => {
    if (n.params.effect === t && c) {
      if (!d || !d().slideShadows)
        return;
      n.slides.forEach((f) => {
        f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((p) => p.remove());
      }), c();
    }
  });
  let u;
  r("virtualUpdate", () => {
    n.params.effect === t && (n.slides.length || (u = !0), requestAnimationFrame(() => {
      u && n.slides && n.slides.length && (a(), u = !1);
    }));
  });
}
function jh(e, t) {
  const n = k3(t);
  return n !== t && (n.style.backfaceVisibility = "hidden", n.style["-webkit-backface-visibility"] = "hidden"), n;
}
function Ph(e) {
  let {
    swiper: t,
    duration: n,
    transformElements: r,
    allSlides: a
  } = e;
  const {
    activeIndex: i
  } = t, s = (o) => o.parentElement ? o.parentElement : t.slides.filter((d) => d.shadowRoot && d.shadowRoot === o.parentNode)[0];
  if (t.params.virtualTranslate && n !== 0) {
    let o = !1, c;
    a ? c = r : c = r.filter((d) => {
      const u = d.classList.contains("swiper-slide-transform") ? s(d) : d;
      return t.getSlideIndex(u) === i;
    }), c.forEach((d) => {
      g9(d, () => {
        if (o || !t || t.destroyed)
          return;
        o = !0, t.animating = !1;
        const u = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        t.wrapperEl.dispatchEvent(u);
      });
    });
  }
}
function Ah(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r
  } = e;
  n({
    fadeEffect: {
      crossFade: !1
    }
  }), kh({
    effect: "fade",
    swiper: t,
    on: r,
    setTranslate: () => {
      const {
        slides: s
      } = t, o = t.params.fadeEffect;
      for (let c = 0; c < s.length; c += 1) {
        const d = t.slides[c];
        let f = -d.swiperSlideOffset;
        t.params.virtualTranslate || (f -= t.translate);
        let p = 0;
        t.isHorizontal() || (p = f, f = 0);
        const h = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(d.progress), 0) : 1 + Math.min(Math.max(d.progress, -1), 0), g = jh(o, d);
        g.style.opacity = h, g.style.transform = `translate3d(${f}px, ${p}px, 0px)`;
      }
    },
    setTransition: (s) => {
      const o = t.slides.map((c) => k3(c));
      o.forEach((c) => {
        c.style.transitionDuration = `${s}ms`;
      }), Ph({
        swiper: t,
        duration: s,
        transformElements: o,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !t.params.cssMode
    })
  });
}
const O3 = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function or(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object" && !e.__swiper__;
}
function Rr(e, t) {
  const n = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((r) => n.indexOf(r) < 0).forEach((r) => {
    typeof e[r] > "u" ? e[r] = t[r] : or(t[r]) && or(e[r]) && Object.keys(t[r]).length > 0 ? t[r].__swiper__ ? e[r] = t[r] : Rr(e[r], t[r]) : e[r] = t[r];
  });
}
function R3(e) {
  return e === void 0 && (e = {}), e.navigation && typeof e.navigation.nextEl > "u" && typeof e.navigation.prevEl > "u";
}
function D3(e) {
  return e === void 0 && (e = {}), e.pagination && typeof e.pagination.el > "u";
}
function F3(e) {
  return e === void 0 && (e = {}), e.scrollbar && typeof e.scrollbar.el > "u";
}
function B3(e) {
  e === void 0 && (e = "");
  const t = e.split(" ").map((r) => r.trim()).filter((r) => !!r), n = [];
  return t.forEach((r) => {
    n.indexOf(r) < 0 && n.push(r);
  }), n.join(" ");
}
function $h(e) {
  return e === void 0 && (e = ""), e ? e.includes("swiper-wrapper") ? e : `swiper-wrapper ${e}` : "swiper-wrapper";
}
function Ih(e) {
  let {
    swiper: t,
    slides: n,
    passedParams: r,
    changedParams: a,
    nextEl: i,
    prevEl: s,
    scrollbarEl: o,
    paginationEl: c
  } = e;
  const d = a.filter((T) => T !== "children" && T !== "direction" && T !== "wrapperClass"), {
    params: u,
    pagination: f,
    navigation: p,
    scrollbar: h,
    virtual: g,
    thumbs: v
  } = t;
  let x, m, b, _, C, w, N, M;
  a.includes("thumbs") && r.thumbs && r.thumbs.swiper && u.thumbs && !u.thumbs.swiper && (x = !0), a.includes("controller") && r.controller && r.controller.control && u.controller && !u.controller.control && (m = !0), a.includes("pagination") && r.pagination && (r.pagination.el || c) && (u.pagination || u.pagination === !1) && f && !f.el && (b = !0), a.includes("scrollbar") && r.scrollbar && (r.scrollbar.el || o) && (u.scrollbar || u.scrollbar === !1) && h && !h.el && (_ = !0), a.includes("navigation") && r.navigation && (r.navigation.prevEl || s) && (r.navigation.nextEl || i) && (u.navigation || u.navigation === !1) && p && !p.prevEl && !p.nextEl && (C = !0);
  const S = (T) => {
    t[T] && (t[T].destroy(), T === "navigation" ? (t.isElement && (t[T].prevEl.remove(), t[T].nextEl.remove()), u[T].prevEl = void 0, u[T].nextEl = void 0, t[T].prevEl = void 0, t[T].nextEl = void 0) : (t.isElement && t[T].el.remove(), u[T].el = void 0, t[T].el = void 0));
  };
  a.includes("loop") && t.isElement && (u.loop && !r.loop ? w = !0 : !u.loop && r.loop ? N = !0 : M = !0), d.forEach((T) => {
    if (or(u[T]) && or(r[T]))
      Object.assign(u[T], r[T]), (T === "navigation" || T === "pagination" || T === "scrollbar") && "enabled" in r[T] && !r[T].enabled && S(T);
    else {
      const j = r[T];
      (j === !0 || j === !1) && (T === "navigation" || T === "pagination" || T === "scrollbar") ? j === !1 && S(T) : u[T] = r[T];
    }
  }), d.includes("controller") && !m && t.controller && t.controller.control && u.controller && u.controller.control && (t.controller.control = u.controller.control), a.includes("children") && n && g && u.virtual.enabled ? (g.slides = n, g.update(!0)) : a.includes("virtual") && g && u.virtual.enabled && (n && (g.slides = n), g.update(!0)), a.includes("children") && n && u.loop && (M = !0), x && v.init() && v.update(!0), m && (t.controller.control = u.controller.control), b && (t.isElement && (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-pagination"), c.part.add("pagination"), t.el.appendChild(c)), c && (u.pagination.el = c), f.init(), f.render(), f.update()), _ && (t.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-scrollbar"), o.part.add("scrollbar"), t.el.appendChild(o)), o && (u.scrollbar.el = o), h.init(), h.updateSize(), h.setTranslate()), C && (t.isElement && ((!i || typeof i == "string") && (i = document.createElement("div"), i.classList.add("swiper-button-next"), i.innerHTML = t.hostEl.constructor.nextButtonSvg, i.part.add("button-next"), t.el.appendChild(i)), (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-prev"), s.innerHTML = t.hostEl.constructor.prevButtonSvg, s.part.add("button-prev"), t.el.appendChild(s))), i && (u.navigation.nextEl = i), s && (u.navigation.prevEl = s), p.init(), p.update()), a.includes("allowSlideNext") && (t.allowSlideNext = r.allowSlideNext), a.includes("allowSlidePrev") && (t.allowSlidePrev = r.allowSlidePrev), a.includes("direction") && t.changeDirection(r.direction, !1), (w || M) && t.loopDestroy(), (N || M) && t.loopCreate(), t.update();
}
function Oh(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = !0);
  const n = {
    on: {}
  }, r = {}, a = {};
  Rr(n, Es), n._emitClasses = !0, n.init = !1;
  const i = {}, s = O3.map((c) => c.replace(/_/, "")), o = Object.assign({}, e);
  return Object.keys(o).forEach((c) => {
    typeof e[c] > "u" || (s.indexOf(c) >= 0 ? or(e[c]) ? (n[c] = {}, a[c] = {}, Rr(n[c], e[c]), Rr(a[c], e[c])) : (n[c] = e[c], a[c] = e[c]) : c.search(/on[A-Z]/) === 0 && typeof e[c] == "function" ? t ? r[`${c[2].toLowerCase()}${c.substr(3)}`] = e[c] : n.on[`${c[2].toLowerCase()}${c.substr(3)}`] = e[c] : i[c] = e[c]);
  }), ["navigation", "pagination", "scrollbar"].forEach((c) => {
    n[c] === !0 && (n[c] = {}), n[c] === !1 && delete n[c];
  }), {
    params: n,
    passedParams: a,
    rest: i,
    events: r
  };
}
function Rh(e, t) {
  let {
    el: n,
    nextEl: r,
    prevEl: a,
    paginationEl: i,
    scrollbarEl: s,
    swiper: o
  } = e;
  R3(t) && r && a && (o.params.navigation.nextEl = r, o.originalParams.navigation.nextEl = r, o.params.navigation.prevEl = a, o.originalParams.navigation.prevEl = a), D3(t) && i && (o.params.pagination.el = i, o.originalParams.pagination.el = i), F3(t) && s && (o.params.scrollbar.el = s, o.originalParams.scrollbar.el = s), o.init(n);
}
function Dh(e, t, n, r, a) {
  const i = [];
  if (!t)
    return i;
  const s = (c) => {
    i.indexOf(c) < 0 && i.push(c);
  };
  if (n && r) {
    const c = r.map(a), d = n.map(a);
    c.join("") !== d.join("") && s("children"), r.length !== n.length && s("children");
  }
  return O3.filter((c) => c[0] === "_").map((c) => c.replace(/_/, "")).forEach((c) => {
    if (c in e && c in t)
      if (or(e[c]) && or(t[c])) {
        const d = Object.keys(e[c]), u = Object.keys(t[c]);
        d.length !== u.length ? s(c) : (d.forEach((f) => {
          e[c][f] !== t[c][f] && s(c);
        }), u.forEach((f) => {
          e[c][f] !== t[c][f] && s(c);
        }));
      } else
        e[c] !== t[c] && s(c);
  }), i;
}
const Fh = (e) => {
  !e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
};
function Ni() {
  return Ni = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ni.apply(this, arguments);
}
function V3(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function H3(e) {
  const t = [];
  return Y.Children.toArray(e).forEach((n) => {
    V3(n) ? t.push(n) : n.props && n.props.children && H3(n.props.children).forEach((r) => t.push(r));
  }), t;
}
function Bh(e) {
  const t = [], n = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return Y.Children.toArray(e).forEach((r) => {
    if (V3(r))
      t.push(r);
    else if (r.props && r.props.slot && n[r.props.slot])
      n[r.props.slot].push(r);
    else if (r.props && r.props.children) {
      const a = H3(r.props.children);
      a.length > 0 ? a.forEach((i) => t.push(i)) : n["container-end"].push(r);
    } else
      n["container-end"].push(r);
  }), {
    slides: t,
    slots: n
  };
}
function Vh(e, t, n) {
  if (!n)
    return null;
  const r = (u) => {
    let f = u;
    return u < 0 ? f = t.length + u : f >= t.length && (f = f - t.length), f;
  }, a = e.isHorizontal() ? {
    [e.rtlTranslate ? "right" : "left"]: `${n.offset}px`
  } : {
    top: `${n.offset}px`
  }, {
    from: i,
    to: s
  } = n, o = e.params.loop ? -t.length : 0, c = e.params.loop ? t.length * 2 : t.length, d = [];
  for (let u = o; u < c; u += 1)
    u >= i && u <= s && d.push(t[r(u)]);
  return d.map((u, f) => /* @__PURE__ */ Y.cloneElement(u, {
    swiper: e,
    style: a,
    key: u.props.virtualIndex || u.key || `slide-${f}`
  }));
}
function fa(e, t) {
  return typeof window > "u" ? ve(e, t) : io(e, t);
}
const ml = /* @__PURE__ */ on(null), Hh = /* @__PURE__ */ on(null), zi = /* @__PURE__ */ K(function(e, t) {
  let {
    className: n,
    tag: r = "div",
    wrapperTag: a = "div",
    children: i,
    onSwiper: s,
    ...o
  } = e === void 0 ? {} : e, c = !1;
  const [d, u] = ne("swiper"), [f, p] = ne(null), [h, g] = ne(!1), v = pe(!1), x = pe(null), m = pe(null), b = pe(null), _ = pe(null), C = pe(null), w = pe(null), N = pe(null), M = pe(null), {
    params: S,
    passedParams: T,
    rest: j,
    events: D
  } = Oh(o), {
    slides: A,
    slots: k
  } = Bh(i), $ = () => {
    g(!h);
  };
  Object.assign(S.on, {
    _containerClasses(H, O) {
      u(O);
    }
  });
  const R = () => {
    Object.assign(S.on, D), c = !0;
    const H = {
      ...S
    };
    if (delete H.wrapperClass, m.current = new Ji(H), m.current.virtual && m.current.params.virtual.enabled) {
      m.current.virtual.slides = A;
      const O = {
        cache: !1,
        slides: A,
        renderExternal: p,
        renderExternalUpdate: !1
      };
      Rr(m.current.params.virtual, O), Rr(m.current.originalParams.virtual, O);
    }
  };
  x.current || R(), m.current && m.current.on("_beforeBreakpoint", $);
  const F = () => {
    c || !D || !m.current || Object.keys(D).forEach((H) => {
      m.current.on(H, D[H]);
    });
  }, P = () => {
    !D || !m.current || Object.keys(D).forEach((H) => {
      m.current.off(H, D[H]);
    });
  };
  ve(() => () => {
    m.current && m.current.off("_beforeBreakpoint", $);
  }), ve(() => {
    !v.current && m.current && (m.current.emitSlidesClasses(), v.current = !0);
  }), fa(() => {
    if (t && (t.current = x.current), !!x.current)
      return m.current.destroyed && R(), Rh({
        el: x.current,
        nextEl: C.current,
        prevEl: w.current,
        paginationEl: N.current,
        scrollbarEl: M.current,
        swiper: m.current
      }, S), s && !m.current.destroyed && s(m.current), () => {
        m.current && !m.current.destroyed && m.current.destroy(!0, !1);
      };
  }, []), fa(() => {
    F();
    const H = Dh(T, b.current, A, _.current, (O) => O.key);
    return b.current = T, _.current = A, H.length && m.current && !m.current.destroyed && Ih({
      swiper: m.current,
      slides: A,
      passedParams: T,
      changedParams: H,
      nextEl: C.current,
      prevEl: w.current,
      scrollbarEl: M.current,
      paginationEl: N.current
    }), () => {
      P();
    };
  }), fa(() => {
    Fh(m.current);
  }, [f]);
  function I() {
    return S.virtual ? Vh(m.current, A, f) : A.map((H, O) => /* @__PURE__ */ Y.cloneElement(H, {
      swiper: m.current,
      swiperSlideIndex: O
    }));
  }
  return /* @__PURE__ */ Y.createElement(r, Ni({
    ref: x,
    className: B3(`${d}${n ? ` ${n}` : ""}`)
  }, j), /* @__PURE__ */ Y.createElement(Hh.Provider, {
    value: m.current
  }, k["container-start"], /* @__PURE__ */ Y.createElement(a, {
    className: $h(S.wrapperClass)
  }, k["wrapper-start"], I(), k["wrapper-end"]), R3(S) && /* @__PURE__ */ Y.createElement(Y.Fragment, null, /* @__PURE__ */ Y.createElement("div", {
    ref: w,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ Y.createElement("div", {
    ref: C,
    className: "swiper-button-next"
  })), F3(S) && /* @__PURE__ */ Y.createElement("div", {
    ref: M,
    className: "swiper-scrollbar"
  }), D3(S) && /* @__PURE__ */ Y.createElement("div", {
    ref: N,
    className: "swiper-pagination"
  }), k["container-end"]));
});
zi.displayName = "Swiper";
const Ei = /* @__PURE__ */ K(function(e, t) {
  let {
    tag: n = "div",
    children: r,
    className: a = "",
    swiper: i,
    zoom: s,
    lazy: o,
    virtualIndex: c,
    swiperSlideIndex: d,
    ...u
  } = e === void 0 ? {} : e;
  const f = pe(null), [p, h] = ne("swiper-slide"), [g, v] = ne(!1);
  function x(C, w, N) {
    w === f.current && h(N);
  }
  fa(() => {
    if (typeof d < "u" && (f.current.swiperSlideIndex = d), t && (t.current = f.current), !(!f.current || !i)) {
      if (i.destroyed) {
        p !== "swiper-slide" && h("swiper-slide");
        return;
      }
      return i.on("_slideClass", x), () => {
        i && i.off("_slideClass", x);
      };
    }
  }), fa(() => {
    i && f.current && !i.destroyed && h(i.getSlideClasses(f.current));
  }, [i]);
  const m = {
    isActive: p.indexOf("swiper-slide-active") >= 0,
    isVisible: p.indexOf("swiper-slide-visible") >= 0,
    isPrev: p.indexOf("swiper-slide-prev") >= 0,
    isNext: p.indexOf("swiper-slide-next") >= 0
  }, b = () => typeof r == "function" ? r(m) : r, _ = () => {
    v(!0);
  };
  return /* @__PURE__ */ Y.createElement(n, Ni({
    ref: f,
    className: B3(`${p}${a ? ` ${a}` : ""}`),
    "data-swiper-slide-index": c,
    onLoad: _
  }, u), s && /* @__PURE__ */ Y.createElement(ml.Provider, {
    value: m
  }, /* @__PURE__ */ Y.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof s == "number" ? s : void 0
  }, b(), o && !g && /* @__PURE__ */ Y.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !s && /* @__PURE__ */ Y.createElement(ml.Provider, {
    value: m
  }, b(), o && !g && /* @__PURE__ */ Y.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
Ei.displayName = "SwiperSlide";
const qh = "_thumbnail_1cc2x_298", Ue = {
  "active-slide-container": "_active-slide-container_1cc2x_209",
  "media-container": "_media-container_1cc2x_212",
  "swiper-button-prev": "_swiper-button-prev_1cc2x_233",
  "swiper-button-next": "_swiper-button-next_1cc2x_234",
  "media-container-audio-asset": "_media-container-audio-asset_1cc2x_257",
  "slide-caption": "_slide-caption_1cc2x_272",
  "slide-headline": "_slide-headline_1cc2x_280",
  "thumbnail-container": "_thumbnail-container_1cc2x_298",
  "thumbnail-swiper": "_thumbnail-swiper_1cc2x_302",
  "swiper-slide": "_swiper-slide_1cc2x_302",
  "active-thumb": "_active-thumb_1cc2x_311",
  "inactive-thumb": "_inactive-thumb_1cc2x_314",
  thumbnail: qh,
  "thumbnail-with-icon": "_thumbnail-with-icon_1cc2x_326",
  "play-icon": "_play-icon_1cc2x_332",
  "swiper-thumb-button-prev": "_swiper-thumb-button-prev_1cc2x_342",
  "swiper-thumb-button-next": "_swiper-thumb-button-next_1cc2x_343",
  "media-gallery-carousel-base": "_media-gallery-carousel-base_1cc2x_370"
};
Ji.use([Nh, ks]);
const A1 = 4, q3 = (e) => {
  const {
    slides: t,
    shouldHideThumbnails: n,
    shouldHideNavigation: r,
    componentName: a,
    ...i
  } = e, [s, o] = ne(), [c, d] = ne(), [u, f] = ne(0), p = pe({}), h = (m) => (b) => {
    p.current[m] = b;
  }, g = () => {
    const m = p.current[u];
    m && m.stopVideo();
  };
  ve(() => {
    const m = (b) => {
      b.key === "ArrowLeft" ? c == null || c.slidePrev() : b.key === "ArrowRight" && (c == null || c.slideNext());
    };
    return window.addEventListener("keydown", m), () => {
      window.removeEventListener("keydown", m);
    };
  }, [c]);
  const v = (m, b) => {
    (m.key === "Enter" || m.key === " ") && (m.preventDefault(), x(b));
  }, x = (m) => {
    f(m), c == null || c.slideTo(m), s == null || s.slideTo(m);
  };
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: Ue["media-gallery-carousel-base"],
      "data-testid": "media-gallery-carousel",
      tabIndex: 0,
      ...i,
      children: [
        /* @__PURE__ */ l.jsx("div", { className: Ue["active-slide-container"], children: /* @__PURE__ */ l.jsx(
          zi,
          {
            spaceBetween: 10,
            modules: [ks, Ts],
            autoHeight: !0,
            onSwiper: d,
            navigation: {
              prevEl: ".prev",
              nextEl: ".next"
            },
            thumbs: {
              swiper: s && !s.destroyed ? s : null
            },
            onSlideChange: ({ activeIndex: m }) => {
              g(), f(m);
            },
            children: t.map((m, b) => /* @__PURE__ */ l.jsx(
              Ei,
              {
                ...i,
                children: /* @__PURE__ */ l.jsx(
                  W3,
                  {
                    ...m,
                    isActive: b === u,
                    isNextDisabled: b === t.length - 1,
                    isPrevDisabled: b === 0,
                    onReady: h(b),
                    componentName: a,
                    ...i
                  }
                )
              },
              b
            ))
          }
        ) }),
        !n && /* @__PURE__ */ l.jsxs("div", { className: Ue["thumbnail-container"], children: [
          /* @__PURE__ */ l.jsx(
            zi,
            {
              onSwiper: o,
              spaceBetween: 24,
              slidesPerView: A1,
              modules: [ks, Ts],
              autoHeight: !0,
              navigation: t.length > A1 && {
                prevEl: ".prev-thumb",
                nextEl: ".next-thumb"
              },
              className: Ue["thumbnail-swiper"],
              children: t.map((m, b) => {
                const {
                  videoId: _,
                  image: C,
                  audioSrc: w,
                  shouldLazyLoad: N = !1
                } = m, M = mr(
                  C,
                  N
                );
                return /* @__PURE__ */ l.jsx(
                  Ei,
                  {
                    tabIndex: 0,
                    onKeyDown: (S) => v(S, b),
                    onClick: () => x(b),
                    className: z(Ue["swiper-slide"], {
                      [Ue["active-thumb"]]: b === u,
                      [Ue["inactive-thumb"]]: b !== u
                    }),
                    "data-component": a,
                    ...i,
                    children: _ || w ? /* @__PURE__ */ l.jsxs(
                      "div",
                      {
                        className: Ue["thumbnail-with-icon"],
                        "data-testid": "media-gallery-carousel-thumbnail",
                        children: [
                          _ ? /* @__PURE__ */ l.jsx(
                            "img",
                            {
                              src: `https://img.youtube.com/vi/${_}/0.jpg`,
                              alt: "Video thumbnail",
                              className: Ue.thumbnail
                            }
                          ) : M && Te(
                            M,
                            {
                              className: Ue.thumbnail,
                              "data-testid": "media-gallery-carousel-thumbnail"
                            }
                          ),
                          b !== u && /* @__PURE__ */ l.jsx(
                            re,
                            {
                              className: Ue["play-icon"],
                              icon: "circlePlay",
                              color: "white"
                            }
                          )
                        ]
                      }
                    ) : M && Te(
                      M,
                      {
                        className: Ue.thumbnail,
                        "data-testid": "media-gallery-carousel-thumbnail"
                      }
                    )
                  },
                  b
                );
              })
            }
          ),
          !r && t.length > A1 && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
            /* @__PURE__ */ l.jsx(
              "button",
              {
                className: z(
                  Ue["swiper-thumb-button-prev"],
                  "prev-thumb"
                ),
                disabled: u === 0,
                tabIndex: 0,
                children: /* @__PURE__ */ l.jsx(
                  re,
                  {
                    icon: "chevronLeftSharp",
                    color: "denimBlue",
                    role: "button"
                  }
                )
              }
            ),
            /* @__PURE__ */ l.jsx(
              "button",
              {
                className: z(
                  Ue["swiper-thumb-button-next"],
                  "next-thumb"
                ),
                disabled: u === t.length - 1,
                tabIndex: 0,
                children: /* @__PURE__ */ l.jsx(
                  re,
                  {
                    icon: "chevronRightSharp",
                    color: "denimBlue",
                    role: "button"
                  }
                )
              }
            )
          ] })
        ] })
      ]
    }
  );
};
q3.displayName = "MediaGalleryCarousel";
const W3 = (e) => {
  const {
    headline: t,
    image: n,
    isActive: r,
    isNextDisabled: a,
    isPrevDisabled: i,
    onReady: s,
    supportCopy: o,
    videoId: c,
    audioSrc: d,
    componentName: u,
    shouldLazyLoad: f = !1
  } = e, p = r ? 0 : -1, h = mr(n, f);
  return /* @__PURE__ */ l.jsxs("figure", { "data-component": u, children: [
    /* @__PURE__ */ l.jsxs("div", { className: Ue["media-container"], children: [
      c ? /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
        o1,
        {
          videoId: c,
          onReady: s,
          isActive: !!r,
          tabIndex: p
        }
      ) }) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        h && Te(h, {
          tabIndex: p
        }),
        d && /* @__PURE__ */ l.jsx(
          "audio",
          {
            className: Ue["media-container-audio-asset"],
            controls: !0,
            src: d
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx(
        "button",
        {
          className: z(Ue["swiper-button-prev"], "prev"),
          "data-testid": "media-gallery-carousel-arrow-left",
          disabled: i,
          children: /* @__PURE__ */ l.jsx(
            re,
            {
              icon: "chevronLeftSharp",
              color: "white"
            }
          )
        }
      ),
      /* @__PURE__ */ l.jsx(
        "button",
        {
          className: z(Ue["swiper-button-next"], "next"),
          "data-testid": "media-gallery-carousel-arrow-right",
          disabled: a,
          children: /* @__PURE__ */ l.jsx(
            re,
            {
              icon: "chevronRightSharp",
              color: "white"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ l.jsxs("figcaption", { className: Ue["slide-caption"], children: [
      t && /* @__PURE__ */ l.jsx(
        G,
        {
          className: Ue["slide-headline"],
          tag: "p",
          "data-testid": "media-gallery-carousel-slide-headline",
          fontStyle: "smParagraph",
          children: t
        }
      ),
      o && /* @__PURE__ */ l.jsx(le, { "data-testid": "media-gallery-carousel-slide-support-copy", children: o })
    ] })
  ] });
};
W3.displayName = "MediaGallerySlide";
const Wh = "_headline_570ux_231", Uh = "_cta_570ux_253", Gh = "_content_570ux_209", Ze = {
  "content-container": "_content-container_570ux_209",
  "spacing-72-48": "_spacing-72-48_570ux_209",
  "spacing-72-24": "_spacing-72-24_570ux_209",
  "spacing-40-24": "_spacing-40-24_570ux_209",
  "spacing-72-32": "_spacing-72-32_570ux_213",
  "spacing-64-40": "_spacing-64-40_570ux_217",
  "text-center": "_text-center_570ux_227",
  headline: Wh,
  "headline-with-icon": "_headline-with-icon_570ux_234",
  "headline-icon-top": "_headline-icon-top_570ux_244",
  "support-copy": "_support-copy_570ux_251",
  "support-copy-bottom": "_support-copy-bottom_570ux_252",
  cta: Uh,
  content: Gh,
  "cta-link": "_cta-link_570ux_267",
  "cta-center": "_cta-center_570ux_271"
}, He = (e) => {
  const {
    children: t,
    className: n,
    contentAlignment: r = "center",
    cta: a,
    ctaAlignment: i,
    ctaStyle: s = "solid",
    headline: o,
    headlineAlignment: c,
    headlineIcon: d,
    headlineIconPlacement: u = "left",
    headlineTag: f = "p",
    spacing: p = "72-48",
    supportCopy: h,
    supportCopyAlignment: g,
    supportCopyBottom: v,
    supportCopyBottomAlignment: x,
    ...m
  } = e, b = c || r, _ = g || r, C = x || r, w = i || r;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: z(
        Ze["content-container"],
        {
          [Ze["spacing-72-48"]]: p === "72-48",
          [Ze["spacing-64-40"]]: p === "64-40",
          [Ze["spacing-40-24"]]: p === "40-24",
          [Ze["spacing-72-32"]]: p === "72-32",
          [Ze["spacing-72-24"]]: p === "72-24"
        },
        n
      ),
      "data-testid": "content-container",
      ...m,
      children: /* @__PURE__ */ l.jsxs("div", { children: [
        o && /* @__PURE__ */ l.jsxs(
          G,
          {
            "data-testid": "content-container-headline",
            tag: f,
            className: z(Ze.headline, {
              [Ze["headline-with-icon"]]: d,
              [Ze["headline-icon-top"]]: u === "top",
              [Ze["text-center"]]: b === "center"
            }),
            children: [
              d && /* @__PURE__ */ l.jsx(re, { icon: d }),
              o
            ]
          }
        ),
        h && /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "content-container-support-copy",
            className: z(Ze["support-copy"], {
              [Ze["text-center"]]: _ === "center"
            }),
            children: h
          }
        ),
        /* @__PURE__ */ l.jsx(lt, { className: Ze.content, children: an.count(t) > 1 ? /* @__PURE__ */ l.jsx("div", { children: t }) : t }),
        v && /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "content-container-support-copy-bottom",
            className: z(Ze["support-copy-bottom"], {
              [Ze["text-center"]]: C === "center"
            }),
            children: v
          }
        ),
        a && /* @__PURE__ */ l.jsx(
          X,
          {
            "data-testid": "content-container-cta",
            className: z(Ze.cta, {
              [Ze["cta-center"]]: w === "center",
              [Ze["cta-link"]]: s === "link"
            }),
            size: "responsive",
            buttonStyle: s,
            children: a
          }
        )
      ] })
    }
  );
}, Yh = {
  "search-result": "_search-result_1jb7y_209"
}, JE = (e) => {
  const {
    className: t,
    numberOfResult: n,
    resultText: r,
    searchText: a,
    totalNumberOfResult: i,
    ...s
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: t,
      ...s,
      children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          "data-testid": "search-result",
          className: Yh["search-result"],
          children: [
            /* @__PURE__ */ l.jsxs(G, { "data-testid": "result-text", children: [
              " ",
              r,
              " "
            ] }),
            /* @__PURE__ */ l.jsx(
              G,
              {
                "data-testid": "number-of-result",
                fontStyle: "smLinkMobile",
                children: n
              }
            ),
            /* @__PURE__ */ l.jsx(G, { "data-testid": "total-result", children: i }),
            /* @__PURE__ */ l.jsx(
              G,
              {
                "data-testid": "search-text",
                fontStyle: "smLinkMobile",
                children: a
              }
            )
          ]
        }
      )
    }
  );
}, Kh = "_active_1meqp_245", hl = {
  "search-pagination-base": "_search-pagination-base_1meqp_209",
  active: Kh
}, Xh = (e, t) => t < 7 ? Array.from({ length: t }, (n, r) => r + 1) : e <= 3 ? [1, 2, 3, "...", t] : e >= t - 2 ? [1, "...", t - 2, t - 1, t] : [1, "...", e, "...", t], eT = (e) => {
  const {
    className: t,
    currentPage: n,
    nextPageActionText: r = "Go to next page",
    onPageChange: a,
    previousPageActionText: i = "Go to previous page",
    totalPages: s,
    ...o
  } = e, c = zt(
    () => Xh(n, s),
    [n, s]
  ), d = (p) => {
    a(p), typeof window < "u" && window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, u = n === 1, f = n === s;
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: z(hl["search-pagination-base"], t),
      "data-testid": "search-pagination",
      ...o,
      children: [
        (c == null ? void 0 : c.length) > 1 && /* @__PURE__ */ l.jsx(
          "button",
          {
            disabled: u,
            onClick: () => d(n - 1),
            title: i,
            children: /* @__PURE__ */ l.jsx(re, { icon: "chevronLeft" })
          }
        ),
        c.map(
          (p, h) => typeof p == "number" ? /* @__PURE__ */ l.jsx(
            "button",
            {
              className: p === n ? hl.active : "",
              onClick: () => d(p),
              children: p
            },
            h
          ) : /* @__PURE__ */ l.jsx(
            G,
            {
              fontStyle: "smParagraph",
              children: p
            },
            h
          )
        ),
        (c == null ? void 0 : c.length) > 1 && /* @__PURE__ */ l.jsx(
          "button",
          {
            disabled: f,
            onClick: () => d(n + 1),
            title: r,
            children: /* @__PURE__ */ l.jsx(re, { icon: "chevronRight" })
          }
        )
      ]
    }
  );
}, Zh = "_grid_196i5_209", Qh = "_card_196i5_213", Un = {
  grid: Zh,
  card: Qh,
  "featured-card": "_featured-card_196i5_214",
  "card-link": "_card-link_196i5_224",
  "card-content": "_card-content_196i5_230",
  "card-date": "_card-date_196i5_237"
}, Jh = (e) => {
  const {
    cards: t,
    className: n,
    shouldLazyLoad: r = !1,
    placeholderImage: a,
    ...i
  } = e;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: z(Un.grid, n),
      "data-testid": "content-feed-grid",
      ...i,
      children: t.map((s, o) => {
        const { image: c, date: d, link: u, excerpt: f, isFeatured: p } = s, g = mr(
          c || a,
          r
        );
        return /* @__PURE__ */ l.jsx(
          ur,
          {
            backgroundColor: "white",
            children: /* @__PURE__ */ l.jsxs(
              Bt,
              {
                elevation: "elevation1",
                className: z({
                  [Un["featured-card"]]: p,
                  [Un.card]: !p
                }),
                "data-testid": "content-feed-grid-card",
                children: [
                  g,
                  /* @__PURE__ */ l.jsxs("div", { className: Un["card-content"], children: [
                    /* @__PURE__ */ l.jsx(
                      G,
                      {
                        className: Un["card-date"],
                        "data-testid": "content-feed-grid-card-date",
                        tag: "span",
                        children: d
                      }
                    ),
                    /* @__PURE__ */ l.jsx(
                      X,
                      {
                        buttonStyle: "link",
                        className: Un["card-link"],
                        "data-testid": "content-feed-grid-card-link",
                        children: u
                      }
                    ),
                    p && f && /* @__PURE__ */ l.jsx(
                      le,
                      {
                        className: Un["card-excerpt"],
                        "data-testid": "content-feed-grid-card-excerpt",
                        children: f
                      }
                    )
                  ] })
                ]
              }
            )
          },
          o
        );
      })
    }
  );
}, eg = "_headline_1nxcr_224", tg = "_truncate_1nxcr_252", xn = {
  "news-listing-card": "_news-listing-card_1nxcr_209",
  "is-featured": "_is-featured_1nxcr_214",
  "content-container": "_content-container_1nxcr_219",
  headline: eg,
  "support-copy": "_support-copy_1nxcr_225",
  "headline-wrapper": "_headline-wrapper_1nxcr_236",
  truncate: tg,
  "empty-image-placeholder": "_empty-image-placeholder_1nxcr_263",
  "news-listing-container": "_news-listing-container_1nxcr_291"
}, tT = (e) => {
  const {
    categoryName: t,
    className: n,
    headline: r,
    href: a,
    image: i,
    isFeatured: s,
    shouldShowImage: o = !0,
    shouldTruncateSupportCopy: c = !0,
    supportCopyText: d,
    shouldLazyLoad: u = !1,
    ...f
  } = e, p = mr(i, u);
  return /* @__PURE__ */ l.jsxs(
    Bt,
    {
      elevation: "none",
      className: z(
        xn["news-listing-card"],
        {
          [xn["is-featured"]]: s
        },
        n
      ),
      "data-testid": "news-listing-card",
      ...f,
      children: [
        o && p,
        o && !p && /* @__PURE__ */ l.jsx("div", { className: xn["empty-image-placeholder"] }),
        /* @__PURE__ */ l.jsxs("div", { className: xn["content-container"], children: [
          t ? /* @__PURE__ */ l.jsxs("div", { className: xn["headline-wrapper"], children: [
            /* @__PURE__ */ l.jsx(X, { href: a, children: r && /* @__PURE__ */ l.jsx(
              "span",
              {
                dangerouslySetInnerHTML: {
                  __html: r
                }
              }
            ) }),
            t && /* @__PURE__ */ l.jsxs(
              G,
              {
                fontStyle: "smParagraphBold",
                "data-testid": "news-listing-card-category-name",
                children: [
                  "(",
                  t,
                  ")"
                ]
              }
            )
          ] }) : /* @__PURE__ */ l.jsx(
            X,
            {
              className: xn.headline,
              "data-testid": "news-listing-card-headline",
              href: a,
              children: r
            }
          ),
          /* @__PURE__ */ l.jsx(
            le,
            {
              className: z(xn["support-copy"], {
                [xn.truncate]: c
              }),
              "data-testid": "news-listing-card-support-copy",
              children: d
            }
          )
        ] })
      ]
    }
  );
}, ng = {
  "checkbox-facet-item-base": "_checkbox-facet-item-base_1cop5_209"
}, rg = (e) => {
  const { className: t, label: n, count: r, checked: a, onCheckedChange: i, ...s } = e;
  return /* @__PURE__ */ l.jsxs(
    "label",
    {
      "data-testid": "checkbox-facet-item",
      className: z(ng["checkbox-facet-item-base"], t),
      ...s,
      children: [
        /* @__PURE__ */ l.jsx(
          Cd,
          {
            defaultChecked: a,
            onCheckedChange: i
          }
        ),
        /* @__PURE__ */ l.jsx(
          G,
          {
            fontStyle: "smParagraph",
            fontStyleCorp: "smParagraph",
            children: n
          }
        ),
        /* @__PURE__ */ l.jsxs(
          G,
          {
            as: "span",
            fontStyle: "smParagraphBold",
            fontStyleCorp: "smParagraphBold",
            children: [
              "(",
              r,
              ")"
            ]
          }
        )
      ]
    }
  );
}, Lr = {
  "suggestive-form": "_suggestive-form_fcxnm_209",
  "input-wrapper": "_input-wrapper_fcxnm_214",
  "dropdown-select-list": "_dropdown-select-list_fcxnm_220",
  "suggestion-active": "_suggestion-active_fcxnm_247",
  "search-button": "_search-button_fcxnm_269"
}, gl = /^[\w~=.'\s/-]*$/, vl = 100, ag = (e) => {
  const {
    className: t,
    initialInputValue: n,
    labelText: r,
    onChangeCallback: a,
    onSubmitCallback: i,
    placeholderText: s,
    shouldAutoFocusOnMatch: o = !1,
    shouldDisableSearchUntilMatch: c = !1,
    shouldDisableSubmitOnEnter: d = !1,
    submitButtonText: u,
    suggestions: f
  } = e, [p, h] = ne(
    n || ""
  ), [g, v] = ne(-1), [x, m] = ne(void 0), [b, _] = ne(!1), C = pe(null), w = pe(null), N = pe(null);
  ve(() => {
    a(p);
  }, [p]);
  const M = (k) => {
    const { value: $ } = k.target;
    gl.test($) && $.length <= vl && h($);
  }, S = () => p.trim() !== "" && p.length <= vl && gl.test(p), T = () => {
    _(!0);
  }, j = (k, $) => {
    k.preventDefault(), h($.text), m($);
  }, D = !S() || (c ? !(x != null && x.href) : !1);
  ve(() => {
    var k;
    D || (_(!1), (k = N.current) == null || k.focus());
  }, [x]), ve(() => {
    if (!o)
      return;
    const k = f.find(
      ($) => $.text === p
    );
    (k == null ? void 0 : k.text) !== (x == null ? void 0 : x.text) && m(k);
  }, [p]), ve(() => {
    const k = ($) => {
      var R, F;
      $.target instanceof Node && !((R = C.current) != null && R.contains($.target)) && !((F = w.current) != null && F.contains($.target)) && _(!1);
    };
    return document.addEventListener("mousedown", k), document.addEventListener("touchstart", k), () => {
      document.removeEventListener("mousedown", k), document.removeEventListener("touchstart", k);
    };
  }, []), ve(() => {
    var $;
    const k = ($ = w.current) == null ? void 0 : $.querySelector(
      '[aria-selected="true"]'
    );
    k == null || k.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  }, [g]);
  const A = (k) => {
    var $, R;
    if (k.key === "Tab" && _(!1), k.key === "Escape" && (_(!1), ($ = C.current) == null || $.blur()), k.key === "ArrowUp" && (k.preventDefault(), v((F) => F <= -1 ? -1 : F - 1)), k.key === "ArrowDown" && (k.preventDefault(), v(
      (F) => F < f.length - 1 ? F + 1 : F
    )), k.key === "Enter") {
      d && k.preventDefault(), !d && g === -1 && (_(!1), (R = N.current) == null || R.focus());
      const F = f[g];
      F && (k.preventDefault(), h(F.text), m(F), _(!1), v(-1));
    }
  };
  return ve(() => {
    g > -1 && v(-1);
  }, [p]), /* @__PURE__ */ l.jsxs(
    "form",
    {
      onSubmit: (k) => i(k),
      className: z(Lr["suggestive-form"], t),
      children: [
        /* @__PURE__ */ l.jsxs("div", { className: Lr["input-wrapper"], children: [
          /* @__PURE__ */ l.jsx(
            En,
            {
              "aria-activedescendant": g >= 0 ? `suggestion-${g}` : void 0,
              ariaLabel: r,
              ariaRequired: "true",
              autoComplete: "off",
              className: Lr.input,
              "data-testid": "suggestive-dropdown-input",
              inputId: r,
              label: r,
              onChange: M,
              onFocus: T,
              onKeyDown: A,
              placeholder: s,
              ref: C,
              value: p
            }
          ),
          b && !!f.length && /* @__PURE__ */ l.jsx(
            "ul",
            {
              role: "listbox",
              ref: w,
              className: Lr["dropdown-select-list"],
              children: f.map((k, $) => {
                const R = $ === g;
                return /* @__PURE__ */ l.jsx(
                  "li",
                  {
                    "aria-selected": R,
                    className: z({
                      [Lr["suggestion-active"]]: R
                    }),
                    id: `suggestion-${$}`,
                    onClick: (F) => j(F, k),
                    role: "option",
                    children: k.text
                  },
                  $
                );
              })
            }
          )
        ] }),
        /* @__PURE__ */ l.jsx(
          vn,
          {
            ref: N,
            size: "responsive",
            type: "submit",
            disabled: D,
            className: Lr["search-button"],
            children: u
          }
        )
      ]
    }
  );
}, ig = "_footer_iq6ce_209", sg = "_language_iq6ce_283", Ye = {
  footer: ig,
  "bottom-text": "_bottom-text_iq6ce_215",
  "content-container": "_content-container_iq6ce_247",
  "column-heading": "_column-heading_iq6ce_252",
  "column-list": "_column-list_iq6ce_262",
  "border-separator": "_border-separator_iq6ce_277",
  language: sg,
  "legal-section1": "_legal-section1_iq6ce_307",
  "copyright-text": "_copyright-text_iq6ce_310",
  "social-media-link": "_social-media-link_iq6ce_320",
  "social-icon": "_social-icon_iq6ce_332",
  "content-grid": "_content-grid_iq6ce_343",
  "footer-logo": "_footer-logo_iq6ce_348",
  "content-container-4": "_content-container-4_iq6ce_366",
  "content-container-3": "_content-container-3_iq6ce_370",
  "content-container-2": "_content-container-2_iq6ce_374",
  "content-container-1": "_content-container-1_iq6ce_378",
  "footer-column2-max-width": "_footer-column2-max-width_iq6ce_392",
  "grid-row": "_grid-row_iq6ce_395"
}, nT = (e) => {
  const {
    bottomText: t,
    className: n,
    copyRightText: r,
    footerColumn: a,
    legalSection1Text: i,
    legalSection2Text: s,
    logo: o,
    logoLink: c,
    socialMediaLinks: d,
    ...u
  } = e, f = a.length === 4, p = a.length, h = nr(o) ? Te(o, {
    loading: "lazy"
  }) : o;
  return /* @__PURE__ */ l.jsxs(
    xe,
    {
      tag: "footer",
      className: z(Ye.footer, n),
      "data-testid": "footer",
      ...u,
      children: [
        /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: z(Ye["content-grid"], {
              [Ye["grid-row"]]: p < 3
            }),
            children: [
              /* @__PURE__ */ l.jsx(
                "div",
                {
                  className: z(Ye["footer-logo"], {
                    [Ye["footer-column2"]]: !f,
                    [Ye["footer-column2-max-width"]]: p < 3
                  }),
                  "data-testid": "footer-logo",
                  children: nr(c) ? /* @__PURE__ */ l.jsx(X, { children: Te(c, {
                    children: h
                  }) }) : o
                }
              ),
              /* @__PURE__ */ l.jsx(
                "div",
                {
                  className: z(Ye["content-container"], {
                    [Ye[`content-container-${p}`]]: !0
                  }),
                  children: a.map((g, v) => /* @__PURE__ */ l.jsxs(
                    "div",
                    {
                      className: Ye.column,
                      children: [
                        /* @__PURE__ */ l.jsx(
                          G,
                          {
                            tag: "p",
                            className: Ye["column-heading"],
                            children: g.headline
                          }
                        ),
                        /* @__PURE__ */ l.jsx("ul", { className: Ye["column-list"], children: g.footerLinkItems.map(
                          (x, m) => /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx(X, { children: x }) }, m)
                        ) }),
                        v === 0 && /* @__PURE__ */ l.jsx(
                          "div",
                          {
                            className: Ye["social-media-link"],
                            children: d == null ? void 0 : d.map(
                              (x, m) => /* @__PURE__ */ l.jsx(X, { children: Te(
                                x.link,
                                {
                                  children: /* @__PURE__ */ l.jsx(
                                    re,
                                    {
                                      className: Ye["social-icon"],
                                      icon: x.iconName
                                    }
                                  )
                                }
                              ) }, m)
                            )
                          }
                        )
                      ]
                    },
                    v
                  ))
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "bottom-text",
            className: Ye["bottom-text"],
            children: t
          }
        ),
        /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx("div", { className: Ye["border-separator"] }) }),
        /* @__PURE__ */ l.jsxs("div", { className: Ye.language, children: [
          i && /* @__PURE__ */ l.jsx(
            le,
            {
              "data-testid": "legal-section1",
              className: Ye["legal-section1"],
              children: i
            }
          ),
          r && /* @__PURE__ */ l.jsx(le, { className: Ye["copyright-text"], children: r }),
          s && /* @__PURE__ */ l.jsx(
            le,
            {
              "data-testid": "legal-section2",
              className: Ye["legal-section2"],
              children: s
            }
          )
        ] })
      ]
    }
  );
}, og = "_header_z3sy2_209", cg = "_sentinel_z3sy2_215", lg = "_stuck_z3sy2_223", dg = "_fixed_z3sy2_230", ia = {
  header: og,
  sentinel: cg,
  stuck: lg,
  fixed: dg,
  "slide-down": "_slide-down_z3sy2_234"
}, Ho = () => {
  const e = Et(hd);
  if (e === void 0)
    throw new Error("useThemeContext must be used within a ThemeProvider");
  const { theme: t } = e;
  return {
    theme: t,
    isConsumer: t === "Consumer",
    isCorporate: t === "Corporate",
    isChildrens: t === "Childrens",
    isSoutheastConsumer: t === "SoutheastConsumer"
  };
}, U3 = ({
  threshold: e = 0
}) => {
  const [t, n] = ne(
    void 0
  ), [r, a] = ne(0);
  return ve(() => {
    let i = window.scrollY, s = !1;
    const o = () => {
      const d = window.scrollY;
      if (Math.abs(d - i) < e) {
        s = !1;
        return;
      }
      n(d > i ? "down" : "up"), i = d > 0 ? d : 0, s = !1;
    }, c = () => {
      s || (window.requestAnimationFrame(o), s = !0), a((window == null ? void 0 : window.pageYOffset) ?? 0);
    };
    return window.addEventListener("scroll", c), () => window.removeEventListener("scroll", c);
  }, [t]), { scrollDir: t, scrollPos: r };
};
function bl() {
  return typeof window < "u" ? {
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight
  } : { windowWidth: void 0, windowHeight: void 0 };
}
const ug = () => {
  const [e, t] = ne(
    bl()
  );
  return ve(() => {
    function n() {
      t(bl());
    }
    return window == null || window.addEventListener("resize", n), () => window == null ? void 0 : window.removeEventListener("resize", n);
  }, []), e;
}, fg = (e) => (ve(() => {
  const t = e.current;
  if (!t)
    return;
  const n = t.querySelector("figure");
  if (!n)
    return;
  const r = () => {
    const s = "next-to-left-floated-image", o = t.querySelector(
      'figure[class*="media-left"]'
    ), c = o == null ? void 0 : o.getBoundingClientRect(), d = t.querySelectorAll("ul, ol");
    d.forEach((u) => {
      u.classList.remove(s);
    }), c && (t.style.setProperty(
      "--image-width",
      `${c.width}px`
    ), d.forEach((u) => {
      const f = u.getBoundingClientRect();
      f.top < c.bottom && f.left < c.right && u.classList.add(s);
    }));
  };
  r();
  const a = new ResizeObserver(() => {
    r();
  });
  a.observe(n);
  const i = new MutationObserver(() => {
    r();
  });
  return i.observe(n, {
    attributes: !0,
    childList: !0,
    subtree: !0
  }), () => {
    a.disconnect(), i.disconnect();
  };
}, [e]), {}), rT = (e) => {
  var x, m;
  const t = pe(null), n = pe(null), r = 96, { scrollDir: a } = U3({ threshold: r }), [i, s] = ne(), [o, c] = ne(!1), {
    className: d,
    utilityNavigation: u,
    globalNavigation: f,
    featuredUtilityCtaNumber: p,
    ...h
  } = e;
  ve(() => {
    var w;
    if (!n.current)
      return;
    s((((w = n.current) == null ? void 0 : w.getBoundingClientRect().top) ?? 0) < 0);
    let b = !1;
    const _ = () => b ? !0 : (b = !0, setTimeout(() => {
      b = !1;
    }, 200), !1), C = new IntersectionObserver((N) => {
      _() || s(!N.some((M) => M.isIntersecting));
    });
    return C.observe(n.current), () => {
      C.disconnect();
    };
  }, [n.current]);
  const g = i && a === "up" && window.scrollY > (((x = t.current) == null ? void 0 : x.offsetHeight) ?? 0) || !u;
  ve(() => {
    if (!window)
      return;
    setTimeout(() => {
      if (!document.body || !t.current)
        return;
      const _ = t.current.getBoundingClientRect().bottom / 16;
      document.body.style.setProperty(
        "--header-height",
        `${_}rem`
      );
    }, 201);
  }, [t.current, i, g, o]);
  const v = p ? (m = u == null ? void 0 : u.ctaButtons) == null ? void 0 : m[p - 1] : void 0;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      "div",
      {
        className: z(ia.sentinel, {
          [ia.stuck]: i
        }),
        ref: n
      }
    ),
    /* @__PURE__ */ l.jsxs(
      "header",
      {
        "data-testid": "header",
        ref: t,
        className: z(ia.header, {
          // Transparent background must be fixed to allow the components below to slide up behind the header.
          [ia.fixed]: f.backgroundColor === "transparent",
          [ia["slide-down"]]: g,
          className: d
        }),
        ...h,
        children: [
          u && /* @__PURE__ */ l.jsx(j8, { ...u }),
          /* @__PURE__ */ l.jsx(
            km,
            {
              isStuck: i,
              utilityNavigation: u,
              featuredCtaButton: v,
              isSearchBarOpen: o,
              setIsSearchBarOpen: c,
              ...f
            }
          )
        ]
      }
    )
  ] });
}, pg = "_headline_19d4f_209", At = {
  headline: pg,
  "top-copy": "_top-copy_19d4f_217",
  "bottom-copy": "_bottom-copy_19d4f_220",
  "content-copy-container": "_content-copy-container_19d4f_223",
  "content-copy-container-left": "_content-copy-container-left_19d4f_226",
  "content-copy-container-center": "_content-copy-container-center_19d4f_229",
  "cta-button": "_cta-button_19d4f_232",
  "content-cards-grid": "_content-cards-grid_19d4f_240"
}, yl = De(At["cta-content-cards-base"], {
  variants: {
    hasDropShadows: me({
      true: Qe["with-shadow"],
      false: ""
    }),
    contentAlignment: me({
      left: At["content-copy-container-left"],
      center: At["content-copy-container-center"]
    })
  }
}), aT = (e) => {
  const {
    headline: t,
    headlineTag: n = "p",
    contentAlignment: r = "center",
    numColumns: a = "2",
    supportingCopy: i,
    bottomSupportingCopy: s,
    cta: o,
    hasDropShadows: c = !1,
    backgroundColor: d = "white",
    contentCards: u,
    className: f,
    ...p
  } = e;
  return /* @__PURE__ */ l.jsxs(
    xe,
    {
      "data-testid": "cta-content-cards",
      backgroundColor: d,
      className: z(
        yl({ contentAlignment: r }),
        At["content-copy-container"],
        f
      ),
      ...p,
      children: [
        /* @__PURE__ */ l.jsxs("div", { className: At["top-copy"], children: [
          t && /* @__PURE__ */ l.jsx(
            G,
            {
              "data-testid": "cta-cards-container-headline",
              className: At.headline,
              tag: n,
              children: t
            }
          ),
          i && /* @__PURE__ */ l.jsx(
            "div",
            {
              "data-testid": "cta-cards-top-copy",
              className: At["top-copy"],
              children: /* @__PURE__ */ l.jsx(le, { children: i })
            }
          )
        ] }),
        u && /* @__PURE__ */ l.jsx(
          rt,
          {
            className: z(
              yl({ hasDropShadows: c }),
              At["content-cards-grid"]
            ),
            columns: "1",
            "data-backgroundcolor": d,
            columnsTablet: parseInt(a) >= 2 ? "2" : "1",
            columnsDesktop: a ?? "3",
            children: u
          }
        ),
        s && /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "cta-cards-bottom-copy",
            className: At["bottom-copy"],
            children: s
          }
        ),
        o && /* @__PURE__ */ l.jsx("div", { className: At["cta-button-container"], children: /* @__PURE__ */ l.jsx(
          X,
          {
            "data-testid": "cta-cards-container-cta",
            size: "responsive",
            variant: "solid1",
            className: At["cta-button"],
            children: o
          }
        ) })
      ]
    }
  );
}, mg = "_center_dhlua_212", hg = "_headline_dhlua_220", Mt = {
  "side-photo-content-card-carousel-base": "_side-photo-content-card-carousel-base_dhlua_209",
  center: mg,
  "top-content": "_top-content_dhlua_215",
  headline: hg,
  "side-photo-content-card-carousel": "_side-photo-content-card-carousel_dhlua_209",
  "carousel-controls": "_carousel-controls_dhlua_226",
  "bottom-content": "_bottom-content_dhlua_229",
  "layout-forty": "_layout-forty_dhlua_253",
  "image-right": "_image-right_dhlua_257",
  "layout-fifty": "_layout-fifty_dhlua_261"
}, gg = De("", {
  variants: {
    imageSide: {
      left: Mt["image-left"],
      right: Mt["image-right"]
    },
    layout: {
      fifty: Mt["layout-fifty"],
      forty: Mt["layout-forty"]
    }
  }
}), sa = De("", {
  variants: {
    contentAlignment: me({
      center: Mt.center,
      left: Mt.left
    })
  }
}), vg = {
  solid: "solid",
  outline: "outlined",
  link: "link"
}, iT = (e) => {
  const {
    backgroundColor: t = "whiteSmoke",
    bottomSupportCopy: n,
    className: r,
    cta: a,
    contentAlignment: i = "center",
    ctaStyle: s = "solid",
    headline: o,
    headlineTag: c = "p",
    imageSide: d,
    layout: u,
    slides: f,
    slideTimingSeconds: p = 6,
    supportCopy: h,
    ...g
  } = e, v = f.map((x) => {
    const m = {
      ...x.props,
      imageSide: d,
      layout: u,
      backgroundColor: t,
      hasCarouselControls: !0,
      isPadded: !1
    };
    return Te(x, m);
  });
  return /* @__PURE__ */ l.jsxs(
    xe,
    {
      backgroundColor: t,
      className: z(
        Mt["side-photo-content-card-carousel-base"],
        r
      ),
      "data-testid": "side-photo-content-card-carousel",
      ...g,
      children: [
        /* @__PURE__ */ l.jsxs("div", { className: Mt["top-content"], children: [
          o && /* @__PURE__ */ l.jsx(
            G,
            {
              className: z(
                Mt.headline,
                sa({
                  contentAlignment: i
                })
              ),
              tag: c,
              children: o
            }
          ),
          h && /* @__PURE__ */ l.jsx(
            le,
            {
              className: sa({
                contentAlignment: i
              }),
              children: h
            }
          )
        ] }),
        /* @__PURE__ */ l.jsx(
          c1,
          {
            backgroundColor: t,
            className: z(
              Mt["side-photo-content-card-carousel"],
              gg({
                imageSide: d,
                layout: u
              })
            ),
            controlsClass: Mt["carousel-controls"],
            slides: v,
            slideTimingSeconds: p
          }
        ),
        /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: z(
              Mt["bottom-content"],
              sa({
                contentAlignment: i
              })
            ),
            children: [
              n && /* @__PURE__ */ l.jsx(
                le,
                {
                  className: sa({
                    contentAlignment: i
                  }),
                  children: n
                }
              ),
              a && /* @__PURE__ */ l.jsx(
                X,
                {
                  className: sa({
                    contentAlignment: i
                  }),
                  buttonStyle: vg[s ?? "solid"],
                  size: "responsive",
                  children: a
                }
              )
            ]
          }
        )
      ]
    }
  );
}, bg = {
  "icon-cta-bordered-grid": "_icon-cta-bordered-grid_193ke_209"
}, sT = (e) => {
  const {
    bottomSupportCopy: t,
    children: n,
    className: r,
    headline: a,
    numberOfColumns: i = "2",
    supportCopy: s,
    headlineTag: o = "p",
    ...c
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      className: r,
      "data-testid": "icon-cta-bordered",
      contentAlignment: "left",
      headline: a,
      headlineTag: o,
      supportCopy: s,
      supportCopyBottom: t,
      ...c,
      children: /* @__PURE__ */ l.jsx(
        rt,
        {
          columns: "1",
          columnsTablet: i === "1" ? "1" : "2",
          columnsDesktop: i,
          className: bg["icon-cta-bordered-grid"],
          "data-testid": "icon-cta-bordered-grid",
          children: n
        }
      )
    }
  );
}, yg = "_heading_1fja2_218", Kn = {
  "reverse-rows-base": "_reverse-rows-base_1fja2_209",
  "content-row": "_content-row_1fja2_212",
  "with-padding": "_with-padding_1fja2_215",
  heading: yg,
  "supporting-copy-top": "_supporting-copy-top_1fja2_221",
  "supporting-copy-bottom": "_supporting-copy-bottom_1fja2_224"
}, xg = De("", {
  variants: {
    shouldRemovePaddingBetweenRows: me({
      true: "",
      false: [Kn["with-padding"], et["media-side-padding"]]
    })
  }
}), oT = (e) => {
  const {
    className: t,
    headline: n,
    headlineTag: r = "h2",
    topSupportingCopy: a,
    bottomSupportingCopy: i,
    bottomCta: s,
    rows: o,
    shouldRemovePaddingBetweenRows: c,
    ...d
  } = e;
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: z(Kn["reverse-rows-base"], t),
      "data-testid": "reverse-rows",
      ...d,
      children: [
        /* @__PURE__ */ l.jsxs(xe, { children: [
          /* @__PURE__ */ l.jsx(
            G,
            {
              "data-testid": "reverse-rows-heading",
              tag: r,
              className: Kn.heading,
              children: n
            }
          ),
          /* @__PURE__ */ l.jsx(
            le,
            {
              "data-testid": "reverse-rows-supporting-copy-top",
              className: Kn["supporting-copy-top"],
              children: a
            }
          )
        ] }),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: z(
              xg({
                shouldRemovePaddingBetweenRows: c
              }),
              Kn["content-row"]
            ),
            children: o
          }
        ),
        /* @__PURE__ */ l.jsxs(xe, { className: Kn["bottom-section"], children: [
          /* @__PURE__ */ l.jsx(
            le,
            {
              "data-testid": "reverse-rows-supporting-copy-bottom",
              className: Kn["supporting-copy-bottom"],
              children: i
            }
          ),
          /* @__PURE__ */ l.jsx(X, { children: s })
        ] })
      ]
    }
  );
}, _g = {
  "icon-cta-simplified-grid": "_icon-cta-simplified-grid_1csdk_209"
}, cT = (e) => {
  const {
    className: t,
    headline: n,
    headlineTag: r = "p",
    supportCopy: a,
    bottomSupportCopy: i,
    numberOfColumns: s = "2",
    iconCtas: o,
    mobileBehavior: c = "stacked",
    ...d
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      tag: "section",
      className: t,
      "data-testid": "icon-cta-simplified",
      headline: n,
      headlineTag: r,
      supportCopy: a,
      supportCopyBottom: i,
      ...d,
      children: /* @__PURE__ */ l.jsx(
        rt,
        {
          columns: c === "stacked" ? "1" : "2",
          columnsTablet: s === "1" ? "1" : "2",
          columnsDesktop: s,
          className: _g["icon-cta-simplified-grid"],
          "data-testid": "icon-cta-simplified-grid",
          children: o
        }
      )
    }
  );
}, wg = {
  "icon-cta-left-aligned-grid": "_icon-cta-left-aligned-grid_1hf9d_209"
}, lT = (e) => {
  const {
    bottomSupportCopy: t,
    children: n,
    className: r,
    headline: a,
    headlineAlignment: i = "center",
    headlineTag: s = "p",
    numberOfColumns: o = "2",
    supportCopy: c,
    supportCopyAlignment: d = "center",
    ...u
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      className: r,
      "data-testid": "icon-cta-left-aligned",
      headline: a,
      headlineAlignment: i,
      headlineTag: s,
      supportCopy: c,
      supportCopyAlignment: d,
      supportCopyBottom: t,
      supportCopyBottomAlignment: d,
      ...u,
      children: /* @__PURE__ */ l.jsx(
        rt,
        {
          columns: "1",
          columnsTablet: o === "1" ? "1" : "2",
          columnsDesktop: o,
          className: wg["icon-cta-left-aligned-grid"],
          "data-testid": "icon-cta-left-aligned-grid",
          children: n
        }
      )
    }
  );
}, Cg = {
  "card-container": "_card-container_1lssu_209"
}, dT = (e) => {
  const {
    headline: t,
    headlineTag: n = "p",
    headlineAlignment: r = "center",
    supportCopy: a,
    supportCopyAlignment: i = "center",
    bottomSupportCopy: s,
    children: o,
    columns: c = "2",
    className: d,
    ...u
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      className: d,
      "data-testid": "icon-cta-colored-box",
      headline: t,
      headlineAlignment: r,
      headlineTag: n,
      supportCopy: a,
      supportCopyAlignment: i,
      supportCopyBottom: s,
      supportCopyBottomAlignment: i,
      ...u,
      children: /* @__PURE__ */ l.jsx(
        rt,
        {
          className: Cg["card-container"],
          columnsTablet: c,
          columns: "1",
          rowGap: "even",
          "data-testid": "card",
          children: o
        }
      )
    }
  );
}, Xt = {
  "corporate-footer-base": "_corporate-footer-base_17han_209",
  "top-footer": "_top-footer_17han_218",
  "top-footer-container": "_top-footer-container_17han_221",
  "sub-footer-container": "_sub-footer-container_17han_271",
  "sub-footer": "_sub-footer_17han_271",
  "social-media-links": "_social-media-links_17han_300"
}, uT = (e) => {
  const {
    className: t,
    copyRightText: n,
    footerBody: r,
    legalPrivacyLink: a,
    socialMediaLinks: i,
    ...s
  } = e, o = i && i.length > 0;
  return /* @__PURE__ */ l.jsxs(
    "footer",
    {
      className: z(Xt["corporate-footer-base"], t),
      "data-testid": "corporate-footer",
      ...s,
      children: [
        /* @__PURE__ */ l.jsx(
          xe,
          {
            className: Xt["top-footer-container"],
            backgroundColor: "transparent",
            "data-testid": "corp-footer-body",
            variant: "containedSmall",
            children: /* @__PURE__ */ l.jsx("div", { className: Xt["top-footer"], children: r })
          }
        ),
        /* @__PURE__ */ l.jsx(xe, { className: Xt["sub-footer-container"], children: /* @__PURE__ */ l.jsxs("div", { className: Xt["sub-footer"], children: [
          o && /* @__PURE__ */ l.jsx("div", { className: Xt["social-media-links"], children: i == null ? void 0 : i.map((c, d) => /* @__PURE__ */ l.jsx(
            X,
            {
              "data-testid": "corporate-footer-link",
              children: Te(
                c.link,
                {
                  title: c.iconName,
                  children: /* @__PURE__ */ l.jsx(
                    re,
                    {
                      "data-testid": `corporate-footer-link-${c.iconName}`,
                      className: Xt["social-icon"],
                      icon: c.iconName
                    }
                  )
                }
              )
            },
            d
          )) }),
          /* @__PURE__ */ l.jsx(
            le,
            {
              className: Xt["copy-right-text"],
              "data-testid": "corporate-footer-copyright-text",
              children: n
            }
          ),
          /* @__PURE__ */ l.jsx(
            X,
            {
              "data-testid": "corporate-footer-legal-privacy-link",
              asInherited: !0,
              underline: "none",
              className: Xt["legal-privacy-text"],
              children: a
            }
          )
        ] }) })
      ]
    }
  );
}, Sg = {
  "stats-list": "_stats-list_1ws3p_209"
}, fT = (e) => {
  const {
    className: t,
    backgroundColor: n = "white",
    contentAlignments: r = "center",
    ctaAlignment: a = "center",
    headline: i,
    headlineTag: s = "p",
    supportCopy: o,
    supportCopyBottom: c,
    cta: d,
    children: u,
    ...f
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      "data-testid": "side-statistics",
      variant: "containedSmall",
      headline: i,
      headlineTag: s,
      supportCopy: o,
      contentAlignment: r,
      backgroundColor: n,
      supportCopyBottom: c,
      cta: d,
      ctaAlignment: a,
      className: t,
      ...f,
      children: /* @__PURE__ */ l.jsx("ul", { className: Sg["stats-list"], children: u })
    }
  );
}, Lg = "_grid_whj9s_209", _n = {
  grid: Lg,
  "grid-2-m": "_grid-2-m_whj9s_220",
  "grid-dividers": "_grid-dividers_whj9s_223",
  "content-inverse": "_content-inverse_whj9s_238",
  "grid-1": "_grid-1_whj9s_248",
  "grid-2": "_grid-2_whj9s_220",
  "grid-3": "_grid-3_whj9s_254",
  "grid-4": "_grid-4_whj9s_257"
}, G3 = on({
  isStackedMobile: !0,
  isStackedDesktop: !1
}), pT = (e) => {
  const {
    className: t,
    backgroundColor: n = "white",
    contentAlignments: r = "center",
    ctaAlignment: a = "center",
    headline: i,
    headlineTag: s = "p",
    supportCopy: o,
    supportCopyBottom: c,
    cta: d,
    numberOfColumnsMobile: u = "1",
    numberOfColumns: f = "3",
    shouldShowColumnDividers: p = !1,
    children: h,
    ...g
  } = e, v = hr(n);
  return /* @__PURE__ */ l.jsx(
    G3.Provider,
    {
      value: {
        isStackedMobile: u === "1",
        isStackedDesktop: f === "1"
      },
      children: /* @__PURE__ */ l.jsx(
        He,
        {
          "data-testid": "hero-statistics",
          backgroundColor: n,
          headline: i,
          headlineTag: s,
          supportCopy: o,
          variant: "containedSmall",
          supportCopyBottom: c,
          contentAlignment: r,
          cta: d,
          ctaAlignment: a,
          className: z(
            t,
            v && _n["content-inverse"]
          ),
          ...g,
          children: /* @__PURE__ */ l.jsx(
            "div",
            {
              "data-testid": "hero-statistics-column-grid",
              className: z(_n.grid, {
                [_n["grid-dividers"]]: p,
                [_n["grid-2-m"]]: u === "2",
                [_n["grid-1"]]: f === "1",
                [_n["grid-2"]]: f === "2",
                [_n["grid-3"]]: f === "3",
                [_n["grid-4"]]: f === "4"
              }),
              children: h
            }
          )
        }
      )
    }
  );
}, Mg = "_copy_lditx_209", Ng = "_headline_lditx_214", tn = {
  "media-gallery-base": "_media-gallery-base_lditx_209",
  copy: Mg,
  headline: Ng,
  "copy-center": "_copy-center_lditx_217",
  "cta-container": "_cta-container_lditx_220",
  "cta-container-no-margin": "_cta-container-no-margin_lditx_227"
}, zg = De("", {
  variants: {
    alignment: me({
      left: "",
      center: tn["copy-center"]
    })
  }
}), mT = (e) => {
  const {
    backgroundColor: t = "white",
    className: n,
    contentAlignment: r = "left",
    cta: a,
    headline: i,
    headlineTag: s = "p",
    shouldHideNavigation: o,
    shouldHideThumbnails: c,
    slides: d,
    supportCopy: u,
    componentName: f,
    shouldLazyLoad: p = !1,
    ...h
  } = e, g = d.filter(
    ({ image: v, videoId: x }) => v || x
  );
  return /* @__PURE__ */ l.jsx(
    He,
    {
      variant: "containedSmall",
      className: z(tn["media-gallery-base"], n),
      backgroundColor: t,
      "data-testid": "media-gallery",
      ...h,
      children: /* @__PURE__ */ l.jsx(rt, { children: /* @__PURE__ */ l.jsxs(
        Rn,
        {
          span: "4",
          offsetTablet: "1",
          spanTablet: "10",
          offsetDesktop: "0",
          spanDesktop: "12",
          children: [
            /* @__PURE__ */ l.jsxs(
              "div",
              {
                className: z(
                  tn.copy,
                  zg({ alignment: r })
                ),
                children: [
                  i && /* @__PURE__ */ l.jsx(
                    G,
                    {
                      tag: s,
                      "data-testid": "media-gallery-headline",
                      className: tn.headline,
                      children: i
                    }
                  ),
                  u && /* @__PURE__ */ l.jsx(
                    le,
                    {
                      "data-testid": "media-gallery-support-copy",
                      className: tn["support-copy"],
                      children: u
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ l.jsx(
              q3,
              {
                slides: g,
                shouldHideNavigation: o,
                shouldHideThumbnails: c,
                shouldLazyLoad: p,
                componentName: f,
                ...h
              }
            ),
            a && /* @__PURE__ */ l.jsx("div", { className: z(tn.copy), children: /* @__PURE__ */ l.jsx(
              "div",
              {
                className: z(tn["cta-container"], {
                  [tn["cta-container-no-margin"]]: !!c
                }),
                children: /* @__PURE__ */ l.jsx(
                  X,
                  {
                    "data-testid": "media-gallery-cta",
                    buttonStyle: "outlined",
                    size: "responsive",
                    className: tn.cta,
                    children: a
                  }
                )
              }
            ) })
          ]
        }
      ) })
    }
  );
}, Eg = "_grid_uljjq_209", Qa = {
  grid: Eg,
  "grid-4": "_grid-4_uljjq_221",
  "grid-2": "_grid-2_uljjq_225",
  "grid-3": "_grid-3_uljjq_237"
}, hT = (e) => {
  const {
    className: t,
    backgroundColor: n = "white",
    numberOfColumns: r = "4",
    contentAlignments: a = "center",
    ctaAlignment: i = "center",
    headline: s,
    headlineTag: o = "p",
    supportCopy: c,
    supportCopyBottom: d,
    cta: u,
    children: f,
    ...p
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      "data-testid": "top-statistics",
      headline: s,
      headlineTag: o,
      supportCopy: c,
      contentAlignment: a,
      supportCopyBottom: d,
      cta: u,
      ctaAlignment: i,
      variant: "containedSmall",
      backgroundColor: n,
      className: t,
      ...p,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          "data-testid": "top-statistics-column-grid",
          className: z(Qa.grid, {
            [Qa["grid-2"]]: r === "2",
            [Qa["grid-3"]]: r === "3",
            [Qa["grid-4"]]: r === "4"
          }),
          children: f
        }
      )
    }
  );
}, Tg = "_alert_g4a68_209", kg = {
  alert: Tg
}, Y3 = {
  info: "utilityInfo",
  warning: "utilityWarning",
  error: "utilityNegative",
  success: "utilityPositive",
  utility: "utilityUtility"
}, K3 = {
  info: "circleInfoSolid",
  warning: "circleExclamation",
  error: "circleXmark",
  success: "circleCheck",
  utility: "wrench"
}, gT = (e) => {
  const {
    className: t,
    alertType: n = "info",
    alertFunction: r,
    shouldHideIcon: a = !1,
    primaryAlertText: i,
    mobileAlertText: s,
    expandedAlertText: o,
    showMoreLabel: c = "Show More",
    showLessLabel: d = "Show Less",
    dismissButtonTitle: u = "Dismiss alert",
    isDismissed: f,
    onDismiss: p,
    ...h
  } = e, g = z(kg.alert, t);
  return r === "expanding" && o ? /* @__PURE__ */ l.jsx(
    e9,
    {
      className: g,
      alertType: n,
      primaryAlertText: i,
      mobileAlertText: s,
      shouldHideIcon: a,
      expandedAlertText: o,
      showMoreLabel: c,
      showLessLabel: d,
      ...h
    }
  ) : /* @__PURE__ */ l.jsx(
    n9,
    {
      className: g,
      alertType: n,
      primaryAlertText: i,
      mobileAlertText: s,
      shouldHideIcon: a,
      dismissButtonTitle: u,
      isDismissed: f,
      onDismiss: p,
      isDismissible: r === "dismissible",
      ...h
    }
  );
}, jg = {
  "location-grid": "_location-grid_h368d_209"
}, vT = (e) => {
  const {
    headline: t,
    supportCopy: n,
    bottomSupportCopy: r,
    cta: a,
    headlineTag: i = "p",
    contentAlignment: s = "center",
    backgroundColor: o = "whiteSmoke",
    children: c,
    numberOfColumns: d = "3",
    className: u,
    ...f
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      "data-testid": "location-cards-container",
      variant: "containedSmall",
      backgroundColor: o,
      className: u,
      contentAlignment: s,
      headline: t,
      headlineTag: i,
      supportCopy: n,
      supportCopyBottom: r,
      cta: a,
      ctaAlignment: s,
      ctaStyle: "link",
      ...f,
      children: /* @__PURE__ */ l.jsx(
        rt,
        {
          className: jg["location-cards-grid"],
          columns: "1",
          columnsTablet: d === "1" ? "1" : "2",
          columnsDesktop: d,
          "data-testid": "location-cards-grid",
          children: c
        }
      )
    }
  );
}, xl = {
  "accordion-wrapper-items": "_accordion-wrapper-items_1gb3e_209"
}, Pg = "multiple", bT = (e) => {
  const {
    accordionItems: t,
    bottomDescription: n,
    className: r,
    icon: a,
    shouldOpenFirstItem: i,
    title: s,
    topDescription: o,
    type: c = Pg,
    defaultOpenItem: d = "",
    ...u
  } = e, [f, p] = ne(
    c === "single" ? i ? d : "" : i ? [d] : []
  ), h = (x) => {
    p(x);
  }, g = ft(
    (x) => {
      const m = document.querySelector(
        `div[data-testid="accordion-item"] [name="${x}"]`
      ) ?? document.getElementById(x);
      if (m) {
        const b = m.closest("[data-value]");
        b == null || b.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
        const _ = (b == null ? void 0 : b.getAttribute("data-value")) || "";
        p((C) => {
          if (c === "single")
            return C === _ ? "" : _;
          {
            const w = Array.isArray(C) ? [...C] : [];
            return w.push(_), w;
          }
        });
      }
    },
    [c]
  ), v = ft(
    (x) => {
      var C;
      x.preventDefault();
      const m = x.target, b = (C = m == null ? void 0 : m.getAttribute("href")) == null ? void 0 : C.substring(1), _ = window.location;
      if (_.hash = b ?? "", window.history.pushState(null, "", _.href), b)
        g(b);
      else
        return;
    },
    [g]
  );
  return ve(() => {
    const x = document.querySelectorAll('a[href^="#"]');
    return x.forEach((m) => {
      m.addEventListener("click", v);
    }), () => {
      x.forEach((m) => {
        m.removeEventListener("click", v);
      });
    };
  }, [v]), ve(() => {
    if (window) {
      const x = () => {
        const m = window.location.hash.substring(1);
        m && setTimeout(() => {
          g(m);
        }, 500);
      };
      return window.addEventListener("hashchange", x), x(), () => {
        window.removeEventListener("hashchange", x);
      };
    }
  }, [g]), /* @__PURE__ */ l.jsx(
    He,
    {
      className: r,
      "data-testid": "accordion-wrapper",
      headline: s == null ? void 0 : s.value,
      headlineTag: s == null ? void 0 : s.tag,
      headlineIcon: a == null ? void 0 : a.value,
      headlineIconPlacement: a == null ? void 0 : a.placement,
      headlineAlignment: s == null ? void 0 : s.alignment,
      supportCopy: o,
      supportCopyAlignment: "left",
      supportCopyBottom: n,
      supportCopyBottomAlignment: "left",
      ...u,
      children: c === "single" ? /* @__PURE__ */ l.jsx(
        Ps,
        {
          className: z(xl["accordion-wrapper-items"]),
          type: "single",
          collapsible: !0,
          value: f,
          onValueChange: h,
          defaultValue: i ? d : void 0,
          children: t
        }
      ) : /* @__PURE__ */ l.jsx(
        Ps,
        {
          className: z(xl["accordion-wrapper-items"]),
          type: "multiple",
          value: f,
          onValueChange: h,
          defaultValue: i ? [d] : void 0,
          children: t
        }
      )
    }
  );
}, Ag = "_content_1roo2_230", $g = "_hidden_1roo2_235", Ig = "_heading_1roo2_330", Ie = {
  "hero-banner-desktop": "_hero-banner-desktop_1roo2_209",
  "hero-banner-mobile": "_hero-banner-mobile_1roo2_219",
  "bg-img": "_bg-img_1roo2_225",
  content: Ag,
  hidden: $g,
  "hero-gradient-overlay": "_hero-gradient-overlay_1roo2_245",
  "gradient-level-80": "_gradient-level-80_1roo2_258",
  "gradient-level-60": "_gradient-level-60_1roo2_263",
  "gradient-level-40": "_gradient-level-40_1roo2_268",
  "gradient-level-20": "_gradient-level-20_1roo2_273",
  "gradient-level-0": "_gradient-level-0_1roo2_278",
  "content-wrapper": "_content-wrapper_1roo2_283",
  "content-container": "_content-container_1roo2_298",
  "with-controls": "_with-controls_1roo2_312",
  "text-content": "_text-content_1roo2_317",
  "left-align": "_left-align_1roo2_325",
  heading: Ig,
  "rich-text": "_rich-text_1roo2_335",
  "cta-wrapper": "_cta-wrapper_1roo2_341"
}, Og = De("", {
  variants: {
    backgroundGradientLevel: me({
      0: Ie["gradient-level-0"],
      20: Ie["gradient-level-20"],
      40: Ie["gradient-level-40"],
      60: Ie["gradient-level-60"],
      80: Ie["gradient-level-80"]
    })
  }
}), Rg = (e) => {
  const {
    backgroundGradientLevel: t,
    backgroundImage: n,
    className: r,
    firstCTALink: a,
    hasCarouselControls: i,
    headline: s,
    mobileBackgroundImage: o,
    secondCTALink: c,
    supportingCopy: d,
    ...u
  } = e;
  return /* @__PURE__ */ l.jsxs(
    xe,
    {
      variant: "containedLarge",
      className: z(Ie["hero-banner-desktop"], r),
      "data-testid": "hero-banner-desktop",
      ...u,
      children: [
        /* @__PURE__ */ l.jsx(
          yn,
          {
            ratio: "golden-ratio-landscape",
            className: z(Ie["bg-img"]),
            children: /* @__PURE__ */ l.jsx(
              ac,
              {
                image: n,
                mobileSrc: o,
                tabletLgSrc: n.src,
                tabletSrc: o,
                "data-testid": "hero-banner-image-desktop"
              }
            )
          }
        ),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: z(
              Ie["hero-gradient-overlay"],
              Og({ backgroundGradientLevel: t })
            )
          }
        ),
        /* @__PURE__ */ l.jsx("div", { className: z(Ie["content-wrapper"], r), children: /* @__PURE__ */ l.jsx(xe, { className: Ie["content-container"], children: /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: z(Ie.content, {
              [Ie["with-controls"]]: i
            }),
            children: [
              /* @__PURE__ */ l.jsxs("div", { className: z(Ie["text-content"]), children: [
                /* @__PURE__ */ l.jsx(
                  G,
                  {
                    fontStyle: "lgHeading",
                    fontStyleTablet: "xlHeading",
                    "data-testid": "hero-banner-heading-desktop",
                    className: Ie.heading,
                    tag: "h1",
                    children: s
                  }
                ),
                /* @__PURE__ */ l.jsx(
                  le,
                  {
                    "data-testid": "hero-banner-supporting-copy-desktop",
                    className: Ie["rich-text"],
                    children: d
                  }
                )
              ] }),
              (a || c) && /* @__PURE__ */ l.jsxs("div", { className: Ie["cta-wrapper"], children: [
                a && /* @__PURE__ */ l.jsx(
                  X,
                  {
                    variant: "solid1",
                    size: "large",
                    "data-testid": "hero-banner-first-link-desktop",
                    children: a
                  }
                ),
                c && /* @__PURE__ */ l.jsx(
                  X,
                  {
                    variant: "light-inverse",
                    size: "large",
                    "data-testid": "hero-banner-second-link-desktop",
                    children: c
                  }
                )
              ] })
            ]
          }
        ) }) })
      ]
    }
  );
}, Dg = (e) => {
  const {
    backgroundImage: t,
    className: n,
    firstCTALink: r,
    hasCarouselControls: a,
    headline: i,
    mobileBackgroundImage: s,
    secondCTALink: o,
    shouldHideImgOnMobile: c,
    shouldLeftAlignOnMobile: d = !1,
    supportingCopy: u,
    ...f
  } = e;
  return /* @__PURE__ */ l.jsxs(
    xe,
    {
      className: z(Ie["hero-banner-mobile"], n),
      "data-testid": "hero-banner-mobile",
      ...f,
      children: [
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: z(
              Ie["bg-img"],
              c ? Ie.hidden : ""
            ),
            children: /* @__PURE__ */ l.jsx(yn, { ratio: "golden-ratio-landscape", children: /* @__PURE__ */ l.jsx(
              ac,
              {
                image: t,
                mobileSrc: s,
                tabletLgSrc: t.src,
                tabletSrc: s,
                "data-testid": "hero-banner-image-mobile"
              }
            ) })
          }
        ),
        /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: z(Ie.content, {
              [Ie["with-controls"]]: a
            }),
            children: [
              /* @__PURE__ */ l.jsxs(
                "div",
                {
                  className: z(
                    Ie["text-content"],
                    d ? Ie["left-align"] : ""
                  ),
                  children: [
                    /* @__PURE__ */ l.jsx(
                      G,
                      {
                        fontStyle: "lgHeadingMobile",
                        className: Ie.heading,
                        "data-testid": "hero-banner-heading-mobile",
                        tag: "h1",
                        children: i
                      }
                    ),
                    /* @__PURE__ */ l.jsx(
                      le,
                      {
                        className: Ie["rich-text"],
                        "data-testid": "hero-banner-supporting-copy-mobile",
                        children: u
                      }
                    )
                  ]
                }
              ),
              (r || o) && /* @__PURE__ */ l.jsxs("div", { className: Ie["cta-wrapper"], children: [
                r && /* @__PURE__ */ l.jsx(
                  X,
                  {
                    variant: "light1",
                    size: "medium",
                    "data-testid": "hero-banner-first-link-mobile",
                    children: r
                  }
                ),
                o && /* @__PURE__ */ l.jsx(
                  X,
                  {
                    variant: "light1",
                    size: "medium",
                    "data-testid": "hero-banner-second-link-mobile",
                    children: o
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, yT = (e) => {
  const {
    shouldHideImgOnMobile: t,
    shouldLeftAlignOnMobile: n,
    backgroundGradientLevel: r,
    ...a
  } = e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      Rg,
      {
        backgroundGradientLevel: r,
        ...a
      }
    ),
    /* @__PURE__ */ l.jsx(
      Dg,
      {
        shouldHideImgOnMobile: t,
        shouldLeftAlignOnMobile: n,
        ...a
      }
    )
  ] });
}, _l = {
  "hero-banner-carousel": "_hero-banner-carousel_1vhum_209",
  "carousel-controls": "_carousel-controls_1vhum_209"
}, xT = (e) => {
  const {
    className: t,
    slides: n = [],
    slideTimingSeconds: r = 6,
    shouldLeftAlignOnMobile: a,
    ...i
  } = e, s = n.map((o) => {
    const c = {
      ...o.props,
      shouldLeftAlignOnMobile: a,
      hasCarouselControls: !0
    };
    return Te(o, c);
  });
  return /* @__PURE__ */ l.jsx(
    c1,
    {
      "data-testid": "hero-banner-carousel",
      className: z(_l["hero-banner-carousel"], t),
      controlsClass: _l["carousel-controls"],
      slides: s,
      slideTimingSeconds: r,
      ...i
    }
  );
}, kr = {
  "support-copy-large": "_support-copy-large_17dfn_209",
  "text-center": "_text-center_17dfn_218",
  "text-left": "_text-left_17dfn_221",
  "text-right": "_text-right_17dfn_224"
}, Fg = De(kr["table-base"], {
  variants: {
    cellAlignment: me({
      left: kr["text-left"],
      center: kr["text-center"],
      right: kr["text-right"]
    })
  }
}), _T = (e) => {
  const {
    headline: t,
    supportCopy: n,
    headlineTag: r = "p",
    contentAlignment: a = "left",
    tableStyle: i = "standard",
    cellAlignment: s = "center",
    shouldPinFirstColumn: o = !1,
    className: c,
    children: d,
    ...u
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      className: c,
      contentAlignment: a,
      headline: t,
      headlineTag: r,
      spacing: "72-24",
      supportCopy: /* @__PURE__ */ l.jsx(
        lt,
        {
          className: z({
            [kr["support-copy-large"]]: i === "standard"
          }),
          children: n
        }
      ),
      ...u,
      children: /* @__PURE__ */ l.jsx(
        pd,
        {
          isSticky: o,
          isStriped: !0,
          tableStyle: i,
          className: z(
            Fg({ cellAlignment: s }),
            kr.table
          ),
          children: d
        }
      )
    }
  );
}, Bg = "_animal_g17t2_215", Vg = "_bubble_g17t2_241", $1 = {
  "children-animal-motif-base": "_children-animal-motif-base_g17t2_209",
  animal: Bg,
  bubble: Vg
}, wT = (e) => {
  const {
    className: t,
    animals: n,
    randomAnimalIndex: r = 0,
    staticMobileImage: a,
    ...i
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: t,
      ...i,
      children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: $1["children-animal-motif-base"],
          "data-testid": "children-animal-motif",
          children: [
            a,
            n.map((s, o) => {
              const { quote: c, image: d } = s;
              return /* @__PURE__ */ l.jsxs(
                "div",
                {
                  className: $1.animal,
                  "data-testid": "childrens-animal-motif-animal",
                  children: [
                    d,
                    r === o && /* @__PURE__ */ l.jsxs(
                      "div",
                      {
                        className: $1.bubble,
                        "data-testid": "childrens-animal-motif-bubbles",
                        children: [
                          /* @__PURE__ */ l.jsx(Rv, {}),
                          c
                        ]
                      }
                    )
                  ]
                },
                o
              );
            })
          ]
        }
      )
    }
  );
}, Hg = "_breadcrumbs_1e0q1_209", cr = {
  breadcrumbs: Hg,
  "show-on-mobile": "_show-on-mobile_1e0q1_212",
  "breadcrumb-list": "_breadcrumb-list_1e0q1_220",
  "breadcrumb-item": "_breadcrumb-item_1e0q1_229",
  "breadcrumb-link": "_breadcrumb-link_1e0q1_234",
  "breadcrumb-page": "_breadcrumb-page_1e0q1_248",
  "breadcrumb-separator": "_breadcrumb-separator_1e0q1_257"
}, X3 = K(
  (e, t) => {
    const { ...n } = e;
    return /* @__PURE__ */ l.jsx(
      "nav",
      {
        "data-testid": "breadcrumbs",
        ref: t,
        "aria-label": "breadcrumb",
        ...n
      }
    );
  }
);
X3.displayName = "Breadcrumb";
const Z3 = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    "ol",
    {
      ref: t,
      "data-testid": "breadcrumb-list",
      className: z(cr["breadcrumb-list"], n),
      ...r
    }
  );
});
Z3.displayName = "BreadcrumbList";
const js = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    "li",
    {
      ref: t,
      "data-testid": "breadcrumb-item",
      className: z(cr["breadcrumb-item"], n),
      ...r
    }
  );
});
js.displayName = "BreadcrumbItem";
const Q3 = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    X,
    {
      fontStyle: null,
      ref: t,
      underline: "hover",
      className: z(cr["breadcrumb-link"], n),
      "data-testid": "breadcrumb-link",
      ...r
    }
  );
});
Q3.displayName = "BreadcrumbLink";
const J3 = K(
  (e, t) => {
    const { className: n, ...r } = e;
    return /* @__PURE__ */ l.jsx(
      G,
      {
        customRef: t,
        role: "link",
        "data-testid": "breadcrumb-page",
        "aria-disabled": "true",
        "aria-current": "page",
        className: z(cr["breadcrumb-page"], n),
        ...r
      }
    );
  }
);
J3.displayName = "BreadcrumbPage";
const e6 = (e) => {
  const { children: t, className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    "span",
    {
      role: "presentation",
      "data-testid": "breadcrumb-separator",
      "aria-hidden": "true",
      className: z(cr["breadcrumb-separator"], n),
      ...r,
      children: t ?? /* @__PURE__ */ l.jsx(re, { icon: "chevronRight" })
    }
  );
};
e6.displayName = "BreadcrumbSeparator";
const qg = (e) => {
  const {
    className: t,
    showOnMobile: n = !1,
    links: r,
    currentPage: a,
    ...i
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      verticalSpacing: !0,
      className: z(
        cr.breadcrumbs,
        n && cr["show-on-mobile"],
        t
      ),
      "data-testid": "breadcrumbs-container",
      ...i,
      children: /* @__PURE__ */ l.jsx(X3, { "data-testid": "breadcrumbs", children: /* @__PURE__ */ l.jsxs(Z3, { children: [
        r.map((s, o) => /* @__PURE__ */ l.jsxs(js, { children: [
          /* @__PURE__ */ l.jsx(Q3, { children: s }),
          /* @__PURE__ */ l.jsx(e6, {})
        ] }, o)),
        /* @__PURE__ */ l.jsx(js, { children: /* @__PURE__ */ l.jsx(J3, { children: a }) })
      ] }) })
    }
  );
};
qg.displayName = "Breadcrumbs";
const Wg = "_image_42eyu_209", Ug = "_desktop_42eyu_220", Gg = "_mobile_42eyu_223", St = {
  "image-asset": "_image-asset_42eyu_209",
  "image-wrapper": "_image-wrapper_42eyu_209",
  image: Wg,
  desktop: Ug,
  mobile: Gg,
  "image-asset-right": "_image-asset-right_42eyu_226",
  "image-asset-left": "_image-asset-left_42eyu_229",
  "image-border": "_image-border_42eyu_232",
  "image-caption": "_image-caption_42eyu_235",
  "image-figure": "_image-figure_42eyu_242"
}, wl = (e) => {
  const { mobileImage: t, image: n, shouldLazyLoad: r } = e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    Te(n, {
      className: z(St.image, {
        [St.desktop]: t
      }),
      loading: r ? "lazy" : void 0
    }),
    t && Te(t, {
      className: z(St.image, {
        [St.mobile]: t
      }),
      loading: r ? "lazy" : void 0
    })
  ] });
}, CT = (e) => {
  const {
    image: t,
    caption: n,
    imageCTA: r,
    imageAlignment: a = "right",
    isImageBorderOn: i = !1,
    className: s,
    mobileImage: o,
    shouldLazyLoad: c = !1,
    ...d
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      "data-testid": "image-asset-container",
      className: s,
      ...d,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          "data-testid": "image-asset",
          className: z(St["image-asset"], {
            [St["image-asset-left"]]: a === "left",
            [St["image-asset-right"]]: a === "right",
            [St["image-border"]]: i
          }),
          children: /* @__PURE__ */ l.jsxs("figure", { className: St["image-figure"], children: [
            r ? /* @__PURE__ */ l.jsx(
              X,
              {
                className: St["image-wrapper"],
                "data-testid": "image-asset-image-wrapper",
                children: Te(r, {
                  children: /* @__PURE__ */ l.jsx(
                    wl,
                    {
                      image: t,
                      mobileImage: o,
                      shouldLazyLoad: c
                    }
                  )
                })
              }
            ) : /* @__PURE__ */ l.jsx(
              "div",
              {
                className: St["image-wrapper"],
                "data-testid": "image-asset-image-wrapper",
                children: /* @__PURE__ */ l.jsx(
                  wl,
                  {
                    image: t,
                    mobileImage: o,
                    shouldLazyLoad: c
                  }
                )
              }
            ),
            n && /* @__PURE__ */ l.jsx(
              le,
              {
                as: "figcaption",
                className: St["image-caption"],
                "data-testid": "image-asset-caption",
                children: n
              }
            )
          ] })
        }
      )
    }
  );
}, Cl = {
  "video-asset-base": "_video-asset-base_1izd8_209",
  "video-asset-caption": "_video-asset-caption_1izd8_209"
}, ST = (e) => {
  const { className: t, videoId: n, caption: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: z(Cl["video-asset-base"], t),
      "data-testid": "video-asset",
      ...a,
      children: /* @__PURE__ */ l.jsxs("figure", { children: [
        /* @__PURE__ */ l.jsx(o1, { videoId: n }),
        r && /* @__PURE__ */ l.jsx(
          le,
          {
            as: "figcaption",
            "data-testid": "video-asset-caption",
            className: Cl["video-asset-caption"],
            children: r
          }
        )
      ] })
    }
  );
}, I1 = {
  "column-grid-left": "_column-grid-left_1ez2s_209",
  "column-grid-center": "_column-grid-center_1ez2s_213"
}, LT = (e) => {
  const {
    className: t,
    headline: n,
    supportingCopy: r,
    headlineAlignment: a = "left",
    supportCopyAlignment: i = "left",
    ctaAlignment: s = "left",
    headlineTag: o,
    backgroundColor: c = "white",
    numColumns: d = "2",
    columnAlignment: u = "left",
    links: f,
    ctaStyle: p = "button",
    bottomCta: h,
    ...g
  } = e, v = {
    button: "solid",
    link: "link"
  };
  return /* @__PURE__ */ l.jsx(
    He,
    {
      backgroundColor: c,
      className: t,
      cta: h,
      ctaAlignment: s,
      ctaStyle: v[p],
      "data-testid": "link-list",
      headline: n,
      headlineTag: o,
      headlineAlignment: a,
      supportCopy: r,
      supportCopyAlignment: i,
      variant: "containedSmall",
      ...g,
      spacing: "64-40",
      children: /* @__PURE__ */ l.jsx(
        rt,
        {
          columns: "1",
          rowGap: "even",
          className: z(I1["column-grid"], {
            [I1["column-grid-left"]]: u === "left",
            [I1["column-grid-center"]]: u === "center"
          }),
          columnsTablet: d === "1" ? "1" : "2",
          columnsDesktop: d,
          "data-testid": "link-list-column-grid",
          children: f
        }
      )
    }
  );
}, Yg = "_hundred_1t0cv_229", Kg = "_headline_1t0cv_235", Xg = "_thirty_1t0cv_263", Zg = "_forty_1t0cv_266", Qg = "_fifty_1t0cv_269", ut = {
  "promo-callout": "_promo-callout_1t0cv_209",
  "with-controls": "_with-controls_1t0cv_215",
  "content-center": "_content-center_1t0cv_218",
  "anchor-wrapper": "_anchor-wrapper_1t0cv_223",
  "image-wrapper": "_image-wrapper_1t0cv_226",
  hundred: Yg,
  "text-wrapper": "_text-wrapper_1t0cv_232",
  headline: Kg,
  "supporting-copy": "_supporting-copy_1t0cv_238",
  "content-left-desktop": "_content-left-desktop_1t0cv_255",
  thirty: Xg,
  forty: Zg,
  fifty: Qg,
  "image-side-right": "_image-side-right_1t0cv_272"
}, MT = [
  "wellnessBlue",
  "denimBlue",
  "whiteSmoke",
  "achOrange",
  "cchaPurple",
  "burntOrange",
  "blue",
  "teal",
  "darkTeal"
], NT = (e) => {
  const {
    backgroundColor: t = "wellnessBlue",
    className: n,
    firstCTALink: r,
    hasCarouselControls: a,
    headline: i,
    headlineTag: s = "p",
    image: o,
    imageSide: c = "left",
    layout: d = "thirty",
    secondCTALink: u,
    secondCTAStyle: f = "solid",
    supportingCopy: p,
    textAlignment: h = "left",
    shouldLazyLoad: g = !1,
    ...v
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: n,
      backgroundColor: t,
      variant: "containedSmall",
      "data-testid": "promo-callout",
      ...v,
      children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: z(ut["promo-callout"], {
            [ut["with-controls"]]: a,
            [ut["content-center"]]: h === "center",
            // Force alignment left on desktop when image is visible.
            [ut["content-left-desktop"]]: h === "center" && o && d !== "hundred"
          }),
          children: [
            o && /* @__PURE__ */ l.jsx(
              "div",
              {
                "data-testid": "promo-callout-image-wrapper",
                className: z(ut["image-wrapper"], {
                  [ut.thirty]: d === "thirty",
                  [ut.forty]: d === "forty",
                  [ut.fifty]: d === "fifty",
                  [ut.hundred]: d === "hundred",
                  [ut["image-side-right"]]: c === "right"
                }),
                children: /* @__PURE__ */ l.jsx(
                  yn,
                  {
                    ratio: "8:5",
                    "data-testid": "promo-callout-image",
                    shouldLazyLoad: g,
                    children: o
                  }
                )
              }
            ),
            /* @__PURE__ */ l.jsxs("div", { className: ut["text-wrapper"], children: [
              /* @__PURE__ */ l.jsx(
                G,
                {
                  tag: s,
                  "data-testid": "promo-callout-headline",
                  className: ut.headline,
                  children: i
                }
              ),
              p && /* @__PURE__ */ l.jsx(
                le,
                {
                  className: ut["supporting-copy"],
                  "data-testid": "promo-callout-support-copy",
                  children: p
                }
              ),
              (r || u) && /* @__PURE__ */ l.jsxs("div", { className: ut["anchor-wrapper"], children: [
                r && /* @__PURE__ */ l.jsx(
                  X,
                  {
                    buttonStyle: "solid",
                    size: "responsive",
                    "data-testid": "promo-callout-first-cta",
                    children: r
                  }
                ),
                u && /* @__PURE__ */ l.jsx(
                  X,
                  {
                    buttonStyle: f,
                    size: "responsive",
                    "data-testid": "promo-callout-second-cta",
                    children: u
                  }
                )
              ] })
            ] })
          ]
        }
      )
    }
  );
}, zT = (e) => {
  const {
    backgroundColor: t = "wellnessBlue",
    imageSide: n = "left",
    secondCTAStyle: r = "solid",
    slides: a = [],
    slideTimingSeconds: i = 6,
    textAlignment: s = "left",
    ...o
  } = e, c = a.map((d) => {
    const u = {
      ...d.props,
      backgroundColor: t,
      hasCarouselControls: !0,
      imageSide: n,
      secondCTAStyle: r,
      textAlignment: s
    };
    return Te(d, u);
  });
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      backgroundColor: t,
      ...o,
      children: /* @__PURE__ */ l.jsx(
        c1,
        {
          "data-testid": "promo-carousel",
          slides: c,
          slideTimingSeconds: i
        }
      )
    }
  );
}, Zt = {
  "text-accordion-base": "_text-accordion-base_quyy6_209",
  "text-accordion-content": "_text-accordion-content_quyy6_213",
  "text-accordion-content-open": "_text-accordion-content-open_quyy6_224",
  "text-accordion-content-center": "_text-accordion-content-center_quyy6_228",
  "hidden-text": "_hidden-text_quyy6_232",
  "hidden-text-expanded": "_hidden-text-expanded_quyy6_236",
  "always-visible-text": "_always-visible-text_quyy6_240",
  "always-visible-text-expanded": "_always-visible-text-expanded_quyy6_255",
  "button-wrapper": "_button-wrapper_quyy6_259"
}, Jg = () => {
  if (typeof window > "u")
    return {
      asString: "9.5rem",
      asRem: 9.5,
      asPx: 152,
      asRemWithUtilityNav: 12.5,
      asPxWithUtilityNav: 200
    };
  const e = getComputedStyle(document.body).getPropertyValue(
    "--header-height"
  );
  return {
    asString: e,
    asRem: parseFloat(e),
    asPx: parseFloat(e) * 16,
    asRemWithUtilityNav: parseFloat(e) + 3,
    asPxWithUtilityNav: parseFloat(e) * 16 + 48
  };
}, ET = (e) => {
  const {
    alwaysVisibleText: t,
    bodyCopyAlignment: n = "left",
    className: r,
    headline: a,
    headlineAlignment: i = "left",
    headlineTag: s = "p",
    hiddenText: o,
    showLessText: c = "View less",
    showMoreText: d = "View more",
    ...u
  } = e, [f, p] = ne(!1), h = pe(null), g = () => {
    p(!f), f && h.current && typeof window < "u" && setTimeout(() => {
      h.current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
      const v = Jg().asPxWithUtilityNav, x = h.current.getBoundingClientRect().top - v;
      window.scrollBy({ top: x, behavior: "smooth" });
    }, 150);
  };
  return /* @__PURE__ */ l.jsx(
    He,
    {
      className: r,
      headline: a,
      headlineAlignment: i,
      headlineTag: s,
      spacing: "40-24",
      ...u,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          ref: h,
          className: Zt["text-accordion-base"],
          "data-testid": "text-accordion",
          children: /* @__PURE__ */ l.jsxs(
            "div",
            {
              className: z(Zt["text-accordion-content"], {
                [Zt["text-accordion-content-open"]]: f,
                [Zt["text-accordion-content-center"]]: n === "center"
              }),
              children: [
                /* @__PURE__ */ l.jsx(
                  le,
                  {
                    className: z({
                      [Zt["always-visible-text"]]: !f,
                      [Zt["always-visible-text-expanded"]]: f
                    }),
                    children: t
                  }
                ),
                /* @__PURE__ */ l.jsx(
                  le,
                  {
                    className: z({
                      [Zt["hidden-text"]]: !f,
                      [Zt["hidden-text-expanded"]]: f
                    }),
                    children: o
                  }
                ),
                /* @__PURE__ */ l.jsx("div", { className: Zt["button-wrapper"], children: /* @__PURE__ */ l.jsx(X, { children: /* @__PURE__ */ l.jsx(
                  "button",
                  {
                    type: "button",
                    onClick: g,
                    children: f ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                      c,
                      " ",
                      /* @__PURE__ */ l.jsx(re, { icon: "minus" })
                    ] }) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                      d,
                      " ",
                      /* @__PURE__ */ l.jsx(re, { icon: "plus" })
                    ] })
                  }
                ) }) })
              ]
            }
          )
        }
      )
    }
  );
}, TT = (e) => {
  const { className: t, children: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      className: t,
      spacing: "40-24",
      "data-testid": "rich-text-rendering",
      ...r,
      children: /* @__PURE__ */ l.jsx(le, { children: n })
    }
  );
}, ev = "_heading_11fx2_209", Mr = {
  heading: ev,
  "sub-heading": "_sub-heading_11fx2_222",
  "cta-wrapper": "_cta-wrapper_11fx2_226",
  "cta-button": "_cta-button_11fx2_235",
  "cta-wrapper-single": "_cta-wrapper-single_11fx2_250",
  "cta-wrapper-multi": "_cta-wrapper-multi_11fx2_253"
}, kT = (e) => {
  const {
    backgroundColor: t = "white",
    className: n,
    firstCTA: r,
    fourthCTA: a,
    headline: i,
    icon: s,
    secondCTA: o,
    subHeading: c,
    thirdCTA: d,
    ...u
  } = e, f = [r, o, d, a].filter(Boolean);
  return /* @__PURE__ */ l.jsxs(
    He,
    {
      backgroundColor: t,
      className: n,
      variant: "containedSmall",
      "data-testid": "multi-button",
      ...u,
      children: [
        /* @__PURE__ */ l.jsxs(
          G,
          {
            tag: "h2",
            fontStyle: "lgHeading",
            className: Mr.heading,
            "data-testid": "multi-button-heading",
            children: [
              s && /* @__PURE__ */ l.jsx(re, { icon: s }),
              i
            ]
          }
        ),
        c && /* @__PURE__ */ l.jsx(
          G,
          {
            tag: "p",
            fontStyle: "smParagraph",
            className: Mr["sub-heading"],
            "data-testid": "multi-button-subHeading",
            children: c
          }
        ),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: z(
              Mr["cta-wrapper"],
              f.length === 1 ? Mr["cta-wrapper-single"] : Mr["cta-wrapper-multi"]
            ),
            children: f.map((p, h) => /* @__PURE__ */ l.jsx(
              X,
              {
                className: Mr["cta-button"],
                buttonStyle: "solid",
                size: "responsive",
                "data-testid": `multi-button-${h + 1}`,
                children: p
              },
              h
            ))
          }
        )
      ]
    }
  );
}, tv = "_content_gdtl3_245", nv = "_headline_gdtl3_272", tt = {
  "hero-featured-banner": "_hero-featured-banner_gdtl3_209",
  "bg-img": "_bg-img_gdtl3_216",
  "hero-gradient-overlay": "_hero-gradient-overlay_gdtl3_219",
  "gradient-level-80": "_gradient-level-80_gdtl3_230",
  "gradient-level-60": "_gradient-level-60_gdtl3_233",
  "gradient-level-40": "_gradient-level-40_gdtl3_236",
  "gradient-level-20": "_gradient-level-20_gdtl3_239",
  "gradient-level-0": "_gradient-level-0_gdtl3_242",
  "content-wrapper": "_content-wrapper_gdtl3_245",
  content: tv,
  "text-content": "_text-content_gdtl3_267",
  headline: nv,
  "tagline-bottom": "_tagline-bottom_gdtl3_285",
  "tagline-top": "_tagline-top_gdtl3_286",
  "cta-wrapper": "_cta-wrapper_gdtl3_293"
}, rv = De("", {
  variants: {
    backgroundGradientLevel: me({
      0: tt["gradient-level-0"],
      20: tt["gradient-level-20"],
      40: tt["gradient-level-40"],
      60: tt["gradient-level-60"],
      80: tt["gradient-level-80"]
    })
  }
}), jT = [
  "arrowRightLong",
  "arrowUpRightFromSquare",
  "youtube",
  "play",
  "download"
], PT = (e) => {
  var x, m, b, _, C, w;
  const {
    backgroundGradientLevel: t,
    backgroundImage: n,
    className: r,
    firstCTAIcon: a,
    firstCTALink: i,
    firstCTAStyle: s = "default",
    headline: o,
    mobileBackgroundImage: c,
    secondCTAIcon: d,
    secondCTALink: u,
    secondCTAStyle: f = "default",
    taglineBottom: p,
    taglineTop: h,
    bannerRatio: g = "golden-ratio-landscape",
    ...v
  } = e;
  return /* @__PURE__ */ l.jsxs(
    xe,
    {
      variant: "containedLarge",
      className: z(tt["hero-featured-banner"], r),
      "data-testid": "hero-featured-banner",
      ...v,
      children: [
        /* @__PURE__ */ l.jsx(
          yn,
          {
            ratio: g,
            className: tt["bg-img"],
            children: /* @__PURE__ */ l.jsx(
              ac,
              {
                "data-testid": "hero-featured-banner-image",
                image: n,
                mobileSrc: c,
                tabletLgSrc: n.src,
                tabletSrc: c
              }
            )
          }
        ),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: z(
              tt["hero-gradient-overlay"],
              rv({ backgroundGradientLevel: t })
            )
          }
        ),
        /* @__PURE__ */ l.jsx(xe, { className: tt["content-wrapper"], children: /* @__PURE__ */ l.jsxs("div", { className: tt.content, children: [
          /* @__PURE__ */ l.jsxs("div", { className: tt["text-content"], children: [
            h && /* @__PURE__ */ l.jsx(
              G,
              {
                "data-testid": "hero-featured-banner-tagline-top",
                className: tt["tagline-top"],
                tag: "p",
                children: h
              }
            ),
            /* @__PURE__ */ l.jsx(
              le,
              {
                "data-testid": "hero-featured-banner-headline",
                className: tt.headline,
                as: "h1",
                children: o
              }
            ),
            p && /* @__PURE__ */ l.jsx(
              G,
              {
                "data-testid": "hero-featured-banner-tagline-bottom",
                className: tt["tagline-bottom"],
                tag: "p",
                children: p
              }
            )
          ] }),
          (i || u) && /* @__PURE__ */ l.jsxs("div", { className: tt["cta-wrapper"], children: [
            i && /* @__PURE__ */ l.jsx(
              X,
              {
                variant: s === "default" ? "solid1" : "light1",
                size: "large",
                "data-testid": "hero-featured-banner-first-link",
                children: Te(i, {
                  children: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                    (b = (m = (x = i == null ? void 0 : i.props) == null ? void 0 : x.field) == null ? void 0 : m.value) == null ? void 0 : b.text,
                    a && /* @__PURE__ */ l.jsx(
                      re,
                      {
                        className: tt["hero-link-icon"],
                        "data-testid": "hero-featured-banner-first-link-icon",
                        icon: a
                      }
                    )
                  ] })
                })
              }
            ),
            u && /* @__PURE__ */ l.jsx(
              X,
              {
                variant: f === "default" ? "solid1" : "light1",
                size: "large",
                "data-testid": "hero-featured-banner-second-link",
                children: Te(u, {
                  children: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                    (w = (C = (_ = u == null ? void 0 : u.props) == null ? void 0 : _.field) == null ? void 0 : C.value) == null ? void 0 : w.text,
                    d && /* @__PURE__ */ l.jsx(
                      re,
                      {
                        className: tt["hero-link-icon"],
                        "data-testid": "hero-featured-banner-second-link-icon",
                        icon: d
                      }
                    )
                  ] })
                })
              }
            )
          ] })
        ] }) })
      ]
    }
  );
}, av = {
  "headline-with-optional-cta-base": "_headline-with-optional-cta-base_myqat_209"
}, AT = (e) => {
  const { className: t, headline: n, cta: r, headlineTag: a = "h1", ...i } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: t,
      ...i,
      children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: av["headline-with-optional-cta-base"],
          "data-testid": "headline-with-optional-cta",
          children: [
            /* @__PURE__ */ l.jsx(G, { tag: a, children: n }),
            r
          ]
        }
      )
    }
  );
}, iv = "_headline_j3c23_281", sv = "_name_j3c23_294", Qt = {
  "bio-card-directory": "_bio-card-directory_j3c23_209",
  "bio-card": "_bio-card_j3c23_209",
  headline: iv,
  "bio-card-image": "_bio-card-image_j3c23_287",
  "bio-card-details": "_bio-card-details_j3c23_294",
  name: sv,
  "text-value": "_text-value_j3c23_322"
}, $T = (e) => {
  const {
    additionalInformationLabel: t,
    headline: n,
    headlineTag: r = "p",
    bios: a,
    className: i,
    emailLabel: s,
    faxLabel: o,
    locationsLabel: c,
    phoneLabel: d,
    specialtyLabel: u,
    titleLabel: f,
    shouldLazyLoad: p = !1,
    ...h
  } = e;
  return /* @__PURE__ */ l.jsxs(
    He,
    {
      className: i,
      ...h,
      children: [
        n && /* @__PURE__ */ l.jsx(
          G,
          {
            "data-testid": "headline",
            className: Qt.headline,
            tag: r,
            children: n
          }
        ),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: Qt["bio-card-directory"],
            "data-testid": "bio-card-directory",
            children: a.map((g, v) => {
              const {
                additional: x,
                email: m,
                fax: b,
                image: _,
                locations: C,
                name: w,
                displayName: N,
                phone: M,
                specialty: S,
                title: T,
                optionalLink: j
              } = g, D = N || w;
              return /* @__PURE__ */ l.jsxs(
                "div",
                {
                  className: Qt["bio-card"],
                  "data-testid": "bio-card",
                  children: [
                    _ && /* @__PURE__ */ l.jsx(
                      "div",
                      {
                        className: Qt["bio-card-image"],
                        "data-testid": "bio-card-image",
                        children: /* @__PURE__ */ l.jsx(
                          yn,
                          {
                            ratio: "A4-portrait",
                            shouldLazyLoad: p,
                            children: _
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ l.jsxs("div", { className: Qt["bio-card-details"], children: [
                      D && (j ? /* @__PURE__ */ l.jsx(
                        X,
                        {
                          fontStyle: "smLink",
                          className: Qt.name,
                          fontStyleCorp: "smLink",
                          children: Te(
                            j,
                            {
                              children: /* @__PURE__ */ l.jsx(
                                G,
                                {
                                  asChild: !0,
                                  fontStyle: "mdHeading",
                                  children: D
                                }
                              )
                            }
                          )
                        }
                      ) : /* @__PURE__ */ l.jsx(
                        G,
                        {
                          className: Qt.name,
                          fontStyle: "smParagraph",
                          fontStyleCorp: "smParagraph",
                          tag: "p",
                          children: D
                        }
                      )),
                      /* @__PURE__ */ l.jsxs("dl", { children: [
                        S && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                          /* @__PURE__ */ l.jsxs(
                            G,
                            {
                              fontStyle: "smParagraph",
                              fontStyleCorp: "smParagraph",
                              tag: "dt",
                              children: [
                                u,
                                ":",
                                " "
                              ]
                            }
                          ),
                          /* @__PURE__ */ l.jsx(
                            G,
                            {
                              fontStyle: "smParagraph",
                              fontStyleCorp: "smParagraph",
                              tag: "dd",
                              className: Qt["text-value"],
                              children: S
                            }
                          )
                        ] }),
                        T && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                          /* @__PURE__ */ l.jsxs(
                            G,
                            {
                              fontStyle: "smParagraph",
                              fontStyleCorp: "smParagraph",
                              tag: "dt",
                              children: [
                                f,
                                ":",
                                " "
                              ]
                            }
                          ),
                          /* @__PURE__ */ l.jsx(
                            G,
                            {
                              fontStyle: "smParagraph",
                              fontStyleCorp: "smParagraph",
                              tag: "dd",
                              className: Qt["text-value"],
                              children: T
                            }
                          )
                        ] }),
                        M && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                          /* @__PURE__ */ l.jsxs(
                            G,
                            {
                              fontStyle: "smParagraph",
                              fontStyleCorp: "smParagraph",
                              tag: "dt",
                              children: [
                                d,
                                ":",
                                " "
                              ]
                            }
                          ),
                          /* @__PURE__ */ l.jsx("dd", { children: /* @__PURE__ */ l.jsx(
                            G,
                            {
                              fontStyle: "smLink",
                              fontStyleCorp: "smLink",
                              asChild: !0,
                              children: /* @__PURE__ */ l.jsx(
                                "a",
                                {
                                  href: `tel:${M.props.field.value}`,
                                  children: M
                                }
                              )
                            }
                          ) })
                        ] }),
                        b && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                          /* @__PURE__ */ l.jsxs(
                            G,
                            {
                              fontStyle: "smParagraph",
                              fontStyleCorp: "smParagraph",
                              tag: "dt",
                              children: [
                                o,
                                ":",
                                " "
                              ]
                            }
                          ),
                          /* @__PURE__ */ l.jsx("dd", { children: /* @__PURE__ */ l.jsx(
                            G,
                            {
                              fontStyle: "smLink",
                              fontStyleCorp: "smLink",
                              asChild: !0,
                              children: /* @__PURE__ */ l.jsx(
                                "a",
                                {
                                  href: `fax:${b.props.field.value}`,
                                  children: b
                                }
                              )
                            }
                          ) })
                        ] }),
                        m && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                          /* @__PURE__ */ l.jsxs(
                            G,
                            {
                              fontStyle: "smParagraph",
                              fontStyleCorp: "smParagraph",
                              tag: "dt",
                              children: [
                                s,
                                ":",
                                " "
                              ]
                            }
                          ),
                          /* @__PURE__ */ l.jsx("dd", { children: /* @__PURE__ */ l.jsx(
                            G,
                            {
                              fontStyle: "smLink",
                              fontStyleCorp: "smLink",
                              asChild: !0,
                              children: /* @__PURE__ */ l.jsx(
                                "a",
                                {
                                  href: `mailto:${m.props.field.value}`,
                                  children: m
                                }
                              )
                            }
                          ) })
                        ] }),
                        C && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                          /* @__PURE__ */ l.jsxs(
                            G,
                            {
                              fontStyle: "smParagraph",
                              fontStyleCorp: "smParagraph",
                              tag: "dt",
                              children: [
                                c,
                                ":",
                                " "
                              ]
                            }
                          ),
                          /* @__PURE__ */ l.jsx(le, { as: "dd", children: C })
                        ] }),
                        x && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                          /* @__PURE__ */ l.jsxs(
                            G,
                            {
                              fontStyle: "smParagraph",
                              fontStyleCorp: "smParagraph",
                              tag: "dt",
                              children: [
                                t,
                                ":",
                                " "
                              ]
                            }
                          ),
                          /* @__PURE__ */ l.jsx(le, { as: "dd", children: x })
                        ] })
                      ] })
                    ] })
                  ]
                },
                v
              );
            })
          }
        )
      ]
    }
  );
}, ov = "_headline_lgk7t_209", Nr = {
  headline: ov,
  "bio-card-grid": "_bio-card-grid_lgk7t_215",
  "bio-card-grid-item": "_bio-card-grid-item_lgk7t_219",
  "bio-name": "_bio-name_lgk7t_225"
}, IT = (e) => {
  const {
    bios: t,
    className: n,
    headline: r,
    headlineTag: a = "p",
    columnsDesktop: i = "4",
    columnsTablet: s,
    shouldLazyLoad: o = !1,
    ...c
  } = e, d = s ?? (i !== "4" && i !== "5" && i !== "6") ? i : "3";
  return /* @__PURE__ */ l.jsxs(
    xe,
    {
      className: n,
      ...c,
      children: [
        r && /* @__PURE__ */ l.jsx(
          G,
          {
            "data-testid": "headline",
            className: Nr.headline,
            tag: a,
            children: r
          }
        ),
        /* @__PURE__ */ l.jsx(
          rt,
          {
            className: Nr["bio-card-grid"],
            "data-testid": "bio-card-grid",
            columns: "2",
            columnsTablet: d,
            columnsDesktop: i,
            children: t.map(
              ({ image: u, name: f, displayName: p, title: h, optionalLink: g }, v) => {
                const x = p || f;
                return /* @__PURE__ */ l.jsxs(
                  "div",
                  {
                    className: Nr["bio-card-grid-item"],
                    "data-testid": "bio-card-grid-item",
                    children: [
                      u && /* @__PURE__ */ l.jsx(
                        "div",
                        {
                          className: Nr["bio-card-grid-image"],
                          "data-testid": "bio-card-grid-image",
                          children: /* @__PURE__ */ l.jsx(
                            yn,
                            {
                              ratio: "6:7",
                              shouldLazyLoad: o,
                              children: u
                            }
                          )
                        }
                      ),
                      x && (g ? /* @__PURE__ */ l.jsx(
                        X,
                        {
                          fontStyle: "smLink",
                          fontStyleCorp: "smLink",
                          "data-testid": "bio-name",
                          className: Nr["bio-name"],
                          children: Te(
                            g,
                            {
                              children: /* @__PURE__ */ l.jsx(
                                G,
                                {
                                  asChild: !0,
                                  fontStyle: "mdHeading",
                                  children: x
                                }
                              )
                            }
                          )
                        }
                      ) : /* @__PURE__ */ l.jsx(
                        G,
                        {
                          "data-testid": "bio-name",
                          fontStyle: "smParagraphBold",
                          fontStyleCorp: "smParagraphBold",
                          tag: "h3",
                          children: x
                        }
                      )),
                      h && /* @__PURE__ */ l.jsx(
                        G,
                        {
                          fontStyle: "smParagraph",
                          "data-testid": "bio-title",
                          className: Nr["bio-title"],
                          tag: "p",
                          children: h
                        }
                      )
                    ]
                  },
                  v
                );
              }
            )
          }
        )
      ]
    }
  );
}, cv = "_headline_11jq0_209", O1 = {
  "side-media-asset-container": "_side-media-asset-container_11jq0_209",
  headline: cv
}, OT = (e) => {
  const {
    className: t,
    headline: n,
    headlineTag: r = "p",
    supportCopy: a,
    image: i,
    videoId: s,
    imageCaption: o,
    imageCtaLink: c,
    imageSide: d = "right",
    isImageBorderOn: u,
    imageContainerSize: f = "fifty",
    shouldLazyLoad: p = !1,
    ...h
  } = e, g = pe(null);
  return fg(g), /* @__PURE__ */ l.jsx(
    xe,
    {
      className: z(O1["side-media-asset-container"], t),
      "data-testid": "side-media-asset",
      ...h,
      children: /* @__PURE__ */ l.jsxs("div", { ref: g, children: [
        n && /* @__PURE__ */ l.jsx(
          G,
          {
            "data-testid": "side-media-asset-headline",
            className: O1.headline,
            tag: r,
            children: n
          }
        ),
        /* @__PURE__ */ l.jsx(
          z3,
          {
            image: i,
            videoId: s,
            imageCaption: o,
            imageCtaLink: c,
            imageSide: d,
            isImageBorderOn: u,
            imageContainerSize: f,
            shouldLazyLoad: p
          }
        ),
        /* @__PURE__ */ l.jsx(
          le,
          {
            "data-testid": "side-media-asset-support-copy",
            className: O1["support-copy"],
            children: a
          }
        )
      ] })
    }
  );
}, lv = "_card_wlbi1_209", dv = "_image_wlbi1_221", uv = "_content_wlbi1_235", fv = "_headline_wlbi1_250", pv = "_cta_wlbi1_256", wt = {
  card: lv,
  "image-right": "_image-right_wlbi1_221",
  "layout-forty": "_layout-forty_wlbi1_224",
  image: dv,
  content: uv,
  "with-controls": "_with-controls_wlbi1_239",
  headline: fv,
  "support-copy": "_support-copy_wlbi1_253",
  "cta-wrapper": "_cta-wrapper_wlbi1_256",
  cta: pv
}, RT = (e) => {
  const {
    className: t,
    hasCarouselControls: n,
    headline: r,
    headlineTag: a = "p",
    image: i,
    imageSide: s = "left",
    layout: o = "fifty",
    primaryCtaButton: c,
    primaryLink: d,
    secondaryCtaButton: u,
    secondaryCtaStyle: f = "solid1",
    secondaryLink: p,
    supportCopy: h,
    shouldLazyLoad: g = !1,
    ...v
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: t,
      "data-testid": "side-photo-content-card",
      ...v,
      children: /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          "data-testid": "side-photo-content-card-item",
          className: z(wt.card, {
            [wt["image-right"]]: s === "right",
            [wt["layout-forty"]]: o === "forty"
          }),
          children: [
            /* @__PURE__ */ l.jsx("div", { className: wt.image, children: /* @__PURE__ */ l.jsx(
              yn,
              {
                ratio: o === "forty" ? 864 / 520 : 720 / 480,
                shouldLazyLoad: g,
                children: i
              }
            ) }),
            /* @__PURE__ */ l.jsxs(
              "div",
              {
                className: z(wt.content, {
                  [wt["with-controls"]]: n
                }),
                children: [
                  r && /* @__PURE__ */ l.jsx(
                    G,
                    {
                      className: wt.headline,
                      tag: a,
                      children: r
                    }
                  ),
                  h && /* @__PURE__ */ l.jsx(le, { className: wt["support-copy"], children: h }),
                  c && /* @__PURE__ */ l.jsxs("div", { className: wt["cta-wrapper"], children: [
                    /* @__PURE__ */ l.jsx(
                      X,
                      {
                        className: wt.cta,
                        size: "responsive",
                        variant: "solid1",
                        children: c
                      }
                    ),
                    u && /* @__PURE__ */ l.jsx(
                      X,
                      {
                        className: wt.cta,
                        size: "responsive",
                        variant: f,
                        children: u
                      }
                    )
                  ] }),
                  d && /* @__PURE__ */ l.jsxs("div", { className: wt["cta-wrapper"], children: [
                    /* @__PURE__ */ l.jsx(X, { children: d }),
                    p && /* @__PURE__ */ l.jsx(X, { children: p })
                  ] })
                ]
              }
            )
          ]
        }
      ) })
    }
  );
}, mv = [
  "solid1",
  "solid2",
  "outlined",
  "outlined-alt",
  "light1",
  "light2",
  "solid-1-inverse",
  "outlined-inverse",
  "light-inverse"
], hv = "tablet", gv = "tabletLg", vv = "desktop", Sl = "24.625rem", bv = "37.5rem", yv = "52.1875rem", xv = "96rem", _v = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
], Gn = {
  "alpha-links-index": "_alpha-links-index_1j3l7_209",
  "dict-index-container": "_dict-index-container_1j3l7_212",
  "dictionary-buttons": "_dictionary-buttons_1j3l7_222",
  "dictionary-buttons-selected": "_dictionary-buttons-selected_1j3l7_233",
  "grouped-links-container": "_grouped-links-container_1j3l7_241",
  "link-container": "_link-container_1j3l7_249",
  "dictionary-buttons-list-item": "_dictionary-buttons-list-item_1j3l7_281"
}, DT = (e) => {
  var x, m;
  const {
    headline: t,
    topSupportCopy: n,
    bottomSupportCopy: r,
    linkItemFolder: a = {},
    headlineTag: i = "p",
    topContentAlignment: s = "center",
    backgroundTheme: o = "whiteSmoke",
    className: c,
    ...d
  } = e, u = zt(
    () => _v.reduce((b, _) => (b[_] = a[_] ?? [], b), {}),
    [a]
  ), [f, p] = ne(
    (x = Object.keys(u)) == null ? void 0 : x.find(
      (b) => {
        var _;
        return (_ = u[b]) == null ? void 0 : _.length;
      }
    )
  ), h = pe(null), g = pe(null), v = pe(null);
  return ve(() => {
    if (!f || !g.current || !h.current)
      return;
    const b = (
      // offsetLeft brings the selected letter to the left edge of the scroll container
      g.current.offsetLeft - // so this brings the left edge of the selected letter back to the center of the list
      h.current.clientWidth / 2 + // and this accounts for the width of the selected letter so it's perfectly centered
      g.current.clientWidth / 2
    );
    h.current.scrollTo({
      left: b,
      behavior: "smooth"
    });
  }, [f, g, h]), /* @__PURE__ */ l.jsxs(
    He,
    {
      className: z(Gn["alpha-links-index"], c),
      backgroundColor: o,
      "data-testid": "alpha-links-index",
      headline: t,
      headlineTag: i,
      headlineAlignment: s,
      supportCopy: n,
      supportCopyAlignment: s,
      supportCopyBottom: r,
      supportCopyBottomAlignment: "left",
      spacing: "64-40",
      ...d,
      children: [
        Object.keys(u).length && /* @__PURE__ */ l.jsx(
          "ul",
          {
            ref: h,
            "data-testid": "alpha-links-index-dict-container",
            className: Gn["dict-index-container"],
            children: Object.entries(u).map(
              ([b, _], C) => /* @__PURE__ */ l.jsx(
                "li",
                {
                  className: Gn["dictionary-buttons-list-item"],
                  children: /* @__PURE__ */ l.jsx(
                    "button",
                    {
                      ref: b === f ? g : void 0,
                      className: z(
                        Gn["dictionary-buttons"],
                        {
                          [Gn["dictionary-buttons-selected"]]: f === b
                        }
                      ),
                      disabled: !_.length,
                      "aria-disabled": !_.length,
                      onKeyDown: (w) => {
                        var N;
                        _.length && (w.key === "Enter" || w.key === " ") && (p(b), (N = v.current) == null || N.focus());
                      },
                      onClick: () => _.length > 0 && p(b),
                      children: b
                    }
                  )
                },
                C
              )
            )
          }
        ),
        f && ((m = u[f]) == null ? void 0 : m.length) && /* @__PURE__ */ l.jsx(
          "ul",
          {
            className: Gn["grouped-links-container"],
            style: {
              "--rows-desktop": Math.ceil(
                u[f].length / 3
              ),
              "--rows-tablet": Math.ceil(
                u[f].length / 2
              )
            },
            children: u[f].map((b, _) => /* @__PURE__ */ l.jsx(
              "li",
              {
                className: Gn["link-container"],
                children: /* @__PURE__ */ l.jsx(
                  X,
                  {
                    ref: _ === 0 ? v : void 0,
                    onKeyDown: (C) => {
                      var w;
                      _ === 0 && C.shiftKey && C.key === "Tab" && (C.preventDefault(), (w = g.current) == null || w.focus());
                    },
                    children: b
                  }
                )
              },
              _
            ))
          }
        )
      ]
    }
  );
}, ya = {
  "left-navigation-desktop": "_left-navigation-desktop_7awyp_209",
  "left-navigation-mobile": "_left-navigation-mobile_7awyp_212",
  "left-navigation-title": "_left-navigation-title_7awyp_215",
  "left-navigation-carrot": "_left-navigation-carrot_7awyp_220",
  "left-navigation-button": "_left-navigation-button_7awyp_223"
}, Ti = 10, t6 = (e) => {
  const { isShowingMore: t, setIsShowingMore: n } = e, r = t ? "Show less" : "Show more";
  return /* @__PURE__ */ l.jsx(
    "button",
    {
      type: "button",
      className: z(ya["left-navigation-button"]),
      onClick: () => {
        n(!t);
      },
      title: r,
      children: r
    }
  );
};
function wv() {
  const e = document.querySelectorAll(
    '[data-testid="left-navigation-list"] > [data-testid="accordion-item"]'
  );
  if (e.length !== 1)
    return;
  const t = e[0].closest('[data-state="closed"]');
  if (!t)
    return;
  const n = t.querySelector("button");
  n && n.click();
}
const ki = (e) => {
  const { item: t, isShowingMore: n } = e, { id: r, url: a, isActive: i, navigationTitle: s, target: o, children: c } = t;
  return ve(() => {
    wv();
  }, []), !c || c.length === 0 ? /* @__PURE__ */ l.jsx(hn, { value: r, children: /* @__PURE__ */ l.jsx(Ri, { children: /* @__PURE__ */ l.jsx(
    X,
    {
      href: a,
      target: o,
      underline: "hover",
      "data-isactive": i,
      asInherited: !0,
      title: s,
      children: s
    }
  ) }) }) : /* @__PURE__ */ l.jsx(hn, { value: r, children: /* @__PURE__ */ l.jsxs(Ri, { children: [
    /* @__PURE__ */ l.jsxs("div", { children: [
      /* @__PURE__ */ l.jsx(
        X,
        {
          href: a,
          underline: "hover",
          "data-isactive": i,
          asInherited: !0,
          title: s,
          children: s
        }
      ),
      c && /* @__PURE__ */ l.jsx(
        fd,
        {
          title: n ? `See less ${s}` : `See more ${s}`
        }
      )
    ] }),
    c && /* @__PURE__ */ l.jsx($a, { title: s, children: /* @__PURE__ */ l.jsx(Sv, { listItems: c }) })
  ] }) });
}, Cv = (e) => {
  var s, o;
  const { navigations: t } = e, [n, r] = ne(!1), a = ((s = t == null ? void 0 : t.children) == null ? void 0 : s.slice(0, Ti)) ?? [], i = ((o = t == null ? void 0 : t.children) == null ? void 0 : o.slice(Ti)) ?? [];
  return /* @__PURE__ */ l.jsx(i1, { children: /* @__PURE__ */ l.jsxs(Ia, { "data-testid": "left-navigation-list", children: [
    a.map((c, d) => /* @__PURE__ */ l.jsx(
      ki,
      {
        item: c,
        isShowingMore: n
      },
      d
    )),
    i.length > 0 && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      n && i.map((c, d) => /* @__PURE__ */ l.jsx(
        ki,
        {
          item: c,
          isShowingMore: n
        },
        d
      )),
      /* @__PURE__ */ l.jsx(
        t6,
        {
          isShowingMore: n,
          setIsShowingMore: r
        }
      )
    ] })
  ] }) });
}, Sv = (e) => {
  const { listItems: t } = e, [n, r] = ne(!1), a = t.slice(0, Ti) ?? [], i = t.slice(Ti) ?? [];
  return /* @__PURE__ */ l.jsx(i1, { children: /* @__PURE__ */ l.jsxs(Ia, { children: [
    a.map((s, o) => /* @__PURE__ */ l.jsx(
      ki,
      {
        item: s,
        isShowingMore: n
      },
      o
    )),
    i.length > 0 && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      n && i.map((s, o) => /* @__PURE__ */ l.jsx(
        ki,
        {
          item: s,
          isShowingMore: n
        },
        o
      )),
      /* @__PURE__ */ l.jsx(
        t6,
        {
          isShowingMore: n,
          setIsShowingMore: r
        }
      )
    ] })
  ] }) });
}, Ll = (e) => {
  const { navigations: t } = e;
  return /* @__PURE__ */ l.jsxs($a, { title: t.navigationTitle, children: [
    /* @__PURE__ */ l.jsxs(Bz, { children: [
      /* @__PURE__ */ l.jsx(
        re,
        {
          icon: "angleLeft",
          className: ya["left-navigation-carrot"]
        }
      ),
      /* @__PURE__ */ l.jsx(
        X,
        {
          href: t.url,
          className: ya["left-navigation-title"],
          asInherited: !0,
          children: t.navigationTitle
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx(Cv, { ...e })
  ] });
}, FT = (e) => {
  const { navigations: t, ...n } = e;
  return /* @__PURE__ */ l.jsxs("div", { ...n, children: [
    /* @__PURE__ */ l.jsx(
      ud,
      {
        className: ya["left-navigation-desktop"],
        type: "multiple",
        defaultValue: ["item-1"],
        id: "radix-:r1:-d",
        "data-testid": "left-navigation",
        children: /* @__PURE__ */ l.jsx(hn, { value: "item-1", children: /* @__PURE__ */ l.jsx(Ll, { navigations: t }) })
      }
    ),
    /* @__PURE__ */ l.jsx(
      uc,
      {
        className: ya["left-navigation-mobile"],
        type: "multiple",
        children: /* @__PURE__ */ l.jsxs(
          hn,
          {
            value: "item-1",
            id: "radix-:r1:m",
            children: [
              /* @__PURE__ */ l.jsxs(s1, { title: "Page navigation", children: [
                /* @__PURE__ */ l.jsx("span", { children: "Page navigation " }),
                /* @__PURE__ */ l.jsx(re, { icon: "bars" }),
                /* @__PURE__ */ l.jsx(re, { icon: "close" })
              ] }),
              /* @__PURE__ */ l.jsx(Ll, { navigations: t })
            ]
          }
        )
      }
    )
  ] });
};
var n6 = { exports: {} };
/*! For license information please see ScrollspyNav.js.LICENSE.txt */
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(qd, () => (() => {
    var n = { 7418: (s) => {
      var o = Object.getOwnPropertySymbols, c = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
      function u(f) {
        if (f == null)
          throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(f);
      }
      s.exports = function() {
        try {
          if (!Object.assign)
            return !1;
          var f = new String("abc");
          if (f[5] = "de", Object.getOwnPropertyNames(f)[0] === "5")
            return !1;
          for (var p = {}, h = 0; h < 10; h++)
            p["_" + String.fromCharCode(h)] = h;
          if (Object.getOwnPropertyNames(p).map(function(v) {
            return p[v];
          }).join("") !== "0123456789")
            return !1;
          var g = {};
          return "abcdefghijklmnopqrst".split("").forEach(function(v) {
            g[v] = v;
          }), Object.keys(Object.assign({}, g)).join("") === "abcdefghijklmnopqrst";
        } catch {
          return !1;
        }
      }() ? Object.assign : function(f, p) {
        for (var h, g, v = u(f), x = 1; x < arguments.length; x++) {
          for (var m in h = Object(arguments[x]))
            c.call(h, m) && (v[m] = h[m]);
          if (o) {
            g = o(h);
            for (var b = 0; b < g.length; b++)
              d.call(h, g[b]) && (v[g[b]] = h[g[b]]);
          }
        }
        return v;
      };
    }, 2408: (s, o, c) => {
      var d = c(7418), u = typeof Symbol == "function" && Symbol.for, f = u ? Symbol.for("react.element") : 60103, p = u ? Symbol.for("react.portal") : 60106, h = u ? Symbol.for("react.fragment") : 60107, g = u ? Symbol.for("react.strict_mode") : 60108, v = u ? Symbol.for("react.profiler") : 60114, x = u ? Symbol.for("react.provider") : 60109, m = u ? Symbol.for("react.context") : 60110, b = u ? Symbol.for("react.forward_ref") : 60112, _ = u ? Symbol.for("react.suspense") : 60113, C = u ? Symbol.for("react.memo") : 60115, w = u ? Symbol.for("react.lazy") : 60116, N = typeof Symbol == "function" && Symbol.iterator;
      function M(L) {
        for (var B = "https://reactjs.org/docs/error-decoder.html?invariant=" + L, ce = 1; ce < arguments.length; ce++)
          B += "&args[]=" + encodeURIComponent(arguments[ce]);
        return "Minified React error #" + L + "; visit " + B + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
      }
      var S = { isMounted: function() {
        return !1;
      }, enqueueForceUpdate: function() {
      }, enqueueReplaceState: function() {
      }, enqueueSetState: function() {
      } }, T = {};
      function j(L, B, ce) {
        this.props = L, this.context = B, this.refs = T, this.updater = ce || S;
      }
      function D() {
      }
      function A(L, B, ce) {
        this.props = L, this.context = B, this.refs = T, this.updater = ce || S;
      }
      j.prototype.isReactComponent = {}, j.prototype.setState = function(L, B) {
        if (typeof L != "object" && typeof L != "function" && L != null)
          throw Error(M(85));
        this.updater.enqueueSetState(this, L, B, "setState");
      }, j.prototype.forceUpdate = function(L) {
        this.updater.enqueueForceUpdate(this, L, "forceUpdate");
      }, D.prototype = j.prototype;
      var k = A.prototype = new D();
      k.constructor = A, d(k, j.prototype), k.isPureReactComponent = !0;
      var $ = { current: null }, R = Object.prototype.hasOwnProperty, F = { key: !0, ref: !0, __self: !0, __source: !0 };
      function P(L, B, ce) {
        var _e, we = {}, ze = null, Ge = null;
        if (B != null)
          for (_e in B.ref !== void 0 && (Ge = B.ref), B.key !== void 0 && (ze = "" + B.key), B)
            R.call(B, _e) && !F.hasOwnProperty(_e) && (we[_e] = B[_e]);
        var Pe = arguments.length - 2;
        if (Pe === 1)
          we.children = ce;
        else if (1 < Pe) {
          for (var at = Array(Pe), jt = 0; jt < Pe; jt++)
            at[jt] = arguments[jt + 2];
          we.children = at;
        }
        if (L && L.defaultProps)
          for (_e in Pe = L.defaultProps)
            we[_e] === void 0 && (we[_e] = Pe[_e]);
        return { $$typeof: f, type: L, key: ze, ref: Ge, props: we, _owner: $.current };
      }
      function I(L) {
        return typeof L == "object" && L !== null && L.$$typeof === f;
      }
      var H = /\/+/g, O = [];
      function W(L, B, ce, _e) {
        if (O.length) {
          var we = O.pop();
          return we.result = L, we.keyPrefix = B, we.func = ce, we.context = _e, we.count = 0, we;
        }
        return { result: L, keyPrefix: B, func: ce, context: _e, count: 0 };
      }
      function se(L) {
        L.result = null, L.keyPrefix = null, L.func = null, L.context = null, L.count = 0, 10 > O.length && O.push(L);
      }
      function ue(L, B, ce, _e) {
        var we = typeof L;
        we !== "undefined" && we !== "boolean" || (L = null);
        var ze = !1;
        if (L === null)
          ze = !0;
        else
          switch (we) {
            case "string":
            case "number":
              ze = !0;
              break;
            case "object":
              switch (L.$$typeof) {
                case f:
                case p:
                  ze = !0;
              }
          }
        if (ze)
          return ce(_e, L, B === "" ? "." + ae(L, 0) : B), 1;
        if (ze = 0, B = B === "" ? "." : B + ":", Array.isArray(L))
          for (var Ge = 0; Ge < L.length; Ge++) {
            var Pe = B + ae(we = L[Ge], Ge);
            ze += ue(we, Pe, ce, _e);
          }
        else if (typeof (Pe = L === null || typeof L != "object" ? null : typeof (Pe = N && L[N] || L["@@iterator"]) == "function" ? Pe : null) == "function")
          for (L = Pe.call(L), Ge = 0; !(we = L.next()).done; )
            ze += ue(we = we.value, Pe = B + ae(we, Ge++), ce, _e);
        else if (we === "object")
          throw ce = "" + L, Error(M(31, ce === "[object Object]" ? "object with keys {" + Object.keys(L).join(", ") + "}" : ce, ""));
        return ze;
      }
      function ee(L, B, ce) {
        return L == null ? 0 : ue(L, "", B, ce);
      }
      function ae(L, B) {
        return typeof L == "object" && L !== null && L.key != null ? function(ce) {
          var _e = { "=": "=0", ":": "=2" };
          return "$" + ("" + ce).replace(/[=:]/g, function(we) {
            return _e[we];
          });
        }(L.key) : B.toString(36);
      }
      function ie(L, B) {
        L.func.call(L.context, B, L.count++);
      }
      function U(L, B, ce) {
        var _e = L.result, we = L.keyPrefix;
        L = L.func.call(L.context, B, L.count++), Array.isArray(L) ? J(L, _e, ce, function(ze) {
          return ze;
        }) : L != null && (I(L) && (L = function(ze, Ge) {
          return { $$typeof: f, type: ze.type, key: Ge, ref: ze.ref, props: ze.props, _owner: ze._owner };
        }(L, we + (!L.key || B && B.key === L.key ? "" : ("" + L.key).replace(H, "$&/") + "/") + ce)), _e.push(L));
      }
      function J(L, B, ce, _e, we) {
        var ze = "";
        ce != null && (ze = ("" + ce).replace(H, "$&/") + "/"), ee(L, U, B = W(B, ze, _e, we)), se(B);
      }
      var fe = { current: null };
      function Z() {
        var L = fe.current;
        if (L === null)
          throw Error(M(321));
        return L;
      }
      var be = { ReactCurrentDispatcher: fe, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: $, IsSomeRendererActing: { current: !1 }, assign: d };
      o.Children = { map: function(L, B, ce) {
        if (L == null)
          return L;
        var _e = [];
        return J(L, _e, null, B, ce), _e;
      }, forEach: function(L, B, ce) {
        if (L == null)
          return L;
        ee(L, ie, B = W(null, null, B, ce)), se(B);
      }, count: function(L) {
        return ee(L, function() {
          return null;
        }, null);
      }, toArray: function(L) {
        var B = [];
        return J(L, B, null, function(ce) {
          return ce;
        }), B;
      }, only: function(L) {
        if (!I(L))
          throw Error(M(143));
        return L;
      } }, o.Component = j, o.Fragment = h, o.Profiler = v, o.PureComponent = A, o.StrictMode = g, o.Suspense = _, o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = be, o.cloneElement = function(L, B, ce) {
        if (L == null)
          throw Error(M(267, L));
        var _e = d({}, L.props), we = L.key, ze = L.ref, Ge = L._owner;
        if (B != null) {
          if (B.ref !== void 0 && (ze = B.ref, Ge = $.current), B.key !== void 0 && (we = "" + B.key), L.type && L.type.defaultProps)
            var Pe = L.type.defaultProps;
          for (at in B)
            R.call(B, at) && !F.hasOwnProperty(at) && (_e[at] = B[at] === void 0 && Pe !== void 0 ? Pe[at] : B[at]);
        }
        var at = arguments.length - 2;
        if (at === 1)
          _e.children = ce;
        else if (1 < at) {
          Pe = Array(at);
          for (var jt = 0; jt < at; jt++)
            Pe[jt] = arguments[jt + 2];
          _e.children = Pe;
        }
        return { $$typeof: f, type: L.type, key: we, ref: ze, props: _e, _owner: Ge };
      }, o.createContext = function(L, B) {
        return B === void 0 && (B = null), (L = { $$typeof: m, _calculateChangedBits: B, _currentValue: L, _currentValue2: L, _threadCount: 0, Provider: null, Consumer: null }).Provider = { $$typeof: x, _context: L }, L.Consumer = L;
      }, o.createElement = P, o.createFactory = function(L) {
        var B = P.bind(null, L);
        return B.type = L, B;
      }, o.createRef = function() {
        return { current: null };
      }, o.forwardRef = function(L) {
        return { $$typeof: b, render: L };
      }, o.isValidElement = I, o.lazy = function(L) {
        return { $$typeof: w, _ctor: L, _status: -1, _result: null };
      }, o.memo = function(L, B) {
        return { $$typeof: C, type: L, compare: B === void 0 ? null : B };
      }, o.useCallback = function(L, B) {
        return Z().useCallback(L, B);
      }, o.useContext = function(L, B) {
        return Z().useContext(L, B);
      }, o.useDebugValue = function() {
      }, o.useEffect = function(L, B) {
        return Z().useEffect(L, B);
      }, o.useImperativeHandle = function(L, B, ce) {
        return Z().useImperativeHandle(L, B, ce);
      }, o.useLayoutEffect = function(L, B) {
        return Z().useLayoutEffect(L, B);
      }, o.useMemo = function(L, B) {
        return Z().useMemo(L, B);
      }, o.useReducer = function(L, B, ce) {
        return Z().useReducer(L, B, ce);
      }, o.useRef = function(L) {
        return Z().useRef(L);
      }, o.useState = function(L) {
        return Z().useState(L);
      }, o.version = "16.14.0";
    }, 7294: (s, o, c) => {
      s.exports = c(2408);
    } }, r = {};
    function a(s) {
      var o = r[s];
      if (o !== void 0)
        return o.exports;
      var c = r[s] = { exports: {} };
      return n[s](c, c.exports, a), c.exports;
    }
    a.d = (s, o) => {
      for (var c in o)
        a.o(o, c) && !a.o(s, c) && Object.defineProperty(s, c, { enumerable: !0, get: o[c] });
    }, a.o = (s, o) => Object.prototype.hasOwnProperty.call(s, o), a.r = (s) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
    };
    var i = {};
    return (() => {
      a.r(i), a.d(i, { default: () => v });
      var s = a(7294);
      function o(x) {
        return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
          return typeof m;
        } : function(m) {
          return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
        }, o(x);
      }
      function c(x, m) {
        for (var b = 0; b < m.length; b++) {
          var _ = m[b];
          _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(x, _.key, _);
        }
      }
      function d(x, m) {
        return d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(b, _) {
          return b.__proto__ = _, b;
        }, d(x, m);
      }
      function u(x, m) {
        if (m && (o(m) === "object" || typeof m == "function"))
          return m;
        if (m !== void 0)
          throw new TypeError("Derived constructors may only return object or undefined");
        return f(x);
      }
      function f(x) {
        if (x === void 0)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return x;
      }
      function p(x) {
        return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(m) {
          return m.__proto__ || Object.getPrototypeOf(m);
        }, p(x);
      }
      var h = typeof window < "u", g = "react-scrollspy-nav";
      const v = function(x) {
        (function(M, S) {
          if (typeof S != "function" && S !== null)
            throw new TypeError("Super expression must either be null or a function");
          M.prototype = Object.create(S && S.prototype, { constructor: { value: M, writable: !0, configurable: !0 } }), Object.defineProperty(M, "prototype", { writable: !1 }), S && d(M, S);
        })(N, x);
        var m, b, _, C, w = (_ = N, C = function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return !1;
          if (typeof Proxy == "function")
            return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }(), function() {
          var M, S = p(_);
          if (C) {
            var T = p(this).constructor;
            M = Reflect.construct(S, arguments, T);
          } else
            M = S.apply(this, arguments);
          return u(this, M);
        });
        function N(M) {
          var S;
          return function(T, j) {
            if (!(T instanceof j))
              throw new TypeError("Cannot call a class as a function");
          }(this, N), (S = w.call(this, M)).props = M, S.scrollTargetIds = S.props.scrollTargetIds, S.activeNavClass = S.props.activeNavClass, S.scrollDuration = Number(S.props.scrollDuration) || 1e3, S.headerBackground = S.props.headerBackground === "true", S.offset = S.props.offset || 0, S.onScroll = S.onScroll.bind(f(S)), S.props.router && S.props.router === "HashRouter" ? (S.homeDefaultLink = "#/", S.hashIdentifier = "#/#") : (S.homeDefaultLink = "/", S.hashIdentifier = "#"), S;
        }
        return m = N, (b = [{ key: "onScroll", value: function() {
          var M, S = this;
          this.scrollTargetIds.forEach(function(T, j) {
            document.getElementById(T) ? (M = document.getElementById(T).offsetTop - (S.headerBackground ? document.querySelector("div[data-nav='list']").scrollHeight : 0), h && window.pageYOffset - S.offset >= M && window.pageYOffset < M + document.getElementById(T).scrollHeight ? (S.getNavLinkElement(T).classList.add(S.activeNavClass), S.clearOtherNavLinkActiveStyle(T)) : S.getNavLinkElement(T).classList.remove(S.activeNavClass), h && window.innerHeight + window.pageYOffset >= document.body.scrollHeight && j === S.scrollTargetIds.length - 1 && (S.getNavLinkElement(T).classList.add(S.activeNavClass), S.clearOtherNavLinkActiveStyle(T))) : console.warn("".concat(g, ": no element with id ").concat(T, " present in the DOM"));
          });
        } }, { key: "easeInOutQuad", value: function(M, S, T, j) {
          return (M /= j / 2) < 1 ? T / 2 * M * M + S : -T / 2 * (--M * (M - 2) - 1) + S;
        } }, { key: "scrollTo", value: function(M, S, T) {
          var j = this, D = S - M, A = 0;
          (function k() {
            A += 10;
            var $ = j.easeInOutQuad(A, M, D, T);
            h && window.scrollTo(0, $), A < T && setTimeout(k, 10);
          })();
        } }, { key: "getNavLinkElement", value: function(M) {
          return document.querySelector("a[href='".concat(this.hashIdentifier).concat(M, "']"));
        } }, { key: "getNavToSectionID", value: function(M) {
          return M.includes(this.hashIdentifier) ? M.replace(this.hashIdentifier, "") : "";
        } }, { key: "clearOtherNavLinkActiveStyle", value: function(M) {
          var S = this;
          this.scrollTargetIds.map(function(T, j) {
            T !== M && S.getNavLinkElement(T).classList.remove(S.activeNavClass);
          });
        } }, { key: "componentDidMount", value: function() {
          var M = this;
          document.querySelector("a[href='".concat(this.homeDefaultLink, "#']")) && document.querySelector("a[href='".concat(this.homeDefaultLink, "#']")).addEventListener("click", function(S) {
            S.preventDefault(), h && M.scrollTo(window.pageYOffset, 0, M.scrollDuration), h && (window.location.hash = "");
          }), document.querySelector("div[data-nav='list']").querySelectorAll("a").forEach(function(S) {
            S.addEventListener("click", function(T) {
              T.preventDefault();
              var j = M.getNavToSectionID(S.getAttribute("href"));
              if (j)
                if (document.getElementById(j)) {
                  var D = document.getElementById(j).offsetTop - (M.headerBackground ? document.querySelector("div[data-nav='list']").scrollHeight : 0);
                  h && M.scrollTo(window.pageYOffset, D + M.offset, M.scrollDuration);
                } else
                  console.warn("".concat(g, ": no element with id ").concat(j, " present in the DOM"));
              else
                h && M.scrollTo(window.pageYOffset, 0, M.scrollDuration);
            });
          }), h && window.addEventListener("scroll", this.onScroll);
        } }, { key: "componentWillUnmount", value: function() {
          h && window.removeEventListener("scroll", this.onScroll);
        } }, { key: "render", value: function() {
          return s.createElement("div", { "data-nav": "list" }, this.props.children);
        } }]) && c(m.prototype, b), Object.defineProperty(m, "prototype", { writable: !1 }), N;
      }(s.Component);
    })(), i;
  })());
})(n6);
var Lv = n6.exports;
const Mv = /* @__PURE__ */ L2(Lv), Xn = {
  "left-side-navigation-anchor-links-base": "_left-side-navigation-anchor-links-base_rpr55_209",
  "anchor-back": "_anchor-back_rpr55_209",
  "left-side-navigation-anchor-desktop": "_left-side-navigation-anchor-desktop_rpr55_241",
  "left-side-navigation-anchor-mobile": "_left-side-navigation-anchor-mobile_rpr55_244",
  "active-scroll-spy": "_active-scroll-spy_rpr55_252"
}, r6 = (e) => {
  const { item: t } = e, { url: n, navigationTitle: r, children: a } = t;
  return /* @__PURE__ */ l.jsx(hn, { value: r, children: /* @__PURE__ */ l.jsxs(Ri, { children: [
    /* @__PURE__ */ l.jsx(
      X,
      {
        href: n,
        underline: "always",
        asInherited: !0,
        title: r,
        children: r
      }
    ),
    a && !!(a != null && a.length) && /* @__PURE__ */ l.jsx(zv, { listItems: a })
  ] }) });
}, Nv = (e) => {
  var n;
  const { navigations: t } = e;
  return /* @__PURE__ */ l.jsx(i1, { children: /* @__PURE__ */ l.jsx(Ia, { "data-testid": "left-side-navigation-anchor-links-list", children: (n = t == null ? void 0 : t.children) == null ? void 0 : n.map((r, a) => /* @__PURE__ */ l.jsx(
    r6,
    {
      item: r
    },
    a
  )) }) });
}, zv = (e) => {
  const { listItems: t } = e;
  return /* @__PURE__ */ l.jsx(i1, { children: /* @__PURE__ */ l.jsx(Ia, { children: t.map((n, r) => /* @__PURE__ */ l.jsx(
    r6,
    {
      item: n
    },
    r
  )) }) });
}, Ml = (e) => {
  const { navigations: t } = e;
  return /* @__PURE__ */ l.jsx($a, { title: t.navigationTitle, children: /* @__PURE__ */ l.jsx(Nv, { ...e }) });
}, BT = (e) => {
  const { navigations: t, ...n } = e, r = (i) => {
    let s = [];
    for (const o of i)
      s.push(o.url.slice(1)), o.children && (s = s.concat(r(o.children)));
    return s;
  }, a = r(t.children || []);
  return /* @__PURE__ */ l.jsxs("div", { ...n, children: [
    /* @__PURE__ */ l.jsx("div", { className: Xn["left-side-navigation-anchor-links-base"], children: /* @__PURE__ */ l.jsx(
      Mv,
      {
        scrollTargetIds: a,
        activeNavClass: z(Xn["active-scroll-spy"]),
        offset: 55,
        children: /* @__PURE__ */ l.jsx(
          ud,
          {
            className: z(
              Xn["left-side-navigation-anchor-links-base"],
              Xn["left-side-navigation-anchor-desktop"]
            ),
            type: "multiple",
            defaultValue: ["item-1"],
            id: "radix-:r1-d:",
            "data-testid": "left-side-navigation-anchor-links",
            children: /* @__PURE__ */ l.jsx(hn, { value: "item-1", children: /* @__PURE__ */ l.jsx(Ml, { ...e }) })
          }
        )
      }
    ) }),
    /* @__PURE__ */ l.jsx(
      uc,
      {
        className: z(
          Xn["left-side-navigation-anchor-links-base"],
          Xn["left-side-navigation-anchor-mobile"]
        ),
        type: "multiple",
        children: /* @__PURE__ */ l.jsxs(
          hn,
          {
            value: "item-1",
            id: "radix-:r1-m:",
            children: [
              /* @__PURE__ */ l.jsxs(s1, { title: "Page navigation", children: [
                /* @__PURE__ */ l.jsx("span", { children: "Page navigation " }),
                /* @__PURE__ */ l.jsx(re, { icon: "bars" }),
                /* @__PURE__ */ l.jsx(re, { icon: "close" })
              ] }),
              /* @__PURE__ */ l.jsx(Ml, { ...e })
            ]
          }
        )
      }
    )
  ] });
}, a6 = (e) => {
  const { className: t } = e, [n, r] = ne(!1);
  ve(() => {
    if (typeof window < "u") {
      const i = () => {
        r(window.scrollY > 200);
      };
      return window.addEventListener("scroll", i), () => window.removeEventListener("scroll", i);
    }
  }, []);
  const a = () => {
    typeof window < "u" && window.scrollTo({
      top: 0,
      behavior: "smooth"
      // for smoothly scrolling
    });
  };
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: z(Xn["anchor-back"], t),
      "data-hide": `${n ? "show" : "hide"}`,
      children: /* @__PURE__ */ l.jsx(
        "a",
        {
          title: "Jump to Start of Content",
          onClick: a,
          children: /* @__PURE__ */ l.jsx(re, { icon: "arrowUp" })
        }
      )
    }
  );
}, Nl = {
  "multi-column-grid": "_multi-column-grid_1ftdg_210"
}, VT = (e) => {
  const { className: t, numberOfColumns: n = "2", columnContents: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: z(Nl["multi-column-grid-base"], t),
      "data-testid": "multi-column-container",
      ...a,
      children: /* @__PURE__ */ l.jsx(
        rt,
        {
          className: Nl["multi-column-grid"],
          columns: "1",
          columnsTablet: "2",
          columnsDesktop: n,
          "data-testid": "multi-column-container-grid",
          children: r
        }
      )
    }
  );
}, Jt = {
  "content-wrapper": "_content-wrapper_1ymzm_209",
  "article-image": "_article-image_1ymzm_215",
  "article-text": "_article-text_1ymzm_215",
  "social-media": "_social-media_1ymzm_221",
  "social-icon": "_social-icon_1ymzm_231",
  "article-image-full-width": "_article-image-full-width_1ymzm_238",
  "article-image-float-right": "_article-image-float-right_1ymzm_242"
}, HT = (e) => {
  const {
    className: t,
    headline: n,
    image: r,
    imageCaption: a,
    imageStyle: i = "fullWidth",
    mainContent: s,
    publishDate: o,
    socialShareLabel: c = "Share this story:",
    shouldDisplaySocialMediaIcons: d,
    shouldHideSubHeadline: u,
    socialMediaLinks: f,
    subHeadline: p,
    ...h
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      tag: "article",
      className: t,
      spacing: "40-24",
      "data-testid": "article",
      ...h,
      children: /* @__PURE__ */ l.jsxs("div", { className: Jt["content-wrapper"], children: [
        /* @__PURE__ */ l.jsx(
          G,
          {
            tag: "h1",
            className: Jt["article-headline"],
            "data-testid": "article-headline",
            children: n
          }
        ),
        !u && /* @__PURE__ */ l.jsx(
          G,
          {
            tag: "h2",
            className: Jt["article-sub-headline"],
            "data-testid": "article-subheadline",
            children: p
          }
        ),
        /* @__PURE__ */ l.jsx(G, { asChild: !0, children: /* @__PURE__ */ l.jsx(
          "time",
          {
            "data-testid": "article-publish-date",
            dateTime: o,
            children: o
          }
        ) }),
        d && /* @__PURE__ */ l.jsxs(
          "span",
          {
            "data-testid": "article-social-media-icons",
            className: Jt["social-media"],
            children: [
              c,
              f == null ? void 0 : f.map((g, v) => {
                const { link: x, icon: m } = g;
                return /* @__PURE__ */ l.jsx(X, { children: Te(x, {
                  children: /* @__PURE__ */ l.jsx(
                    re,
                    {
                      className: Jt["social-icon"],
                      icon: m
                    }
                  )
                }) }, v);
              })
            ]
          }
        ),
        /* @__PURE__ */ l.jsxs("div", { children: [
          r && /* @__PURE__ */ l.jsx(
            z3,
            {
              className: z(Jt["article-image"], {
                [Jt["article-image-full-width"]]: i === "fullWidth",
                [Jt["article-image-float-right"]]: i === "floatRight"
              }),
              "data-testid": "article-image",
              image: r,
              imageSide: i === "floatRight" ? "right" : void 0,
              imageContainerSize: i === "floatRight" ? "thirty" : void 0,
              imageCaption: a
            }
          ),
          /* @__PURE__ */ l.jsx(
            le,
            {
              className: Jt["article-text"],
              "data-testid": "article-body",
              children: s
            }
          )
        ] })
      ] })
    }
  );
}, Ev = "_grid_1ptyc_209", Tv = {
  grid: Ev
}, qT = (e) => {
  const {
    backgroundColor: t = "white",
    className: n,
    headline: r,
    headlineTag: a = "p",
    supportingCopy: i,
    textAlignment: s = "left",
    columns: o = "2",
    ctas: c,
    ...d
  } = e;
  return /* @__PURE__ */ l.jsx(
    He,
    {
      tag: "section",
      backgroundColor: t,
      className: n,
      "data-testid": "multi-column-cta",
      headline: r,
      headlineTag: a,
      contentAlignment: s,
      supportCopy: i,
      ...d,
      children: /* @__PURE__ */ l.jsx(
        rt,
        {
          columns: "1",
          columnsTablet: o === "4" ? "2" : o,
          columnsDesktop: o,
          className: Tv.grid,
          "data-testid": "multi-column-cta-column-grid",
          children: c
        }
      )
    }
  );
}, kv = "_testimonials_ye04m_209", Ja = {
  testimonials: kv,
  "testimonials-grid": "_testimonials-grid_ye04m_209",
  "expand-button": "_expand-button_ye04m_213",
  "expand-button-center": "_expand-button-center_ye04m_216"
}, WT = (e) => {
  const {
    backgroundColor: t = "whiteSmoke",
    className: n,
    contentAlignment: r = "center",
    expandButtonText: a,
    expandButtonAlignment: i = "center",
    headline: s,
    headlineTag: o = "p",
    numberOfColumns: c = "1",
    showOnlyFirstRowOnLoad: d,
    supportCopy: u,
    testimonialCards: f = [],
    ...p
  } = e, h = f.length, g = parseInt(c), [v, x] = ne(
    d ? g : h
  ), m = () => {
    x(h);
  };
  return /* @__PURE__ */ l.jsxs(
    He,
    {
      className: z(Ja.testimonials, n),
      backgroundColor: t,
      "data-testid": "testimonials",
      contentAlignment: r,
      headline: s,
      headlineTag: o,
      supportCopy: u,
      ...p,
      children: [
        h > 0 && /* @__PURE__ */ l.jsx(
          rt,
          {
            columns: "1",
            columnsTablet: g > 2 ? "2" : c,
            columnsDesktop: c,
            className: Ja["testimonials-grid"],
            "data-testid": "testimonials-grid",
            children: f.slice(0, v).map((b, _) => /* @__PURE__ */ l.jsx(
              o9,
              {
                ...b
              },
              _
            ))
          }
        ),
        v < h && /* @__PURE__ */ l.jsx(
          vn,
          {
            variant: "solid1",
            size: "responsive",
            "data-testid": "testimonials-expand-button",
            className: z(Ja["expand-button"], {
              [Ja["expand-button-center"]]: i === "center"
            }),
            onClick: m,
            children: a
          }
        )
      ]
    }
  );
}, zl = {
  "news-listing": "_news-listing_1h3mm_209",
  "card-list": "_card-list_1h3mm_212"
}, UT = (e) => {
  const { children: t, className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: z(zl["news-listing"], n),
      "data-testid": "news-listing",
      ...r,
      children: /* @__PURE__ */ l.jsx("div", { className: zl["card-list"], children: t })
    }
  );
}, ei = {
  "location-info": "_location-info_1hb65_209",
  "location-info-map-wrapper": "_location-info-map-wrapper_1hb65_209",
  "location-info-wrapper": "_location-info-wrapper_1hb65_224",
  "location-info-name": "_location-info-name_1hb65_230"
}, GT = (e) => {
  const {
    className: t,
    detailPageLink: n,
    isMapShowing: r = !0,
    location: a,
    showHoursOfOperation: i = !0,
    showServicesAvailable: s = !0,
    googleMapsApiKey: o,
    directionsLabel: c = "Get Directions",
    hoursLabel: d = "Hours: ",
    servicesAvailableLabel: u = "Services Available: ",
    ...f
  } = e, [p, h] = ne(!0), g = pe(null), { defaultPhone: v, hoursOfOperation: x, locationName: m, servicesAvailable: b } = a, _ = im(a), C = M3(a), w = s && !!b, N = i && !!x;
  return ve(() => {
    g.current && h(
      g.current.closest(
        '[data-testid="multi-column-container-grid"]'
      ) !== null
    );
  }, []), /* @__PURE__ */ l.jsx(
    xe,
    {
      className: t,
      "data-testid": "location-info-container",
      ...f,
      children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          ref: g,
          className: ei["location-info"],
          children: [
            r && _ && o && !p && /* @__PURE__ */ l.jsx(
              "div",
              {
                "data-testid": "location-info-map-wrapper",
                className: ei["location-info-map-wrapper"],
                children: /* @__PURE__ */ l.jsx(
                  mE,
                  {
                    title: m,
                    address: _,
                    googleMapsApiKey: o
                  }
                )
              }
            ),
            /* @__PURE__ */ l.jsxs(
              "div",
              {
                "data-testid": "location-info-wrapper",
                className: ei["location-info-wrapper"],
                children: [
                  n ? /* @__PURE__ */ l.jsx(X, { "data-testid": "location-info-name-link", children: Te(n, {
                    children: m
                  }) }) : /* @__PURE__ */ l.jsx(
                    G,
                    {
                      tag: "p",
                      "data-testid": "location-info-name",
                      className: ei["location-info-name"],
                      children: m
                    }
                  ),
                  /* @__PURE__ */ l.jsx(
                    wd,
                    {
                      "data-testid": "location-info-address",
                      location: a,
                      href: C,
                      target: "_blank"
                    }
                  ),
                  r && _ && /* @__PURE__ */ l.jsx(
                    X,
                    {
                      "data-testid": "location-info-directions",
                      href: C,
                      target: "_blank",
                      children: c
                    }
                  ),
                  (N || w) && /* @__PURE__ */ l.jsxs("dl", { children: [
                    N && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                      /* @__PURE__ */ l.jsx(
                        G,
                        {
                          tag: "dt",
                          fontStyleCorp: "smParagraph",
                          "data-testid": "location-info-hours-term",
                          children: d
                        }
                      ),
                      /* @__PURE__ */ l.jsx(
                        le,
                        {
                          as: "dd",
                          "data-testid": "location-info-hours-definition",
                          children: x
                        }
                      )
                    ] }),
                    w && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                      /* @__PURE__ */ l.jsx(
                        G,
                        {
                          tag: "dt",
                          fontStyleCorp: "smParagraph",
                          "data-testid": "location-info-services-term",
                          children: u
                        }
                      ),
                      /* @__PURE__ */ l.jsx(
                        le,
                        {
                          as: "dd",
                          "data-testid": "location-info-services-definition",
                          children: b
                        }
                      )
                    ] })
                  ] }),
                  v && /* @__PURE__ */ l.jsx(
                    X,
                    {
                      "data-testid": "location-info-phone",
                      href: `tel:${v}`,
                      children: v
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}, jv = "_headline_gsem9_218", Pv = "_cta_gsem9_226", wn = {
  "content-feed-with-featured-card-container": "_content-feed-with-featured-card-container_gsem9_209",
  headline: jv,
  "support-copy": "_support-copy_gsem9_221",
  "content-feed-grid": "_content-feed-grid_gsem9_224",
  cta: Pv,
  "support-copy-bottom": "_support-copy-bottom_gsem9_229",
  "text-center": "_text-center_gsem9_237",
  "cta-center": "_cta-center_gsem9_245"
}, YT = (e) => {
  const {
    backgroundColor: t = "whiteSmoke",
    cards: n,
    className: r,
    contentAlignment: a = "center",
    cta: i,
    ctaAlignment: s = "center",
    headline: o,
    headlineTag: c = "p",
    supportCopy: d,
    shouldLazyLoad: u = !1,
    placeholderImage: f,
    ...p
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      backgroundColor: t,
      className: z(
        wn["content-feed-with-featured-card-container"],
        r
      ),
      "data-testid": "content-feed-with-featured-card-container",
      ...p,
      children: /* @__PURE__ */ l.jsxs("div", { children: [
        o && /* @__PURE__ */ l.jsx(
          G,
          {
            className: z(wn.headline, {
              [wn["text-center"]]: a === "center"
            }),
            "data-testid": "content-feed-with-featured-card-headline",
            tag: c,
            children: o
          }
        ),
        d && /* @__PURE__ */ l.jsx(
          le,
          {
            className: z(wn["support-copy"], {
              [wn["text-center"]]: a === "center"
            }),
            "data-testid": "content-feed-with-featured-card-support-copy",
            children: d
          }
        ),
        /* @__PURE__ */ l.jsx(
          Jh,
          {
            cards: n.map((h, g) => ({
              isFeatured: g === 0,
              ...h
            })),
            className: wn["content-feed-grid"],
            shouldLazyLoad: u,
            placeholderImage: f
          }
        ),
        i && /* @__PURE__ */ l.jsx(
          X,
          {
            buttonStyle: "link",
            className: z(wn.cta, {
              [wn["cta-center"]]: s === "center"
            }),
            "data-testid": "content-feed-with-featured-card-cta",
            children: i
          }
        )
      ] })
    }
  );
}, El = {
  "audio-asset": "_audio-asset_5jw7l_209",
  "audio-center": "_audio-center_5jw7l_222"
}, KT = (e) => {
  const {
    audioSrc: t,
    caption: n,
    captionPlacement: r = "top",
    className: a,
    playerAlignment: i = "left",
    ...s
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      className: z(El["audio-asset"], a),
      "data-testid": "audio-asset",
      ...s,
      children: /* @__PURE__ */ l.jsxs("figure", { children: [
        n && r === "top" && /* @__PURE__ */ l.jsx("figcaption", { children: /* @__PURE__ */ l.jsx(le, { children: n }) }),
        /* @__PURE__ */ l.jsx(
          "audio",
          {
            className: z({
              [El["audio-center"]]: i === "center"
            }),
            controls: !0,
            src: t
          }
        ),
        n && r === "bottom" && /* @__PURE__ */ l.jsx("figcaption", { children: /* @__PURE__ */ l.jsx(le, { children: n }) })
      ] })
    }
  );
}, Av = "_container_1b3zj_209", $v = {
  container: Av
}, XT = (e) => {
  const {
    headline: t,
    headlineTag: n = "p",
    backgroundColor: r = "whiteSmoke",
    contentAlignment: a = "left",
    supportCopy: i,
    cta: s,
    links: o,
    placeholderText: c,
    submitButtonText: d,
    labelText: u,
    className: f,
    ...p
  } = e, [h, g] = ne(""), v = zt(() => h.trim().length <= 0 ? o : o.filter(
    ({ text: b }) => b.toLowerCase().includes(h.toLowerCase().trim())
  ), [h]), x = (b) => {
    g(b);
  }, m = (b) => {
    b.preventDefault();
    const _ = o.find((C) => C.text === h);
    _ != null && _.href && window.open(
      _.href,
      _.target || "_self"
    );
  };
  return /* @__PURE__ */ l.jsx(
    He,
    {
      backgroundColor: r,
      className: z($v.container, f),
      contentAlignment: a,
      cta: s,
      ctaAlignment: "left",
      ctaStyle: "link",
      "data-testid": "suggestive-dropdown",
      headline: t,
      headlineTag: n,
      spacing: "72-32",
      supportCopy: i,
      ...p,
      children: /* @__PURE__ */ l.jsx(
        ag,
        {
          shouldAutoFocusOnMatch: !0,
          shouldDisableSearchUntilMatch: !0,
          shouldDisableSubmitOnEnter: !0,
          labelText: u,
          onChangeCallback: x,
          onSubmitCallback: m,
          placeholderText: c,
          submitButtonText: d,
          suggestions: v
        }
      )
    }
  );
}, Iv = "_center_1hj6c_215", zr = {
  "simple-signup-base": "_simple-signup-base_1hj6c_209",
  "simple-signup-container": "_simple-signup-container_1hj6c_209",
  center: Iv,
  "simple-signup-cta-link": "_simple-signup-cta-link_1hj6c_230"
}, ZT = (e) => {
  const {
    alignment: t = "center",
    backgroundColor: n = "white",
    className: r,
    children: a,
    cta: i,
    ctaStyle: s,
    headline: o,
    headlineTag: c = "p",
    supportCopy: d,
    ...u
  } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      backgroundColor: n,
      className: z(zr["simple-signup-base"], r),
      "data-testid": "simple-signup",
      ...u,
      children: /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: z(zr["simple-signup-container"], {
            [zr.center]: t === "center"
          }),
          children: [
            /* @__PURE__ */ l.jsx(
              G,
              {
                tag: c,
                "data-testid": "simple-signup-headline",
                className: zr["simple-signup-headline"],
                children: o
              }
            ),
            d && /* @__PURE__ */ l.jsx(
              le,
              {
                "data-testid": "simple-signup-support-copy",
                className: zr["simple-signup-support-copy"],
                children: d
              }
            ),
            a,
            i && /* @__PURE__ */ l.jsx(
              X,
              {
                className: z({
                  [zr["simple-signup-cta-link"]]: s !== "button"
                }),
                size: "responsive",
                variant: s === "button" ? "solid1" : void 0,
                "data-testid": "simple-signup-cta",
                children: i
              }
            )
          ]
        }
      ) })
    }
  );
}, Ov = "_heading_1dkk2_229", Er = {
  "checkbox-facets-base": "_checkbox-facets-base_1dkk2_209",
  "checkbox-facets-wrapper": "_checkbox-facets-wrapper_1dkk2_214",
  "checkbox-facets-wrapper--open": "_checkbox-facets-wrapper--open_1dkk2_223",
  heading: Ov,
  "facets-list": "_facets-list_1dkk2_232",
  "toggle-button": "_toggle-button_1dkk2_238"
}, QT = (e) => {
  const {
    className: t,
    checkboxFacetItems: n,
    heading: r = "Filter by type",
    onFilterChange: a,
    isOpen: i,
    onToggleOpen: s,
    ...o
  } = e, [c, d] = ne(!1), u = i ?? c, f = s ?? (() => d(!c)), [p, h] = ne(/* @__PURE__ */ new Set()), g = (v, x) => {
    const m = new Set(p);
    x ? m.add(v) : m.delete(v), h(m), a(v, x);
  };
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: z(Er["checkbox-facets-base"], t),
      "data-testid": "checkbox-facets",
      ...o,
      children: [
        /* @__PURE__ */ l.jsxs(
          vn,
          {
            className: Er["toggle-button"],
            onClick: f,
            variant: "outlined",
            size: "responsive",
            "aria-expanded": u,
            children: [
              r,
              /* @__PURE__ */ l.jsx(re, { icon: u ? "chevronUp" : "chevronDown" })
            ]
          }
        ),
        /* @__PURE__ */ l.jsx(ur, { backgroundColor: "whiteSmoke", children: /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: z(Er["checkbox-facets-wrapper"], {
              [Er["checkbox-facets-wrapper--open"]]: u
            }),
            "data-testid": "checkbox-facets-wrapper",
            children: [
              r && /* @__PURE__ */ l.jsx(
                G,
                {
                  as: "h4",
                  className: Er.heading,
                  fontStyle: "smHeadingMobile",
                  fontStyleCorp: "smHeadingMobile",
                  children: r
                }
              ),
              /* @__PURE__ */ l.jsx("div", { className: Er["facets-list"], children: n == null ? void 0 : n.map((v, x) => /* @__PURE__ */ l.jsx(
                rg,
                {
                  ...v,
                  onCheckedChange: (m) => g(v.label, m)
                },
                x
              )) })
            ]
          }
        ) })
      ]
    }
  );
}, ti = {
  "mobile-carousel": "_mobile-carousel_1ukkk_209",
  "cards-grid": "_cards-grid_1ukkk_209",
  "cards-carousel": "_cards-carousel_1ukkk_212",
  "carousel-controls": "_carousel-controls_1ukkk_218"
}, JT = (e) => {
  const {
    backgroundColor: t = "white",
    cards: n = [],
    className: r,
    contentAlignment: a = "center",
    cta: i,
    enableCarouselOnMobile: s,
    headline: o,
    headlineTag: c = "p",
    shouldHideImagesOnMobile: d,
    shouldHideSupportCopyOnCards: u,
    supportCopy: f,
    slideTimingInSeconds: p = 6,
    shouldLazyLoad: h = !1,
    ...g
  } = e, v = n.map((x, m) => /* @__PURE__ */ l.jsx(
    Am,
    {
      ...x,
      shouldHideImagesOnMobile: d,
      shouldHideSupportCopyOnCards: u,
      shouldLazyLoad: h
    },
    m
  ));
  return /* @__PURE__ */ l.jsxs(
    He,
    {
      backgroundColor: t,
      className: z(
        {
          [ti["mobile-carousel"]]: s
        },
        r
      ),
      contentAlignment: a,
      cta: i,
      ctaStyle: "link",
      "data-testid": "content-feed-for-health-news-container",
      headline: o,
      headlineTag: c,
      supportCopy: f,
      ...g,
      children: [
        /* @__PURE__ */ l.jsx(
          rt,
          {
            className: ti["cards-grid"],
            "data-testid": "content-feed-for-health-news-grid",
            columns: "1",
            columnsTablet: "2",
            columnsDesktop: "4",
            children: v
          }
        ),
        s && /* @__PURE__ */ l.jsx(
          c1,
          {
            "data-testid": "content-feed-for-health-news-carousel",
            className: ti["cards-carousel"],
            controlsClass: ti["carousel-controls"],
            slides: v,
            slideTimingSeconds: p,
            controlsPosition: "static",
            backgroundColor: t
          }
        )
      ]
    }
  );
}, Yn = {
  "on-page-navigation-anchor-link-container-div": "_on-page-navigation-anchor-link-container-div_18rm3_209",
  "on-page-navigation-anchor-link-dropdown": "_on-page-navigation-anchor-link-dropdown_18rm3_216",
  "on-page-navigation-anchor-link-back-to-top": "_on-page-navigation-anchor-link-back-to-top_18rm3_227",
  "on-page-navigation-anchor-link-container": "_on-page-navigation-anchor-link-container_18rm3_209"
}, ek = (e) => {
  const [t, n] = ne(!1), { windowHeight: r } = ug(), { scrollPos: a } = U3({ threshold: 0 });
  ve(() => {
    n(
      a >= (typeof r < "u" ? r : 200) * 3
    );
  }, [r, a]);
  const { className: i, anchors: s, removeTopMargin: o = !1, ...c } = e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(
      xe,
      {
        id: "on-page-navigation-anchor-link-container",
        className: z(
          Yn["on-page-navigation-anchor-link-base"],
          Yn["on-page-navigation-anchor-link-container"],
          i
        ),
        "data-testid": "on-page-navigation-anchor-link-container",
        "data-remove-top-margin": o,
        ...c,
        children: [
          /* @__PURE__ */ l.jsx(
            "div",
            {
              id: "on-page-navigation-anchor-link-container-div",
              className: z(
                Yn["on-page-navigation-anchor-link-container-div"]
              ),
              "data-testid": "on-page-navigation-anchor-link-container-div",
              children: s && Array.isArray(s) && s.map((d) => /* @__PURE__ */ l.jsx(
                X,
                {
                  href: d.url,
                  variant: "outlined",
                  size: "medium",
                  scrollBehavior: "smooth",
                  role: "button",
                  target: "_self",
                  children: d.navigationTitle
                }
              ))
            }
          ),
          /* @__PURE__ */ l.jsx(
            uc,
            {
              id: "on-page-navigation-anchor-link-dropdown",
              className: z(
                Yn["on-page-navigation-anchor-link-base"],
                Yn["on-page-navigation-anchor-link-dropdown"],
                i
              ),
              type: "multiple",
              "data-testid": "on-page-navigation-anchor-link-dropdown",
              children: /* @__PURE__ */ l.jsxs(hn, { value: "item-1", children: [
                /* @__PURE__ */ l.jsxs(s1, { title: "Jump To", children: [
                  /* @__PURE__ */ l.jsx("span", { children: "Jump To" }),
                  /* @__PURE__ */ l.jsx(re, { icon: "bars" }),
                  /* @__PURE__ */ l.jsx(re, { icon: "close" })
                ] }),
                /* @__PURE__ */ l.jsx($a, { children: /* @__PURE__ */ l.jsx(Ia, { children: s && Array.isArray(s) && s.map((d) => /* @__PURE__ */ l.jsx(Ri, { children: /* @__PURE__ */ l.jsx(
                  X,
                  {
                    href: d.url,
                    scrollBehavior: "smooth",
                    target: "_self",
                    children: d.navigationTitle
                  }
                ) })) }) })
              ] })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ l.jsx(
      vn,
      {
        className: z(
          Yn["on-page-navigation-anchor-link-base"],
          Yn["on-page-navigation-anchor-link-back-to-top"],
          i
        ),
        "data-hide": t ? "show" : "hide",
        variant: "solid1",
        size: "medium",
        onClick: mm,
        "data-testid": "on-page-navigation-anchor-link-back-to-top",
        children: /* @__PURE__ */ l.jsx(re, { icon: "arrowUp" })
      }
    )
  ] });
}, Ct = {
  "bmi-calculator-base": "_bmi-calculator-base_33fyq_209",
  "bmi-calculator-card": "_bmi-calculator-card_33fyq_213",
  "bmi-calculator-title-container": "_bmi-calculator-title-container_33fyq_216",
  "bmi-calculator-title": "_bmi-calculator-title_33fyq_216",
  "bmi-calculator-controls-container": "_bmi-calculator-controls-container_33fyq_226",
  "bmi-calculator-controls-inputs": "_bmi-calculator-controls-inputs_33fyq_229",
  "bmi-calculator-controls-outputs": "_bmi-calculator-controls-outputs_33fyq_230",
  "bmi-calculator-input": "_bmi-calculator-input_33fyq_242",
  "bmi-calculator-output": "_bmi-calculator-output_33fyq_255"
}, tk = (e) => {
  const { className: t, ...n } = e, [r, a] = ne(""), [i, s] = ne(""), [o, c] = ne(""), [d, u] = ne(""), [f, p] = ne({
    heightFeet: !1,
    weightLbs: !1
  }), h = () => {
    const m = {
      heightFeet: !1,
      weightLbs: !1
    };
    r || (m.heightFeet = !0), o || (m.weightLbs = !0), p(m);
  }, g = /^[1-9][0-9]*$/, v = (m) => (b) => {
    const _ = b.target.value;
    (_ === "" || g.test(_)) && m(_), h();
  }, x = () => {
    if (h(), !r || !o) {
      u("");
      return;
    }
    const m = +r * 12 + +i;
    let b = 703 * +o / m ** 2;
    u("" + Math.round(b * 10) / 10);
  };
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: z(Ct["bmi-calculator-base"], t),
      "data-testid": "bmi-calculator",
      ...n,
      children: /* @__PURE__ */ l.jsxs(Bt, { className: Ct["bmi-calculator-card"], children: [
        /* @__PURE__ */ l.jsx("div", { className: Ct["bmi-calculator-title-container"], children: /* @__PURE__ */ l.jsx(
          G,
          {
            className: Ct["bmi-calculator-title"],
            fontStyle: "smHeading",
            children: "BMI Calculator"
          }
        ) }),
        /* @__PURE__ */ l.jsxs("div", { className: Ct["bmi-calculator-controls-container"], children: [
          /* @__PURE__ */ l.jsxs("div", { className: Ct["bmi-calculator-controls-inputs"], children: [
            /* @__PURE__ */ l.jsx(
              En,
              {
                "data-testid": "bmi-calculator-height-feet",
                className: Ct["bmi-calculator-input"],
                inputId: "height_feet",
                ariaRequired: "true",
                label: "Height",
                placeholder: "Feet",
                maxLength: 2,
                hasError: f.heightFeet,
                errorMessageId: "height-feet-error",
                errorMessage: "* Height is required",
                value: r,
                onChange: v(a),
                onKeyUp: () => h()
              }
            ),
            /* @__PURE__ */ l.jsx(
              En,
              {
                "data-testid": "bmi-calculator-height-inches",
                className: Ct["bmi-calculator-input"],
                inputId: "height_inches",
                ariaRequired: "true",
                placeholder: "Inches",
                maxLength: 2,
                value: i,
                onChange: v(s)
              }
            ),
            /* @__PURE__ */ l.jsx(
              En,
              {
                "data-testid": "bmi-calculator-weight-lbs",
                className: Ct["bmi-calculator-input"],
                inputId: "weight_lbs",
                ariaRequired: "true",
                label: "Weight",
                placeholder: "Pounds",
                maxLength: 4,
                hasError: f.weightLbs,
                errorMessageId: "weight-lbs-error",
                errorMessage: "* Weight is required",
                value: o,
                onChange: v(c),
                onKeyUp: () => h()
              }
            )
          ] }),
          /* @__PURE__ */ l.jsxs("div", { className: Ct["bmi-calculator-controls-outputs"], children: [
            /* @__PURE__ */ l.jsx(
              vn,
              {
                "data-testid": "bmi-calculator-calculate-button",
                className: Ct["bmi-calculator-output"],
                size: "responsive",
                onClick: x,
                children: "Calculate BMI"
              }
            ),
            /* @__PURE__ */ l.jsx(
              En,
              {
                "data-testid": "bmi-calculator-output",
                className: Ct["bmi-calculator-output"],
                inputId: "bmi",
                ariaRequired: "false",
                label: "Your BMI",
                disabled: !0,
                value: d
              }
            )
          ] })
        ] })
      ] })
    }
  );
}, Tl = {
  "left-nav-content-column": "_left-nav-content-column_rdwzu_208",
  "left-nav-navigation-column": "_left-nav-navigation-column_rdwzu_213"
}, nk = (e) => {
  const {
    className: t,
    breadcrumbsSection: n,
    aboveLeftNavSection: r,
    leftNavLinks: a,
    leftNavContent: i,
    belowLeftNavSection: s,
    ...o
  } = e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    r,
    n && /* @__PURE__ */ l.jsx(l.Fragment, { children: n }),
    /* @__PURE__ */ l.jsxs(
      xe,
      {
        verticalSpacing: !0,
        className: t,
        ...o,
        children: [
          /* @__PURE__ */ l.jsxs(rt, { children: [
            /* @__PURE__ */ l.jsx(
              Rn,
              {
                span: "4",
                spanDesktop: "4",
                className: Tl["left-nav-navigation-column"],
                children: a
              }
            ),
            /* @__PURE__ */ l.jsx(
              Rn,
              {
                span: "4",
                spanDesktop: "8",
                className: Tl["left-nav-content-column"],
                children: i
              }
            )
          ] }),
          /* @__PURE__ */ l.jsx(a6, {})
        ]
      }
    ),
    s
  ] });
}, kl = {
  "right-rail-body-content-column": "_right-rail-body-content-column_18567_208",
  "right-rail-content-column": "_right-rail-content-column_18567_212"
}, rk = (e) => {
  const {
    className: t,
    breadcrumbsSection: n,
    aboveRightRailSection: r,
    rightRailBodyContent: a,
    rightRailContent: i,
    belowRightRailSection: s,
    ...o
  } = e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    r,
    n && /* @__PURE__ */ l.jsx(l.Fragment, { children: n }),
    /* @__PURE__ */ l.jsxs(
      xe,
      {
        verticalSpacing: !0,
        className: t,
        ...o,
        children: [
          /* @__PURE__ */ l.jsxs(rt, { children: [
            /* @__PURE__ */ l.jsx(
              Rn,
              {
                span: "4",
                spanDesktop: "8",
                className: kl["right-rail-body-content-column"],
                children: a
              }
            ),
            /* @__PURE__ */ l.jsx(
              Rn,
              {
                span: "4",
                spanDesktop: "4",
                className: kl["right-rail-content-column"],
                children: i
              }
            )
          ] }),
          /* @__PURE__ */ l.jsx(a6, {})
        ]
      }
    ),
    s
  ] });
}, Rv = () => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    "data-name": "though-bubbles",
    xmlns: "http://www.w3.org/2000/svg",
    width: "40px",
    height: "40px",
    viewBox: "0 0 735.246 577.128",
    children: [
      /* @__PURE__ */ l.jsx(
        "ellipse",
        {
          cx: "523.394",
          cy: "152",
          rx: "115.82",
          ry: "208.197",
          transform: "translate(169.868 566.806) rotate(-65.754)",
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: "10",
          strokeWidth: "30"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "ellipse",
        {
          cx: "240.719",
          cy: "317.696",
          rx: "58.048",
          ry: "110.401",
          transform: "translate(-157.813 324.638) rotate(-53.847)",
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: "10",
          strokeWidth: "30"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "ellipse",
        {
          cx: "105.3",
          cy: "500.177",
          rx: "88.703",
          ry: "60.837",
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: "10",
          strokeWidth: "30"
        }
      )
    ]
  }
), It = {
  "accordion-base": "_accordion-base_11q66_209",
  "accordion-trigger": "_accordion-trigger_11q66_213",
  "accordion-item": "_accordion-item_11q66_246",
  "accordion-content": "_accordion-content_11q66_275",
  "accordion-trigger-text": "_accordion-trigger-text_11q66_282"
}, Ps = (e) => {
  const { className: t, type: n } = e;
  if (n === "single") {
    const { children: r, collapsible: a, type: i, ...s } = e;
    return /* @__PURE__ */ l.jsx(
      Fr,
      {
        className: z(It["accordion-base"], t),
        children: r,
        collapsible: a,
        type: i,
        ...s
      }
    );
  } else {
    const { children: r, type: a, ...i } = e;
    return /* @__PURE__ */ l.jsx(
      Fr,
      {
        className: z(It["accordion-base"], t),
        children: r,
        type: a,
        ...i
      }
    );
  }
}, i6 = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    mo,
    {
      "data-testid": "accordion-item",
      "data-value": e.value,
      ref: t,
      className: z(It["accordion-item"], n),
      ...r
    }
  );
});
i6.displayName = "AccordionItem";
const s6 = K((e, t) => {
  const { className: n, children: r, hasIcon: a = !0, ...i } = e;
  return /* @__PURE__ */ l.jsx(
    E8,
    {
      "data-testid": "accordion-header",
      className: It["accordion-header"],
      children: /* @__PURE__ */ l.jsxs(
        fr,
        {
          ref: t,
          "data-testid": "accordion-trigger",
          className: z(
            It["accordion-trigger"],
            It["typography-small-paragraph"],
            n
          ),
          ...i,
          children: [
            /* @__PURE__ */ l.jsx(
              G,
              {
                fontStyle: "smParagraph",
                className: It["accordion-trigger-text"],
                children: r
              }
            ),
            a && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
              /* @__PURE__ */ l.jsx(re, { icon: "plus" }),
              /* @__PURE__ */ l.jsx(re, { icon: "minus" })
            ] })
          ]
        }
      )
    }
  );
});
s6.displayName = fr.displayName;
const o6 = K((e, t) => {
  const { className: n, forceMount: r = !0, children: a, ...i } = e;
  return /* @__PURE__ */ l.jsx(
    Ur,
    {
      "data-testid": "accordion-content",
      ref: t,
      forceMount: r,
      className: It["accordion-content-wrap"],
      ...i,
      children: /* @__PURE__ */ l.jsx(
        le,
        {
          className: z(
            It["accordion-content"],
            It["typography-small-paragraph"],
            n
          ),
          children: a
        }
      )
    }
  );
});
o6.displayName = Ur.displayName;
const Dv = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    Ur,
    {
      "data-testid": "accordion-content",
      ref: t,
      className: z(It["accordion-content-wrap"], n),
      ...a,
      children: r
    }
  );
});
o6.displayName = "AccordionContentPlain";
const ak = ["medium", "large", "responsive"], Fv = (e) => mv.includes(e), Bv = "large", Vv = "solid1", vn = K((e, t) => {
  const {
    asChild: n = !1,
    className: r,
    size: a = Bv,
    variant: i = Vv,
    buttonStyle: s,
    order: o,
    ...c
  } = e, d = n ? lt : "button", u = Et(Hn), { theme: f } = Ho(), p = s ? S3({ backgroundColor: u, theme: f, buttonStyle: s, order: o }) : i;
  return /* @__PURE__ */ l.jsx(
    d,
    {
      className: z(
        Fo({ variant: p, size: a }),
        r
      ),
      ref: t,
      ...c
    }
  );
});
vn.displayName = "Button";
function jl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function te(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jl(Object(n), !0).forEach(function(r) {
      Xe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jl(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ji(e) {
  "@babel/helpers - typeof";
  return ji = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ji(e);
}
function Hv(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Pl(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function qv(e, t, n) {
  return t && Pl(e.prototype, t), n && Pl(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Xe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function qo(e, t) {
  return Uv(e) || Yv(e, t) || c6(e, t) || Xv();
}
function Ta(e) {
  return Wv(e) || Gv(e) || c6(e) || Kv();
}
function Wv(e) {
  if (Array.isArray(e))
    return As(e);
}
function Uv(e) {
  if (Array.isArray(e))
    return e;
}
function Gv(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Yv(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, i = !1, s, o;
    try {
      for (n = n.call(e); !(a = (s = n.next()).done) && (r.push(s.value), !(t && r.length === t)); a = !0)
        ;
    } catch (c) {
      i = !0, o = c;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (i)
          throw o;
      }
    }
    return r;
  }
}
function c6(e, t) {
  if (e) {
    if (typeof e == "string")
      return As(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return As(e, t);
  }
}
function As(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Kv() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xv() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Al = function() {
}, Wo = {}, l6 = {}, d6 = null, u6 = {
  mark: Al,
  measure: Al
};
try {
  typeof window < "u" && (Wo = window), typeof document < "u" && (l6 = document), typeof MutationObserver < "u" && (d6 = MutationObserver), typeof performance < "u" && (u6 = performance);
} catch {
}
var Zv = Wo.navigator || {}, $l = Zv.userAgent, Il = $l === void 0 ? "" : $l, $n = Wo, Re = l6, Ol = d6, ni = u6;
$n.document;
var bn = !!Re.documentElement && !!Re.head && typeof Re.addEventListener == "function" && typeof Re.createElement == "function", f6 = ~Il.indexOf("MSIE") || ~Il.indexOf("Trident/"), ri, ai, ii, si, oi, fn = "___FONT_AWESOME___", $s = 16, p6 = "fa", m6 = "svg-inline--fa", lr = "data-fa-i2svg", Is = "data-fa-pseudo-element", Qv = "data-fa-pseudo-element-pending", Uo = "data-prefix", Go = "data-icon", Rl = "fontawesome-i2svg", Jv = "async", eb = ["HTML", "HEAD", "STYLE", "SCRIPT"], h6 = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), Oe = "classic", Ve = "sharp", Yo = [Oe, Ve];
function ka(e) {
  return new Proxy(e, {
    get: function(n, r) {
      return r in n ? n[r] : n[Oe];
    }
  });
}
var xa = ka((ri = {}, Xe(ri, Oe, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  fakd: "kit",
  "fa-kit": "kit",
  "fa-kit-duotone": "kit"
}), Xe(ri, Ve, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light",
  fast: "thin",
  "fa-thin": "thin"
}), ri)), _a = ka((ai = {}, Xe(ai, Oe, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), Xe(ai, Ve, {
  solid: "fass",
  regular: "fasr",
  light: "fasl",
  thin: "fast"
}), ai)), wa = ka((ii = {}, Xe(ii, Oe, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), Xe(ii, Ve, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light",
  fast: "fa-thin"
}), ii)), tb = ka((si = {}, Xe(si, Oe, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), Xe(si, Ve, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl",
  "fa-thin": "fast"
}), si)), nb = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/, g6 = "fa-layers-text", rb = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, ab = ka((oi = {}, Xe(oi, Oe, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), Xe(oi, Ve, {
  900: "fass",
  400: "fasr",
  300: "fasl",
  100: "fast"
}), oi)), v6 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], ib = v6.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), sb = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Qn = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Ca = /* @__PURE__ */ new Set();
Object.keys(_a[Oe]).map(Ca.add.bind(Ca));
Object.keys(_a[Ve]).map(Ca.add.bind(Ca));
var ob = [].concat(Yo, Ta(Ca), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Qn.GROUP, Qn.SWAP_OPACITY, Qn.PRIMARY, Qn.SECONDARY]).concat(v6.map(function(e) {
  return "".concat(e, "x");
})).concat(ib.map(function(e) {
  return "w-".concat(e);
})), pa = $n.FontAwesomeConfig || {};
function cb(e) {
  var t = Re.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function lb(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
if (Re && typeof Re.querySelector == "function") {
  var db = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  db.forEach(function(e) {
    var t = qo(e, 2), n = t[0], r = t[1], a = lb(cb(n));
    a != null && (pa[r] = a);
  });
}
var b6 = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: p6,
  replacementClass: m6,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
pa.familyPrefix && (pa.cssPrefix = pa.familyPrefix);
var Hr = te(te({}, b6), pa);
Hr.autoReplaceSvg || (Hr.observeMutations = !1);
var oe = {};
Object.keys(b6).forEach(function(e) {
  Object.defineProperty(oe, e, {
    enumerable: !0,
    set: function(n) {
      Hr[e] = n, ma.forEach(function(r) {
        return r(oe);
      });
    },
    get: function() {
      return Hr[e];
    }
  });
});
Object.defineProperty(oe, "familyPrefix", {
  enumerable: !0,
  set: function(t) {
    Hr.cssPrefix = t, ma.forEach(function(n) {
      return n(oe);
    });
  },
  get: function() {
    return Hr.cssPrefix;
  }
});
$n.FontAwesomeConfig = oe;
var ma = [];
function ub(e) {
  return ma.push(e), function() {
    ma.splice(ma.indexOf(e), 1);
  };
}
var Cn = $s, Ht = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function fb(e) {
  if (!(!e || !bn)) {
    var t = Re.createElement("style");
    t.setAttribute("type", "text/css"), t.innerHTML = e;
    for (var n = Re.head.childNodes, r = null, a = n.length - 1; a > -1; a--) {
      var i = n[a], s = (i.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(s) > -1 && (r = i);
    }
    return Re.head.insertBefore(t, r), e;
  }
}
var pb = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Sa() {
  for (var e = 12, t = ""; e-- > 0; )
    t += pb[Math.random() * 62 | 0];
  return t;
}
function Jr(e) {
  for (var t = [], n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function Ko(e) {
  return e.classList ? Jr(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function(t) {
    return t;
  });
}
function y6(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function mb(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, '="').concat(y6(e[n]), '" ');
  }, "").trim();
}
function e1(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, ": ").concat(e[n].trim(), ";");
  }, "");
}
function Xo(e) {
  return e.size !== Ht.size || e.x !== Ht.x || e.y !== Ht.y || e.rotate !== Ht.rotate || e.flipX || e.flipY;
}
function hb(e) {
  var t = e.transform, n = e.containerWidth, r = e.iconWidth, a = {
    transform: "translate(".concat(n / 2, " 256)")
  }, i = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), s = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), o = "rotate(".concat(t.rotate, " 0 0)"), c = {
    transform: "".concat(i, " ").concat(s, " ").concat(o)
  }, d = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: a,
    inner: c,
    path: d
  };
}
function gb(e) {
  var t = e.transform, n = e.width, r = n === void 0 ? $s : n, a = e.height, i = a === void 0 ? $s : a, s = e.startCentered, o = s === void 0 ? !1 : s, c = "";
  return o && f6 ? c += "translate(".concat(t.x / Cn - r / 2, "em, ").concat(t.y / Cn - i / 2, "em) ") : o ? c += "translate(calc(-50% + ".concat(t.x / Cn, "em), calc(-50% + ").concat(t.y / Cn, "em)) ") : c += "translate(".concat(t.x / Cn, "em, ").concat(t.y / Cn, "em) "), c += "scale(".concat(t.size / Cn * (t.flipX ? -1 : 1), ", ").concat(t.size / Cn * (t.flipY ? -1 : 1), ") "), c += "rotate(".concat(t.rotate, "deg) "), c;
}
var vb = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, 0));
          transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function x6() {
  var e = p6, t = m6, n = oe.cssPrefix, r = oe.replacementClass, a = vb;
  if (n !== e || r !== t) {
    var i = new RegExp("\\.".concat(e, "\\-"), "g"), s = new RegExp("\\--".concat(e, "\\-"), "g"), o = new RegExp("\\.".concat(t), "g");
    a = a.replace(i, ".".concat(n, "-")).replace(s, "--".concat(n, "-")).replace(o, ".".concat(r));
  }
  return a;
}
var Dl = !1;
function R1() {
  oe.autoAddCss && !Dl && (fb(x6()), Dl = !0);
}
var bb = {
  mixout: function() {
    return {
      dom: {
        css: x6,
        insertCss: R1
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        R1();
      },
      beforeI2svg: function() {
        R1();
      }
    };
  }
}, pn = $n || {};
pn[fn] || (pn[fn] = {});
pn[fn].styles || (pn[fn].styles = {});
pn[fn].hooks || (pn[fn].hooks = {});
pn[fn].shims || (pn[fn].shims = []);
var Ot = pn[fn], _6 = [], yb = function e() {
  Re.removeEventListener("DOMContentLoaded", e), Pi = 1, _6.map(function(t) {
    return t();
  });
}, Pi = !1;
bn && (Pi = (Re.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Re.readyState), Pi || Re.addEventListener("DOMContentLoaded", yb));
function xb(e) {
  bn && (Pi ? setTimeout(e, 0) : _6.push(e));
}
function ja(e) {
  var t = e.tag, n = e.attributes, r = n === void 0 ? {} : n, a = e.children, i = a === void 0 ? [] : a;
  return typeof e == "string" ? y6(e) : "<".concat(t, " ").concat(mb(r), ">").concat(i.map(ja).join(""), "</").concat(t, ">");
}
function Fl(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var _b = function(t, n) {
  return function(r, a, i, s) {
    return t.call(n, r, a, i, s);
  };
}, D1 = function(t, n, r, a) {
  var i = Object.keys(t), s = i.length, o = a !== void 0 ? _b(n, a) : n, c, d, u;
  for (r === void 0 ? (c = 1, u = t[i[0]]) : (c = 0, u = r); c < s; c++)
    d = i[c], u = o(u, t[d], d, t);
  return u;
};
function wb(e) {
  for (var t = [], n = 0, r = e.length; n < r; ) {
    var a = e.charCodeAt(n++);
    if (a >= 55296 && a <= 56319 && n < r) {
      var i = e.charCodeAt(n++);
      (i & 64512) == 56320 ? t.push(((a & 1023) << 10) + (i & 1023) + 65536) : (t.push(a), n--);
    } else
      t.push(a);
  }
  return t;
}
function Os(e) {
  var t = wb(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function Cb(e, t) {
  var n = e.length, r = e.charCodeAt(t), a;
  return r >= 55296 && r <= 56319 && n > t + 1 && (a = e.charCodeAt(t + 1), a >= 56320 && a <= 57343) ? (r - 55296) * 1024 + a - 56320 + 65536 : r;
}
function Bl(e) {
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n], a = !!r.icon;
    return a ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function Rs(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.skipHooks, a = r === void 0 ? !1 : r, i = Bl(t);
  typeof Ot.hooks.addPack == "function" && !a ? Ot.hooks.addPack(e, Bl(t)) : Ot.styles[e] = te(te({}, Ot.styles[e] || {}), i), e === "fas" && Rs("fa", t);
}
var ci, li, di, jr = Ot.styles, Sb = Ot.shims, Lb = (ci = {}, Xe(ci, Oe, Object.values(wa[Oe])), Xe(ci, Ve, Object.values(wa[Ve])), ci), Zo = null, w6 = {}, C6 = {}, S6 = {}, L6 = {}, M6 = {}, Mb = (li = {}, Xe(li, Oe, Object.keys(xa[Oe])), Xe(li, Ve, Object.keys(xa[Ve])), li);
function Nb(e) {
  return ~ob.indexOf(e);
}
function zb(e, t) {
  var n = t.split("-"), r = n[0], a = n.slice(1).join("-");
  return r === e && a !== "" && !Nb(a) ? a : null;
}
var N6 = function() {
  var t = function(i) {
    return D1(jr, function(s, o, c) {
      return s[c] = D1(o, i, {}), s;
    }, {});
  };
  w6 = t(function(a, i, s) {
    if (i[3] && (a[i[3]] = s), i[2]) {
      var o = i[2].filter(function(c) {
        return typeof c == "number";
      });
      o.forEach(function(c) {
        a[c.toString(16)] = s;
      });
    }
    return a;
  }), C6 = t(function(a, i, s) {
    if (a[s] = s, i[2]) {
      var o = i[2].filter(function(c) {
        return typeof c == "string";
      });
      o.forEach(function(c) {
        a[c] = s;
      });
    }
    return a;
  }), M6 = t(function(a, i, s) {
    var o = i[2];
    return a[s] = s, o.forEach(function(c) {
      a[c] = s;
    }), a;
  });
  var n = "far" in jr || oe.autoFetchSvg, r = D1(Sb, function(a, i) {
    var s = i[0], o = i[1], c = i[2];
    return o === "far" && !n && (o = "fas"), typeof s == "string" && (a.names[s] = {
      prefix: o,
      iconName: c
    }), typeof s == "number" && (a.unicodes[s.toString(16)] = {
      prefix: o,
      iconName: c
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  S6 = r.names, L6 = r.unicodes, Zo = t1(oe.styleDefault, {
    family: oe.familyDefault
  });
};
ub(function(e) {
  Zo = t1(e.styleDefault, {
    family: oe.familyDefault
  });
});
N6();
function Qo(e, t) {
  return (w6[e] || {})[t];
}
function Eb(e, t) {
  return (C6[e] || {})[t];
}
function Jn(e, t) {
  return (M6[e] || {})[t];
}
function z6(e) {
  return S6[e] || {
    prefix: null,
    iconName: null
  };
}
function Tb(e) {
  var t = L6[e], n = Qo("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function In() {
  return Zo;
}
var Jo = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function t1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.family, r = n === void 0 ? Oe : n, a = xa[r][e], i = _a[r][e] || _a[r][a], s = e in Ot.styles ? e : null;
  return i || s || null;
}
var Vl = (di = {}, Xe(di, Oe, Object.keys(wa[Oe])), Xe(di, Ve, Object.keys(wa[Ve])), di);
function n1(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.skipLookups, a = r === void 0 ? !1 : r, i = (t = {}, Xe(t, Oe, "".concat(oe.cssPrefix, "-").concat(Oe)), Xe(t, Ve, "".concat(oe.cssPrefix, "-").concat(Ve)), t), s = null, o = Oe;
  (e.includes(i[Oe]) || e.some(function(d) {
    return Vl[Oe].includes(d);
  })) && (o = Oe), (e.includes(i[Ve]) || e.some(function(d) {
    return Vl[Ve].includes(d);
  })) && (o = Ve);
  var c = e.reduce(function(d, u) {
    var f = zb(oe.cssPrefix, u);
    if (jr[u] ? (u = Lb[o].includes(u) ? tb[o][u] : u, s = u, d.prefix = u) : Mb[o].indexOf(u) > -1 ? (s = u, d.prefix = t1(u, {
      family: o
    })) : f ? d.iconName = f : u !== oe.replacementClass && u !== i[Oe] && u !== i[Ve] && d.rest.push(u), !a && d.prefix && d.iconName) {
      var p = s === "fa" ? z6(d.iconName) : {}, h = Jn(d.prefix, d.iconName);
      p.prefix && (s = null), d.iconName = p.iconName || h || d.iconName, d.prefix = p.prefix || d.prefix, d.prefix === "far" && !jr.far && jr.fas && !oe.autoFetchSvg && (d.prefix = "fas");
    }
    return d;
  }, Jo());
  return (e.includes("fa-brands") || e.includes("fab")) && (c.prefix = "fab"), (e.includes("fa-duotone") || e.includes("fad")) && (c.prefix = "fad"), !c.prefix && o === Ve && (jr.fass || oe.autoFetchSvg) && (c.prefix = "fass", c.iconName = Jn(c.prefix, c.iconName) || c.iconName), (c.prefix === "fa" || s === "fa") && (c.prefix = In() || "fas"), c;
}
var kb = /* @__PURE__ */ function() {
  function e() {
    Hv(this, e), this.definitions = {};
  }
  return qv(e, [{
    key: "add",
    value: function() {
      for (var n = this, r = arguments.length, a = new Array(r), i = 0; i < r; i++)
        a[i] = arguments[i];
      var s = a.reduce(this._pullDefinitions, {});
      Object.keys(s).forEach(function(o) {
        n.definitions[o] = te(te({}, n.definitions[o] || {}), s[o]), Rs(o, s[o]);
        var c = wa[Oe][o];
        c && Rs(c, s[o]), N6();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(n, r) {
      var a = r.prefix && r.iconName && r.icon ? {
        0: r
      } : r;
      return Object.keys(a).map(function(i) {
        var s = a[i], o = s.prefix, c = s.iconName, d = s.icon, u = d[2];
        n[o] || (n[o] = {}), u.length > 0 && u.forEach(function(f) {
          typeof f == "string" && (n[o][f] = d);
        }), n[o][c] = d;
      }), n;
    }
  }]), e;
}(), Hl = [], Pr = {}, Dr = {}, jb = Object.keys(Dr);
function Pb(e, t) {
  var n = t.mixoutsTo;
  return Hl = e, Pr = {}, Object.keys(Dr).forEach(function(r) {
    jb.indexOf(r) === -1 && delete Dr[r];
  }), Hl.forEach(function(r) {
    var a = r.mixout ? r.mixout() : {};
    if (Object.keys(a).forEach(function(s) {
      typeof a[s] == "function" && (n[s] = a[s]), ji(a[s]) === "object" && Object.keys(a[s]).forEach(function(o) {
        n[s] || (n[s] = {}), n[s][o] = a[s][o];
      });
    }), r.hooks) {
      var i = r.hooks();
      Object.keys(i).forEach(function(s) {
        Pr[s] || (Pr[s] = []), Pr[s].push(i[s]);
      });
    }
    r.provides && r.provides(Dr);
  }), n;
}
function Ds(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    r[a - 2] = arguments[a];
  var i = Pr[e] || [];
  return i.forEach(function(s) {
    t = s.apply(null, [t].concat(r));
  }), t;
}
function dr(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var a = Pr[e] || [];
  a.forEach(function(i) {
    i.apply(null, n);
  });
}
function mn() {
  var e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Dr[e] ? Dr[e].apply(null, t) : void 0;
}
function Fs(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  var t = e.iconName, n = e.prefix || In();
  if (t)
    return t = Jn(n, t) || t, Fl(E6.definitions, n, t) || Fl(Ot.styles, n, t);
}
var E6 = new kb(), Ab = function() {
  oe.autoReplaceSvg = !1, oe.observeMutations = !1, dr("noAuto");
}, $b = {
  i2svg: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return bn ? (dr("beforeI2svg", t), mn("pseudoElements2svg", t), mn("i2svg", t)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot;
    oe.autoReplaceSvg === !1 && (oe.autoReplaceSvg = !0), oe.observeMutations = !0, xb(function() {
      Ob({
        autoReplaceSvgRoot: n
      }), dr("watch", t);
    });
  }
}, Ib = {
  icon: function(t) {
    if (t === null)
      return null;
    if (ji(t) === "object" && t.prefix && t.iconName)
      return {
        prefix: t.prefix,
        iconName: Jn(t.prefix, t.iconName) || t.iconName
      };
    if (Array.isArray(t) && t.length === 2) {
      var n = t[1].indexOf("fa-") === 0 ? t[1].slice(3) : t[1], r = t1(t[0]);
      return {
        prefix: r,
        iconName: Jn(r, n) || n
      };
    }
    if (typeof t == "string" && (t.indexOf("".concat(oe.cssPrefix, "-")) > -1 || t.match(nb))) {
      var a = n1(t.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: a.prefix || In(),
        iconName: Jn(a.prefix, a.iconName) || a.iconName
      };
    }
    if (typeof t == "string") {
      var i = In();
      return {
        prefix: i,
        iconName: Jn(i, t) || t
      };
    }
  }
}, yt = {
  noAuto: Ab,
  config: oe,
  dom: $b,
  parse: Ib,
  library: E6,
  findIconDefinition: Fs,
  toHtml: ja
}, Ob = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot, r = n === void 0 ? Re : n;
  (Object.keys(Ot.styles).length > 0 || oe.autoFetchSvg) && bn && oe.autoReplaceSvg && yt.dom.i2svg({
    node: r
  });
};
function r1(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map(function(r) {
        return ja(r);
      });
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (bn) {
        var r = Re.createElement("div");
        return r.innerHTML = e.html, r.children;
      }
    }
  }), e;
}
function Rb(e) {
  var t = e.children, n = e.main, r = e.mask, a = e.attributes, i = e.styles, s = e.transform;
  if (Xo(s) && n.found && !r.found) {
    var o = n.width, c = n.height, d = {
      x: o / c / 2,
      y: 0.5
    };
    a.style = e1(te(te({}, i), {}, {
      "transform-origin": "".concat(d.x + s.x / 16, "em ").concat(d.y + s.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: a,
    children: t
  }];
}
function Db(e) {
  var t = e.prefix, n = e.iconName, r = e.children, a = e.attributes, i = e.symbol, s = i === !0 ? "".concat(t, "-").concat(oe.cssPrefix, "-").concat(n) : i;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: te(te({}, a), {}, {
        id: s
      }),
      children: r
    }]
  }];
}
function ec(e) {
  var t = e.icons, n = t.main, r = t.mask, a = e.prefix, i = e.iconName, s = e.transform, o = e.symbol, c = e.title, d = e.maskId, u = e.titleId, f = e.extra, p = e.watchable, h = p === void 0 ? !1 : p, g = r.found ? r : n, v = g.width, x = g.height, m = a === "fak", b = [oe.replacementClass, i ? "".concat(oe.cssPrefix, "-").concat(i) : ""].filter(function(T) {
    return f.classes.indexOf(T) === -1;
  }).filter(function(T) {
    return T !== "" || !!T;
  }).concat(f.classes).join(" "), _ = {
    children: [],
    attributes: te(te({}, f.attributes), {}, {
      "data-prefix": a,
      "data-icon": i,
      class: b,
      role: f.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(v, " ").concat(x)
    })
  }, C = m && !~f.classes.indexOf("fa-fw") ? {
    width: "".concat(v / x * 16 * 0.0625, "em")
  } : {};
  h && (_.attributes[lr] = ""), c && (_.children.push({
    tag: "title",
    attributes: {
      id: _.attributes["aria-labelledby"] || "title-".concat(u || Sa())
    },
    children: [c]
  }), delete _.attributes.title);
  var w = te(te({}, _), {}, {
    prefix: a,
    iconName: i,
    main: n,
    mask: r,
    maskId: d,
    transform: s,
    symbol: o,
    styles: te(te({}, C), f.styles)
  }), N = r.found && n.found ? mn("generateAbstractMask", w) || {
    children: [],
    attributes: {}
  } : mn("generateAbstractIcon", w) || {
    children: [],
    attributes: {}
  }, M = N.children, S = N.attributes;
  return w.children = M, w.attributes = S, o ? Db(w) : Rb(w);
}
function ql(e) {
  var t = e.content, n = e.width, r = e.height, a = e.transform, i = e.title, s = e.extra, o = e.watchable, c = o === void 0 ? !1 : o, d = te(te(te({}, s.attributes), i ? {
    title: i
  } : {}), {}, {
    class: s.classes.join(" ")
  });
  c && (d[lr] = "");
  var u = te({}, s.styles);
  Xo(a) && (u.transform = gb({
    transform: a,
    startCentered: !0,
    width: n,
    height: r
  }), u["-webkit-transform"] = u.transform);
  var f = e1(u);
  f.length > 0 && (d.style = f);
  var p = [];
  return p.push({
    tag: "span",
    attributes: d,
    children: [t]
  }), i && p.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), p;
}
function Fb(e) {
  var t = e.content, n = e.title, r = e.extra, a = te(te(te({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), i = e1(r.styles);
  i.length > 0 && (a.style = i);
  var s = [];
  return s.push({
    tag: "span",
    attributes: a,
    children: [t]
  }), n && s.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), s;
}
var F1 = Ot.styles;
function Bs(e) {
  var t = e[0], n = e[1], r = e.slice(4), a = qo(r, 1), i = a[0], s = null;
  return Array.isArray(i) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(oe.cssPrefix, "-").concat(Qn.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(oe.cssPrefix, "-").concat(Qn.SECONDARY),
        fill: "currentColor",
        d: i[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(oe.cssPrefix, "-").concat(Qn.PRIMARY),
        fill: "currentColor",
        d: i[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: i
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: s
  };
}
var Bb = {
  found: !1,
  width: 512,
  height: 512
};
function Vb(e, t) {
  !h6 && !oe.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function Vs(e, t) {
  var n = t;
  return t === "fa" && oe.styleDefault !== null && (t = In()), new Promise(function(r, a) {
    if (mn("missingIconAbstract"), n === "fa") {
      var i = z6(e) || {};
      e = i.iconName || e, t = i.prefix || t;
    }
    if (e && t && F1[t] && F1[t][e]) {
      var s = F1[t][e];
      return r(Bs(s));
    }
    Vb(e, t), r(te(te({}, Bb), {}, {
      icon: oe.showMissingIcons && e ? mn("missingIconAbstract") || {} : {}
    }));
  });
}
var Wl = function() {
}, Hs = oe.measurePerformance && ni && ni.mark && ni.measure ? ni : {
  mark: Wl,
  measure: Wl
}, la = 'FA "6.5.2"', Hb = function(t) {
  return Hs.mark("".concat(la, " ").concat(t, " begins")), function() {
    return T6(t);
  };
}, T6 = function(t) {
  Hs.mark("".concat(la, " ").concat(t, " ends")), Hs.measure("".concat(la, " ").concat(t), "".concat(la, " ").concat(t, " begins"), "".concat(la, " ").concat(t, " ends"));
}, tc = {
  begin: Hb,
  end: T6
}, mi = function() {
};
function Ul(e) {
  var t = e.getAttribute ? e.getAttribute(lr) : null;
  return typeof t == "string";
}
function qb(e) {
  var t = e.getAttribute ? e.getAttribute(Uo) : null, n = e.getAttribute ? e.getAttribute(Go) : null;
  return t && n;
}
function Wb(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(oe.replacementClass);
}
function Ub() {
  if (oe.autoReplaceSvg === !0)
    return hi.replace;
  var e = hi[oe.autoReplaceSvg];
  return e || hi.replace;
}
function Gb(e) {
  return Re.createElementNS("http://www.w3.org/2000/svg", e);
}
function Yb(e) {
  return Re.createElement(e);
}
function k6(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.ceFn, r = n === void 0 ? e.tag === "svg" ? Gb : Yb : n;
  if (typeof e == "string")
    return Re.createTextNode(e);
  var a = r(e.tag);
  Object.keys(e.attributes || []).forEach(function(s) {
    a.setAttribute(s, e.attributes[s]);
  });
  var i = e.children || [];
  return i.forEach(function(s) {
    a.appendChild(k6(s, {
      ceFn: r
    }));
  }), a;
}
function Kb(e) {
  var t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
var hi = {
  replace: function(t) {
    var n = t[0];
    if (n.parentNode)
      if (t[1].forEach(function(a) {
        n.parentNode.insertBefore(k6(a), n);
      }), n.getAttribute(lr) === null && oe.keepOriginalSource) {
        var r = Re.createComment(Kb(n));
        n.parentNode.replaceChild(r, n);
      } else
        n.remove();
  },
  nest: function(t) {
    var n = t[0], r = t[1];
    if (~Ko(n).indexOf(oe.replacementClass))
      return hi.replace(t);
    var a = new RegExp("".concat(oe.cssPrefix, "-.*"));
    if (delete r[0].attributes.id, r[0].attributes.class) {
      var i = r[0].attributes.class.split(" ").reduce(function(o, c) {
        return c === oe.replacementClass || c.match(a) ? o.toSvg.push(c) : o.toNode.push(c), o;
      }, {
        toNode: [],
        toSvg: []
      });
      r[0].attributes.class = i.toSvg.join(" "), i.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", i.toNode.join(" "));
    }
    var s = r.map(function(o) {
      return ja(o);
    }).join(`
`);
    n.setAttribute(lr, ""), n.innerHTML = s;
  }
};
function Gl(e) {
  e();
}
function j6(e, t) {
  var n = typeof t == "function" ? t : mi;
  if (e.length === 0)
    n();
  else {
    var r = Gl;
    oe.mutateApproach === Jv && (r = $n.requestAnimationFrame || Gl), r(function() {
      var a = Ub(), i = tc.begin("mutate");
      e.map(a), i(), n();
    });
  }
}
var nc = !1;
function P6() {
  nc = !0;
}
function qs() {
  nc = !1;
}
var Ai = null;
function Yl(e) {
  if (Ol && oe.observeMutations) {
    var t = e.treeCallback, n = t === void 0 ? mi : t, r = e.nodeCallback, a = r === void 0 ? mi : r, i = e.pseudoElementsCallback, s = i === void 0 ? mi : i, o = e.observeMutationsRoot, c = o === void 0 ? Re : o;
    Ai = new Ol(function(d) {
      if (!nc) {
        var u = In();
        Jr(d).forEach(function(f) {
          if (f.type === "childList" && f.addedNodes.length > 0 && !Ul(f.addedNodes[0]) && (oe.searchPseudoElements && s(f.target), n(f.target)), f.type === "attributes" && f.target.parentNode && oe.searchPseudoElements && s(f.target.parentNode), f.type === "attributes" && Ul(f.target) && ~sb.indexOf(f.attributeName))
            if (f.attributeName === "class" && qb(f.target)) {
              var p = n1(Ko(f.target)), h = p.prefix, g = p.iconName;
              f.target.setAttribute(Uo, h || u), g && f.target.setAttribute(Go, g);
            } else
              Wb(f.target) && a(f.target);
        });
      }
    }), bn && Ai.observe(c, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function Xb() {
  Ai && Ai.disconnect();
}
function Zb(e) {
  var t = e.getAttribute("style"), n = [];
  return t && (n = t.split(";").reduce(function(r, a) {
    var i = a.split(":"), s = i[0], o = i.slice(1);
    return s && o.length > 0 && (r[s] = o.join(":").trim()), r;
  }, {})), n;
}
function Qb(e) {
  var t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "", a = n1(Ko(e));
  return a.prefix || (a.prefix = In()), t && n && (a.prefix = t, a.iconName = n), a.iconName && a.prefix || (a.prefix && r.length > 0 && (a.iconName = Eb(a.prefix, e.innerText) || Qo(a.prefix, Os(e.innerText))), !a.iconName && oe.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = e.firstChild.data)), a;
}
function Jb(e) {
  var t = Jr(e.attributes).reduce(function(a, i) {
    return a.name !== "class" && a.name !== "style" && (a[i.name] = i.value), a;
  }, {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return oe.autoA11y && (n ? t["aria-labelledby"] = "".concat(oe.replacementClass, "-title-").concat(r || Sa()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function ey() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Ht,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Kl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, n = Qb(e), r = n.iconName, a = n.prefix, i = n.rest, s = Jb(e), o = Ds("parseNodeAttributes", {}, e), c = t.styleParser ? Zb(e) : [];
  return te({
    iconName: r,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: Ht,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: c,
      attributes: s
    }
  }, o);
}
var ty = Ot.styles;
function A6(e) {
  var t = oe.autoReplaceSvg === "nest" ? Kl(e, {
    styleParser: !1
  }) : Kl(e);
  return ~t.extra.classes.indexOf(g6) ? mn("generateLayersText", e, t) : mn("generateSvgReplacementMutation", e, t);
}
var On = /* @__PURE__ */ new Set();
Yo.map(function(e) {
  On.add("fa-".concat(e));
});
Object.keys(xa[Oe]).map(On.add.bind(On));
Object.keys(xa[Ve]).map(On.add.bind(On));
On = Ta(On);
function Xl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!bn)
    return Promise.resolve();
  var n = Re.documentElement.classList, r = function(f) {
    return n.add("".concat(Rl, "-").concat(f));
  }, a = function(f) {
    return n.remove("".concat(Rl, "-").concat(f));
  }, i = oe.autoFetchSvg ? On : Yo.map(function(u) {
    return "fa-".concat(u);
  }).concat(Object.keys(ty));
  i.includes("fa") || i.push("fa");
  var s = [".".concat(g6, ":not([").concat(lr, "])")].concat(i.map(function(u) {
    return ".".concat(u, ":not([").concat(lr, "])");
  })).join(", ");
  if (s.length === 0)
    return Promise.resolve();
  var o = [];
  try {
    o = Jr(e.querySelectorAll(s));
  } catch {
  }
  if (o.length > 0)
    r("pending"), a("complete");
  else
    return Promise.resolve();
  var c = tc.begin("onTree"), d = o.reduce(function(u, f) {
    try {
      var p = A6(f);
      p && u.push(p);
    } catch (h) {
      h6 || h.name === "MissingIcon" && console.error(h);
    }
    return u;
  }, []);
  return new Promise(function(u, f) {
    Promise.all(d).then(function(p) {
      j6(p, function() {
        r("active"), r("complete"), a("pending"), typeof t == "function" && t(), c(), u();
      });
    }).catch(function(p) {
      c(), f(p);
    });
  });
}
function ny(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  A6(e).then(function(n) {
    n && j6([n], t);
  });
}
function ry(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (t || {}).icon ? t : Fs(t || {}), a = n.mask;
    return a && (a = (a || {}).icon ? a : Fs(a || {})), e(r, te(te({}, n), {}, {
      mask: a
    }));
  };
}
var ay = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.transform, a = r === void 0 ? Ht : r, i = n.symbol, s = i === void 0 ? !1 : i, o = n.mask, c = o === void 0 ? null : o, d = n.maskId, u = d === void 0 ? null : d, f = n.title, p = f === void 0 ? null : f, h = n.titleId, g = h === void 0 ? null : h, v = n.classes, x = v === void 0 ? [] : v, m = n.attributes, b = m === void 0 ? {} : m, _ = n.styles, C = _ === void 0 ? {} : _;
  if (t) {
    var w = t.prefix, N = t.iconName, M = t.icon;
    return r1(te({
      type: "icon"
    }, t), function() {
      return dr("beforeDOMElementCreation", {
        iconDefinition: t,
        params: n
      }), oe.autoA11y && (p ? b["aria-labelledby"] = "".concat(oe.replacementClass, "-title-").concat(g || Sa()) : (b["aria-hidden"] = "true", b.focusable = "false")), ec({
        icons: {
          main: Bs(M),
          mask: c ? Bs(c.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: w,
        iconName: N,
        transform: te(te({}, Ht), a),
        symbol: s,
        title: p,
        maskId: u,
        titleId: g,
        extra: {
          attributes: b,
          styles: C,
          classes: x
        }
      });
    });
  }
}, iy = {
  mixout: function() {
    return {
      icon: ry(ay)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.treeCallback = Xl, n.nodeCallback = ny, n;
      }
    };
  },
  provides: function(t) {
    t.i2svg = function(n) {
      var r = n.node, a = r === void 0 ? Re : r, i = n.callback, s = i === void 0 ? function() {
      } : i;
      return Xl(a, s);
    }, t.generateSvgReplacementMutation = function(n, r) {
      var a = r.iconName, i = r.title, s = r.titleId, o = r.prefix, c = r.transform, d = r.symbol, u = r.mask, f = r.maskId, p = r.extra;
      return new Promise(function(h, g) {
        Promise.all([Vs(a, o), u.iconName ? Vs(u.iconName, u.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(v) {
          var x = qo(v, 2), m = x[0], b = x[1];
          h([n, ec({
            icons: {
              main: m,
              mask: b
            },
            prefix: o,
            iconName: a,
            transform: c,
            symbol: d,
            maskId: f,
            title: i,
            titleId: s,
            extra: p,
            watchable: !0
          })]);
        }).catch(g);
      });
    }, t.generateAbstractIcon = function(n) {
      var r = n.children, a = n.attributes, i = n.main, s = n.transform, o = n.styles, c = e1(o);
      c.length > 0 && (a.style = c);
      var d;
      return Xo(s) && (d = mn("generateAbstractTransformGrouping", {
        main: i,
        transform: s,
        containerWidth: i.width,
        iconWidth: i.width
      })), r.push(d || i.icon), {
        children: r,
        attributes: a
      };
    };
  }
}, sy = {
  mixout: function() {
    return {
      layer: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.classes, i = a === void 0 ? [] : a;
        return r1({
          type: "layer"
        }, function() {
          dr("beforeDOMElementCreation", {
            assembler: n,
            params: r
          });
          var s = [];
          return n(function(o) {
            Array.isArray(o) ? o.map(function(c) {
              s = s.concat(c.abstract);
            }) : s = s.concat(o.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(oe.cssPrefix, "-layers")].concat(Ta(i)).join(" ")
            },
            children: s
          }];
        });
      }
    };
  }
}, oy = {
  mixout: function() {
    return {
      counter: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.title, i = a === void 0 ? null : a, s = r.classes, o = s === void 0 ? [] : s, c = r.attributes, d = c === void 0 ? {} : c, u = r.styles, f = u === void 0 ? {} : u;
        return r1({
          type: "counter",
          content: n
        }, function() {
          return dr("beforeDOMElementCreation", {
            content: n,
            params: r
          }), Fb({
            content: n.toString(),
            title: i,
            extra: {
              attributes: d,
              styles: f,
              classes: ["".concat(oe.cssPrefix, "-layers-counter")].concat(Ta(o))
            }
          });
        });
      }
    };
  }
}, cy = {
  mixout: function() {
    return {
      text: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.transform, i = a === void 0 ? Ht : a, s = r.title, o = s === void 0 ? null : s, c = r.classes, d = c === void 0 ? [] : c, u = r.attributes, f = u === void 0 ? {} : u, p = r.styles, h = p === void 0 ? {} : p;
        return r1({
          type: "text",
          content: n
        }, function() {
          return dr("beforeDOMElementCreation", {
            content: n,
            params: r
          }), ql({
            content: n,
            transform: te(te({}, Ht), i),
            title: o,
            extra: {
              attributes: f,
              styles: h,
              classes: ["".concat(oe.cssPrefix, "-layers-text")].concat(Ta(d))
            }
          });
        });
      }
    };
  },
  provides: function(t) {
    t.generateLayersText = function(n, r) {
      var a = r.title, i = r.transform, s = r.extra, o = null, c = null;
      if (f6) {
        var d = parseInt(getComputedStyle(n).fontSize, 10), u = n.getBoundingClientRect();
        o = u.width / d, c = u.height / d;
      }
      return oe.autoA11y && !a && (s.attributes["aria-hidden"] = "true"), Promise.resolve([n, ql({
        content: n.innerHTML,
        width: o,
        height: c,
        transform: i,
        title: a,
        extra: s,
        watchable: !0
      })]);
    };
  }
}, ly = new RegExp('"', "ug"), Zl = [1105920, 1112319];
function dy(e) {
  var t = e.replace(ly, ""), n = Cb(t, 0), r = n >= Zl[0] && n <= Zl[1], a = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: Os(a ? t[0] : t),
    isSecondary: r || a
  };
}
function Ql(e, t) {
  var n = "".concat(Qv).concat(t.replace(":", "-"));
  return new Promise(function(r, a) {
    if (e.getAttribute(n) !== null)
      return r();
    var i = Jr(e.children), s = i.filter(function(M) {
      return M.getAttribute(Is) === t;
    })[0], o = $n.getComputedStyle(e, t), c = o.getPropertyValue("font-family").match(rb), d = o.getPropertyValue("font-weight"), u = o.getPropertyValue("content");
    if (s && !c)
      return e.removeChild(s), r();
    if (c && u !== "none" && u !== "") {
      var f = o.getPropertyValue("content"), p = ~["Sharp"].indexOf(c[2]) ? Ve : Oe, h = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(c[2]) ? _a[p][c[2].toLowerCase()] : ab[p][d], g = dy(f), v = g.value, x = g.isSecondary, m = c[0].startsWith("FontAwesome"), b = Qo(h, v), _ = b;
      if (m) {
        var C = Tb(v);
        C.iconName && C.prefix && (b = C.iconName, h = C.prefix);
      }
      if (b && !x && (!s || s.getAttribute(Uo) !== h || s.getAttribute(Go) !== _)) {
        e.setAttribute(n, _), s && e.removeChild(s);
        var w = ey(), N = w.extra;
        N.attributes[Is] = t, Vs(b, h).then(function(M) {
          var S = ec(te(te({}, w), {}, {
            icons: {
              main: M,
              mask: Jo()
            },
            prefix: h,
            iconName: _,
            extra: N,
            watchable: !0
          })), T = Re.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(T, e.firstChild) : e.appendChild(T), T.outerHTML = S.map(function(j) {
            return ja(j);
          }).join(`
`), e.removeAttribute(n), r();
        }).catch(a);
      } else
        r();
    } else
      r();
  });
}
function uy(e) {
  return Promise.all([Ql(e, "::before"), Ql(e, "::after")]);
}
function fy(e) {
  return e.parentNode !== document.head && !~eb.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Is) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function Jl(e) {
  if (bn)
    return new Promise(function(t, n) {
      var r = Jr(e.querySelectorAll("*")).filter(fy).map(uy), a = tc.begin("searchPseudoElements");
      P6(), Promise.all(r).then(function() {
        a(), qs(), t();
      }).catch(function() {
        a(), qs(), n();
      });
    });
}
var py = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.pseudoElementsCallback = Jl, n;
      }
    };
  },
  provides: function(t) {
    t.pseudoElements2svg = function(n) {
      var r = n.node, a = r === void 0 ? Re : r;
      oe.searchPseudoElements && Jl(a);
    };
  }
}, e2 = !1, my = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          P6(), e2 = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        Yl(Ds("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        Xb();
      },
      watch: function(n) {
        var r = n.observeMutationsRoot;
        e2 ? qs() : Yl(Ds("mutationObserverCallbacks", {
          observeMutationsRoot: r
        }));
      }
    };
  }
}, t2 = function(t) {
  var n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return t.toLowerCase().split(" ").reduce(function(r, a) {
    var i = a.toLowerCase().split("-"), s = i[0], o = i.slice(1).join("-");
    if (s && o === "h")
      return r.flipX = !0, r;
    if (s && o === "v")
      return r.flipY = !0, r;
    if (o = parseFloat(o), isNaN(o))
      return r;
    switch (s) {
      case "grow":
        r.size = r.size + o;
        break;
      case "shrink":
        r.size = r.size - o;
        break;
      case "left":
        r.x = r.x - o;
        break;
      case "right":
        r.x = r.x + o;
        break;
      case "up":
        r.y = r.y - o;
        break;
      case "down":
        r.y = r.y + o;
        break;
      case "rotate":
        r.rotate = r.rotate + o;
        break;
    }
    return r;
  }, n);
}, hy = {
  mixout: function() {
    return {
      parse: {
        transform: function(n) {
          return t2(n);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var a = r.getAttribute("data-fa-transform");
        return a && (n.transform = t2(a)), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractTransformGrouping = function(n) {
      var r = n.main, a = n.transform, i = n.containerWidth, s = n.iconWidth, o = {
        transform: "translate(".concat(i / 2, " 256)")
      }, c = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), d = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), u = "rotate(".concat(a.rotate, " 0 0)"), f = {
        transform: "".concat(c, " ").concat(d, " ").concat(u)
      }, p = {
        transform: "translate(".concat(s / 2 * -1, " -256)")
      }, h = {
        outer: o,
        inner: f,
        path: p
      };
      return {
        tag: "g",
        attributes: te({}, h.outer),
        children: [{
          tag: "g",
          attributes: te({}, h.inner),
          children: [{
            tag: r.icon.tag,
            children: r.icon.children,
            attributes: te(te({}, r.icon.attributes), h.path)
          }]
        }]
      };
    };
  }
}, B1 = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function n2(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function gy(e) {
  return e.tag === "g" ? e.children : [e];
}
var vy = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var a = r.getAttribute("data-fa-mask"), i = a ? n1(a.split(" ").map(function(s) {
          return s.trim();
        })) : Jo();
        return i.prefix || (i.prefix = In()), n.mask = i, n.maskId = r.getAttribute("data-fa-mask-id"), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractMask = function(n) {
      var r = n.children, a = n.attributes, i = n.main, s = n.mask, o = n.maskId, c = n.transform, d = i.width, u = i.icon, f = s.width, p = s.icon, h = hb({
        transform: c,
        containerWidth: f,
        iconWidth: d
      }), g = {
        tag: "rect",
        attributes: te(te({}, B1), {}, {
          fill: "white"
        })
      }, v = u.children ? {
        children: u.children.map(n2)
      } : {}, x = {
        tag: "g",
        attributes: te({}, h.inner),
        children: [n2(te({
          tag: u.tag,
          attributes: te(te({}, u.attributes), h.path)
        }, v))]
      }, m = {
        tag: "g",
        attributes: te({}, h.outer),
        children: [x]
      }, b = "mask-".concat(o || Sa()), _ = "clip-".concat(o || Sa()), C = {
        tag: "mask",
        attributes: te(te({}, B1), {}, {
          id: b,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [g, m]
      }, w = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: _
          },
          children: gy(p)
        }, C]
      };
      return r.push(w, {
        tag: "rect",
        attributes: te({
          fill: "currentColor",
          "clip-path": "url(#".concat(_, ")"),
          mask: "url(#".concat(b, ")")
        }, B1)
      }), {
        children: r,
        attributes: a
      };
    };
  }
}, by = {
  provides: function(t) {
    var n = !1;
    $n.matchMedia && (n = $n.matchMedia("(prefers-reduced-motion: reduce)").matches), t.missingIconAbstract = function() {
      var r = [], a = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      r.push({
        tag: "path",
        attributes: te(te({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var s = te(te({}, i), {}, {
        attributeName: "opacity"
      }), o = {
        tag: "circle",
        attributes: te(te({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || o.children.push({
        tag: "animate",
        attributes: te(te({}, i), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: te(te({}, s), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), r.push(o), r.push({
        tag: "path",
        attributes: te(te({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: te(te({}, s), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || r.push({
        tag: "path",
        attributes: te(te({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: te(te({}, s), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: r
      };
    };
  }
}, yy = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var a = r.getAttribute("data-fa-symbol"), i = a === null ? !1 : a === "" ? !0 : a;
        return n.symbol = i, n;
      }
    };
  }
}, xy = [bb, iy, sy, oy, cy, py, my, hy, vy, by, yy];
Pb(xy, {
  mixoutsTo: yt
});
yt.noAuto;
var _y = yt.config;
yt.library;
yt.dom;
var Ws = yt.parse;
yt.findIconDefinition;
yt.toHtml;
var wy = yt.icon;
yt.layer;
yt.text;
yt.counter;
var Us = { exports: {} }, ui = { exports: {} }, ke = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var r2;
function Cy() {
  if (r2)
    return ke;
  r2 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function _(w) {
    if (typeof w == "object" && w !== null) {
      var N = w.$$typeof;
      switch (N) {
        case t:
          switch (w = w.type, w) {
            case c:
            case d:
            case r:
            case i:
            case a:
            case f:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case o:
                case u:
                case g:
                case h:
                case s:
                  return w;
                default:
                  return N;
              }
          }
        case n:
          return N;
      }
    }
  }
  function C(w) {
    return _(w) === d;
  }
  return ke.AsyncMode = c, ke.ConcurrentMode = d, ke.ContextConsumer = o, ke.ContextProvider = s, ke.Element = t, ke.ForwardRef = u, ke.Fragment = r, ke.Lazy = g, ke.Memo = h, ke.Portal = n, ke.Profiler = i, ke.StrictMode = a, ke.Suspense = f, ke.isAsyncMode = function(w) {
    return C(w) || _(w) === c;
  }, ke.isConcurrentMode = C, ke.isContextConsumer = function(w) {
    return _(w) === o;
  }, ke.isContextProvider = function(w) {
    return _(w) === s;
  }, ke.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, ke.isForwardRef = function(w) {
    return _(w) === u;
  }, ke.isFragment = function(w) {
    return _(w) === r;
  }, ke.isLazy = function(w) {
    return _(w) === g;
  }, ke.isMemo = function(w) {
    return _(w) === h;
  }, ke.isPortal = function(w) {
    return _(w) === n;
  }, ke.isProfiler = function(w) {
    return _(w) === i;
  }, ke.isStrictMode = function(w) {
    return _(w) === a;
  }, ke.isSuspense = function(w) {
    return _(w) === f;
  }, ke.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === d || w === i || w === a || w === f || w === p || typeof w == "object" && w !== null && (w.$$typeof === g || w.$$typeof === h || w.$$typeof === s || w.$$typeof === o || w.$$typeof === u || w.$$typeof === x || w.$$typeof === m || w.$$typeof === b || w.$$typeof === v);
  }, ke.typeOf = _, ke;
}
var je = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a2;
function Sy() {
  return a2 || (a2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function _(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === r || L === d || L === i || L === a || L === f || L === p || typeof L == "object" && L !== null && (L.$$typeof === g || L.$$typeof === h || L.$$typeof === s || L.$$typeof === o || L.$$typeof === u || L.$$typeof === x || L.$$typeof === m || L.$$typeof === b || L.$$typeof === v);
    }
    function C(L) {
      if (typeof L == "object" && L !== null) {
        var B = L.$$typeof;
        switch (B) {
          case t:
            var ce = L.type;
            switch (ce) {
              case c:
              case d:
              case r:
              case i:
              case a:
              case f:
                return ce;
              default:
                var _e = ce && ce.$$typeof;
                switch (_e) {
                  case o:
                  case u:
                  case g:
                  case h:
                  case s:
                    return _e;
                  default:
                    return B;
                }
            }
          case n:
            return B;
        }
      }
    }
    var w = c, N = d, M = o, S = s, T = t, j = u, D = r, A = g, k = h, $ = n, R = i, F = a, P = f, I = !1;
    function H(L) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(L) || C(L) === c;
    }
    function O(L) {
      return C(L) === d;
    }
    function W(L) {
      return C(L) === o;
    }
    function se(L) {
      return C(L) === s;
    }
    function ue(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function ee(L) {
      return C(L) === u;
    }
    function ae(L) {
      return C(L) === r;
    }
    function ie(L) {
      return C(L) === g;
    }
    function U(L) {
      return C(L) === h;
    }
    function J(L) {
      return C(L) === n;
    }
    function fe(L) {
      return C(L) === i;
    }
    function Z(L) {
      return C(L) === a;
    }
    function be(L) {
      return C(L) === f;
    }
    je.AsyncMode = w, je.ConcurrentMode = N, je.ContextConsumer = M, je.ContextProvider = S, je.Element = T, je.ForwardRef = j, je.Fragment = D, je.Lazy = A, je.Memo = k, je.Portal = $, je.Profiler = R, je.StrictMode = F, je.Suspense = P, je.isAsyncMode = H, je.isConcurrentMode = O, je.isContextConsumer = W, je.isContextProvider = se, je.isElement = ue, je.isForwardRef = ee, je.isFragment = ae, je.isLazy = ie, je.isMemo = U, je.isPortal = J, je.isProfiler = fe, je.isStrictMode = Z, je.isSuspense = be, je.isValidElementType = _, je.typeOf = C;
  }()), je;
}
var i2;
function $6() {
  return i2 || (i2 = 1, process.env.NODE_ENV === "production" ? ui.exports = Cy() : ui.exports = Sy()), ui.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var V1, s2;
function Ly() {
  if (s2)
    return V1;
  s2 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, o = 0; o < 10; o++)
        s["_" + String.fromCharCode(o)] = o;
      var c = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        d[u] = u;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return V1 = a() ? Object.assign : function(i, s) {
    for (var o, c = r(i), d, u = 1; u < arguments.length; u++) {
      o = Object(arguments[u]);
      for (var f in o)
        t.call(o, f) && (c[f] = o[f]);
      if (e) {
        d = e(o);
        for (var p = 0; p < d.length; p++)
          n.call(o, d[p]) && (c[d[p]] = o[d[p]]);
      }
    }
    return c;
  }, V1;
}
var H1, o2;
function rc() {
  if (o2)
    return H1;
  o2 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return H1 = e, H1;
}
var q1, c2;
function I6() {
  return c2 || (c2 = 1, q1 = Function.call.bind(Object.prototype.hasOwnProperty)), q1;
}
var W1, l2;
function My() {
  if (l2)
    return W1;
  l2 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = rc(), n = {}, r = I6();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function a(i, s, o, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var f;
          try {
            if (typeof i[u] != "function") {
              var p = Error(
                (c || "React class") + ": " + o + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = i[u](s, u, c, o, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + o + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var h = d ? d() : "";
            e(
              "Failed " + o + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, W1 = a, W1;
}
var U1, d2;
function Ny() {
  if (d2)
    return U1;
  d2 = 1;
  var e = $6(), t = Ly(), n = rc(), r = I6(), a = My(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(o) {
    var c = "Warning: " + o;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return U1 = function(o, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(O) {
      var W = O && (d && O[d] || O[u]);
      if (typeof W == "function")
        return W;
    }
    var p = "<<anonymous>>", h = {
      array: m("array"),
      bigint: m("bigint"),
      bool: m("boolean"),
      func: m("function"),
      number: m("number"),
      object: m("object"),
      string: m("string"),
      symbol: m("symbol"),
      any: b(),
      arrayOf: _,
      element: C(),
      elementType: w(),
      instanceOf: N,
      node: j(),
      objectOf: S,
      oneOf: M,
      oneOfType: T,
      shape: A,
      exact: k
    };
    function g(O, W) {
      return O === W ? O !== 0 || 1 / O === 1 / W : O !== O && W !== W;
    }
    function v(O, W) {
      this.message = O, this.data = W && typeof W == "object" ? W : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function x(O) {
      if (process.env.NODE_ENV !== "production")
        var W = {}, se = 0;
      function ue(ae, ie, U, J, fe, Z, be) {
        if (J = J || p, Z = Z || U, be !== n) {
          if (c) {
            var L = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw L.name = "Invariant Violation", L;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var B = J + ":" + U;
            !W[B] && // Avoid spamming the console because they are often not actionable except for lib authors
            se < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Z + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), W[B] = !0, se++);
          }
        }
        return ie[U] == null ? ae ? ie[U] === null ? new v("The " + fe + " `" + Z + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new v("The " + fe + " `" + Z + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : O(ie, U, J, fe, Z);
      }
      var ee = ue.bind(null, !1);
      return ee.isRequired = ue.bind(null, !0), ee;
    }
    function m(O) {
      function W(se, ue, ee, ae, ie, U) {
        var J = se[ue], fe = F(J);
        if (fe !== O) {
          var Z = P(J);
          return new v(
            "Invalid " + ae + " `" + ie + "` of type " + ("`" + Z + "` supplied to `" + ee + "`, expected ") + ("`" + O + "`."),
            { expectedType: O }
          );
        }
        return null;
      }
      return x(W);
    }
    function b() {
      return x(s);
    }
    function _(O) {
      function W(se, ue, ee, ae, ie) {
        if (typeof O != "function")
          return new v("Property `" + ie + "` of component `" + ee + "` has invalid PropType notation inside arrayOf.");
        var U = se[ue];
        if (!Array.isArray(U)) {
          var J = F(U);
          return new v("Invalid " + ae + " `" + ie + "` of type " + ("`" + J + "` supplied to `" + ee + "`, expected an array."));
        }
        for (var fe = 0; fe < U.length; fe++) {
          var Z = O(U, fe, ee, ae, ie + "[" + fe + "]", n);
          if (Z instanceof Error)
            return Z;
        }
        return null;
      }
      return x(W);
    }
    function C() {
      function O(W, se, ue, ee, ae) {
        var ie = W[se];
        if (!o(ie)) {
          var U = F(ie);
          return new v("Invalid " + ee + " `" + ae + "` of type " + ("`" + U + "` supplied to `" + ue + "`, expected a single ReactElement."));
        }
        return null;
      }
      return x(O);
    }
    function w() {
      function O(W, se, ue, ee, ae) {
        var ie = W[se];
        if (!e.isValidElementType(ie)) {
          var U = F(ie);
          return new v("Invalid " + ee + " `" + ae + "` of type " + ("`" + U + "` supplied to `" + ue + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return x(O);
    }
    function N(O) {
      function W(se, ue, ee, ae, ie) {
        if (!(se[ue] instanceof O)) {
          var U = O.name || p, J = H(se[ue]);
          return new v("Invalid " + ae + " `" + ie + "` of type " + ("`" + J + "` supplied to `" + ee + "`, expected ") + ("instance of `" + U + "`."));
        }
        return null;
      }
      return x(W);
    }
    function M(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function W(se, ue, ee, ae, ie) {
        for (var U = se[ue], J = 0; J < O.length; J++)
          if (g(U, O[J]))
            return null;
        var fe = JSON.stringify(O, function(be, L) {
          var B = P(L);
          return B === "symbol" ? String(L) : L;
        });
        return new v("Invalid " + ae + " `" + ie + "` of value `" + String(U) + "` " + ("supplied to `" + ee + "`, expected one of " + fe + "."));
      }
      return x(W);
    }
    function S(O) {
      function W(se, ue, ee, ae, ie) {
        if (typeof O != "function")
          return new v("Property `" + ie + "` of component `" + ee + "` has invalid PropType notation inside objectOf.");
        var U = se[ue], J = F(U);
        if (J !== "object")
          return new v("Invalid " + ae + " `" + ie + "` of type " + ("`" + J + "` supplied to `" + ee + "`, expected an object."));
        for (var fe in U)
          if (r(U, fe)) {
            var Z = O(U, fe, ee, ae, ie + "." + fe, n);
            if (Z instanceof Error)
              return Z;
          }
        return null;
      }
      return x(W);
    }
    function T(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var W = 0; W < O.length; W++) {
        var se = O[W];
        if (typeof se != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + I(se) + " at index " + W + "."
          ), s;
      }
      function ue(ee, ae, ie, U, J) {
        for (var fe = [], Z = 0; Z < O.length; Z++) {
          var be = O[Z], L = be(ee, ae, ie, U, J, n);
          if (L == null)
            return null;
          L.data && r(L.data, "expectedType") && fe.push(L.data.expectedType);
        }
        var B = fe.length > 0 ? ", expected one of type [" + fe.join(", ") + "]" : "";
        return new v("Invalid " + U + " `" + J + "` supplied to " + ("`" + ie + "`" + B + "."));
      }
      return x(ue);
    }
    function j() {
      function O(W, se, ue, ee, ae) {
        return $(W[se]) ? null : new v("Invalid " + ee + " `" + ae + "` supplied to " + ("`" + ue + "`, expected a ReactNode."));
      }
      return x(O);
    }
    function D(O, W, se, ue, ee) {
      return new v(
        (O || "React class") + ": " + W + " type `" + se + "." + ue + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ee + "`."
      );
    }
    function A(O) {
      function W(se, ue, ee, ae, ie) {
        var U = se[ue], J = F(U);
        if (J !== "object")
          return new v("Invalid " + ae + " `" + ie + "` of type `" + J + "` " + ("supplied to `" + ee + "`, expected `object`."));
        for (var fe in O) {
          var Z = O[fe];
          if (typeof Z != "function")
            return D(ee, ae, ie, fe, P(Z));
          var be = Z(U, fe, ee, ae, ie + "." + fe, n);
          if (be)
            return be;
        }
        return null;
      }
      return x(W);
    }
    function k(O) {
      function W(se, ue, ee, ae, ie) {
        var U = se[ue], J = F(U);
        if (J !== "object")
          return new v("Invalid " + ae + " `" + ie + "` of type `" + J + "` " + ("supplied to `" + ee + "`, expected `object`."));
        var fe = t({}, se[ue], O);
        for (var Z in fe) {
          var be = O[Z];
          if (r(O, Z) && typeof be != "function")
            return D(ee, ae, ie, Z, P(be));
          if (!be)
            return new v(
              "Invalid " + ae + " `" + ie + "` key `" + Z + "` supplied to `" + ee + "`.\nBad object: " + JSON.stringify(se[ue], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(O), null, "  ")
            );
          var L = be(U, Z, ee, ae, ie + "." + Z, n);
          if (L)
            return L;
        }
        return null;
      }
      return x(W);
    }
    function $(O) {
      switch (typeof O) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !O;
        case "object":
          if (Array.isArray(O))
            return O.every($);
          if (O === null || o(O))
            return !0;
          var W = f(O);
          if (W) {
            var se = W.call(O), ue;
            if (W !== O.entries) {
              for (; !(ue = se.next()).done; )
                if (!$(ue.value))
                  return !1;
            } else
              for (; !(ue = se.next()).done; ) {
                var ee = ue.value;
                if (ee && !$(ee[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function R(O, W) {
      return O === "symbol" ? !0 : W ? W["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && W instanceof Symbol : !1;
    }
    function F(O) {
      var W = typeof O;
      return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : R(W, O) ? "symbol" : W;
    }
    function P(O) {
      if (typeof O > "u" || O === null)
        return "" + O;
      var W = F(O);
      if (W === "object") {
        if (O instanceof Date)
          return "date";
        if (O instanceof RegExp)
          return "regexp";
      }
      return W;
    }
    function I(O) {
      var W = P(O);
      switch (W) {
        case "array":
        case "object":
          return "an " + W;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + W;
        default:
          return W;
      }
    }
    function H(O) {
      return !O.constructor || !O.constructor.name ? p : O.constructor.name;
    }
    return h.checkPropTypes = a, h.resetWarningCache = a.resetWarningCache, h.PropTypes = h, h;
  }, U1;
}
var G1, u2;
function zy() {
  if (u2)
    return G1;
  u2 = 1;
  var e = rc();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, G1 = function() {
    function r(s, o, c, d, u, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, G1;
}
if (process.env.NODE_ENV !== "production") {
  var Ey = $6(), Ty = !0;
  Us.exports = Ny()(Ey.isElement, Ty);
} else
  Us.exports = zy()();
var ky = Us.exports;
const Ce = /* @__PURE__ */ L2(ky);
function f2(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f2(Object(n), !0).forEach(function(r) {
      Ar(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f2(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $i(e) {
  "@babel/helpers - typeof";
  return $i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $i(e);
}
function Ar(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function jy(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Py(e, t) {
  if (e == null)
    return {};
  var n = jy(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Gs(e) {
  return Ay(e) || $y(e) || Iy(e) || Oy();
}
function Ay(e) {
  if (Array.isArray(e))
    return Ys(e);
}
function $y(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Iy(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ys(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ys(e, t);
  }
}
function Ys(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Oy() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ry(e) {
  var t, n = e.beat, r = e.fade, a = e.beatFade, i = e.bounce, s = e.shake, o = e.flash, c = e.spin, d = e.spinPulse, u = e.spinReverse, f = e.pulse, p = e.fixedWidth, h = e.inverse, g = e.border, v = e.listItem, x = e.flip, m = e.size, b = e.rotation, _ = e.pull, C = (t = {
    "fa-beat": n,
    "fa-fade": r,
    "fa-beat-fade": a,
    "fa-bounce": i,
    "fa-shake": s,
    "fa-flash": o,
    "fa-spin": c,
    "fa-spin-reverse": u,
    "fa-spin-pulse": d,
    "fa-pulse": f,
    "fa-fw": p,
    "fa-inverse": h,
    "fa-border": g,
    "fa-li": v,
    "fa-flip": x === !0,
    "fa-flip-horizontal": x === "horizontal" || x === "both",
    "fa-flip-vertical": x === "vertical" || x === "both"
  }, Ar(t, "fa-".concat(m), typeof m < "u" && m !== null), Ar(t, "fa-rotate-".concat(b), typeof b < "u" && b !== null && b !== 0), Ar(t, "fa-pull-".concat(_), typeof _ < "u" && _ !== null), Ar(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(C).map(function(w) {
    return C[w] ? w : null;
  }).filter(function(w) {
    return w;
  });
}
function Dy(e) {
  return e = e - 0, e === e;
}
function O6(e) {
  return Dy(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var Fy = ["style"];
function By(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Vy(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), a = O6(n.slice(0, r)), i = n.slice(r + 1).trim();
    return a.startsWith("webkit") ? t[By(a)] = i : t[a] = i, t;
  }, {});
}
function R6(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var r = (t.children || []).map(function(c) {
    return R6(e, c);
  }), a = Object.keys(t.attributes || {}).reduce(function(c, d) {
    var u = t.attributes[d];
    switch (d) {
      case "class":
        c.attrs.className = u, delete t.attributes.class;
        break;
      case "style":
        c.attrs.style = Vy(u);
        break;
      default:
        d.indexOf("aria-") === 0 || d.indexOf("data-") === 0 ? c.attrs[d.toLowerCase()] = u : c.attrs[O6(d)] = u;
    }
    return c;
  }, {
    attrs: {}
  }), i = n.style, s = i === void 0 ? {} : i, o = Py(n, Fy);
  return a.attrs.style = zn(zn({}, a.attrs.style), s), e.apply(void 0, [t.tag, zn(zn({}, a.attrs), o)].concat(Gs(r)));
}
var D6 = !1;
try {
  D6 = process.env.NODE_ENV === "production";
} catch {
}
function Hy() {
  if (!D6 && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function p2(e) {
  if (e && $i(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (Ws.icon)
    return Ws.icon(e);
  if (e === null)
    return null;
  if (e && $i(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function Y1(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? Ar({}, e, t) : {};
}
var Pa = /* @__PURE__ */ Y.forwardRef(function(e, t) {
  var n = e.icon, r = e.mask, a = e.symbol, i = e.className, s = e.title, o = e.titleId, c = e.maskId, d = p2(n), u = Y1("classes", [].concat(Gs(Ry(e)), Gs(i.split(" ")))), f = Y1("transform", typeof e.transform == "string" ? Ws.transform(e.transform) : e.transform), p = Y1("mask", p2(r)), h = wy(d, zn(zn(zn(zn({}, u), f), p), {}, {
    symbol: a,
    title: s,
    titleId: o,
    maskId: c
  }));
  if (!h)
    return Hy("Could not find icon", d), null;
  var g = h.abstract, v = {
    ref: t
  };
  return Object.keys(e).forEach(function(x) {
    Pa.defaultProps.hasOwnProperty(x) || (v[x] = e[x]);
  }), qy(g[0], v);
});
Pa.displayName = "FontAwesomeIcon";
Pa.propTypes = {
  beat: Ce.bool,
  border: Ce.bool,
  beatFade: Ce.bool,
  bounce: Ce.bool,
  className: Ce.string,
  fade: Ce.bool,
  flash: Ce.bool,
  mask: Ce.oneOfType([Ce.object, Ce.array, Ce.string]),
  maskId: Ce.string,
  fixedWidth: Ce.bool,
  inverse: Ce.bool,
  flip: Ce.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: Ce.oneOfType([Ce.object, Ce.array, Ce.string]),
  listItem: Ce.bool,
  pull: Ce.oneOf(["right", "left"]),
  pulse: Ce.bool,
  rotation: Ce.oneOf([0, 90, 180, 270]),
  shake: Ce.bool,
  size: Ce.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: Ce.bool,
  spinPulse: Ce.bool,
  spinReverse: Ce.bool,
  symbol: Ce.oneOfType([Ce.bool, Ce.string]),
  title: Ce.string,
  titleId: Ce.string,
  transform: Ce.oneOfType([Ce.string, Ce.object]),
  swapOpacity: Ce.bool
};
Pa.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var qy = R6.bind(null, Y.createElement);
const Wy = "_blue_qjkyo_222", Uy = "_teal_qjkyo_225", Gy = "_white_qjkyo_234", Be = {
  "svg-icon-base": "_svg-icon-base_qjkyo_209",
  "denim-blue": "_denim-blue_qjkyo_216",
  "wellness-blue": "_wellness-blue_qjkyo_219",
  blue: Wy,
  teal: Uy,
  "dark-teal": "_dark-teal_qjkyo_228",
  "burnt-orange": "_burnt-orange_qjkyo_231",
  white: Gy,
  "childrens-orange": "_childrens-orange_qjkyo_237",
  "childrens-green": "_childrens-green_qjkyo_240",
  "childrens-blue": "_childrens-blue_qjkyo_243",
  "childrens-purple": "_childrens-purple_qjkyo_246",
  "childrens-yellow": "_childrens-yellow_qjkyo_249",
  "white-smoke": "_white-smoke_qjkyo_252",
  "utility-info": "_utility-info_qjkyo_255",
  "utility-warning": "_utility-warning_qjkyo_258",
  "utility-negative": "_utility-negative_qjkyo_261",
  "utility-positive": "_utility-positive_qjkyo_264",
  "utility-utility": "_utility-utility_qjkyo_267"
}, m2 = De(Be["svg-icon-base"], {
  variants: {
    color: me({
      achOrange: Be["ach-orange"],
      blue: Be.blue,
      burntOrange: Be["burnt-orange"],
      cchaPurple: Be["ccha-purple"],
      childrensAlliance: Be["childrens-alliance"],
      childrensBlue: Be["childrens-blue"],
      childrensGreen: Be["childrens-green"],
      childrensOrange: Be["childrens-orange"],
      childrensPurple: Be["childrens-purple"],
      childrensYellow: Be["childrens-yellow"],
      darkTeal: Be["dark-teal"],
      denimBlue: Be["denim-blue"],
      teal: Be.teal,
      utilityInfo: Be["utility-info"],
      utilityNegative: Be["utility-negative"],
      utilityPositive: Be["utility-positive"],
      utilityUtility: Be["utility-utility"],
      utilityWarning: Be["utility-warning"],
      wellnessBlue: Be["wellness-blue"],
      white: Be.white,
      whiteSmoke: Be["white-smoke"]
    })
  }
});
var Yy = {
  prefix: "fab",
  iconName: "twitter",
  icon: [
    512,
    512,
    [],
    "f099",
    "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
  ]
}, Ky = {
  prefix: "fab",
  iconName: "youtube",
  icon: [
    576,
    512,
    [61802],
    "f167",
    "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
  ]
}, Xy = {
  prefix: "fab",
  iconName: "facebook",
  icon: [
    512,
    512,
    [62e3],
    "f09a",
    "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"
  ]
}, Zy = {
  prefix: "fab",
  iconName: "instagram",
  icon: [
    448,
    512,
    [],
    "f16d",
    "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
  ]
}, Qy = {
  prefix: "fab",
  iconName: "linkedin",
  icon: [
    448,
    512,
    [],
    "f08c",
    "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
  ]
}, Jy = {
  prefix: "fab",
  iconName: "x-twitter",
  icon: [
    512,
    512,
    [],
    "e61b",
    "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
  ]
}, ex = {
  prefix: "fab",
  iconName: "linkedin-in",
  icon: [
    448,
    512,
    [],
    "f0e1",
    "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
  ]
}, tx = {
  prefix: "far",
  iconName: "hand-holding-medical",
  icon: [
    576,
    512,
    [],
    "e05c",
    "M224 24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l56 0 0-56zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z"
  ]
}, nx = {
  prefix: "far",
  iconName: "video",
  icon: [
    576,
    512,
    ["video-camera"],
    "f03d",
    "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 33 0 190 0 33c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM528 363.4l0-214.7L416 199l0-52.6L520.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5l0 241c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L416 365.6l0-52.6 112 50.4z"
  ]
}, rx = {
  prefix: "far",
  iconName: "print",
  icon: [
    512,
    512,
    [9113, 128424, 128438],
    "f02f",
    "M112 160l0-96c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3l0 69.5 48 0 0-69.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64l0 96 48 0zm16 208l256 0 0 96-256 0 0-96zm-16-48c-17.7 0-32 14.3-32 32l-32 0 0-96c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 96-32 0c0-17.7-14.3-32-32-32l-288 0zm320 80l48 0c17.7 0 32-14.3 32-32l0-112c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64L0 368c0 17.7 14.3 32 32 32l48 0 0 80c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-80z"
  ]
}, ax = {
  prefix: "far",
  iconName: "circle-3",
  icon: [
    512,
    512,
    [],
    "e0f0",
    "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l66.3 0-50.5 46.3c-7.3 6.7-9.7 17.2-6.1 26.5s12.6 15.3 22.5 15.2l51.5-.3c20.1-.1 36.4 16.1 36.4 36.2c0 20-16.2 36.2-36.2 36.2L240 336c-13.5 0-26-7-33-18.4l-2.6-4.2c-7-11.3-21.8-14.8-33-7.8s-14.8 21.8-7.8 33l2.6 4.2C182 368.4 209.9 384 240 384l27.8 0c46.5 0 84.2-37.7 84.2-84.2c0-43.3-32.6-78.9-74.6-83.6l50.8-46.5c7.3-6.7 9.7-17.2 6.2-26.4s-12.5-15.3-22.4-15.3l-128 0z"
  ]
}, ix = {
  prefix: "far",
  iconName: "circle-2",
  icon: [
    512,
    512,
    [],
    "e0ef",
    "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM222.7 184.7c7.2-5.5 16.1-8.4 25.3-8.3l3.4 .1c20.3 .3 36.6 16.8 36.6 37.1c0 10.3-4.2 20.1-11.7 27.1L167.6 342.5c-7.2 6.7-9.5 17.2-5.9 26.3S174.2 384 184 384l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-83.3 0 64.4-60.4C326.3 259.5 336 237 336 213.5c0-46.5-37.3-84.4-83.8-85.1l-3.4-.1c-19.9-.3-39.3 6.1-55.1 18.1l-24.2 18.4c-10.5 8-12.6 23.1-4.5 33.6s23.1 12.6 33.6 4.5l24.2-18.4z"
  ]
}, sx = {
  prefix: "far",
  iconName: "circle-4",
  icon: [
    512,
    512,
    [],
    "e0f1",
    "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM223.6 129.2c12.6 4.2 19.4 17.8 15.2 30.4L201.3 272l70.7 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-104 0c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l48-144c4.2-12.6 17.8-19.4 30.4-15.2z"
  ]
}, ox = {
  prefix: "far",
  iconName: "circle-plus",
  icon: [
    512,
    512,
    ["plus-circle"],
    "f055",
    "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
  ]
}, cx = {
  prefix: "far",
  iconName: "shoe-prints",
  icon: [
    640,
    512,
    [],
    "f54b",
    "M323.7 62.6C355.1 54.7 390.3 48 416 48c41.2 0 89.8 10.6 126.5 28.9C582 96.7 592 116.3 592 128c0 9.4-5.1 21.5-35.9 33.1c-29.4 11.1-67 14.9-92.1 14.9c-34.7 0-53.5-10.4-80.2-25.7l-.7-.4c-20.6-11.8-45.1-25.8-79.1-33l0-49.1c6-1.7 12.7-3.4 19.7-5.2zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32l0 80 0 48s0 0 0 0zM128 96c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64zm67.7 353.4c-7-1.8-13.7-3.5-19.7-5.2l0-49.1c34-7.3 58.5-21.3 79.1-33l.7-.4C282.5 346.4 301.3 336 336 336c25.2 0 62.7 3.7 92.1 14.9C458.9 362.5 464 374.6 464 384c0 11.7-10 31.3-49.5 51.1C377.8 453.4 329.2 464 288 464c-25.7 0-60.9-6.7-92.3-14.6zM128 352s0 0 0 0l0 48 0 80s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM0 416c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64z"
  ]
}, lx = {
  prefix: "far",
  iconName: "user-doctor-message",
  icon: [
    640,
    512,
    ["user-md-chat"],
    "f82e",
    "M144 128a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128A128 128 0 1 1 224 0a128 128 0 1 1 0 256zm-48 96c-5.4 0-10.8 .3-16 1l0 49.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-41c-46.9 19-80 65-80 118.7l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-97.2 78.8-176 176-176l96 0c97.2 0 176 78.8 176 176l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-53.7-33.1-99.7-80-118.7l0 40.7c27.6 7.1 48 32.2 48 62l0 32c0 8.8-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0 0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-29.8 20.4-54.9 48-62l0-49c-5.2-.7-10.6-1-16-1l-96 0zm-8 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM432 0L592 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-48 0-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2l0-56-16 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z"
  ]
}, dx = lx, ux = {
  prefix: "far",
  iconName: "angles-left",
  icon: [
    512,
    512,
    [171, "angle-double-left"],
    "f100",
    "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM399 79L239 239c-9.4 9.4-9.4 24.6 0 33.9L399 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-143-143L433 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
  ]
}, fx = ux, F6 = {
  prefix: "far",
  iconName: "xmark",
  icon: [
    384,
    512,
    [215, 10005, 10006, 10060, 128473, "close", "multiply", "remove", "times"],
    "f00d",
    "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"
  ]
}, px = F6, mx = {
  prefix: "far",
  iconName: "plus",
  icon: [
    448,
    512,
    [10133, 61543, "add"],
    "2b",
    "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160L40 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0 0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160 160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0 0-160z"
  ]
}, hx = {
  prefix: "far",
  iconName: "circle-1",
  icon: [
    512,
    512,
    [],
    "e0ee",
    "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 131.2c7.4 4.3 12 12.2 12 20.8l0 184 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-142.6-20.1 11.5c-11.5 6.6-26.2 2.6-32.7-8.9s-2.6-26.2 8.9-32.7l56-32c7.4-4.2 16.6-4.2 24 .1z"
  ]
}, gx = {
  prefix: "far",
  iconName: "magnifying-glass",
  icon: [
    512,
    512,
    [128269, "search"],
    "f002",
    "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"
  ]
}, vx = {
  prefix: "far",
  iconName: "location-dot",
  icon: [
    384,
    512,
    ["map-marker-alt"],
    "f3c5",
    "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"
  ]
}, bx = vx, yx = {
  prefix: "far",
  iconName: "mobile",
  icon: [
    384,
    512,
    [128241, "mobile-android", "mobile-phone"],
    "f3ce",
    "M80 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L80 48zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM160 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
  ]
}, xx = yx, _x = {
  prefix: "far",
  iconName: "flask",
  icon: [
    448,
    512,
    [],
    "f0c3",
    "M176 196.8c0 20.7-5.8 41-16.6 58.7L119.7 320l208.6 0-39.7-64.5c-10.9-17.7-16.6-38-16.6-58.7L272 48l-96 0 0 148.8zM320 48l0 148.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4L69.4 512C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5L128 48l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L288 0l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0z"
  ]
}, wx = {
  prefix: "far",
  iconName: "sliders",
  icon: [
    512,
    512,
    ["sliders-h"],
    "f1de",
    "M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z"
  ]
}, Cx = {
  prefix: "far",
  iconName: "industry-windows",
  icon: [
    576,
    512,
    [127981, "industry-alt"],
    "f3b3",
    "M80 88c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 126.7c0 8.6 4.6 16.5 12 20.8s16.6 4.2 24-.1L320 153.8l0 70.9c0 8.8 4.8 16.8 12.5 21.1s17.1 3.9 24.5-.8l139.1-89L496 304l0 16 0 88c0 13.3-10.7 24-24 24l-368 0c-13.3 0-24-10.7-24-24l0-56 0-48L80 88zm8-56C57.1 32 32 57.1 32 88l0 216 0 48 0 56c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72l0-88 0-16 0-148.1c0-37.9-41.9-60.9-73.9-40.4L368 180.8l0-27c0-37-40.2-60.1-72.2-41.5L192 172.9 192 88c0-30.9-25.1-56-56-56L88 32zm56 264c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm104 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm136-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0z"
  ]
}, Sx = Cx, Lx = {
  prefix: "far",
  iconName: "piggy-bank",
  icon: [
    576,
    512,
    [],
    "f4d3",
    "M277.1 48c23 0 42.5 14.7 49.8 35.2c4.4 12.5 18.1 19 30.6 14.6s19-18.1 14.6-30.6C358.3 28.1 321 0 277.1 0S195.8 28.1 182 67.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6C234.5 62.7 254.1 48 277.1 48zM66.7 197.5c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-4.7 2.3C15.7 169.3 0 194.7 0 222.6c0 37.4 28 68.3 64.2 72.9C66.4 344.7 91 388.2 128 416l0 48c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-16 48 0 0 16c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-37.4c18.7-10.8 35.1-25.4 48-42.6l32 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-13.3 0c-8.2-18.8-19.9-35.7-34.2-49.8l11.3-36.8-22.9-7 22.9 7c6.3-20.6-9.1-41.4-30.6-41.4L456 96c-31.5 0-60.2 12.2-81.6 32L224 128c-74.4 0-137 50.8-154.9 119.6c-12-2-21.1-12.5-21.1-25.1c0-9.6 5.4-18.4 14.1-22.8l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM402.3 168c13.1-14.7 32.1-23.9 53.2-24L446 174.8c-2.9 9.4 .2 19.6 7.9 25.8c17.4 13.9 30.4 32.8 37.1 54.5c3.1 10.1 12.4 17 22.9 17l14 0 0 64-28.6 0c-8.3 0-16 4.3-20.3 11.3c-11.7 18.7-28.7 33.7-48.9 42.8C421.5 394 416 402.5 416 412l0 52-48 0 0-40c0-13.3-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24l0 40-48 0 0-60.6c0-8.3-4.3-16-11.3-20.3c-31.7-19.8-52.7-55-52.7-95c0-61.9 50.1-112 112-112l160 0s0 0 0 0l.4 0c6.8 0 13.4-2.9 17.9-8z"
  ]
}, Mx = {
  prefix: "far",
  iconName: "clock",
  icon: [
    512,
    512,
    [128339, "clock-four"],
    "f017",
    "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
  ]
}, Nx = {
  prefix: "far",
  iconName: "hands-asl-interpreting",
  icon: [
    640,
    512,
    ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"],
    "f2a3",
    "M186.3 55.8l-51.8 86.3c-5.8 9.6-17.4 14-28.1 10.5S89 138.6 90 127.5l5.9-61.9c.8-8.8-5.6-16.6-14.4-17.4s-16.6 5.6-17.4 14.4l-16 168-.1 .8 0 .8 0 32c0 61.9 50.1 112 112 112l48 0c31.6 0 60.5-14.5 76.2-41.6c4.4-7.7 1.8-17.4-5.8-21.9c-2.5-1.4-5.1-2.1-7.7-2.2l-.3 0-.3 0c-5.5 .1-10.7 3-13.6 8C247.4 334.1 230 344 208 344c-30.9 0-56-25.1-56-56s25.1-56 56-56c11.6 0 21.7 1.8 30.1 5.8c8.9 4.2 14.8 10.3 18.4 16.6c2.9 5 8.1 7.9 13.6 8l.3 0 .3 0c2.6 0 5.2-.7 7.7-2.2c7.6-4.4 10.3-14.2 5.8-21.9c-6-10.3-13.5-18-21.9-23.6c-7.1-4.8-11.1-12.9-10.5-21.5s5.6-16.1 13.2-19.9l46.2-23.1c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-87.4 43.7c-9.5 4.8-21.1 2.7-28.3-5.2s-8.5-19.5-3-28.7l35.6-59.4c4.5-7.6 2.1-17.4-5.5-22s-17.4-2.1-22 5.5zm92.8 349.5C257.5 417.8 232.7 424 208 424l-48 0C71.6 424 0 352.4 0 264l0-32 0-1.9c0-.8 0-1.5 .1-2.3l.2-1.9 16-168C19.6 22.8 50.9-3.1 86.1 .3c24.7 2.4 44.9 18.5 53.4 40.1l5.6-9.3c18.2-30.3 57.5-40.1 87.8-22c26.9 16.2 37.7 49 27 77.4l15.4-7.7c31.4-15.7 69.5-3.2 85.5 28C382.5 94.2 407.3 88 432 88l48 0c88.4 0 160 71.6 160 160l0 32 0 1.9c0 .8 0 1.5-.1 2.3l-.2 1.9-16 168c-3.4 35.2-34.6 61-69.8 57.6c-24.7-2.4-44.9-18.5-53.4-40.1l-5.6 9.3c-18.2 30.3-57.5 40.1-87.8 22c-26.9-16.2-37.7-49-27-77.4l-15.4 7.7c-31.4 15.7-69.5 3.2-85.5-28zm174.6 51l51.8-86.3c5.8-9.6 17.4-14 28.1-10.5s17.5 13.9 16.4 25.1l-5.9 61.9c-.8 8.8 5.6 16.6 14.4 17.4s16.6-5.6 17.4-14.4l16-168 .1-.8 0-.8 0-32c0-61.9-50.1-112-112-112l-48 0c-31.6 0-60.5 14.5-76.2 41.6c-4.4 7.6-1.8 17.4 5.8 21.9c2.5 1.4 5.1 2.1 7.7 2.2l.3 0 .3 0c5.5-.1 10.7-3 13.6-8C392.6 177.9 410 168 432 168c30.9 0 56 25.1 56 56s-25.1 56-56 56c-11.6 0-21.7-1.8-30.1-5.8c-8.9-4.2-14.8-10.3-18.4-16.6c-2.9-5-8.1-7.9-13.6-8l-.3 0-.3 0c-2.6 0-5.2 .7-7.7 2.2c-7.7 4.4-10.3 14.2-5.8 21.9c6 10.3 13.5 18 21.9 23.6c7.1 4.8 11.1 12.9 10.6 21.5s-5.6 16.1-13.2 19.9l-46.2 23.1c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l87.4-43.7c9.5-4.8 21.1-2.7 28.3 5.2s8.5 19.5 3 28.7l-35.6 59.4c-4.5 7.6-2.1 17.4 5.5 22s17.4 2.1 22-5.5zM224 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm208-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
  ]
}, zx = Nx, Ex = {
  prefix: "far",
  iconName: "minus",
  icon: [
    448,
    512,
    [8211, 8722, 10134, "subtract"],
    "f068",
    "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"
  ]
}, Tx = {
  prefix: "far",
  iconName: "circle-5",
  icon: [
    512,
    512,
    [],
    "e0f2",
    "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128c-11.6 0-21.5 8.3-23.6 19.7l-16 88c-1.2 6.5 .4 13.3 4.4 18.6s10 8.8 16.6 9.5l86.9 9.8c15.8 1.8 27.8 15.2 27.8 31.1c0 17.3-14 31.3-31.3 31.3l-36 0c-11.5 0-22.3-5.7-28.8-15.3l-4.1-6.1c-7.4-11-22.3-13.9-33.3-6.5s-13.9 22.3-6.5 33.3l4.1 6.1c15.4 22.9 41.1 36.6 68.6 36.6l36 0c43.8 0 79.3-35.5 79.3-79.3c0-40.3-30.3-74.3-70.4-78.8L220.2 219l7.8-43 84 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-104 0z"
  ]
}, kx = {
  prefix: "far",
  iconName: "calendar-plus",
  icon: [
    448,
    512,
    [],
    "f271",
    "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm176 40c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"
  ]
}, B6 = {
  prefix: "far",
  iconName: "circle-info",
  icon: [
    512,
    512,
    ["info-circle"],
    "f05a",
    "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
  ]
}, jx = B6, Px = {
  prefix: "far",
  iconName: "child",
  icon: [
    320,
    512,
    [],
    "f1ae",
    "M160 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-96a72 72 0 1 1 0 144A72 72 0 1 1 160 0zM128 214l0 122 64 0 0-121.6c-10.2-4.2-21.2-6.4-32.4-6.4c-11 0-21.6 2.1-31.6 6zm0 170l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-230.1L43.7 309.8c-7.6 10.9-22.6 13.5-33.4 5.9S-3.3 293.1 4.3 282.2L50.1 217c25-35.7 65.9-57 109.5-57c43.2 0 83.7 20.8 108.8 56L315.5 282c7.7 10.8 5.2 25.8-5.6 33.5s-25.8 5.2-33.5-5.6L240 258.9 240 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-64 0z"
  ]
}, Ax = {
  prefix: "far",
  iconName: "file-pdf",
  icon: [
    512,
    512,
    [],
    "f1c1",
    "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
  ]
}, $x = {
  prefix: "far",
  iconName: "books-medical",
  icon: [
    576,
    512,
    [],
    "f7e8",
    "M112 416l0 48 64 0 0-48-64 0zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4l-64 0c-26.5 0-48-21.5-48-48l0-48 0-24 0-8 112 0 0-16 0-48 48 0 0 48 64 0 0-224-64 0 0 48-48 0 0-48 0-16L64 128l0-8 0-24 0-48C64 21.5 85.5 0 112 0l64 0c8.7 0 16.9 2.3 24 6.4C207.1 2.3 215.3 0 224 0l64 0c20.6 0 38.1 12.9 45 31.1c5.6-6.1 12.9-10.7 21.4-13L413.9 1.6c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5l-59.6 16.5c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2L339.6 145.9 336 132.2l0 11.8 0 224 0 24 0 24 0 48c0 26.5-21.5 48-48 48l-64 0c-8.7 0-16.9-2.3-24-6.4zM224 464l64 0 0-48-64 0 0 48zM176 48l-64 0 0 48 64 0 0-48zm48 48l64 0 0-48-64 0 0 48zM504.1 355.7l-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1l11.9 45.7L528 447.9c0-.1 0-.2 0-.3l0-.1-11.7-45.2-56.5 15.6zm-79.9-308l56.5-15.6L424.4 48.5 368 64.1c0 .1 0 .2 0 .4l11.7 45.2zM64 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
  ]
}, Ix = {
  prefix: "far",
  iconName: "location-crosshairs",
  icon: [
    512,
    512,
    ["location"],
    "f601",
    "M256 0c13.3 0 24 10.7 24 24l0 41.5C366.8 76.3 435.7 145.2 446.5 232l41.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.5 0C435.7 366.8 366.8 435.7 280 446.5l0 41.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-41.5C145.2 435.7 76.3 366.8 65.5 280L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l41.5 0C76.3 145.2 145.2 76.3 232 65.5L232 24c0-13.3 10.7-24 24-24zM112 256a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm192 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"
  ]
}, Ox = {
  prefix: "far",
  iconName: "ban-smoking",
  icon: [
    512,
    512,
    [128685, "smoking-ban"],
    "f54d",
    "M92.9 126.9L385.1 419.1C349.7 447.2 304.8 464 256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1zm165 97.1L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L353.9 320l46.1 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-142.1 0zm32 32l94.1 0 0 32-62.1 0-32-32zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM112 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l128.8 0-96-96L112 224z"
  ]
}, Rx = Ox, Dx = {
  prefix: "far",
  iconName: "recycle",
  icon: [
    512,
    512,
    [9842, 9850, 9851],
    "f1b8",
    "M181.5 40.9C197.7 15.3 226 0 256 0s58.3 15.3 74.5 40.9L392.8 139l6.6-31.8c2.7-13 15.4-21.3 28.3-18.7s21.3 15.4 18.7 28.3l-19.4 94.4c-1.4 6.7-5.6 12.5-11.5 15.9s-13.1 4.2-19.6 2l-91.4-30.4c-12.6-4.2-19.4-17.8-15.2-30.3s17.8-19.4 30.3-15.2l32.2 10.7L290 66.6C282.7 55.1 269.8 48 256 48s-26.7 7.1-34 18.6l-21.5 33.9c-7 11-21.4 14.4-32.6 7.7c-11.6-6.9-15.1-22-7.9-33.4l21.5-33.9zM439 255.5c11.2-6.7 25.6-3.3 32.6 7.7l26.8 42.2c8.8 13.9 13.5 30 13.6 46.4c.3 48.6-39 88.2-87.6 88.2l-137.2 0 24.8 22c9.9 8.8 10.8 24 2 33.9s-24 10.8-33.9 2l-72-64c-5.1-4.6-8.1-11.1-8.1-17.9s2.9-13.4 8.1-17.9l72-64c9.9-8.8 25.1-7.9 33.9 2s7.9 25.1-2 33.9L287.1 392l137.3 0c22 0 39.8-17.9 39.6-39.9c0-7.4-2.2-14.7-6.2-21l-26.8-42.2c-7.2-11.4-3.7-26.5 7.9-33.4zm-311.6 3.7l-6.7-32.8L54.2 331.1c-4 6.3-6.1 13.6-6.2 21c-.1 22 17.7 39.9 39.6 39.9l48.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48.4 0C39 440-.3 400.5 0 351.9c.1-16.4 4.8-32.5 13.6-46.4L78.8 202.8 47.6 213.1c-12.6 4.2-26.2-2.6-30.3-15.2s2.6-26.2 15.2-30.3l91.4-30.4c6.5-2.2 13.6-1.4 19.6 2s10.1 9.2 11.5 15.9l19.4 94.4c2.7 13-5.7 25.7-18.7 28.3s-25.7-5.7-28.3-18.7z"
  ]
}, Fx = {
  prefix: "far",
  iconName: "circle",
  icon: [
    512,
    512,
    [9679, 9898, 9899, 11044, 61708, 61915, 128308, 128309, 128992, 128993, 128994, 128995, 128996],
    "f111",
    "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
  ]
}, Bx = {
  prefix: "far",
  iconName: "arrow-up-right-from-square",
  icon: [
    512,
    512,
    ["external-link"],
    "f08e",
    "M304 24c0 13.3 10.7 24 24 24l102.1 0L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223L464 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24L328 0c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"
  ]
}, Vx = {
  prefix: "far",
  iconName: "seedling",
  icon: [
    512,
    512,
    [127793, "sprout"],
    "f4d8",
    "M307.3 207c82.9-9.1 148.4-75.6 156-159L456 48c-76.7 0-142 49.1-166.1 117.5c-8.8-16.8-19.4-32.6-31.6-47.1C296.1 48 370.5 0 456 0l24 0c17.7 0 32 14.3 32 32c0 113.6-84.6 207.4-194.2 222c-2.1-16.2-5.6-31.9-10.5-47.1zM48 112l0 16c0 97.2 78.8 176 176 176l8 0 0-16c0 0 0 0 0 0c0-97.2-78.8-176-176-176l-8 0zM280 288l0 16 0 48 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-8 0C100.3 352 0 251.7 0 128L0 96C0 78.3 14.3 64 32 64l24 0c123.7 0 224 100.3 224 224z"
  ]
}, Hx = {
  prefix: "far",
  iconName: "circle-play",
  icon: [
    512,
    512,
    [61469, "play-circle"],
    "f144",
    "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"
  ]
}, qx = {
  prefix: "far",
  iconName: "angles-right",
  icon: [
    512,
    512,
    [187, "angle-double-right"],
    "f101",
    "M113 433L273 273c9.4-9.4 9.4-24.6 0-33.9L113 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L79 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm192 0L465 273c9.4-9.4 9.4-24.6 0-33.9L305 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L271 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"
  ]
}, Wx = qx, Ux = {
  prefix: "far",
  iconName: "square-plus",
  icon: [
    448,
    512,
    [61846, "plus-square"],
    "f0fe",
    "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
  ]
}, Gx = {
  prefix: "far",
  iconName: "weight-scale",
  icon: [
    512,
    512,
    ["weight"],
    "f496",
    "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm304 0c0-22.6-4.3-44.2-12-64l28 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l28 0c-7.7 19.8-12 41.4-12 64c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-56.2 0zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
  ]
}, Yx = Gx, Kx = {
  prefix: "far",
  iconName: "dumpster",
  icon: [
    576,
    512,
    [],
    "f793",
    "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160l94 0L140.5 32 49.7 32zM272 160l0-128-98.9 0L147.5 160 272 160zm32 0l124.5 0L402.9 32 304 32l0 128zm157.1 0l94 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32l-90.8 0 25.6 128zM86.4 240l403.3 0-20 160-363.3 0-20-160zM112 448l352 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 22-176 18 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-12 0 4-32-48.4 0L80.4 192 32 192l4 32-12 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l18 0L64 448l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8z"
  ]
}, Xx = {
  prefix: "far",
  iconName: "lightbulb-on",
  icon: [
    640,
    512,
    [],
    "f672",
    "M69.3 4C58.3-3.3 43.4-.3 36 10.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L69.3 4zM597.3 44c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM117.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm432-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM448 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5l48.6 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8c0 0 0 0 0 0s0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C200.4 228.3 192 203.2 192 176c0-70.7 57.3-128 128-128s128 57.3 128 128zm-176 0c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM400 432l0-16-160 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80z"
  ]
}, Zx = {
  prefix: "far",
  iconName: "asterisk",
  icon: [
    384,
    512,
    [10033, 61545],
    "2a",
    "M192 32c13.3 0 24 10.7 24 24l0 156.9 131.4-81.3c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L237.6 256l135 83.6c11.3 7 14.7 21.8 7.8 33s-21.8 14.7-33 7.8L216 299.1 216 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-156.9L36.6 380.4c-11.3 7-26.1 3.5-33-7.8s-3.5-26.1 7.8-33l135-83.6-135-83.6c-11.3-7-14.8-21.8-7.8-33s21.8-14.8 33-7.8L168 212.9 168 56c0-13.3 10.7-24 24-24z"
  ]
}, Qx = {
  prefix: "far",
  iconName: "film",
  icon: [
    512,
    512,
    [127902],
    "f008",
    "M352 432l-192 0 0-112 0-40 192 0 0 40 0 112zm0-200l-192 0 0-40 0-112 192 0 0 112 0 40zM64 80l48 0 0 88-64 0 0-72c0-8.8 7.2-16 16-16zM48 216l64 0 0 80-64 0 0-80zm64 216l-48 0c-8.8 0-16-7.2-16-16l0-72 64 0 0 88zM400 168l0-88 48 0c8.8 0 16 7.2 16 16l0 72-64 0zm0 48l64 0 0 80-64 0 0-80zm0 128l64 0 0 72c0 8.8-7.2 16-16 16l-48 0 0-88zM448 32L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64z"
  ]
}, Jx = {
  prefix: "far",
  iconName: "circle-minus",
  icon: [
    512,
    512,
    ["minus-circle"],
    "f056",
    "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
  ]
}, e_ = {
  prefix: "far",
  iconName: "message",
  icon: [
    512,
    512,
    ["comment-alt"],
    "f27a",
    "M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z"
  ]
}, t_ = e_, n_ = {
  prefix: "far",
  iconName: "stethoscope",
  icon: [
    576,
    512,
    [129658],
    "f0f1",
    "M142.5 15.6c4.7 12.4-1.6 26.2-14 30.9L85.2 62.7c-3.1 1.2-5.2 4.2-5.2 7.5L80 200c0 57.4 46.6 104 104 104l8 0 8 0c57.4 0 104-46.6 104-104l0-129.8c0-3.3-2.1-6.3-5.2-7.5L255.6 46.5c-12.4-4.7-18.7-18.5-14-30.9s18.5-18.7 30.9-14l43.2 16.2C337.5 25.9 352 46.8 352 70.2L352 200c0 78.5-59.5 143.1-135.8 151.1C219.9 414.1 272.1 464 336 464c66.3 0 120-53.7 120-120l0-75.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 75.7c0 92.8-75.2 168-168 168c-90.4 0-164.1-71.4-167.8-160.8C91.7 343.3 32 278.6 32 200L32 70.2c0-23.3 14.5-44.2 36.3-52.4L111.6 1.5c12.4-4.7 26.2 1.6 30.9 14zM480 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
  ]
}, r_ = {
  prefix: "fas",
  iconName: "hand-holding-medical",
  icon: [
    576,
    512,
    [],
    "e05c",
    "M224 24l0 56-56 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l56 0 0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-56 0 0-56c0-13.3-10.7-24-24-24L248 0c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0c0 0 0 0 0 0c-.3 0-.6 0-.9 0z"
  ]
}, a_ = {
  prefix: "fas",
  iconName: "graduation-cap",
  icon: [
    640,
    512,
    [127891, "mortar-board"],
    "f19d",
    "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9l0 28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5l0-24.6c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
  ]
}, i_ = {
  prefix: "fas",
  iconName: "shield-keyhole",
  icon: [
    512,
    512,
    [],
    "e248",
    "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM312 208c0 22.3-13.1 41.6-32 50.6l0 69.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-69.4c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56s56 25.1 56 56z"
  ]
}, s_ = {
  prefix: "fas",
  iconName: "exclamation",
  icon: [
    128,
    512,
    [10069, 10071, 61738],
    "21",
    "M96 64c0-17.7-14.3-32-32-32S32 46.3 32 64l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32L96 64zM64 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
  ]
}, o_ = {
  prefix: "fas",
  iconName: "boot",
  icon: [
    512,
    512,
    [129406],
    "f782",
    "M0 32C0 14.3 14.3 0 32 0L320 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L0 96 0 32zM0 457.4L0 448l512 0 0 9.4c0 14.5-5.8 28.4-16 38.6s-24.1 16-38.6 16l-14.9 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-14.9 0c-14.5 0-28.4-5.8-38.6-16S0 471.9 0 457.4zM0 416L0 128l320 0 0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 119.3 29.8C482 296.5 512 334.9 512 379l0 37L0 416z"
  ]
}, c_ = {
  prefix: "fas",
  iconName: "syringe",
  icon: [
    512,
    512,
    [128137],
    "f48e",
    "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4l-88.8 0L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-88.8c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
  ]
}, l_ = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [
    512,
    512,
    [61532, "times-circle", "xmark-circle"],
    "f057",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
  ]
}, d_ = {
  prefix: "fas",
  iconName: "chevrons-right",
  icon: [
    512,
    512,
    ["chevron-double-right"],
    "f324",
    "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
  ]
}, u_ = d_, f_ = {
  prefix: "fas",
  iconName: "angle-left",
  icon: [
    320,
    512,
    [8249],
    "f104",
    "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
  ]
}, p_ = {
  prefix: "fas",
  iconName: "buildings",
  icon: [
    512,
    512,
    [],
    "e0cc",
    "M256 0c-35.3 0-64 28.7-64 64l0 64L64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0 192 0c35.3 0 64-28.7 64-64l0-256 0-128c0-35.3-28.7-64-64-64L256 0zM64 304c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm208 16c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0zm112-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM80 192l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 208l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0z"
  ]
}, m_ = {
  prefix: "fas",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
  ]
}, h_ = {
  prefix: "fas",
  iconName: "book",
  icon: [
    448,
    512,
    [128212],
    "f02d",
    "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
  ]
}, g_ = {
  prefix: "fas",
  iconName: "shoe-prints",
  icon: [
    640,
    512,
    [],
    "f54b",
    "M416 0C352.3 0 256 32 256 32l0 128c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32l0 128s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64z"
  ]
}, v_ = {
  prefix: "fas",
  iconName: "calendar",
  icon: [
    448,
    512,
    [128197, 128198],
    "f133",
    "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z"
  ]
}, b_ = {
  prefix: "fas",
  iconName: "shield-heart",
  icon: [
    512,
    512,
    [],
    "e574",
    "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
  ]
}, y_ = {
  prefix: "fas",
  iconName: "house-medical",
  icon: [
    576,
    512,
    [],
    "e3b2",
    "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
  ]
}, x_ = {
  prefix: "fas",
  iconName: "angles-left",
  icon: [
    512,
    512,
    [171, "angle-double-left"],
    "f100",
    "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
  ]
}, __ = {
  prefix: "fas",
  iconName: "trophy",
  icon: [
    576,
    512,
    [127942],
    "f091",
    "M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z"
  ]
}, w_ = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
  ]
}, C_ = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
  ]
}, S_ = {
  prefix: "fas",
  iconName: "cars",
  icon: [
    640,
    512,
    [],
    "f85b",
    "M123.4 74.9c2.2-6.5 8.3-10.9 15.2-10.9l138.8 0c6.9 0 13 4.4 15.2 10.9L310.3 128l-204.5 0 17.7-53.1zM36.1 134.4C14.8 144.7 0 166.6 0 192l0 96s0 0 0 0l0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 136.5 0c5.1-5.7 10.8-10.7 17.1-15.1l22.8-68.3c15.2-45.7 58-76.6 106.3-76.6l15.1 0L353.3 54.7C342.4 22 311.8 0 277.4 0L138.6 0c-34.4 0-65 22-75.9 54.7L36.1 134.4zM56 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm306.6 16l138.8 0c6.9 0 13 4.4 15.2 10.9L534.3 288l-204.5 0 17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352l0 96s0 0 0 0l0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 0-96c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160l-138.8 0c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
  ]
}, L_ = {
  prefix: "fas",
  iconName: "baby",
  icon: [
    448,
    512,
    [],
    "f77c",
    "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25l0 36.3-192 0 0-36.3c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
  ]
}, M_ = {
  prefix: "fas",
  iconName: "chalkboard-user",
  icon: [
    640,
    512,
    ["chalkboard-teacher"],
    "f51c",
    "M160 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-11.8-25.5-29.9-47.5-52.4-64l99.6 0 0-32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 32 64 0 0-288L224 64l0 49.1C205.2 102.2 183.3 96 160 96l0-32zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
  ]
}, N_ = {
  prefix: "fas",
  iconName: "copy",
  icon: [
    448,
    512,
    [],
    "f0c5",
    "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"
  ]
}, z_ = {
  prefix: "fas",
  iconName: "arrow-up",
  icon: [
    384,
    512,
    [8593],
    "f062",
    "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
  ]
}, E_ = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [
    512,
    512,
    [],
    "f078",
    "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
  ]
}, T_ = {
  prefix: "fas",
  iconName: "fax",
  icon: [
    512,
    512,
    [128224, 128439],
    "f1ac",
    "M128 64l0 96 64 0 0-96 194.7 0L416 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0L192 0c-35.3 0-64 28.7-64 64zM0 160L0 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm480 32l-352 0 0 288c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
  ]
}, k_ = {
  prefix: "fas",
  iconName: "hospital",
  icon: [
    640,
    512,
    [62589, 127973, "hospital-alt", "hospital-wide"],
    "f0f8",
    "M192 48c0-26.5 21.5-48 48-48L400 0c26.5 0 48 21.5 48 48l0 464-80 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-80 0 0-464zM48 96l112 0 0 416L48 512c-26.5 0-48-21.5-48-48L0 320l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 288l0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 192l0-48c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48l0 48-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 144c0 26.5-21.5 48-48 48l-112 0 0-416 112 0zM312 64c-8.8 0-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0z"
  ]
}, j_ = {
  prefix: "fas",
  iconName: "location-dot",
  icon: [
    384,
    512,
    ["map-marker-alt"],
    "f3c5",
    "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
  ]
}, P_ = {
  prefix: "fas",
  iconName: "credit-card",
  icon: [
    576,
    512,
    [62083, 128179, "credit-card-alt"],
    "f09d",
    "M64 32C28.7 32 0 60.7 0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32zM576 224L0 224 0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-192zM112 352l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
  ]
}, A_ = {
  prefix: "fas",
  iconName: "kit-medical",
  icon: [
    576,
    512,
    ["first-aid"],
    "f479",
    "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l32 0L96 32 64 32zm64 0l0 448 320 0 0-448L128 32zM512 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-32 0 0 448 32 0zM256 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
  ]
}, $_ = {
  prefix: "fas",
  iconName: "ellipsis",
  icon: [
    448,
    512,
    ["ellipsis-h"],
    "f141",
    "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
  ]
}, I_ = $_, O_ = {
  prefix: "fas",
  iconName: "arrow-right-long",
  icon: [
    512,
    512,
    ["long-arrow-right"],
    "f178",
    "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
  ]
}, R_ = {
  prefix: "fas",
  iconName: "angle-down",
  icon: [
    448,
    512,
    [8964],
    "f107",
    "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
  ]
}, D_ = {
  prefix: "fas",
  iconName: "mars",
  icon: [
    448,
    512,
    [9794],
    "f222",
    "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8l112 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80s0 0 0 0s0 0 0 0s0 0 0 0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
  ]
}, F_ = {
  prefix: "fas",
  iconName: "folder-medical",
  icon: [
    512,
    512,
    [],
    "e18c",
    "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM224 208l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
  ]
}, B_ = {
  prefix: "fas",
  iconName: "house",
  icon: [
    576,
    512,
    [63498, 63500, 127968, "home", "home-alt", "home-lg-alt"],
    "f015",
    "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
  ]
}, V_ = {
  prefix: "fas",
  iconName: "download",
  icon: [
    512,
    512,
    [],
    "f019",
    "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
  ]
}, H_ = {
  prefix: "fas",
  iconName: "ellipsis-vertical",
  icon: [
    128,
    512,
    ["ellipsis-v"],
    "f142",
    "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
  ]
}, q_ = H_, W_ = {
  prefix: "fas",
  iconName: "piggy-bank",
  icon: [
    576,
    512,
    [],
    "f4d3",
    "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7L256 96c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96l11.5 0c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9l13.3 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-32 0c-9.1 12.1-19.9 22.9-32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-128 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c-34.9-26.2-58.7-66.3-63.2-112L68 304c-37.6 0-68-30.4-68-68s30.4-68 68-68l4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-4 0c-11 0-20 9-20 20s9 20 20 20l31.2 0c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2l128 0zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
  ]
}, U_ = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [
    320,
    512,
    [],
    "f0d7",
    "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
  ]
}, G_ = {
  prefix: "fas",
  iconName: "shield-plus",
  icon: [
    512,
    512,
    [],
    "e24a",
    "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
  ]
}, Y_ = {
  prefix: "fas",
  iconName: "gear",
  icon: [
    512,
    512,
    [9881, "cog"],
    "f013",
    "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
  ]
}, K_ = Y_, X_ = {
  prefix: "fas",
  iconName: "chart-user",
  icon: [
    640,
    512,
    ["user-chart"],
    "f6a3",
    "M160 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-11.8-25.5-29.9-47.5-52.4-64L576 352l0-288L224 64l0 49.1C205.2 102.2 183.3 96 160 96l0-32zm252.7 75.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l88 0c8.8 0 16 7.2 16 16l0 88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM0 485.3C0 411.7 59.7 352 133.3 352l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3z"
  ]
}, Z_ = {
  prefix: "fas",
  iconName: "dumbbell",
  icon: [
    640,
    512,
    [],
    "f44b",
    "M96 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 160 0 64 0 160c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64-32 0c-17.7 0-32-14.3-32-32l0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l32 0 0-64zm448 0l0 64 32 0c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 64c0 17.7-14.3 32-32 32l-32 0 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-160 0-64 0-160c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32zM416 224l0 64-192 0 0-64 192 0z"
  ]
}, Q_ = {
  prefix: "fas",
  iconName: "plate-utensils",
  icon: [
    640,
    512,
    [58713],
    "e43b",
    "M40.7 16c4 .3 7.1 3.5 7.3 7.5L55.5 152l17.3 0L88.1 23.1c.5-4 3.9-7.1 7.9-7.1s7.5 3 7.9 7.1L119.1 152l17.3 0L144 23.5c.2-4 3.3-7.2 7.3-7.5s7.6 2.3 8.5 6.1l30.3 128.7c1.3 5.4 1.9 11 1.9 16.6c0 39.9-32.2 72.2-72 72.5l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232c-39.8-.3-72-32.6-72-72.5c0-5.6 .6-11.2 1.9-16.6L32.2 22.2c.9-3.9 4.5-6.5 8.5-6.1zm572.4 1c2-.7 4-1 6.1-1c11.5 0 20.9 9.3 20.9 20.9L640 216l0 104 0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-152-48 0c-17.7 0-32-14.3-32-32l0-128C512 59.2 596.2 23.2 613.1 17zM221.2 143.6L204.9 74.3C241.8 47.7 287.1 32 336 32c60.3 0 115 23.8 155.3 62.5C484.3 113.3 480 135 480 160l0 26.2C454.1 132.8 399.3 96 336 96c-44.9 0-85.5 18.5-114.6 48.3l-.2-.8zM336 480c-76.2 0-143.5-38.1-184-96.2l0-116.9c8.5-2.8 16.6-6.7 24-11.4l0 .6c0 88.4 71.6 160 160 160c68.1 0 126.2-42.5 149.3-102.4c9.2 21 29.3 36.2 53.2 38.2C502.6 427.6 425.4 480 336 480zM208 256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z"
  ]
}, J_ = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [
    512,
    512,
    ["info-circle"],
    "f05a",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  ]
}, ew = {
  prefix: "fas",
  iconName: "user-doctor",
  icon: [
    448,
    512,
    ["user-md"],
    "f0f0",
    "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1l0 50.8c27.6 7.1 48 32.2 48 62l0 40c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-40c0-29.8 20.4-54.9 48-62l0-57.1c-6-.6-12.1-.9-18.3-.9l-91.4 0c-6.2 0-12.3 .3-18.3 .9l0 65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-59.1zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
  ]
}, tw = {
  prefix: "fas",
  iconName: "envelope",
  icon: [
    512,
    512,
    [9993, 61443, 128386],
    "f0e0",
    "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
  ]
}, nw = {
  prefix: "fas",
  iconName: "comment",
  icon: [
    512,
    512,
    [61669, 128489],
    "f075",
    "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
  ]
}, rw = {
  prefix: "fas",
  iconName: "shield-virus",
  icon: [
    512,
    512,
    [],
    "e06c",
    "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
  ]
}, aw = {
  prefix: "fas",
  iconName: "phone",
  icon: [
    512,
    512,
    [128222, 128379],
    "f095",
    "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
  ]
}, iw = {
  prefix: "fas",
  iconName: "head-side-medical",
  icon: [
    512,
    512,
    [],
    "f809",
    "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM192 112l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
  ]
}, sw = {
  prefix: "fas",
  iconName: "circle-question",
  icon: [
    512,
    512,
    [62108, "question-circle"],
    "f059",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
  ]
}, ow = {
  prefix: "fas",
  iconName: "wrench",
  icon: [
    512,
    512,
    [128295],
    "f0ad",
    "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
  ]
}, cw = {
  prefix: "fas",
  iconName: "cube",
  icon: [
    512,
    512,
    [],
    "f1b2",
    "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6l0 242.9c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4L0 134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1 0-188L288 246.6l0 188z"
  ]
}, lw = {
  prefix: "fas",
  iconName: "hands-holding-dollar",
  icon: [
    640,
    512,
    ["hands-usd"],
    "f4c5",
    "M344 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c0 0 0 0 0 0c-2.1-.7-4.1-1.4-5.9-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L296 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM40 64c22.1 0 40 17.9 40 40l0 40 0 80 0 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2c0 0 0 0 0 0l25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 224l0-64 0-56C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 56 0 64 0 101.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3c0 0 0 0 0 0l15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3l0-40.2 0-80 0-40c0-22.1 17.9-40 40-40z"
  ]
}, dw = lw, uw = {
  prefix: "fas",
  iconName: "apple-whole",
  icon: [
    448,
    512,
    [127822, 127823, "apple-alt"],
    "f5d1",
    "M224 112c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80l16 0c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80l-16 0zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
  ]
}, fw = {
  prefix: "fas",
  iconName: "heart",
  icon: [
    512,
    512,
    [9829, 10084, 61578, 128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505],
    "f004",
    "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
  ]
}, pw = {
  prefix: "fas",
  iconName: "hands-holding-heart",
  icon: [
    640,
    512,
    ["hands-heart"],
    "f4c3",
    "M195.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L342.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L195.9 136.9zM40 64c22.1 0 40 17.9 40 40l0 40 0 80 0 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2c0 0 0 0 0 0l25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 224l0-64 0-56C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 56 0 64 0 101.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3c0 0 0 0 0 0l15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3l0-40.2 0-80 0-40c0-22.1 17.9-40 40-40z"
  ]
}, mw = {
  prefix: "fas",
  iconName: "arrow-right",
  icon: [
    448,
    512,
    [8594],
    "f061",
    "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
  ]
}, hw = {
  prefix: "fas",
  iconName: "hand-holding-heart",
  icon: [
    576,
    512,
    [],
    "f4be",
    "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"
  ]
}, gw = {
  prefix: "fas",
  iconName: "language",
  icon: [
    640,
    512,
    [],
    "f1ab",
    "M0 128C0 92.7 28.7 64 64 64l192 0 48 0 16 0 256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-256 0-16 0-48 0L64 448c-35.3 0-64-28.7-64-64L0 128zm320 0l0 256 256 0 0-256-256 0zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1 73.6 0 8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276l-38 0 19-42.8zM448 164c11 0 20 9 20 20l0 4 44 0 16 0c11 0 20 9 20 20s-9 20-20 20l-2 0-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45L448 228l-72 0c-11 0-20-9-20-20s9-20 20-20l52 0 0-4c0-11 9-20 20-20z"
  ]
}, vw = {
  prefix: "fas",
  iconName: "newspaper",
  icon: [
    512,
    512,
    [128240],
    "f1ea",
    "M96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L80 480c-44.2 0-80-35.8-80-80L0 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16L96 96zm64 24l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16z"
  ]
}, bw = {
  prefix: "fas",
  iconName: "memo",
  icon: [
    384,
    512,
    [],
    "e1d8",
    "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm64 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 320z"
  ]
}, yw = {
  prefix: "fas",
  iconName: "cloud-arrow-down",
  icon: [
    640,
    512,
    [62337, "cloud-download", "cloud-download-alt"],
    "f0ed",
    "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 134.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
  ]
}, xw = yw, _w = {
  prefix: "fas",
  iconName: "arrows-left-right",
  icon: [
    512,
    512,
    ["arrows-h"],
    "f07e",
    "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
  ]
}, ww = {
  prefix: "fas",
  iconName: "cloud-arrow-up",
  icon: [
    640,
    512,
    [62338, "cloud-upload", "cloud-upload-alt"],
    "f0ee",
    "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
  ]
}, Cw = ww, Sw = {
  prefix: "fas",
  iconName: "certificate",
  icon: [
    512,
    512,
    [],
    "f0a3",
    "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
  ]
}, Lw = {
  prefix: "fas",
  iconName: "viruses",
  icon: [
    640,
    512,
    [],
    "e076",
    "M192 0c13.3 0 24 10.7 24 24l0 13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168l13.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-13.5 0c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5l0 13.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216L24 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l13.5 0c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5L168 24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
  ]
}, Mw = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [
    512,
    512,
    [61533, "check-circle"],
    "f058",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
  ]
}, Nw = {
  prefix: "fas",
  iconName: "angles-right",
  icon: [
    512,
    512,
    [187, "angle-double-right"],
    "f101",
    "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
  ]
}, zw = {
  prefix: "fas",
  iconName: "gift",
  icon: [
    512,
    512,
    [127873],
    "f06b",
    "M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z"
  ]
}, Ew = {
  prefix: "fas",
  iconName: "wifi",
  icon: [
    640,
    512,
    ["wifi-3", "wifi-strong"],
    "f1eb",
    "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
  ]
}, Tw = {
  prefix: "fas",
  iconName: "bars-sort",
  icon: [
    448,
    512,
    [],
    "e0ae",
    "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM192 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c17.7 0 32 14.3 32 32z"
  ]
}, kw = {
  prefix: "fas",
  iconName: "weight-hanging",
  icon: [
    512,
    512,
    [],
    "f5cd",
    "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32L120 128c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512l416 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128l-45.5 0z"
  ]
}, jw = {
  prefix: "fas",
  iconName: "heart-pulse",
  icon: [
    512,
    512,
    ["heartbeat"],
    "f21e",
    "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4l87 0c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31l104.5 0c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240l-132 0c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9L16 240c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9l0-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1l0 5.8c0 16.9-2.8 33.5-8.3 49.1z"
  ]
}, Pw = {
  prefix: "fas",
  iconName: "venus",
  icon: [
    384,
    512,
    [9792],
    "f221",
    "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9z"
  ]
}, Aw = {
  prefix: "fas",
  iconName: "calendar-star",
  icon: [
    448,
    512,
    [],
    "f736",
    "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm233.3 58.9c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L224 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z"
  ]
}, $w = {
  prefix: "fas",
  iconName: "x-ray",
  icon: [
    512,
    512,
    [],
    "f497",
    "M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 320c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16l0 32-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 48-112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 0 70.6L189.1 307c-5.2-2-10.6-3-16.2-3l-2.1 0c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6l120.8 0c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8l-2.2 0c-5.5 0-11 1-16.2 3L272 326.6l0-70.6 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-48 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-32c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
  ]
}, Iw = {
  prefix: "fas",
  iconName: "scalpel-line-dashed",
  icon: [
    576,
    512,
    ["scalpel-path"],
    "f61e",
    "M441.4 0c-20.8 0-40.6 9.2-54 25.1L187.8 261.7c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3l132.6 0c14.1 0 27.6-6.2 36.7-17L494.4 122.7C505.8 109.2 512 92.2 512 74.6l0-4C512 31.6 480.4 0 441.4 0zM164.7 324.7l-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336l0-16-16 0-96 0-6.6 0-4.7 4.7zM304 480l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z"
  ]
}, Ow = {
  prefix: "fas",
  iconName: "venus-mars",
  icon: [
    640,
    512,
    [9892],
    "f228",
    "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0L616 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
  ]
}, Rw = {
  prefix: "fas",
  iconName: "globe",
  icon: [
    512,
    512,
    [127760],
    "f0ac",
    "M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z"
  ]
}, Dw = {
  prefix: "fas",
  iconName: "bullhorn",
  icon: [
    512,
    512,
    [128226, 128363],
    "f0a1",
    "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75l-8.7 0-32 0-96 0c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-147.6c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4L480 32zm-64 76.7L416 240l0 131.3C357.2 317.8 280.5 288 200.7 288l-8.7 0 0-96 8.7 0c79.8 0 156.5-29.8 215.3-83.3z"
  ]
}, Fw = {
  prefix: "fas",
  iconName: "user",
  icon: [
    448,
    512,
    [62144, 128100],
    "f007",
    "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"
  ]
}, Bw = {
  prefix: "fas",
  iconName: "shield-check",
  icon: [
    512,
    512,
    [],
    "f2f7",
    "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
  ]
}, Vw = {
  prefix: "fas",
  iconName: "staff-snake",
  icon: [
    384,
    512,
    ["rod-asclepius", "rod-snake", "staff-aesculapius"],
    "e579",
    "M222.6 43.2l-.1 4.8L288 48c53 0 96 43 96 96s-43 96-96 96l-40 0 0-80 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0-28 0-4.5 144 40.5 0c53 0 96 43 96 96s-43 96-96 96l-16 0 0-80 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-43 0-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31L136 464c-22.1 0-40-17.9-40-40s17.9-40 40-40l36 0-1-32-19 0c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7l0 94.7c0 8.8 7.2 16 16 16l16.5 0L164 128l-28 0-13.4 0c-9 18.9-28.3 32-50.6 32l-16 0c-30.9 0-56-25.1-56-56S25.1 48 56 48l8 0 8 0 89.5 0-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
  ]
}, Hw = {
  prefix: "fas",
  iconName: "pills",
  icon: [
    576,
    512,
    [],
    "f484",
    "M112 96c-26.5 0-48 21.5-48 48l0 112 96 0 0-112c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112l0 224c0 61.9-50.1 112-112 112S0 429.9 0 368L0 144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
  ]
}, qw = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [
    512,
    512,
    [],
    "f077",
    "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
  ]
}, Ww = {
  prefix: "fas",
  iconName: "hand-heart",
  icon: [
    512,
    512,
    [],
    "f4bc",
    "M256 0c17.7 0 32 14.3 32 32l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 208c0 97.2-78.8 176-176 176l-19.2 0c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6l0-272c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-17.7 14.3-32 32-32zM208 362.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6c0-23.5-19.1-42.6-42.6-42.6l-1.1 0c-14.6 0-28.3 7.3-36.4 19.5c-8.1-12.2-21.7-19.5-36.4-19.5l-1.1 0c-23.5 0-42.6 19.1-42.6 42.6z"
  ]
}, Uw = {
  prefix: "fas",
  iconName: "car-side",
  icon: [
    640,
    512,
    [128663],
    "f5e4",
    "M171.3 96L224 96l0 96-112.7 0 30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192l0-96 81.2 0c9.7 0 18.9 4.4 25 12l67.2 84L272 192zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36L171.3 32c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256L0 368c0 17.7 14.3 32 32 32l33.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l33.3 0c17.7 0 32-14.3 32-32l0-48c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
  ]
}, Gw = {
  prefix: "fas",
  iconName: "pen-to-square",
  icon: [
    512,
    512,
    ["edit"],
    "f044",
    "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"
  ]
}, Yw = Gw, Kw = {
  prefix: "fas",
  iconName: "clipboard-medical",
  icon: [
    384,
    512,
    [],
    "e133",
    "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"
  ]
}, Xw = {
  prefix: "fas",
  iconName: "square-check",
  icon: [
    448,
    512,
    [9745, 9989, 61510, "check-square"],
    "f14a",
    "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
  ]
}, Zw = Xw, V6 = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [
    512,
    512,
    ["exclamation-circle"],
    "f06a",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
  ]
}, Qw = V6, Jw = {
  prefix: "fas",
  iconName: "bars",
  icon: [
    448,
    512,
    ["navicon"],
    "f0c9",
    "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
  ]
}, eC = {
  prefix: "fas",
  iconName: "cloud",
  icon: [
    640,
    512,
    [9729],
    "f0c2",
    "M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
  ]
}, tC = {
  prefix: "fas",
  iconName: "rainbow",
  icon: [
    640,
    512,
    [127752],
    "f75b",
    "M320 96C178.6 96 64 210.6 64 352l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96C0 175.3 143.3 32 320 32s320 143.3 320 320l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-70.7 57.3-128 128-128s128 57.3 128 128l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-35.3-28.7-64-64-64zM160 352l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-123.7 100.3-224 224-224s224 100.3 224 224l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
  ]
}, nC = {
  prefix: "fas",
  iconName: "blog",
  icon: [
    512,
    512,
    [],
    "f781",
    "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144L0 368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144l-16 0 0 96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48l0-224z"
  ]
}, rC = {
  prefix: "fas",
  iconName: "comments",
  icon: [
    640,
    512,
    [61670, 128490],
    "f086",
    "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2s0 0 0 0s0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9c0 0 0 0 0 0s0 0 0 0l-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
  ]
}, aC = {
  prefix: "fas",
  iconName: "chevrons-left",
  icon: [
    512,
    512,
    ["chevron-double-left"],
    "f323",
    "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zm384-192l-192 192c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
  ]
}, iC = aC, sC = {
  prefix: "fas",
  iconName: "person",
  icon: [
    320,
    512,
    [129485, "male"],
    "f183",
    "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0z"
  ]
}, oC = {
  prefix: "fass",
  iconName: "circle-3",
  icon: [
    512,
    512,
    [],
    "e0f0",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-384l24 0 0 34.6-7.8 7.1-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2l-25.2 0c-32.2 0-61.6-18.2-76-47l-4.2-8.3 42.9-21.5 4.2 8.3c6.3 12.5 19.1 20.4 33 20.4l25.2 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3-24.1 .1 0-34.7 7.8-7.1L250.3 176 184 176l-24 0 0-48 24 0 128 0z"
  ]
}, cC = {
  prefix: "fass",
  iconName: "circle-2",
  icon: [
    512,
    512,
    [],
    "e0ef",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM193.7 146.5c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L244.7 336l83.3 0 24 0 0 48-24 0-144 0-24 0 0-34.4 7.6-7.1L276.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3L206.5 197l-19.1 14.5-29.1-38.2 19.1-14.5 16.2-12.3z"
  ]
}, lC = {
  prefix: "fass",
  iconName: "circle-4",
  icon: [
    512,
    512,
    [],
    "e0f1",
    "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320-64l-48 0 0 24 0 56-64.4 0 40-144-49.8 0L152.9 289.6 144.4 320l31.6 0 96 0 0 40 0 24 48 0 0-24 0-40 8 0 24 0 0-48-24 0-8 0 0-56 0-24z"
  ]
}, dC = {
  prefix: "fass",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M317.3 256l-22.6 22.6-192 192L80 493.3 34.7 448l22.6-22.6L226.7 256 57.4 86.6 34.7 64 80 18.7l22.6 22.6 192 192L317.3 256z"
  ]
}, uC = {
  prefix: "fass",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    "M2.7 256l22.6 22.6 192 192L240 493.3 285.3 448l-22.6-22.6L93.3 256 262.6 86.6 285.3 64 240 18.7 217.4 41.4l-192 192L2.7 256z"
  ]
}, fC = {
  prefix: "fass",
  iconName: "circle-1",
  icon: [
    512,
    512,
    [],
    "e0ee",
    "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176 80l0 48 24 0 56 0 56 0 24 0 0-48-24 0-32 0 0-184 0-24-24 0-8 0-6.2 0-5.4 3L176 164.5l0 54.9 11.7-6.5L232 188.3 232 336l-32 0-24 0z"
  ]
}, pC = {
  prefix: "fass",
  iconName: "play",
  icon: [
    384,
    512,
    [9654],
    "f04b",
    "M384 256L0 32V480L384 256z"
  ]
}, mC = {
  prefix: "fass",
  iconName: "circle-5",
  icon: [
    512,
    512,
    [],
    "e0f2",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128l104 0 24 0 0 48-24 0-82.1 0L226 218.9l56 6.7c39.9 4.8 70 38.7 70 78.9c0 43.9-35.6 79.5-79.5 79.5l-33 0c-29.8 0-57.1-16.4-71.2-42.6l-5.4-10 42.3-22.7 5.4 10c5.7 10.7 16.9 17.3 29 17.3l33 0c17.4 0 31.5-14.1 31.5-31.5c0-15.9-11.9-29.3-27.7-31.2l-79.1-9.5L174 261.1l2.1-23.2 8-88 2-21.8 21.9 0z"
  ]
}, hC = {
  prefix: "fass",
  iconName: "pause",
  icon: [
    320,
    512,
    [9208],
    "f04c",
    "M128 64L0 64 0 448l128 0 0-384zm192 0L192 64l0 384 128 0 0-384z"
  ]
}, gC = {
  prefix: "fal",
  iconName: "calendar-check",
  icon: [
    448,
    512,
    [],
    "f274",
    "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM331.3 283.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l112-112z"
  ]
}, vC = {
  prefix: "fal",
  iconName: "calendar-days",
  icon: [
    448,
    512,
    ["calendar-alt"],
    "f073",
    "M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192l-104 0 0 72 104 0 0-72zm0 104l-104 0 0 80 104 0 0-80zm0 112l-104 0 0 72 72 0c17.7 0 32-14.3 32-32l0-40zM280 376l0-80-112 0 0 80 112 0zM168 408l0 72 112 0 0-72-112 0zm-32-32l0-80L32 296l0 80 104 0zM32 408l0 40c0 17.7 14.3 32 32 32l72 0 0-72L32 408zm0-144l104 0 0-72L32 192l0 72zm136 0l112 0 0-72-112 0 0 72zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32z"
  ]
}, bC = {
  prefix: "fat",
  iconName: "graduation-cap",
  icon: [
    640,
    512,
    [127891, "mortar-board"],
    "f19d",
    "M301.8 51.2L21.3 152.5c-3.2 1.1-5.3 4.2-5.3 7.5s2.1 6.4 5.3 7.5L115 201.4c12.7-10.1 27-18.4 42.8-24.3l159.4-59.8c4.1-1.6 8.7 .5 10.3 4.7s-.5 8.7-4.7 10.3L163.4 192.1c-10.9 4.1-21 9.4-30.3 15.8l168.7 60.9c5.8 2.1 12 3.2 18.2 3.2s12.4-1.1 18.2-3.2L618.7 167.5c3.2-1.1 5.3-4.2 5.3-7.5s-2.1-6.4-5.3-7.5L338.2 51.2c-5.8-2.1-12-3.2-18.2-3.2s-12.4 1.1-18.2 3.2zm-5.4 232.7L118.3 219.6c-27.7 25.1-44.8 60.6-46.2 99.2l7.1 18.9c11.1 29.6 16.8 61 16.8 92.7L96 472c0 2.5-1.2 4.9-3.2 6.4s-4.7 2-7.1 1.2l-80-24c-2.6-.8-4.6-2.8-5.4-5.4s-.2-5.4 1.5-7.4l8.8-10.5c19.6-23.6 33.1-51.6 39.1-81.7l6.4-31.8c1.3-40.3 18-77.7 45.4-105.3L15.8 182.6C6.3 179.1 0 170.1 0 160s6.3-19.1 15.8-22.6L296.3 36.1c7.6-2.7 15.6-4.1 23.7-4.1s16.1 1.4 23.7 4.1L624.2 137.4c9.5 3.4 15.8 12.5 15.8 22.6s-6.3 19.1-15.8 22.6L343.7 283.9c-7.6 2.7-15.6 4.1-23.7 4.1s-16.1-1.4-23.7-4.1zM158.8 268.2L144 408.6c.2 2.4 2 7 9.5 13.5c7.9 6.8 20.1 13.9 36.5 20.3C222.7 455.1 268.6 464 320 464s97.3-8.9 129.9-21.6c16.4-6.4 28.6-13.5 36.5-20.3c7.5-6.5 9.3-11.2 9.5-13.5L481.2 268.2l15.5-5.6L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.3-145.4 15.5 5.6zM65.4 353.8c-6.5 32.7-21.1 63.2-42.5 88.8l-1 1.2L80 461.2l0-30.8c0-27.7-4.6-55.1-13.7-81.2l-.9 4.6z"
  ]
}, yC = {
  prefix: "fat",
  iconName: "shield-keyhole",
  icon: [
    512,
    512,
    [],
    "e248",
    "M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 23.8 17.3 43.5 40 47.3l0 72.7c0 4.4 3.6 8 8 8s8-3.6 8-8l0-72.7c22.7-3.8 40-23.6 40-47.3z"
  ]
}, xC = {
  prefix: "fat",
  iconName: "circle-3",
  icon: [
    512,
    512,
    [],
    "e0f0",
    "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128c-4.4 0-8 3.6-8 8s3.6 8 8 8l138.7 0-112 98c-2.5 2.2-3.4 5.7-2.2 8.9s4.2 5.2 7.5 5.2l79.5-.4c31.1-.1 56.4 25.1 56.4 56.2c0 31-25.2 56.2-56.2 56.2l-71.1 0c-12.1 0-23.2-6.8-28.6-17.7l-4.9-9.9c-2-4-6.8-5.6-10.7-3.6s-5.6 6.8-3.6 10.7l4.9 9.9c8.1 16.3 24.8 26.5 42.9 26.5l71.1 0c39.9 0 72.2-32.3 72.2-72.2c0-40-32.5-72.4-72.5-72.2l-58.1 .3L333.3 142c2.5-2.2 3.4-5.7 2.2-8.8s-4.2-5.2-7.5-5.2l-160 0z"
  ]
}, _C = {
  prefix: "fat",
  iconName: "boot",
  icon: [
    512,
    512,
    [129406],
    "f782",
    "M32 16l320 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L16 112l0-80c0-8.8 7.2-16 16-16zM0 32l0 80 0 16 16 0 336 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 0C14.3 0 0 14.3 0 32zM240 160c-4.4 0-8 3.6-8 8s3.6 8 8 8l96 0 0 48-96 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l108.6 0 100.3 45.1c28.7 12.9 47.2 41.5 47.2 73l0 41.9L16 400l0-240L0 160 0 400l0 16 0 41.4c0 14.5 5.8 28.4 16 38.6s24.1 16 38.6 16l14.9 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l11 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l11 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l14.9 0c14.5 0 28.4-5.8 38.6-16s16-24.1 16-38.6l0-41.4 0-16 0-41.9c0-37.8-22.2-72-56.6-87.5L352 224l0-56c0-4.4-3.6-8-8-8l-104 0zM16 416l480 0 0 41.4c0 10.2-4.1 20.1-11.3 27.3s-17.1 11.3-27.3 11.3l-14.9 0c-12.7 0-24.9-5.1-33.9-14.1l-7.6-7.6c-9.4-9.4-24.6-9.4-33.9 0l-7.6 7.6c-9 9-21.2 14.1-33.9 14.1l-11 0c-12.7 0-24.9-5.1-33.9-14.1l-7.6-7.6c-9.4-9.4-24.6-9.4-33.9 0l-7.6 7.6c-9 9-21.2 14.1-33.9 14.1l-11 0c-12.7 0-24.9-5.1-33.9-14.1l-7.6-7.6c-9.4-9.4-24.6-9.4-33.9 0l-7.6 7.6c-9 9-21.2 14.1-33.9 14.1l-14.9 0c-10.2 0-20.1-4.1-27.3-11.3S16 467.6 16 457.4L16 416z"
  ]
}, wC = {
  prefix: "fat",
  iconName: "circle-2",
  icon: [
    512,
    512,
    [],
    "e0ef",
    "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM219.4 157.9c11.2-9 25.2-13.8 39.6-13.6l2.3 0c32.6 .5 58.8 27 58.8 59.6c0 15.8-6.3 31-17.5 42.2L178.3 370.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9l160 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-140.7 0L313.9 257.5C328 243.3 336 224 336 204c0-41.3-33.2-75-74.5-75.6l-2.3 0c-18.1-.3-35.7 5.8-49.8 17.1L179 169.8c-3.5 2.8-4 7.8-1.2 11.2s7.8 4 11.2 1.2l30.4-24.3z"
  ]
}, CC = {
  prefix: "fat",
  iconName: "syringe",
  icon: [
    512,
    512,
    [128137],
    "f48e",
    "M402.3 2.3c-3.1 3.1-3.1 8.2 0 11.3L444.7 56 384 116.7 301.7 34.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l88 88 88 88c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L395.3 128 456 67.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-48-48-48-48c-3.1-3.1-8.2-3.1-11.3 0zm-264 232L80.4 292.3C69.9 302.8 64 317 64 331.9l0 104.8L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L75.3 448l104.8 0c14.9 0 29.1-5.9 39.6-16.4L425.4 225.9l-11.3-11.3L208.4 420.3c-7.5 7.5-17.7 11.7-28.3 11.7L80 432l0-100.1c0-10.6 4.2-20.8 11.7-28.3L144 251.3l58.3 58.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L155.3 240 208 187.3l58.3 58.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L219.3 176l78.1-78.1L286.1 86.6l-83.7 83.7s0 0 0 0s0 0 0 0l-64 64s0 0 0 0s0 0 0 0z"
  ]
}, SC = {
  prefix: "fat",
  iconName: "circle-4",
  icon: [
    512,
    512,
    [],
    "e0f1",
    "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM235 128.6c4.1 1.7 6 6.3 4.4 10.4L171.9 304 304 304l0-104c0-4.4 3.6-8 8-8s8 3.6 8 8l0 104 24 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-24 0 0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-56-144 0c-2.7 0-5.2-1.3-6.6-3.5s-1.8-5-.8-7.5l72-176c1.7-4.1 6.3-6 10.4-4.4z"
  ]
}, LC = {
  prefix: "fat",
  iconName: "buildings",
  icon: [
    512,
    512,
    [],
    "e0cc",
    "M256 16c-26.5 0-48 21.5-48 48l0 384c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-384c0-26.5-21.5-48-48-48L256 16zM192 64c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-384zM56 128l104 0 0 16L56 144c-22.1 0-40 17.9-40 40l0 272c0 22.1 17.9 40 40 40l116.8 0c3.3 5.7 7.2 11.1 11.6 16L56 512c-30.9 0-56-25.1-56-56L0 184c0-30.9 25.1-56 56-56zm8 216c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-32zm24-8c-4.4 0-8 3.6-8 8l0 32c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-32 0zm0-144l32 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24zm-8 24l0 32c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8zM368 376l0-32c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm24 8l32 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8l0 32c0 4.4 3.6 8 8 8zm0-112c-13.3 0-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-32 0zm-8-24c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8l0 32zM256 376l0-32c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm24 8l32 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8l0 32c0 4.4 3.6 8 8 8zm0-312l32 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24zm-8 24l0 32c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8zM256 248l0-32c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm24 8l32 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8l0 32c0 4.4 3.6 8 8 8zM392 72l32 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24zm-8 24l0 32c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8z"
  ]
}, MC = {
  prefix: "fat",
  iconName: "book",
  icon: [
    448,
    512,
    [128212],
    "f02d",
    "M0 56C0 25.1 25.1 0 56 0L408 0c22.1 0 40 17.9 40 40l0 336c0 19.4-13.7 35.5-32 39.2l0 80.8 24 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L56 512c-30.9 0-56-25.1-56-56L0 56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40l344 0 0-80L56 416zm-40 .8C26.2 406.4 40.3 400 56 400l56 0 0-384L56 16C33.9 16 16 33.9 16 56l0 360.8zM128 16l0 384 280 0c13.3 0 24-10.7 24-24l0-336c0-13.3-10.7-24-24-24L128 16zm48 120c0-4.4 3.6-8 8-8l192 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-192 0c-4.4 0-8-3.6-8-8zm0 80c0-4.4 3.6-8 8-8l192 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-192 0c-4.4 0-8-3.6-8-8z"
  ]
}, NC = {
  prefix: "fat",
  iconName: "shoe-prints",
  icon: [
    640,
    512,
    [],
    "f54b",
    "M276.6 42.3c9.8-2.9 23.6-6.9 39.4-10.8C347.8 23.6 386.2 16 416 16c45.7 0 99.3 11.5 140.8 32.3C599.3 69.6 624 97.4 624 128c0 29.8-21.6 49.8-56.5 63c-34.4 13-76.3 17-103.5 17c-43.6 0-68.5-14.1-96.1-29.9l-.3-.2c-25.3-14.5-52.8-30.2-95.7-33.4l0-100.9c1.4-.4 3-.9 4.6-1.4zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32l0 112 0 16s0 0 0 0zm-64-16c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0 0-16-32 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l32 0 0-16-32 0zM148.6 469.7c-1.7-.5-3.2-1-4.6-1.4l0-100.9c42.8-3.2 70.3-18.9 95.7-33.4l.3-.2C267.5 318.1 292.4 304 336 304c27.2 0 69 3.9 103.5 17c34.9 13.2 56.5 33.2 56.5 63c0 30.6-24.7 58.4-67.2 79.7C387.3 484.5 333.7 496 288 496c-29.8 0-68.2-7.6-100-15.5c-15.7-3.9-29.5-7.9-39.4-10.8zM128 352s0 0 0 0l0 16 0 112s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM64 368l32 0 0-16-32 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l32 0 0-16-32 0c-26.5 0-48-21.5-48-48s21.5-48 48-48z"
  ]
}, zC = {
  prefix: "fat",
  iconName: "calendar",
  icon: [
    448,
    512,
    [128197, 128198],
    "f133",
    "M120 0c4.4 0 8 3.6 8 8l0 56 192 0 0-56c0-4.4 3.6-8 8-8s8 3.6 8 8l0 56 48 0c35.3 0 64 28.7 64 64l0 48 0 16 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-16 0-48C0 92.7 28.7 64 64 64l48 0 0-56c0-4.4 3.6-8 8-8zM432 192L16 192l0 256c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-256zM112 120l0-40L64 80c-26.5 0-48 21.5-48 48l0 48 416 0 0-48c0-26.5-21.5-48-48-48l-48 0 0 40c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-40L128 80l0 40c0 4.4-3.6 8-8 8s-8-3.6-8-8z"
  ]
}, EC = {
  prefix: "fat",
  iconName: "shield-heart",
  icon: [
    512,
    512,
    [],
    "e574",
    "M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM160 217.9c0-23.2 18.8-41.9 41.9-41.9c11.1 0 21.8 4.4 29.7 12.3L250.3 207c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3l18.7-18.7c7.9-7.9 18.5-12.3 29.7-12.3c23.2 0 41.9 18.8 41.9 41.9l0 .6c0 10.6-4 20.9-11.2 28.8l-78.9 86.1c-1.5 1.7-3.7 2.6-5.9 2.6s-4.4-.9-5.9-2.6l-78.9-86.1c-7.2-7.8-11.2-18.1-11.2-28.8l0-.6zM201.9 160c-32 0-57.9 25.9-57.9 57.9l0 .6c0 14.7 5.5 28.8 15.4 39.6l78.9 86.1c4.5 5 11 7.8 17.7 7.8s13.1-2.8 17.7-7.8l78.9-86.1c9.9-10.8 15.4-24.9 15.4-39.6l0-.6c0-32-25.9-57.9-57.9-57.9c-15.4 0-30.1 6.1-41 17L256 190.1 242.9 177c-10.9-10.9-25.6-17-41-17z"
  ]
}, TC = {
  prefix: "fat",
  iconName: "house-medical",
  icon: [
    576,
    512,
    [],
    "e3b2",
    "M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1 64 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-230.9L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448l0-245.1L288 18.7 496 202.9 496 448c0 26.5-21.5 48-48 48l-320 0c-26.5 0-48-21.5-48-48zM264 200c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 56c0 4.4 3.6 8 8 8l56 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-56 0c-4.4 0-8 3.6-8 8l0 56c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-56c0-4.4-3.6-8-8-8l-56 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8l56 0c4.4 0 8-3.6 8-8l0-56zm8-24c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24l32 0c13.3 0 24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24l0-32c0-13.3-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24l-32 0z"
  ]
}, kC = {
  prefix: "fat",
  iconName: "trophy",
  icon: [
    576,
    512,
    [127942],
    "f091",
    "M176 16l224 0c17.7 0 31.8 14.5 31.1 31.6c-6.3 165.9-45.5 245.5-80.2 283.6c-17.3 19-33.8 28.1-45.5 32.5c-5.9 2.2-10.6 3.3-13.7 3.8c-1.5 .2-2.7 .4-3.3 .4l-.4 0-.4 0c-.6-.1-1.8-.2-3.3-.4c-3.1-.5-7.8-1.6-13.7-3.8c-11.7-4.4-28.2-13.5-45.5-32.5c-34.7-38.1-73.9-117.8-80.2-283.6C144.2 30.5 158.3 16 176 16zM400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L40 64C18.2 64-.7 82 1.8 104.9c10.2 92 62.3 158.4 119 202.8c56.5 44.3 118.4 67.5 149.8 73c0 0 0 0 0 0c3.6 1.1 6.8 1.9 9.4 2.3l0 113-112 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l120 0 120 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-112 0 0-113c2.6-.5 5.8-1.2 9.4-2.3c0 0 0 0 0 0c31.5-5.5 93.3-28.7 149.8-73c56.7-44.5 108.8-110.8 119-202.8C576.7 82 557.8 64 536 64l-89.6 0c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zm45.4 80L536 80c13.5 0 23.7 10.9 22.3 23.1c-9.6 86.5-58.5 149.3-113 192c-29.5 23.2-60.5 40.2-87.2 51.8c37.1-37.7 77-113.7 87.3-266.9zM217.9 346.9c-26.7-11.6-57.7-28.6-87.2-51.8c-54.4-42.7-103.4-105.5-113-192C16.3 90.9 26.5 80 40 80l90.6 0c10.3 153.2 50.3 229.2 87.3 266.9z"
  ]
}, jC = {
  prefix: "fat",
  iconName: "cars",
  icon: [
    640,
    512,
    [],
    "f85b",
    "M124.2 16l135.6 0c17.9 0 33.6 11.8 38.5 29l19.5 68.2c-4.5-.8-9-1.2-13.7-1.2L80 112c-4.7 0-9.3 .4-13.7 1.2L85.7 45c4.9-17.2 20.6-29 38.5-29zM48.3 117.8l1 .3C20.4 130.1 0 158.7 0 192l0 64 0 16 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 191.2 0 4.6-16L80 256l-16 0-48 0 0-64c0-35.3 28.7-64 64-64l224 0c18.6 0 35.3 7.9 47 20.5c5.7-1.8 11.5-3.1 17.5-3.8c-8.6-11.7-20.3-21-33.9-26.6l1-.3L313.6 40.6C306.8 16.6 284.8 0 259.8 0L124.2 0c-25 0-47 16.6-53.8 40.6L48.3 117.8zM16 272l48 0 0 32c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-32zm80-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM80 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm261.7 61l-19.5 68.2c4.5-.8 9-1.2 13.7-1.2l224 0c4.7 0 9.3 .4 13.7 1.2L554.3 221c-4.9-17.2-20.6-29-38.5-29l-135.6 0c-17.9 0-33.6 11.8-38.5 29zm-36.4 73.1l-1-.3 22.1-77.2c6.9-24 28.8-40.6 53.8-40.6l135.6 0c25 0 47 16.6 53.8 40.6l22.1 77.2-1 .3c29 12 49.3 40.6 49.3 73.9l0 64 0 16 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32-224 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32 0-16 0-64c0-33.3 20.4-61.9 49.3-73.9zM560 432l16 0 48 0 0-64c0-35.3-28.7-64-64-64l-224 0c-35.3 0-64 28.7-64 64l0 64 48 0 16 0 224 0zm16 16l0 32c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-32-48 0zm-304 0l0 32c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-32-48 0zm64-96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm176 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
  ]
}, PC = {
  prefix: "fat",
  iconName: "users-line",
  icon: [
    640,
    512,
    [],
    "e592",
    "M147.2 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm110.4-16a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm48 208c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80l96 0c44.2 0 80 35.8 80 80zm-176-96c-53 0-96 43-96 96c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32c0-53-43-96-96-96l-96 0zM0 456c0 4.4 3.6 8 8 8l624 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 448c-4.4 0-8 3.6-8 8zM48 256c0-26.5 21.5-48 48-48l96 0c4.8 0 9.4 .7 13.7 2c4.2 1.3 8.7-1.2 9.9-5.4s-1.2-8.7-5.4-9.9c-5.8-1.7-11.9-2.7-18.3-2.7l-96 0c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l88 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-88 0c-8.8 0-16-7.2-16-16zM496 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm99.2 96c0 8.8-7.2 16-16 16l-88 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l88 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-6.3 0-12.5 .9-18.3 2.7c-4.2 1.3-6.6 5.7-5.4 9.9s5.7 6.6 9.9 5.4c4.3-1.3 8.9-2 13.7-2l96 0c26.5 0 48 21.5 48 48z"
  ]
}, AC = {
  prefix: "fat",
  iconName: "baby",
  icon: [
    448,
    512,
    [],
    "f77c",
    "M313.5 237c14.2-6.3 27.7-14.1 40.4-23.3l36.2-26.4c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3l-36.2 26.4C296.1 196.4 260.5 208 224 208s-72.1-11.6-101.6-33.1L86.1 148.6c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5l36.2 26.4c12.7 9.2 26.2 17 40.4 23.3c5.8 2.6 9.5 8.3 9.5 14.6l0 36.3 160 0 0-36.3c0-6.3 3.7-12.1 9.5-14.6zM144 304l0 16.7L198 368l52 0 54-47.3 0-16.7-160 0zm162.4 35.9L269.7 372c.9 .8 1.8 1.8 2.5 2.8l24.8 35.4c4.5 6.4 3.7 15-1.8 20.5L271 455c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c8.2-8.2 9.4-21.2 2.7-30.7l-48.8-69.7c-.2-.2-.3-.5-.5-.7zM178.3 372l-36.7-32.1c-.1 .2-.3 .5-.5 .7L92.3 410.2c-6.7 9.5-5.5 22.5 2.7 30.7l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-24.3-24.3c-5.5-5.5-6.2-14.1-1.8-20.5l24.8-35.4c.7-1.1 1.6-2 2.5-2.8zM320 288l0 16 0 24 0 3.4 48.8 69.7c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4 259.2 384l-3.2 0-64 0-3.2 0L164 419.4l24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1L128 331.4l0-3.4 0-24 0-16 0-36.3c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9s38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25l0 36.3zM280 88A56 56 0 1 0 168 88a56 56 0 1 0 112 0zM152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88z"
  ]
}, $C = {
  prefix: "fat",
  iconName: "circle-1",
  icon: [
    512,
    512,
    [],
    "e0ee",
    "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM260 129.1c2.5 1.4 4 4.1 4 6.9l0 232 56 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-64 0-64 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l56 0 0-218.2-44 25.2c-3.8 2.2-8.7 .9-10.9-3s-.9-8.7 3-10.9l56-32c2.5-1.4 5.5-1.4 8 0z"
  ]
}, IC = {
  prefix: "fat",
  iconName: "hospitals",
  icon: [
    576,
    512,
    [],
    "f80e",
    "M256 56c0-30.9 25.1-56 56-56L520 0c30.9 0 56 25.1 56 56l0 400c0 30.9-25.1 56-56 56l-216 0c3.7-4.9 6.8-10.3 9.3-16L520 496c22.1 0 40-17.9 40-40l0-56-232 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l232 0 0-80-232 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l232 0 0-232c0-22.1-17.9-40-40-40L312 16c-22.1 0-40 17.9-40 40l0 8c0 2.2-.9 4.2-2.4 5.7c-4.3-1.7-8.8-3.1-13.5-4c-.1-.5-.2-1.1-.2-1.6l0-8zM64 112c-26.5 0-48 21.5-48 48l0 192 256 0 0-192c0-26.5-21.5-48-48-48L64 112zM16 368l0 48 256 0 0-48L16 368zm256 64L16 432l0 16c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-16zM0 160c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160zm112 32c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24l16 0 0-16zm24-8c-4.4 0-8 3.6-8 8l0 24c0 4.4-3.6 8-8 8l-24 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l24 0c4.4 0 8 3.6 8 8l0 24c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-24c0-4.4 3.6-8 8-8l24 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-24 0c-4.4 0-8-3.6-8-8l0-24c0-4.4-3.6-8-8-8l-16 0zM424 72l16 0c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24zm-8 24l0 24c0 4.4-3.6 8-8 8l-24 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l24 0c4.4 0 8 3.6 8 8l0 24c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-24c0-4.4 3.6-8 8-8l24 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-24 0c-4.4 0-8-3.6-8-8l0-24c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z"
  ]
}, OC = {
  prefix: "fat",
  iconName: "fax",
  icon: [
    512,
    512,
    [128224, 128439],
    "f1ac",
    "M160 56c0-22.1 17.9-40 40-40l180.1 0c10.6 0 20.8 4.2 28.3 11.7l27.9 27.9c7.5 7.5 11.7 17.7 11.7 28.3l0 76.1 16 0 0-76.1c0-14.9-5.9-29.1-16.4-39.6L419.7 16.4C409.2 5.9 395 0 380.1 0L200 0c-30.9 0-56 25.1-56 56l0 93.7C132.3 136.4 115.1 128 96 128l-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l32 0c22.9 0 43-12 54.3-30.1c9.3 17.9 28.1 30.1 49.7 30.1l256 0c30.9 0 56-25.1 56-56l0-208c0-30.9-25.1-56-56-56l-296 0 0-136zm0 152l296 0c22.1 0 40 17.9 40 40l0 208c0 22.1-17.9 40-40 40l-256 0c-22.1 0-40-17.9-40-40l0-7.9c0 0 0 0 0-.1l0-240zM144 448.1c0 26.5-21.5 47.9-48 47.9l-32 0c-26.5 0-48-21.5-48-48l0-256c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 8 0 248c0 0 0 0 0 .1zM232 320a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm144 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-48 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-144 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
  ]
}, RC = {
  prefix: "fat",
  iconName: "hospital",
  icon: [
    640,
    512,
    [62589, 127973, "hospital-alt", "hospital-wide"],
    "f0f8",
    "M160 64c0-35.3 28.7-64 64-64L416 0c35.3 0 64 28.7 64 64l0 32 104 0c30.9 0 56 25.1 56 56l0 304c0 30.9-25.1 56-56 56l-168 0s0 0 0 0l-32 0-8 0-112 0-8 0-32 0s0 0 0 0L56 512c-30.9 0-56-25.1-56-56L0 152c0-30.9 25.1-56 56-56l104 0 0-32zm304 0c0-26.5-21.5-48-48-48L224 16c-26.5 0-48 21.5-48 48l0 32 0 16 0 384 80 0 0-80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80 80 0 0-160 0-224 0-16 0-32zm120 48l-104 0 0 224 0 160 104 0c22.1 0 40-17.9 40-40l0-152-104 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l104 0 0-80-104 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l104 0 0-40c0-22.1-17.9-40-40-40zm-424 0L56 112c-22.1 0-40 17.9-40 40l0 40 104 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L16 208l0 80 104 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L16 304l0 152c0 22.1 17.9 40 40 40l104 0 0-384zM368 416c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80 96 0 0-80zM312 56l16 0c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24zm-8 24l0 24c0 4.4-3.6 8-8 8l-24 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l24 0c4.4 0 8 3.6 8 8l0 24c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-24c0-4.4 3.6-8 8-8l24 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-24 0c-4.4 0-8-3.6-8-8l0-24c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z"
  ]
}, DC = {
  prefix: "fat",
  iconName: "location-dot",
  icon: [
    384,
    512,
    ["map-marker-alt"],
    "f3c5",
    "M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm64 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
  ]
}, FC = {
  prefix: "fat",
  iconName: "credit-card",
  icon: [
    576,
    512,
    [62083, 128179, "credit-card-alt"],
    "f09d",
    "M64 48C37.5 48 16 69.5 16 96l0 32 544 0 0-32c0-26.5-21.5-48-48-48L64 48zM16 144l0 96 544 0 0-96L16 144zm0 112l0 160c0 26.5 21.5 48 48 48l448 0c26.5 0 48-21.5 48-48l0-160L16 256zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 360c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8zm128 0c0-4.4 3.6-8 8-8l144 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-144 0c-4.4 0-8-3.6-8-8z"
  ]
}, BC = {
  prefix: "fat",
  iconName: "kit-medical",
  icon: [
    576,
    512,
    ["first-aid"],
    "f479",
    "M112 464l352 0 0-416L112 48l0 416zm-16 0L96 48 64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l32 0zM64 32l32 0 8 0 8 0 352 0 8 0 8 0 32 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-32 0-8 0-8 0-352 0-8 0-8 0-32 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM480 464l32 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48l-32 0 0 416zM264 168l0 56c0 4.4-3.6 8-8 8l-56 0c-4.4 0-8 3.6-8 8l0 32c0 4.4 3.6 8 8 8l56 0c4.4 0 8 3.6 8 8l0 56c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-56c0-4.4 3.6-8 8-8l56 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-56 0c-4.4 0-8-3.6-8-8l0-56c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8zm8-24l32 0c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24z"
  ]
}, VC = {
  prefix: "fat",
  iconName: "mars",
  icon: [
    448,
    512,
    [9794],
    "f222",
    "M288 40c0 4.4 3.6 8 8 8l124.7 0-126 126c-31.3-28.6-72.9-46-118.7-46C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-45.7-17.4-87.4-46-118.7l126-126L432 184c0 4.4 3.6 8 8 8s8-3.6 8-8l0-144c0-4.4-3.6-8-8-8L296 32c-4.4 0-8 3.6-8 8zM16 304a160 160 0 1 1 320 0A160 160 0 1 1 16 304z"
  ]
}, HC = {
  prefix: "fat",
  iconName: "folder-medical",
  icon: [
    512,
    512,
    [],
    "e18c",
    "M448 464L64 464c-26.5 0-48-21.5-48-48L16 96c0-26.5 21.5-48 48-48l133.5 0c12.7 0 24.9 5.1 33.9 14.1l35.9 35.9c9 9 21.2 14.1 33.9 14.1L448 112c26.5 0 48 21.5 48 48l0 256c0 26.5-21.5 48-48 48zM64 480l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L301.3 96c-8.5 0-16.6-3.4-22.6-9.4L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64zM232 200c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 56c0 4.4 3.6 8 8 8l56 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-56 0c-4.4 0-8 3.6-8 8l0 56c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-56c0-4.4-3.6-8-8-8l-56 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8l56 0c4.4 0 8-3.6 8-8l0-56zm8-24c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24l32 0c13.3 0 24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24l0-32c0-13.3-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24l-32 0z"
  ]
}, qC = {
  prefix: "fat",
  iconName: "house",
  icon: [
    576,
    512,
    [63498, 63500, 127968, "home", "home-alt", "home-lg-alt"],
    "f015",
    "M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1 64 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-230.9L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448l0-245.1L288 18.7 496 202.9 496 448c0 26.5-21.5 48-48 48l-80 0 0-168c0-13.3-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24l0 168-80 0c-26.5 0-48-21.5-48-48zm144 48l0-168c0-4.4 3.6-8 8-8l112 0c4.4 0 8 3.6 8 8l0 168-128 0z"
  ]
}, WC = {
  prefix: "fat",
  iconName: "piggy-bank",
  icon: [
    576,
    512,
    [],
    "f4d3",
    "M272 16c-53 0-96 43-96 96c0 4.4-3.6 8-8 8s-8-3.6-8-8C160 50.1 210.1 0 272 0c56 0 102.4 41.1 110.7 94.8c.7 4.4-2.3 8.5-6.7 9.1s-8.5-2.3-9.1-6.7C359.8 51.2 320 16 272 16zM52 200c-19.9 0-36 16.1-36 36s16.1 36 36 36l12.8 0c8-80.9 76.2-144 159.2-144l157 0c18.9-19.7 45.6-32 75-32l11.2 0c15.8 0 27.3 14.9 23.2 30.2l-9.2 34.7c21.4 16.4 38.6 38.1 49.6 63.2l13.3 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-32 0c-16.5 22-38.5 39.5-64 50.7l0 29.3c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-16-64 0 0 16c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-48c-38.8-29.2-64-75.7-64-128l-12 0c-28.7 0-52-23.3-52-52s23.3-52 52-52l4 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-4 0zM248 432l80 0 16 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-8 0 0 16c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-34.6c0-3.3 2-6.2 5.1-7.4c26-10.3 48.4-28 64.4-50.6c1.5-2.1 3.9-3.4 6.5-3.4l36.1 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-18.6 0c-3.3 0-6.2-2-7.4-5.1c-10.3-26-28-48.4-50.6-64.4c-2.7-1.9-4-5.4-3.1-8.6l10.6-39.9c1.4-5.1-2.5-10.1-7.7-10.1L456 112c-26.1 0-49.5 11.3-65.6 29.3c-1.5 1.7-3.7 2.7-6 2.7l-.4 0s0 0 0 0l-160 0c-79.5 0-144 64.5-144 144c0 48.5 23.9 91.3 60.6 117.4c2.1 1.5 3.4 3.9 3.4 6.5l0 52.1c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-16-8 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l16 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  ]
}, UC = {
  prefix: "fat",
  iconName: "clock",
  icon: [
    512,
    512,
    [128339, "clock-four"],
    "f017",
    "M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104l0 152c0 2.7 1.3 5.2 3.6 6.7l96 64c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1L264 251.7 264 104c0-4.4-3.6-8-8-8s-8 3.6-8 8z"
  ]
}, GC = {
  prefix: "fat",
  iconName: "shield-plus",
  icon: [
    512,
    512,
    [],
    "e24a",
    "M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM248 352c0 4.4 3.6 8 8 8s8-3.6 8-8l0-88 88 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-88 0 0-88c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 88-88 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l88 0 0 88z"
  ]
}, YC = {
  prefix: "fat",
  iconName: "chart-user",
  icon: [
    640,
    512,
    ["user-chart"],
    "f6a3",
    "M224 16l352 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-247.7 0c3.1 5.2 6 10.5 8.5 16L576 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 32c5.4 0 10.8 .3 16 1l0-33c0-26.5 21.5-48 48-48zM416 120c0 4.4 3.6 8 8 8l76.7 0L384 244.7l-74.3-74.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l80 80c3.1 3.1 8.2 3.1 11.3 0L512 139.3l0 76.7c0 4.4 3.6 8 8 8s8-3.6 8-8l0-96c0-4.4-3.6-8-8-8l-96 0c-4.4 0-8 3.6-8 8zM133.3 368l53.3 0C251.5 368 304 420.5 304 485.3c0 5.9-4.8 10.7-10.7 10.7L26.7 496c-5.9 0-10.7-4.8-10.7-10.7C16 420.5 68.5 368 133.3 368zm0-16C59.7 352 0 411.7 0 485.3C0 500.1 11.9 512 26.7 512l266.7 0c14.7 0 26.7-11.9 26.7-26.7C320 411.7 260.3 352 186.7 352l-53.3 0zM80 224a80 80 0 1 1 160 0A80 80 0 1 1 80 224zm176 0A96 96 0 1 0 64 224a96 96 0 1 0 192 0z"
  ]
}, KC = {
  prefix: "fat",
  iconName: "circle-5",
  icon: [
    512,
    512,
    [],
    "e0f2",
    "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 128c-3.7 0-7 2.6-7.8 6.2l-24 104c-.5 2.3 0 4.6 1.3 6.5s3.5 3.1 5.8 3.3l110.7 10.1c28.4 2.6 50.1 26.4 50.1 54.9c0 30.4-24.7 55.1-55.1 55.1l-53.1 0c-21.3 0-41.3-10.7-53.2-28.5l-13.3 8.9c14.8 22.1 39.8 35.5 66.5 35.5l53.1 0c39.3 0 71.1-31.8 71.1-71.1c0-36.8-28-67.4-64.6-70.8l-101.5-9.3L206.4 144 328 144c4.4 0 8-3.6 8-8s-3.6-8-8-8l-128 0z"
  ]
}, XC = {
  prefix: "fat",
  iconName: "dumbbell",
  icon: [
    640,
    512,
    [],
    "f44b",
    "M184 48c13.3 0 24 10.7 24 24l0 184 0 184c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-64 0-240 0-64c0-13.3 10.7-24 24-24l32 0zM112 408l0 32c0 22.1 17.9 40 40 40l32 0c22.1 0 40-17.9 40-40l0-176 192 0 0 176c0 22.1 17.9 40 40 40l32 0c22.1 0 40-17.9 40-40l0-32c6.7 5 15 8 24 8l16 0c22.1 0 40-17.9 40-40l0-112 24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-112c0-22.1-17.9-40-40-40l-16 0c-9 0-17.3 3-24 8l0-32c0-22.1-17.9-40-40-40l-32 0c-22.1 0-40 17.9-40 40l0 176-192 0 0-176c0-22.1-17.9-40-40-40l-32 0c-22.1 0-40 17.9-40 40l0 32c-6.7-5-15-8-24-8L72 96c-22.1 0-40 17.9-40 40l0 112L8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0 0 112c0 22.1 17.9 40 40 40l16 0c9 0 17.3-3 24-8zM528 136c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 120 0 120c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-240zM512 376l0 64c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-184 0-184c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 64 0 240zM112 136l0 240c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-120 0-120c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24z"
  ]
}, ZC = {
  prefix: "fat",
  iconName: "plate-utensils",
  icon: [
    640,
    512,
    [58713],
    "e43b",
    "M8 16c-4.4 0-8 3.6-8 8L0 184c0 22.1 17.9 40 40 40l24 0 0 264c0 4.4 3.6 8 8 8s8-3.6 8-8l0-264 24 0c22.1 0 40-17.9 40-40l0-160c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 160c0 13.3-10.7 24-24 24l-24 0L80 24c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 184-24 0c-13.3 0-24-10.7-24-24L16 24c0-4.4-3.6-8-8-8zM498 78.9C455.3 39.8 398.4 16 336 16c-61.5 0-117.5 23.1-160 61.1l0 22.1C216.7 57.7 273.3 32 336 32c60.3 0 115 23.8 155.3 62.5c2-5.5 4.3-10.7 6.7-15.6zm40.6 272.9C502.6 427.6 425.4 480 336 480c-91.4 0-170.1-54.8-204.9-133.3c-4.9 2-10.1 3.5-15.6 4.4C152.4 436.3 237.2 496 336 496c98.4 0 183-59.2 220-144l-12 0c-1.8 0-3.7-.1-5.4-.2zM480 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-272 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM618.6 32c0 0 0 0 0 0c.1 0 .2 0 .5 0c2.7 0 4.9 2.2 4.9 4.9L624 304l-80 0c-8.8 0-16-7.2-16-16l0-128c0-89.7 74.6-122.1 90.6-128zM640 304l0-267.1c0-11.5-9.3-20.9-20.9-20.9c-2.1 0-4.1 .3-6.1 1C596.2 23.2 512 59.2 512 160l0 128c0 17.7 14.3 32 32 32l80 0 0 168c0 4.4 3.6 8 8 8s8-3.6 8-8l0-168 0-8 0-8z"
  ]
}, QC = {
  prefix: "fat",
  iconName: "user-doctor",
  icon: [
    448,
    512,
    ["user-md"],
    "f0f0",
    "M224 240a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM152 322l0 46.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3l0-43.4C66.9 343.5 16 406.4 16 481.2c0 8.2 6.6 14.8 14.8 14.8l386.4 0c8.2 0 14.8-6.6 14.8-14.8c0-74.8-50.9-137.7-120-155.9l0 43.4c22.7 3.8 40 23.6 40 47.3l0 40c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l8 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32 8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-40c0-23.8 17.3-43.5 40-47.3l0-46.7c-8.2-1.3-16.6-2-25.2-2l-93.6 0c-8.6 0-17 .7-25.2 2zm-8 62a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM0 481.2C0 383.3 79.3 304 177.2 304l93.6 0C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8L30.8 512C13.8 512 0 498.2 0 481.2z"
  ]
}, JC = {
  prefix: "fat",
  iconName: "shield-virus",
  icon: [
    512,
    512,
    [],
    "e06c",
    "M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM248 119.1c0-4.4 3.6-8 8-8s8 3.6 8 8c0 37.5 45.3 56.3 71.9 29.8c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3C320.7 186.7 339.5 232 377 232c4.4 0 8 3.6 8 8s-3.6 8-8 8c-37.5 0-56.3 45.3-29.8 71.9c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0C309.4 304.7 264 323.5 264 361c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-37.5-45.3-56.3-71.9-29.8c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3c26.5-26.5 7.7-71.9-29.8-71.9c-4.4 0-8-3.6-8-8s3.6-8 8-8c37.5 0 56.3-45.3 29.8-71.9c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0c26.5 26.5 71.9 7.7 71.9-29.8zm8-24c-13.3 0-24 10.7-24 24c0 23.2-28.1 34.9-44.5 18.4c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c16.4 16.4 4.8 44.5-18.4 44.5c-13.3 0-24 10.7-24 24s10.7 24 24 24c23.2 0 34.9 28.1 18.4 44.5c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c16.4-16.4 44.5-4.8 44.5 18.4c0 13.3 10.7 24 24 24s24-10.7 24-24c0-23.2 28.1-34.9 44.5-18.4c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C342.1 292.1 353.7 264 377 264c13.3 0 24-10.7 24-24s-10.7-24-24-24c-23.2 0-34.9-28.1-18.4-44.5c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C308.1 154 280 142.3 280 119.1c0-13.3-10.7-24-24-24zM224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
  ]
}, eS = {
  prefix: "fat",
  iconName: "phone",
  icon: [
    512,
    512,
    [128222, 128379],
    "f095",
    "M317.1 378.1c-4.7 5.7-12.6 7.5-19.2 4.3c-73.8-34.8-133.5-94.5-168.3-168.3c-3.1-6.6-1.3-14.6 4.3-19.2l49.3-40.4c8.2-6.7 11-18 7-27.8l-40-96c-4.6-11.1-16.8-17.1-28.5-13.9l-88 24C23.2 43.7 16 53.2 16 64c0 238.6 193.4 432 432 432c10.8 0 20.3-7.2 23.2-17.7l24-88c3.2-11.6-2.8-23.8-13.9-28.5l-96-40c-9.8-4.1-21.1-1.3-27.8 7l-40.4 49.3zM304.7 368L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7z"
  ]
}, tS = {
  prefix: "fat",
  iconName: "mobile-button",
  icon: [
    384,
    512,
    [],
    "f10b",
    "M96 16C69.5 16 48 37.5 48 64l0 384c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-384c0-26.5-21.5-48-48-48L96 16zM32 64C32 28.7 60.7 0 96 0L288 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64zM176 432a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
  ]
}, nS = {
  prefix: "fat",
  iconName: "head-side-medical",
  icon: [
    512,
    512,
    [],
    "f809",
    "M16 222.9C16 108.6 108.6 16 222.9 16l16.8 0c71.6 0 137.5 43.3 166.4 105c3.5 7.4 6.9 15.1 10.4 22.9c6.4 14.3 12.9 28.9 20.1 42.7c11.3 21.6 24.8 42.2 43.5 58.9l3.8 3.4c7.7 6.9 12.1 16.7 12.1 27c0 20-16.2 36.2-36.2 36.2L440 312c-4.4 0-8 3.6-8 8l0 72c0 22.1-17.9 40-40 40l-80 0c-4.4 0-8 3.6-8 8l0 64c0 4.4 3.6 8 8 8s8-3.6 8-8l0-56 72 0c30.9 0 56-25.1 56-56l0-64 11.8 0c28.8 0 52.2-23.4 52.2-52.2c0-14.9-6.4-29.1-17.5-39l-3.8-3.4c-16.7-14.9-29.2-33.6-40-54.4c-7-13.4-13.1-27.1-19.3-41c-3.5-7.9-7.1-15.9-10.8-23.9C389.1 46.9 317.6 0 239.7 0L222.9 0C99.8 0 0 99.8 0 222.9c0 52.8 16.9 101.5 47.4 139.9C57.5 375.5 64 390.2 64 405.3L64 504c0 4.4 3.6 8 8 8s8-3.6 8-8l0-98.7c0-19.8-8.5-37.8-20.1-52.4C31.8 317.5 16 272.3 16 222.9zM216 120c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 56c0 4.4 3.6 8 8 8l56 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-56 0c-4.4 0-8 3.6-8 8l0 56c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-56c0-4.4-3.6-8-8-8l-56 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8l56 0c4.4 0 8-3.6 8-8l0-56zm8-24c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24l32 0c13.3 0 24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24l0-32c0-13.3-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24l-32 0z"
  ]
}, rS = {
  prefix: "fat",
  iconName: "circle-question",
  icon: [
    512,
    512,
    [62108, "question-circle"],
    "f059",
    "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168-56c0-30.9 25.1-56 56-56l56.2 0c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L264 294.9l0 25.1c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-29.5c0-2.7 1.4-5.2 3.6-6.7l54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8L224 160c-22.1 0-40 17.9-40 40l0 6.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-6.5zm72 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
  ]
}, aS = {
  prefix: "fat",
  iconName: "recycle",
  icon: [
    512,
    512,
    [9842, 9850, 9851],
    "f1b8",
    "M200.6 31.3C212.3 11.9 233.3 0 256 0s43.7 11.9 55.4 31.3l88.2 146.1 15.4-75c.9-4.3 5.1-7.1 9.4-6.2s7.1 5.1 6.2 9.4L411.3 200c-.5 2.2-1.9 4.2-3.8 5.3s-4.4 1.4-6.5 .7l-91.4-30.4c-4.2-1.4-6.5-5.9-5.1-10.1s5.9-6.5 10.1-5.1l70.2 23.3-87-144.2C288.9 24.9 273.1 16 256 16s-32.9 8.9-41.7 23.5l-48.4 80.3c-2.3 3.8-7.2 5-11 2.7c-3.8-2.3-5-7.2-2.7-11l48.4-80.3zM428 239.9c3.8-2.3 8.7-1 11 2.7l65.3 108.3c5 8.2 7.6 17.6 7.7 27.2c.2 29.7-23.8 53.9-53.5 53.9l-213.5 0 56.3 50c3.3 2.9 3.6 8 .7 11.3s-8 3.6-11.3 .7l-72-64c-1.7-1.5-2.7-3.7-2.7-6s1-4.5 2.7-6l72-64c3.3-2.9 8.4-2.6 11.3 .7s2.6 8.4-.7 11.3L245 416l213.5 0c20.8 0 37.6-17 37.5-37.8c-.1-6.7-1.9-13.3-5.4-19L425.3 250.9c-2.3-3.8-1.1-8.7 2.7-11zM114.4 174.1L42.5 197.9c-4.2 1.4-8.7-.9-10.1-5.1s.9-8.7 5.1-10.1l91.4-30.4c2.2-.7 4.5-.5 6.5 .7s3.4 3.1 3.8 5.3l19.4 94.4c.9 4.3-1.9 8.6-6.2 9.4s-8.6-1.9-9.4-6.2l-15.1-73.3L21.4 359.2c-3.5 5.7-5.3 12.3-5.4 19C15.8 399 32.7 416 53.5 416L168 416c4.4 0 8 3.6 8 8s-3.6 8-8 8L53.5 432C23.8 432-.2 407.8 0 378.1c.1-9.6 2.7-19 7.7-27.2L114.4 174.1z"
  ]
}, iS = {
  prefix: "fat",
  iconName: "hands-holding-dollar",
  icon: [
    640,
    512,
    ["hands-usd"],
    "f4c5",
    "M328 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 24.3c-11.4 .9-23.5 4.2-33.5 10.4c-12.8 7.9-22.5 20.9-22.4 39.4c.1 17 9.2 28.1 21.2 35.7c11.1 7 25.5 11.6 38.7 15.8l1.4 .5c14.2 4.5 27 8.7 36.4 14.9c8.9 5.9 14 13 14.2 23.8c.2 12.9-5.6 21.5-14.3 27.1c-9 5.9-21.4 8.6-33.4 8.2c-15.4-.5-29.8-5.7-45.6-11.3c-2.6-.9-5.3-1.9-8-2.9c-4.2-1.5-8.7 .7-10.2 4.9s.7 8.7 4.9 10.2c2.5 .9 5 1.8 7.6 2.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c13.4 4.8 27.8 10 43.1 11.8l0 24.6c0 4.4 3.6 8 8 8s8-3.6 8-8l0-24.2c12-.7 24.3-4 34.4-10.6c12.8-8.3 21.8-21.9 21.6-40.7c-.2-17.5-9.2-29-21.3-37c-11.6-7.7-26.7-12.4-40.4-16.8l-.2-.1c-14.2-4.5-26.9-8.5-36.2-14.4C277 98.6 272.1 92 272.1 82c-.1-11.9 5.8-20.1 14.8-25.7c9.3-5.8 21.7-8.5 33-8.3c13 .2 26.7 3.2 40 6.9c4.3 1.2 8.7-1.3 9.9-5.6s-1.3-8.7-5.6-9.9c-11.3-3.2-23.7-6-36.2-7L328 8zM96 112c0-26.5-21.5-48-48-48S0 85.5 0 112L0 344.2c0 27.6 11 54 30.5 73.5l91.9 91.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L41.8 406.5C25.3 390 16 367.6 16 344.2L16 112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 147c0 20.7 8.2 40.6 22.9 55.2l19.5 19.5 55.9 55.9s0 0 0 0l8 8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-8-8s0 0 0 0l-55.9-55.9s0 0 0 0c-10.6-10.6-11.3-27.6-1.5-39.1c10.9-12.7 30.3-13.5 42.2-1.6l92.8 92.7c13.3 13.3 20.8 31.4 20.8 50.3l0 79.2c0 4.4 3.6 8 8 8s8-3.6 8-8l0-79.2c0-23.1-9.2-45.3-25.5-61.6l-92.8-92.8c-18.4-18.4-48.7-17.3-65.6 2.5c-6.2 7.2-9.7 15.9-10.6 24.7C100.8 286.7 96 273.1 96 259l0-147zM592 64c-26.5 0-48 21.5-48 48l0 147c0 14.1-4.8 27.8-13.5 38.7c-.9-8.8-4.4-17.5-10.6-24.7c-17-19.8-47.2-21-65.6-2.5l-92.7 92.8c-16.3 16.3-25.5 38.5-25.5 61.6l0 79.2c0 4.4 3.6 8 8 8s8-3.6 8-8l0-79.2c0-18.9 7.5-37 20.8-50.3l92.8-92.7c11.8-11.9 31.3-11.1 42.2 1.6c9.8 11.4 9.1 28.4-1.5 39.1c0 0 0 0 0 0l-55.9 55.9s0 0 0 0l-8 8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l8-8 55.9-55.9 19.5-19.5C551.8 299.5 560 279.7 560 259l0-147c0-17.7 14.3-32 32-32s32 14.3 32 32l0 232.2c0 23.3-9.3 45.7-25.8 62.2l-91.9 91.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l91.9-91.9c19.5-19.5 30.5-46 30.5-73.5L640 112c0-26.5-21.5-48-48-48z"
  ]
}, sS = iS, oS = {
  prefix: "fat",
  iconName: "apple-whole",
  icon: [
    448,
    512,
    [127822, 127823, "apple-alt"],
    "f5d1",
    "M240 96l-16 0 0-16c0-35.3 28.7-64 64-64l16 0 0 16c0 35.3-28.7 64-64 64zm0 16c44.2 0 80-35.8 80-80l0-16c0-8.8-7.2-16-16-16L288 0c-44.2 0-80 35.8-80 80l0 16c0 8.8 7.2 16 16 16l16 0zM16 288c0-36 8.5-72.9 25.1-100.3C57.4 160.7 80.8 144 112 144c24.1 0 54.2 9.4 76.9 18.2c22.5 8.8 47.8 8.8 70.3 0c22.7-8.8 52.7-18.2 76.9-18.2c31.2 0 54.6 16.7 70.9 43.7C423.5 215.1 432 252 432 288c0 60.7-19 113.3-46.8 150.4c-28 37.3-63.7 57.6-97.2 57.6c-9.5 0-22.2-2.8-34.1-6.4c-19.4-5.8-40.3-5.8-59.7 0c-11.9 3.6-24.7 6.4-34.1 6.4c-33.5 0-69.2-20.3-97.2-57.6C35 401.3 16 348.7 16 288zm96-160C35.7 128 0 211.7 0 288C0 416 80 512 160 512c11.9 0 26.5-3.4 38.8-7.1c16.4-4.9 34.1-4.9 50.5 0c12.2 3.7 26.8 7.1 38.8 7.1c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128z"
  ]
}, cS = {
  prefix: "fat",
  iconName: "hands-holding-heart",
  icon: [
    640,
    512,
    ["hands-heart"],
    "f4c3",
    "M320 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108L297.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L444.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L320 46.9zm5.7 17l23.4-23.8c23.1-23.5 60.5-23.5 83.6 0c23.2 23.6 23.2 61.9 0 85.5L331.1 228.9c-3.1 3.1-7.1 4.7-11.1 4.7s-8-1.5-11.1-4.7L207.3 125.7c-23.2-23.6-23.2-61.9 0-85.5c23.1-23.5 60.5-23.5 83.6 0l23.4 23.8c3.1 3.2 8.3 3.2 11.4 0zM96 112c0-26.5-21.5-48-48-48S0 85.5 0 112L0 344.2c0 27.6 11 54 30.5 73.5l91.9 91.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L41.8 406.5C25.3 390 16 367.6 16 344.2L16 112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 147c0 20.7 8.2 40.6 22.9 55.2l19.5 19.5 55.9 55.9s0 0 0 0l8 8c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-8-8s0 0 0 0l-55.9-55.9s0 0 0 0c-10.6-10.6-11.3-27.6-1.5-39.1c10.9-12.7 30.3-13.5 42.2-1.6l92.8 92.7c13.3 13.3 20.8 31.4 20.8 50.3l0 79.2c0 4.4 3.6 8 8 8s8-3.6 8-8l0-79.2c0-23.1-9.2-45.3-25.5-61.6l-92.8-92.8c-18.4-18.4-48.7-17.3-65.6 2.5c-6.2 7.2-9.7 15.9-10.6 24.7C100.8 286.7 96 273.1 96 259l0-147zM592 64c-26.5 0-48 21.5-48 48l0 147c0 14.1-4.8 27.8-13.5 38.7c-.9-8.8-4.4-17.5-10.6-24.7c-17-19.8-47.2-21-65.6-2.5l-92.7 92.8c-16.3 16.3-25.5 38.5-25.5 61.6l0 79.2c0 4.4 3.6 8 8 8s8-3.6 8-8l0-79.2c0-18.9 7.5-37 20.8-50.3l92.8-92.7c11.8-11.9 31.3-11.1 42.2 1.6c9.8 11.4 9.1 28.4-1.5 39.1c0 0 0 0 0 0l-55.9 55.9s0 0 0 0l-8 8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l8-8 55.9-55.9 19.5-19.5C551.8 299.5 560 279.7 560 259l0-147c0-17.7 14.3-32 32-32s32 14.3 32 32l0 232.2c0 23.3-9.3 45.7-25.8 62.2l-91.9 91.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l91.9-91.9c19.5-19.5 30.5-46 30.5-73.5L640 112c0-26.5-21.5-48-48-48z"
  ]
}, lS = {
  prefix: "fat",
  iconName: "hand-holding-heart",
  icon: [
    576,
    512,
    [],
    "f4be",
    "M288 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108L265.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L412.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L288 46.9zm5.7 17l23.4-23.8c23.1-23.5 60.5-23.5 83.6 0c23.2 23.6 23.2 61.9 0 85.5L299.1 228.9c-3.1 3.1-7.1 4.7-11.1 4.7s-8-1.5-11.1-4.7L175.3 125.7c-23.2-23.6-23.2-61.9 0-85.5c23.1-23.5 60.5-23.5 83.6 0l23.4 23.8c3.1 3.2 8.3 3.2 11.4 0zM521.8 340.7c10.7-7.9 25.7-5.6 33.6 5.1s5.6 25.7-5.1 33.6L423.6 472.6C403 487.8 378.1 496 352.5 496L8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l344.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L394.7 414.4c-1.4 1-3 1.6-4.7 1.6L268 416c-6.6 0-12-5.4-12-12s5.4-12 12-12l80 0c19.9 0 36-16.1 36-36s-16.1-36-36-36l-154.3 0c-29.1 0-57.3 9.9-80 28L71 382.2c-1.4 1.1-3.2 1.8-5 1.8L8 384c-4.4 0-8 3.6-8 8s3.6 8 8 8l58 0c5.4 0 10.7-1.9 15-5.3l42.7-34.2c19.9-15.9 44.5-24.5 70-24.5L348 336c11 0 20 9 20 20s-9 20-20 20l-80 0c-15.5 0-28 12.5-28 28s12.5 28 28 28l121.9 0c5.1 0 10.1-1.6 14.2-4.7l117.6-86.6z"
  ]
}, dS = {
  prefix: "fat",
  iconName: "language",
  icon: [
    640,
    512,
    [],
    "f1ab",
    "M312 80l0 352L64 432c-26.5 0-48-21.5-48-48l0-256c0-26.5 21.5-48 48-48l248 0zm16 0l248 0c26.5 0 48 21.5 48 48l0 256c0 26.5-21.5 48-48 48l-248 0 0-352zm312 48c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256zM167.4 165c-1.2-3-4.2-5-7.4-5s-6.2 2-7.4 5l-72 176c-1.7 4.1 .3 8.8 4.4 10.4s8.8-.3 10.4-4.4L113 304l94 0 17.6 43c1.7 4.1 6.3 6 10.4 4.4s6-6.3 4.4-10.4l-72-176zM160 189.1L200.4 288l-80.9 0L160 189.1zM488 168c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 24-72 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l80 0 52.9 0-6.6 19.8c-9.2 27.6-25.4 52.2-46.6 71.4c-4.5-3.7-8.8-7.7-12.9-11.8l-29.1-29.1c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l29.1 29.1c3.8 3.8 7.7 7.4 11.7 10.8c-6.2 4.6-12.8 8.8-19.7 12.6L420.2 337c-3.9 2.1-5.3 7-3.2 10.9s7 5.3 10.9 3.2L455 336.2c8.8-4.8 17.2-10.3 25-16.4c6.2 4.5 12.6 8.7 19.2 12.5L532 350.9c3.8 2.2 8.7 .9 10.9-3s.9-8.7-3-10.9l-32.7-18.7c-5-2.9-9.9-6-14.6-9.3c22.2-20.8 39.1-46.9 48.9-76.2l8.3-24.8 10.2 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-16 0-56 0 0-24z"
  ]
}, uS = {
  prefix: "fat",
  iconName: "newspaper",
  icon: [
    512,
    512,
    [128240],
    "f1ea",
    "M152 48c-22.1 0-40 17.9-40 40l0 336c0 15.7-6.4 29.8-16.8 40L440 464c30.9 0 56-25.1 56-56l0-320c0-22.1-17.9-40-40-40L152 48zM56 480c-30.9 0-56-25.1-56-56L0 192c0-35.3 28.7-64 64-64l0 16c-26.5 0-48 21.5-48 48l0 232c0 22.1 17.9 40 40 40s40-17.9 40-40L96 88c0-30.9 25.1-56 56-56l304 0c30.9 0 56 25.1 56 56l0 320c0 39.8-32.2 72-72 72L56 480zM352 104c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8zM160 296c0-4.4 3.6-8 8-8l272 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-272 0c-4.4 0-8-3.6-8-8zm0 64c0-4.4 3.6-8 8-8l272 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-272 0c-4.4 0-8-3.6-8-8zm24-248c-4.4 0-8 3.6-8 8l0 96c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8l0-96c0-4.4-3.6-8-8-8l-112 0zm-24 8c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 96c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-96z"
  ]
}, fS = {
  prefix: "fat",
  iconName: "memo",
  icon: [
    384,
    512,
    [],
    "e1d8",
    "M64 16C37.5 16 16 37.5 16 64l0 384c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-384c0-26.5-21.5-48-48-48L64 16zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm72 64l240 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L72 144c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96l240 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L72 240c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 96l144 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L72 336c-4.4 0-8-3.6-8-8s3.6-8 8-8z"
  ]
}, pS = {
  prefix: "fat",
  iconName: "seedling",
  icon: [
    512,
    512,
    [127793, "sprout"],
    "f4d8",
    "M480 16c8.8 0 16 7.2 16 16c0 102.9-74.7 188.4-172.9 205.1c1 5.2 1.9 10.5 2.6 15.8C431.4 234.9 512 142.9 512 32c0-17.7-14.3-32-32-32L448 0C367 0 296 43 256.6 107.5c3.8 4.1 7.5 8.3 11.1 12.6C303.7 57.9 371 16 448 16l32 0zM64 80c114.9 0 208 93.1 208 208l0 16-48 0C109.1 304 16 210.9 16 96c0-8.8 7.2-16 16-16l32 0zM32 64C14.3 64 0 78.3 0 96C0 219.7 100.3 320 224 320l48 0 0 184c0 4.4 3.6 8 8 8s8-3.6 8-8l0-184 0-8 0-8 0-16C288 164.3 187.7 64 64 64L32 64z"
  ]
}, mS = {
  prefix: "fat",
  iconName: "viruses",
  icon: [
    640,
    512,
    [],
    "e076",
    "M200 24c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 13.5c0 49.9-60.3 74.9-95.6 39.6l-9.5-9.5c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l9.5 9.5C112.4 123.7 87.4 184 37.5 184L24 184c-4.4 0-8 3.6-8 8s3.6 8 8 8l13.5 0c49.9 0 74.9 60.3 39.6 95.6l-9.5 9.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l9.5-9.5c35.3-35.3 95.6-10.3 95.6 39.6l0 13.5c0 4.4 3.6 8 8 8s8-3.6 8-8l0-13.5c0-49.9 60.3-74.9 95.6-39.6l9.5 9.5c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-9.5-9.5c-35.3-35.3-10.3-95.6 39.6-95.6l13.5 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-13.5 0c-49.9 0-74.9-60.3-39.6-95.6l9.5-9.5c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-9.5 9.5C260.3 112.4 200 87.4 200 37.5L200 24zM192 0c13.3 0 24 10.7 24 24l0 13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168l13.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-13.5 0c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5l0 13.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216L24 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l13.5 0c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5L168 24c0-13.3 10.7-24 24-24zM480 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM240 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM575.2 266.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2zM405.5 277.5c33.4 33.4 9.7 90.5-37.5 90.5c47.2 0 70.9 57.1 37.5 90.5c33.4-33.4 90.5-9.7 90.5 37.5c0-47.2 57.1-70.9 90.5-37.5C553.1 425.1 576.8 368 624 368c-47.2 0-70.9-57.1-37.5-90.5c-17.6 17.6-41.9 19.4-60.8 10.1c-17-8.3-29.7-25.3-29.7-47.6c0 47.2-57.1 70.9-90.5 37.5z"
  ]
}, hS = {
  prefix: "fat",
  iconName: "circle-check",
  icon: [
    512,
    512,
    [61533, "check-circle"],
    "f058",
    "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.7 197.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z"
  ]
}, gS = {
  prefix: "fat",
  iconName: "gift",
  icon: [
    512,
    512,
    [127873],
    "f06b",
    "M373.1 16c-20.3 0-39.2 10.5-50 27.7L270.4 128l25.6 0 80 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-2.9 0zM241.6 128L188.9 43.7C178.1 26.5 159.2 16 138.9 16L136 16c-30.9 0-56 25.1-56 56s25.1 56 56 56l80 0 25.6 0zm14.4-7.1l53.6-85.7C323.3 13.3 347.3 0 373.1 0L376 0c39.8 0 72 32.2 72 72c0 22.6-10.4 42.8-26.7 56l42.7 0c26.5 0 48 21.5 48 48l0 32c0 20.9-13.4 38.7-32 45.3l0 2.7 0 192c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-192 0-2.7C13.4 246.7 0 228.9 0 208l0-32c0-26.5 21.5-48 48-48l42.7 0C74.4 114.8 64 94.6 64 72C64 32.2 96.2 0 136 0l2.9 0c25.8 0 49.8 13.3 63.5 35.2L256 120.9zM136 144l-88 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l200 0 0-96-32 0-80 0zm128 0l0 96 200 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-88 0-80 0-32 0zM248 256L48 256l0 192c0 26.5 21.5 48 48 48l152 0 0-240zm16 240l152 0c26.5 0 48-21.5 48-48l0-192-200 0 0 240z"
  ]
}, vS = {
  prefix: "fat",
  iconName: "wifi",
  icon: [
    640,
    512,
    ["wifi-3", "wifi-strong"],
    "f1eb",
    "M13.8 175.3C92 96.6 200.3 48 320 48s228 48.6 306.2 127.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3C556.4 82.5 444.1 32 320 32S83.6 82.5 2.5 164c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zM320 208c72.2 0 137.8 28.1 186.5 74c3.2 3 8.3 2.9 11.3-.3s2.9-8.3-.3-11.3C465.9 221.8 396.4 192 320 192s-145.9 29.8-197.5 78.4c-3.2 3-3.4 8.1-.3 11.3s8.1 3.4 11.3 .3c48.7-45.9 114.3-74 186.5-74zm0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
  ]
}, bS = {
  prefix: "fat",
  iconName: "weight-hanging",
  icon: [
    512,
    512,
    [],
    "f5cd",
    "M200 72a56 56 0 1 1 112 0A56 56 0 1 1 200 72zm101.3 56C317.6 114.8 328 94.6 328 72c0-39.8-32.2-72-72-72s-72 32.2-72 72c0 22.6 10.4 42.8 26.7 56L120 128c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512l416 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128l-90.7 0zM256 144l136 0c14.7 0 27.5 10 31 24.2l72 288c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3L48 496c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l72-288C92.5 154 105.3 144 120 144l136 0z"
  ]
}, yS = {
  prefix: "fat",
  iconName: "heart-pulse",
  icon: [
    512,
    512,
    ["heartbeat"],
    "f21e",
    "M393.6 57.7C451.9 65.3 496 115 496 173.6c0 30.3-11.7 59.3-32.8 81.1L462 256l-90.2 0c-9.1 0-17.4-5.1-21.5-13.3l-23.2-46.3c-1.4-2.7-4.1-4.4-7.2-4.4s-5.8 1.7-7.2 4.4L256.4 309.4 191.3 164.7c-1.3-2.9-4.2-4.8-7.4-4.7s-6 2-7.3 4.9l-31.8 76.3c-3.7 8.9-12.5 14.8-22.2 14.8l-72.6 0-1.3-1.3C27.8 232.9 16 203.8 16 173.5C16 114.9 60.1 65.3 118.3 57.7c42.9-5.6 85.8 12.6 111.2 47.6l20 27.5c1.5 2.1 3.9 3.3 6.5 3.3s5-1.2 6.5-3.3l20-27.5c25.4-34.9 68.3-53.2 111.2-47.6zM464 272l4.8 0 6-6.2C498.6 241.1 512 208 512 173.6c0-66.8-50.2-123.2-116.3-131.8c-48.6-6.3-97.3 14.3-126.2 54L256 114.4 242.5 95.8c-28.9-39.7-77.6-60.4-126.2-54C50.2 50.4 0 106.8 0 173.5c0 34.5 13.4 67.6 37.4 92.3l6 6.2 3.6 0c0 0 0 0 0 0l75.7 0c16.1 0 30.7-9.7 36.9-24.6l24.7-59.3 64.4 143.2c1.3 2.8 4 4.7 7.1 4.7s5.9-1.7 7.3-4.4L320 217.9l16 32c6.8 13.6 20.6 22.1 35.8 22.1l92.2 0s0 0 0 0zM74.3 304L236.5 471.6c5.2 5.4 12.4 8.4 19.9 8.4c7.5 0 14.7-3 19.9-8.5L437.9 304l-22.2 0-151 156.4c-2.2 2.3-5.2 3.6-8.4 3.6s-6.2-1.3-8.4-3.6L96.6 304l-22.3 0z"
  ]
}, xS = {
  prefix: "fat",
  iconName: "venus",
  icon: [
    384,
    512,
    [9792],
    "f221",
    "M32 176a160 160 0 1 1 320 0A160 160 0 1 1 32 176zM200 351.8c93.5-4.2 168-81.3 168-175.8C368 78.8 289.2 0 192 0S16 78.8 16 176c0 94.5 74.5 171.6 168 175.8l0 64.2-80 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l80 0 0 72c0 4.4 3.6 8 8 8s8-3.6 8-8l0-72 80 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-80 0 0-64.2z"
  ]
}, _S = {
  prefix: "fat",
  iconName: "calendar-star",
  icon: [
    448,
    512,
    [],
    "f736",
    "M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 56L64 64C28.7 64 0 92.7 0 128l0 48 0 16L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-16 0-48c0-35.3-28.7-64-64-64l-48 0 0-56c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 56L128 64l0-56zM16 192l416 0 0 256c0 26.5-21.5 48-48 48L64 496c-26.5 0-48-21.5-48-48l0-256zM112 80l0 40c0 4.4 3.6 8 8 8s8-3.6 8-8l0-40 192 0 0 40c0 4.4 3.6 8 8 8s8-3.6 8-8l0-40 48 0c26.5 0 48 21.5 48 48l0 48L16 176l0-48c0-26.5 21.5-48 48-48l48 0zM238.3 251c-5.9-11.9-22.8-11.9-28.7 0l-23.9 48.4-53.4 7.8c-13.1 1.9-18.4 18-8.9 27.3l38.6 37.7L153 425.3c-2.2 13.1 11.5 23 23.2 16.9L224 417l47.8 25.1c11.7 6.2 25.5-3.8 23.2-16.9l-9.1-53.2 38.6-37.7c9.5-9.3 4.3-25.4-8.9-27.3l-53.4-7.8L238.3 251zM224 258.1l25.7 52.2 1.9 3.8 4.2 .6 57.6 8.4-41.7 40.6-3 2.9 .7 4.1 9.8 57.3-51.5-27.1-3.7-2-3.7 2L168.8 428l9.8-57.3 .7-4.1-3-2.9L134.7 323l57.6-8.4 4.2-.6 1.9-3.8L224 258.1z"
  ]
}, wS = {
  prefix: "fat",
  iconName: "x-ray",
  icon: [
    512,
    512,
    [],
    "f497",
    "M0 40c0-4.4 3.6-8 8-8l32 0 432 0 32 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-24 0 0 416 24 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-32 0L40 480 8 480c-4.4 0-8-3.6-8-8s3.6-8 8-8l24 0L32 48 8 48c-4.4 0-8-3.6-8-8zm48 8l0 416 416 0 0-416L48 48zM256 96c4.4 0 8 3.6 8 8l0 40 80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0 0 48 112 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-112 0 0 80c0 .5-.1 1.1-.2 1.6c0 0 0 0 .1 0L328.7 283c5.7-2 11.6-3 17.6-3c29.6 0 53.6 24 53.6 53.6l0 3.1c0 12.7-4.3 25-12.1 35L371 393.3c-11.2 14.3-28.4 22.7-46.6 22.7l-136.8 0c-18.2 0-35.4-8.4-46.6-22.7l-16.9-21.5c-7.8-10-12.1-22.3-12.1-35l0-3.1c0-29.6 24-53.6 53.6-53.6c6 0 12 1 17.6 3l64.8 22.6c0 0 0 0 .1 0c-.1-.5-.2-1-.2-1.6l0-80-104 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l104 0 0-48-72 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l72 0 0-40c0-4.4 3.6-8 8-8zM128 333.6l0 3.1c0 9.1 3.1 18 8.7 25.2l16.9 21.5c8.2 10.4 20.7 16.5 34 16.5l136.8 0c13.3 0 25.8-6.1 34-16.5l16.9-21.5c5.6-7.2 8.7-16 8.7-25.2l0-3.1c0-20.8-16.8-37.6-37.6-37.6c-4.2 0-8.4 .7-12.4 2.1l-64.8 22.6c-8.5 3-17.8 3-26.3 0L178 298.1c-4-1.4-8.2-2.1-12.4-2.1c-20.8 0-37.6 16.8-37.6 37.6zM192 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
  ]
}, CS = {
  prefix: "fat",
  iconName: "scalpel-line-dashed",
  icon: [
    576,
    512,
    ["scalpel-path"],
    "f61e",
    "M441.4 16c-16.1 0-31.4 7.1-41.7 19.4L200 272l132.6 0c9.4 0 18.4-4.2 24.5-11.4L482.2 112.4c8.9-10.6 13.8-24 13.8-37.8l0-4C496 40.5 471.5 16 441.4 16zM185.5 278.7c-2.6-5.6-1.7-12.3 2.3-17.1L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6l0 4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17L200 288c-6.2 0-11.9-3.6-14.5-9.3zM176.1 320l22.3 0L28.5 494.4c30.8-3.6 87.1-14 141-36.8c63.8-27 121.4-70 132.5-137.6l16.2 0C307 397.3 241.7 444.5 175.8 472.4C103 503.1 25.9 512 8 512c-3.2 0-6.1-1.9-7.4-4.9s-.6-6.4 1.6-8.7L176.1 320zM232 496l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8s3.6-8 8-8zm128 0l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8s3.6-8 8-8zm128 0l80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8s3.6-8 8-8z"
  ]
}, SS = {
  prefix: "fat",
  iconName: "venus-mars",
  icon: [
    640,
    512,
    [9892],
    "f228",
    "M176 336a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM352 176c0 94.5-74.5 171.6-168 175.8l0 64.2 80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-80 0 0 72c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-72-80 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l80 0 0-64.2C74.5 347.6 0 270.5 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM286.2 352.5c29 29.4 69.3 47.5 113.8 47.5c88.4 0 160-71.6 160-160s-71.6-160-160-160c-12.8 0-25.3 1.5-37.2 4.4c-2.4-5-5.1-9.8-7.9-14.5C369.3 66 384.4 64 400 64c45.7 0 87.4 17.4 118.7 46l94-94L488 16c-4.4 0-8-3.6-8-8s3.6-8 8-8L632 0c4.4 0 8 3.6 8 8l0 144c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-124.7-94 94c28.6 31.3 46 72.9 46 118.7c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4c4.9-2.5 9.7-5.3 14.3-8.2z"
  ]
}, LS = {
  prefix: "fat",
  iconName: "globe",
  icon: [
    512,
    512,
    [127760],
    "f0ac",
    "M256 496c26 0 53.9-21.5 76.2-66.1c11-21.9 19.9-48.3 26.2-77.9l-204.7 0c6.2 29.5 15.2 55.9 26.2 77.9C202.1 474.5 230 496 256 496zM150.6 336l210.8 0c4.3-25 6.6-51.9 6.6-80s-2.3-55-6.6-80l-210.8 0c-4.3 25-6.6 51.9-6.6 80s2.3 55 6.6 80zm3-176l204.7 0c-6.2-29.6-15.2-55.9-26.2-77.9C309.9 37.5 282 16 256 16s-53.9 21.5-76.2 66.1c-11 21.9-19.9 48.3-26.2 77.9zm224 16c4.1 25.2 6.4 52.1 6.4 80s-2.2 54.8-6.4 80l104.7 0c8.8-25 13.7-51.9 13.7-80s-4.8-55-13.7-80l-104.7 0zM476 160C445.6 90.5 383.2 38.1 307.5 21.5c30.5 26.8 54.7 76.6 67.2 138.5L476 160zm-338.7 0c12.5-61.8 36.8-111.7 67.2-138.5C128.8 38.1 66.4 90.5 36 160l101.3 0zM29.7 176C20.8 201 16 227.9 16 256s4.8 55 13.7 80l104.7 0c-4.1-25.2-6.4-52.1-6.4-80s2.2-54.8 6.4-80L29.7 176zM307.5 490.5C383.2 473.9 445.6 421.5 476 352l-101.3 0c-12.5 61.8-36.8 111.7-67.2 138.5zm-102.9 0c-30.5-26.8-54.7-76.6-67.2-138.5L36 352c30.4 69.5 92.8 121.9 168.6 138.5zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"
  ]
}, MS = {
  prefix: "fat",
  iconName: "bullhorn",
  icon: [
    512,
    512,
    [128226, 128363],
    "f0a1",
    "M464 32c0-28.1-33.7-42.6-54.1-23.2l-44 41.9C326.4 88.4 277 113.4 224 123.3l0 16.3c57.1-10 110.4-36.7 152.9-77.2l44-41.9c10.2-9.7 27-2.5 27 11.6l0 416c0 14.1-16.8 21.3-27 11.6l-44-41.9c-42.5-40.5-95.8-67.2-152.9-77.2l0 16.3c53 9.9 102.4 34.9 141.9 72.5l44 41.9c20.4 19.4 54.1 5 54.1-23.2l0-134.7c28.3-12.3 48-40.5 48-73.3s-19.7-61-48-73.3L464 32zM192 416l0-63.3 0-16 0-193.2 0-16c-6.4 .4-12.8 .7-19.2 .7L160 128l-96 0c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l0 120c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-56zM464 295.4l0-110.9c19.1 11.1 32 31.7 32 55.4s-12.9 44.4-32 55.4zM176 352l0 120c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-120 80 0 12.8 0c1.1 0 2.1 0 3.2 0zm-3.2-16L160 336l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l96 0 12.8 0c1.1 0 2.1 0 3.2 0l0 192c-1.1 0-2.1 0-3.2 0z"
  ]
}, NS = {
  prefix: "fat",
  iconName: "user",
  icon: [
    448,
    512,
    [62144, 128100],
    "f007",
    "M336 128a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM16 482.3c0 7.6 6.1 13.7 13.7 13.7l388.6 0c7.6 0 13.7-6.1 13.7-13.7C432 392.7 359.3 320 269.7 320l-91.4 0C88.7 320 16 392.7 16 482.3zm-16 0C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"
  ]
}, zS = {
  prefix: "fat",
  iconName: "shield-check",
  icon: [
    512,
    512,
    [],
    "f2f7",
    "M237.3 22.6c12-5.1 25.5-5.1 37.5 0l176.7 75c16.6 7.1 28.6 23.2 28.5 42.4c-.5 96.6-40.3 270.2-204.5 348.8c-12.3 5.9-26.7 5.9-39 0C72.3 410.1 32.5 236.5 32 139.9c-.1-19.1 11.9-35.3 28.5-42.4l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm76.6 189.8c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z"
  ]
}, ES = {
  prefix: "fat",
  iconName: "staff-snake",
  icon: [
    384,
    512,
    ["rod-asclepius", "rod-snake", "staff-aesculapius"],
    "e579",
    "M236.9 48c1.4-26-19.3-48-45.4-48s-46.9 22-45.4 48L56 48C25.1 48 0 73.1 0 104s25.1 56 56 56l15.7 0c22.6 0 43.8-10.6 57.3-28.7l2.5-3.3 19.7 0 2.1 32c-49.7 .9-89.8 41.5-89.8 91.5l0 4.5c0 53 43 96 96 96l6.2 0c0 .2 0 .3 0 .5l2 31.5-40.2 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l44.4 0 3.1 48.5c.6 8.7 7.8 15.5 16.5 15.5s15.9-6.8 16.5-15.5l9.3-144c0-.2 0-.3 0-.5l54.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0c-44.2 0-80-35.8-80-80l0-4.5c0-41.5 33.4-75.1 74.8-75.5l2.1 32.1c-25.1 1.6-44.9 22.4-44.9 47.9c0 26.5 21.5 48 48 48l112 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-40 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l40 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-112 0c-17.7 0-32-14.3-32-32c0-17 13.2-30.9 29.9-31.9l2.1 32.4c.3 4.4 4.1 7.8 8.5 7.5s7.8-4.1 7.5-8.5L167.3 128l48.5 0-8.2 127.5c-.3 4.4 3.1 8.2 7.5 8.5s8.2-3.1 8.5-7.5L231.8 128l55.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-2.5 0-4.9 1.2-6.4 3.2l-4.9 6.5c-10.5 14-27 22.3-44.5 22.3L56 144c-22.1 0-40-17.9-40-40s17.9-40 40-40l231.5 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-40 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l40 0c53 0 96-43 96-96s-43-96-96-96l-50.6 0zM170.8 432l-43.3 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l41.3 0 2.1 32zm30.5-80L192 495.5c0 .3-.3 .5-.5 .5s-.5-.2-.5-.5L181.7 352l19.6 0zM162.1 48c0-.2 0-.4 0-.6C161 30.4 174.5 16 191.5 16s30.5 14.4 29.4 31.4c0 .2 0 .4 0 .6l-58.8 0zM47.5 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z"
  ]
}, TS = {
  prefix: "fat",
  iconName: "pills",
  icon: [
    576,
    512,
    [],
    "f484",
    "M112 48c53 0 96 43 96 96l0 112L16 256l0-112c0-53 43-96 96-96zM16 368l0-96 192 0 0 96c0 53-43 96-96 96s-96-43-96-96zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-224c0-61.9-50.1-112-112-112S0 82.1 0 144zM416 464c-79.5 0-144-64.5-144-144c0-36.9 13.9-70.5 36.7-96L512 427.3c-25.5 22.8-59.1 36.7-96 36.7zM320 212.7c25.5-22.8 59.1-36.7 96-36.7c79.5 0 144 64.5 144 144c0 36.9-13.9 70.5-36.7 96L320 212.7zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"
  ]
}, kS = {
  prefix: "fat",
  iconName: "hand-heart",
  icon: [
    512,
    512,
    [],
    "f4bc",
    "M264 16c17.7 0 32 14.3 32 32l0 24 0 8 0 168c0 4.4 3.6 8 8 8s8-3.6 8-8l0-168c0-17.7 14.3-32 32-32s32 14.3 32 32l0 56 0 8 0 56 0 48c0 4.4 3.6 8 8 8s8-3.6 8-8l0-48 0-56c0-17.7 14.3-32 32-32s32 14.3 32 32l0 200c0 83.9-68.1 152-152 152l-8.5 0c-59.4 0-116.4-23.6-158.4-65.6L25.4 318.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l67.7 67.7c2.3 2.3 5.7 3 8.7 1.7s4.9-4.2 4.9-7.4L152 80c0-17.7 14.3-32 32-32s32 14.3 32 32c0 0 0 0 0 0l0 168c0 4.4 3.6 8 8 8s8-3.6 8-8l0-176c0 0 0 0 0 0l0-24c0-17.7 14.3-32 32-32zm47.9 28.3C310 19.5 289.3 0 264 0s-46 19.5-47.9 44.3C207.6 36.7 196.4 32 184 32c-26.5 0-48 21.5-48 48l0 236.1L81.9 262.1c-18.7-18.7-49.1-18.7-67.9 0s-18.7 49.1 0 67.9L125.8 441.7c45 45 106.1 70.3 169.7 70.3l8.5 0c92.8 0 168-75.2 168-168l0-200c0-26.5-21.5-48-48-48c-12.3 0-23.5 4.6-32 12.2L392 80c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3zM204.6 336.6c0-20.2 16.4-36.6 36.6-36.6l.6 0c9.7 0 19 3.8 26 10.5l14.6 14.2c3.1 3 8 3 11.2 0l14.6-14.2c7-6.8 16.3-10.5 26-10.5l.6 0c20.2 0 36.6 16.4 36.6 36.6c0 9.3-3.6 18.3-10 25.1l-67.6 71.7c-1.5 1.6-3.6 2.5-5.8 2.5s-4.3-.9-5.8-2.5l-67.6-71.7c-6.4-6.8-10-15.8-10-25.1zM241.2 284c-29.1 0-52.6 23.6-52.6 52.6c0 13.4 5.1 26.3 14.3 36.1l67.6 71.7c4.5 4.8 10.9 7.5 17.5 7.5s12.9-2.7 17.5-7.5l67.6-71.7c9.2-9.8 14.3-22.7 14.3-36.1c0-29.1-23.6-52.6-52.6-52.6l-.6 0c-13.9 0-27.2 5.4-37.1 15.1l-9 8.8-9-8.8c-9.9-9.7-23.3-15.1-37.1-15.1l-.6 0z"
  ]
}, jS = {
  prefix: "fat",
  iconName: "car-side",
  icon: [
    640,
    512,
    [128663],
    "f5e4",
    "M171.3 48L240 48l0 32 0 96 0 16L75.8 192 119.3 83.2c8.5-21.3 29.1-35.2 52-35.2zM256 208l256 0c61.9 0 112 50.1 112 112l0 48c0 8.8-7.2 16-16 16l-32 0c0-53-43-96-96-96s-96 43-96 96l-128 0c0-53-43-96-96-96s-96 43-96 96l-32 0c-8.8 0-16-7.2-16-16l0-112c0-26.5 21.5-48 48-48l176 0 16 0zM574.7 400l33.3 0c17.7 0 32-14.3 32-32l0-48c0-69.4-55.2-125.9-124.1-127.9L409.5 59c-13.7-17.1-34.3-27-56.2-27L171.3 32c-29.4 0-55.9 17.9-66.9 45.3l-46 115C25.7 195 0 222.5 0 256L0 368c0 17.7 14.3 32 32 32l33.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80zM495.4 192L256 192l0-16 0-96 0-32 97.2 0c17 0 33.1 7.7 43.7 21l98.4 123zM160 304a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"
  ]
}, PS = {
  prefix: "fat",
  iconName: "clipboard-medical",
  icon: [
    384,
    512,
    [],
    "e133",
    "M192 0c-37.1 0-67.6 28-71.6 64L112 64C91.1 64 73.3 77.4 66.7 96L64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64l-2.7 0c-6.6-18.6-24.4-32-45.3-32l-8.4 0c-4-36-34.5-64-71.6-64zM16 160c0-26.5 21.5-48 48-48l0 16c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-16c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48L64 496c-26.5 0-48-21.5-48-48l0-288zM136 72c0-30.9 25.1-56 56-56s56 25.1 56 56c0 4.4 3.6 8 8 8l16 0c17.7 0 32 14.3 32 32l0 16c0 8.8-7.2 16-16 16L96 144c-8.8 0-16-7.2-16-16l0-16c0-17.7 14.3-32 32-32l16 0c4.4 0 8-3.6 8-8zm56 24a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM168 232c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 56c0 4.4 3.6 8 8 8l56 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-56 0c-4.4 0-8 3.6-8 8l0 56c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-56c0-4.4-3.6-8-8-8l-56 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8l56 0c4.4 0 8-3.6 8-8l0-56zm8-24c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24l32 0c13.3 0 24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24l0-32c0-13.3-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24l-32 0z"
  ]
}, AS = {
  prefix: "fat",
  iconName: "hospital-user",
  icon: [
    576,
    512,
    [],
    "f80d",
    "M0 56C0 25.1 25.1 0 56 0L264 0c30.9 0 56 25.1 56 56l0 215.8 0 64.2 0 31.8c-5.6 3.1-11 6.7-16 10.7l0-42.4 0-280c0-22.1-17.9-40-40-40L56 16C33.9 16 16 33.9 16 56l0 216 136 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L16 288l0 80 136 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L16 384l0 72c0 22.1 17.9 40 40 40l202.8 0c1.7 5.7 4.1 11.1 7.2 16L56 512c-30.9 0-56-25.1-56-56L0 56zm152 0l16 0c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24zm-8 24l0 24c0 4.4-3.6 8-8 8l-24 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l24 0c4.4 0 8 3.6 8 8l0 24c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-24c0-4.4 3.6-8 8-8l24 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-24 0c-4.4 0-8-3.6-8-8l0-24c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zM496 272a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM304 477.1c0 10.4 8.5 18.9 18.9 18.9l218.2 0c10.4 0 18.9-8.5 18.9-18.9c0-42.6-34.5-77.1-77.1-77.1l-101.8 0c-42.6 0-77.1 34.5-77.1 77.1zM432 192a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM381.1 384l101.8 0c51.4 0 93.1 41.7 93.1 93.1c0 19.3-15.6 34.9-34.9 34.9l-218.2 0c-19.3 0-34.9-15.6-34.9-34.9c0-51.4 41.7-93.1 93.1-93.1z"
  ]
}, $S = {
  prefix: "fat",
  iconName: "rainbow",
  icon: [
    640,
    512,
    [127752],
    "f75b",
    "M320 48C152.1 48 16 184.1 16 352l0 120c0 4.4-3.6 8-8 8s-8-3.6-8-8L0 352C0 175.3 143.3 32 320 32s320 143.3 320 320l0 120c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-120C624 184.1 487.9 48 320 48zm0 192c-61.9 0-112 50.1-112 112l0 120c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-120c0-70.7 57.3-128 128-128s128 57.3 128 128l0 120c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-120c0-61.9-50.1-112-112-112zM104 360l0 112c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-112c0-128.1 103.9-232 232-232s232 103.9 232 232l0 112c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-112c0-119.3-96.7-216-216-216s-216 96.7-216 216z"
  ]
}, IS = {
  prefix: "fat",
  iconName: "person",
  icon: [
    320,
    512,
    [129485, "male"],
    "f183",
    "M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM141.1 144c-21.5 0-41.1 12.3-50.4 31.7L23.2 315.5c-1.9 4-6.7 5.6-10.7 3.7s-5.6-6.7-3.7-10.7L76.3 168.7c12-24.9 37.2-40.7 64.8-40.7l37.8 0c27.6 0 52.8 15.8 64.8 40.7l67.5 139.8c1.9 4 .3 8.8-3.7 10.7s-8.8 .3-10.7-3.7L229.3 175.7C220 156.3 200.4 144 178.9 144l-37.8 0zM104 248l0 232c0 8.8 7.2 16 16 16s16-7.2 16-16l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 8.8 7.2 16 16 16s16-7.2 16-16l0-232c0-4.4 3.6-8 8-8s8 3.6 8 8l0 232c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-120c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 120c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-232c0-4.4 3.6-8 8-8s8 3.6 8 8z"
  ]
}, OS = {
  prefix: "fak",
  iconName: "colorectal-solid",
  icon: [
    439,
    512,
    [],
    "e012",
    "M135.4 3.7a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm73.1 14.6a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm54.9 18.3a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm65.8-18.3a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm62.2-11a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zM69.6 245a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm11-58.5a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zM58.6 120.7a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zM54.9 54.9a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zM354.8 226.7a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm-58.5 25.6a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm-62.2 0a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm157.3-65.8a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm7.3-73.1a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zm3.7-62.2a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4zM281.7 395l0 0c3.7-7.3 3.7-11 3.7-18.3c0-25.6-21.9-51.2-47.5-51.2s-51.2 21.9-51.2 51.2c0 7.3 0 14.6 3.7 18.3l0 0c0 3.7 3.7 7.3 7.3 11c11 21.9 14.6 43.9 14.6 54.9c0 7.3 3.7 14.6 11 21.9c11 14.6 21.9 7.3 29.3 0c3.7-7.3 7.3-14.6 11-21.9c3.7-25.6 11-47.5 14.6-54.9c3.7-3.7 3.7-7.3 3.7-11l0 0 0 0zM76.9 3.7a51.2 51.2 0 1 0 0 102.4 51.2 51.2 0 1 0 0-102.4z"
  ]
}, RS = {
  prefix: "fak",
  iconName: "contact-thin",
  icon: [
    850,
    512,
    [],
    "e001",
    "M493.1 351.2l-108.5-46.5c-12.8-5.5-27.8-1.8-36.5 9L304 367.5c-69.2-34-125.5-90.3-159.5-159.5l53.8-44.1c10.7-8.8 14.4-23.7 8.9-36.4L160.8 18.9C154.7 5 139.7-2.6 125 .8L24.2 24C10 27.3 0 39.8 0 54.5C0 306.8 205.2 512 457.5 512c14.7 0 27.2-10 30.5-24.2L511.2 387c3.4-14.6-5.1-29.8-18.1-35.8zm2.5 32.2l-23.2 100.8c-1.6 6.9-7.8 11.8-14.9 11.8C214 496 16 297.9 16 54.5c0-7.2 4.9-13.2 11.8-14.9l100.8-23.2c7.2-1.7 14.6 2.1 17.6 8.9l46.5 108.5c2.7 6.2 .8 13.5-4.4 17.8l-63.5 52c62.3 133.5 168.7 176.7 183.8 183.8l52-63.5c4.2-5.2 11.5-7.1 17.7-4.4L486.8 366c6.7 2.9 10.5 10.3 8.8 17.4zm282.7-350H407.8c-39.1 0-70.7 31.7-70.7 70.7v148.4c0 5.1 5.4 8.3 9.9 5.9l2.5-1.3c2.2-1.2 3.6-3.5 3.6-5.9v-91.1c0-5.7 6.6-8.8 11-5.2l183.8 148.3c26.4 21.3 64 21.3 90.4 0l183.8-148.3c4.4-3.5 11-.4 11 5.2v186.5c0 30.2-24.5 54.7-54.7 54.7c-50.8 0-92.4 .2-223.7 0c-.8 0-1.6 0-2.3 0c-3.2 0-5.9 2.2-6.6 5.3c-.2 .8-.4 1.7-.6 2.5c-.9 4.2 2.2 8.2 6.5 8.2h.1c80.3 .7 162.3 .1 233.2 0c4.3 0 26.9-.5 45.2-18.8C841.9 387 849 371 849 353.4V104.1c0-39.1-31.6-70.7-70.7-70.7zM833 125.6L628.1 290.8c-20.5 16.5-49.8 16.5-70.3 0L353 125.6V97.4c0-26.5 21.5-48 48-48h384c26.5 0 48 21.5 48 48v28.2z"
  ]
}, DS = {
  prefix: "fak",
  iconName: "knee-solid",
  icon: [
    342,
    512,
    [],
    "e015",
    "M65.2 242.3c13.7 3.4 20.5 10.2 23.9 17.1c0 6.8 6.8 10.2 13.7 13.7c34.1 17.1 41-10.2 44.4-30.7c0-10.2-3.4-20.5-6.8-27.3c-10.2-13.7-13.7-23.9-13.7-30.7v-3.4l0 0L188.1 6.8H140.3l-30.7 102.4c-6.8 20.5-23.9 47.8-34.1 61.4c-3.4 6.8-6.8 10.2-13.7 10.2c-27.3 10.2-27.3 27.3-20.5 41c3.4 10.2 13.7 17.1 23.9 20.5zm126.3 78.5l0 0c10.2-20.5 10.2-34.1 10.2-34.1c-6.8-44.4-47.8-13.7-47.8-13.7c-34.1 30.7-75.1 0-75.1 0c-41-13.7-34.1 23.9-34.1 23.9c3.4 54.6 44.4 41 44.4 41c23.9-6.8 184.3 150.2 184.3 150.2l34.1-27.3L212 372.1c-13.7-20.5-20.5-47.8-20.5-51.2zM58.4 259.4c0-3.4-3.4-6.8-6.8-10.2c-20.5-13.7-23.9-41-23.9-51.2c0-3.4 0-6.8-3.4-10.2c-6.8-13.7-17.1 6.8-17.1 6.8C-3.1 215 14 238.9 24.2 249.2c3.4 3.4 10.2 6.8 13.7 10.2c17.1 10.2 20.5 3.4 20.5 0l0 0zM229 324.3c-3.4-6.8-3.4-13.7-3.4-17.1c3.4-6.8 0-17.1-13.7-27.3c0 0 0 23.9-6.8 41c0 3.4 0 3.4-3.4 6.8c0 3.4 0 13.7 3.4 20.5l3.4 3.4 105.8 99 10.2-10.2c-3.4 0-95.6-116.1-95.6-116.1z"
  ]
}, FS = {
  prefix: "fak",
  iconName: "map-alabama",
  icon: [
    346,
    512,
    [],
    "e00b",
    "M41.4 513.1c-.5-9.1-3.2-17.4-5.9-25.7c-.5-1.9-1.1-3.8-1.9-5.6C16.5 426.2 9.7 374.8 13 324.1c1.1-17.4-.5-35.1-1.9-52c-.3-4-.8-8.3-1.1-12.6c-1.1-13.4-2.7-27.3-4-40.5C3 189.5-.2 159 .4 128.7c.5-22.2 .3-45 0-66.7c-.3-8.6-.3-17.2-.3-26l1.1-.3c3.5-.5 6.7-1.1 10.2-1.6c14.2-2.4 28.7-4.8 42.9-7.5c33.2-5.9 67.8-11.8 101.9-16.9c7.2-1.1 14.7-2.7 21.7-4c12.6-2.7 25.7-5.1 38.6-5.9c5.9 17.2 12.1 34.3 18 51.5c15.8 45.3 31.9 92.2 49.3 137.8c6.2 16.6 15.5 32.2 24.7 47.2c3.5 5.9 7.2 12.1 10.7 18.2c2.9 5.1 4 10.2 4 16.1c0 10.7 0 21.7 0 32.2c0 13.9 0 28.7-.3 42.9c-.3 9.7 2.1 18.5 7.2 27.3c1.6 2.7 3.2 5.6 4.8 8.3c3.8 6.2 7.5 12.1 9.9 18.5l-33.2 6.4c-29.2 5.6-58.4 11.5-87.7 17.2c-15 2.9-29.8 5.9-44.8 8.8c-16.1 3.2-32.4 6.4-48.5 9.7h-.5c-8 1.6-12.1 2.4-13.9 6.2c-1.6 3.8 .3 7.2 4 14.2l.3 .5c1.3 2.7 2.9 5.1 4.6 7.8c3.5 6.2 7 11.8 9.7 18c-6.2 2.4-12.6 4-19.3 5.6c-4.3 1.1-8.6 1.9-12.9 3.2c-.8 .3-1.3 .3-1.9 .3c-1.9 0-3.2-1.6-5.4-5.1c-1.1-1.6-2.1-3.2-3.5-4.8c-.5-.5-1.3-1.9-1.9-2.9c-1.6-2.9-3.8-7.5-9.1-7.5c-.5 0-1.1 0-1.6 .3c-5.6 1.1-6.4 7.2-7 11.3c-.3 1.1-.3 2.4-.5 3.2c-2.7 9.9-4 15.8-7 18s-8.8 2.4-19.3 2.7c-.8 0-1.3 0-2.1 0c-.5 .5-1.3 .5-1.9 .5l0 0z"
  ]
}, BS = {
  prefix: "fak",
  iconName: "map-georgia",
  icon: [
    487,
    512,
    [],
    "e00c",
    "M154.3 510.8c-2.3 0-4.3-.3-5.8-5.8c-1.7-6.3-4-12.7-6.3-18.7c-.9-2.6-2-5.2-2.9-7.5c-2.9-9.8-8.1-18.4-13.2-26.8c-1.7-2.9-3.5-5.8-5.2-8.6c-4.6-8.3-6.6-15.8-6.6-24.7c.3-15.5 .3-31.1 .3-46.3c0-11.2 0-23 0-34.2c0-8.1-1.7-15-5.5-21.9c-3.7-6.6-7.8-13.2-11.5-19.8c-9.5-15.8-19.3-32.2-25.9-49.2c-18.4-48.9-36-99.2-52.9-147.6C12.8 82 6.8 64.4 .4 46.6c4.9-.9 9.8-1.7 14.4-2.6c15.2-2.6 31.1-5.2 46.3-8.1c5.5-1.2 11.2-1.7 16.7-2.6c11.5-1.4 23.3-3.2 34.8-7.2c2.9-.6 5.8-1.2 8.6-1.7c6.6-1.2 13.2-2.6 19.8-4c6-1.4 11.8-2.6 17.8-3.7c21.9-4.6 44.3-9.5 66.2-16.7c-2.3 5.8-5.8 11.2-9.2 16.7c-2.3 3.5-4.3 7.2-6.3 10.9C205 36 206.7 41.1 215 46c4.6 2.6 9.2 4.9 13.8 7.2c14.1 7.2 27.6 14.4 39.1 24.7c23.6 21.9 51.8 43.1 88 67.6c11.2 7.5 22.1 15.2 33.1 22.7c8.6 6 17.5 12.4 26.5 18.4c4.6 3.2 7.5 6.6 9.8 11.8l3.2 6.9c8.1 18.7 16.4 38 21.6 57.8c6 22.7 20.4 38.3 35.1 51.5c0 .6 0 1.4 0 1.7c-19.6 40.8-27 84.6-21.6 130h-8.1c-9.8 0-19.6 0-29.3 0c-8.9 0-13.5 0-16.4 3.5s-2 7.8-.3 16.4v.6c2 10.4 4 20.7 6 31.6c.3 1.7 .6 3.2 .9 4.9c-1.2-.6-2-1.4-3.2-2c-9.2-6-17.8-11.8-25.9-17.5c-5.2-3.7-10.4-5.5-15.5-5.5c-1.2 0-2.6 0-3.7 .3c-34.8 5.2-69.6 10.6-104.4 15.8l-36.5 5.5c-23.6 3.5-47.2 7.2-70.8 10.6c-.9 .3-1.4 .3-2 .3l0 0z"
  ]
}, VS = {
  prefix: "fak",
  iconName: "map-illinois",
  icon: [
    278,
    512,
    [],
    "e00f",
    "M196.3 511.5c-.9-1.2-1.9-2.1-2.8-3.3c-2.1-2.6-4.2-5.2-6.3-7.8c-8.9-10.8-17.4-20.9-20.9-33.8c-1.9-7-5.2-15-12.4-20.9c-17.6-13.9-36.2-29.4-52.8-46.7c-4.2-4.5-4-6.1-.9-9.9c2.6-3.3 4.9-6.8 7.3-10.3c2.3-3.8 4.7-7 7.3-10.3c1.9-2.1 4.2-5.6 3.3-9.6c-.7-3.8-4.2-6.1-7.3-7.5c-13.4-6.8-24.2-9.9-35.2-9.9c-2.1 0-4.2 .2-6.3 .5c-.9 0-1.6 .2-2.3 .2c-3.1 0-4.7-.9-5.9-3.3c-10.3-19-27-31.7-43.4-43.9l-.9-.7c-3.5-2.6-5.4-5.6-6.1-9.9c-2.8-14.6-5.2-29.4-7.5-43.7c-.7-4.9-1.6-9.9-2.3-14.8l1.2-2.8c12-27.7 24.2-56.6 19.3-89.2c-.5-2.6 .2-4.2 4.2-5.9c8.2-3.5 16.2-7 24.2-10.6l2.3-1.2c.2-.2 .7-.2 1.2-.5c2.8-1.2 7-3.1 8-8l.2-.9c3.5-17.6 7-35.7-4.5-53.5c-3.1-4.7-6.6-8.7-10.1-12.7c-2.3-2.6-4.5-4.9-6.3-7.5l24.4-4.7C113.2 19.3 161.3 9.9 209.7 .7c1.6-.2 3.1-.5 4.7-.7c.7 15 9.9 26.1 18.3 36.9l.9 1.4c4.9 5.9 9.9 12 14.6 17.8c1.9 2.3 4 4.7 5.9 7c.5 3.3 .7 6.3 1.2 9.6c.9 8 1.9 15.7 2.6 23.7c.7 6.6 1.4 12.9 2.1 19.5c2.1 21.4 4.5 43.7 6.6 65.3l.7 7c2.3 23.7 4.5 46 1.2 69.5c-.2 1.9-.5 3.8-.7 5.4c-2.8 19.3-6.1 41.3 8.2 60.8c.9 1.2 1.2 3.3 .7 4.9c-3.8 12.9-4.5 26.1-4.9 39c-.5 9.4-.9 19-2.6 28.2c-.5 3.1-.7 5.9-.9 8.9c-.5 6.6-.9 12.9-5.2 18.1c-3.1 3.8-6.3 7.5-9.4 11.5c-6.1 7.3-12.4 15-18.8 22.3c-5.4 6.1-5.4 11.7 0 17.6l14.6 21.8c-3.5-.5-7-.7-10.3-.7c-16.7-.5-31 4.9-42.7 15.7l0 0z"
  ]
}, HS = {
  prefix: "fak",
  iconName: "map-northcarolina",
  icon: [
    1110,
    512,
    [],
    "e009",
    "M746.8 484c-35.8-30.9-72.7-62.6-108.9-93.9c-4.9-4.5-11-6.5-17.5-6.5c-3.3 0-6.5 .4-8.9 .8l-9.8 1.6c-15.8 2.8-32.1 5.7-47.9 9.3l-2 .4c-18.7 4.5-36.2 8.5-53.6 8.5c-19.9 0-36.2-5.7-51.2-17.5c-1.2-.8-3.7-2.4-6.9-2.8c-11-.4-22.3-1.2-33.3-2c-17.5-1.2-35.8-2.4-53.6-2.4c-24 0-43.9 2-61.8 6.9c-38.6 9.8-74.4 30.1-109.3 50c-6.1 3.3-11.8 6.9-17.5 9.8l-.4 .4-4.9 3.7s-.4 .4-.8 .4c-32.9 11.8-67.5 19.1-101.2 26.4c-8.5 1.6-16.7 3.7-25.2 5.3c-8.9 2-18.7 3.7-27.6 5.3c-1.2 .4-2.4 .4-3.7 .8c2.4-11.4 5.7-23.2 8.9-34.1c2-6.5 4.1-13.4 5.7-19.9c.8-2.8 2-4.5 4.9-6.9c15-11.8 30.5-23.6 45.5-35.4c55.7-43.9 113.8-89.4 178.4-121.9c8.9-4.5 14.6-11.4 17.9-22.3c5.7-19.5 11.8-39 17.5-58.1c2-6.1 4.1-12.6 5.7-19.1l155.2-36.2C590.8 99.1 746.4 63 899.2 26.8c10.6-2.4 21.5-4.9 32.1-7.3c26.4-5.7 53.6-11.8 80.1-20.3c8.9 6.9 16.3 15.4 24.4 24.4c6.5 7.3 13 14.6 20.3 21.1c25.6 22.8 39.4 49.6 41.4 82.1c.8 14.6 4.1 30.1 9.8 49.2c4.5 14.2 2 24.4-8.1 36.6c-18.7 21.5-36.2 44.7-53.2 66.6c-4.9 6.1-9.8 12.6-14.6 18.7s-9.8 9.3-17.1 11.4c-74 18.7-120.7 66.6-139 141.8c-1.6 6.1-3.3 11.8-4.9 17.9c-2.4 8.9-5.3 18.7-6.9 28c-1.2 6.5-3.3 6.5-6.9 6.5c-.8 0-1.2 0-2 0c-17.5-1.6-31.7-4.5-44.7-8.5c-4.5-1.6-8.5-2.4-11.8-2.4c-9.3 0-16.3 5.3-19.9 16.3c0 0 0 .4-.4 .4L746.8 484l0 0z"
  ]
}, qS = {
  prefix: "fak",
  iconName: "map-southcarolina",
  icon: [
    635,
    512,
    [],
    "e00d",
    "M390 510.8c-19.3-17.2-37.3-37.3-44.6-65.5c-7.8-29.1-19.7-56.9-31.5-84l-4.5-9.8c-4.1-9.4-9.8-16.8-18.4-22.5c-12.7-8.6-25.4-17.2-37.7-25.8c-15.6-10.6-31.5-21.7-47.1-32.4c-51.2-34-90.5-64.3-123.7-94.6c-17.6-16.4-38.5-27-58.6-37.3c-6.6-3.3-13.1-6.6-19.3-10.2c-4.1-2-4.5-3.3-4.5-3.3s0-1.2 2-4.9c2.5-4.9 5.7-10.2 8.6-14.7C17.3 94.6 24.2 83.1 28.3 70c2-1.2 3.3-3.3 3.7-4.5c5.3-2.9 10.6-6.1 16-9c34.4-19.7 70-39.7 106.9-49.2C172.1 2 190.9 0 214.3 0c17.6 0 35.6 1.2 53.2 2.5c11.1 .4 22.1 1.2 33.2 1.6c17.2 13.9 36.9 20.5 59.8 20.5c18.8 0 38.1-4.5 56.9-8.6l2-.4c15.6-3.7 31.9-6.6 47.5-9.4l9.8-1.6c2-.4 4.5-.8 7-.8c3.7 0 6.6 .8 9 3.3c36.5 31.9 73.7 63.9 109.8 94.6l31.9 27.4c-6.6 18-16.8 34.8-27 50.8l-3.3 5.3c-11.1 17.2-15.6 36.5-13.5 53.7c4.5 34.4-15.6 54.9-35.6 70c-33.2 25.4-58.2 57.3-82.7 88.9c-3.3 4.1-6.1 8.2-9.4 11.9c-5.7 7.4-11.5 14.3-17.2 21.3c-20.5 25-41 50.4-55.7 79.9l0 0z"
  ]
}, WS = {
  prefix: "fak",
  iconName: "map-wisconsin",
  icon: [
    488,
    512,
    [],
    "e00a",
    "M237.1 511.7c-2.4-2.4-4.5-4.5-6.9-6.9c-10.2-10.5-20.8-21.4-36.1-26.5c-6.6-2.4-9.3-7.2-11.7-15.1c-2.1-6.9-3.9-13.9-6-20.8c-4.2-15.4-8.4-31.3-15.1-46.4c0-1.2 0-2.7 0-3.9c0-3.6-.3-6.9 0-9.9c1.5-12.6-5.4-20.5-10.8-25c-19-16.3-38.2-32.5-57.2-48.8c-20.2-17.2-40.1-34.3-60.2-51.5c-6.6-5.7-9.6-12-9.3-20.2c.3-7.2 .3-14.5 0-21.4c-.3-12.3-.6-23.8 1.5-35.5c1.8-9.9-6.3-14.5-11.1-17.5l-1.5-.9C6.7 158.1 1 154.5-.3 153c.6-1.8 5.7-6.6 9.9-11.1c3-3 6-6 9-9c8.7-9 16.9-17.8 27.7-23.5c7.8-4.2 8.1-11.4 8.4-17.5c.9-18.1-1.5-35.8-3.9-52.7l-.3-1.8c12-1.8 22.9-6.6 33.4-11.1c4.8-2.1 9.9-4.2 15.1-6.3c15.7-5.7 31.3-12.6 45.8-19c.6-.6 1.2-.9 1.5-.9c0 .3 0 .6 0 .9c-1.5 21.4 9 33.4 31.3 36.4c3.9 .6 7.8 1.8 10.8 3.3c37 19.9 77.1 26.5 111.4 30.4c14.8 1.5 29.5 6 43.7 9.9c14.5 4.2 29.5 8.7 45.2 10.2c19 2.1 24.7 12.3 28 28.3c.6 3.6 1.5 7.2 2.4 10.8c1.5 6.6 3 13.9 4.2 20.8c2.4 12.6 1.2 22-3.3 31c-3 6-5.1 12.3-6.9 18.7c-.6 1.5-.9 3-1.5 4.8c-2.1 6.9-1.2 14.5 2.4 21.4c3.9 6.9 10.2 11.7 17.2 13.6c.9 .3 1.8 .3 2.7 .3c6.3 0 7.8-5.4 8.4-7.2c0-.3 .3-.9 .3-1.2c2.4-5.1 4.5-10.5 6.9-15.7c3.3-7.8 6.9-16 10.5-23.8c6.6-13.9 16-25.6 25.9-37.9c.3-.3 .3-.6 .6-.6c-1.8 6.9-4.5 14.2-8.1 22.3c-9 21.4-14.5 43.7-19.6 65.4c-1.8 7.5-3.6 15.4-5.7 23.2c-.9 3.3-.6 6.6-.3 9.6c0 .9 .3 1.8 .3 2.7l5.4 75c2.7 36.7 5.1 73.5 7.8 110.2c.3 2.1 0 4.2 0 6.3c-2.7 .3-5.4 .6-7.8 1.2c-60.5 11.7-121.1 23.2-181.6 34.9l-40.1 6.3 0 0z"
  ]
}, US = {
  prefix: "fak",
  iconName: "spine-solid",
  icon: [
    220,
    512,
    [],
    "e016",
    "M131.9 51.2s0-3.7 0 0c-3.7-7.3 0-11 0-14.6V32.9c-3.7-7.3-11-7.3-18.3-7.3c-3.7-11-18.3-7.3-18.3-7.3c-11 0-14.6-3.7-14.6-3.7C62.5 0 58.8 11 58.8 11s0 0-3.7 3.7c-3.7 0-18.3-3.7-21.9 7.3v3.7c0 3.7 3.7 7.3 0 11c0 0 0 0 0 3.7s0 11 7.3 11c0 0 3.7 0 11-3.7c0 14.6 18.3 11 18.3 11C84.4 54.9 99 62.2 99 62.2c7.3 3.7 11 0 11-3.7c3.7 7.3 14.6 3.7 14.6 3.7c7.3 0 7.3-7.3 7.3-11l0 0zm-7.3 58.5s0-3.7 0 0c-3.7-7.3-3.7-11 0-14.6V91.4c-3.7-11-14.6-11-18.3-7.3c-3.7-11-18.3-7.3-18.3-7.3c-14.6 0-18.3-3.7-18.3-3.7c-14.6-14.6-21.9-3.7-21.9-3.7s0 0-3.7 3.7c-3.7 0-18.3-3.7-21.9 7.3v3.7c0 3.7 3.7 7.3 0 11c0 0 0 0 0 3.7s0 11 7.3 11c0 0 3.7 0 11-3.7c0 14.6 18.3 11 18.3 11c14.6-3.7 32.9 3.7 32.9 3.7c7.3 0 11-3.7 11-7.3c3.7 7.3 14.6 3.7 14.6 3.7c7.3 0 7.3-3.7 7.3-7.3l0 0zm-18.3 54.9l0 0c-3.7-7.3-3.7-11 0-14.6c0-3.7 0-3.7 0-3.7c-3.7-7.3-11-7.3-18.3-7.3c-3.7-7.3-18.3-7.3-18.3-7.3c-11 3.7-18.3 0-18.3 0C36.9 113.4 29.5 128 29.5 128s0 0-3.7 3.7c-3.7 0-18.3-3.7-21.9 7.3c0 3.7 0 3.7 0 3.7c0 3.7 3.7 7.3 0 11v3.7c0 3.7 0 11 7.3 11c0 0 3.7 0 11-3.7c0 14.6 18.3 11 18.3 11c18.3-3.7 32.9 3.7 32.9 3.7c7.3 0 11-3.7 11-7.3c3.7 7.3 14.6 3.7 14.6 3.7c7.3 0 7.3-7.3 7.3-11l0 0zm11 47.5l0 0c-3.7-3.7-3.7-11-3.7-11c0-3.7 0-3.7 0-3.7c-3.7-11-14.6-7.3-18.3-7.3c-7.3-7.3-21.9-3.7-21.9-3.7c-11 3.7-14.6 0-14.6 0c-18.3-11-21.9 3.7-21.9 3.7v3.7c-3.7 0-21.9 0-21.9 11c0 3.7 0 3.7 0 3.7c0 3.7 3.7 7.3 3.7 11v3.7c0 3.7 3.7 7.3 11 7.3c0 0 3.7 0 7.3-3.7c3.7 14.6 18.3 7.3 18.3 7.3c14.6-7.3 29.3 0 29.3 0c7.3 0 11-3.7 11-11c7.3 7.3 14.6 3.7 14.6 3.7c11-3.7 7.3-11 7.3-14.6l0 0zm25.6 40.2s-3.7 0 0 0c-7.3-3.7-7.3-7.3-7.3-11s0-3.7-3.7-3.7c-3.7-7.3-14.6-3.7-18.3 0c-7.3-7.3-18.3 0-18.3 0c-11 7.3-18.3 3.7-18.3 3.7c-21.9-3.7-21.9 7.3-21.9 7.3v3.7c-3.7 0-18.3 3.7-18.3 14.6c0 3.7 0 3.7 3.7 3.7c3.7 3.7 3.7 7.3 3.7 7.3v3.7c0 3.7 3.7 7.3 11 3.7c0 0 3.7 0 7.3-7.3c11 18.3 25.6 11 25.6 11c11-7.3 29.3-7.3 29.3-7.3c7.3-3.7 7.3-7.3 7.3-11c7.3 3.7 14.6 0 14.6 0c7.3-7.3 3.7-14.6 3.7-18.3l0 0zm21.9 47.5l0 0c-3.7-3.7-7.3-7.3-7.3-11s0-3.7-3.7-3.7c-7.3-3.7-14.6 0-18.3 3.7c-7.3-7.3-18.3 3.7-18.3 3.7c-11 7.3-14.6 7.3-14.6 7.3c-21.9-7.3-21.9 7.3-21.9 7.3v3.7c-3.7 0-18.3 7.3-14.6 18.3c0 0 0 3.7 3.7 3.7s7.3 3.7 7.3 7.3v3.7c3.7 3.7 7.3 7.3 14.6 3.7c0 0 3.7 0 7.3-7.3c11 14.6 21.9 0 21.9 0c7.3-7.3 25.6-11 25.6-11c3.7 0 7.3-7.3 7.3-11c7.3 3.7 14.6-3.7 14.6-3.7c3.7-3.7 0-11-3.7-14.6l0 0zm29.3 65.8l0 0c-3.7-3.7-3.7-7.3-7.3-11c0-3.7 0-3.7-3.7-3.7c0-7.3-11-3.7-14.6 0c-7.3-11-21.9-3.7-21.9-3.7c-11 7.3-14.6 3.7-14.6 3.7c-21.9-7.3-21.9 3.7-21.9 3.7v3.7c-3.7 0-18.3 3.7-18.3 14.6c0 3.7 0 3.7 3.7 3.7c3.7 3.7 3.7 7.3 3.7 11v3.7c0 3.7 3.7 7.3 11 7.3c0 0 3.7 0 7.3-7.3c7.3 14.6 21.9 3.7 21.9 3.7c11-7.3 29.3-7.3 29.3-7.3c7.3 0 7.3-7.3 7.3-11c7.3 3.7 14.6 0 14.6 0c7.3 0 7.3-7.3 3.7-11l0 0zm0 73.1s0-3.7 0 0c-3.7-3.7-3.7-11-3.7-14.6s0-3.7 0-3.7c-3.7-7.3-11-7.3-18.3-3.7c-3.7-11-18.3-3.7-18.3-3.7c-14.6 7.3-14.6 0-14.6 0c-14.6-7.3-21.9 0-21.9 0v3.7c-3.7 0-21.9 0-21.9 11c0 3.7 0 3.7 0 3.7c0 3.7 3.7 7.3 3.7 11v3.7c0 3.7 3.7 11 11 7.3c0 0 3.7 0 7.3-3.7c3.7 14.6 18.3 7.3 18.3 7.3c14.6-3.7 29.3 0 29.3 0c7.3 0 11-3.7 11-7.3c7.3 7.3 14.6 3.7 14.6 3.7c7.3-3.7 3.7-11 3.7-14.6l0 0zm-11 73.1s0-3.7 0 0c-3.7-7.3 0-11 0-14.6s0-3.7 0-3.7c-3.7-7.3-11-7.3-18.3-7.3c-3.7-11-18.3-11-18.3-11c-11 3.7-14.6-3.7-14.6-3.7c-14.6-7.3-21.9-3.7-21.9-3.7s0 0-3.7 3.7c-3.7 0-18.3-3.7-21.9 7.3c0 3.7 0 3.7 0 3.7c0 3.7 3.7 7.3 0 11v3.7c0 3.7 0 11 7.3 11c0 0 3.7 0 11-3.7c0 14.6 14.6 11 14.6 11c14.6 0 29.3 7.3 29.3 7.3c7.3 0 11-3.7 14.6-7.3c3.7 7.3 11 3.7 11 3.7c7.3 0 11-7.3 11-7.3l0 0z"
  ]
}, GS = {
  prefix: "fak",
  iconName: "street-view-solid",
  icon: [
    512,
    512,
    [],
    "e004",
    "M320 64c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64 64-28.7 64-64zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5l11-99.5h1.8c17.7 0 32-14.3 32-32v-48c0-35.3-28.7-64-64-64h-64zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6c-7.5 8.1-13.9 19.1-13.9 32.6c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4c44.7 12.3 104.9 19.6 170.5 19.6s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45s-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3c-39.1 10.9-94.9 17.9-157.4 17.9s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69.1-20.5h0z"
  ]
}, YS = {
  prefix: "fak",
  iconName: "user-patient-thin",
  icon: [
    464,
    512,
    [],
    "e002",
    "M234.1 265.3c70.6 0 127.8-57.2 127.8-127.8S304.7 9.7 234.1 9.7 106.4 66.9 106.4 137.5s57.2 127.8 127.8 127.8zm0-239.6c61.8 0 111.8 50.1 111.8 111.8s-50.1 111.8-111.8 111.8-111.8-50.1-111.8-111.8S172.4 25.7 234.1 25.7zm25.2 464.9H40.2c-7.6 0-13.7-6.1-13.7-13.7c0-89.4 72.6-162 162-162h71.3c5-8.3 13.7-14.3 23.8-15.3c.1-.3 .3-.4 .4-.7c-1.4 0-2.9 0-4.3 0h-91.3c-98.4 0-178 79.7-178 178c0 16.4 13.3 29.7 29.7 29.7h241.7c-9.7-1.6-18-7.7-22.5-16zm106-239.2c-18.5 0-33.8 14-35.8 31.9h-4.1c-10.4 0-19.3 6.7-22.7 16h-1.3c-17.7 0-31.9 14.3-31.9 31.9v143.8c0 17.7 14.3 31.9 31.9 31.9h127.8c17.7 0 31.9-14.3 31.9-31.9V331.3c0-17.7-14.3-31.9-31.9-31.9H428c-3.3-9.3-12.1-16-22.7-16h-4.1c-2-18-17.3-31.9-35.8-31.9zm-83.4 83.4c0-12.6 10.1-22.8 22.8-22.8v7.6c0 8.4 6.8 15.1 15.1 15.1h91c8.4 0 15.1-6.8 15.1-15.1V312c12.6 0 22.8 10.1 22.8 22.8v136.6c0 12.6-10.1 22.8-22.8 22.8H304.6c-12.6 0-22.8-10.1-22.8-22.8V334.9h.1zm55.5-43.2c0-15.4 12.6-28 28-28s28 12.6 28 28c0 2.1 1.9 4 4 4h8c8.8 0 16 7.1 16 16v8c0 4.4-3.6 8-8 8h-95.8c-4.4 0-8-3.6-8-8v-8c0-8.8 7.1-16 16-16h8c2.3 0 4-1.7 4-4zm28 7.7c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8zm-12 67.9c0-2.1 1.9-4 4-4h16c2.1 0 4 1.9 4 4v28c0 2.1 1.9 4 4 4h28c2.1 0 4 1.9 4 4v16c0 2.1-1.9 4-4 4h-28c-2.1 0-4 1.9-4 4v28c0 2.1-1.9 4-4 4h-16c-2.1 0-4-1.9-4-4v-28c0-2.1-1.9-4-4-4h-28c-2.1 0-4-1.9-4-4v-16c0-2.1 1.9-4 4-4h28c2.1 0 4-1.9 4-4v-28zm4-12c-6.7 0-12 5.3-12 12v24h-24c-6.7 0-12 5.3-12 12v16c0 6.7 5.3 12 12 12h24v24c0 6.7 5.3 12 12 12h16c6.7 0 12-5.3 12-12v-24h24c6.7 0 12-5.3 12-12v-16c0-6.7-5.3-12-12-12h-24v-24c0-6.7-5.3-12-12-12h-16z"
  ]
}, KS = {
  prefix: "fak",
  iconName: "user-visitor-thin",
  icon: [
    464,
    512,
    [],
    "e003",
    "M234.1 265.3c70.6 0 127.8-57.2 127.8-127.8S304.7 9.7 234.1 9.7 106.4 66.9 106.4 137.5s57.2 127.8 127.8 127.8zm0-239.6c61.8 0 111.8 50.1 111.8 111.8s-50.1 111.8-111.8 111.8-111.8-50.1-111.8-111.8S172.4 25.7 234.1 25.7zm47.2 464.9H40.2c-7.6 0-13.7-6.1-13.7-13.7c0-89.4 72.6-162 162-162h91.3c.4 0 .9 0 1.3 0v-5.3c0-3.9 1.1-7.6 3-10.7c-1.4 0-2.9 0-4.3 0h-91.3c-98.4 0-178 79.7-178 178c0 16.4 13.3 29.7 29.7 29.7h253.6c-6.6-2.7-11.4-8.7-12.4-16zm72.2-167.3h47.9c1.9 0 3.4-1.6 3.4-3.4s-1.6-3.4-3.4-3.4h-47.9c-1.9 0-3.4 1.6-3.4 3.4s1.6 3.4 3.4 3.4zm85.6-34.2H315.9c-11.4 0-20.5 9.1-20.5 20.5v178c0 11.4 9.1 20.5 20.5 20.5h123.2c11.4 0 20.5-9.1 20.5-20.5v-178c0-11.4-9.3-20.5-20.5-20.5zm10 194.1c0 7.1-5.8 13-13 13H319c-7.1 0-13-5.8-13-13V314c0-7.1 5.8-13 13-13h117.1c7.1 0 13 5.8 13 13V483.2zm-71.6-70.9c15.1 0 27.4-12.3 27.4-27.4s-12.3-27.4-27.4-27.4-27.4 12.3-27.4 27.4 12.3 27.4 27.4 27.4zm0-47.9c11.3 0 20.5 9.3 20.5 20.5s-9.1 20.5-20.5 20.5-20.5-9.1-20.5-20.5c0-11.3 9.1-20.5 20.5-20.5zM391.2 426h-27.4c-18.8 0-34.2 15.4-34.2 34.2v3.4c0 1.9 1.6 3.4 3.4 3.4s3.4-1.6 3.4-3.4v-3.4c0-15.1 12.3-27.4 27.4-27.4h27.4c15.1 0 27.4 12.3 27.4 27.4v3.4c0 1.9 1.6 3.4 3.4 3.4s3.4-1.6 3.4-3.4v-3.4c0-18.8-15.4-34.2-34.2-34.2z"
  ]
}, XS = {
  prefix: "fad",
  iconName: "hand-holding-medical",
  icon: [
    576,
    512,
    [],
    "e05c",
    ["M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z", "M248 0c-13.3 0-24 10.7-24 24l0 56-56 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l56 0 0 56c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-56 0 0-56c0-13.3-10.7-24-24-24L248 0z"]
  ]
}, ZS = {
  prefix: "fad",
  iconName: "graduation-cap",
  icon: [
    640,
    512,
    [127891, "mortar-board"],
    "f19d",
    ["M.9 453.4c1.8 5 6 8.9 11.2 10.2l64 16c1.3 .3 2.6 .5 3.9 .5c3 0 6-.8 8.6-2.5c3.7-2.3 6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7c-3.2-14-7.5-28.3-13.4-41.5c1.9-37 19.2-70.9 46.7-94.2c11.5-9.7 24.7-17.6 39.3-23.1c53.1-19.9 106.3-39.9 159.4-59.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4c-53.2 19.9-106.3 39.9-159.4 59.8c-23.9 9-44.9 23.1-61.7 40.9c-27.2 28.7-43.7 66.7-45.1 107.7c-.1 .6-.1 1.2-.1 1.8c0 28.4-10.8 57.8-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4z", "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l77.4 27.9c16.8-17.8 37.8-31.9 61.7-40.9l159.4-59.8c8.3-3.1 17.5 1.1 20.6 9.4s-1.1 17.5-9.4 20.6L166.2 199.6c-14.6 5.5-27.8 13.4-39.3 23.1l169.5 61.2c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"]
  ]
}, QS = {
  prefix: "fad",
  iconName: "video",
  icon: [
    576,
    512,
    ["video-camera"],
    "f03d",
    ["M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 68.2 0 119.6 0 68.2c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z", "M576 128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6L384 196.2V315.8l142.2 94.8c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128z"]
  ]
}, JS = {
  prefix: "fad",
  iconName: "shield-keyhole",
  icon: [
    512,
    512,
    [],
    "e248",
    ["M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM200 208c0-30.9 25.1-56 56-56c15.5 0 29.5 6.3 39.6 16.4c5.1 5.1 9.2 11.1 12 17.8c1.4 3.3 2.5 6.9 3.3 10.5c.4 1.9 .7 3.8 .9 5.7c.1 .9 .2 1.9 .2 2.8c0 .9 .1 1.8 .1 2.9l0 .6c0 .4 0 1 0 1.7c0 .6-.1 1.2-.1 1.8c-.1 1.3-.3 2.7-.4 4.1c-.4 2.7-1 5.3-1.7 7.8c-1.5 5.1-3.7 9.9-6.6 14.2c-5.6 8.7-13.6 15.8-23.1 20.3c0 23.1 0 46.3 0 69.4l0 .4c0 .5 0 1.3-.1 2.1c-.1 .8-.2 1.6-.4 2.4c-.3 1.5-.8 3.1-1.4 4.5c-1.2 2.9-3 5.4-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-23.1 0-46.3 0-69.4c-18.9-9-32-28.3-32-50.6z", "M280 258.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 69.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-69.4z"]
  ]
}, eL = {
  prefix: "fad",
  iconName: "circle-3",
  icon: [
    512,
    512,
    [],
    "e0f0",
    ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 152c0-13.3 10.7-24 24-24l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2L240 384c-30.1 0-58.1-15.6-73.9-41.2c-.9-1.4-1.7-2.8-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c10 0 19-4 25.6-10.6c3.3-3.3 5.9-7.2 7.7-11.5c.9-2.2 1.6-4.4 2.1-6.8c.2-1.2 .4-2.4 .5-3.6c.1-.6 .1-1.2 .1-1.8s0-1.2 0-2c0-.6 0-1.2 0-1.8s-.1-1.2-.1-1.8c-.1-1.2-.3-2.4-.6-3.6c-.5-2.4-1.2-4.6-2.1-6.8c-1.8-4.3-4.5-8.2-7.8-11.5c-6.6-6.5-15.7-10.6-25.7-10.5l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L250.3 176 184 176c-13.3 0-24-10.7-24-24z", "M160 152c0-13.3 10.7-24 24-24l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2L240 384c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L250.3 176 184 176c-13.3 0-24-10.7-24-24z"]
  ]
}, tL = {
  prefix: "fad",
  iconName: "boot",
  icon: [
    512,
    512,
    [129406],
    "f782",
    ["M0 96l320 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 119.3 29.8C482 296.5 512 334.9 512 379l0 69L0 448 0 96z", "M32 0C14.3 0 0 14.3 0 32L0 96l320 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 0zM0 448l0 9.4c0 14.5 5.8 28.4 16 38.6s24.1 16 38.6 16l14.9 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l11 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l11 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l14.9 0c14.5 0 28.4-5.8 38.6-16s16-24.1 16-38.6l0-9.4L0 448z"]
  ]
}, nL = {
  prefix: "fad",
  iconName: "circle-2",
  icon: [
    512,
    512,
    [],
    "e0ef",
    ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm161.7 96.8c-3.6-9.2-1.3-19.6 5.9-26.3c36.2-34 72.5-67.9 108.7-101.9c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3c-8.1 6.1-16.1 12.3-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6c8.1-6.1 16.1-12.3 24.2-18.4c15.8-12 35.2-18.4 55.1-18.1c1.1 0 2.3 0 3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1c-21.5 20.1-42.9 40.3-64.4 60.4c27.8 0 55.5 0 83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-48 0-96 0-144 0c-9.8 0-18.7-6-22.3-15.2z", "M248 160.3c-9.1-.1-18 2.8-25.3 8.3l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L244.7 320l83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L276.3 224.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1z"]
  ]
}, rL = {
  prefix: "fad",
  iconName: "syringe",
  icon: [
    512,
    512,
    [128137],
    "f48e",
    ["M0 488c0 6.1 2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l57-57 88.8 0c14.9 0 29.1-5.9 39.6-16.4L440 217.9c-.3-.3-.7-.6-1-.9l-16-16-56-56L311 89 295 73c-.3-.3-.6-.7-.9-1c-27.9 27.9-55.8 55.8-83.7 83.7c19 19 38 38 57 57c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-19-19-38-38-57-57c-13.8 13.8-27.6 27.6-41.4 41.4c19 19 38 38 57 57c6.2 6.2 6.2 16.4 0 22.6c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-19-19-38-38-57-57L80.4 285.7C69.9 296.2 64 310.4 64 325.3l0 88.8L7 471c-4.7 4.7-7 10.8-7 17z", "M441 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15 15L384 94.1 329 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72 72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L456 89.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L473 39 441 7zM210.3 155.7l-22.6 22.6 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57zm-64 64l-22.6 22.6 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"]
  ]
}, aL = {
  prefix: "fad",
  iconName: "circle-4",
  icon: [
    512,
    512,
    [],
    "e0f1",
    ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.3 36.2c.2-1.3 .5-2.5 .9-3.8c16-48 32-96 48-144c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4c-12.5 37.5-25 74.9-37.5 112.4c23.6 0 47.1 0 70.7 0l0-56c0-.8 0-1.6 .1-2.5s.2-1.6 .4-2.4c.3-1.6 .8-3.1 1.4-4.5c1.2-2.9 3-5.5 5.1-7.6c4.3-4.3 10.3-7 17-7c13.3 0 24 10.7 24 24l0 56c2.7 0 5.3 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.7 0-5.3 0-8 0l0 40c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-1.2-.4-2.4-.4-2.4c-.1-1.2-.1-1.2-.1-2.5c0-13.3 0-26.7 0-40c-34.7 0-69.3 0-104 0c-7.7 0-15-3.7-19.5-10c-1.5-2.1-2.6-4.3-3.4-6.7c-.4-1.2-.7-2.4-.9-3.6c-.1-.9-.2-1.8-.2-1.8c-.1-.9-.1-.9-.1-1.9c0-.6 0-1.3 .1-1.9s.1-1.3 .2-1.9z", "M238.8 159.6c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10l104 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-70.7 0 37.5-112.4z"]
  ]
}, iL = {
  prefix: "fad",
  iconName: "brain",
  icon: [
    512,
    512,
    [129504],
    "f5dc",
    ["M0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56l0-400c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304zM272 56l0 400c0 30.9 25.1 56 56 56c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56z", "M240 456l0-400 32 0 0 400-32 0z"]
  ]
}, sL = {
  prefix: "fad",
  iconName: "buildings",
  icon: [
    512,
    512,
    [],
    "e0cc",
    ["M0 192L0 448c0 35.3 28.7 64 64 64l192 0 192 0c35.3 0 64-28.7 64-64l0-256 0-128c0-35.3-28.7-64-64-64L256 0c-35.3 0-64 28.7-64 64l0 64L64 128c-35.3 0-64 28.7-64 64zm64 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM256 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM384 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z", "M256 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 192l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM272 320c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0zM80 288l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm304 16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM400 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 208l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0z"]
  ]
}, oL = {
  prefix: "fad",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    ["", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
  ]
}, cL = {
  prefix: "fad",
  iconName: "book",
  icon: [
    448,
    512,
    [128212],
    "f02d",
    ["M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z", "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-64 0-96 0L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 96 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zm144 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0zm-16 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16z"]
  ]
}, lL = {
  prefix: "fad",
  iconName: "clipboard-list-check",
  icon: [
    384,
    512,
    [],
    "f737",
    ["M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128zM64 272c0-4.1 1.6-8.2 4.7-11.3c6.2-6.2 16.4-6.2 22.6 0L112 281.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-3.1-3.1-4.7-7.2-4.7-11.3zm56 128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm40 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm32-96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z", "M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM187.3 228.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 281.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0zM72 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
  ]
}, dL = {
  prefix: "fad",
  iconName: "shoe-prints",
  icon: [
    640,
    512,
    [],
    "f54b",
    ["M0 416c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64zm128-64l0 128s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32z", "M256 32s96.3-32 160-32c96 0 224 48 224 128s-119.6 96-176 96c-48 0-76-16-104-32s-56-32-104-32l0-128zm-64 0l32 0 0 128-32 0c-35.3 0-64-28.7-64-64s28.7-64 64-64z"]
  ]
}, uL = {
  prefix: "fad",
  iconName: "user-doctor-message",
  icon: [
    640,
    512,
    ["user-md-chat"],
    "f82e",
    ["M0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1l0 50.8c27.6 7.1 48 32.2 48 62l0 40c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-40c0-29.8 20.4-54.9 48-62l0-57.1c-6-.6-12.1-.9-18.3-.9l-91.4 0c-6.2 0-12.3 .3-18.3 .9l0 65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-59.1C54 332.9 0 401.3 0 482.3zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm24 296a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z", "M384 48c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-48 0-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2l0-56-16 0c-26.5 0-48-21.5-48-48l0-128z"]
  ]
}, fL = uL, pL = {
  prefix: "fad",
  iconName: "calendar",
  icon: [
    448,
    512,
    [128197, 128198],
    "f133",
    ["M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192z", "M160 32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32z"]
  ]
}, mL = {
  prefix: "fad",
  iconName: "shield-heart",
  icon: [
    512,
    512,
    [],
    "e574",
    ["M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zm352 81.8c0-.4 0-.3 0 0z", "M205.3 160c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
  ]
}, hL = {
  prefix: "fad",
  iconName: "house-medical",
  icon: [
    576,
    512,
    [],
    "e3b2",
    ["M64 270.5c74.7-65.3 149.3-130.7 224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1l-320.4 0c-35.3 0-64-28.6-64-64L64 270.5zM192 304l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z", "M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2l-256-224zM256 240l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
  ]
}, gL = {
  prefix: "fad",
  iconName: "award",
  icon: [
    384,
    512,
    [],
    "f559",
    ["M0 448c0-2.1 .4-4.2 1.3-6.2L56.9 309.7l1.8 .9c6.4 3.2 11.5 8.4 14.7 14.7L83 344.5c5.9 11.8 18.3 19 31.5 18.2l21.3-1.3c7.1-.4 14.2 1.5 20.1 5.4l17.8 11.8c3.4 2.3 7.2 3.8 11 4.7l-50.1 119c-2.3 5.5-7.4 9.2-13.3 9.7c-.5 0-1 .1-1.4 .1c-5.4 0-10.4-2.7-13.4-7.3L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6C1.1 455 0 451.5 0 448zm199.2-64.8c1.9-.4 3.8-1 5.7-1.8c.9-.4 1.8-.8 2.7-1.3c.4-.2 .9-.5 1.3-.7s.9-.5 1.3-.8L228 366.8c6-3.9 13-5.8 20.1-5.4l21.3 1.3c13.2 .8 25.6-6.4 31.5-18.2l9.6-19.1c3.2-6.4 8.4-11.5 14.7-14.7l1.8-.9 55.6 132.1c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7l-50.1-119z", "M210.2 5.5c-11-7.3-25.4-7.3-36.4 0L156 17.2c-6 3.9-13 5.8-20.1 5.4l-21.3-1.3c-13.2-.8-25.6 6.4-31.5 18.2L73.4 58.6C70.2 65 65 70.2 58.6 73.4L39.5 83c-11.8 5.9-19 18.3-18.2 31.5l1.3 21.3c.4 7.1-1.5 14.2-5.4 20.1L5.5 173.8c-7.3 11-7.3 25.4 0 36.4L17.2 228c3.9 6 5.8 13 5.4 20.1l-1.3 21.3c-.8 13.2 6.4 25.6 18.2 31.5l19.1 9.6c6.4 3.2 11.5 8.4 14.7 14.7L83 344.5c5.9 11.8 18.3 19 31.5 18.2l21.3-1.3c7.1-.4 14.2 1.5 20.1 5.4l17.8 11.8c11 7.3 25.4 7.3 36.4 0L228 366.8c6-3.9 13-5.8 20.1-5.4l21.3 1.3c13.2 .8 25.6-6.4 31.5-18.2l9.6-19.1c3.2-6.4 8.4-11.5 14.7-14.7l19.1-9.6c11.8-5.9 19-18.3 18.2-31.5l-1.3-21.3c-.4-7.1 1.5-14.2 5.4-20.1l11.8-17.8c7.3-11 7.3-25.4 0-36.4L366.8 156c-3.9-6-5.8-13-5.4-20.1l1.3-21.3c.8-13.2-6.4-25.6-18.2-31.5l-19.1-9.6c-6.4-3.2-11.5-8.4-14.7-14.7L301 39.5c-5.9-11.8-18.3-19-31.5-18.2l-21.3 1.3c-7.1 .4-14.2-1.5-20.1-5.4L210.2 5.5zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
  ]
}, vL = {
  prefix: "fad",
  iconName: "trophy",
  icon: [
    576,
    512,
    [127942],
    "f091",
    ["M0 88C0 222.5 70.4 295.7 140.5 334.1c34.5 18.9 68.8 29.3 94.3 35c5.5 1.2 10.6 2.3 15.3 3.1c-3.7-7-8.8-13.4-15-18.9c-1.5-1.3-3-2.7-4.5-4.1c-1.7-1.6-3.3-3.1-4.9-4.8c-3.2-3.3-6.5-6.8-9.8-10.7c-6.6-7.7-13.2-16.4-20.1-26.7c-10.5-4.2-21.4-9.2-32.3-15.1C109.8 262.6 56.4 209.9 48.9 112l85.3 0c-1.8-15.1-3.3-31.1-4.3-48L24 64C10.7 64 0 74.7 0 88zM325.9 372.1c4.7-.8 9.8-1.9 15.3-3.1c25.5-5.7 59.8-16.1 94.3-35C505.6 295.7 576 222.5 576 88c0-13.3-10.7-24-24-24L446.1 64c-1 16.9-2.5 32.9-4.3 48l85.3 0c-7.5 97.9-60.9 150.6-114.6 179.9c-11 6-22 11-32.6 15.2c-13.1 20.2-26.6 35.2-39.1 46.3c-6 5.4-11.2 11.7-14.8 18.7z", "M256 395.5c0-16.3-8.6-31.2-20.8-42C192.2 315.3 137.3 231 129.1 48c-1.2-26.5 20.4-48 47-48L400 0c26.5 0 48.1 21.6 47 48c-8.2 183-63.2 267.2-106.2 305.4c-12.2 10.8-20.8 25.7-20.8 42l0 4.5c0 26.5 21.5 48 48 48l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0c26.5 0 48-21.5 48-48l0-4.5z"]
  ]
}, bL = {
  prefix: "fad",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    ["M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z", ""]
  ]
}, yL = {
  prefix: "fad",
  iconName: "cars",
  icon: [
    640,
    512,
    [],
    "f85b",
    ["M0 192l0 96c0 10.7 0 21.3 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 136.5 0c5.1-5.7 10.8-10.7 17.1-15.1l22.8-68.3c15.2-45.7 58-76.6 106.3-76.6l15.1 0L353.3 54.7C342.4 22 311.8 0 277.4 0L138.6 0c-34.4 0-65 22-75.9 54.7L36.1 134.4C14.8 144.7 0 166.6 0 192zm104 16a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm1.7-80l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9l138.8 0c6.9 0 13 4.4 15.2 10.9L310.3 128l-204.5 0z", "M347.4 234.9L329.7 288l204.5 0-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9l-138.8 0c-6.9 0-13 4.4-15.2 10.9zm-87.3 59.4l26.6-79.7C297.6 182 328.2 160 362.6 160l138.8 0c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352l0 96s0 0 0 0l0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32s0 0 0 0l0-96c0-25.4 14.8-47.3 36.1-57.6zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  ]
}, xL = {
  prefix: "fad",
  iconName: "users-line",
  icon: [
    640,
    512,
    [],
    "e592",
    ["M32 256c0 17.7 14.3 32 32 32l85.6 0c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4l-96 0c-35.3 0-64 28.7-64 64zM83.2 96a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm94.4 224c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6c-6.9-1.6-14.2-2.4-21.6-2.4l-96 0c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32zm64-208a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm174.3 88.6c38.1 14.8 67.4 47.3 77.7 87.4l82.4 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-11.7 0-22.7 3.1-32.1 8.6zM435.2 96a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z", "M0 448c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z"]
  ]
}, _L = {
  prefix: "fad",
  iconName: "baby",
  icon: [
    448,
    512,
    [],
    "f77c",
    ["M32 168c0 12.4 5.7 24.6 16.5 32.4l36.2 26.4c13.6 9.9 28.1 18.2 43.3 25l0 36.3 192 0 0-36.3c15.2-6.7 29.7-15.1 43.3-25l36.2-26.4c17.9-13 21.8-38 8.8-55.9s-38-21.8-55.9-8.8L316.2 162c-26.8 19.5-59.1 30-92.2 30s-65.4-10.5-92.2-30L95.5 135.7c-17.9-13-42.9-9-55.9 8.8C34.5 151.6 32 159.8 32 168zM79.2 401.1C68.1 417 70 438.6 83.7 452.3l48 48c7.8 7.8 18 11.7 28.3 11.7s20.5-3.9 28.3-11.7c15.6-15.6 15.6-40.9 0-56.6L164 419.4l26-37.2c-20.2-17.7-40.4-35.3-60.6-53L79.2 401.1zM152 88a72 72 0 1 0 144 0A72 72 0 1 0 152 88zM258 382.3l26 37.2-24.3 24.3c-15.6 15.6-15.6 40.9 0 56.6c7.8 7.8 18 11.7 28.3 11.7s20.5-3.9 28.3-11.7l48-48c13.7-13.7 15.6-35.3 4.5-51.2l-50.2-71.8c-20.2 17.7-40.4 35.3-60.6 53z", "M192 384l-64-56V288H320v40l-64 56H192z"]
  ]
}, wL = {
  prefix: "fad",
  iconName: "circle-1",
  icon: [
    512,
    512,
    [],
    "e0ee",
    ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM168 360c0-13.3 10.7-24 24-24l40 0 0-142.6-20.1 11.5c-11.5 6.6-26.2 2.6-32.7-8.9s-2.6-26.2 8.9-32.7l56-32c3.7-2.1 7.8-3.2 11.9-3.2c4.2 0 8.3 1.1 12 3.2c7.4 4.3 12 12.2 12 20.8l0 184 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-64 0c-13.3 0-24-10.7-24-24z", "M280 152c0-8.6-4.6-16.5-12-20.8s-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L232 193.4 232 336l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-184z"]
  ]
}, CL = {
  prefix: "fad",
  iconName: "user-headset",
  icon: [
    448,
    512,
    [],
    "f82d",
    ["M96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256l-8.6 0c-11.1-19.1-31.7-32-55.4-32l-32 0c-35.3 0-64 28.7-64 64c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192z", "M224 32C135.6 32 64 103.6 64 192l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16C32 86 118 0 224 0S416 86 416 192l0 16c0 61.9-50.1 112-112 112l-64 0-16 0-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l32 0c44.2 0 80-35.8 80-80l0-16c0-88.4-71.6-160-160-160zM134.4 352l179.2 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352z"]
  ]
}, SL = {
  prefix: "fad",
  iconName: "hospitals",
  icon: [
    576,
    512,
    [],
    "f80e",
    ["M256 48c0-26.5 21.5-48 48-48L528 0c26.5 0 48 21.5 48 48l0 208-144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0 0 64-144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0 0 80c0 26.5-21.5 48-48 48l-216.6 0c5.4-9.4 8.6-20.3 8.6-32l0-352c0-35.3-28.7-64-64-64l0-16zm112 88l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16z", "M408 96l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM48 96C21.5 96 0 117.5 0 144L0 384l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 416l0 48c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L48 96zm88 80l16 0c8.8 0 16 7.2 16 16l0 24 24 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-24 0 0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24-24 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l24 0 0-24c0-8.8 7.2-16 16-16z"]
  ]
}, LL = {
  prefix: "fad",
  iconName: "magnifying-glass",
  icon: [
    512,
    512,
    [128269, "search"],
    "f002",
    ["M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm352 0A144 144 0 1 1 64 208a144 144 0 1 1 288 0z", "M330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z"]
  ]
}, ML = LL, NL = {
  prefix: "fad",
  iconName: "fax",
  icon: [
    512,
    512,
    [128224, 128439],
    "f1ac",
    ["M128 64l0 128 352 0 0-101.5c0-17-6.7-33.3-18.7-45.3L434.7 18.7C422.7 6.7 406.5 0 389.5 0L192 0c-35.3 0-64 28.7-64 64zm96 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z", "M32 128c-17.7 0-32 14.3-32 32L0 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32l-32 0zm448 64l-352 0 0 288c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  ]
}, zL = {
  prefix: "fad",
  iconName: "hospital",
  icon: [
    640,
    512,
    [62589, 127973, "hospital-alt", "hospital-wide"],
    "f0f8",
    ["M0 144l0 48 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 224l0 64 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 320 0 464c0 26.5 21.5 48 48 48l112 0 0-416L48 96C21.5 96 0 117.5 0 144zM480 96l0 416 112 0c26.5 0 48-21.5 48-48l0-144-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L480 96z", "M208 0c-26.5 0-48 21.5-48 48l0 464 112 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 112 0 0-464c0-26.5-21.5-48-48-48L208 0zM640 224l0-32-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0zm0 96l0-32-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0zM80 224c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 192l0 32 80 0zm0 96c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 288l0 32 80 0zM312 64l16 0c8.8 0 16 7.2 16 16l0 24 24 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-24 0 0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24-24 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l24 0 0-24c0-8.8 7.2-16 16-16z"]
  ]
}, EL = {
  prefix: "fad",
  iconName: "location-dot",
  icon: [
    384,
    512,
    ["map-marker-alt"],
    "f3c5",
    ["M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm272 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z", "M192 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]
  ]
}, TL = EL, kL = {
  prefix: "fad",
  iconName: "square-h",
  icon: [
    448,
    512,
    ["h-square"],
    "f0fd",
    ["M0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm112 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208z", "M312 128c13.3 0 24 10.7 24 24l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24z"]
  ]
}, jL = {
  prefix: "fad",
  iconName: "credit-card",
  icon: [
    576,
    512,
    [62083, 128179, "credit-card-alt"],
    "f09d",
    ["M0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM0 224L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-192L0 224zM96 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z", "M576 224H0V128H576v96z"]
  ]
}, PL = {
  prefix: "fad",
  iconName: "kit-medical",
  icon: [
    576,
    512,
    ["first-aid"],
    "f479",
    ["M96 32l32 0 0 448-32 0L96 32zm352 0l32 0 0 448-32 0 0-448z", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l32 0L96 32 64 32zm64 0l0 448 320 0 0-448L128 32zM512 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-32 0 0 448 32 0zM256 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
  ]
}, AL = {
  prefix: "fad",
  iconName: "mars",
  icon: [
    448,
    512,
    [9794],
    "f222",
    ["M96 304a80 80 0 1 0 160 0A80 80 0 1 0 96 304z", "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8l112 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80s0 0 0 0s0 0 0 0s0 0 0 0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
  ]
}, $L = {
  prefix: "fad",
  iconName: "folder-medical",
  icon: [
    512,
    512,
    [],
    "e18c",
    ["M0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L288 96c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32L64 32C28.7 32 0 60.7 0 96zM160 272c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32z", "M240 192c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0z"]
  ]
}, h2 = {
  prefix: "fad",
  iconName: "laptop-medical",
  icon: [
    640,
    512,
    [],
    "f812",
    ["M0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384C8.6 384 0 392.6 0 403.2zM64 96l0 256 64 0 0-256 384 0 0 256 64 0 0-256c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96z", "M512 96L128 96l0 256 384 0 0-256zM288 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
  ]
}, IL = {
  prefix: "fad",
  iconName: "house",
  icon: [
    576,
    512,
    [63498, 63500, 127968, "home", "home-alt", "home-lg-alt"],
    "f015",
    ["M64 270.5c74.7-65.3 149.3-130.6 224-196L512.1 270.6l.4 201.3c0 22.1-17.9 40.1-40 40.1L392 512c-22.1 0-40-17.9-40-40l0-88.3c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 88.3c0 22.1-17.9 40-40 40l-79.9 0c-22.1 0-40-17.9-40-40L64 270.5z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z"]
  ]
}, OL = {
  prefix: "fad",
  iconName: "mobile",
  icon: [
    384,
    512,
    [128241, "mobile-android", "mobile-phone"],
    "f3ce",
    ["M16 384l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-64L16 384zm128 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z", "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V384H16V64z"]
  ]
}, RL = OL, DL = {
  prefix: "fad",
  iconName: "industry-windows",
  icon: [
    576,
    512,
    [127981, "industry-alt"],
    "f3b3",
    ["M32 64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 146.1 0 5.3 0 50c64-36.6 128-73.1 192-109.7l0 54.4 0 5.3 0 50c64-36.6 128-73.1 192-109.7L544 304l0 128c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-80 0-48L32 64zM248 328l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm128 0l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z", "M363.9 148.8c11.5-6.6 15.5-21.2 8.9-32.7s-21.2-15.5-32.7-8.9L160 210.1l0 55.3L363.9 148.8zm192 0c11.5-6.6 15.5-21.2 8.9-32.7s-21.2-15.5-32.7-8.9L352 210.1l0 55.3L555.9 148.8zM136 312c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm128 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm112 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z"]
  ]
}, FL = DL, BL = {
  prefix: "fad",
  iconName: "piggy-bank",
  icon: [
    576,
    512,
    [],
    "f4d3",
    ["M208 96c0 13.2 2.7 25.7 7.5 37.2c12.9-3.4 26.5-5.2 40.5-5.2l128 0c1.8 0 3.5 0 5.2 .1s3.5 .1 5.2 .2c3.6-10.1 5.6-21 5.6-32.3c0-53-43-96-96-96s-96 43-96 96z", "M507 115.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9l13.3 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-32 0c-9.1 12.1-19.9 22.9-32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-128 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c-34.9-26.2-58.7-66.3-63.2-112L68 304c-37.6 0-68-30.4-68-68s30.4-68 68-68l4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-4 0c-11 0-20 9-20 20s9 20 20 20l31.2 0C114 183 178.6 128 256 128l128 0c7.8 0 15.5 .6 23 1.6C424.6 109.1 450.8 96 480 96l11.5 0c10.4 0 18 9.8 15.5 19.9zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  ]
}, VL = {
  prefix: "fad",
  iconName: "clock",
  icon: [
    512,
    512,
    [128339, "clock-four"],
    "f017",
    ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120c.1-13.4 10.8-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.5c0 41 0 82.1 0 123.2L365.3 300c6.9 4.6 10.7 12.2 10.7 20c0 4.6-1.3 9.2-4 13.3c-4.6 6.9-12.2 10.7-20 10.7c-4.6 0-9.2-1.3-13.3-4c-32-21.3-64-42.7-96-64C236 271.5 232 264 232 256c0-45.3 0-90.7 0-136z", "M256 96c-13.3 0-24 10.7-24 24l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24z"]
  ]
}, HL = {
  prefix: "fad",
  iconName: "shield-plus",
  icon: [
    512,
    512,
    [],
    "e24a",
    ["M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM144 256c0-13.3 10.7-24 24-24l64 0c0-21.3 0-42.7 0-64c0-13.3 10.7-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.1l0 .4c0 21.3 0 42.7 0 64l64 0c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.5 .1 2l0 .4 0 .4c0 .5 0 1.3-.1 2.1c-.1 .8-.2 1.6-.4 2.4c-.3 1.5-.8 3-1.4 4.5c-1.2 2.9-3 5.4-5.1 7.6c-4.3 4.3-10.3 7-17 7l-64 0c0 21.3 0 42.7 0 64l0 .3c0 .6 0 1.3-.1 2.1c-.1 .8-.2 1.6-.4 2.4c-.3 1.5-.8 3.1-1.4 4.5c-1.2 2.9-3 5.4-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24c0-21.3 0-42.7 0-64l-64 0c-13.3 0-24-10.7-24-24z", "M232 280l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0z"]
  ]
}, qL = {
  prefix: "fad",
  iconName: "hands-asl-interpreting",
  icon: [
    640,
    512,
    ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"],
    "f2a3",
    ["M305.1 392.4c4.7 17.1 22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2l0-9.3c0-70.7-57.3-128-128-128l-72 0-8 0c-35.2 3-65.4 23.1-82.1 52c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.6-27.1 22.2-22.5 39.3z", "M142.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9l-23 46L235.5 7.4c13.6-11.3 33.8-9.5 45.1 4.1s9.5 33.8-4.1 45.1l-81.6 68L295.6 97.1c17.1-4.7 34.6 5.4 39.3 22.5s-5.4 34.6-22.5 39.3l-80.8 22c24.9 7.9 45.6 24.9 58.4 47.1c8.8 15.3 3.6 34.9-11.7 43.7s-34.9 3.6-43.7-11.7c-7-12-19.9-20-34.7-20c-22.1 0-40 17.9-40 40s17.9 40 40 40c14.8 0 27.7-8 34.7-20c8.8-15.3 28.4-20.5 43.7-11.7s20.5 28.4 11.7 43.7c-16.7 28.8-46.9 49-82.1 51.7l0 .3-8 0-72 0C57.3 384 0 326.7 0 256l0-9.3c0-19.9 4.6-39.5 13.5-57.2L99.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3z"]
  ]
}, WL = qL, UL = {
  prefix: "fad",
  iconName: "chart-user",
  icon: [
    640,
    512,
    ["user-chart"],
    "f6a3",
    ["M160 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-11.8-25.5-29.9-47.5-52.4-64L576 352l0-288L224 64l0 49.1C205.2 102.2 183.3 96 160 96l0-32zM303 175c9.4-9.4 24.6-9.4 33.9 0l47 47 55.7-55.7-27-27c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l88 0c8.8 0 16 7.2 16 16l0 88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9z", "M160 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-26.7 32C59.7 352 0 411.7 0 485.3C0 500.1 11.9 512 26.7 512l266.7 0c14.7 0 26.7-11.9 26.7-26.7C320 411.7 260.3 352 186.7 352l-53.3 0z"]
  ]
}, GL = {
  prefix: "fad",
  iconName: "street-view",
  icon: [
    512,
    512,
    [],
    "f21d",
    ["M0 424c0 22.1 15.1 37.4 29.8 47c15.2 9.9 35.5 17.5 57.8 23.3C132.7 505.9 192.9 512 256 512s123.3-6.1 168.4-17.8c22.4-5.8 42.6-13.3 57.8-23.3c14.7-9.6 29.8-24.9 29.8-47s-15.1-37.4-29.8-47c-15.2-9.9-35.5-17.5-57.8-23.3c-30.9-8-68.8-13.4-109.9-16l-5.3 47.8c39.6 2.4 75.3 7.5 103.2 14.7c56.6 14.6 56.6 32.9 0 47.5C372.5 458.1 316.6 464 256 464s-116.5-5.9-156.4-16.2c-56.6-14.6-56.6-32.9 0-47.5c27.9-7.2 63.6-12.3 103.2-14.7c-1.8-15.9-3.5-31.8-5.3-47.8c-41.1 2.6-79 8-109.9 16C65.2 359.6 45 367.1 29.8 377C15.1 386.6 0 401.9 0 424z", "M256 0a64 64 0 1 1 0 128A64 64 0 1 1 256 0zM160 224c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 48c0 17.7-14.3 32-32 32l-1.8 0-11.1 99.5c-1.8 16.2-15.5 28.5-31.8 28.5l-38.7 0c-16.3 0-30-12.3-31.8-28.5L193.8 304l-1.8 0c-17.7 0-32-14.3-32-32l0-48z"]
  ]
}, YL = {
  prefix: "fad",
  iconName: "circle-5",
  icon: [
    512,
    512,
    [],
    "e0f2",
    ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160 72c0-7.7 3.7-15.3 10.6-19.9c11-7.4 25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c8.6 0 16.5-3.5 22.1-9.2c2.8-2.8 5.1-6.2 6.7-9.9c.8-1.9 1.4-3.8 1.8-5.9c.2-1 .4-2.1 .5-3.1c.1-.5 .1-1.1 .1-1.6s0-1 0-1.8c0-.6 0-1 0-1.4c0-.5-.1-1-.1-1.5c-.1-1-.2-1.9-.4-2.9c-.4-1.9-.9-3.7-1.6-5.5c-1.4-3.5-3.4-6.7-5.8-9.5c-5-5.6-11.9-9.3-19.8-10.2c-29-3.3-57.9-6.5-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0c-2.6 14.3-5.2 28.7-7.8 43l61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3l-36 0c-27.5 0-53.3-13.7-68.6-36.6c-1.4-2-2.7-4-4.1-6.1c-2.8-4.1-4.1-8.8-4.1-13.4z", "M184.4 147.7c2.1-11.4 12-19.7 23.6-19.7l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3l-36 0c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88z"]
  ]
}, KL = {
  prefix: "fad",
  iconName: "house-medical-circle-check",
  icon: [
    640,
    512,
    [],
    "e511",
    ["M0 255.5c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l266.7 0C349.5 480.1 320 427.5 320 368c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 40.2 0c32.3-39.1 81.1-64 135.8-64c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24zM320 352l0 16c0-5.4 .2-10.7 .7-16l-.7 0z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
  ]
}, XL = {
  prefix: "fad",
  iconName: "dumbbell",
  icon: [
    640,
    512,
    [],
    "f44b",
    ["M0 256c0 17.7 14.3 32 32 32l0-64c-17.7 0-32 14.3-32 32zm192-32l0 64 256 0 0-64-256 0zm416 0l0 64c17.7 0 32-14.3 32-32s-14.3-32-32-32z", "M128 32c-17.7 0-32 14.3-32 32l0 64-32 0c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l32 0 0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32l-32 0zm384 0l-32 0c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64 32 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-32 0 0-64c0-17.7-14.3-32-32-32z"]
  ]
}, ZL = {
  prefix: "fad",
  iconName: "plate-utensils",
  icon: [
    640,
    512,
    [58713],
    "e43b",
    ["M152 266.8l0 116.9C192.5 441.9 259.8 480 336 480c89.4 0 166.6-52.4 202.6-128.2c-23.9-2-44-17.2-53.2-38.2C462.2 373.5 404.1 416 336 416c-88.4 0-160-71.6-160-160l0-.6c-7.4 4.8-15.5 8.6-24 11.4zM204.9 74.3l16.3 69.2c.1 .3 .1 .5 .2 .8C250.5 114.5 291.1 96 336 96c63.3 0 118.1 36.8 144 90.2l0-26.2c0-25 4.3-46.7 11.3-65.5C451 55.8 396.3 32 336 32c-48.9 0-94.2 15.7-131.1 42.3zM208 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0z", "M48 23.5c-.2-4-3.3-7.2-7.3-7.5s-7.6 2.3-8.5 6.1L1.9 150.9C.6 156.3 0 161.9 0 167.5c0 39.9 32.2 72.2 72 72.5l0 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232c39.8-.3 72-32.6 72-72.5c0-5.6-.6-11.2-1.9-16.6L159.8 22.2c-.9-3.9-4.5-6.5-8.5-6.1s-7.1 3.5-7.3 7.5L136.5 152l-17.3 0L103.9 23.1c-.5-4-3.9-7.1-7.9-7.1s-7.5 3-7.9 7.1L72.9 152l-17.3 0L48 23.5zM512 160l0 128c0 17.7 14.3 32 32 32l48 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 0-104 0-179.1c0-11.5-9.3-20.9-20.9-20.9c-2.1 0-4.1 .3-6.1 1C596.2 23.2 512 59.2 512 160z"]
  ]
}, QL = {
  prefix: "fad",
  iconName: "circle-info",
  icon: [
    512,
    512,
    ["info-circle"],
    "f05a",
    ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm192-8c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-64-24 0c-13.3 0-24-10.7-24-24zm96-88a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z", "M256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 248c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-64-24 0c-13.3 0-24-10.7-24-24z"]
  ]
}, JL = QL, eM = {
  prefix: "fad",
  iconName: "user-doctor",
  icon: [
    448,
    512,
    ["user-md"],
    "f0f0",
    ["M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z", "M280 304c2.7 0 5.3 .1 8 .2l0 57.8c-27.6 7.1-48 32.2-48 62l0 40c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-40c0-29.8-20.4-54.9-48-62l0-53.2C393.5 326.7 448 393 448 472l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-79 54.5-145.3 128-163.2l0 61.5c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-66.1c2.7-.1 5.3-.2 8-.2l112 0zM144 400a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  ]
}, tM = {
  prefix: "fad",
  iconName: "lungs",
  icon: [
    640,
    512,
    [129729],
    "f604",
    ["M.2 412c-.2 1.3-.2 2.6-.2 4l0 7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7l72.7-18.2C226 480.5 256 442.1 256 398l0-111.4L161.2 347c-14.9 9.5-34.7 5.1-44.2-9.8c-3.4-5.3-5-11.3-5-17.2c0-10.6 5.2-20.9 14.8-27c43.1-27.4 86.1-54.8 129.2-82.2l0-45.5C256 127 225 96 186.7 96c-21.7 0-42.8 10.2-55.8 28.8c-15.4 22.1-44.3 65.4-71 116.9C33.4 292.6 7.5 354.2 .2 412zM384 165.3l0 45.5c43.1 27.4 86.1 54.8 129.2 82.2c4.8 3 8.5 7.2 11 11.8c1.3 2.3 2.2 4.8 2.8 7.4c.3 1.3 .6 2.6 .7 3.9c.1 .6 .1 1.3 .2 1.9c0 .3 0 .7 .1 2c0 1.5-.1 1.9-.1 2.3c-.1 .7-.1 1.4-.2 2.2c-.2 1.5-.5 2.9-.9 4.4c-.8 2.9-2.1 5.7-3.8 8.4c-6.1 9.6-16.5 14.8-27 14.8c-5.9 0-11.8-1.6-17.1-5L384 286.7 384 398c0 44.1 30 82.5 72.7 93.1l72.7 18.2c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89l0-7c0-1.3-.1-2.7-.2-4c-7.2-57.9-33.1-119.4-59.6-170.3c-26.8-51.5-55.6-94.8-71-116.9c-13-18.6-34-28.8-55.8-28.8C415 96 384 127 384 165.3z", "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 132.1c0 16.4-8.4 31.7-22.2 40.5L126.8 293c-14.9 9.5-19.3 29.3-9.8 44.2s29.3 19.3 44.2 9.8l139-88.4c7.3-4.6 13.9-10.1 19.9-16.1c5.9 6 12.6 11.5 19.9 16.1l139 88.4c14.9 9.5 34.7 5.1 44.2-9.8s5.1-34.7-9.8-44.2l-139-88.4c-13.8-8.8-22.2-24.1-22.2-40.5L352 32z"]
  ]
}, nM = {
  prefix: "fad",
  iconName: "ribbon",
  icon: [
    448,
    512,
    [127895],
    "f4d6",
    ["M18.7 440c0 11 5.6 21.8 16.1 27.8l55.1 31.5c5 2.8 10.4 4.2 15.9 4.2c8.7 0 17.3-3.6 23.6-10.3l97.7-106.3c-27.8-31.9-55.6-63.7-83.3-95.6L27.1 418.5c-5.7 6.2-8.4 13.9-8.4 21.6zM96 64c16.7 18.2 33.4 36.4 50 54.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L352 64 328 32C312.9 11.9 289.2 0 264 0L184 0c-25.2 0-48.9 11.9-64 32L96 64z", "M96 64L420.9 418.5c13.9 15.1 10.1 39.2-7.7 49.4L358.8 499c-13.2 7.6-30 4.7-40-6.8L87.6 227.1C72.4 209.6 64 187.2 64 164l0-23c0-19 5.6-37.5 16.1-53.3L96 64zM328.4 270.2L245.7 180 352 64l19.4 33.9c8.3 14.5 12.6 30.9 12.6 47.6l0 25.8c0 23.6-8.7 46.4-24.5 64l-31.2 34.8z"]
  ]
}, rM = {
  prefix: "fad",
  iconName: "child",
  icon: [
    320,
    512,
    [],
    "f1ae",
    ["M96 64a64 64 0 1 0 128 0A64 64 0 1 0 96 64z", "M144 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192.2L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8 240 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0z"]
  ]
}, aM = {
  prefix: "fad",
  iconName: "shield-virus",
  icon: [
    512,
    512,
    [],
    "e06c",
    ["M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM112 256c0-8.8 7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c11.7 11.7 27.5 13.4 40.3 8c6.4-2.7 12.2-7.1 16.3-12.9c2-2.9 3.7-6.2 4.8-9.7c.6-1.8 1-3.6 1.3-5.6c.1-1 .3-1.9 .3-2.9c.1-.9 .1-1.7 .1-2.6l0-.4c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.6c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c4.4 0 8.4 1.8 11.3 4.7c1.4 1.5 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.3l0 .4 0 .4c0 .3 0 .8-.1 1.3c-.1 .5-.1 1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384.3c0 .3 0 .9-.1 1.4c-.1 .5-.1 1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16l0-.4c0-.9 0-1.8-.1-2.7c-.1-1-.2-2-.3-2.9c-.3-1.9-.7-3.8-1.3-5.6c-1.1-3.6-2.8-6.8-4.8-9.7c-4.1-5.8-9.8-10.2-16.3-12.9c-12.9-5.3-28.7-3.6-40.3 8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16z", "M272 128c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 200.1 161 240 128 240c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 334.5 240 351 240 384c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C334.5 311.9 351 272 384 272c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 177.5 272 161 272 128zM208 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
  ]
}, iM = {
  prefix: "fad",
  iconName: "laptop-mobile",
  icon: [
    640,
    512,
    ["phone-laptop"],
    "f87a",
    ["M0 307.2C0 349.6 34.4 384 76.8 384L352 384l0-96-224 0 0-224 320 0 0 32 64 0 0-32c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 224-44.8 0C8.6 288 0 296.6 0 307.2zM448 192l0 256 128 0 0-256-128 0z", "M448 192l128 0 0 256-128 0 0-256zm-16-64c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-160 0z"]
  ]
}, sM = {
  prefix: "fad",
  iconName: "books-medical",
  icon: [
    576,
    512,
    [],
    "f7e8",
    ["M64 32C64 14.3 78.3 0 96 0l64 0c17.7 0 32 14.3 32 32l0 64c-42.7 0-85.3 0-128 0l0-64zm0 384l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM224 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c-42.7 0-85.3 0-128 0l0-64zm0 96c42.7 0 85.3 0 128 0l0 256-128 0 0-256zm0 288l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM353.4 117.9c40.9-11 81.8-21.9 122.8-32.9c2.7 10.3 5.5 20.6 8.2 30.9c-40.9 11-81.8 21.9-122.8 32.9c-2.7-10.3-5.5-20.6-8.2-30.9zm74.2 278.3c40.9-11 81.8-21.9 122.8-32.9l8.2 30.9L435.8 427c-2.7-10.3-5.5-20.6-8.2-30.9z", "M353.4 117.9l-1.4-5.2 0 15.4-128 0 0-32 128 0 0-75.3c2.3-1.3 4.8-2.4 7.5-3.1L420.9 1.1c16.9-4.6 34.4 5.5 38.9 22.6L476.2 85 353.4 117.9zm8.2 30.9l122.8-32.9 66 247.4L427.6 396.1l-66-247.4zM435.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L435.8 427zM192 96l0 32L64 128l0-32 128 0zM64 416l0-32 128 0 0 32L64 416zm160-32l128 0 0 32-128 0 0-32zM64 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
  ]
}, oM = {
  prefix: "fad",
  iconName: "phone",
  icon: [
    512,
    512,
    [128222, 128379],
    "f095",
    ["M68.4 14.8c.3 2.3 .6 4.5 .9 6.7c.3 2.2 .6 4.5 1 6.7c.7 4.5 1.4 8.9 2.2 13.3c1.6 8.8 3.4 17.6 5.4 26.2c4.1 17.3 9 34.3 14.9 50.8c11.7 33.1 26.8 64.6 44.9 94c8.3-6.8 16.7-13.6 25-20.5C129.2 136.7 107.2 73.7 99.7 6.3L68.4 14.8zm231 359.6c58.9 36.2 125.9 60.4 197.8 69.1l8.5-31.2c-67.4-7.5-130.4-29.5-185.8-62.9l-20.5 25z", "M68.4 14.8l-39 10.6C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l10.6-39C273.2 416.4 95.6 238.8 68.4 14.8zM505.7 412.3l4.9-17.8c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6l-25.1 30.7c55.4 33.4 118.4 55.4 185.8 62.9zM162.6 192.1L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2L99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8z"]
  ]
}, cM = {
  prefix: "fad",
  iconName: "ban-smoking",
  icon: [
    512,
    512,
    [128685, "smoking-ban"],
    "f54d",
    ["M96 240l0 64c0 8.8 7.2 16 16 16l162.7 0c-32-32-64-64-96-96L112 224c-8.8 0-16 7.2-16 16zM256 112c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16zm13.3 112l32 32 82.7 0 0 32-50.7 0 32 32 34.7 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-130.7 0z", "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  ]
}, lM = cM, dM = {
  prefix: "fad",
  iconName: "head-side-medical",
  icon: [
    512,
    512,
    [],
    "f809",
    ["M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM128 176l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z", "M208 96c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0z"]
  ]
}, uM = {
  prefix: "fad",
  iconName: "circle-question",
  icon: [
    512,
    512,
    [62108, "question-circle"],
    "f059",
    ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm169.4-89.5c.1-.4 .3-.8 .4-1.2c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8c-10.8 6.2-21.5 12.4-32.3 18.5c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24c0-4.5 0-9 0-13.5c0-8.7 4.6-16.6 12.1-20.8c14.8-8.5 29.6-17 44.3-25.4c2.4-1.4 4.3-3.3 5.6-5.5c.7-1.1 1.2-2.4 1.5-3.6c.2-.6 .3-1.3 .4-2c0-.3 .1-.7 .1-1s0-.7 0-1.1c0-.5 0-1-.1-1.5s-.1-1-.2-1.5c-.2-1-.5-1.9-.9-2.8c-.8-1.8-1.9-3.4-3.2-4.8c-2.7-2.7-6.5-4.4-10.7-4.4l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3c-.1 .4-.3 .8-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6zM288 352c0 .3 0 .6 0 0z", "M222.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  ]
}, fM = {
  prefix: "fad",
  iconName: "badge-check",
  icon: [
    512,
    512,
    [],
    "f336",
    ["M0 256c0 36.8 20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm136 0c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.5 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]
  ]
}, pM = {
  prefix: "fad",
  iconName: "recycle",
  icon: [
    512,
    512,
    [9842, 9850, 9851],
    "f1b8",
    ["M0 351.6c0 .2 0 .4 0 .6C0 405.1 42.9 448 95.8 448l32.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32.2 0c-17.6 0-31.9-14.4-31.8-32c0-5.9 1.7-11.7 4.8-16.7l51.5-82.4c-18.5-10.7-37-21.3-55.5-32L14.6 301.4C5.1 316.5 .1 333.9 0 351.6zM157.2 73.1c-9.5 15.2-4.7 35.2 10.7 44.4c15 9 34.4 4.3 43.6-10.5L229 79c5.8-9.3 16-15 27-15s21.2 5.7 27 15l37.4 59.8 55.5-32L337.3 45.1C319.8 17 289.1 0 256 0S192.2 17 174.7 45.1l-17.5 28zM320 384l0 64 96.2 0c53.1 0 96.1-43.2 95.8-96.4c-.1-17.8-5.1-35.1-14.6-50.2l-24.4-39.1c-9.2-14.8-28.6-19.5-43.6-10.5c-15.3 9.2-20.2 29.2-10.7 44.4l24.4 39.1c3.1 5 4.8 10.8 4.8 16.7c.1 17.6-14.2 32-31.8 32L320 384z", "M292 155.2c-8.4 4.9-13.1 14.3-11.8 23.9s8.2 17.5 17.6 20l87.4 23.4c12.8 3.4 26-4.2 29.4-17L438 118.2c2.5-9.4-.9-19.3-8.6-25.3s-18.2-6.6-26.6-1.7L292 155.2zM320 352c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-128zM173.5 266.5c7.7-5.9 11.1-15.9 8.6-25.3l-23.4-87.4c-3.4-12.8-16.6-20.4-29.4-17L41.8 160.2c-9.4 2.5-16.3 10.4-17.6 20s3.4 19.1 11.8 23.9l110.9 64c8.4 4.9 18.9 4.2 26.6-1.7z"]
  ]
}, mM = {
  prefix: "fad",
  iconName: "hands-holding-dollar",
  icon: [
    640,
    512,
    ["hands-usd"],
    "f4c5",
    ["M0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c-5.1-5.1-10.2-10.2-15.2-15.2l-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40c0-22.1-17.9-40-40-40S0 81.9 0 104zM352 385.1l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c-8.5 8.5-16.9 16.9-25.4 25.4c-21 21-32.8 49.5-32.8 79.2z", "M320 0c13.3 0 24 10.7 24 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L296 24c0-13.3 10.7-24 24-24z"]
  ]
}, hM = mM, gM = {
  prefix: "fad",
  iconName: "apple-whole",
  icon: [
    448,
    512,
    [127822, 127823, "apple-alt"],
    "f5d1",
    ["M208 80l0 16c0 8.8 7.2 16 16 16l16 0c44.2 0 80-35.8 80-80l0-16c0-8.8-7.2-16-16-16L288 0c-44.2 0-80 35.8-80 80z", "M112 128C35.7 128 0 211.7 0 288C0 416 80 512 160 512c16.5 0 38.1-6.6 51.5-11.3c8.1-2.8 16.9-2.8 25 0c13.4 4.7 35 11.3 51.5 11.3c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128z"]
  ]
}, vM = {
  prefix: "fad",
  iconName: "hands-holding-heart",
  icon: [
    640,
    512,
    ["hands-heart"],
    "f4c3",
    ["M0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c-5.1-5.1-10.2-10.2-15.2-15.2l-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40c0-22.1-17.9-40-40-40S0 81.9 0 104zM352 385.1l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c-8.5 8.5-16.9 16.9-25.4 25.4c-21 21-32.8 49.5-32.8 79.2z", "M195.9 28.9c-29.4 29.8-29.4 78.2 0 108L297.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L444.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L320 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0z"]
  ]
}, bM = {
  prefix: "fad",
  iconName: "hand-holding-heart",
  icon: [
    576,
    512,
    [],
    "f4be",
    ["M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z", "M163.9 28.9c-29.4 29.8-29.4 78.2 0 108L265.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L412.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L288 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0z"]
  ]
}, yM = {
  prefix: "fad",
  iconName: "language",
  icon: [
    640,
    512,
    [],
    "f1ab",
    ["M0 128C0 92.7 28.7 64 64 64l256 0 0 384L64 448c-35.3 0-64-28.7-64-64L0 128zM76 328c0 7.7 4.4 15 11.9 18.3c10.1 4.5 21.9-.1 26.4-10.2c3-6.7 6-13.4 8.9-20.1l73.6 0c3 6.7 6 13.4 8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2c10.1-4.5 14.6-16.2 10.2-26.4c-21.3-48-42.7-96-64-144c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-1.2 2.6-1.7 5.4-1.7 8.1zm65-52l19-42.8L179 276l-38 0z", "M640 128c0-35.3-28.7-64-64-64L320 64l0 384 256 0c35.3 0 64-28.7 64-64l0-256zM500 184l0 4 44 0 16 0c11 0 20 9 20 20s-9 20-20 20l-2 0-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45L480 228l-72 0c-11 0-20-9-20-20s9-20 20-20l52 0 0-4c0-11 9-20 20-20s20 9 20 20zM160 164c-7.9 0-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1 73.6 0 8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144c-3.2-7.2-10.4-11.9-18.3-11.9zm0 69.2L179 276l-38 0 19-42.8z"]
  ]
}, xM = {
  prefix: "fad",
  iconName: "newspaper",
  icon: [
    512,
    512,
    [128240],
    "f1ea",
    ["M48 480c26.5 0 48-21.5 48-48L96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L96 480l-48 0zM160 120l0 80c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L184 96c-13.3 0-24 10.7-24 24zm0 184c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0c-8.8 0-16 7.2-16 16zM368 112c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z", "M0 160L0 432c0 26.5 21.5 48 48 48s48-21.5 48-48L96 96 64 96C28.7 96 0 124.7 0 160zM384 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0zM176 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0z"]
  ]
}, _M = {
  prefix: "fad",
  iconName: "stomach",
  icon: [
    512,
    512,
    [],
    "f623",
    ["M214.8 414l1.7 1.4c11.4 9.5 21.6 17.1 34.4 22.8c12.6 5.5 29.1 9.8 53.1 9.8c69.7 0 127.9-49.5 141.1-115.3c-7.3 1.9-14.6 3.3-21.1 3.3c-16.8 .2-28.4-7.9-40-16s-23.2-16.3-40-16c-7.9 .1-17.1 2.1-25.6 4.6c-8.6 53.5-50.4 95.8-103.6 105.4z", "M160 0c17.7 0 32 14.3 32 32l0 64c0 35.3 28.7 64 64 64l17.1 0c22.1-38.3 63.5-64 110.9-64c70.7 0 128 57.3 128 128l0 80c0 114.9-93.1 208-208 208c-32 0-57.5-5.8-78.9-15.2c-21.2-9.3-36.9-21.7-49.6-32.2c-1.8-1.5-3.6-3-5.3-4.4c0 0 0 0 0 0C148 441.5 136.6 432 112 432c-26.5 0-48 21.5-48 48c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7 57.3-128 128-128l64 0c35.3 0 64-28.7 64-64l0-64c-70.7 0-128-57.3-128-128l0-64c0-17.7 14.3-32 32-32zm54.8 414c.6 .5 1.1 1 1.7 1.4c11.4 9.5 21.6 17.1 34.4 22.8c12.6 5.5 29.1 9.8 53.1 9.8c79.5 0 144-64.5 144-144l0-80c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64c0 62.9-45.4 115.2-105.2 126z"]
  ]
}, wM = {
  prefix: "fad",
  iconName: "memo",
  icon: [
    384,
    512,
    [],
    "e1d8",
    ["M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm64 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 320c-8.8 0-16 7.2-16 16z", "M80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 320z"]
  ]
}, CM = {
  prefix: "fad",
  iconName: "heart-circle-check",
  icon: [
    576,
    512,
    [],
    "e4fd",
    ["M0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6l0-5.8c0-69.9-50.5-129.5-119.4-141c-7.8-1.3-15.7-1.9-23.5-1.9C331.5 42.2 295 57 268 84L256 96 244 84c-27-27-63.5-41.9-101.1-41.9c-7.8 0-15.7 .6-23.5 1.9C50.5 55.6 0 115.2 0 185.1z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
  ]
}, SM = {
  prefix: "fad",
  iconName: "seedling",
  icon: [
    512,
    512,
    [127793, "sprout"],
    "f4d8",
    ["M237.7 146.6c25.1 30.7 42.1 68.3 48 109.4l2.3 0c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32L448 0C351.5 0 269.2 61 237.7 146.6z", "M32 64C14.3 64 0 78.3 0 96C0 219.7 100.3 320 224 320l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-32C288 164.3 187.7 64 64 64L32 64z"]
  ]
}, LM = {
  prefix: "fad",
  iconName: "address-card",
  icon: [
    576,
    512,
    [62140, "contact-card", "vcard"],
    "f2bb",
    ["M0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM64 368c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16zM240 192a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm112-16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z", "M176 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0z"]
  ]
}, MM = {
  prefix: "fad",
  iconName: "viruses",
  icon: [
    640,
    512,
    [],
    "e076",
    ["M0 192c0 13.3 10.7 24 24 24l13.5 0c35.6 0 53.5 43.1 28.3 68.3l-9.5 9.5c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l9.5-9.5c25.2-25.2 68.3-7.4 68.3 28.3l0 13.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-13.5c0-35.6 43.1-53.5 68.3-28.3l9.5 9.5c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-9.5-9.5C293 259.1 310.9 216 346.5 216l13.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-13.5 0c-35.6 0-53.5-43.1-28.3-68.3l9.5-9.5c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-9.5 9.5C259.1 91 216 73.1 216 37.5L216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 13.5c0 35.6-43.1 53.5-68.3 28.3l-9.5-9.5c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l9.5 9.5C91 124.9 73.1 168 37.5 168L24 168c-13.3 0-24 10.7-24 24zm192-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM448 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z", "M160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352 48c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C417.5 312.1 401 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C440.1 446.5 480 463 480 496c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C574.5 423.9 591 384 624 384c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C551.9 289.5 512 273 512 240zM448 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  ]
}, NM = {
  prefix: "fad",
  iconName: "circle-check",
  icon: [
    512,
    512,
    [61533, "check-circle"],
    "f058",
    ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm136 0c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.5 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]
  ]
}, zM = {
  prefix: "fad",
  iconName: "gift",
  icon: [
    512,
    512,
    [127873],
    "f06b",
    ["M0 160c0-17.7 14.3-32 32-32l41.6 0c7.3 14.2 18.3 26.2 31.8 34.7c6.8 4.2 14.1 7.5 21.9 9.8c3.9 1.1 7.9 2 12 2.6c2.1 .3 4.1 .5 6.2 .7c1 .1 2.1 .1 3.2 .2s2.1 .1 3.2 .1l64 0 8 0 0 80L32 256c-17.7 0-32-14.3-32-32l0-64zM32 288l192 0 0 224L80 512c-26.5 0-48-21.5-48-48l0-176zM288 176l72 0c34.2 0 63.8-19.5 78.4-48l41.6 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-192 0 0-80zm0 112l192 0 0 176c0 26.5-21.5 48-48 48l-144 0 0-224z", "M190.5 68.8L225.3 128l-1.3 0-8 0-64 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88s39.4 88 88 88l64 0 8 0 0 80 64 0 0-80 72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5zm65.5-16.7C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-73.3 0 34.8-59.2zM288 512l0-224-64 0 0 224 64 0z"]
  ]
}, H6 = {
  prefix: "fad",
  iconName: "messages",
  icon: [
    640,
    512,
    ["comments-alt"],
    "f4b6",
    ["M256 352l96 0c53 0 96-43 96-96l0-128 128 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-32 0 0 48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448 320 448c-35.3 0-64-28.7-64-64l0-32z", "M0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-149.3 0-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-48-32 0c-35.3 0-64-28.7-64-64L0 64z"]
  ]
}, EM = H6, TM = {
  prefix: "fad",
  iconName: "wifi",
  icon: [
    640,
    512,
    ["wifi-3", "wifi-strong"],
    "f1eb",
    ["", "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
  ]
}, q6 = {
  prefix: "fad",
  iconName: "weight-scale",
  icon: [
    512,
    512,
    ["weight"],
    "f496",
    ["M432 176A176 176 0 1 1 80 176a176 176 0 1 1 352 0zM216 224c0 22.1 17.9 40 40 40s40-17.9 40-40c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40z", "M256 352c97.2 0 176-78.8 176-176c0-42.5-15.1-81.6-40.2-112L448 64c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l56.2 0C95.1 94.4 80 133.5 80 176c0 97.2 78.8 176 176 176zm40-128c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-22 17.8-39.9 39.7-40l33.6-78.3c3.5-8.1 12.9-11.9 21-8.4s11.9 12.9 8.4 21l-33.6 78.3c6.7 7.2 10.9 16.8 10.9 27.4z"]
  ]
}, kM = q6, jM = {
  prefix: "fad",
  iconName: "weight-hanging",
  icon: [
    512,
    512,
    [],
    "f5cd",
    ["M160 96c0 11.2 1.9 22 5.5 32l81 0c-12.7-4.4-22-17-22.4-31c0-.3 0-.7 0-1c0-17.7 14.3-32 32-32s32 14.3 32 32c0 .3 0 .6 0 .8c-.4 14-9.7 26.8-22.4 31.2l81 0c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96z", "M120 128c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512l416 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128l-272 0z"]
  ]
}, PM = {
  prefix: "fad",
  iconName: "heart-pulse",
  icon: [
    512,
    512,
    ["heartbeat"],
    "f21e",
    ["M0 185.1l0 5.8c0 17.3 3 34.3 8.7 50.2c2.3-.7 4.8-1.1 7.3-1.1l106.7 0c3.2 0 6.1-1.9 7.4-4.9l31.8-76.3c3.7-8.8 12.3-14.6 21.8-14.8s18.3 5.4 22.2 14.1l51.3 113.9 41.4-82.8c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3l23.2 46.3c1.4 2.7 4.1 4.4 7.2 4.4l132 0c5.4-15.6 8.3-32.2 8.3-49.1l0-5.8c0-69.9-50.5-129.5-119.4-141c-7.8-1.3-15.7-1.9-23.5-1.9C331.5 42.2 295 57 268 84L256 96 244 84c-27-27-63.5-41.9-101.1-41.9c-7.8 0-15.7 .6-23.5 1.9C50.5 55.6 0 115.2 0 185.1zM35.7 288c3.7 4.3 7.7 8.5 11.9 12.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c4.2-3.9 8.2-8.1 11.9-12.4l-104.5 0c-21.2 0-40.6-12-50.1-31l-1.7-3.4-42.5 85.1c-4.1 8.3-12.7 13.5-22 13.3s-17.6-5.7-21.4-14.1L184.8 228.4l-10.5 25.2c-8.7 20.9-29.1 34.5-51.7 34.5l-87 0z", "M35.7 288l87 0c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31l104.5 0c12.1-14.2 21.4-30.5 27.4-48l-132 0c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9L16 240c-2.6 0-5 .4-7.3 1.1c6.1 17 15.2 32.9 27 46.9z"]
  ]
}, AM = {
  prefix: "fad",
  iconName: "venus",
  icon: [
    384,
    512,
    [9792],
    "f221",
    ["M112 176a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z", "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9z"]
  ]
}, $M = {
  prefix: "fad",
  iconName: "family",
  icon: [
    512,
    512,
    [],
    "e300",
    ["M21.8 282.7c-.2 1.8-.2 3.6-.2 5.4c0 27.5 17.6 51.3 42.4 60.2L64 464c0 26.5 21.5 48 48 48l32 0c13.5 0 25.7-5.6 34.4-14.5c-1.6-5.5-2.4-11.4-2.4-17.5l0-56.4c-19.6-17.6-32-43.1-32-71.6l0-16c0-43.1 24.3-80.5 60-99.2c-17.1-14.7-28-36.5-28-60.8c0-3.9 .3-7.8 .8-11.5c-8.3-2.9-17.2-4.5-26.4-4.5l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zM308 236.8c35.7 18.7 60 56.1 60 99.2l0 16c0 28.4-12.4 54-32 71.6l0 56.4c0 6.1-.8 11.9-2.4 17.5c8.7 9 20.9 14.5 34.4 14.5l32 0c26.5 0 48-21.5 48-48l0-80 21.6 0c18.2 0 32-14.9 32-31.9c0-2.9-.4-5.9-1.3-8.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0c-11.8 0-23 3.2-32.6 8.9c.2 2.3 .3 4.7 .3 7.1c0 24.3-10.9 46.1-28 60.8zM320 64a64 64 0 1 0 128 0A64 64 0 1 0 320 64z", "M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM176 336c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16c0 23.7-12.9 44.4-32 55.4l0 72.6c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-72.6c-19.1-11.1-32-31.7-32-55.4l0-16z"]
  ]
}, IM = {
  prefix: "fad",
  iconName: "files-medical",
  icon: [
    448,
    512,
    [],
    "f7fd",
    ["M96 64l0 288c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-256-64 0c-17.7 0-32-14.3-32-32l0-64L160 0C124.7 0 96 28.7 96 64zm80 176c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32z", "M352 64l0-64 96 96-64 0c-17.7 0-32-14.3-32-32zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-192 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24zm216 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
  ]
}, OM = {
  prefix: "fad",
  iconName: "calendar-star",
  icon: [
    448,
    512,
    [],
    "f736",
    ["M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM132.6 324.1l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L224 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7z", "M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM233.3 250.9c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L224 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z"]
  ]
}, RM = {
  prefix: "fad",
  iconName: "x-ray",
  icon: [
    512,
    512,
    [],
    "f497",
    ["M32 96l0 320 448 0 0-320L32 96zm80 144c0-8.8 7.2-16 16-16l112 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 32 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0 0 48c0 .4 0 .8 0 1.2l50.4-21.6c5.5-2.4 11.4-3.6 17.4-3.6l7.4 0c20.4 0 36.9 16.5 36.9 36.9c0 8.2-2.8 16.3-7.9 22.8l-19.4 24.8C347 376.8 332.1 384 316.4 384l-120.8 0c-15.7 0-30.6-7.2-40.3-19.6l-19.4-24.8c-5.1-6.5-7.9-14.5-7.9-22.8c0-20.4 16.5-36.9 36.9-36.9l7.4 0c6 0 11.9 1.2 17.4 3.6L240 305.2c0-.4 0-.8 0-1.2l0-48-112 0c-8.8 0-16-7.2-16-16zm80 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z"]
  ]
}, DM = {
  prefix: "fad",
  iconName: "file-invoice-dollar",
  icon: [
    384,
    512,
    [],
    "f571",
    ["M0 64C0 28.7 28.7 0 64 0L224 0c0 42.7 0 85.3 0 128c0 .6 0 1.1 0 1.6c0 .5 .1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.2 1 .5 2.1 .8 3.1c.2 .5 .3 1 .5 1.5s.4 1 .6 1.5c1.6 3.8 4 7.3 6.9 10.2s6.3 5.2 10.2 6.9c1.9 .8 3.9 1.4 6 1.9c1 .2 2.1 .4 3.2 .5c.5 .1 1.1 .1 1.6 .1s1.1 0 1.6 0l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm64.2 150.9c-.1 1.2-.1 2.3-.1 3.6c0 1.2 .1 2.3 .1 3.4s.2 2.2 .4 3.2c.3 2.1 .8 4.1 1.4 6c1.2 3.8 2.9 7.2 5 10.3c4.2 6.1 9.8 10.9 15.8 14.5c10.5 6.3 23.8 10.4 34.8 13.7c.5 .2 1.1 .3 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1c-.3 .8-.5 1.7-.6 2.5c-.1 .4-.1 .8-.2 1.3c0 .2 0 .4-.1 1.3l.1 1.3c0 0 0 .6 .1 1.2c.1 .8 .3 1.6 .6 2.4c.5 1.6 1.2 3 2.2 4.4c1.9 2.7 4.6 4.8 8 5.9c2 .7 4.1 1.4 6.2 2.1c9.2 3.2 19.7 6.8 30.9 8.9c0 5.9 0 11.9 0 17.8c0 .6 0 1.1 .1 1.6s.1 1.1 .2 1.6c.2 1 .5 2 .9 3c.8 1.9 2 3.6 3.4 5.1c2.9 2.9 6.9 4.7 11.3 4.7c8.8 0 16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c6.6-4.1 12.4-9.7 16.5-16.6c2-3.5 3.7-7.3 4.8-11.4c.5-2.1 1-4.2 1.2-6.5c.1-1.1 .2-2.3 .3-3.4c.1-1.1 .1-2.3 .1-3.5c-.2-18.6-10.6-30.7-22.7-38.3c-11-6.9-25-11.2-36.3-14.6l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-3-1.8-4.8-3.4-5.9-5c-.5-.8-.9-1.6-1.1-2.4c-.1-.4-.2-.8-.2-1.3c0-.4-.1-.8-.1-1.2c0-.8 0-1.4 .1-2.1s.2-1.3 .4-1.8c.3-1.2 .8-2.3 1.5-3.3c1.3-2.1 3.4-3.9 6.2-5.6c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1c0-5.8 0-11.5 0-17.3c0-8.8-7.2-16-16-16c-4.4 0-8.4 1.8-11.3 4.7c-1.4 1.4-2.6 3.2-3.4 5.1c-.4 1-.7 2-.9 3c-.1 .5-.2 1.1-.2 1.6s-.1 1.1-.1 1.5c0 5.9 0 11.7 0 17.5c-8.3 1.5-16.7 4.3-24.1 8.7c-6.5 3.9-12.5 9.1-16.8 15.9c-2.2 3.4-3.9 7.1-5.1 11.2c-.6 2.1-1.1 4.2-1.4 6.4c-.2 1.1-.3 2.3-.4 3.4z", "M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM208 232c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7c0 0 0 0 0 0l1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1c0 0 0 0 0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6c0 0 0 0 0 0s0 0 0 0l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1l0-17.3z"]
  ]
}, FM = {
  prefix: "fad",
  iconName: "scalpel-line-dashed",
  icon: [
    576,
    512,
    ["scalpel-path"],
    "f61e",
    ["M1.2 502.1c2.5 6 8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336l0-16-16 0-96 0-6.6 0-4.7 4.7-160 160c-4.6 4.6-5.9 11.5-3.5 17.4z", "M387.5 24.6C400.9 9 420.5 0 441.2 0C480.3 0 512 31.7 512 70.8l0 3.4c0 17.9-6.5 35.2-18.2 48.7L337.2 303.5C328 314 314.8 320 300.9 320L168 320c-6.3 0-11.9-3.6-14.5-9.3s-1.7-12.4 2.4-17.1L387.5 24.6zM240 480l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  ]
}, BM = {
  prefix: "fad",
  iconName: "venus-mars",
  icon: [
    640,
    512,
    [9892],
    "f228",
    ["M256 176A80 80 0 1 1 96 176a80 80 0 1 1 160 0zm15.9 184.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0L616 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z", "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zm32 0c0-4.8-.2-9.6-.5-14.3c5.3-1.1 10.8-1.7 16.5-1.7c44.2 0 80 35.8 80 80s-35.8 80-80 80c-21.5 0-41-8.5-55.3-22.2C369.4 263.5 384 221.5 384 176z"]
  ]
}, VM = {
  prefix: "fad",
  iconName: "globe",
  icon: [
    512,
    512,
    [127760],
    "f0ac",
    ["M0 256c0-22.1 2.8-43.5 8.1-64c41 0 82.1 0 123.1 0c-1 10.3-1.8 20.8-2.4 31.6c-.1 2.6-.2 5.3-.4 8.1c-.1 2.5-.2 5-.2 7.5l0 .6c-.1 2.6-.1 5.1-.1 7.5l0 .4c0 2.6 0 5.2-.1 7.7l0 .4c0 8.2 .2 16.4 .5 24.5c.1 2.6 .2 5.3 .3 7.9c.5 10.7 1.3 21.3 2.4 31.6L8.1 320C2.8 299.5 0 278.1 0 256zm18.6-96C48.5 86.3 111.6 29.6 189.5 8.7c-25 34.6-44.3 88-54.2 151.3c-38.9 0-77.8 0-116.6 0zm0 192l116.6 0c9.9 63.3 29.2 116.7 54.2 151.3C111.6 482.4 48.5 425.7 18.6 352zM160.5 231.4c.1-2.7 .2-5.4 .4-8.1c.6-10.7 1.4-21.1 2.5-31.4c61.8 0 123.6 0 185.3 0c2.2 20.4 3.3 41.9 3.3 64c0 22.1-1.2 43.5-3.3 64c-61.8 0-123.6 0-185.3 0c-1.1-10.2-1.9-20.7-2.5-31.4c-.3-5.4-.5-10.9-.6-16.4c-.1-2.7-.1-5.3-.2-8c0-2.6-.1-5.2-.1-7.8l0-.4c0-.1 0-.3 0-.4c0-2.8 0-5.5 .1-8.2c0-2.5 .1-5.1 .2-7.6l0-.6c.1-2.5 .2-5.1 .3-7.7zm7.2-71.4c6.1-36.7 15.5-69.2 27.1-95.5c10.5-23.8 22.2-41.2 33.6-52.1c6.8-6.5 12.8-10.2 18.1-12.2c3.2-.1 6.3-.2 9.5-.2s6.3 .1 9.5 .2c5.3 1.9 11.4 5.7 18.1 12.2c11.4 10.9 23.1 28.3 33.6 52.1c11.6 26.3 21 58.8 27.1 95.5c-58.9 0-117.8 0-176.7 0zm0 192l176.7 0c-6.1 36.7-15.5 69.2-27.1 95.5c-10.5 23.8-22.2 41.2-33.6 52.1c-6.8 6.5-12.8 10.2-18.1 12.2c-3.2 .1-6.3 .2-9.5 .2s-6.3-.1-9.5-.2c-5.3-1.9-11.4-5.7-18.1-12.2c-11.4-10.9-23.1-28.3-33.6-52.1c-11.6-26.3-21-58.8-27.1-95.5zM322.5 8.7c77.8 20.9 141 77.5 170.9 151.3c-38.9 0-77.8 0-116.6 0C366.9 96.7 347.5 43.3 322.5 8.7zm0 494.6c25-34.6 44.3-88 54.2-151.3l116.6 0c-29.8 73.7-93 130.4-170.9 151.3zM380.8 192c41 0 82.1 0 123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64c0-22-1.1-43.4-3.2-64z", "M344.3 352c-6.1 36.7-15.5 69.2-27.1 95.5c-10.5 23.8-22.2 41.2-33.6 52.1c-6.8 6.5-12.8 10.2-18.1 12.2c19.7-.7 38.7-3.6 57-8.6c25-34.6 44.3-88 54.2-151.3l116.6 0c4.2-10.3 7.7-21 10.5-32l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64l123.1 0c-2.8-11-6.4-21.7-10.5-32l-116.6 0C366.9 96.7 347.5 43.3 322.5 8.7c-18.3-4.9-37.4-7.8-57-8.6c5.3 1.9 11.4 5.7 18.1 12.2c11.4 10.9 23.1 28.3 33.6 52.1c11.6 26.3 21 58.8 27.1 95.5l-176.7 0c6.1-36.7 15.5-69.2 27.1-95.5c10.5-23.8 22.2-41.2 33.6-52.1c6.8-6.5 12.8-10.2 18.1-12.2c-19.7 .7-38.7 3.6-57 8.6c-25 34.6-44.4 88-54.2 151.3L18.6 160c-4.2 10.3-7.7 21-10.5 32l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320c2.8 11 6.4 21.7 10.5 32l116.6 0c9.9 63.3 29.2 116.7 54.2 151.3c18.3 4.9 37.4 7.8 57 8.6c-5.3-1.9-11.4-5.7-18.1-12.2c-11.4-10.9-23.1-28.3-33.6-52.1c-11.6-26.3-21-58.8-27.1-95.5l176.7 0zm7.7-96c0 22.1-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.9-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.9 3.3 64z"]
  ]
}, HM = {
  prefix: "fad",
  iconName: "bullhorn",
  icon: [
    512,
    512,
    [128226, 128363],
    "f0a1",
    ["M192 128l0 32 0 32 0 96 0 32 0 32 8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-147.6 0-120.7L480 32c0-12.9-7.8-24.6-19.8-29.6C456.3 .8 452.1 0 448 0c-8.3 0-16.5 3.3-22.6 9.4L381.7 53c-48 48-113.1 75-181 75c-2.9 0-5.8 0-8.7 0z", "M0 192c0-35.3 28.7-64 64-64l128 0 0 192 0 32 0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128c-35.3 0-64-28.7-64-64l0-96zm512 48c0 27.9-13.4 51.6-32 60.4l0-120.7c18.6 8.8 32 32.5 32 60.4z"]
  ]
}, qM = {
  prefix: "fad",
  iconName: "dumpster",
  icon: [
    576,
    512,
    [],
    "f793",
    ["M0 139.1c0-2.1 .3-4.1 .9-6.1L26.8 48.9C29.9 38.9 39.2 32 49.7 32l90.8 0L114.9 160l-94 0C9.3 160 0 150.7 0 139.1zM147.5 160L173.1 32 272 32l0 128-124.5 0zM304 32l98.9 0 25.6 128L304 160l0-128zm131.5 0l90.8 0c10.5 0 19.8 6.9 22.9 16.9L575.1 133c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9l-94 0L435.5 32z", "M64 448L44 288l-12 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l4 0-4-32 512 0-4 32 4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-12 0L512 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l-320 0c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
  ]
}, WM = {
  prefix: "fad",
  iconName: "user",
  icon: [
    448,
    512,
    [62144, 128100],
    "f007",
    ["M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z", "M0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"]
  ]
}, UM = {
  prefix: "fad",
  iconName: "shield-check",
  icon: [
    512,
    512,
    [],
    "f2f7",
    ["M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM136 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]
  ]
}, GM = {
  prefix: "fad",
  iconName: "staff-snake",
  icon: [
    384,
    512,
    ["rod-asclepius", "rod-snake", "staff-aesculapius"],
    "e579",
    ["M0 104c0 30.9 25.1 56 56 56l16 0c22.3 0 41.6-13.1 50.6-32l41.4 0 56 0 68 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-69 0-2.5 80 71.5 0c53 0 96-43 96-96s-43-96-96-96l-65.5 0-61 0L72 48l-8 0-8 0C25.1 48 0 73.1 0 104zm80-8A16 16 0 1 1 48 96a16 16 0 1 1 32 0zM56 256c0 53 43 96 96 96l19 0 42 0 43 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-44 0-2.1 67.5-.4 12.5 46.5 0c53 0 96-43 96-96s-43-96-96-96l-40.5 0-47 0L152 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l15.5 0L165 160l-13 0c-53 0-96 43-96 96zM96 424c0 22.1 17.9 40 40 40l38.5 0c-.1-4.2-.3-8.3-.4-12.5c-.7-22.5-1.4-45-2.1-67.5l-36 0c-22.1 0-40 17.9-40 40z", "M222.6 43.2L223 32c0-.7 0-1.3 0-1.9c-.5-16.6-14.1-30-31-30s-30.5 13.4-31 30c0 .6 0 1.3 0 1.9l.4 11.2 .1 4.8 61 0 .1-4.8zM215.5 272L220 128l-56 0 4.5 144 47 0zM213 352l-42 0 3.1 99.5 1.4 43.5 0 1c.3 8.9 7.6 16 16.5 16s16.2-7.1 16.5-16l0-1 1.4-43.5L213 352z"]
  ]
}, YM = {
  prefix: "fad",
  iconName: "pills",
  icon: [
    576,
    512,
    [],
    "f484",
    ["M0 144l0 80 0 32 32 0 160 0 32 0 0-32 0-80c0-61.9-50.1-112-112-112S0 82.1 0 144zM256 320c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1c12.3-7.1 13.1-23.7 3.1-33.8L310.9 237.5c-10-10-26.7-9.3-33.8 3.1C263.7 264 256 291.1 256 320zm77.5-105.1L521.1 402.5c10 10 26.7 9.3 33.8-3.1C568.3 376 576 348.9 576 320c0-88.4-71.6-160-160-160c-28.9 0-56 7.7-79.4 21.1c-12.3 7.1-13.1 23.7-3.1 33.8z", "M32 256L0 256l0 32 0 80c0 61.9 50.1 112 112 112s112-50.1 112-112l0-80 0-32-32 0L32 256z"]
  ]
}, KM = {
  prefix: "fad",
  iconName: "file-plus",
  icon: [
    384,
    512,
    [],
    "f319",
    ["M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 336c0 13.3 10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24z", "M384 160l-128 0c-17.7 0-32-14.3-32-32L224 0 384 160zM192 240c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24z"]
  ]
}, XM = {
  prefix: "fad",
  iconName: "hand-heart",
  icon: [
    512,
    512,
    [],
    "f4bc",
    ["M11 284.4c-15.2 16-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4zm197 78.2c0-23.5 19.1-42.6 42.6-42.6l1.1 0c14.6 0 28.3 7.3 36.4 19.5c8.1-12.2 21.7-19.5 36.4-19.5l1.1 0c23.5 0 42.6 19.1 42.6 42.6c0 12.1-5.1 23.6-14.1 31.6l-55.2 49.7c-3 2.7-6.9 4.1-10.7 4.1s-7.7-1.4-10.7-4.1l-55.2-49.7c-9-8.1-14.1-19.6-14.1-31.6z", "M250.6 320c-23.5 0-42.6 19.1-42.6 42.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6c0-23.5-19.1-42.6-42.6-42.6l-1.1 0c-14.6 0-28.3 7.3-36.4 19.5c-8.1-12.2-21.7-19.5-36.4-19.5l-1.1 0z"]
  ]
}, ZM = {
  prefix: "fad",
  iconName: "lightbulb-on",
  icon: [
    640,
    512,
    [],
    "f672",
    ["M144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176zm64 0c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48 160 0 0 48z"]
  ]
}, QM = {
  prefix: "fad",
  iconName: "car-side",
  icon: [
    640,
    512,
    [128663],
    "f5e4",
    ["M64 432a80 80 0 1 0 160 0A80 80 0 1 0 64 432zm47.3-208L224 224c0-32 0-64 0-96l-52.7 0c-13.1 0-24.9 8-29.7 20.1c-10.1 25.3-20.2 50.6-30.4 75.9zM272 128c0 32 0 64 0 96l173.4 0-67.2-84c-6.1-7.6-15.3-12-25-12L272 128zM416 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z", "M171.3 128l52.7 0 0 96-112.7 0 30.4-75.9c4.9-12.1 16.6-20.1 29.7-20.1zM272 224l0-96 81.2 0c9.7 0 18.9 4.4 25 12l67.2 84L272 224zm256.2 1l-100-125c-18.2-22.8-45.8-36-75-36L171.3 64c-39.3 0-74.6 23.9-89.1 60.3L40.6 228.4C16.8 237.8 0 260.9 0 288L0 400c0 17.7 14.3 32 32 32c0-61.9 50.1-112 112-112s112 50.1 112 112l128 0c0-61.9 50.1-112 112-112s112 50.1 112 112c17.7 0 32-14.3 32-32l0-48c0-65.2-48.8-119-111.8-127z"]
  ]
}, JM = {
  prefix: "fad",
  iconName: "comments-question-check",
  icon: [
    640,
    512,
    [],
    "e14f",
    ["M0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8C2.4 326.1 0 331 0 336c0 1.6 .3 3.3 .8 4.9C2.9 347.5 9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zm134.7-59.9c0-2.2 .4-4.5 1.2-6.7l.4-1c6.6-18.6 24.2-31.1 44-31.1l48.5 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20l0-11.2c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-48.5 0c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2c-8.2-2.9-13.3-10.6-13.3-18.8zM234.7 264a26.7 26.7 0 1 1 -53.3 0 26.7 26.7 0 1 1 53.3 0z", "M136.2 108.4c6.6-18.6 24.2-31.1 44-31.1l48.5 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20l0-11.2c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-48.5 0c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1zM181.3 264a26.7 26.7 0 1 1 53.3 0 26.7 26.7 0 1 1 -53.3 0zM432 512c-95.6 0-176.2-54.6-200.5-129C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2s0 0 0 0s0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.3-11.4C505.9 503.3 470.2 512 432 512zM566.1 318.1c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L472 355.7l-25.9-25.9c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l40 40c7.8 7.8 20.5 7.8 28.3 0l80-80z"]
  ]
}, eN = {
  prefix: "fad",
  iconName: "clipboard-medical",
  icon: [
    384,
    512,
    [],
    "e133",
    ["M0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-49.6 0c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7c.1-.8 .3-1.6 .4-2.3L64 64C28.7 64 0 92.7 0 128zM96 304c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32z", "M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112l0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
  ]
}, tN = {
  prefix: "fad",
  iconName: "people-group",
  icon: [
    640,
    512,
    [],
    "e533",
    ["M0 304c0 44.7 26.2 83.2 64 101.2L64 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-42.8 0-10.7c-20-24.7-32-56.2-32-90.5c0-37.8 14.6-72.2 38.4-97.9c-16.1-9-34.7-14.1-54.4-14.1l-32 0C50.1 192 0 242.1 0 304zm48 0c0-16.2 6-31.1 16-42.3l0 84.7C54 335 48 320.2 48 304zM64 96a64 64 0 1 0 128 0A64 64 0 1 0 64 96zM441.6 206.1C465.4 231.8 480 266.2 480 304c0 34.3-12 65.8-32 90.5l0 10.7 0 42.8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-42.8c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112l-32 0c-19.7 0-38.3 5.1-54.4 14.1zM448 96a64 64 0 1 0 128 0A64 64 0 1 0 448 96zM576 261.7c10 11.3 16 26.1 16 42.3s-6 31-16 42.3l0-84.7z", "M384 96A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM256 261.7l0 84.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3zm128 84.7l0-84.7c10 11.3 16 26.1 16 42.3s-6 31-16 42.3zm0 58.9c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112l-32 0c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2l0 42.8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-42.8z"]
  ]
}, nN = {
  prefix: "fad",
  iconName: "hospital-user",
  icon: [
    576,
    512,
    [],
    "f80d",
    ["M0 48C0 21.5 21.5 0 48 0L272 0c26.5 0 48 21.5 48 48l0 223.8 0 95.9c-38.2 21.4-64 62.3-64 109.2c0 12.9 3.6 24.9 9.9 35.1L48 512c-26.5 0-48-21.5-48-48l0-80 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 352l0-64 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L0 256 0 48zm96 72l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16z", "M432 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-50.9 32c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0z"]
  ]
}, rN = {
  prefix: "fad",
  iconName: "rainbow",
  icon: [
    640,
    512,
    [127752],
    "f75b",
    ["M96 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-88.4 71.6-160 160-160s160 71.6 160 160l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-123.7-100.3-224-224-224S96 228.3 96 352z", "M64 352C64 210.6 178.6 96 320 96s256 114.6 256 256l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96C640 175.3 496.7 32 320 32S0 175.3 0 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96zm192 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96z"]
  ]
}, aN = {
  prefix: "fad",
  iconName: "user-check",
  icon: [
    640,
    512,
    [],
    "f4fc",
    ["M0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0C79.8 304 0 383.8 0 482.3zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z", "M625 143c9.4 9.4 9.4 24.6 0 33.9L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0z"]
  ]
}, iN = {
  prefix: "fad",
  iconName: "person",
  icon: [
    320,
    512,
    [129485, "male"],
    "f183",
    ["M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z", "M88 256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1z"]
  ]
};
const sN = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsx(
    "svg",
    {
      className: t,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      ...n,
      children: /* @__PURE__ */ l.jsxs("g", { className: "fa-duotone-group", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-secondary",
            fill: "currentColor",
            d: "M0 482.3c0-81 54-149.4 128-171.1l0 59.1c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-65.4c6-.6 12.1-.9 18.3-.9l91.4 0c6.2 0 12.3 .3 18.3 .9l0 57.1c-27.6 7.1-48 32.2-48 62l0 40c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-40c0-29.8-20.4-54.9-48-62l0-50.8c74 21.7 128 90.1 128 171.1c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM96 128c0-45.7 24.4-88 64-110.9C179.8 5.7 201.9 0 224 0s44.2 5.7 64 17.1C327.6 40 352 82.3 352 128s-24.4 88-64 110.9s-88.4 22.9-128 0S96 173.7 96 128zm24 296c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24z"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-primary",
            fill: "currentColor",
            d: "M384 48c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-48 0-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2l0-56-16 0c-26.5 0-48-21.5-48-48l0-128z"
          }
        )
      ] })
    }
  );
}, oN = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsx(
    "svg",
    {
      className: t,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 734 512",
      ...n,
      children: /* @__PURE__ */ l.jsxs("g", { className: "fa-duotone-group", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-secondary",
            fill: "currentColor",
            d: "M.5 420.5l0 18.3c0 40.3 33 73.3 73.3 73.3l586.5 0c40.3 0 73.3-33 73.3-73.3l0-18.3c0-9-8.2-18.3-18.3-18.3l-696.4 0c-10.1 0-18.3 8.2-18.3 18.3zM73.8 55l0 311.6 73.3 0 0-293.2 439.8 0 0 293.2 73.3 0 0-311.6c0-30.2-24.7-55-55-55L128.8 0c-30.2 0-55 24.7-55 55z"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-primary",
            fill: "currentColor",
            d: "M404.9 256.8h4.2v30.5c-14.1 3.8-25.2 17-25.2 32.6v12.6c0 2.2 1.4 4.4 3 6l8.4 8.5c3.3 3.3 8.6 3.3 11.9 0s3.3-8.6 0-11.9l-6.4-6v-9.2c0-9.3 8-16.8 16.8-16.8s17.3 7.6 17.3 16.8v9.2l-6 6c-3.3 3.3-3.3 8.6 0 11.9s8.6 3.3 11.9 0l8.4-8.5c1.6-1.6 2.5-3.8 2.5-6v-12.6c0-15.7-10.8-29-25.2-32.6v-28.1c38.6 9.4 67.4 44 67.4 86.1v4.2c0 9.3-7.6 16.8-16.8 16.8H275.1c-9.3 0-16.8-7.6-16.8-16.8v-4.2c0-41.7 28.6-76.6 67.4-86.1v32.4c-12.1 3.7-21.1 14.9-21.1 28.3s13.2 29.6 29.4 29.6 29.4-13.3 29.4-29.6-8.9-24.6-21.1-28.3v-34.8h62.7-.1zm-84.1 63.3c0-7 6.1-12.6 12.6-12.6s12.6 5.6 12.6 12.6-5.2 12.6-12.6 12.6-12.6-5.6-12.6-12.6zM308.7 164.4c0-37.1 30.1-67.4 67.4-67.4s67.4 30.1 67.4 67.4-30.1 67.4-67.4 67.4-67.4-30.1-67.4-67.4z"
          }
        )
      ] })
    }
  );
}, cN = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      className: t,
      ...n,
      children: /* @__PURE__ */ l.jsxs("g", { className: "fa-duotone-group", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-secondary",
            fill: "currentColor",
            d: "M0 48L0 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48zM64 64l192 0 0 0 0 320L64 384l0-92.3L64 64zm48 384c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 15.1c0 9.7-7.2 16.9-16 16.9l-64.9 0c-7.9 0-15.1-7.2-15.1-16z"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-primary",
            fill: "currentColor",
            d: "M105.8 269.3V304c-13 3.9-22.6 16-22.6 30.3c0 17.5 14.2 31.6 31.6 31.6s31.6-14.2 31.6-31.6c0-14.3-9.5-26.4-22.6-30.3v-37.3c1.5-.1 3-.1 4.5-.1h62.7c2 0 3.5 .1 4.5 .1v32.6c-15.1 4-27.1 18.2-27.1 35v13.6c0 2.4 1.5 4.7 3.2 6.4l9 9c3.5 3.6 9.3 3.6 12.8 0c3.6-3.5 3.6-9.3 0-12.8l-6.9-6.4v-9.8c0-10 8.6-18.1 18.1-18.1c10.5 0 18.6 8.1 18.6 18.1v9.8l-6.4 6.4c-3.6 3.5-3.6 9.3 0 12.8c3.5 3.6 9.3 3.6 12.8 0l9-9c1.7-1.7 2.7-4 2.7-6.4v-13.6c0-16.8-11.5-31-27.1-35v-30c15.9 3.9 30.2 11.7 41.8 22.4V64H64v227.8c11.6-10.7 25.9-18.6 41.8-22.5h0zm22.1 65.1c0 7.5-5.5 13.6-13.6 13.6c-7 0-13.6-6-13.6-13.6s6.6-13.6 13.6-13.6c8 0 13.6 6 13.6 13.6zM87.7 167.2c0-39.9 32.4-72.3 72.3-72.3s72.3 32.4 72.3 72.3-32.4 72.3-72.3 72.3-72.3-32.4-72.3-72.3z"
          }
        )
      ] })
    }
  );
}, lN = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsxs(
    "svg",
    {
      className: t,
      xmlns: `\r
        http://www.w3.org/2000/svg`,
      viewBox: "0 0 473 512",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-secondary",
            fill: "currentColor",
            opacity: ".4",
            d: "M144.3 2a55.1 55.1 0 1 0 0 110.3A55.1 55.1 0 1 0 144.3 2zM282.2 36.2a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM416.5 5.5a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM83.7 198.5a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM55.3 54.7a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM379.1 241a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM250.7 269.8a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM426.3 120.1a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3z"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-primary",
            fill: "currentColor",
            d: "M222.7 15a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zm130.4 0a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM73.1 261.5a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM59.7 124.5a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM316.1 268.2a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zm100.8-71.3a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM429.5 50a55.1 55.1 0 1 0 0 110.3 55.1 55.1 0 1 0 0-110.3zM298.3 421.8h0c3.9-7.9 3.9-11.8 3.9-19.7c0-27.6-23.6-55.1-51.2-55.1s-55.1 23.6-55.1 55.1c0 7.9 0 15.8 3.9 19.7h0c0 3.9 3.9 7.9 7.9 11.8c11.8 23.6 15.8 47.3 15.8 59.1c0 7.9 3.9 15.8 11.8 23.6c11.8 15.8 23.6 7.9 31.5 0l11.8-23.6c3.9-27.6 11.8-51.2 15.8-59.1c3.9-3.9 3.9-7.9 3.9-11.8h0zM79.4 0a55.1 55.1 0 1 0 0 110.3A55.1 55.1 0 1 0 79.4 0z"
          }
        )
      ]
    }
  );
}, dN = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsxs(
    "svg",
    {
      className: t,
      xmlns: `\r
        http://www.w3.org/2000/svg`,
      viewBox: "0 0 330 512",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-secondary",
            fill: "currentColor",
            opacity: ".4",
            d: "M3.7 201.1c-11 21.9 7.3 47.5 18.3 58.5c3.7 3.7 11 7.3 14.6 11c18.3 11 21.9 3.7 21.9 0s-3.7-7.3-7.3-11C29.3 245 25.7 215.8 25.7 204.8c0-3.7 0-7.3-3.7-11c-7.3-14.6-18.3 7.3-18.3 7.3zM212.2 343.8c0 3.7 0 14.6 3.7 21.9l3.7 3.7L332.9 475.4l11-11c-3.7 0-102.4-124.3-102.4-124.3c-3.7-7.3-3.7-14.6-3.7-18.3c3.7-7.3 0-18.3-14.6-29.3c0 0 0 25.6-7.3 43.9c0 2.4-1.2 4.9-3.7 7.3z"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-primary",
            fill: "currentColor",
            d: "M65.9 252.3c14.6 3.7 21.9 11 25.6 18.3c0 7.3 7.3 11 14.6 14.6c36.6 18.3 43.9-11 47.5-32.9c0-11-3.7-21.9-7.3-29.3c-11-14.6-14.6-25.6-14.6-32.9v-3.7h0L197.5 0h-51.2l-32.9 109.7c-7.3 21.9-25.6 51.2-36.6 65.8c-3.7 7.3-7.3 11-14.6 11c-29.3 11-29.3 29.3-21.9 43.9c3.7 11 14.6 18.3 25.6 21.9zm135.3 84.1h0c11-21.9 11-36.6 11-36.6c-7.3-47.5-51.2-14.6-51.2-14.6c-36.6 32.9-80.5 0-80.5 0c-43.9-14.6-36.6 25.6-36.6 25.6c3.7 58.5 47.5 43.9 47.5 43.9c25.6-7.3 197.5 160.9 197.5 160.9l36.6-29.3-102.4-95.1c-14.6-21.9-21.9-51.2-21.9-54.9z"
          }
        )
      ]
    }
  );
}, uN = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsxs(
    "svg",
    {
      className: t,
      xmlns: `\r
http://www.w3.org/2000/svg`,
      viewBox: "0 0 183 512",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-secondary",
            fill: "currentColor",
            opacity: ".4",
            d: "M11 197.9l0 3.7c0 3.7 3.7 7.3 3.7 11l0 3.7c0 3.7 3.7 7.3 11 7.3c0 0 3.7 0 7.3-3.7c3.7 14.6 18.3 7.3 18.3 7.3c14.6-7.3 29.3 0 29.3 0c7.3 0 11-3.7 11-11c7.3 7.3 14.6 3.7 14.6 3.7c11-3.7 7.3-11 7.3-14.6c-3.7-3.7-3.7-11-3.7-11l0-3.7c-3.7-11-14.6-7.3-18.3-7.3c-7.3-7.3-21.9-3.7-21.9-3.7c-11 3.7-14.6 0-14.6 0c-18.3-11-21.9 3.7-21.9 3.7l0 3.7c-3.7 0-21.9 0-21.9 11zM18.4 73.5l0 3.7c0 3.7 3.7 7.3 0 11l0 3.7c0 3.7 0 11 7.3 11c0 0 3.7 0 11-3.7c0 14.6 18.3 11 18.3 11c14.6-3.7 32.9 3.7 32.9 3.7c7.3 0 11-3.7 11-7.3c3.7 7.3 14.6 3.7 14.6 3.7c7.3 0 7.3-3.7 7.3-7.3c-3.7-7.3-3.7-11 0-14.6l0-3.7c-3.7-11-14.6-11-18.3-7.3c-3.7-11-18.3-7.3-18.3-7.3c-14.6 0-18.3-3.7-18.3-3.7C51.3 51.6 44 62.5 44 62.5l-3.7 3.7c-3.7 0-18.3-3.7-21.9 7.3zM62.2 322.2s0 3.7 3.7 3.7s7.3 3.7 7.3 7.3l0 3.7c3.7 3.7 7.3 7.3 14.6 3.7c0 0 3.7 0 7.3-7.3c11 14.6 21.9 0 21.9 0c7.3-7.3 25.6-11 25.6-11c3.7 0 7.3-7.3 7.3-11c7.3 3.7 14.6-3.7 14.6-3.7c3.7-3.7 0-11-3.7-14.6s-7.3-7.3-7.3-11s0-3.7-3.7-3.7c-7.3-3.7-14.6 0-18.3 3.7c-7.3-7.3-18.3 3.7-18.3 3.7c-11 7.3-14.6 7.3-14.6 7.3c-21.9-7.3-21.9 7.3-21.9 7.3l0 3.7c-3.7 0-18.3 7.3-14.6 18.3zm29.3 98.7l0 3.7c0 3.7 3.7 7.3 3.7 11l0 3.7c0 3.7 3.7 11 11 7.3c0 0 3.7 0 7.3-3.7c3.7 14.6 18.3 7.3 18.3 7.3c14.6-3.7 29.3 0 29.3 0c7.3 0 11-3.7 11-7.3c7.3 7.3 14.6 3.7 14.6 3.7c7.3-3.7 3.7-11 3.7-14.6c-3.7-3.7-3.7-11-3.7-14.6l0-3.7c-3.7-7.3-11-7.3-18.3-3.7c-3.7-11-18.3-3.7-18.3-3.7c-14.6 7.3-14.6 0-14.6 0c-14.6-7.3-21.9 0-21.9 0l0 3.7c-3.7 0-21.9 0-21.9 11z"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            className: "fa-primary",
            fill: "currentColor",
            d: "M128.1 44.3s0-3.7 0 0c-3.7-7.3 0-11 0-14.6V26c-3.7-7.3-11-7.3-18.3-7.3c-3.7-11-18.3-7.3-18.3-7.3c-11 0-14.6-3.7-14.6-3.7c-18.3-14.6-21.9-3.7-21.9-3.7l-3.7 3.7C47.6 7.7 33 4 29.3 15v3.7c0 3.7 3.7 7.3 0 11v3.7c0 3.7 0 11 7.3 11c0 0 3.7 0 11-3.7c0 14.6 18.3 11 18.3 11c14.6-3.7 29.3 3.7 29.3 3.7c7.3 3.7 11 0 11-3.7c3.7 7.3 14.6 3.7 14.6 3.7c7.3 0 7.3-7.3 7.3-11h0zM102.5 157.6h0c-3.7-7.3-3.7-11 0-14.6v-3.7c-3.7-7.3-11-7.3-18.3-7.3c-3.7-7.3-18.3-7.3-18.3-7.3c-11 3.7-18.3 0-18.3 0c-14.6-18.3-21.9-3.7-21.9-3.7l-3.7 3.7c-3.7 0-18.3-3.7-21.9 7.3v3.7c0 3.7 3.7 7.3 0 11v3.7c0 3.7 0 11 7.3 11c0 0 3.7 0 11-3.7c0 14.6 18.3 11 18.3 11c18.3-3.7 32.9 3.7 32.9 3.7c7.3 0 11-3.7 11-7.3c3.7 7.3 14.6 3.7 14.6 3.7c7.3 0 7.3-7.3 7.3-11h0zM139 245.4s-3.7 0 0 0c-7.3-3.7-7.3-7.3-7.3-11s0-3.7-3.7-3.7c-3.7-7.3-14.6-3.7-18.3 0c-7.3-7.3-18.3 0-18.3 0c-11 7.3-18.3 3.7-18.3 3.7c-21.9-3.7-21.9 7.3-21.9 7.3v3.7c-3.7 0-18.3 3.7-18.3 14.6q0 3.7 3.7 3.7c3.7 3.7 3.7 7.3 3.7 7.3v3.7c0 3.7 3.7 7.3 11 3.7c0 0 3.7 0 7.3-7.3c11 18.3 25.6 11 25.6 11c11-7.3 29.3-7.3 29.3-7.3c7.3-3.7 7.3-7.3 7.3-11c7.3 3.7 14.6 0 14.6 0c7.3-7.3 3.7-14.6 3.7-18.3h0zm51.2 113.4h0c-3.7-3.7-3.7-7.3-7.3-11q0-3.7-3.7-3.7c0-7.3-11-3.7-14.6 0c-7.3-11-21.9-3.7-21.9-3.7c-11 7.3-14.6 3.7-14.6 3.7c-21.9-7.3-21.9 3.7-21.9 3.7v3.7c-3.7 0-18.3 3.7-18.3 14.6q0 3.7 3.7 3.7c3.7 3.7 3.7 7.3 3.7 11v3.7c0 3.7 3.7 7.3 11 7.3c0 0 3.7 0 7.3-7.3c7.3 14.6 21.9 3.7 21.9 3.7c11-7.3 29.3-7.3 29.3-7.3c7.3 0 7.3-7.3 7.3-11c7.3 3.7 14.6 0 14.6 0c7.3 0 7.3-7.3 3.7-11h0zm-11 146.3s0-3.7 0 0c-3.7-7.3 0-11 0-14.6v-3.7c-3.7-7.3-11-7.3-18.3-7.3c-3.7-11-18.3-11-18.3-11c-11 3.7-14.6-3.7-14.6-3.7c-14.6-7.3-21.9-3.7-21.9-3.7l-3.7 3.7c-3.7 0-18.3-3.7-21.9 7.3v3.7c0 3.7 3.7 7.3 0 11v3.7c0 3.7 0 11 7.3 11c0 0 3.7 0 11-3.7c0 14.6 14.6 11 14.6 11c14.6 0 29.3 7.3 29.3 7.3c7.3 0 11-3.7 14.6-7.3c3.7 7.3 11 3.7 11 3.7c7.3 0 11-7.3 11-7.3h0z"
          }
        )
      ]
    }
  );
}, Ks = {
  addressCardDuotone: LM,
  americanSignLanguageInterpreting: zx,
  americanSignLanguageInterpretingDuotone: WL,
  angleDoubleLeft: fx,
  angleDoubleRight: Wx,
  angleDown: R_,
  angleLeft: f_,
  anglesLeft: x_,
  anglesRight: Nw,
  appleWhole: uw,
  appleWholeDuotone: gM,
  appleWholeThin: oS,
  arrowRight: mw,
  arrowRightLong: O_,
  arrowsLeftRight: _w,
  arrowUp: z_,
  arrowUpRightFromSquare: Bx,
  asterisk: Zx,
  awardDuotone: gL,
  baby: L_,
  babyDuotone: _L,
  babyThin: AC,
  badgeCheckDuotone: fM,
  bars: Jw,
  barsSort: Tw,
  blog: nC,
  book: h_,
  bookDuotone: cL,
  booksMedical: $x,
  booksMedicalDuotone: sM,
  bookThin: MC,
  boot: o_,
  bootDuotone: tL,
  bootThin: _C,
  brainDuotone: iL,
  buildings: p_,
  buildingsDuotone: sL,
  buildingsThin: LC,
  bullhorn: Dw,
  bullhornDuotone: HM,
  bullhornThin: MS,
  calendar: v_,
  calendarCheckLight: gC,
  calendarDaysLight: vC,
  calendarDuotone: pL,
  calendarPlus: kx,
  calendarStar: Aw,
  calendarStarDuotone: OM,
  calendarStarThin: _S,
  calendarThin: zC,
  caretDown: U_,
  cars: S_,
  carsDuotone: yL,
  carSide: Uw,
  carSideDuotone: QM,
  carSideThin: jS,
  carsThin: jC,
  certificate: Sw,
  chalkboardUser: M_,
  chartUser: X_,
  chartUserDuotone: UL,
  chartUserThin: YC,
  check: m_,
  checkDuotone: oL,
  checkSquare: Zw,
  chevronDoubleLeft: iC,
  chevronDoubleRight: u_,
  chevronDown: E_,
  chevronLeft: C_,
  chevronLeftDuotone: bL,
  chevronLeftSharp: uC,
  chevronRight: w_,
  chevronRightSharp: dC,
  chevronUp: qw,
  child: Px,
  childDuotone: rM,
  circle: Fx,
  circle1: hx,
  circle1Duotone: wL,
  circle1Sharp: fC,
  circle1Thin: $C,
  circle2: ix,
  circle2Duotone: nL,
  circle2Sharp: cC,
  circle2Thin: wC,
  circle3: ax,
  circle3Duotone: eL,
  circle3Sharp: oC,
  circle3Thin: xC,
  circle4: sx,
  circle4Duotone: aL,
  circle4Sharp: lC,
  circle4Thin: SC,
  circle5: Tx,
  circle5Duotone: YL,
  circle5Sharp: mC,
  circle5Thin: KC,
  circleCheck: Mw,
  circleCheckDuotone: NM,
  circleCheckThin: hS,
  circleExclamation: V6,
  circleInfo: B6,
  circleInfoSolid: J_,
  circleMinus: Jx,
  circlePlay: Hx,
  circlePlus: ox,
  circleQuestion: sw,
  circleQuestionDuotone: uM,
  circleQuestionThin: rS,
  circleXmark: l_,
  clipboardListCheckDuotone: lL,
  clipboardMedical: Kw,
  clipboardMedicalDuotone: eN,
  clipboardMedicalThin: PS,
  clock: Mx,
  clockDuotone: VL,
  clockThin: UC,
  close: px,
  cloud: eC,
  cloudDownload: xw,
  cloudUpload: Cw,
  cog: K_,
  colorectalSolid: OS,
  comment: nw,
  commentAlt: t_,
  comments: rC,
  commentsAltDuotone: EM,
  commentsQuestionCheckDuotone: JM,
  contactThin: RS,
  copy: N_,
  creditCard: P_,
  creditCardDuotone: jL,
  creditCardThin: FC,
  cube: cw,
  download: V_,
  dumbbell: Z_,
  dumbbellDuotone: XL,
  dumbbellThin: XC,
  dumpster: Kx,
  dumpsterDuotone: qM,
  edit: Yw,
  ellipsisH: I_,
  ellipsisV: q_,
  envelope: tw,
  exclamation: s_,
  exclamationCircle: Qw,
  facebook: Xy,
  familyDuotone: $M,
  fax: T_,
  faxDuotone: NL,
  faxThin: OC,
  fileInvoiceDollarDuotone: DM,
  filePdf: Ax,
  filePlusDuotone: KM,
  filesMedicalDuotone: IM,
  film: Qx,
  flask: _x,
  folderMedical: F_,
  folderMedicalDuotone: $L,
  folderMedicalThin: HC,
  gift: zw,
  giftDuotone: zM,
  giftThin: gS,
  globe: Rw,
  globeDuotone: VM,
  globeThin: LS,
  graduationCap: a_,
  graduationCapDuotone: ZS,
  graduationCapThin: bC,
  handHeart: Ww,
  handHeartDuotone: XM,
  handHeartThin: kS,
  handHoldingHeart: hw,
  handHoldingHeartDuotone: bM,
  handHoldingHeartThin: lS,
  handHoldingMedical: tx,
  handHoldingMedicalDuotone: XS,
  handHoldingMedicalSolid: r_,
  handsHoldingDollar: dw,
  handsHoldingDollarDuotone: hM,
  handsHoldingDollarThin: sS,
  handsHoldingHeart: pw,
  handsHoldingHeartDuotone: vM,
  handsHoldingHeartThin: cS,
  headSideMedical: iw,
  headSideMedicalDuotone: dM,
  headSideMedicalThin: nS,
  heart: fw,
  heartCircleCheckDuotone: CM,
  heartPulse: jw,
  heartPulseDuotone: PM,
  heartPulseThin: yS,
  hospital: k_,
  hospitalDuotone: zL,
  hospitalsDuotone: SL,
  hospitalsThin: IC,
  hospitalThin: RC,
  hospitalUserDuotone: nN,
  hospitalUserThin: AS,
  house: B_,
  houseDuotone: IL,
  houseMedical: y_,
  houseMedicalCircleCheckDuotone: KL,
  houseMedicalDuotone: hL,
  houseMedicalThin: TC,
  houseThin: qC,
  industryAlt: Sx,
  industryAltDuotone: FL,
  infoCircle: jx,
  infoCircleDuotone: JL,
  instagram: Zy,
  kitMedical: A_,
  kitMedicalDuotone: PL,
  kitMedicalThin: BC,
  kneeSolid: DS,
  language: gw,
  languageDuotone: yM,
  languageThin: dS,
  laptopMedialDuotone: h2,
  laptopMedicalDuotone: h2,
  laptopMobileDuotone: iM,
  lightbulbOn: Xx,
  lightbulbOnDuotone: ZM,
  linkedin: Qy,
  linkedinIn: ex,
  locationCrosshairs: Ix,
  locationDot: j_,
  locationDotThin: DC,
  lungsDuotone: tM,
  magnifyingGlass: gx,
  mapAlabama: FS,
  mapGeorgia: BS,
  mapIllinois: VS,
  mapMarkerAlt: bx,
  mapMarkerAltDuotone: TL,
  mapNorthcarolina: HS,
  mapSouthcarolina: qS,
  mapWisconsin: WS,
  mars: D_,
  marsDuotone: AL,
  marsThin: VC,
  memo: bw,
  memoDuotone: wM,
  memoThin: fS,
  messagesDuotone: H6,
  minus: Ex,
  mobileAndroid: xx,
  mobileAndroidDuotone: RL,
  mobileButtonThin: tS,
  newspaper: vw,
  newspaperDuotone: xM,
  newspaperThin: uS,
  pause: hC,
  peopleGroup: tN,
  person: sC,
  personDuotone: iN,
  personThin: IS,
  phone: aw,
  phoneDuotone: oM,
  phoneThin: eS,
  piggyBank: Lx,
  piggyBankDuotone: BL,
  piggyBankSolid: W_,
  piggyBankThin: WC,
  pills: Hw,
  pillsDuotone: YM,
  pillsThin: TS,
  plateUtensils: Q_,
  plateUtensilsDuotone: ZL,
  plateUtensilsThin: ZC,
  play: pC,
  plus: mx,
  print: rx,
  rainbow: tC,
  rainbowDuotone: rN,
  rainbowThin: $S,
  recycle: Dx,
  recycleDuotone: pM,
  recycleThin: aS,
  ribbonDuotone: nM,
  scalpelLineDashed: Iw,
  scalpelLineDashedDuotone: FM,
  scalpelLineDashedThin: CS,
  searchDuotone: ML,
  seedling: Vx,
  seedlingDuotone: SM,
  seedlingThin: pS,
  shieldCheck: Bw,
  shieldCheckDuotone: UM,
  shieldCheckThin: zS,
  shieldHeart: b_,
  shieldHeartDuotone: mL,
  shieldHeartThin: EC,
  shieldKeyhole: i_,
  shieldKeyholeDuotone: JS,
  shieldKeyholeThin: yC,
  shieldPlus: G_,
  shieldPlusDuotone: HL,
  shieldPlusThin: GC,
  shieldVirus: rw,
  shieldVirusDuotone: aM,
  shieldVirusThin: JC,
  shoePrints: cx,
  shoePrintsDuotone: dL,
  shoePrintsSolid: g_,
  shoePrintsThin: NC,
  sliders: wx,
  smokingBan: Rx,
  smokingBanDuotone: lM,
  spineSolid: US,
  squareHDuotone: kL,
  squarePlus: Ux,
  staffSnake: Vw,
  staffSnakeDuotone: GM,
  staffSnakeThin: ES,
  stethoscope: n_,
  stomachDuotone: _M,
  streetViewDuotone: GL,
  streetViewSolid: GS,
  syringe: c_,
  syringeDuotone: rL,
  syringeThin: CC,
  trophy: __,
  trophyDuotone: vL,
  trophyThin: kC,
  twitter: Yy,
  user: Fw,
  userCheckDuotone: aN,
  userDoctor: ew,
  userDoctorDuotone: eM,
  userDoctorThin: QC,
  userDuotone: WM,
  userHeadsetDuotone: CL,
  userMdChat: dx,
  userMdChatDuotone: fL,
  userPatientThin: YS,
  usersLineDuotone: xL,
  usersLineThin: PC,
  userThin: NS,
  userVisitorThin: KS,
  venus: Pw,
  venusDuotone: AM,
  venusMars: Ow,
  venusMarsDuotone: BM,
  venusMarsThin: SS,
  venusThin: xS,
  video: nx,
  videoDuotone: QS,
  viruses: Lw,
  virusesDuotone: MM,
  virusesThin: mS,
  weight: Yx,
  weightDuotone: kM,
  weightHanging: kw,
  weightHangingDuotone: jM,
  weightHangingThin: bS,
  weightScaleDuotone: q6,
  wifi: Ew,
  wifiDuotone: TM,
  wifiThin: vS,
  wrench: ow,
  xmark: F6,
  xRay: $w,
  xRayDuotone: RM,
  xRayThin: wS,
  xTwitter: Jy,
  youtube: Ky
}, Xs = {
  laptopPhysician: /* @__PURE__ */ l.jsx(oN, {}),
  mobilePhysician: /* @__PURE__ */ l.jsx(cN, {}),
  userDoctorMessageDuotone: /* @__PURE__ */ l.jsx(sN, {}),
  colorectalDuotone: /* @__PURE__ */ l.jsx(lN, {}),
  kneeDuotone: /* @__PURE__ */ l.jsx(dN, {}),
  spineDuotone: /* @__PURE__ */ l.jsx(uN, {})
}, ik = Object.keys({
  ...Ks,
  ...Xs
}).sort();
_y.autoAddCss = !1;
const re = (e) => {
  const { className: t, icon: n, color: r, style: a = {}, ...i } = e;
  return a.height || (a.height = ""), a.width || (a.width = ""), n in Xs ? Te(Xs[n], {
    "aria-hidden": "true",
    "data-testid": "svg-icon",
    className: z(m2({ color: r }), t),
    style: a,
    ...i
  }) : n in Ks ? /* @__PURE__ */ l.jsx(
    Pa,
    {
      className: z(m2({ color: r }), t),
      "data-testid": "svg-icon",
      icon: Ks[n],
      style: a,
      ...i
    }
  ) : (console.warn(`The icon "${n}" is not imported.`), null);
}, fN = {
  "image-base": "_image-base_1t7ua_209"
}, pN = {
  "1:1": 1,
  "5:4": 5 / 4,
  "5:2": 5 / 2,
  "4:5": 4 / 5,
  "8:5": 8 / 5,
  "4:3": 4 / 3,
  "8:3": 8 / 3,
  "3:4": 3 / 4,
  "3:2": 3 / 2,
  "3:1": 3,
  "2:3": 2 / 3,
  "16:10": 16 / 10,
  "16:5": 16 / 5,
  "10:16": 10 / 16,
  "golden-ratio-landscape": 1.618,
  "golden-ratio-half-landscape": 3.235,
  "golden-ratio-portrait": 0.618,
  "golden-ratio-half-portrait": 0.144,
  "16:9": 16 / 9,
  "32:9": 32 / 9,
  "9:16": 9 / 16,
  "9:8": 9 / 8,
  "2:1": 2,
  "4:1": 4,
  "1:2": 1 / 2,
  "21:9": 21 / 9,
  "14:3": 14 / 3,
  "9:21": 9 / 21,
  "6:7": 6 / 7,
  "A4-landscape": 1.414,
  "A4-half-landscape": 2.828,
  "A4-portrait": 0.707,
  "A4-half-portrait": 1.414,
  "letter-landscape": 1.294,
  "letter-half-landscape": 2.588,
  "letter-portrait": 0.772,
  "letter-half-portrait": 1.545
}, mN = "1:1", yn = K((e, t) => {
  const {
    className: n,
    children: r,
    ratio: a,
    shouldLazyLoad: i = !1,
    ...s
  } = e, o = mr(r, i);
  return /* @__PURE__ */ l.jsx(
    mf,
    {
      className: n,
      "data-testid": "image",
      ratio: (typeof a == "number" ? a : pN[a]) ?? mN,
      children: /* @__PURE__ */ l.jsx(
        lt,
        {
          ref: t,
          className: fN["image-base"],
          ...s,
          children: o ?? /* @__PURE__ */ l.jsx("img", { ...i ? { loading: "lazy" } : {} })
        }
      )
    }
  );
}), hN = "_h1_2zy5l_209", gN = "_h2_2zy5l_227", vN = "_h3_2zy5l_245", bN = "_h4_2zy5l_263", yN = "_p_2zy5l_281", xN = "_base_2zy5l_375", _N = "_inverse_2zy5l_382", de = {
  h1: hN,
  h2: gN,
  h3: vN,
  h4: bN,
  p: yN,
  base: xN,
  inverse: _N,
  "xl-heading": "_xl-heading_2zy5l_385",
  "xl-heading-mobile": "_xl-heading-mobile_2zy5l_396",
  "large-heading": "_large-heading_2zy5l_407",
  "large-heading-mobile": "_large-heading-mobile_2zy5l_418",
  "medium-heading": "_medium-heading_2zy5l_429",
  "medium-heading-mobile": "_medium-heading-mobile_2zy5l_440",
  "small-heading": "_small-heading_2zy5l_451",
  "small-heading-mobile": "_small-heading-mobile_2zy5l_462",
  "small-paragraph": "_small-paragraph_2zy5l_473",
  "small-paragraph-bold": "_small-paragraph-bold_2zy5l_484",
  "small-link": "_small-link_2zy5l_495",
  "small-link-mobile": "_small-link-mobile_2zy5l_506",
  "tablet-xl-heading": "_tablet-xl-heading_2zy5l_518",
  "tablet-xl-heading-mobile": "_tablet-xl-heading-mobile_2zy5l_529",
  "tablet-large-heading": "_tablet-large-heading_2zy5l_540",
  "tablet-large-heading-mobile": "_tablet-large-heading-mobile_2zy5l_551",
  "tablet-medium-heading": "_tablet-medium-heading_2zy5l_562",
  "tablet-medium-heading-mobile": "_tablet-medium-heading-mobile_2zy5l_573",
  "tablet-small-heading": "_tablet-small-heading_2zy5l_584",
  "tablet-small-heading-mobile": "_tablet-small-heading-mobile_2zy5l_595",
  "tablet-small-paragraph": "_tablet-small-paragraph_2zy5l_606",
  "tablet-small-paragraph-bold": "_tablet-small-paragraph-bold_2zy5l_617",
  "tablet-small-link": "_tablet-small-link_2zy5l_628",
  "tablet-small-link-mobile": "_tablet-small-link-mobile_2zy5l_639",
  "corp-xl-heading": "_corp-xl-heading_2zy5l_651",
  "corp-xl-heading-mobile": "_corp-xl-heading-mobile_2zy5l_660",
  "corp-large-heading": "_corp-large-heading_2zy5l_669",
  "corp-large-heading-mobile": "_corp-large-heading-mobile_2zy5l_678",
  "corp-medium-heading": "_corp-medium-heading_2zy5l_687",
  "corp-medium-heading-mobile": "_corp-medium-heading-mobile_2zy5l_696",
  "corp-small-heading": "_corp-small-heading_2zy5l_705",
  "corp-small-heading-mobile": "_corp-small-heading-mobile_2zy5l_714",
  "corp-small-paragraph": "_corp-small-paragraph_2zy5l_723",
  "corp-small-paragraph-bold": "_corp-small-paragraph-bold_2zy5l_732",
  "corp-small-link": "_corp-small-link_2zy5l_741",
  "corp-small-link-mobile": "_corp-small-link-mobile_2zy5l_750",
  "tablet-corp-xl-heading": "_tablet-corp-xl-heading_2zy5l_760",
  "tablet-corp-xl-heading-mobile": "_tablet-corp-xl-heading-mobile_2zy5l_769",
  "tablet-corp-large-heading": "_tablet-corp-large-heading_2zy5l_778",
  "tablet-corp-large-heading-mobile": "_tablet-corp-large-heading-mobile_2zy5l_787",
  "tablet-corp-medium-heading": "_tablet-corp-medium-heading_2zy5l_796",
  "tablet-corp-medium-heading-mobile": "_tablet-corp-medium-heading-mobile_2zy5l_805",
  "tablet-corp-small-heading": "_tablet-corp-small-heading_2zy5l_814",
  "tablet-corp-small-heading-mobile": "_tablet-corp-small-heading-mobile_2zy5l_823",
  "tablet-corp-small-paragraph": "_tablet-corp-small-paragraph_2zy5l_832",
  "tablet-corp-small-paragraph-bold": "_tablet-corp-small-paragraph-bold_2zy5l_841",
  "tablet-corp-small-link": "_tablet-corp-small-link_2zy5l_850",
  "tablet-corp-small-link-mobile": "_tablet-corp-small-link-mobile_2zy5l_859"
}, wN = me({
  h1: de.h1,
  h2: de.h2,
  h3: de.h3,
  h4: de.h4,
  h5: de.h4,
  h6: de.h4,
  p: de.p,
  span: de.p,
  dd: "",
  dt: "",
  label: "",
  sup: ""
}), Zs = me({
  xlHeading: de["xl-heading"],
  xlHeadingMobile: de["xl-heading-mobile"],
  lgHeading: de["large-heading"],
  lgHeadingMobile: de["large-heading-mobile"],
  mdHeading: de["medium-heading"],
  mdHeadingMobile: de["medium-heading-mobile"],
  smHeading: de["small-heading"],
  smHeadingMobile: de["small-heading-mobile"],
  smParagraph: de["small-paragraph"],
  smParagraphBold: de["small-paragraph-bold"],
  smLink: de["small-link"],
  smLinkMobile: de["small-link-mobile"]
}), Qs = me({
  xlHeading: de["tablet-xl-heading"],
  xlHeadingMobile: de["tablet-xl-heading-mobile"],
  lgHeading: de["tablet-large-heading"],
  lgHeadingMobile: de["tablet-large-heading-mobile"],
  mdHeading: de["tablet-medium-heading"],
  mdHeadingMobile: de["tablet-medium-heading-mobile"],
  smHeading: de["tablet-small-heading"],
  smHeadingMobile: de["tablet-small-heading-mobile"],
  smParagraph: de["tablet-small-paragraph"],
  smParagraphBold: de["tablet-small-paragraph-bold"],
  smLink: de["tablet-small-link"],
  smLinkMobile: de["tablet-small-link-mobile"]
}), Js = me({
  xlHeading: de["corp-xl-heading"],
  xlHeadingMobile: de["corp-xl-heading-mobile"],
  lgHeading: de["corp-large-heading"],
  lgHeadingMobile: de["corp-large-heading-mobile"],
  mdHeading: de["corp-medium-heading"],
  mdHeadingMobile: de["corp-medium-heading-mobile"],
  smHeading: de["corp-small-heading"],
  smHeadingMobile: de["corp-small-heading-mobile"],
  smParagraph: de["corp-small-paragraph"],
  smParagraphBold: de["corp-small-paragraph-bold"],
  smLink: de["corp-small-link"],
  smLinkMobile: de["corp-small-link-mobile"]
}), eo = me({
  xlHeading: de["tablet-corp-xl-heading"],
  xlHeadingMobile: de["tablet-corp-xl-heading-mobile"],
  lgHeading: de["tablet-corp-large-heading"],
  lgHeadingMobile: de["tablet-corp-large-heading-mobile"],
  mdHeading: de["tablet-corp-medium-heading"],
  mdHeadingMobile: de["tablet-corp-medium-heading-mobile"],
  smHeading: de["tablet-corp-small-heading"],
  smHeadingMobile: de["tablet-corp-small-heading-mobile"],
  smParagraph: de["tablet-corp-small-paragraph"],
  smParagraphBold: de["tablet-corp-small-paragraph-bold"],
  smLink: de["tablet-corp-small-link"],
  smLinkMobile: de["tablet-corp-small-link-mobile"]
}), CN = De([de.base], {
  variants: {
    tag: wN,
    fontStyle: Zs,
    fontStyleTablet: Qs,
    fontStyleCorp: Js,
    fontStyleCorpTablet: eo,
    isInverse: me({
      true: de.inverse,
      false: ""
    })
  }
}), SN = "span", G = (e) => {
  var v;
  const {
    tag: t = SN,
    asChild: n = !1,
    fontStyle: r,
    fontStyleTablet: a,
    fontStyleCorp: i = r,
    fontStyleCorpTablet: s = a,
    className: o,
    customRef: c,
    ...d
  } = e, u = n ? lt : t, f = Et(Hn), p = hr(f), h = !!((v = d.dangerouslySetInnerHTML) != null && v.__html), g = z(
    CN({
      tag: t,
      fontStyle: r,
      fontStyleTablet: a,
      fontStyleCorp: i,
      fontStyleCorpTablet: s,
      isInverse: p
    }),
    o
  );
  return (d.children || h) && /* @__PURE__ */ l.jsx(
    u,
    {
      className: g,
      ref: c,
      ...d
    }
  );
}, LN = "_inverse_rqnbq_274", MN = "_alt_rqnbq_292", NN = "_inherit_rqnbq_325", qr = {
  "anchor-base": "_anchor-base_rqnbq_209",
  inverse: LN,
  alt: MN,
  "underline-hover": "_underline-hover_rqnbq_310",
  "underline-none": "_underline-none_rqnbq_316",
  inherit: NN
}, zN = qr["anchor-base"], EN = me(
  {
    always: "",
    hover: qr["underline-hover"],
    none: qr["underline-none"]
  }
), TN = me({
  true: qr.inherit
}), kN = me({
  default: "",
  alt: qr.alt,
  inverse: qr.inverse
}), jN = me({
  smLink: Zs.smLink,
  smLinkMobile: Zs.smLinkMobile
}), PN = me({
  smLink: Qs.smLink,
  smLinkMobile: Qs.smLinkMobile
}), AN = me({
  smLink: Js.smLink,
  smLinkMobile: Js.smLinkMobile
}), $N = me({
  smLink: eo.smLink,
  smLinkMobile: eo.smLinkMobile
}), IN = De(zN, {
  variants: {
    underline: EN,
    fontStyle: jN,
    fontStyleTablet: PN,
    fontStyleCorp: AN,
    asInherited: TN,
    fontStyleCorpTablet: $N,
    color: kN
  }
}), sk = ["smLink", "smLinkMobile"], ok = ["always", "hover", "none"], ON = "smLink", RN = "always", DN = (e) => (t) => {
  t.preventDefault(), hm(e);
}, X = K(
  (e, t) => {
    const {
      asInherited: n,
      children: r = "",
      buttonStyle: a,
      variant: i,
      color: s,
      order: o,
      fontStyle: c = ON,
      fontStyleTablet: d,
      fontStyleCorp: u = c,
      fontStyleCorpTablet: f = d,
      size: p,
      underline: h = RN,
      className: g = !1,
      disabled: v = !1,
      href: x,
      ...m
    } = e, b = Et(Hn), { theme: _ } = Ho(), C = a ? S3({
      buttonStyle: a,
      backgroundColor: b,
      theme: _,
      order: o
    }) : i, w = s || L3({ theme: _, backgroundColor: b }), N = v ? {
      href: "#",
      "aria-disabled": "true",
      onClick: (M) => {
        M.preventDefault();
      }
    } : {};
    return /* @__PURE__ */ l.jsx(
      lt,
      {
        ref: t,
        "data-testid": "anchor",
        rel: "noopener noreferrer",
        className: z(
          C && Fv(C) ? Fo({ variant: C, size: p }) : IN({
            asInherited: n,
            fontStyle: c,
            fontStyleTablet: d,
            fontStyleCorp: u,
            fontStyleCorpTablet: f,
            underline: h,
            color: w
          }),
          g
        ),
        ...m,
        children: typeof r == "string" || x ? /* @__PURE__ */ l.jsx(
          "a",
          {
            href: x,
            onClick: e != null && e.scrollBehavior ? DN(x) : void 0,
            ...N,
            children: r
          }
        ) : Te(r, N)
      }
    );
  }
), le = K(
  (e, t) => {
    const { as: n, children: r, customRef: a, className: i, ...s } = e, { theme: o } = Ho(), c = Et(Hn), d = hr(c), u = L3({ theme: o, backgroundColor: c }), f = z(
      "r-rich-text",
      d && "r-rich-text-inverse",
      u && `r-rich-text-anchors-${u}`,
      i
    ), p = n || "div";
    return typeof r == "string" ? /* @__PURE__ */ l.jsx(
      p,
      {
        className: f,
        "data-testid": "rich-text",
        ref: a || t,
        dangerouslySetInnerHTML: { __html: r },
        ...s
      }
    ) : /* @__PURE__ */ l.jsx(
      p,
      {
        className: f,
        ref: a || t,
        "data-testid": "rich-text",
        ...s,
        children: r
      }
    );
  }
);
le.displayName = "RichText";
const FN = "_container_1r8n0_209", BN = "_contained_1r8n0_219", VN = "_padded_1r8n0_224", Tr = {
  container: FN,
  "contained-small": "_contained-small_1r8n0_219",
  contained: BN,
  "contained-large": "_contained-large_1r8n0_221",
  padded: VN,
  "vertical-spacing": "_vertical-spacing_1r8n0_241"
}, HN = De(Tr.container, {
  variants: {
    variant: me({
      full: "",
      containedSmall: Tr["contained-small"],
      contained: Tr.contained,
      containedLarge: Tr["contained-large"]
    }),
    isPadded: me({
      true: Tr.padded,
      false: ""
    }),
    verticalSpacing: me({
      true: Tr["vertical-spacing"],
      false: ""
    })
  }
}), qN = !1, WN = "contained", UN = "div", xe = (e) => {
  const {
    className: t,
    variant: n = WN,
    tag: r = UN,
    verticalSpacing: a = qN,
    isPadded: i = !0,
    backgroundColor: s,
    children: o,
    asChild: c = !1,
    customRef: d,
    ...u
  } = e, f = c ? lt : r;
  return /* @__PURE__ */ l.jsx(ur, { backgroundColor: s, children: /* @__PURE__ */ l.jsx(
    f,
    {
      ref: d,
      className: z(
        HN({
          variant: n,
          isPadded: i,
          verticalSpacing: a
        }),
        t
      ),
      "data-testid": "container",
      ...u,
      children: o
    }
  ) });
}, V = {
  "column-grid": "_column-grid_6qve9_209",
  "row-gap-even": "_row-gap-even_6qve9_230",
  "row-gap-none": "_row-gap-none_6qve9_233",
  "center-orphans": "_center-orphans_6qve9_236",
  "reverse-tablet": "_reverse-tablet_6qve9_240",
  "reverse-tablet-lg": "_reverse-tablet-lg_6qve9_246",
  "reverse-desktop": "_reverse-desktop_6qve9_252",
  "cols-1": "_cols-1_6qve9_260",
  "cols-2": "_cols-2_6qve9_263",
  "cols-3": "_cols-3_6qve9_266",
  "cols-4": "_cols-4_6qve9_269",
  "cols-tablet-1": "_cols-tablet-1_6qve9_276",
  "cols-tablet-2": "_cols-tablet-2_6qve9_282",
  "cols-tablet-3": "_cols-tablet-3_6qve9_288",
  "cols-tablet-4": "_cols-tablet-4_6qve9_294",
  "cols-tablet-lg-1": "_cols-tablet-lg-1_6qve9_299",
  "cols-tablet-lg-2": "_cols-tablet-lg-2_6qve9_302",
  "cols-tablet-lg-3": "_cols-tablet-lg-3_6qve9_305",
  "cols-tablet-lg-4": "_cols-tablet-lg-4_6qve9_308",
  "cols-tablet-lg-5": "_cols-tablet-lg-5_6qve9_311",
  "cols-tablet-lg-6": "_cols-tablet-lg-6_6qve9_314",
  "cols-desktop-1": "_cols-desktop-1_6qve9_319",
  "cols-desktop-2": "_cols-desktop-2_6qve9_322",
  "cols-desktop-3": "_cols-desktop-3_6qve9_325",
  "cols-desktop-4": "_cols-desktop-4_6qve9_328",
  "cols-desktop-5": "_cols-desktop-5_6qve9_331",
  "cols-desktop-6": "_cols-desktop-6_6qve9_334",
  "col-1-4": "_col-1-4_6qve9_351",
  "col-2-4": "_col-2-4_6qve9_359",
  "col-3-4": "_col-3-4_6qve9_367",
  "col-4-4": "_col-4-4_6qve9_375",
  "col-tablet-1-12": "_col-tablet-1-12_6qve9_384",
  "col-tablet-2-12": "_col-tablet-2-12_6qve9_387",
  "col-tablet-3-12": "_col-tablet-3-12_6qve9_390",
  "col-tablet-4-12": "_col-tablet-4-12_6qve9_393",
  "col-tablet-5-12": "_col-tablet-5-12_6qve9_396",
  "col-tablet-6-12": "_col-tablet-6-12_6qve9_399",
  "col-tablet-7-12": "_col-tablet-7-12_6qve9_402",
  "col-tablet-8-12": "_col-tablet-8-12_6qve9_405",
  "col-tablet-9-12": "_col-tablet-9-12_6qve9_408",
  "col-tablet-10-12": "_col-tablet-10-12_6qve9_411",
  "col-tablet-11-12": "_col-tablet-11-12_6qve9_414",
  "col-tablet-12-12": "_col-tablet-12-12_6qve9_417",
  "col-tablet-lg-1-12": "_col-tablet-lg-1-12_6qve9_422",
  "col-tablet-lg-2-12": "_col-tablet-lg-2-12_6qve9_425",
  "col-tablet-lg-3-12": "_col-tablet-lg-3-12_6qve9_428",
  "col-tablet-lg-4-12": "_col-tablet-lg-4-12_6qve9_431",
  "col-tablet-lg-5-12": "_col-tablet-lg-5-12_6qve9_434",
  "col-tablet-lg-6-12": "_col-tablet-lg-6-12_6qve9_437",
  "col-tablet-lg-7-12": "_col-tablet-lg-7-12_6qve9_440",
  "col-tablet-lg-8-12": "_col-tablet-lg-8-12_6qve9_443",
  "col-tablet-lg-9-12": "_col-tablet-lg-9-12_6qve9_446",
  "col-tablet-lg-10-12": "_col-tablet-lg-10-12_6qve9_449",
  "col-tablet-lg-11-12": "_col-tablet-lg-11-12_6qve9_452",
  "col-tablet-lg-12-12": "_col-tablet-lg-12-12_6qve9_455",
  "col-desktop-1-12": "_col-desktop-1-12_6qve9_460",
  "col-desktop-2-12": "_col-desktop-2-12_6qve9_463",
  "col-desktop-3-12": "_col-desktop-3-12_6qve9_466",
  "col-desktop-4-12": "_col-desktop-4-12_6qve9_469",
  "col-desktop-5-12": "_col-desktop-5-12_6qve9_472",
  "col-desktop-6-12": "_col-desktop-6-12_6qve9_475",
  "col-desktop-7-12": "_col-desktop-7-12_6qve9_478",
  "col-desktop-8-12": "_col-desktop-8-12_6qve9_481",
  "col-desktop-9-12": "_col-desktop-9-12_6qve9_484",
  "col-desktop-10-12": "_col-desktop-10-12_6qve9_487",
  "col-desktop-11-12": "_col-desktop-11-12_6qve9_490",
  "col-desktop-12-12": "_col-desktop-12-12_6qve9_493",
  "col-offset-1-4": "_col-offset-1-4_6qve9_511",
  "col-offset-2-4": "_col-offset-2-4_6qve9_519",
  "col-offset-3-4": "_col-offset-3-4_6qve9_527",
  "col-offset-4-4": "_col-offset-4-4_6qve9_535",
  "col-offset-tablet-0-12": "_col-offset-tablet-0-12_6qve9_544",
  "col-offset-tablet-1-12": "_col-offset-tablet-1-12_6qve9_547",
  "col-offset-tablet-2-12": "_col-offset-tablet-2-12_6qve9_550",
  "col-offset-tablet-3-12": "_col-offset-tablet-3-12_6qve9_553",
  "col-offset-tablet-4-12": "_col-offset-tablet-4-12_6qve9_556",
  "col-offset-tablet-5-12": "_col-offset-tablet-5-12_6qve9_559",
  "col-offset-tablet-6-12": "_col-offset-tablet-6-12_6qve9_562",
  "col-offset-tablet-7-12": "_col-offset-tablet-7-12_6qve9_565",
  "col-offset-tablet-8-12": "_col-offset-tablet-8-12_6qve9_568",
  "col-offset-tablet-9-12": "_col-offset-tablet-9-12_6qve9_571",
  "col-offset-tablet-10-12": "_col-offset-tablet-10-12_6qve9_574",
  "col-offset-tablet-11-12": "_col-offset-tablet-11-12_6qve9_577",
  "col-offset-tablet-12-12": "_col-offset-tablet-12-12_6qve9_580",
  "col-offset-tablet-lg-0-12": "_col-offset-tablet-lg-0-12_6qve9_585",
  "col-offset-tablet-lg-1-12": "_col-offset-tablet-lg-1-12_6qve9_588",
  "col-offset-tablet-lg-2-12": "_col-offset-tablet-lg-2-12_6qve9_591",
  "col-offset-tablet-lg-3-12": "_col-offset-tablet-lg-3-12_6qve9_594",
  "col-offset-tablet-lg-4-12": "_col-offset-tablet-lg-4-12_6qve9_597",
  "col-offset-tablet-lg-5-12": "_col-offset-tablet-lg-5-12_6qve9_600",
  "col-offset-tablet-lg-6-12": "_col-offset-tablet-lg-6-12_6qve9_603",
  "col-offset-tablet-lg-7-12": "_col-offset-tablet-lg-7-12_6qve9_606",
  "col-offset-tablet-lg-8-12": "_col-offset-tablet-lg-8-12_6qve9_609",
  "col-offset-tablet-lg-9-12": "_col-offset-tablet-lg-9-12_6qve9_612",
  "col-offset-tablet-lg-10-12": "_col-offset-tablet-lg-10-12_6qve9_615",
  "col-offset-tablet-lg-11-12": "_col-offset-tablet-lg-11-12_6qve9_618",
  "col-offset-tablet-lg-12-12": "_col-offset-tablet-lg-12-12_6qve9_621",
  "col-offset-desktop-0-12": "_col-offset-desktop-0-12_6qve9_626",
  "col-offset-desktop-1-12": "_col-offset-desktop-1-12_6qve9_629",
  "col-offset-desktop-2-12": "_col-offset-desktop-2-12_6qve9_632",
  "col-offset-desktop-3-12": "_col-offset-desktop-3-12_6qve9_635",
  "col-offset-desktop-4-12": "_col-offset-desktop-4-12_6qve9_638",
  "col-offset-desktop-5-12": "_col-offset-desktop-5-12_6qve9_641",
  "col-offset-desktop-6-12": "_col-offset-desktop-6-12_6qve9_644",
  "col-offset-desktop-7-12": "_col-offset-desktop-7-12_6qve9_647",
  "col-offset-desktop-8-12": "_col-offset-desktop-8-12_6qve9_650",
  "col-offset-desktop-9-12": "_col-offset-desktop-9-12_6qve9_653",
  "col-offset-desktop-10-12": "_col-offset-desktop-10-12_6qve9_656",
  "col-offset-desktop-11-12": "_col-offset-desktop-11-12_6qve9_659",
  "col-offset-desktop-12-12": "_col-offset-desktop-12-12_6qve9_662"
}, GN = De(V["column-grid"], {
  variants: {
    rowGap: me({
      even: V["row-gap-even"],
      none: V["row-gap-none"],
      standard: ""
    }),
    centerOrphans: me({
      true: V["center-orphans"],
      false: ""
    }),
    columns: me({
      1: V["cols-1"],
      2: V["cols-2"],
      3: V["cols-3"],
      4: V["cols-4"]
    }),
    columnsTablet: me({
      1: V["cols-tablet-1"],
      2: V["cols-tablet-2"],
      3: V["cols-tablet-3"],
      4: V["cols-tablet-4"]
    }),
    columnsTabletLg: me({
      1: V["cols-tablet-lg-1"],
      2: V["cols-tablet-lg-2"],
      3: V["cols-tablet-lg-3"],
      4: V["cols-tablet-lg-4"],
      5: V["cols-tablet-lg-5"],
      6: V["cols-tablet-lg-6"]
    }),
    columnsDesktop: me({
      1: V["cols-desktop-1"],
      2: V["cols-desktop-2"],
      3: V["cols-desktop-3"],
      4: V["cols-desktop-4"],
      5: V["cols-desktop-5"],
      6: V["cols-desktop-6"]
    }),
    reverse: me({
      tablet: V["reverse-tablet"],
      tabletLg: V["reverse-tablet-lg"],
      desktop: V["reverse-desktop"]
    })
  }
}), YN = De("", {
  variants: {
    span: me({
      1: V["col-1-4"],
      2: V["col-2-4"],
      3: V["col-3-4"],
      4: V["col-4-4"]
    }),
    spanTablet: me({
      1: V["col-tablet-1-12"],
      2: V["col-tablet-2-12"],
      3: V["col-tablet-3-12"],
      4: V["col-tablet-4-12"],
      5: V["col-tablet-5-12"],
      6: V["col-tablet-6-12"],
      7: V["col-tablet-7-12"],
      8: V["col-tablet-8-12"],
      9: V["col-tablet-9-12"],
      10: V["col-tablet-10-12"],
      11: V["col-tablet-11-12"],
      12: V["col-tablet-12-12"]
    }),
    spanTabletLg: me({
      1: V["col-tablet-lg-1-12"],
      2: V["col-tablet-lg-2-12"],
      3: V["col-tablet-lg-3-12"],
      4: V["col-tablet-lg-4-12"],
      5: V["col-tablet-lg-5-12"],
      6: V["col-tablet-lg-6-12"],
      7: V["col-tablet-lg-7-12"],
      8: V["col-tablet-lg-8-12"],
      9: V["col-tablet-lg-9-12"],
      10: V["col-tablet-lg-10-12"],
      11: V["col-tablet-lg-11-12"],
      12: V["col-tablet-lg-12-12"]
    }),
    spanDesktop: me({
      1: V["col-desktop-1-12"],
      2: V["col-desktop-2-12"],
      3: V["col-desktop-3-12"],
      4: V["col-desktop-4-12"],
      5: V["col-desktop-5-12"],
      6: V["col-desktop-6-12"],
      7: V["col-desktop-7-12"],
      8: V["col-desktop-8-12"],
      9: V["col-desktop-9-12"],
      10: V["col-desktop-10-12"],
      11: V["col-desktop-11-12"],
      12: V["col-desktop-12-12"]
    }),
    offset: me({
      1: V["col-offset-1-4"],
      2: V["col-offset-2-4"],
      3: V["col-offset-3-4"],
      4: V["col-offset-4-4"]
    }),
    offsetTablet: me({
      0: V["col-offset-tablet-0-12"],
      1: V["col-offset-tablet-1-12"],
      2: V["col-offset-tablet-2-12"],
      3: V["col-offset-tablet-3-12"],
      4: V["col-offset-tablet-4-12"],
      5: V["col-offset-tablet-5-12"],
      6: V["col-offset-tablet-6-12"],
      7: V["col-offset-tablet-7-12"],
      8: V["col-offset-tablet-8-12"],
      9: V["col-offset-tablet-9-12"],
      10: V["col-offset-tablet-10-12"],
      11: V["col-offset-tablet-11-12"],
      12: V["col-offset-tablet-12-12"]
    }),
    offsetTabletLg: me({
      0: V["col-offset-tablet-lg-0-12"],
      1: V["col-offset-tablet-lg-1-12"],
      2: V["col-offset-tablet-lg-2-12"],
      3: V["col-offset-tablet-lg-3-12"],
      4: V["col-offset-tablet-lg-4-12"],
      5: V["col-offset-tablet-lg-5-12"],
      6: V["col-offset-tablet-lg-6-12"],
      7: V["col-offset-tablet-lg-7-12"],
      8: V["col-offset-tablet-lg-8-12"],
      9: V["col-offset-tablet-lg-9-12"],
      10: V["col-offset-tablet-lg-10-12"],
      11: V["col-offset-tablet-lg-11-12"],
      12: V["col-offset-tablet-lg-12-12"]
    }),
    offsetDesktop: me({
      0: V["col-offset-desktop-0-12"],
      1: V["col-offset-desktop-1-12"],
      2: V["col-offset-desktop-2-12"],
      3: V["col-offset-desktop-3-12"],
      4: V["col-offset-desktop-4-12"],
      5: V["col-offset-desktop-5-12"],
      6: V["col-offset-desktop-6-12"],
      7: V["col-offset-desktop-7-12"],
      8: V["col-offset-desktop-8-12"],
      9: V["col-offset-desktop-9-12"],
      10: V["col-offset-desktop-10-12"],
      11: V["col-offset-desktop-11-12"],
      12: V["col-offset-desktop-12-12"]
    })
  }
}), ck = ["standard", "even", "none"], lk = [
  hv,
  gv,
  vv
], Rn = (e) => {
  const {
    className: t,
    children: n,
    span: r = "1",
    spanTablet: a,
    spanTabletLg: i,
    spanDesktop: s,
    offset: o,
    offsetTablet: c,
    offsetTabletLg: d,
    offsetDesktop: u,
    ...f
  } = e;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: z(
        YN({
          span: r,
          spanTablet: a,
          spanTabletLg: i,
          spanDesktop: s,
          offset: o,
          offsetTablet: c,
          offsetTabletLg: d,
          offsetDesktop: u
        }),
        t
      ),
      "data-testid": "column",
      ...f,
      children: n
    }
  );
};
Rn.displayName = "Column";
const rt = K(
  (e, t) => {
    const {
      className: n,
      children: r,
      columns: a,
      columnsTablet: i,
      columnsTabletLg: s,
      columnsDesktop: o,
      centerOrphans: c,
      rowGap: d = "standard",
      reverse: u,
      ...f
    } = e;
    return /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: t,
        "data-testid": "column-grid",
        "data-column-grid": !0,
        className: z(
          GN({
            columns: a,
            columnsTablet: i,
            columnsTabletLg: s,
            columnsDesktop: o,
            centerOrphans: c,
            rowGap: d,
            reverse: u
          }),
          n
        ),
        ...f,
        children: r
      }
    );
  }
);
rt.displayName = "ColumnGrid";
const kn = {
  "tabbed-container": "_tabbed-container_13y4t_209",
  "has-shadow": "_has-shadow_13y4t_212",
  "tabs-base": "_tabs-base_13y4t_218",
  "tab-trigger": "_tab-trigger_13y4t_218",
  "tab-content": "_tab-content_13y4t_235",
  "tab-list": "_tab-list_13y4t_240",
  "small-text": "_small-text_13y4t_244",
  "large-text": "_large-text_13y4t_265"
}, KN = De([kn["tabs-base"]], {
  variants: {
    size: me({
      small: kn["small-text"],
      large: kn["large-text"]
    })
  }
}), XN = "small", dk = (e) => {
  const { className: t, size: n, hasShadow: r = !1, children: a, ...i } = e;
  return /* @__PURE__ */ l.jsx(xe, { className: kn["tabbed-container"], children: /* @__PURE__ */ l.jsx(
    tm,
    {
      className: t,
      ...i,
      children: /* @__PURE__ */ l.jsx(
        LE,
        {
          condition: r,
          wrapper: (s) => /* @__PURE__ */ l.jsx("div", { className: kn["has-shadow"], children: s }),
          children: an.map(
            a,
            (s) => an.map(
              s.props.children,
              (o) => Te(o, { size: n })
            )
          )
        }
      )
    }
  ) });
}, ZN = K((e, t) => {
  const { className: n, color: r, size: a = XN, ...i } = e;
  return /* @__PURE__ */ l.jsx(
    nm,
    {
      "data-testid": "tab-list",
      "data-accent-color": r,
      asChild: !1,
      ref: t,
      className: z(kn["tab-list"], KN({ size: a }), n),
      ...i
    }
  );
});
ZN.displayName = "Tabs.List";
const QN = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    rm,
    {
      "data-testid": "tab-trigger",
      ...a,
      asChild: !1,
      ref: t,
      className: z(kn["tab-trigger"], n),
      children: r
    }
  );
});
QN.displayName = "Tabs.Trigger";
const JN = K(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  C3,
  {
    "data-testid": "tab-content",
    ref: n,
    className: z(kn["tab-content"], e),
    ...t
  }
));
JN.displayName = C3.displayName;
const ez = {
  "picture-base": "_picture-base_n5pay_209"
}, ac = (e) => {
  const {
    className: t = "",
    sources: n = [],
    image: r = { src: "", alt: "" },
    ...a
  } = "sources" in e ? e : {}, i = z(ez["picture-base"], t);
  if (n != null && n.length)
    return /* @__PURE__ */ l.jsxs(
      "picture",
      {
        className: i,
        "data-testid": "picture-element",
        children: [
          n.map((s, o) => {
            const { media: c, srcset: d } = s, u = [];
            return d.map((f) => {
              const { path: p, descriptor: h } = f;
              u.push(`${p} ${h ?? ""}`.trim());
            }), /* @__PURE__ */ l.jsx(
              "source",
              {
                "data-testid": "picture-source",
                srcSet: u.join(", "),
                media: c
              },
              o
            );
          }),
          /* @__PURE__ */ l.jsx(
            "img",
            {
              src: r.src,
              alt: r.alt,
              "data-testid": "picture-image",
              ...a
            }
          )
        ]
      }
    );
  {
    const {
      desktopLgSrc: s,
      tabletLgSrc: o,
      tabletSrc: c,
      image: d,
      mobileSrc: u,
      ...f
    } = e;
    return /* @__PURE__ */ l.jsxs("picture", { className: i, children: [
      s && /* @__PURE__ */ l.jsx(
        "source",
        {
          media: `(min-width: ${xv})`,
          srcSet: s
        }
      ),
      /* @__PURE__ */ l.jsx(
        "source",
        {
          media: `(min-width: ${yv})`,
          srcSet: d.src
        }
      ),
      o && /* @__PURE__ */ l.jsx(
        "source",
        {
          media: `(min-width: ${bv})`,
          srcSet: o
        }
      ),
      c && /* @__PURE__ */ l.jsx(
        "source",
        {
          media: `(min-width: ${Sl})`,
          srcSet: c
        }
      ),
      u && /* @__PURE__ */ l.jsx(
        "source",
        {
          media: `(max-width: ${Sl})`,
          srcSet: u
        }
      ),
      /* @__PURE__ */ l.jsx(
        "img",
        {
          src: d.src,
          alt: d.alt,
          "data-testid": "picture-image",
          ...f
        }
      )
    ] });
  }
};
function tz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Lt(e);
  ve(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const to = "dismissableLayer.update", nz = "dismissableLayer.pointerDownOutside", rz = "dismissableLayer.focusOutside";
let g2;
const az = /* @__PURE__ */ on({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), iz = /* @__PURE__ */ K((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: s, onInteractOutside: o, onDismiss: c, ...d } = e, u = Et(az), [f, p] = ne(null), h = (n = f == null ? void 0 : f.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, g] = ne({}), v = Rt(
    t,
    (S) => p(S)
  ), x = Array.from(u.layers), [m] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), b = x.indexOf(m), _ = f ? x.indexOf(f) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, w = _ >= b, N = sz((S) => {
    const T = S.target, j = [
      ...u.branches
    ].some(
      (D) => D.contains(T)
    );
    !w || j || (i == null || i(S), o == null || o(S), S.defaultPrevented || c == null || c());
  }, h), M = oz((S) => {
    const T = S.target;
    [
      ...u.branches
    ].some(
      (D) => D.contains(T)
    ) || (s == null || s(S), o == null || o(S), S.defaultPrevented || c == null || c());
  }, h);
  return tz((S) => {
    _ === u.layers.size - 1 && (a == null || a(S), !S.defaultPrevented && c && (S.preventDefault(), c()));
  }, h), ve(() => {
    if (f)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (g2 = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(f)), u.layers.add(f), v2(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = g2);
      };
  }, [
    f,
    h,
    r,
    u
  ]), ve(() => () => {
    f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), v2());
  }, [
    f,
    u
  ]), ve(() => {
    const S = () => g({});
    return document.addEventListener(to, S), () => document.removeEventListener(to, S);
  }, []), /* @__PURE__ */ ge(ot.div, Ne({}, d, {
    ref: v,
    style: {
      pointerEvents: C ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Ke(e.onFocusCapture, M.onFocusCapture),
    onBlurCapture: Ke(e.onBlurCapture, M.onBlurCapture),
    onPointerDownCapture: Ke(e.onPointerDownCapture, N.onPointerDownCapture)
  }));
});
function sz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Lt(e), r = pe(!1), a = pe(() => {
  });
  return ve(() => {
    const i = (o) => {
      if (o.target && !r.current) {
        let d = function() {
          W6(nz, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: o
        };
        o.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = d, t.addEventListener("click", a.current, {
          once: !0
        })) : d();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function oz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Lt(e), r = pe(!1);
  return ve(() => {
    const a = (i) => {
      i.target && !r.current && W6(rz, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function v2() {
  const e = new CustomEvent(to);
  document.dispatchEvent(e);
}
function W6(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), r ? t8(a, i) : a.dispatchEvent(i);
}
function cz(e) {
  const t = pe({
    value: e,
    previous: e
  });
  return zt(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const Aa = "NavigationMenu", [ic, U6, lz] = oo(Aa), [no, dz, uz] = oo(Aa), [sc, uk] = Di(Aa, [
  lz,
  uz
]), [fz, Ft] = sc(Aa), [pz, mz] = sc(Aa), hz = /* @__PURE__ */ K((e, t) => {
  const { __scopeNavigationMenu: n, value: r, onValueChange: a, defaultValue: i, delayDuration: s = 200, skipDelayDuration: o = 300, orientation: c = "horizontal", dir: d, ...u } = e, [f, p] = ne(null), h = Rt(
    t,
    (T) => p(T)
  ), g = P2(d), v = pe(0), x = pe(0), m = pe(0), [b, _] = ne(!0), [C = "", w] = Fi({
    prop: r,
    onChange: (T) => {
      const j = T !== "", D = o > 0;
      j ? (window.clearTimeout(m.current), D && _(!1)) : (window.clearTimeout(m.current), m.current = window.setTimeout(
        () => _(!0),
        o
      )), a == null || a(T);
    },
    defaultProp: i
  }), N = ft(() => {
    window.clearTimeout(x.current), x.current = window.setTimeout(
      () => w(""),
      150
    );
  }, [
    w
  ]), M = ft((T) => {
    window.clearTimeout(x.current), w(T);
  }, [
    w
  ]), S = ft((T) => {
    C === T ? window.clearTimeout(x.current) : v.current = window.setTimeout(() => {
      window.clearTimeout(x.current), w(T);
    }, s);
  }, [
    C,
    w,
    s
  ]);
  return ve(() => () => {
    window.clearTimeout(v.current), window.clearTimeout(x.current), window.clearTimeout(m.current);
  }, []), /* @__PURE__ */ ge(gz, {
    scope: n,
    isRootMenu: !0,
    value: C,
    dir: g,
    orientation: c,
    rootNavigationMenu: f,
    onTriggerEnter: (T) => {
      window.clearTimeout(v.current), b ? S(T) : M(T);
    },
    onTriggerLeave: () => {
      window.clearTimeout(v.current), N();
    },
    onContentEnter: () => window.clearTimeout(x.current),
    onContentLeave: N,
    onItemSelect: (T) => {
      w(
        (j) => j === T ? "" : T
      );
    },
    onItemDismiss: () => w("")
  }, /* @__PURE__ */ ge(ot.nav, Ne({
    "aria-label": "Main",
    "data-orientation": c,
    dir: g
  }, u, {
    ref: h
  })));
}), gz = (e) => {
  const { scope: t, isRootMenu: n, rootNavigationMenu: r, dir: a, orientation: i, children: s, value: o, onItemSelect: c, onItemDismiss: d, onTriggerEnter: u, onTriggerLeave: f, onContentEnter: p, onContentLeave: h } = e, [g, v] = ne(null), [x, m] = ne(/* @__PURE__ */ new Map()), [b, _] = ne(null);
  return /* @__PURE__ */ ge(fz, {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: r,
    value: o,
    previousValue: cz(o),
    baseId: Bi(),
    dir: a,
    orientation: i,
    viewport: g,
    onViewportChange: v,
    indicatorTrack: b,
    onIndicatorTrackChange: _,
    onTriggerEnter: Lt(u),
    onTriggerLeave: Lt(f),
    onContentEnter: Lt(p),
    onContentLeave: Lt(h),
    onItemSelect: Lt(c),
    onItemDismiss: Lt(d),
    onViewportContentChange: ft((C, w) => {
      m((N) => (N.set(C, w), new Map(N)));
    }, []),
    onViewportContentRemove: ft((C) => {
      m((w) => w.has(C) ? (w.delete(C), new Map(w)) : w);
    }, [])
  }, /* @__PURE__ */ ge(ic.Provider, {
    scope: t
  }, /* @__PURE__ */ ge(pz, {
    scope: t,
    items: x
  }, s)));
}, vz = "NavigationMenuList", bz = /* @__PURE__ */ K((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, a = Ft(vz, n), i = /* @__PURE__ */ ge(ot.ul, Ne({
    "data-orientation": a.orientation
  }, r, {
    ref: t
  }));
  return /* @__PURE__ */ ge(ot.div, {
    style: {
      position: "relative"
    },
    ref: a.onIndicatorTrackChange
  }, /* @__PURE__ */ ge(ic.Slot, {
    scope: n
  }, a.isRootMenu ? /* @__PURE__ */ ge(Z6, {
    asChild: !0
  }, i) : i));
}), yz = "NavigationMenuItem", [xz, G6] = sc(yz), _z = /* @__PURE__ */ K((e, t) => {
  const { __scopeNavigationMenu: n, value: r, ...a } = e, i = Bi(), s = r || i || "LEGACY_REACT_AUTO_VALUE", o = pe(null), c = pe(null), d = pe(null), u = pe(() => {
  }), f = pe(!1), p = ft((g = "start") => {
    if (o.current) {
      u.current();
      const v = ro(o.current);
      v.length && oc(g === "start" ? v : v.reverse());
    }
  }, []), h = ft(() => {
    if (o.current) {
      const g = ro(o.current);
      g.length && (u.current = jz(g));
    }
  }, []);
  return /* @__PURE__ */ ge(xz, {
    scope: n,
    value: s,
    triggerRef: c,
    contentRef: o,
    focusProxyRef: d,
    wasEscapeCloseRef: f,
    onEntryKeyDown: p,
    onFocusProxyEnter: p,
    onRootContentClose: h,
    onContentFocusOutside: h
  }, /* @__PURE__ */ ge(ot.li, Ne({}, a, {
    ref: t
  })));
}), b2 = "NavigationMenuTrigger", wz = /* @__PURE__ */ K((e, t) => {
  const { __scopeNavigationMenu: n, disabled: r, ...a } = e, i = Ft(b2, e.__scopeNavigationMenu), s = G6(b2, e.__scopeNavigationMenu), o = pe(null), c = Rt(o, s.triggerRef, t), d = Q6(i.baseId, s.value), u = J6(i.baseId, s.value), f = pe(!1), p = pe(!1), h = s.value === i.value;
  return /* @__PURE__ */ ge(Z1, null, /* @__PURE__ */ ge(ic.ItemSlot, {
    scope: n,
    value: s.value
  }, /* @__PURE__ */ ge(kz, {
    asChild: !0
  }, /* @__PURE__ */ ge(ot.button, Ne({
    id: d,
    disabled: r,
    "data-disabled": r ? "" : void 0,
    "data-state": cc(h),
    "aria-expanded": h,
    "aria-controls": u
  }, a, {
    ref: c,
    onPointerEnter: Ke(e.onPointerEnter, () => {
      p.current = !1, s.wasEscapeCloseRef.current = !1;
    }),
    onPointerMove: Ke(e.onPointerMove, Ii(() => {
      r || p.current || s.wasEscapeCloseRef.current || f.current || (i.onTriggerEnter(s.value), f.current = !0);
    })),
    onPointerLeave: Ke(e.onPointerLeave, Ii(() => {
      r || (i.onTriggerLeave(), f.current = !1);
    })),
    onClick: Ke(e.onClick, () => {
      i.onItemSelect(s.value), p.current = h;
    }),
    onKeyDown: Ke(e.onKeyDown, (g) => {
      const x = {
        horizontal: "ArrowDown",
        vertical: i.dir === "rtl" ? "ArrowLeft" : "ArrowRight"
      }[i.orientation];
      h && g.key === x && (s.onEntryKeyDown(), g.preventDefault());
    })
  })))), h && /* @__PURE__ */ ge(Z1, null, /* @__PURE__ */ ge(am, {
    "aria-hidden": !0,
    tabIndex: 0,
    ref: s.focusProxyRef,
    onFocus: (g) => {
      const v = s.contentRef.current, x = g.relatedTarget, m = x === o.current, b = v == null ? void 0 : v.contains(x);
      (m || !b) && s.onFocusProxyEnter(m ? "start" : "end");
    }
  }), i.viewport && /* @__PURE__ */ ge("span", {
    "aria-owns": u
  })));
}), Y6 = "NavigationMenuIndicator", Cz = /* @__PURE__ */ K((e, t) => {
  const { forceMount: n, ...r } = e, a = Ft(Y6, e.__scopeNavigationMenu), i = !!a.value;
  return a.indicatorTrack ? /* @__PURE__ */ C2.createPortal(/* @__PURE__ */ ge(Wr, {
    present: n || i
  }, /* @__PURE__ */ ge(Sz, Ne({}, r, {
    ref: t
  }))), a.indicatorTrack) : null;
}), Sz = /* @__PURE__ */ K((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, a = Ft(Y6, n), i = U6(n), [s, o] = ne(null), [c, d] = ne(null), u = a.orientation === "horizontal", f = !!a.value;
  ve(() => {
    var h;
    const v = (h = i().find(
      (x) => x.value === a.value
    )) === null || h === void 0 ? void 0 : h.ref.current;
    v && o(v);
  }, [
    i,
    a.value
  ]);
  const p = () => {
    s && d({
      size: u ? s.offsetWidth : s.offsetHeight,
      offset: u ? s.offsetLeft : s.offsetTop
    });
  };
  return ao(s, p), ao(a.indicatorTrack, p), c ? /* @__PURE__ */ ge(ot.div, Ne({
    "aria-hidden": !0,
    "data-state": f ? "visible" : "hidden",
    "data-orientation": a.orientation
  }, r, {
    ref: t,
    style: {
      position: "absolute",
      ...u ? {
        left: 0,
        width: c.size + "px",
        transform: `translateX(${c.offset}px)`
      } : {
        top: 0,
        height: c.size + "px",
        transform: `translateY(${c.offset}px)`
      },
      ...r.style
    }
  })) : null;
}), La = "NavigationMenuContent", Lz = /* @__PURE__ */ K((e, t) => {
  const { forceMount: n, ...r } = e, a = Ft(La, e.__scopeNavigationMenu), i = G6(La, e.__scopeNavigationMenu), s = Rt(i.contentRef, t), o = i.value === a.value, c = {
    value: i.value,
    triggerRef: i.triggerRef,
    focusProxyRef: i.focusProxyRef,
    wasEscapeCloseRef: i.wasEscapeCloseRef,
    onContentFocusOutside: i.onContentFocusOutside,
    onRootContentClose: i.onRootContentClose,
    ...r
  };
  return a.viewport ? /* @__PURE__ */ ge(Mz, Ne({
    forceMount: n
  }, c, {
    ref: s
  })) : /* @__PURE__ */ ge(Wr, {
    present: n || o
  }, /* @__PURE__ */ ge(K6, Ne({
    "data-state": cc(o)
  }, c, {
    ref: s,
    onPointerEnter: Ke(e.onPointerEnter, a.onContentEnter),
    onPointerLeave: Ke(e.onPointerLeave, Ii(a.onContentLeave)),
    style: {
      // Prevent interaction when animating out
      pointerEvents: !o && a.isRootMenu ? "none" : void 0,
      ...c.style
    }
  })));
}), Mz = /* @__PURE__ */ K((e, t) => {
  const n = Ft(La, e.__scopeNavigationMenu), { onViewportContentChange: r, onViewportContentRemove: a } = n;
  return rr(() => {
    r(e.value, {
      ref: t,
      ...e
    });
  }, [
    e,
    t,
    r
  ]), rr(() => () => a(e.value), [
    e.value,
    a
  ]), null;
}), K1 = "navigationMenu.rootContentDismiss", K6 = /* @__PURE__ */ K((e, t) => {
  const { __scopeNavigationMenu: n, value: r, triggerRef: a, focusProxyRef: i, wasEscapeCloseRef: s, onRootContentClose: o, onContentFocusOutside: c, ...d } = e, u = Ft(La, n), f = pe(null), p = Rt(f, t), h = Q6(u.baseId, r), g = J6(u.baseId, r), v = U6(n), x = pe(null), { onItemDismiss: m } = u;
  ve(() => {
    const _ = f.current;
    if (u.isRootMenu && _) {
      const C = () => {
        var w;
        m(), o(), _.contains(document.activeElement) && ((w = a.current) === null || w === void 0 || w.focus());
      };
      return _.addEventListener(K1, C), () => _.removeEventListener(K1, C);
    }
  }, [
    u.isRootMenu,
    e.value,
    a,
    m,
    o
  ]);
  const b = zt(() => {
    const C = v().map(
      (j) => j.value
    );
    u.dir === "rtl" && C.reverse();
    const w = C.indexOf(u.value), N = C.indexOf(u.previousValue), M = r === u.value, S = N === C.indexOf(r);
    if (!M && !S)
      return x.current;
    const T = (() => {
      if (w !== N) {
        if (M && N !== -1)
          return w > N ? "from-end" : "from-start";
        if (S && w !== -1)
          return w > N ? "to-start" : "to-end";
      }
      return null;
    })();
    return x.current = T, T;
  }, [
    u.previousValue,
    u.value,
    u.dir,
    v,
    r
  ]);
  return /* @__PURE__ */ ge(Z6, {
    asChild: !0
  }, /* @__PURE__ */ ge(iz, Ne({
    id: g,
    "aria-labelledby": h,
    "data-motion": b,
    "data-orientation": u.orientation
  }, d, {
    ref: p,
    onDismiss: () => {
      var _;
      const C = new Event(K1, {
        bubbles: !0,
        cancelable: !0
      });
      (_ = f.current) === null || _ === void 0 || _.dispatchEvent(C);
    },
    onFocusOutside: Ke(e.onFocusOutside, (_) => {
      var C;
      c();
      const w = _.target;
      (C = u.rootNavigationMenu) !== null && C !== void 0 && C.contains(w) && _.preventDefault();
    }),
    onPointerDownOutside: Ke(e.onPointerDownOutside, (_) => {
      var C;
      const w = _.target, N = v().some((S) => {
        var T;
        return (T = S.ref.current) === null || T === void 0 ? void 0 : T.contains(w);
      }), M = u.isRootMenu && ((C = u.viewport) === null || C === void 0 ? void 0 : C.contains(w));
      (N || M || !u.isRootMenu) && _.preventDefault();
    }),
    onKeyDown: Ke(e.onKeyDown, (_) => {
      const C = _.altKey || _.ctrlKey || _.metaKey;
      if (_.key === "Tab" && !C) {
        const M = ro(_.currentTarget), S = document.activeElement, T = M.findIndex(
          (A) => A === S
        ), D = _.shiftKey ? M.slice(0, T).reverse() : M.slice(T + 1, M.length);
        if (oc(D))
          _.preventDefault();
        else {
          var N;
          (N = i.current) === null || N === void 0 || N.focus();
        }
      }
    }),
    onEscapeKeyDown: Ke(e.onEscapeKeyDown, (_) => {
      s.current = !0;
    })
  })));
}), X6 = "NavigationMenuViewport", Nz = /* @__PURE__ */ K((e, t) => {
  const { forceMount: n, ...r } = e, i = !!Ft(X6, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ ge(Wr, {
    present: n || i
  }, /* @__PURE__ */ ge(zz, Ne({}, r, {
    ref: t
  })));
}), zz = /* @__PURE__ */ K((e, t) => {
  const { __scopeNavigationMenu: n, children: r, ...a } = e, i = Ft(X6, n), s = Rt(t, i.onViewportChange), o = mz(La, e.__scopeNavigationMenu), [c, d] = ne(null), [u, f] = ne(null), p = c ? (c == null ? void 0 : c.width) + "px" : void 0, h = c ? (c == null ? void 0 : c.height) + "px" : void 0, g = !!i.value, v = g ? i.value : i.previousValue;
  return ao(u, () => {
    u && d({
      width: u.offsetWidth,
      height: u.offsetHeight
    });
  }), /* @__PURE__ */ ge(ot.div, Ne({
    "data-state": cc(g),
    "data-orientation": i.orientation
  }, a, {
    ref: s,
    style: {
      // Prevent interaction when animating out
      pointerEvents: !g && i.isRootMenu ? "none" : void 0,
      "--radix-navigation-menu-viewport-width": p,
      "--radix-navigation-menu-viewport-height": h,
      ...a.style
    },
    onPointerEnter: Ke(e.onPointerEnter, i.onContentEnter),
    onPointerLeave: Ke(e.onPointerLeave, Ii(i.onContentLeave))
  }), Array.from(o.items).map(([m, { ref: b, forceMount: _, ...C }]) => {
    const w = v === m;
    return /* @__PURE__ */ ge(Wr, {
      key: m,
      present: _ || w
    }, /* @__PURE__ */ ge(K6, Ne({}, C, {
      ref: so(b, (N) => {
        w && N && f(N);
      })
    })));
  }));
}), Ez = "FocusGroup", Z6 = /* @__PURE__ */ K((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, a = Ft(Ez, n);
  return /* @__PURE__ */ ge(no.Provider, {
    scope: n
  }, /* @__PURE__ */ ge(no.Slot, {
    scope: n
  }, /* @__PURE__ */ ge(ot.div, Ne({
    dir: a.dir
  }, r, {
    ref: t
  }))));
}), y2 = [
  "ArrowRight",
  "ArrowLeft",
  "ArrowUp",
  "ArrowDown"
], Tz = "FocusGroupItem", kz = /* @__PURE__ */ K((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, a = dz(n), i = Ft(Tz, n);
  return /* @__PURE__ */ ge(no.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ ge(ot.button, Ne({}, r, {
    ref: t,
    onKeyDown: Ke(e.onKeyDown, (s) => {
      if ([
        "Home",
        "End",
        ...y2
      ].includes(s.key)) {
        let c = a().map(
          (f) => f.ref.current
        );
        if ([
          i.dir === "rtl" ? "ArrowRight" : "ArrowLeft",
          "ArrowUp",
          "End"
        ].includes(s.key) && c.reverse(), y2.includes(s.key)) {
          const f = c.indexOf(s.currentTarget);
          c = c.slice(f + 1);
        }
        setTimeout(
          () => oc(c)
        ), s.preventDefault();
      }
    })
  })));
});
function ro(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function oc(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function jz(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function ao(e, t) {
  const n = Lt(t);
  rr(() => {
    let r = 0;
    if (e) {
      const a = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return a.observe(e), () => {
        window.cancelAnimationFrame(r), a.unobserve(e);
      };
    }
  }, [
    e,
    n
  ]);
}
function cc(e) {
  return e ? "open" : "closed";
}
function Q6(e, t) {
  return `${e}-trigger-${t}`;
}
function J6(e, t) {
  return `${e}-content-${t}`;
}
function Ii(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const ed = hz, td = bz, Pz = _z, nd = wz, rd = Cz, ad = Lz, id = Nz, Ut = {
  "navigation-menu-base": "_navigation-menu-base_q1hs1_209",
  "navigation-menu-list": "_navigation-menu-list_q1hs1_215",
  "navigation-menu-trigger": "_navigation-menu-trigger_q1hs1_223",
  "navigation-menu-content": "_navigation-menu-content_q1hs1_233",
  "navigation-menu-item-link": "_navigation-menu-item-link_q1hs1_244"
}, Oi = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    ed,
    {
      className: z(Ut["navigation-menu-base"], n),
      "data-testid": "navigation-menu",
      ref: t,
      ...r
    }
  );
});
Oi.displayName = ed.displayName;
const a1 = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    td,
    {
      className: z(Ut["navigation-menu-list"], n),
      "data-testid": "navigation-menu-list",
      ref: t,
      ...r
    }
  );
});
a1.displayName = td.displayName;
const qt = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsx(
    Pz,
    {
      "data-testid": "navigation-menu-item",
      className: z(Ut["navigation-menu-item"], t),
      ...n
    }
  );
}, lc = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    nd,
    {
      "data-testid": "navigation-menu-trigger",
      ref: t,
      className: z(Ut["navigation-menu-trigger"], n),
      ...a,
      children: r
    }
  );
});
lc.displayName = nd.displayName;
const dc = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    ad,
    {
      className: z(Ut["navigation-menu-content"], n),
      "data-testid": "navigation-menu-content",
      ref: t,
      ...r
    }
  );
});
dc.displayName = ad.displayName;
const tr = K(
  (e, t) => {
    const { className: n, ...r } = e;
    return /* @__PURE__ */ l.jsx(
      X,
      {
        ref: t,
        className: z(Ut["navigation-menu-item-link"], n),
        ...r
      }
    );
  }
), Az = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: z(Ut["navigation-menu-viewport-wrapper"]),
      "data-tesid": "navigation-menu-viewport-wrapper",
      children: /* @__PURE__ */ l.jsx(
        id,
        {
          className: z(Ut["navigation-menu-viewport"], n),
          "data-testid": "navigation-menu-viewport",
          ref: t,
          ...r
        }
      )
    }
  );
});
Az.displayName = id.displayName;
const $z = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    rd,
    {
      className: z(Ut["navigation-menu-indicator"], n),
      "data-testid": "navigation-menu-indicator",
      ref: t,
      ...r,
      children: /* @__PURE__ */ l.jsx("div", { className: Ut["navigation-menu-indicator-inner"] })
    }
  );
});
$z.displayName = rd.displayName;
const Vt = {
  "sheet-overlay": "_sheet-overlay_gri6u_212",
  "sheet-content": "_sheet-content_gri6u_233",
  "side-top": "_side-top_gri6u_242",
  "side-left": "_side-left_gri6u_242",
  "side-bottom": "_side-bottom_gri6u_242",
  "side-right": "_side-right_gri6u_242",
  "sheet-header": "_sheet-header_gri6u_269",
  "sheet-close": "_sheet-close_gri6u_275"
}, Iz = De(Vt["sheet-content"], {
  variants: {
    direction: me({
      top: [Vt["side-top"]],
      bottom: [Vt["side-bottom"]],
      left: [Vt["side-left"]],
      right: [Vt["side-right"]]
    })
  },
  defaultVariants: {
    direction: "right"
  }
}), Oz = wp, x2 = Cp, Rz = Lp, Dz = Sp, sd = K(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  Q4,
  {
    className: z(Vt["sheet-overlay"], e),
    ...t,
    ref: n
  }
));
sd.displayName = Q4.displayName;
const od = K(({ direction: e = "right", className: t, children: n, ...r }, a) => /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
  J4,
  {
    ref: a,
    className: z(Iz({ direction: e }), t),
    ...r,
    children: n
  }
) }));
od.displayName = J4.displayName;
const cd = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: z(Vt["sheet-header"], e),
    ...t
  }
);
cd.displayName = "SheetHeader";
const Fz = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: z(Vt["sheet-footer"], e),
    ...t
  }
);
Fz.displayName = "SheetFooter";
const ld = K(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  e3,
  {
    ref: n,
    className: z(Vt["sheet-title"], e),
    ...t
  }
));
ld.displayName = e3.displayName;
const dd = K(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  t3,
  {
    ref: n,
    className: z(Vt["sheet-description"], e),
    ...t
  }
));
dd.displayName = t3.displayName;
const kt = {
  "drop-down-menu-base": "_drop-down-menu-base_1fe2s_209",
  "drop-down-menu-trigger": "_drop-down-menu-trigger_1fe2s_214",
  "drop-down-menu-list": "_drop-down-menu-list_1fe2s_261",
  "drop-down-menu-item": "_drop-down-menu-item_1fe2s_277",
  "drop-down-menu-label": "_drop-down-menu-label_1fe2s_285",
  "drop-down-menu-content": "_drop-down-menu-content_1fe2s_303",
  "drop-down-menu-sub-trigger": "_drop-down-menu-sub-trigger_1fe2s_340"
}, i1 = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsx(
    Fr,
    {
      collapsible: !0,
      type: "single",
      className: z(kt["drop-down-menu-base"], t),
      "data-testid": "dropDownMenu",
      ...n
    }
  );
}, ud = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsx(
    Fr,
    {
      className: z(kt["drop-down-menu-base"], t),
      "data-testid": "dropDownMenu",
      ...n
    }
  );
}, uc = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsx(
    Fr,
    {
      className: z(kt["drop-down-menu-base"], t),
      ...n
    }
  );
}, hn = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    mo,
    {
      "data-testid": "accordion-item",
      ref: t,
      className: z(kt["accordion-item"], n),
      ...r
    }
  );
});
hn.displayName = "AccordionItem";
const s1 = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    fr,
    {
      ref: t,
      "data-testid": "accordion-trigger",
      className: z(
        kt["accordion-trigger"],
        kt["drop-down-menu-trigger"],
        n
      ),
      ...a,
      children: r
    }
  );
});
s1.displayName = fr.displayName;
const fd = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsxs(
    fr,
    {
      ref: t,
      "data-testid": "accordion-trigger",
      className: z(
        kt["accordion-trigger"],
        kt["drop-down-menu-sub-trigger"],
        n
      ),
      ...a,
      children: [
        r,
        /* @__PURE__ */ l.jsx(re, { icon: "plus" }),
        /* @__PURE__ */ l.jsx(re, { icon: "minus" })
      ]
    }
  );
});
fd.displayName = fr.displayName;
const $a = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    Ur,
    {
      "data-testid": "accordion-content",
      ref: t,
      className: z(kt["drop-down-menu-content"], n),
      ...a,
      children: r
    }
  );
});
$a.displayName = Ur.displayName;
const Ia = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: t,
      className: z(kt["drop-down-menu-list"], n),
      "data-testid": "dropDownMenu-list",
      ...a,
      children: r
    }
  );
}), Ri = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: t,
      className: z(kt["drop-down-menu-item"], n),
      ...a,
      children: r
    }
  );
}), Bz = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: t,
      className: z(kt["drop-down-menu-label"], n),
      ...a,
      children: r
    }
  );
}), Vz = {
  "youtube-embed-base": "_youtube-embed-base_7xrup_209",
  "yt-player": "_yt-player_7xrup_218"
}, Hz = "https://www.youtube-nocookie.com", qz = "https://www.youtube.com/iframe_api", Wz = "?controls=1&modestbranding=1&rel=0&showinfo=0", o1 = (e) => {
  const { className: t, videoId: n, onReady: r, isActive: a, ...i } = e, s = (o) => `https://www.youtube-nocookie.com/embed/${o}${Wz}`;
  return ve(() => {
    var o;
    if (a && r && window !== void 0) {
      const c = (u) => {
        r(u.target);
      }, d = () => {
        new window.YT.Player(`youtube-player-${n}`, {
          events: {
            onReady: c
          },
          videoId: n,
          host: Hz,
          playerVars: {
            controls: 1,
            modestbranding: 1,
            rel: 0,
            showinfo: 0
          }
        });
      };
      if (window.YT && window.YT.Player)
        d();
      else {
        const u = document.createElement("script");
        u.src = qz;
        const f = document.getElementsByTagName("script")[0];
        (o = f == null ? void 0 : f.parentNode) == null || o.insertBefore(u, f), window.onYouTubeIframeAPIReady = d;
      }
    }
  }, [a, n, r]), /* @__PURE__ */ l.jsx(
    "div",
    {
      className: z(Vz["youtube-embed-base"], t),
      "data-testid": "youtube-embed",
      id: `youtube-player-${n}`,
      ...i,
      children: /* @__PURE__ */ l.jsx(
        "iframe",
        {
          src: s(n),
          allowFullScreen: !0,
          referrerPolicy: "strict-origin-when-cross-origin",
          title: "Embedded youtube"
        }
      )
    }
  );
}, Uz = "_headline_1vl9e_214", $r = {
  "column-cta": "_column-cta_1vl9e_209",
  "column-cta-center": "_column-cta-center_1vl9e_209",
  headline: Uz,
  "body-copy": "_body-copy_1vl9e_217",
  "anchor-wrapper": "_anchor-wrapper_1vl9e_220"
}, _2 = De($r["column-cta"], {
  variants: {
    textAlignment: me({
      left: "",
      center: $r["column-cta-center"]
    })
  }
}), fk = (e) => {
  const {
    className: t,
    headlineTag: n = "p",
    headline: r,
    bodyCopy: a,
    textAlignment: i = "left",
    extraCTA: s,
    ...o
  } = e;
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: z(
        _2({
          textAlignment: i
        }),
        t
      ),
      "data-testid": "column-cta",
      ...o,
      children: [
        /* @__PURE__ */ l.jsx(
          G,
          {
            tag: n,
            "data-testid": "column-cta-headline",
            className: $r.headline,
            children: r
          }
        ),
        /* @__PURE__ */ l.jsx(
          le,
          {
            className: $r["body-copy"],
            "data-testid": "column-cta-body-copy",
            children: a
          }
        ),
        s && /* @__PURE__ */ l.jsx(
          "div",
          {
            className: z(
              _2({ textAlignment: i }),
              $r["anchor-wrapper"]
            ),
            children: /* @__PURE__ */ l.jsx(
              X,
              {
                className: $r.anchor,
                variant: "solid1",
                size: "responsive",
                "data-testid": "column-cta-link",
                children: s
              }
            )
          }
        )
      ]
    }
  );
}, Gz = "_pagination_k40j1_232", Yz = "_dot_k40j1_250", Kz = "_inverse_k40j1_264", Zn = {
  "controls-absolute": "_controls-absolute_k40j1_209",
  "carousel-controls": "_carousel-controls_k40j1_218",
  pagination: Gz,
  dot: Yz,
  "dot-active": "_dot-active_k40j1_259",
  inverse: Kz
}, Xz = De(Zn["carousel-controls"], {
  variants: {
    isInverse: me({
      true: [Zn.inverse],
      false: ""
    })
  }
}), c1 = (e) => {
  const {
    backgroundColor: t,
    className: n,
    slideTimingSeconds: r = 6,
    slides: a = [],
    controlsClass: i,
    controlsPosition: s = "absolute",
    ...o
  } = e, [c, d] = ne(!1), [u, f] = ne(0), p = Hd().replaceAll(":", "-"), h = r * 1e3, g = pe(), v = pe(
    null
  ), x = (w) => {
    g.current && g.current.slides.forEach((M, S) => {
      const T = M.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      ), j = S === w ? "0" : "-1";
      T.forEach(
        (D) => D.setAttribute("tabindex", j)
      );
    });
  }, m = () => {
    if (g.current) {
      const { autoplay: w } = g.current;
      c ? (w.start(), d(!1)) : (w.stop(), d(!0));
    }
  }, b = () => {
    if (g.current) {
      const w = g.current.slides.length, N = g.current.activeIndex === 0 ? w - 1 : g.current.activeIndex - 1;
      g.current.slideTo(N), f(N), x(N);
    }
  }, _ = () => {
    if (g.current) {
      const w = g.current.slides.length, N = g.current.activeIndex === w - 1 ? 0 : g.current.activeIndex + 1;
      g.current.slideTo(N), f(N), x(N);
    }
  }, C = zt(() => {
    var N;
    const w = a[u];
    return hr(
      ((N = w == null ? void 0 : w.props) == null ? void 0 : N.backgroundColor) || t
    );
  }, [u, a, t]);
  return ve(() => {
    const w = () => {
      g.current && x(g.current.realIndex);
    };
    return g.current && g.current.on("slideChange", w), () => {
      g.current && g.current.off("slideChange", w);
    };
  }, []), ve(() => {
    g.current && x(u);
  }, [u]), ve(() => {
    const w = document.querySelector(".swiper-slide-active"), N = w == null ? void 0 : w.querySelectorAll(
      'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    ), M = N == null ? void 0 : N[N.length - 1], S = v.current, T = (j) => {
      j.key === "Tab" && !j.shiftKey && (j.preventDefault(), S == null || S.focus());
    };
    return M == null || M.addEventListener("keydown", T), () => {
      M == null || M.removeEventListener(
        "keydown",
        T
      );
    };
  }, []), /* @__PURE__ */ l.jsxs(
    zi,
    {
      className: n,
      modules: [Eh, Ts, Th, Ah, zh],
      effect: "fade",
      "data-testid": "carousel",
      slidesPerView: 1,
      loop: !0,
      pagination: {
        enabled: !0,
        clickable: !0,
        el: `.pagination-${p}`,
        renderBullet: () => `<button class="${Zn.dot}" type="button" title="slide navigation" />`,
        bulletClass: Zn.dot,
        bulletActiveClass: Zn["dot-active"]
      },
      autoHeight: !0,
      autoplay: {
        delay: h
      },
      onSwiper: (w) => {
        g.current = w, w.on("slideChange", () => {
          f(w.realIndex), x(w.realIndex);
        });
        const { autoplay: N, pagination: M } = w, S = () => {
          N && (N.stop(), d(!0));
        };
        if (M != null && M.bullets)
          return M.bullets.forEach((T) => {
            T.addEventListener("click", S);
          }), () => {
            M.bullets.forEach((T) => {
              T.removeEventListener(
                "click",
                S
              );
            });
          };
      },
      ...o,
      children: [
        a.map((w, N) => /* @__PURE__ */ l.jsx(
          Ei,
          {
            "data-testid": "carousel-slide",
            children: w
          },
          N
        )),
        !!(a != null && a.length) && /* @__PURE__ */ l.jsx(
          xe,
          {
            className: z({
              [Zn["controls-absolute"]]: s === "absolute"
            }),
            backgroundColor: t,
            children: /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsxs(
              "div",
              {
                className: z(
                  Xz({
                    isInverse: C
                  }),
                  i
                ),
                children: [
                  /* @__PURE__ */ l.jsx(
                    "button",
                    {
                      onClick: b,
                      title: "Previous slide",
                      ref: v,
                      type: "button",
                      "data-testid": "carousel-previous-slide-btn",
                      children: /* @__PURE__ */ l.jsx(re, { icon: "chevronLeftSharp" })
                    }
                  ),
                  /* @__PURE__ */ l.jsx(
                    "button",
                    {
                      onClick: m,
                      title: c ? "Play" : "Pause",
                      type: "button",
                      "data-testid": "carousel-pause-play-btn",
                      children: c ? /* @__PURE__ */ l.jsx(re, { icon: "play" }) : /* @__PURE__ */ l.jsx(re, { icon: "pause" })
                    }
                  ),
                  /* @__PURE__ */ l.jsx(
                    "div",
                    {
                      className: z(
                        `pagination-${p}`,
                        Zn.pagination
                      )
                    }
                  ),
                  /* @__PURE__ */ l.jsx(
                    "button",
                    {
                      onClick: _,
                      title: "Next slide",
                      type: "button",
                      "data-testid": "carousel-next-slide-btn",
                      children: /* @__PURE__ */ l.jsx(re, { icon: "chevronRightSharp" })
                    }
                  )
                ]
              }
            ) })
          }
        )
      ]
    }
  );
}, Zz = "_striped_xk4qq_230", Qz = "_sticky_xk4qq_239", Jz = "_left_xk4qq_266", eE = "_right_xk4qq_269", tE = "_center_xk4qq_272", Nt = {
  "table-wrapper": "_table-wrapper_xk4qq_209",
  "table-base": "_table-base_xk4qq_212",
  striped: Zz,
  sticky: Qz,
  "sticky-shadow": "_sticky-shadow_xk4qq_256",
  "table-cell-base": "_table-cell-base_xk4qq_266",
  left: Jz,
  right: eE,
  center: tE,
  "table-custom": "_table-custom_xk4qq_319"
}, nE = De(Nt["table-base"], {
  variants: {
    isStriped: me({
      true: Nt.striped,
      false: ""
    }),
    isSticky: me({
      true: Nt.sticky,
      false: ""
    }),
    tableStyle: me({
      standard: "",
      custom: Nt["table-custom"]
    })
  }
}), fc = De(Nt["table-cell-base"], {
  variants: {
    cellAlignment: me({
      default: "",
      left: Nt.left,
      right: Nt.right,
      center: Nt.center
    })
  }
}), pd = K((e, t) => {
  const {
    className: n,
    isStriped: r = !0,
    isSticky: a,
    tableStyle: i = "standard",
    ...s
  } = e, o = pe(null), [c, d] = ne(!1);
  return ve(() => {
    if (!window || !(o != null && o.current) || !a)
      return;
    const u = () => {
      var p, h;
      return (((p = o.current) == null ? void 0 : p.scrollWidth) || 0) > (((h = o.current) == null ? void 0 : h.clientWidth) || 0);
    };
    d(() => !!a && u());
    const f = dm(() => {
      d(() => !!a && u());
    }, 200);
    return window.addEventListener("resize", f), () => {
      window.removeEventListener("resize", f);
    };
  }, [a, o]), /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: o,
      className: z(Nt["table-wrapper"], n),
      children: /* @__PURE__ */ l.jsx(
        "table",
        {
          ref: t,
          className: z(
            Nt["table-base"],
            { [Nt["sticky-shadow"]]: c },
            nE({ isStriped: r, isSticky: a, tableStyle: i })
          ),
          "data-testid": "table",
          ...s
        }
      )
    }
  );
});
pd.displayName = "Table";
const rE = K(
  (e, t) => {
    const { cellAlignment: n = "default", className: r, ...a } = e;
    return /* @__PURE__ */ l.jsx(
      "thead",
      {
        "data-testid": "table-header",
        ref: t,
        className: z(
          Nt["table-cell-base"],
          fc({ cellAlignment: n }),
          r
        ),
        ...a
      }
    );
  }
);
rE.displayName = "TableHeader";
const aE = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    "tbody",
    {
      ref: t,
      className: n,
      "data-testid": "table-body",
      ...r
    }
  );
});
aE.displayName = "TableBody";
const iE = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    "tfoot",
    {
      ref: t,
      className: n,
      ...r
    }
  );
});
iE.displayName = "TableFooter";
const sE = K(
  (e, t) => {
    const { cellAlignment: n = "default", className: r, ...a } = e;
    return /* @__PURE__ */ l.jsx(
      "tr",
      {
        "data-testid": "table-row",
        ref: t,
        className: z(fc({ cellAlignment: n }), r),
        ...a
      }
    );
  }
);
sE.displayName = "TableRow";
const oE = K(
  (e, t) => {
    const { className: n, align: r = "left", ...a } = e;
    return /* @__PURE__ */ l.jsx(
      "th",
      {
        ref: t,
        ...a
      }
    );
  }
);
oE.displayName = "TableHead";
const cE = K(
  (e, t) => {
    const {
      className: n,
      icon: r,
      cellAlignment: a = "default",
      children: i,
      ...s
    } = e;
    return /* @__PURE__ */ l.jsxs(
      "td",
      {
        "data-testid": "table-cell",
        ref: t,
        className: z(fc({ cellAlignment: a }), n),
        ...s,
        children: [
          r && /* @__PURE__ */ l.jsx(
            re,
            {
              color: "denimBlue",
              icon: r
            }
          ),
          !r && i && /* @__PURE__ */ l.jsx(le, { children: i })
        ]
      }
    );
  }
);
cE.displayName = "TableCell";
const lE = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    "caption",
    {
      ref: t,
      className: n,
      ...r
    }
  );
});
lE.displayName = "TableCaption";
const dE = "_teal_wj4oq_228", uE = "_blue_wj4oq_231", $e = {
  "elevation-1": "_elevation-1_wj4oq_209",
  "elevation-2": "_elevation-2_wj4oq_212",
  "elevation-3": "_elevation-3_wj4oq_215",
  "color-bar": "_color-bar_wj4oq_218",
  "denim-blue": "_denim-blue_wj4oq_222",
  "dark-teal": "_dark-teal_wj4oq_225",
  teal: dE,
  blue: uE,
  "burnt-orange": "_burnt-orange_wj4oq_234",
  "wellness-blue": "_wellness-blue_wj4oq_237",
  "childrens-blue": "_childrens-blue_wj4oq_240",
  "childrens-green": "_childrens-green_wj4oq_243",
  "childrens-orange": "_childrens-orange_wj4oq_246",
  "childrens-purple": "_childrens-purple_wj4oq_249",
  "childrens-yellow": "_childrens-yellow_wj4oq_252",
  "childrens-alliance": "_childrens-alliance_wj4oq_255"
}, fE = De("", {
  variants: {
    elevation: me({
      none: "",
      elevation1: $e["elevation-1"],
      elevation2: $e["elevation-2"],
      elevation3: $e["elevation-3"]
    }),
    topColorBar: me({
      blue: [$e["color-bar"], $e.blue],
      burntOrange: [$e["color-bar"], $e["burnt-orange"]],
      childrensAlliance: [
        $e["color-bar"],
        $e["childrens-alliance"]
      ],
      childrensBlue: [$e["color-bar"], $e["childrens-blue"]],
      childrensGreen: [$e["color-bar"], $e["childrens-green"]],
      childrensOrange: [$e["color-bar"], $e["childrens-orange"]],
      childrensPurple: [$e["color-bar"], $e["childrens-purple"]],
      childrensYellow: [$e["color-bar"], $e["childrens-yellow"]],
      darkTeal: [$e["color-bar"], $e["dark-teal"]],
      denimBlue: [$e["color-bar"], $e["denim-blue"]],
      none: "",
      teal: [$e["color-bar"], $e.teal],
      wellnessBlue: [$e["color-bar"], $e["wellness-blue"]]
    })
  }
}), Bt = (e) => {
  const {
    elevation: t = "elevation2",
    topColorBar: n,
    className: r,
    children: a,
    ...i
  } = e;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: z(fE({ elevation: t, topColorBar: n }), r),
      "data-testid": "card",
      ...i,
      children: a
    }
  );
}, it = {
  "bg-transparent": "_bg-transparent_duy0h_209",
  "bg-white": "_bg-white_duy0h_212",
  "bg-white-smoke": "_bg-white-smoke_duy0h_215",
  "bg-wellness-blue": "_bg-wellness-blue_duy0h_218",
  "bg-denim-blue": "_bg-denim-blue_duy0h_221",
  "bg-ach-orange": "_bg-ach-orange_duy0h_224",
  "bg-ccha-purple": "_bg-ccha-purple_duy0h_227",
  "bg-utility-info": "_bg-utility-info_duy0h_230",
  "bg-utility-warning": "_bg-utility-warning_duy0h_233",
  "bg-utility-negative": "_bg-utility-negative_duy0h_236",
  "bg-utility-positive": "_bg-utility-positive_duy0h_239",
  "bg-utility-utility": "_bg-utility-utility_duy0h_242",
  "bg-blue": "_bg-blue_duy0h_248",
  "bg-teal": "_bg-teal_duy0h_251",
  "bg-dark-teal": "_bg-dark-teal_duy0h_254",
  "bg-burnt-orange": "_bg-burnt-orange_duy0h_257"
}, pE = De("", {
  variants: {
    backgroundColor: me({
      achOrange: it["bg-ach-orange"],
      blue: it["bg-blue"],
      burntOrange: it["bg-burnt-orange"],
      cchaPurple: it["bg-ccha-purple"],
      darkTeal: it["bg-dark-teal"],
      denimBlue: it["bg-denim-blue"],
      teal: it["bg-teal"],
      transparent: it["bg-transparent"],
      utilityInfo: it["bg-utility-info"],
      utilityNegative: it["bg-utility-negative"],
      utilityPositive: it["bg-utility-positive"],
      utilityUtility: it["bg-utility-utility"],
      utilityWarning: it["bg-utility-warning"],
      wellnessBlue: it["bg-wellness-blue"],
      white: it["bg-white"],
      whiteSmoke: it["bg-white-smoke"]
    })
  }
}), Hn = on("white"), ur = (e) => {
  const { className: t, children: n, backgroundColor: r = "white", ...a } = e;
  return /* @__PURE__ */ l.jsx(Hn.Provider, { value: r || "white", children: /* @__PURE__ */ l.jsx(
    lt,
    {
      "data-background-color": r !== "white",
      className: z(
        pE({ backgroundColor: r }),
        t
      ),
      ...a,
      children: n
    }
  ) });
}, md = "Consumer", hd = on({
  theme: md
}), pk = (e) => {
  const { children: t, theme: n = md } = e;
  return /* @__PURE__ */ l.jsx(hd.Provider, { value: { theme: n }, children: /* @__PURE__ */ l.jsx(lt, { "data-theme": n, children: t }) });
}, mE = (e) => {
  const { className: t, address: n, googleMapsApiKey: r, title: a, ...i } = e;
  if (!r && !n)
    return null;
  const s = `https://www.google.com/maps/embed/v1/place?key=${r}&q=${n}`;
  return /* @__PURE__ */ l.jsx(
    "iframe",
    {
      title: a,
      className: t,
      "data-testid": "map",
      loading: "lazy",
      src: s,
      referrerPolicy: "strict-origin-when-cross-origin",
      ...i
    }
  );
}, hE = "_input_17n90_209", gE = "_label_17n90_214", Sn = {
  input: hE,
  label: gE,
  "input-container": "_input-container_17n90_226",
  "input-box": "_input-box_17n90_229",
  "inline-btn": "_inline-btn_17n90_255",
  "error-message": "_error-message_17n90_265",
  "show-error": "_show-error_17n90_276"
}, En = K((e, t) => {
  const {
    ariaLabel: n,
    ariaRequired: r,
    className: a,
    errorMessage: i,
    errorMessageId: s,
    hasError: o,
    inputId: c,
    label: d,
    placeholder: u,
    setHasError: f,
    inlineButton: p,
    onFocus: h,
    ...g
  } = e, v = (m) => {
    o && (f == null || f(!1)), h == null || h(m);
  }, x = !!o && !!i && !!s;
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: z(Sn.input, a),
      "data-testid": "input",
      children: [
        d && /* @__PURE__ */ l.jsx(
          G,
          {
            "data-testid": "label",
            className: z(Sn.label, {
              [Sn["show-error"]]: x
            }),
            tag: "label",
            htmlFor: c,
            children: d
          }
        ),
        /* @__PURE__ */ l.jsxs("div", { className: Sn["input-container"], children: [
          /* @__PURE__ */ l.jsx(
            "input",
            {
              id: c,
              "data-testid": "input-box",
              className: Sn["input-box"],
              ref: t,
              placeholder: u,
              "aria-invalid": x,
              "aria-required": r,
              "aria-label": n,
              "aria-describedby": x ? s : void 0,
              onFocus: v,
              ...g
            }
          ),
          p && /* @__PURE__ */ l.jsx(lt, { className: Sn["inline-btn"], children: p })
        ] }),
        x && /* @__PURE__ */ l.jsx(
          le,
          {
            "aria-live": "polite",
            id: s,
            "data-testid": "input-error-message",
            className: z(Sn["error-message"], {
              [Sn["show-error"]]: o
            }),
            children: i
          }
        )
      ]
    }
  );
}), mk = (e) => {
  const { ...t } = e;
  return /* @__PURE__ */ l.jsx(
    xe,
    {
      "data-testid": "form-container",
      ...t,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          id: "formio",
          "data-testid": "form"
        }
      )
    }
  );
}, vE = "_label_7i97t_214", bE = "_icon_7i97t_226", yE = "_popper_7i97t_316", xE = "_viewport_7i97t_331", _E = "_separator_7i97t_385", nt = {
  "select-dropdown": "_select-dropdown_7i97t_209",
  label: vE,
  icon: bE,
  "select-trigger": "_select-trigger_7i97t_229",
  "select-scroll-btn": "_select-scroll-btn_7i97t_273",
  "select-content": "_select-content_7i97t_280",
  popper: yE,
  viewport: xE,
  "select-label": "_select-label_7i97t_336",
  "select-item": "_select-item_7i97t_346",
  separator: _E
}, wE = x7, w2 = L7, CE = _7, gd = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsxs(
    x4,
    {
      ref: t,
      className: z(nt["select-trigger"], n),
      ...a,
      children: [
        r,
        /* @__PURE__ */ l.jsx(w7, { asChild: !0, children: /* @__PURE__ */ l.jsx(re, { icon: "chevronDown" }) })
      ]
    }
  );
});
gd.displayName = x4.displayName;
const vd = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    S4,
    {
      ref: t,
      className: z(nt["select-scroll-btn"], n),
      ...r,
      children: /* @__PURE__ */ l.jsx(re, { icon: "chevronUp" })
    }
  );
});
vd.displayName = S4.displayName;
const bd = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    L4,
    {
      ref: t,
      className: z(nt["select-scroll-btn"], n),
      ...r,
      children: /* @__PURE__ */ l.jsx(re, { icon: "chevronDown" })
    }
  );
});
bd.displayName = L4.displayName;
const yd = K((e, t) => {
  const { className: n, children: r, position: a = "popper", ...i } = e;
  return /* @__PURE__ */ l.jsx(C7, { children: /* @__PURE__ */ l.jsxs(
    _4,
    {
      ref: t,
      className: z(
        nt["select-content"],
        {
          [nt.popper]: a === "popper"
        },
        n
      ),
      position: a,
      ...i,
      children: [
        /* @__PURE__ */ l.jsx(vd, {}),
        /* @__PURE__ */ l.jsx(
          S7,
          {
            className: z(nt.viewport, {
              [nt.popper]: a === "popper"
            }),
            children: r
          }
        ),
        /* @__PURE__ */ l.jsx(bd, {})
      ]
    }
  ) });
});
yd.displayName = _4.displayName;
const xd = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    w4,
    {
      ref: t,
      className: z(nt["select-label"], n),
      ...r
    }
  );
});
xd.displayName = w4.displayName;
const Ma = K((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    C4,
    {
      ref: t,
      className: z(nt["select-item"], n),
      ...a,
      children: /* @__PURE__ */ l.jsxs(M7, { children: [
        /* @__PURE__ */ l.jsx("span", { className: nt.icon, children: /* @__PURE__ */ l.jsx(N7, { children: /* @__PURE__ */ l.jsx(re, { icon: "check" }) }) }),
        r
      ] })
    }
  );
});
Ma.displayName = C4.displayName;
const SE = K((e, t) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    M4,
    {
      ref: t,
      className: z(nt.separator, n),
      ...r
    }
  );
});
SE.displayName = M4.displayName;
const _d = (e) => {
  const {
    ariaLabel: t,
    ariaRequired: n,
    children: r,
    errorMessage: a,
    errorMessageId: i,
    hasError: s,
    inputId: o,
    label: c,
    onValueChange: d,
    placeholder: u,
    setHasError: f
  } = e, p = () => {
    s && (f == null || f(!1));
  };
  return /* @__PURE__ */ l.jsxs("div", { className: nt["select-dropdown"], children: [
    c && /* @__PURE__ */ l.jsx(
      G,
      {
        "data-testid": "label",
        className: z(nt.label, {
          [nt["show-error"]]: s
        }),
        tag: "label",
        htmlFor: o,
        children: c
      }
    ),
    /* @__PURE__ */ l.jsxs(wE, { onValueChange: d, children: [
      /* @__PURE__ */ l.jsx(
        gd,
        {
          "aria-describedby": s ? i : void 0,
          "aria-invalid": s,
          "aria-label": t,
          "aria-required": n,
          className: nt["select-box"],
          "data-testid": "select-box",
          id: o,
          onFocus: p,
          children: /* @__PURE__ */ l.jsx(CE, { placeholder: u })
        }
      ),
      /* @__PURE__ */ l.jsx(yd, { children: r })
    ] }),
    s && i && /* @__PURE__ */ l.jsx(
      le,
      {
        "aria-live": "polite",
        className: z(nt["error-message"], {
          [nt["show-error"]]: s
        }),
        "data-testid": "input-error-message",
        id: i,
        children: a
      }
    )
  ] });
}, LE = ({ condition: e, wrapper: t, children: n }) => e ? t(n) : n, pc = {
  "location-address": "_location-address_wmn9s_209"
}, mc = (e) => {
  const { addressLine1: t, addressLine2: n, city: r, state: a, zip: i } = e;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    t && /* @__PURE__ */ l.jsx("span", { children: t }),
    n && /* @__PURE__ */ l.jsx("span", { children: n }),
    (r || a || i) && /* @__PURE__ */ l.jsx("span", { children: `${r}${r && a && ", "}${a}${i && ` ${i}`}` })
  ] });
}, ME = (e) => {
  const { location: t, className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    X,
    {
      "data-testid": "location-address-link",
      className: z(pc["location-address"], n),
      ...r,
      children: /* @__PURE__ */ l.jsx(mc, { ...t })
    }
  );
}, NE = (e) => {
  const { detailPage: t, location: n, className: r, ...a } = e;
  return /* @__PURE__ */ l.jsx(
    X,
    {
      "data-testid": "location-address-detail-page",
      className: z(pc["location-address"], r),
      ...a,
      children: Te(
        t || n.locationDetailPage,
        {
          children: /* @__PURE__ */ l.jsx(mc, { ...n })
        }
      )
    }
  );
}, zE = (e) => {
  const { location: t, className: n, ...r } = e;
  return /* @__PURE__ */ l.jsx(
    G,
    {
      tag: "p",
      "data-testid": "location-address-text",
      className: z(pc["location-address"], n),
      ...r,
      children: /* @__PURE__ */ l.jsx(mc, { ...t })
    }
  );
}, wd = (e) => e.href ? /* @__PURE__ */ l.jsx(ME, { ...e }) : e.location.locationDetailPage ? /* @__PURE__ */ l.jsx(
  NE,
  {
    ...e
  }
) : /* @__PURE__ */ l.jsx(zE, { ...e }), EE = "_spinner_1bw4j_209", TE = {
  spinner: EE
}, hk = (e) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: z(TE.spinner, t),
      "data-testid": "spinner",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 512 512",
          width: "56",
          height: "56",
          children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "var(--semantic-color-surface-default-brand-hover-utility)",
              d: "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
            }
          )
        }
      )
    }
  );
}, X1 = {
  "checkbox-base": "_checkbox-base_1d8uh_209",
  "checkbox-indicator": "_checkbox-indicator_1d8uh_233",
  "checkbox-icon": "_checkbox-icon_1d8uh_239"
}, Cd = K((e, t) => {
  const { className: n, checked: r, onCheckedChange: a, ...i } = e;
  return /* @__PURE__ */ l.jsx(
    w0,
    {
      ref: t,
      "data-testid": "checkbox",
      className: z(X1["checkbox-base"], n),
      checked: r,
      title: r ? "Uncheck" : "Check",
      onCheckedChange: (s) => a == null ? void 0 : a(s),
      ...i,
      children: /* @__PURE__ */ l.jsx(
        Af,
        {
          className: X1["checkbox-indicator"],
          children: /* @__PURE__ */ l.jsx(
            re,
            {
              icon: "check",
              className: X1["checkbox-icon"]
            }
          )
        }
      )
    }
  );
});
Cd.displayName = w0.displayName;
export {
  Ps as Accordion,
  o6 as AccordionContent,
  Dv as AccordionContentPlain,
  i6 as AccordionItem,
  s6 as AccordionTrigger,
  bT as AccordionWrapper,
  gT as Alert,
  n9 as AlertDismissible,
  e9 as AlertExpandable,
  DT as AlphaLinksIndex,
  X as Anchor,
  HT as Article,
  KT as AudioAsset,
  tk as BMICalculator,
  ur as BackgroundColor,
  Hn as BackgroundColorContext,
  $T as BioCardDirectory,
  IT as BioCardGrid,
  X3 as Breadcrumb,
  js as BreadcrumbItem,
  Q3 as BreadcrumbLink,
  Z3 as BreadcrumbList,
  J3 as BreadcrumbPage,
  e6 as BreadcrumbSeparator,
  qg as Breadcrumbs,
  vn as Button,
  Bt as Card,
  c1 as Carousel,
  Cd as Checkbox,
  rg as CheckboxFacetItem,
  QT as CheckboxFacets,
  wT as ChildrenAnimalMotif,
  Rn as Column,
  fk as ColumnCta,
  rt as ColumnGrid,
  LE as ConditionalWrapper,
  xe as Container,
  He as ContentContainer,
  JT as ContentFeedForHealthNews,
  Am as ContentFeedForHealthNewsCard,
  Jh as ContentFeedGrid,
  YT as ContentFeedWithFeaturedCard,
  uT as CorporateFooter,
  BE as CtaContentCard,
  aT as CtaContentCards,
  Pg as DEFAULT_ACCORDION_TYPE,
  ON as DEFAULT_ANCHOR_FONT_STYLE,
  RN as DEFAULT_ANCHOR_UNDERLINE,
  Bv as DEFAULT_BUTTON_SIZE,
  Vv as DEFAULT_BUTTON_VARIANT,
  UN as DEFAULT_CONTAINER_TAG,
  WN as DEFAULT_CONTAINER_VARIANT,
  mN as DEFAULT_IMAGE_RATIO,
  XN as DEFAULT_TAB_SIZE,
  SN as DEFAULT_TAG,
  md as DEFAULT_THEME,
  qN as DEFAULT_VERTICAL_SPACING,
  ud as DropdownMenu,
  $a as DropdownMenuContent,
  hn as DropdownMenuItem,
  Ia as DropdownMenuList,
  Ri as DropdownMenuListItem,
  uc as DropdownMenuMobile,
  Bz as DropdownMenuSeparator,
  i1 as DropdownMenuSingle,
  fd as DropdownMenuSubTrigger,
  s1 as DropdownMenuTrigger,
  XE as FindADoctor,
  ZE as FindALocation,
  nT as Footer,
  mk as Form,
  km as GlobalNavigation,
  rT as Header,
  AT as HeadlineWithOptionalCta,
  yT as HeroBanner,
  xT as HeroBannerCarousel,
  Rg as HeroBannerDesktop,
  Dg as HeroBannerMobile,
  PT as HeroFeaturedBanner,
  pT as HeroStatistics,
  G3 as HeroStatisticsContext,
  GE as HeroStatisticsItem,
  sT as IconCtaBordered,
  Dm as IconCtaBorderedCard,
  dT as IconCtaColoredBox,
  qE as IconCtaColoredBoxCard,
  lT as IconCtaLeftAligned,
  HE as IconCtaLeftAlignedCard,
  cT as IconCtaSimplified,
  VE as IconCtaSimplifiedCard,
  yn as Image,
  CT as ImageAsset,
  En as Input,
  nk as LeftNavLayout,
  FT as LeftNavigation,
  Ll as LeftNavigationContent,
  BT as LeftSideNavigationAnchorLinks,
  Ml as LeftSideNavigationAnchorLinksContent,
  a6 as LeftSideNavigationBackToTopAnchor,
  LT as LinkList,
  wd as LocationAddress,
  YE as LocationCard,
  vT as LocationCards,
  GT as LocationInfo,
  N3 as LocationInput,
  mE as Map,
  mT as MediaGallery,
  q3 as MediaGalleryCarousel,
  W3 as MediaGallerySlide,
  z3 as MediaWithCaption,
  kT as MultiButton,
  VT as MultiColumnContainer,
  qT as MultiColumnCta,
  Oi as NavigationMenu,
  dc as NavigationMenuContent,
  $z as NavigationMenuIndicator,
  qt as NavigationMenuItem,
  tr as NavigationMenuLink,
  a1 as NavigationMenuList,
  lc as NavigationMenuTrigger,
  Az as NavigationMenuViewport,
  UT as NewsListing,
  tT as NewsListingCard,
  ek as OnPageNavigationAnchorLink,
  ac as Picture,
  NT as PromoCallout,
  zT as PromoCarousel,
  KE as ReputationScheduleCta,
  r9 as ReputationScheduleForm,
  WE as ReverseRow,
  oT as ReverseRows,
  le as RichText,
  TT as RichTextRendering,
  rk as RightRailLayout,
  ag as SearchBoxForm,
  eT as SearchPagination,
  JE as SearchResultSummary,
  wE as Select,
  yd as SelectContent,
  _d as SelectDropdown,
  w2 as SelectGroup,
  Ma as SelectItem,
  xd as SelectLabel,
  gd as SelectTrigger,
  CE as SelectValue,
  Oz as Sheet,
  Rz as SheetClose,
  od as SheetContent,
  dd as SheetDescription,
  Fz as SheetFooter,
  cd as SheetHeader,
  sd as SheetOverlay,
  Dz as SheetPortal,
  ld as SheetTitle,
  x2 as SheetTrigger,
  OT as SideMediaAsset,
  RT as SidePhotoContentCard,
  iT as SidePhotoContentCardCarousel,
  fT as SideStatistics,
  UE as SideStatisticsItem,
  ZT as SimpleSignup,
  hk as Spinner,
  XT as SuggestiveDropdown,
  re as SvgIcon,
  pd as Table,
  aE as TableBody,
  lE as TableCaption,
  cE as TableCell,
  _T as TableContainer,
  iE as TableFooter,
  oE as TableHead,
  rE as TableHeader,
  sE as TableRow,
  dk as Tabs,
  JN as TabsContent,
  ZN as TabsList,
  QN as TabsTrigger,
  o9 as TestimonialCard,
  WT as Testimonials,
  G as Text,
  ET as TextAccordion,
  hd as ThemeContext,
  pk as ThemeProvider,
  Rv as ThoughtBubbleSVG,
  hT as TopStatistics,
  QE as TopStatisticsItem,
  j8 as UtilityNavigationDesktop,
  $8 as UtilityNavigationMobile,
  ST as VideoAsset,
  o1 as YouTubeEmbed,
  Y3 as alertBgColorMap,
  K3 as alertIconMap,
  ik as allFontAwesomeIcons,
  sk as anchorFontStyles,
  ok as anchorUnderlines,
  pE as backgroundColorCVA,
  FE as backgroundColorOptions,
  ak as buttonSizes,
  lk as columnGridBreakpoints,
  jT as iconList,
  Fv as isButtonVariant,
  DE as navItemColors,
  MT as promoCalloutBackgroundColors,
  pN as ratiosMap,
  ck as rowGaps
};
//# sourceMappingURL=index.es.js.map
